(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("jQuery"), require("ReactDOM"), require("$"));
	else if(typeof define === 'function' && define.amd)
		define(["antd", "React", "loadjs", "ecCom", "jQuery", "ReactDOM", "$"], factory);
	else if(typeof exports === 'object')
		exports["ecCom"] = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("jQuery"), require("ReactDOM"), require("$"));
	else
		root["ecCom"] = factory(root["antd"], root["React"], root["loadjs"], root["ecCom"], root["jQuery"], root["ReactDOM"], root["$"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_54__, __WEBPACK_EXTERNAL_MODULE_752__, __WEBPACK_EXTERNAL_MODULE_506__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_196__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpecCom"];
/******/ 	window["webpackJsonpecCom"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		9: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = (window[__webpack_require__.v] || "") + __webpack_require__.p + "ecCom/" + ({}[chunkId]||chunkId) + ".chunk.js?v=" + {"0":"5ded0ad2","1":"6fb5e084","2":"3bcaa7d1","3":"c49ca9ca","4":"cc413180","5":"1916fd88","6":"cca6158d","7":"2e67c9d6","8":"aa2cc136"}[chunkId] + "";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/cloudstore/resource/pc/com/v1/";
/******/
/******/ 	// __webpack_content_path__
/******/ 	__webpack_require__.v = "ecologyContentPath";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 386);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(100);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(197);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(24);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(316);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(317);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(24);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(424), __esModule: true };

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _assign=__webpack_require__(100);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _class2,_temp2;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var React=__webpack_require__(1);var PropTypes=__webpack_require__(36);var ALL_INITIALIZERS=[];var READY_INITIALIZERS=[];function isWebpackReady(getModuleIds){if(( false?"undefined":(0,_typeof3.default)(__webpack_require__.m))!=="object"){return false;}return getModuleIds().every(function(moduleId){return typeof moduleId!=="undefined"&&typeof __webpack_require__.m[moduleId]!=="undefined";});}function load(loader){var promise=loader();var state={loading:true,loaded:null,error:null};state.promise=promise.then(function(loaded){state.loading=false;state.loaded=loaded;return loaded;}).catch(function(err){state.loading=false;state.error=err;throw err;});return state;}function loadMap(obj){var state={loading:false,loaded:{},error:null};var promises=[];try{(0,_keys2.default)(obj).forEach(function(key){var result=load(obj[key]);if(!result.loading){state.loaded[key]=result.loaded;state.error=result.error;}else{state.loading=true;}promises.push(result.promise);result.promise.then(function(res){state.loaded[key]=res;}).catch(function(err){state.error=err;});});}catch(err){state.error=err;}state.promise=_promise2.default.all(promises).then(function(res){state.loading=false;return res;}).catch(function(err){state.loading=false;throw err;});return state;}function resolve(obj){return obj&&obj.__esModule?obj.default:obj;}function render(loaded,props,ref){return React.createElement(resolve(loaded),(0,_extends3.default)({},props,{ref:ref}));}function createLoadableComponent(loadFn,options){var _class,_temp;if(!options.loading){throw new Error("react-loadable requires a `loading` component");}var opts=(0,_assign2.default)({loader:null,loading:null,delay:200,timeout:null,render:render,webpack:null,modules:null},options);var res=null;function init(){if(!res){res=loadFn(opts.loader);}return res.promise;}ALL_INITIALIZERS.push(init);if(typeof opts.webpack==="function"){READY_INITIALIZERS.push(function(){if(isWebpackReady(opts.webpack)){return init();}});}var LoadableComponent=(_temp=_class=function(_React$Component){(0,_inherits3.default)(LoadableComponent,_React$Component);function LoadableComponent(props){(0,_classCallCheck3.default)(this,LoadableComponent);var _this=(0,_possibleConstructorReturn3.default)(this,(LoadableComponent.__proto__||(0,_getPrototypeOf2.default)(LoadableComponent)).call(this,props));_this.retry=function(){_this.setState({error:null,loading:true,timedOut:false});res=loadFn(opts.loader);_this._loadModule();};init();_this.state={error:res.error,pastDelay:false,timedOut:false,loading:res.loading,loaded:res.loaded};return _this;}(0,_createClass3.default)(LoadableComponent,[{key:"componentWillMount",value:function componentWillMount(){this._mounted=true;this._loadModule();}},{key:"_loadModule",value:function _loadModule(){var _this2=this;if(this.context.loadable&&Array.isArray(opts.modules)){opts.modules.forEach(function(moduleName){_this2.context.loadable.report(moduleName);});}if(!res.loading){return;}if(typeof opts.delay==="number"){if(opts.delay===0){this.setState({pastDelay:true});}else{this._delay=setTimeout(function(){_this2.setState({pastDelay:true});},opts.delay);}}if(typeof opts.timeout==="number"){this._timeout=setTimeout(function(){_this2.setState({timedOut:true});},opts.timeout);}var update=function update(){if(!_this2._mounted){return;}_this2.setState({error:res.error,loaded:res.loaded,loading:res.loading});_this2._clearTimeouts();};res.promise.then(function(){update();}).catch(function(err){update();});}},{key:"componentWillUnmount",value:function componentWillUnmount(){this._mounted=false;this._clearTimeouts();}},{key:"_clearTimeouts",value:function _clearTimeouts(){clearTimeout(this._delay);clearTimeout(this._timeout);}},{key:"render",value:function render(){var forwardRef=this.props.forwardRef;if(this.state.loading||this.state.error){return React.createElement(opts.loading,{isLoading:this.state.loading,pastDelay:this.state.pastDelay,timedOut:this.state.timedOut,error:this.state.error,retry:this.retry,ref:forwardRef,props:this.props});}else if(this.state.loaded){return opts.render(this.state.loaded,this.props,forwardRef);}else{return null;}}}],[{key:"preload",value:function preload(){return init();}}]);return LoadableComponent;}(React.Component),_class.contextTypes={loadable:PropTypes.shape({report:PropTypes.func.isRequired})},_temp);return React.forwardRef(function(props,ref){return React.createElement(LoadableComponent,(0,_extends3.default)({},props,{forwardRef:ref}));});}function Loadable(opts){return createLoadableComponent(load,opts);}function LoadableMap(opts){if(typeof opts.render!=="function"){throw new Error("LoadableMap requires a `render(loaded, props)` function");}return createLoadableComponent(loadMap,opts);}Loadable.Map=LoadableMap;var Capture=(_temp2=_class2=function(_React$Component2){(0,_inherits3.default)(Capture,_React$Component2);function Capture(){(0,_classCallCheck3.default)(this,Capture);return(0,_possibleConstructorReturn3.default)(this,(Capture.__proto__||(0,_getPrototypeOf2.default)(Capture)).apply(this,arguments));}(0,_createClass3.default)(Capture,[{key:"getChildContext",value:function getChildContext(){return{loadable:{report:this.props.report}};}},{key:"render",value:function render(){return React.Children.only(this.props.children);}}]);return Capture;}(React.Component),_class2.propTypes={report:PropTypes.func.isRequired},_class2.childContextTypes={loadable:PropTypes.shape({report:PropTypes.func.isRequired}).isRequired},_temp2);Loadable.Capture=Capture;function flushInitializers(initializers){var promises=[];while(initializers.length){var init=initializers.pop();promises.push(init());}return _promise2.default.all(promises).then(function(){if(initializers.length){return flushInitializers(initializers);}});}Loadable.preloadAll=function(){return new _promise2.default(function(resolve,reject){flushInitializers(ALL_INITIALIZERS).then(resolve,reject);});};Loadable.preloadReady=function(){return new _promise2.default(function(resolve,reject){// We always will resolve, errors should be handled within loading UIs.
flushInitializers(READY_INITIALIZERS).then(resolve,resolve);});};module.exports=Loadable;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);exports.default=middleware;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function isObject(obj){return Object.prototype.toString.call(obj)==="[object Object]";}function isFunction(fn){return typeof fn==="function";}function getModule(obj){return obj&&obj.__esModule?obj.default||obj:obj;}function isReactComponent(com,name,saName){if(com&&com.prototype&&(com.prototype instanceof _react2.default.Component||com.prototype.isReactComponent)&&// isFunction(com.prototype.render) &&
// name !== "Radio" &&
// saName !== "Radio.Button" &&
// saName !== "Tree.TreeNode" &&
// saName !== "Menu.ItemGroup" &&
saName!=="Select.Option"&&saName!=="Select.OptGroup"&&saName!=="SelectNew.Option"&&saName!=="SelectNew.OptGroup"&&// .type === class强比较，搞事情的代码暂时先不加
name!=="WeaDebugRouteMenu"// route 会判定多个子节点...
){return true;}else if(name==="Col"||name==="Icon"||name==="Card"){// no isReactComponent Col Icon Card
return true;}return false;}function middleware(obj,name,saName){var com=getModule(obj);var result=com;if(isObject(window.pcComponentsConfig)){var overwrite=window.pcComponentsConfig[name];if(isObject(overwrite)){if(isReactComponent(com,name)){result=_react2.default.forwardRef(function(props,ref){if(props._noOverwrite){return _react2.default.createElement(com,(0,_extends3.default)({},props,{ref:ref}));}var newProps=(0,_extends3.default)({},props);var overwriteInRender=window.pcComponentsConfig[name];if(isObject(overwriteInRender)){// overwrite render lev 1
var renderFn=overwriteInRender.overwriteRenderFn;if(isFunction(renderFn)){var overwriteRender=renderFn(newProps,saName||name);if(overwriteRender!==false){return overwriteRender;}}// overwrite props lev 2
var propsJson=overwriteInRender.overwritePropsJson;if(isObject(propsJson)){newProps=(0,_extends3.default)({},newProps,propsJson);}var propsFn=overwriteInRender.overwritePropsFn;if(isFunction(propsFn)){var overwriteProps=propsFn(newProps,saName||name);if(isObject(overwriteProps)){newProps=(0,_extends3.default)({},newProps,overwriteProps);}}// overwrite class lev 3
var classFn=overwriteInRender.overwriteClassFn;if(isFunction(classFn)){var overwriteClass=classFn(com,newProps,saName||name);if(overwriteClass.com&&isObject(overwriteClass.props)){return _react2.default.createElement(overwriteClass.com,(0,_extends3.default)({},overwriteClass.props,{ref:ref}));}}}return _react2.default.createElement(com,(0,_extends3.default)({},newProps,{ref:ref}));});}(0,_keys2.default)(com).forEach(function(key){var staticAttribute=getModule(com[key]);var staticAttributeName=name+"."+key;if(isReactComponent(staticAttribute,key,staticAttributeName)){result[key]=middleware(staticAttribute,key,staticAttributeName);}else{result[key]=staticAttribute;}});}}return result;}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _class,_temp2;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _loadjs=__webpack_require__(54);var _loadjs2=_interopRequireDefault(_loadjs);var _util=__webpack_require__(134);var _callApi=__webpack_require__(17);var caUtil=_interopRequireWildcard(_callApi);var _checkSSO=__webpack_require__(247);var _watermark=__webpack_require__(250);var _watermark2=_interopRequireDefault(_watermark);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var callApi=caUtil.callApi;var localeKey="e9_locale";var constant={langRegP:/(~`~`(([\d ]{1,2}[^`]{0,2000}?`~`)+[\d ]{1,2}[^`]{0,2000}?)`~`~).{0,2000}?/i,blank:/&nbsp;/g,LANG_CONTENT_PREFIX:"~`~`",LANG_CONTENT_SPLITTER1:"`~`",LANG_CONTENT_SUFFIX:"`~`~",LANG_INPUT_PREFIX:"__multilangpre_"};var getLocale=function getLocale(){return window[localeKey];};var getUserLanguage=function getUserLanguage(){// 多语言静态资源调整了。目前是直接从localStorage.languageidweaver中取的当前的语言
if(localStorage.languageidweaver){return localStorage.languageidweaver;}if(localStorage.login){try{var login=JSON.parse(localStorage.login);if(login.langId){return login.langId;}if(window[localeKey]){return window[localeKey].userLanguage||7;}}catch(error){console&&console.error("多语言获取失败 :(",error);}}};// const overTime =(msg, timeout) => new Promise((rs, rj) => {
//   setTimeout(() => rs(msg), timeout);
// });
var isInMain=function isInMain(){return window.location.href.indexOf("/wui/index")>0;};var transModeleCode=function transModeleCode(moduleCode){var mod=[];if(Array.isArray(moduleCode)){mod=[].concat((0,_toConsumableArray3.default)(moduleCode));}else if(typeof moduleCode==="string"&&moduleCode.indexOf(",")>0){mod=moduleCode.split(",");}else{mod=[moduleCode];}return mod;};var checkModuleCode=function checkModuleCode(moduleCode){var noNeedTransMod=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;// noNeedTransMod: 是否需要通过transModeleCode转一次moduleCode
if(!moduleCode||!(""+moduleCode))return false;// let mod = noNeedTransMod ? moduleCode : transModeleCode(moduleCode);
var mod=transModeleCode(moduleCode);if(window[localeKey]){// fix: 过滤mod 取window[localeKey].loadedModules没有的,有的直接拿lable，没有走接口
mod=mod.filter(function(m){return!window[localeKey].loadedModules.some(function(_m){return _m===m;});});if(mod.length>0){// fix: 过滤后的mod,拼接到window[localeKey].loadedModules中
window[localeKey].loadedModules=window[localeKey].loadedModules.concat(mod);}}if(mod.length===0)return false;return mod;};// 通过语言类型获取多语言标签
var getLocaleLabelByLang=function getLocaleLabelByLang(moduleCode){var languageId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";// moduleCode: 模块名 languageId:当前语音标识
var language=typeof language==="string"&&languageId!==""?Number(languageId):languageId;return new _promise2.default(function(rs,rj){var noNeedTransMod=!window[localeKey]||window[localeKey].userLanguage!=language;// 如果当前缓存中没有window[localeKey] 或者 当前的语言类型发生改变,重置数据
if(noNeedTransMod){window[localeKey]={userLanguage:language,loadedModules:[],reloadedModules:[]};}else{// 语言类型赋值
window[localeKey].userLanguage=language;}var mod=checkModuleCode(moduleCode,noNeedTransMod);var modUrl=[];mod.length>0&&mod.forEach(function(element){element+="";element=element.toLowerCase();modUrl.push("/mobile/languagelocal/"+languageId+"/"+element+".js");return element;});var loadedConut=0;var callback=function callback(resolve,url){var mod=url.slice(url.lastIndexOf("/")+1,url.lastIndexOf("."));var localjsonTemp="";if(!window["localjson"+mod+languageId]){localjsonTemp=window["localjson"+mod];window["localjson"+mod+languageId]=window["localjson"+mod];}else{localjsonTemp=window["localjson"+mod+languageId];}if(Array.isArray(localjsonTemp)){localjsonTemp.forEach(function(item){if(!window[localeKey][item.type]){window[localeKey][item.type]={};}window[localeKey][item.type][item.id]=item.label;});window.localStorage[localeKey]=(0,_stringify2.default)(window[localeKey]);}// checkMode方法已处理，不需要再处理一次
// window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
//   mod
// );
loadedConut+=1;if(loadedConut==modUrl.length){resolve();}};callback.bind(undefined);!mod?rs():modUrl.forEach(function(url){_loadjs2.default.isDefined(url+"?v="+localStorage["languageVersion"])?_loadjs2.default.ready(url+"?v="+localStorage["languageVersion"],function(){return callback(rs,url);}):(0,_loadjs2.default)([url+"?v="+localStorage["languageVersion"]],url+"?v="+localStorage["languageVersion"],{success:function success(){callback(rs,url);},error:function error(){console&&console.warn("load "+url+" fail");callback(rs,url);}});});//  callApi("/api/ec/dev/locale/getLabelByModule", "GET", {
//     moduleCode: `${mod}`,
//     languageId: language
//   }).then(result => {
//     const { datas } = result;
//     if (Array.isArray(datas)) {
//       datas.forEach(item => {
//         if (!window[localeKey][item.type]) {
//           window[localeKey][item.type] = {};
//         }
//         window[localeKey][item.type][item.id] = item.label;
//       });
//       window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
//     }
//     window[localeKey].loadedModules = window[
//       localeKey
//     ].loadedModules.concat(mod);
//     rs();
//   });
});};// 通过模块名获取多语言标签
var getLocaleLabelByCode=function getLocaleLabelByCode(moduleCode){var isform=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var noNeedTransMod=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return new _promise2.default(function(rs,rj){// if (isform) {
//   if (window[localeKey]) {
//     rs();
//     return;
//   } else {
//     if (window.localStorage[localeKey]) {
//       window[localeKey] = JSON.parse(window.localStorage[localeKey]);
//     }
//   }
// }
if(!window[localeKey]){window[localeKey]={loadedModules:[],reloadedModules:[]};}var mod=checkModuleCode(moduleCode,noNeedTransMod);var modUrl=[];mod.length>0&&mod.forEach(function(element){element+="";element=element.toLowerCase();modUrl.push("/mobile/languagelocal/"+(window.localStorage["languageidweaver"]||7)+"/"+element+".js");return element;});var loadedConut=0;var callback=function callback(resolve,url){var mod=url.slice(url.lastIndexOf("/")+1,url.lastIndexOf("."));var localjsonTemp="";if(!window["localjson"+mod+window.localStorage["languageidweaver"]]){localjsonTemp=window["localjson"+mod];window["localjson"+mod+window.localStorage["languageidweaver"]]=window["localjson"+mod];}else{localjsonTemp=window["localjson"+mod+window.localStorage["languageidweaver"]];}if(Array.isArray(localjsonTemp)){localjsonTemp.forEach(function(item){if(!window[localeKey][item.type]){window[localeKey][item.type]={};}window[localeKey][item.type][item.id]=item.label;});window.localStorage[localeKey]=(0,_stringify2.default)(window[localeKey]);}// checkMode方法已处理，不需要再处理一次
// window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
//   mod
// );
loadedConut+=1;if(loadedConut==modUrl.length){resolve();}};callback.bind(undefined);if(window.localStorage.ennableTrans!="1"){!mod?rs():modUrl.forEach(function(url){_loadjs2.default.isDefined(url+"?v="+localStorage["languageVersion"])?_loadjs2.default.ready(url+"?v="+localStorage["languageVersion"],function(){return callback(rs,url);}):(0,_loadjs2.default)([url+"?v="+localStorage["languageVersion"]],url+"?v="+localStorage["languageVersion"],{success:function success(){callback(rs,url);},error:function error(){console&&console.warn("load "+url+" fail");callback(rs,url);}});});}else{!mod?rs():callApi("/api/ec/dev/locale/getLabelByModule","GET",{moduleCode:""+mod}).then(function(result){var datas=result.datas,language=result.language;window[localeKey].userLanguage=language;if(Array.isArray(datas)){datas.forEach(function(item){if(!window[localeKey][item.type]){window[localeKey][item.type]={};}window[localeKey][item.type][item.id]=item.label;});}window[localeKey].loadedModules=window[localeKey].loadedModules.concat(mod);window.localStorage[localeKey]=(0,_stringify2.default)(window[localeKey]);rs();});}});};// 用于写在 React-Router 的 onEnter 中
var getLocaleLabel=function getLocaleLabel(moduleCode,nextState,replace,callback){var callbackFunction=typeof callback==="function";if(!callbackFunction){console&&void 0;}// check sso
if(!window.ssoChecked){(0,_checkSSO.checkSSO)().then(function(){if(!/.*appid=.*&service=.*/.test(window.location.href)&&!window.loadCas){// window.loadCas = true;
callApi("/api/integration/common1/checkCasIsDeployed","POST",{}).then(function(res){function getQueryVariable(variable){var query=window.location.search.substring(1);var vars=query.split("&");for(var i=0;i<vars.length;i++){var pair=vars[i].split("=");if(pair[0]==variable){return pair[1];}}return false;}var servicePath=window.location.pathname+window.location.search+window.location.hash;if(/\/wui\/index\.html\#\/\?/.test(servicePath)){servicePath=(window.ecologyContentPath||"")+"/wui/index.html#/main";}if(!res.hasSession&&res.isDeployed&&res.weaver_login_type!=="OALogin"&&!/preview=true/.test(window.location.href)){if(/\/spa\/portal\/public\/index\.html#\/licensesubmit\?display=page/.test(window.location.href)){getLocaleLabelInner(moduleCode,nextState,replace,callback);}else{var service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?path="+encodeURIComponent(servicePath)+("&ssoType="+res.ssoType);if(getQueryVariable("languid")){service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?languid="+getQueryVariable("languid")+"&path="+encodeURIComponent(servicePath);}window.localStorage["casPath"]=service;window.location.href=service;}}else{if(!res.isDeployed){window.localStorage.removeItem("casPath");}else{if(!res.hasSession&&res.weaver_login_type!=="OALogin"){var _service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?path="+encodeURIComponent(servicePath)+("&ssoType="+res.ssoType);if(getQueryVariable("languid")){_service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?languid="+getQueryVariable("languid")+"&path="+encodeURIComponent(servicePath);}window.localStorage["casPath"]=_service;}else{window.localStorage.removeItem("casPath");}}getLocaleLabelInner(moduleCode,nextState,replace,callback);}});}else{getLocaleLabelInner(moduleCode,nextState,replace,callback);}});}else{getLocaleLabelInner(moduleCode,nextState,replace,callback);}};var getLocaleLabelInner=function getLocaleLabelInner(moduleCode,nextState,replace,callback){var callbackFunction=typeof callback==="function";if(!callbackFunction){console&&void 0;}var mod=transModeleCode(moduleCode);var userLanguage=getUserLanguage();// 如果当前缓存中没有window[localeKey] 或者 当前的语言类型发生改变,重置数据
var noNeedTransMod=!window[localeKey]||userLanguage!=window[localeKey].userLanguage;if(noNeedTransMod){window[localeKey]={userLanguage:userLanguage,loadedModules:[],reloadedModules:[]};window.localStorage[localeKey]=(0,_stringify2.default)(window[localeKey]);// 默认拼接上common库
mod=mod.concat("common");}else{if(!window[localeKey].loadedModules||!window[localeKey].loadedModules["common"]){mod=mod.concat("common");}}getLocaleLabelByCode(mod,false,noNeedTransMod).then(function(){return callbackFunction&&callback();});// 加载字体大小
if(!isInMain()){if(localStorage["theme-fontsize"]&&JSON.parse(localStorage["theme-fontsize"])){var fontSize=JSON.parse(localStorage["theme-fontsize"]).themeFontSize;if(fontSize)fontSize=Number(fontSize);if(!_loadjs2.default.isDefined("fontSize_"+fontSize)){(0,_loadjs2.default)("/cloudstore/resource/pc/com/font-size/"+fontSize+"px.css","fontSize_"+fontSize);}}else{callApi("/api/portal/themeCenter/getMyTheme").then(function(result){var baseInfo=result.baseInfo;if(baseInfo&&baseInfo.fontsize){var _fontSize=baseInfo.fontsize;if(_fontSize)_fontSize=Number(_fontSize);if(!_loadjs2.default.isDefined("fontSize_"+_fontSize)){(0,_loadjs2.default)("/cloudstore/resource/pc/com/font-size/"+_fontSize+"px.css","fontSize_"+_fontSize);}}});}}try{// 加载组件库时，设置系统水印
_watermark2.default.getSystemSetting();}catch(error){console.error(error);}};var transLang=function transLang(str,lang){//如果没有设过相应语言的翻译，返回中翻译作为默认值
var isExsit=false,defaultValue="",oriLang=lang;if(lang.length<2)lang+=" ";str=str.replace(constant.blank," ");var from=str.indexOf(constant.LANG_CONTENT_PREFIX),to=str.lastIndexOf(constant.LANG_CONTENT_SUFFIX);if(from!=-1&&to!=-1&&from+4<to){var ls=str.substring(from+4,to).split(constant.LANG_CONTENT_SPLITTER1);for(var i=0;i<ls.length;i++){var lg=ls[i];if(lg.indexOf("7 ")===0){defaultValue=lg.substring(lang.length);}if(lg.indexOf(lang)===0){isExsit=true;return lg.substring(lang.length);}else if(lg.startsWith(oriLang)){isExsit=true;return lg.substring(oriLang.length);}}}if(!isExsit){return defaultValue;}return str;};// 解析多语言对应的显示
var formatMultiLang=function formatMultiLang(str){if(!str||!(0,_isString2.default)(str)||str.indexOf(constant.LANG_CONTENT_PREFIX)<0){return str;}var lang=new String(getUserLanguage());var arr=null;while(arr=str.match(constant.langRegP)){var formatValue=arr[1];var value=transLang(formatValue,lang);str=str.replace(formatValue,value);}return str;};var WeaLocaleProvider=(_temp2=_class=function(_React$Component){(0,_inherits3.default)(WeaLocaleProvider,_React$Component);function WeaLocaleProvider(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,WeaLocaleProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=WeaLocaleProvider.__proto__||(0,_getPrototypeOf2.default)(WeaLocaleProvider)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){return _this.props.children;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}return WeaLocaleProvider;}(_react2.default.Component),_class.getLabel=_util.getLabel,_class.getLocale=getLocale,_class.getUserLanguage=getUserLanguage,_class.getLocaleLabel=getLocaleLabel,_class.getLocaleLabelByCode=getLocaleLabelByCode,_class.formatMultiLang=formatMultiLang,_class.transLang=transLang,_class.getLocaleLabelByLang=getLocaleLabelByLang,_temp2);exports.default=WeaLocaleProvider;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellPosition */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_CellRenderer */
/* unused harmony export bpfrpt_proptype_CellCache */
/* unused harmony export bpfrpt_proptype_StyleCache */
/* unused harmony export bpfrpt_proptype_CellRangeRendererParams */
/* unused harmony export bpfrpt_proptype_CellRangeRenderer */
/* unused harmony export bpfrpt_proptype_CellSizeGetter */
/* unused harmony export bpfrpt_proptype_CellSize */
/* unused harmony export bpfrpt_proptype_NoContentRenderer */
/* unused harmony export bpfrpt_proptype_Scroll */
/* unused harmony export bpfrpt_proptype_ScrollbarPresenceChange */
/* unused harmony export bpfrpt_proptype_RenderedSection */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetterParams */
/* unused harmony export bpfrpt_proptype_OverscanIndices */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony export bpfrpt_proptype_Alignment */
/* unused harmony export bpfrpt_proptype_VisibleCellRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_CellPosition =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellCache =  true ? null : PropTypes.objectOf(PropTypes.node.isRequired);
var bpfrpt_proptype_StyleCache =  true ? null : PropTypes.objectOf(PropTypes.object.isRequired);
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  cellCache: PropTypes.objectOf(PropTypes.node.isRequired).isRequired,
  cellRenderer: PropTypes.func.isRequired,
  columnSizeAndPositionManager: function columnSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  deferredMeasurementCache: PropTypes.object,
  horizontalOffsetAdjustment: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isScrollingOptOut: PropTypes.bool.isRequired,
  parent: PropTypes.object.isRequired,
  rowSizeAndPositionManager: function rowSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  styleCache: PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
  verticalOffsetAdjustment: PropTypes.number.isRequired,
  visibleColumnIndices: PropTypes.object.isRequired,
  visibleRowIndices: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRangeRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSizeGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSize =  true ? null : PropTypes.oneOfType([PropTypes.func, PropTypes.number]);
var bpfrpt_proptype_NoContentRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  clientWidth: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  scrollWidth: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  horizontal: PropTypes.bool.isRequired,
  vertical: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired
};
var bpfrpt_proptype_RenderedSection =  true ? null : {
  columnOverscanStartIndex: PropTypes.number.isRequired,
  columnOverscanStopIndex: PropTypes.number.isRequired,
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  rowOverscanStartIndex: PropTypes.number.isRequired,
  rowOverscanStopIndex: PropTypes.number.isRequired,
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,


  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  scrollDirection: PropTypes.oneOf([-1, 1]).isRequired,


  // Number of rows or columns in the current axis
  cellCount: PropTypes.number.isRequired,


  // Maximum number of cells to over-render in either direction
  overscanCellsCount: PropTypes.number.isRequired,


  // Begin of range of visible cells
  startIndex: PropTypes.number.isRequired,


  // End of range of visible cells
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_Alignment =  true ? null : PropTypes.oneOf(['auto', 'end', 'start', 'center']);
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  start: PropTypes.number,
  stop: PropTypes.number
};




















/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(197);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(622)();
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(439), __esModule: true };

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.callApi=exports.getPageCheckCode=exports.getFd=undefined;var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _jsBase=__webpack_require__(138);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);var _util=__webpack_require__(134);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}window.E9Encrypt=false;// import { message, Modal } from "antd";
// fetch 部分处理
var server=window.server||"";var getFd=exports.getFd=function getFd(values,deep){var fd="";for(var p in values){var target=values[p];if(typeof target==="function"){continue;}if(deep&&(typeof target==="undefined"?"undefined":(0,_typeof3.default)(target))==="object"){fd+=getFd(target,deep);}else if(p=="jsonstr"&&(typeof target==="undefined"?"undefined":(0,_typeof3.default)(target))==="object"){var item=(0,_stringify2.default)(target);fd+=p+"="+item.replace(/\\/g,"")+"&";}else{// 处理undefined null数据to 空串
target=target==undefined?"":target;var _item=encodeURIComponent(target);fd+=p+"="+_item+"&";}}return fd;};// 获取页面CRSF code
var getPageCheckCode=exports.getPageCheckCode=function getPageCheckCode(_ref){var key=_ref.key,code=_ref.code;window.pageCheckKey=key;window.pageCheckCode=code;};var getFetchParams=function getFetchParams(method,params,deep,noInclude){var obj={method:method,headers:{"Content-Type":"application/x-www-form-urlencoded; charset=utf-8","X-Requested-With":"XMLHttpRequest"}};if(server==""&&!noInclude){obj.credentials="include";}if(!(0,_isEmpty2.default)(params)&&method.toUpperCase()!=="GET"){obj.body=getFd(params,deep);}return obj;};var handleRedirect=function handleRedirect(msg){window.antd&&antd.message.error(msg);setTimeout(function(){try{if(_window2.default.getTop().opener&&_window2.default.getTop().opener.ecCom){_window2.default.getTop().opener.location.href=""+(window.ecologyContentPath||"")+"/wui/index.html?v="+new Date().getTime();}}catch(error){}window.localStorage["gopage"]=encodeURIComponent(location.href);_window2.default.getTop().location.href=""+(window.ecologyContentPath||"")+"/wui/index.html?v="+new Date().getTime();},1000);};var handleRejct=function handleRejct(msg){if(window.frameElement){var url=window.frameElement.src;if(/.*index-emobile\.html.*/.test(url)){if(em&&em.checkJsApi("pageReload")){em.pageReload({});}return true;}if(/.*index-message\.html.*/.test(url)){if(em&&em.checkJsApi("pageReload")){em.pageReload({});}return true;}if(/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(url)){if(em&&em.checkJsApi("pageReload")){em.pageReload({});}return true;}}if(/.*\/spa\/document\/static4Detail\/index.html#\/main\/document\/outShareDetail/.test(_window2.default.getTop().location.href)||/.*\/main\/document\/outDetail/.test(_window2.default.getTop().location.href)||/.*\/main\/document\/more/.test(_window2.default.getTop().location.href)||/.*\/cloudstore\/e9DevModules\/portal\/element\/rss\/index\.html#\/more/.test(_window2.default.getTop().location.href)||/.*\/login\/OALogin\.jsp.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index\.html.*#\/\?.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index\.html$/.test(_window2.default.getTop().location.href)){return true;}if(!/.*index-emobile\.html.*/.test(_window2.default.getTop().location.href)&&!/.*index-message\.html.*/.test(_window2.default.getTop().location.href)&&!/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(_window2.default.getTop().location.href)){if(window.emClient){emClient.logout();}if(window.localStorage["casPath"]){window.location.href=window.localStorage["casPath"];}else{if(window.e9TimeOutSwitch){handleRedirect(msg);return true;}window.eventRegister.register("f_portal",{lib:["/spa/portal/public/index.css?v=1561346408146","/spa/portal/public/index.js?v=1561346408146","/spa/portal/index.css?v=1561346598585","/spa/portal/index.js?v=1561346598585"],libName:"f_portal",fn:function fn(){return"success";}});window.eventRegister.start("f_portal",function(){if(window.doLoginPop){window.doLoginPop();}else{handleRedirect(msg);}},function(){handleRedirect(msg);});}}else{if(window.em){window.em.getEmAuthCode({sysId:window.localStorage.emobile_ec_id,// 集成系统ID
success:function success(emres){// 如：{"em_auth_code":"abc123","errMsg":"getEmAuthCode:ok"}
if(emres.em_auth_code){callApi("/api/ec/dev/app/test","GET",{em_auth_code:emres.em_auth_code}).then(function(res){if(res.status===true||res.status==="1"){window.location.reload();}else{console&&console.error("认证失败，"+res.errmsg);}},function(){console&&console.error("认证失败，code："+emres.em_auth_code);});}else{console&&console.error("获取em_auth_code失败");}}});}else{console&&console.error("em对象不存在");}}return true;};var checkReject=function checkReject(obj){if(obj.columns&&window.localStorage.getItem("hackResponse")){obj.errorCode="005";}var isFalse=false;if(obj.errorCode&&obj.errorCode==="001"){// session异常，如果有路由就强制跳转
isFalse=handleRejct((0,_util.getLabel)("516531","session过期，请重新登录！"));}else if(obj.errorCode&&obj.errorCode==="002"){// session异常，如果有路由就强制跳转
isFalse=handleRejct((0,_util.getLabel)("516532","登录超时，请重新登录！"));}else if(obj.errorCode&&obj.errorCode==="003"){// session异常，如果有路由就强制跳转
isFalse=handleRejct((0,_util.getLabel)("81908","您已被管理员强制下线！"));}else if(obj.errorCode&&obj.errorCode==="004"){// session异常，如果有路由就强制跳转
isFalse=handleRejct((0,_util.getLabel)("23274","您已经从另一个窗口登入，当前工作窗口失效！"));}else if(obj.errorCode&&obj.errorCode==="005"){window.antd&&antd.message.error(obj.error||obj.msg);// setTimeout(() => window.location.reload(), 1000);
isFalse=true;}else if(typeof obj.status!=="undefined"&&(!obj.status||obj.status==="false")){// window.antd && antd.message.error('接口业务逻辑错误：' + obj.error, 5);
if(obj.error||obj.msg){!/.*index-emobile\.html.*/.test(_window2.default.getTop().location.href)&&!/.*index-message\.html.*/.test(_window2.default.getTop().location.href)&&!/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(_window2.default.getTop().location.href)&&window.antd&&antd.message.error(obj.error||obj.msg);}isFalse=true;}return isFalse;};var checkCSRF=function checkCSRF(url,method,_params,type,deep){var check=arguments.length>5&&arguments[5]!==undefined?arguments[5]:true;if(!check){return callApi(url,method,params,type,deep,false);}var params=Object.prototype.toString.call(_params)==="[object Object]"?(0,_extends3.default)({},_params):{};if(Object.prototype.toString.call(_params)==="[object Array]"){params=[].concat((0,_toConsumableArray3.default)(_params));}if(window.pageCheckKey&&window.pageCheckCode){// 单独处理表单一个页面唯一code
params[window.pageCheckKey]=window.pageCheckCode;params["__randCodeKey__"]=window.pageCheckKey;return callApi(url,method,params,type,deep,false);}return callApi("/api/security/getRandomCode","get",{},"json",false,false).then(function(res){params[res.key]=res.code;params["__randCodeKey__"]=res.key;return callApi(url,method,params,type,deep,false);}).catch(function(err){window.checkCSRF=false;return callApi(url,method,params,type,deep,false);});};var callApi=exports.callApi=function callApi(url){var method=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"GET";var _params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var type=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"json";var deep=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var checkCode=arguments.length>5&&arguments[5]!==undefined?arguments[5]:true;var params=Object.prototype.toString.call(_params)==="[object Object]"?(0,_extends3.default)({},_params):{};if(Object.prototype.toString.call(_params)==="[object Array]"){params=[].concat((0,_toConsumableArray3.default)(_params));}if(typeof localStorage.access_token==="string"&&localStorage.access_token!==""){params.access_token=localStorage.access_token;}if(window.checkCSRF===true&&checkCode&&window.sessionStorage["em_check_csrf"]=="true"&&// method.toUpperCase() === "POST" &&
/^\/api/.test(url)){return checkCSRF(url,method,_params,type,deep);}url=""+server+url;if(window.ecCallApiLogServer&&url=="/api/securtity/addListUrlLog"){url=""+window.ecCallApiLogServer+url;}var reg=new RegExp("^"+window.ecologyContentPath+"");if(!/^http/.test(url)&&!reg.test(url)){url=(window.ecologyContentPath||"")+url;}if(method.toUpperCase()==="GET"&&!(0,_isEmpty2.default)(params)){var c="?";if(/\?/.test(url))c="&";url=""+url+c+getFd(params);}if(method.toUpperCase()==="GET"&&!/__random__=/.test(url)){var _c="?";if(/\?/.test(url))_c="&";url+=_c+"__random__="+new Date().getTime();}// 处理连续&
url=url.replace(/\&\&/g,"&");function evil(fn){var Fn=window.Function;//一个变量指向Function，防止有些前端编译工具报错
return new Fn("return "+fn)();}return new _promise2.default(function(resolve,reject){var lastReq=function lastReq(){var isConfirm=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var validateParams=(0,_stringify2.default)(_params);if(validateParams.indexOf("base64_")>-1){console&&console.warn("原不能提交数据：",_params);// regex
var regexBase=/base64_(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?/g;if(regexBase.test(validateParams)){params=validateParams.replace(regexBase,function(oldStr){return _jsBase.Base64.decode(oldStr.substr(7));});console&&console.warn("后转换成功的数据",JSON.parse(params));}if(params.indexOf("base64_")>-1){reject((0,_util.getLabel)("516533","base64 不能提交:"));}else{params=JSON.parse(params);}}if(isConfirm){params.sensitiveWordconfirm=1;}if(method.toUpperCase()==="GET"&&isConfirm){var _c2="?";if(/\?/.test(url))_c2="&";url+=_c2+"sensitiveWordconfirm=1";}var _url=url;var _fetchParams=getFetchParams(method,params,deep,window.ecCallApiLog?true:false);if(window.e9ssoPCConfig&&window.e9ssoPCConfig.inUse&&window.e9ssoPCConfig.callapi_params_handler&&!isConfirm){var res=window.e9ssoPCConfig.callapi_params_handler(_url,method,params,type,_fetchParams);_url=res.url;method=res.method;params=res.params;type=res.type;_fetchParams=res.fetchParams||getFetchParams(method,params,deep,window.ecCallApiLog?true:false);}if(window.ecCallApiLog){var logParams={};logParams._url=_url;logParams.method=method;logParams.params=params;logParams.type=type;logParams._fetchParams=_fetchParams;logParams.themeAccount=localStorage["theme-account"];logParams.href=window.location.href;logParams.calldatetime=new Date();}fetch(_url,_fetchParams).then(function(response){if(window.ecCallApiLog){logParams.response=response.clone();logParams.endtime=new Date();window.ecCallApiLog(logParams);}if(!response.ok){if(window.ecCallApiHandler){if(typeof window.ecCallApiHandler=="function"){window.ecCallApiHandler(_url,params,response.status,response.statusText);}}return _promise2.default.reject({status:response.status,statusText:response.statusText});}return response.text().then(function(data){if(window.e9ssoPCConfig&&window.e9ssoPCConfig.inUse&&window.e9ssoPCConfig.callapi_response_handler){return window.e9ssoPCConfig.callapi_response_handler(data,reject,response,type);}if(response.redirected&&/\/login\/Login.jsp/.test(response.url)){if(/.*\/wui\/index\.html#\/?.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index\.html$/.test(_window2.default.getTop().location.href)){return{status:true};}if(/.*index-emobile\.html.*/.test(_window2.default.getTop().location.href)||/.*index-message\.html.*/.test(_window2.default.getTop().location.href)||/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(_window2.default.getTop().location.href)){if(window.em){em.setPageReload({setvalue:1,// 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
success:function success(res){// 如：{"errMsg":"setHoldPage:ok"}
//alert(res.errMsg);
}});}return{status:false,errorCode:"002"};}if(window.frameElement){var _url2=window.frameElement.src;if(/.*index-emobile\.html.*/.test(_url2)||/.*index-message\.html.*/.test(_url2)||/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(_url2)){if(window.em){em.setPageReload({setvalue:1,// 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
success:function success(res){// 如：{"errMsg":"setHoldPage:ok"}
//alert(res.errMsg);
}});}return{status:false,errorCode:"002"};}}window.antd&&antd.message.error((0,_util.getLabel)("516532","登录超时，请重新登录！"));console&&console.error(url+" fetch \u767B\u5F55\u8D85\u65F6");setTimeout(function(){window.localStorage["gopage"]=encodeURIComponent(location.href);_window2.default.getTop().location.href=""+(window.ecologyContentPath||"")+"/wui/index.html?v="+new Date().getTime();},1000);}if(type==="json"){try{var dataTemp=JSON.parse(data);if(dataTemp.needResponse){dataTemp.response=response;}return dataTemp;}catch(error){data=data||"{}";return evil("("+data+")");// JSON.parse 解析反斜杠报错处理
}}else{return data;}});}).then(function(data){if(window.rewriteApiData){data=window.rewriteApiData(_url,params,data);}//weaHistory
if(type==="json"&&data&&(data.status==="false"||!data.status)&&data.showType==="url"&&data.url){setTimeout(function(){return _window2.default.getTop().location.href=data.url;},1000);resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&data.showType==="auth"){if(window.weaHistory){var pathname="/main/com/auth";if(_window2.default.getTop().location.href.indexOf("/wui/engine.html")>-1){pathname="/com/auth";}window.weaHistory.push({pathname:pathname});}resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&(data.showMsg||data.showType==="msg")){data.error&&window.antd&&antd.message.warn(data.error);resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&data.showType==="none"){resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&(data.showModal||data.showType==="modal")){data.error&&window.antd&&antd.Modal.warning({title:data.title||(0,_util.getLabel)("19085","消息提醒"),content:data.error});resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&data.errorCode==="009"){// 敏感词预检
var _params2={title:(0,_util.getLabel)("131329","信息确认"),content:data.msg,showClose:false,okCancel:false,okText:(0,_util.getLabel)("532049","确定"),zIndex:9999999,onOk:function onOk(){window.onWeaDialogClose&&window.onWeaDialogClose();lastReq(true);}};if(data.remindType=="2"){_params2=(0,_extends3.default)({},_params2,{showClose:true,okCancel:true,onCancel:function onCancel(){window.onWeaDialogClose&&window.onWeaDialogClose();resolve((0,_extends3.default)({},data,{msg:""}));}});}window.onWeaDialogOpen&&window.onWeaDialogOpen();window.antd&&antd.Modal.confirm(_params2);}else if(type==="json"&&checkReject(data)){console&&console.error(url+" fetch \u8BF7\u6C42\u5F02\u5E38: "+(data.error||"error"));if(/\/api\/ecode\/sync/.test(url)){resolve({status:true});}reject(url+" fetch \u8BF7\u6C42\u5F02\u5E38: "+(data.error||"error"));}else{resolve(data);}}).catch(function(ex){if(window.ecCallApiHandler){if(typeof window.ecCallApiHandler=="function"){window.ecCallApiHandler(_url,params,ex.status,ex.statusText);}}console&&console.error(url+" fetch \u6570\u636E\u5904\u7406\u5F02\u5E38: "+ex+", params:",params);reject({msg:url+" fetch \u6570\u636E\u5904\u7406\u5F02\u5E38: "+ex,responseCode:ex.status,statusText:ex.statusText});});};lastReq();});};if(window.sessionStorage["em_check_csrf"]===undefined){callApi("/api/security/isEnableRandomCode").then(function(res){if(res.randomCodeStatus==true){window.checkCSRF=true;window.sessionStorage["em_check_csrf"]="true";}}).catch(function(error){console&&void 0;window.sessionStorage["em_check_csrf"]="false";});}else{if(window.sessionStorage["em_check_csrf"]=="true"){window.checkCSRF=true;}}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(235),
    getTag = __webpack_require__(93),
    isArguments = __webpack_require__(113),
    isArray = __webpack_require__(21),
    isArrayLike = __webpack_require__(71),
    isBuffer = __webpack_require__(114),
    isPrototype = __webpack_require__(112),
    isTypedArray = __webpack_require__(170);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(341);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(64));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./evpkdf"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(314);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(315);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(62),
    isObject = __webpack_require__(40);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Baron=__webpack_require__(508);var WeaNewScroll=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaNewScroll,_React$Component);function WeaNewScroll(props){(0,_classCallCheck3.default)(this,WeaNewScroll);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaNewScroll.__proto__||(0,_getPrototypeOf2.default)(WeaNewScroll)).call(this,props));_this.update=function(){if(!_this.refs.weaBaron)return;_this.refs.weaBaron&&_this.refs.weaBaron.baron.update();};_this.state={scrollTop:0};return _this;}(0,_createClass3.default)(WeaNewScroll,[{key:"scrollerToTop",value:function scrollerToTop(){if(!this.refs.weaBaron)return;if(this.refs.weaBaron.getScroller())this.refs.weaBaron.getScroller().scrollTop=0;if(this.refs.weaBaron.getBar())this.refs.weaBaron.getBar().top=0;}},{key:"scrollToLast",value:function scrollToLast(){if(!this.refs.weaBaron)return;this.refs.weaBaron.scrollToLast&&this.refs.weaBaron.scrollToLast();}},{key:"scroll",value:function scroll(number){if(!this.refs.weaBaron)return;if(this.refs.weaBaron.getScroller())this.refs.weaBaron.getScroller().scrollTop=number;if(this.refs.weaBaron.getBar())this.refs.weaBaron.getBar().top=number;}},{key:"getScrollTop",value:function getScrollTop(){var v=0;if(this.refs.weaBaron&&this.refs.weaBaron.getScroller())v=this.refs.weaBaron.getScroller().scrollTop;return v;}},{key:"onScroll",value:function onScroll(){var _props;var scrollTop=this.getScrollTop();this.setState({scrollTop:scrollTop});this.props.onScroll&&(_props=this.props).onScroll.apply(_props,arguments);}},{key:"render",value:function render(){var _props2=this.props,toTop=_props2.toTop,_props2$toTopTitle=_props2.toTopTitle,toTopTitle=_props2$toTopTitle===undefined?"滚动到顶部":_props2$toTopTitle,height=_props2.height,direction=_props2.direction;var scrollTop=this.state.scrollTop;var style=this.props.style||{};if(height)style.height=height;return React.createElement("div",{className:"wea-new-scroll "+(this.props.className||""),ref:"weaNewScroll",style:style,id:this.props.scrollId},React.createElement(Baron,(0,_extends3.default)({$:jQuery},this.props,{ecId:this.props.ecId+"_Baron@0phg05",ref:"weaBaron",clipperCls:"clipper "+(direction==="h"?"_h":""),scrollerCls:"scroller "+(navigator.userAgent.indexOf("Firefox")>=0?"firefox-width":"")+" "+(direction==="h"?"_h":""),trackCls:"track "+(navigator.userAgent.indexOf("Firefox")>=0?"firefox-track":""),barCls:"bar",onScroll:this.onScroll.bind(this),barOnCls:"baron"}),this.props.children),toTop&&scrollTop>0&&React.createElement("div",{className:"returnToTop",title:toTopTitle,ecId:this.props.ecId+"_div@b3y0ar",onClick:this.scrollerToTop.bind(this)},React.createElement("span",{className:"icon-coms-upper"})));}}]);return WeaNewScroll;}(React.Component),_class.defaultProps={direction:"v"},_temp);var Com=(0,_middleware2.default)(WeaNewScroll,"WeaNewScroll");exports.default=Com;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(388), __esModule: true };

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WindowFunc=function(){function WindowFunc(){(0,_classCallCheck3.default)(this,WindowFunc);}(0,_createClass3.default)(WindowFunc,[{key:"getTop",value:function getTop(){var current=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;try{var topWindow=window.top;topWindow.canSet="canSet";if(!topWindow.ecCom){return self;}return topWindow;}catch(error){if(current===null){current=self;}if(current.setTopWindow){return current.setTopWindow;}else{try{var parentWindow=current.parent;parentWindow.canSet="canSet";return this.getTop(parentWindow);}catch(error){current.setTopWindow=current;return current;}}}}},{key:"getParent",value:function getParent(){try{var parent=window.parent;if(!parent.ecCom){return self;}return parent;}catch(error){return self;}}}]);return WindowFunc;}();exports.default=new WindowFunc();

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(160)('wks');
var uid = __webpack_require__(109);
var Symbol = __webpack_require__(29).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__ = __webpack_require__(628);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__ = __webpack_require__(277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(11);
/* unused harmony reexport bpfrpt_proptype_NoContentRenderer */
/* unused harmony reexport bpfrpt_proptype_Alignment */
/* unused harmony reexport bpfrpt_proptype_CellPosition */
/* unused harmony reexport bpfrpt_proptype_CellSize */
/* unused harmony reexport bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony reexport bpfrpt_proptype_RenderedSection */
/* unused harmony reexport bpfrpt_proptype_CellRendererParams */
/* unused harmony reexport bpfrpt_proptype_Scroll */

























/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(171);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(164),
    baseTrim = __webpack_require__(233),
    castSlice = __webpack_require__(410),
    charsEndIndex = __webpack_require__(412),
    charsStartIndex = __webpack_require__(415),
    stringToArray = __webpack_require__(416),
    toString = __webpack_require__(57);

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _toNumber=__webpack_require__(149);var _toNumber2=_interopRequireDefault(_toNumber);var _isEqual=__webpack_require__(346);var _isEqual2=_interopRequireDefault(_isEqual);var _cryptoJs=__webpack_require__(513);var _cryptoJs2=_interopRequireDefault(_cryptoJs);var _format=__webpack_require__(182);var format=_interopRequireWildcard(_format);var _getComponent=__webpack_require__(312);var gcUtil=_interopRequireWildcard(_getComponent);var _callApi=__webpack_require__(17);var caUtil=_interopRequireWildcard(_callApi);var _watermark=__webpack_require__(250);var _watermark2=_interopRequireDefault(_watermark);var _html2image=__webpack_require__(251);var _base=__webpack_require__(272);var _base2=_interopRequireDefault(_base);var _dialog=__webpack_require__(345);var dUtil=_interopRequireWildcard(_dialog);var _messageCenter=__webpack_require__(734);var _messageCenter2=_interopRequireDefault(_messageCenter);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);var _util=__webpack_require__(300);var _storage=__webpack_require__(60);var _loadjs=__webpack_require__(54);var _loadjs2=_interopRequireDefault(_loadjs);var _onbeforeunload=__webpack_require__(735);var UnloadHook=_interopRequireWildcard(_onbeforeunload);var _open=__webpack_require__(736);var _userAgent=__webpack_require__(121);var _Encry=__webpack_require__(51);var EncryBase=_interopRequireWildcard(_Encry);__webpack_require__(737);var _antd=__webpack_require__(8);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _loadCss=__webpack_require__(83);var _viewer=__webpack_require__(738);var _loadDevModules=__webpack_require__(739);var _checkRouter=__webpack_require__(740);var _checkRouter2=_interopRequireDefault(_checkRouter);var _color=__webpack_require__(741);var _color2=_interopRequireDefault(_color);var _getUrlParams=__webpack_require__(248);var _getUrlParams2=_interopRequireDefault(_getUrlParams);var _checkSSO=__webpack_require__(247);var _baseLanguageInterval=__webpack_require__(742);var _emTools=__webpack_require__(298);var _contentPath=__webpack_require__(743);var _contentPath2=_interopRequireDefault(_contentPath);var _timeoutSwitch=__webpack_require__(744);var _timeoutSwitch2=_interopRequireDefault(_timeoutSwitch);var _getOsInfo=__webpack_require__(249);var _getOsInfo2=_interopRequireDefault(_getOsInfo);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}__webpack_require__(745);__webpack_require__(746);__webpack_require__(747);var getLabel=_weaLocaleProvider2.default.getLabel;var utf8=__webpack_require__(748);// let Base64WithLocale = {...Base64, decode: function(str) {
//   let base64Str = Base64.decode(str);
//   return WeaLocaleProvider.formatMultiLang(base64Str);
// }};
var getSelectDefaultValue=gcUtil.getSelectDefaultValue;// fetch 部分处理
var server=window.server||"";var trim=function trim(s){return s.replace(/(^\s*)|(\s*$)/g,"");};var tools={getOsInfo:_getOsInfo2.default,openRewrite:_open.openRewrite,watermark:_watermark2.default,EncryBase:EncryBase,WaterMarkCanvas:_html2image.WaterMarkCanvas,Canvas2Image:_html2image.Canvas2Image,UserAgent:_userAgent.UserAgent,ua:_userAgent.ua,messageCenter:_messageCenter2.default,WindowFunc:_window2.default,ls:_storage.ls,ss:_storage.ss,tryCatch:function tryCatch(React,ErrorHandler,handlerOptions){if(!React||!React.Component){throw new Error("arguments[0] for react-try-catch-render does not look like React.");}if(typeof ErrorHandler!=="function"){throw new Error("arguments[1] for react-try-catch-render does not look like a function.");}/**
     * Implementation of the try/catch wrapper
     * @param  {[React.Component]} component The ES6 React.Component
     */return function wrapWithTryCatch(Component){var originalRender=Component.prototype.render;Component.prototype.render=function tryRender(){try{return originalRender.apply(this,arguments);}catch(err){// Log an error
window.console&&console.error("errorLog:",err);if(ErrorHandler.prototype&&ErrorHandler.prototype.render){return React.createElement(ErrorHandler,handlerOptions);}// ErrorHandler is at least a valid function
return ErrorHandler(err);}};return Component;};},downloadFile:function downloadFile(url,method,params){if(!params)params={};if(typeof localStorage.access_token==="string"&&localStorage.access_token!==""){params.access_token=localStorage.access_token;}var reg=new RegExp("^"+window.ecologyContentPath+"");url=reg.test(url)?url:(window.ecologyContentPath||"")+url;url=""+server+url;var form=jQuery("<form></form>").attr("action",url).attr("method",method);var inputs="";for(var key in params){inputs+='<input type="hidden" name="'+key+'" value="'+params[key]+'" />';}inputs+='<input type="hidden" name="testHolder" value="testHolder" />';form.append(inputs);form.appendTo("body").submit().remove();},checkSession:function checkSession(nextState,replace,callback){callback();},isComponentHide:function isComponentHide(field){var hide=false;if(field){var ct=field.conditionType.toUpperCase();var viewAttr=field.viewAttr;if(ct=="BROWSER")viewAttr=field.browserConditionParam.viewAttr;hide=viewAttr==-1;// -1 隐藏
}return hide;},math:function math(){var _this=this;return new _promise2.default(function(resolve,reject){if(window.math){resolve(window.math);}else{_this.loadJs("mathjs",(window.ecologyContentPath||"")+"/cloudstore/resource/pc/mathjs/math.min.js",function(){resolve(window.math);});}});},loadJs:function loadJs(sid,jsurl,callback){var nodeHead=document.getElementsByTagName("head")[0];var nodeScript=null;if(document.getElementById(sid)===null){nodeScript=document.createElement("script");nodeScript.setAttribute("type","text/javascript");nodeScript.setAttribute("src",jsurl);nodeScript.setAttribute("id",sid);if(callback!=null){nodeScript.onload=nodeScript.onreadystatechange=function(){if(nodeScript.ready){return false;}if(!nodeScript.readyState||nodeScript.readyState==="loaded"||nodeScript.readyState==="complete"){nodeScript.ready=true;callback();}};}nodeHead.appendChild(nodeScript);}else{if(callback!=null){callback();}}},loadjs:_loadjs2.default,getSelectDefaultValue:getSelectDefaultValue,formatRealDate:format.formatDate,formatDate:format.formatToDate,formatTime:format.formatToTime,getParamsByConditions:gcUtil.getParamsByConditions,getComponent:gcUtil.getComponent,getFd:caUtil.getFd,callApi:caUtil.callApi,Base64:_base2.default,loadCss:_loadCss.loadCss,viewer:_viewer.viewer,loadDevModules:_loadDevModules.loadDevModules,checkStdRouter:_checkRouter2.default,getReverseColor:_color2.default,getUrlParams:_getUrlParams2.default,checkSSO:_checkSSO.checkSSO,checkJoin:_emTools.checkJoin,getEmAudioOrVideo:_emTools.getEmAudioOrVideo,checkDing:_emTools.checkDing,createDing:_emTools.createDing,checkLang:_baseLanguageInterval.checkLang,checkCustomSSO:_checkSSO.checkCustomSSO,ssoLogout:_checkSSO.ssoLogout,isEqual:_isEqual2.default,utf8:utf8,CryptoJS:_cryptoJs2.default,getDialog:dUtil.getDialog,createDialog:dUtil.createDialog,createReactEle:dUtil.createReactEle,getIconBGC:dUtil.getIconBGC,UnloadHook:UnloadHook,getTextWidth:function getTextWidth(str){var width=0;if(str){for(var i=0;i<str.length;i++){// 如果是汉字
if(str.charCodeAt(i)>255){width+=14;}else{width+=7;}}}return width;},getZindex:function getZindex(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"home";var defaultIndex=arguments.length>1&&arguments[1]!==undefined?arguments[1]:99;var key=page+"ZINDEX";var cache=this.ss.getStr(key);var zindex=cache?Number(cache)+1:defaultIndex;this.ss.set(key,zindex);return zindex;},tooltip:function tooltip(dom){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// http://vadikom.com/demos/poshytip/
if(!dom||!jQuery)return;if(!(dom instanceof jQuery)){dom=jQuery(dom);}if(typeof params==="string")return dom.poshytip(params);var config=(0,_extends3.default)({className:"tip-yellow",alignX:"right",alignY:"center",fade:false,slide:false,offsetX:0},params);dom.poshytip(config);},isWeekendDay:function isWeekendDay(str){var bool=false;if(str){var dt=new Date(str);if(dt.getDay()==0||dt.getDay()==6){bool=true;}}return bool;},isBelowIE9:function isBelowIE9(){return navigator.appName=="Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g,"").replace("MSIE",""))<=9;},/**
   * INPUT ： 文本输入框
   * SELECT ： 下拉选择框
   * DATE ： 日期格式
   * DATEPICKER ：日期格式 不带区间
   * TIMEPICKER ：时间选择
   * YEARPICKER ：年份选择
   * MONTHPICKER ：年月选择
   * BROWSER ：浏览框
   * SELECT_LINKAGE ：下拉选择框联动
   * INPUT_INTERVAL   ：input 区间
   * SCOPE ： input 区间
   * CHECKBOX：check框
   * SWITCH：switch开关
   * TIMEPICKER ：时间
   * TIME_INTERVAL ：时间区间
   * CUSTOM ： 自定义组件(流程自定义查询相关)
   * CASCADER： 多级级联组件
   * INPUTNUMBER： 整数小数输入框
   * PERIOD： 时间段选择
   * UPLOAD： 上传
   * RICHTEXT： 富文本
   * TAGGROUP： 标签组
   * DESCRIPTION：说明
   */types:{INPUT:"INPUT",PASSWORD:"PASSWORD",BROWSER:"BROWSER",CHECKBOX:"CHECKBOX",DATEPICKER:"DATEPICKER",TIMEPICKER:"TIMEPICKER",YEARPICKER:"YEARPICKER",MONTHPICKER:"MONTHPICKER",SELECT:"SELECT",TEXTAREA:"TEXTAREA",DATE:"DATE",SCOPE:"SCOPE",SELECT_LINKAGE:"SELECT_LINKAGE",SWITCH:"SWITCH",RANGEPICKER:"RANGEPICKER",TIMERANGEPICKER:"TIMERANGEPICKER",COLORPICKER:"COLORPICKER",CASCADER:"CASCADER",CASCADERCUSTOMFIELD:"CASCADERCUSTOMFIELD",// CASCADER的子组建
INPUTNUMBER:"INPUTNUMBER",INPUTSEARCH:"INPUTSEARCH",PERIOD:"PERIOD",UPLOAD:"UPLOAD",RICHTEXT:"RICHTEXT",TAGGROUP:"TAGGROUP",DESCRIPTION:"DESCRIPTION"},getKey:function getKey(f){var key="";if(f.domkey)key=f.domkey.join("__");return key;},getValueByfield:function getValueByfield(field){if(!field)return{};var type=field.conditionType.toUpperCase();var types=this.types;var arrs=[types.RICHTEXT,types.INPUT,types.PASSWORD,types.CHECKBOX,types.DATEPICKER,types.TIMEPICKER,types.TEXTAREA,types.SWITCH,types.COLORPICKER,types.INPUTNUMBER,types.DESCRIPTION];if(arrs.indexOf(type)>-1){if(field.value!==undefined){return{value:field.value};}}if([types.CASCADERCUSTOMFIELD,types.CASCADER].indexOf(type)>-1){if(field.value!==undefined||field.values!==undefined){return{value:field.values||field.value};}}if(types.SELECT===type){var value=this.getSelectDefaultValue((0,_extends3.default)({},field.options),field.detailtype);if(field.value!=undefined&&field.value!=="")value=field.value;var valueSpan="";var target=field.options&&field.options.filter(function(data){return data.key==value;})[0];valueSpan=target?target.showname:"";if(value!==undefined){return{value:value,valueSpan:valueSpan};}}if(types.BROWSER===type){if(!(0,_isEmpty2.default)(field.browserConditionParam)){var replacesDatas=field.browserConditionParam.replaceDatas||field.browserConditionParam.valueObj;if(!(0,_isEmpty2.default)(replacesDatas)){var values=[],names=[];replacesDatas.forEach(function(d){if(d){values.push(d.id);names.push(d.lastname||d.name);// 人力按钮特殊处理
}});return{value:values.join(","),valueSpan:names.join(","),valueObj:replacesDatas};}}}if(types.DATE===type){var selectValue="0",startValue=null,endValue=null;if(!(0,_isEmpty2.default)(field.options))selectValue=this.getSelectDefaultValue(field.options)||selectValue;if(!(0,_isEmpty2.default)(field.value)){selectValue=field.value[field.domkey[0]];startValue=field.value[field.domkey[1]];endValue=field.value[field.domkey[2]];}return{value:[selectValue,startValue,endValue]};}if(types.SELECT_LINKAGE===type){var _selectValue=this.getSelectDefaultValue(field.options)||(field.options[0]?field.options[0].key:"");var resp=[_selectValue];if(field.selectLinkageDatas){var rightField=field.selectLinkageDatas[_selectValue];if(rightField){var rightValues=this.getValueByfield(rightField);if(rightValues){var rightResult=[];var rightType=rightField.conditionType.toUpperCase();if(types.BROWSER===rightType){rightResult[0]=rightValues.value;rightResult[1]=rightValues.valueSpan;rightResult[2]=rightValues.valueObj;}else if([types.RANGEPICKER,types.TIMERANGEPICKER,types.SCOPE,types.DATE].indexOf(rightType)>-1){rightResult=rightValues.value;}else{rightResult[0]=rightValues.value;}resp[1]=rightResult;}}}return{value:resp};}if(types.SCOPE===type){var sValue=field.startValue||"",eValue=field.endValue||"";if(sValue)sValue=(0,_toNumber2.default)(sValue);if(eValue)eValue=(0,_toNumber2.default)(eValue);return{value:[sValue,eValue]};}if([types.RANGEPICKER,types.TIMERANGEPICKER].indexOf(type)>-1){var _sValue=field.startDate||field.startValue||field[field.domkey[0]]||"",_eValue=field.endDate||field.endValue||field[field.domkey[1]]||"";var result=[_sValue,_eValue];if(!_sValue&&!_eValue)result=[];return{value:result};}if(types.PERIOD===type){return{value:field.value};}if(types.UPLOAD===type){if(field.datas&&!(0,_isEmpty2.default)(field.datas)){var _value=field.datas.map(function(t){return t.fileid||t.id;}).join(",");return{value:_value,valueSpan:field.datas};}}if(types.TAGGROUP===type){if(field.datas&&!(0,_isEmpty2.default)(field.datas)){var _value2=field.datas.map(function(t){return t.id;}).join(",");return{value:_value2,valueSpan:field.datas};}}// add custom field default value
if(field.value!==undefined){return{value:field.value};}},getStringLength:function getStringLength(){var val=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var len=0;for(var i=0;i<val.length;i++){var c=val.charCodeAt(i);//单字节加1
if(c>=0x0001&&c<=0x007e||0xff60<=c&&c<=0xff9f){len++;}else{len+=3;}}return len;},getStringByLength:function getStringByLength(){var val=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var length=arguments[1];var len=0,str="";for(var i=0;i<val.length;i++){var c=val.charCodeAt(i);var s=val.charAt(i);//单字节加1
if(c>=0x0001&&c<=0x007e||0xff60<=c&&c<=0xff9f){len++;}else{len+=3;}if(len>length)return str;str+=s;}},transHTML:function transHTML(){var val=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var result=val.replace(/>/g,"&gt;").replace(/</g,"&lt;")// .replace(/&gt;/g, ">")
// .replace(/&lt;/g, "<")
.replace(/\n/g,"<br/>").replace(/\r/g,"<br/>").replace(/\s/g,"&nbsp;").replace(/'/g,"&apos;").replace(/"/g,"&quot;");return result;},downloadCvs2Img:function downloadCvs2Img(cvs){var picName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"Download";if(this.isBelowIE9()){_antd.message.warning(getLabel(385817,"IE9以下版本浏览器不支持下载功能，请换个其他版本的浏览使用"));return;}if(!cvs){return;}var $a=document.createElement("a");$a.download=picName+".jpg";$a.target="_blank";var url=cvs.toDataURL("image/jpg");$a.href=url;if(typeof MouseEvent==="function"){var evt=new MouseEvent("click",{view:window,bubbles:true,cancelable:false});$a.dispatchEvent(evt);}else{if(window.navigator.msSaveOrOpenBlob){var bstr=atob(url.split(",")[1]);var n=bstr.length;var u8arr=new Uint8Array(n);while(n--){u8arr[n]=bstr.charCodeAt(n);}var blob=new Blob([u8arr]);window.navigator.msSaveOrOpenBlob(blob,"Download.jpg");}else{// var lang = model.get('lang');
var html=""+'<body style="margin:0;">'+'<img src="'+url+'" style="max-width:100%;" title="" />'+"</body>";var tab=window.open();tab.document.write(html);}}},/** 发送消息*/sendMsg:_util.sendMsgToPC};var openFullWindowHaveBar=function openFullWindowHaveBar(url){var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-50;var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";window.open(redirectUrl,"",szFeatures);};window.openFullWindowHaveBar=openFullWindowHaveBar;window.openFullWindowForXtable=openFullWindowHaveBar;(0,_contentPath2.default)();(0,_timeoutSwitch2.default)();// initBaseLanguageInterval();
// initRefreshLanguageInterval();
exports.default=tools;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(444)();
}


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(486), __esModule: true };

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_38__;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(20);
var ctx = __webpack_require__(68);
var hide = __webpack_require__(58);
var has = __webpack_require__(61);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(231);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(350);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(62),
    isArray = __webpack_require__(21),
    isObjectLike = __webpack_require__(45);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _uniqueId=__webpack_require__(326);var _uniqueId2=_interopRequireDefault(_uniqueId);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Input from '../../_antd1.11.2/input'
// import Button from '../../_antd1.11.2/button'
var InputGroup=_antd.Input.Group;var WeaInputFocus=function(_React$Component){(0,_inherits3.default)(WeaInputFocus,_React$Component);function WeaInputFocus(props){(0,_classCallCheck3.default)(this,WeaInputFocus);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaInputFocus.__proto__||(0,_getPrototypeOf2.default)(WeaInputFocus)).call(this,props));_this.clear=function(){_this.setState({value:""});if(_this.props.onSearchChange){_this.props.onSearchChange("");}(0,_isFunction2.default)(_this.props.onChange)&&_this.props.onChange("");};_this.state={value:props.value||"",focus:false};_this.index=(0,_uniqueId2.default)("weaInputSearch_");return _this;}(0,_createClass3.default)(WeaInputFocus,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextState){nextProps.value!=="undefined"&&nextProps.value!==this.props.value&&nextProps.value!==this.state.value&&this.setState({value:nextProps.value||""});}},{key:"handleFocusBlur",value:function handleFocusBlur(e){if(typeof this.props.onFocusChange==="function"){this.props.onFocusChange(e.target===document.activeElement);}(0,_isFunction2.default)(this.props.onBlur)&&this.props.onBlur(e.target.value);this.setState({focus:e.target===document.activeElement});}},{key:"handleInputChange",value:function handleInputChange(e){var _this2=this;var placeholderExtra=this.props.placeholderExtra;this.setState({value:e.target.value},function(){if(placeholderExtra&&_this2.state.value!==""){jQuery("#"+_this2.index).fadeIn();setTimeout(function(){jQuery("#"+_this2.index).fadeOut();},5000);}});if(this.props.onSearchChange){this.props.onSearchChange(e.target.value);}(0,_isFunction2.default)(this.props.onChange)&&this.props.onChange(e.target.value);}},{key:"handleSearch",value:function handleSearch(){if(this.props.onSearch){this.props.onSearch(this.state.value);}}},{key:"handleInputClick",value:function handleInputClick(e,value){var _this3=this;// 处理右键粘贴问题
var placeholderExtra=this.props.placeholderExtra;this.setState({value:value},function(){if(placeholderExtra&&_this3.state.value!==""){jQuery("#"+_this3.index).fadeIn();setTimeout(function(){jQuery("#"+_this3.index).fadeOut();},5000);}});if(value&&this.props.onSearchChange){this.props.onSearchChange(e.target.value);}(0,_isFunction2.default)(this.props.onChange)&&this.props.onChange(e.target.value);}},{key:"enterKeyDown",value:function enterKeyDown(e){e.keyCode==13&&this.handleSearch();}},{key:"render",value:function render(){var _props=this.props,style=_props.style,placeholder=_props.placeholder,textDecoration=_props.textDecoration,placeholderExtra=_props.placeholderExtra,_props$className=_props.className,className=_props$className===undefined?"":_props$className,children=_props.children;var btnCls=(0,_classnames2.default)({"ant-search-btn":this.state.focus});return React.createElement("div",{ecId:this.props.ecId+"_div@l0egtt",className:"wea-input-focus "+className,onKeyDown:this.enterKeyDown.bind(this),style:style},React.createElement(_antd.Input,{ecId:this.props.ecId+"_Input@kyto3o",placeholder:placeholder,value:this.state.value,onFocus:this.handleFocusBlur.bind(this),onBlur:this.handleFocusBlur.bind(this),onChange:this.handleInputChange.bind(this),onClick:this.handleInputClick.bind(this),className:""+(textDecoration&&"text-decoration")}),this.state.value&&this.state.value!==""&&React.createElement("span",{ecId:this.props.ecId+"_span@n6zb1e",className:"wea-input-clear",onClick:this.clear},React.createElement("icon",{className:"icon-coms-Clear"})),React.createElement(_antd.Button,{className:btnCls+" wea-input-focus-btn",type:"ghost",icon:"search",ecId:this.props.ecId+"_Button@6nv7ke",onClick:this.handleSearch.bind(this)}),React.createElement("span",{className:"placeHolder-tip",id:""+this.index},placeholderExtra),children);}}]);return WeaInputFocus;}(React.Component);var Com=(0,_middleware2.default)(WeaInputFocus,"WeaInputSearch");exports.default=Com;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);__webpack_require__(609);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.formItemFocus=function(){if(!window.ActiveXObject&&!("ActiveXObject"in window)){// 非IE下使用scrollIntoView实现滚动定位
if(!window.doValidateLocaltion){var formItem=ReactDOM.findDOMNode(_this.formItem);if(formItem&&formItem.scrollIntoView){formItem.scrollIntoView({behavior:"smooth",block:"nearest"});window.doValidateLocaltion=true;setTimeout(function(){return window.doValidateLocaltion=false;},2000);}}}};_this.getErrorStyle=function(){var _this$props=_this.props,_this$props$tipPositi=_this$props.tipPosition,tipPosition=_this$props$tipPositi===undefined?"top":_this$props$tipPositi,_this$props$errorStyl=_this$props.errorStyle,errorStyle=_this$props$errorStyl===undefined?{}:_this$props$errorStyl;var style=(0,_extends3.default)({},errorStyle);if(_this.errorRef){var height=_this.errorRef.clientHeight;if(height){var position=-(height+6);style=(0,_extends3.default)({},style,{bottom:tipPosition=="bottom"?position:"auto",top:tipPosition=="bottom"?"auto":position});}}return style;};_this.onAdSearch=function(){// 支持高级搜索内input框的onEnter触发搜索
var onAdSearch=_this.props.onAdSearch;typeof onAdSearch==="function"&&onAdSearch();};_this.renderChild=function(children){// 给children绑定onAdSearch事件 - 支持高级搜索内input框的onEnter触发搜索
if(toString.call(_this.props.children)==="[object Array]"){return _react2.default.Children.map(children,function(child){return child&&(child.type?_react2.default.cloneElement(child,{onAdSearch:_this.onAdSearch}):child);});}else{return children&&(children.type?_react2.default.cloneElement(children,{onAdSearch:_this.onAdSearch}):children);}};_this.state={showError:false};return _this;}(0,_createClass3.default)(main,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this2=this;if("error"in nextProps&&nextProps.error){this.setState({showError:true});setTimeout(function(){_this2.setState({showError:false});},2000);// this.formItemFocus();
}}},{key:"render",value:function render(){var _this3=this;var showError=this.state.showError;var _props=this.props,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style,label=_props.label,labelCol=_props.labelCol,labelStyle=_props.labelStyle,wrapperCol=_props.wrapperCol,_props$hideLabel=_props.hideLabel,hideLabel=_props$hideLabel===undefined?false:_props$hideLabel,viewAttr=_props.viewAttr,children=_props.children,_props$colon=_props.colon,colon=_props$colon===undefined?true:_props$colon,type=_props.type,underline=_props.underline,error=_props.error,_props$tipPosition=_props.tipPosition,tipPosition=_props$tipPosition===undefined?"top":_props$tipPosition,ecId=_props.ecId,ratio1to2=_props.ratio1to2,fieldType=_props.fieldType;var itemWeapperStyle=viewAttr&&viewAttr!=1?{display:"inline-block",verticalAlign:"top"}:{display:"table"};if(ratio1to2){labelCol={span:8};wrapperCol={span:16};return _react2.default.createElement("div",{ref:function ref(_ref2){return _this3.formItem=_ref2;},className:className+" wea-form-item clearfix wea-error "+(underline?"underline":"setLineHeight")+" "+(error&&showError?"has-error":""),style:style},_react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@o4fvbk"},fieldType!==_weaTools2.default.types.DESCRIPTION&&_react2.default.createElement(_antd.Col,(0,_extends3.default)({},labelCol,{ecId:ecId+"_Col@baobp8",style:{position:"static"}}),!hideLabel&&labelCol&&_react2.default.createElement("div",{ecId:ecId+"_div@vudkhk",title:(0,_isString2.default)(label)?label:"",className:"wea-form-item-label text-elli "+(type=="card"?"card":"")+"\n                "+(colon?"colon":""),style:{width:labelCol.span/24*100+"%"}},label)),_react2.default.createElement(_antd.Col,(0,_extends3.default)({},wrapperCol,{ecId:ecId+"_Col@l9odcp"}),_react2.default.createElement("div",{className:"wea-form-item-wrapper",style:itemWeapperStyle},children,error&&showError&&_react2.default.createElement("span",{ecId:ecId+"_span@wmnu5k",ref:function ref(_ref){return _this3.errorRef=_ref;},className:"error-tip "+(tipPosition=="bottom"?"tip-bottom":""),style:this.getErrorStyle()// style={errorStyle}
},_react2.default.createElement(_antd.Icon,{type:"exclamation-circle",ecId:ecId+"_Icon@qyo1qu"}),_react2.default.createElement("span",{className:"tip-msg"},error))))));}return _react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@7fxugh",ref:function ref(_ref4){return _this3.formItem=_ref4;},className:className+" wea-form-item clearfix wea-error "+(underline?"underline":"setLineHeight")+" "+(error&&showError?"has-error":""),style:style},fieldType!==_weaTools2.default.types.DESCRIPTION&&_react2.default.createElement(_antd.Col,(0,_extends3.default)({},labelCol,{ecId:ecId+"_Col@w9t2k1",style:{position:"static"}}),!hideLabel&&labelCol&&_react2.default.createElement("div",{ecId:ecId+"_div@kc55yr",title:(0,_isString2.default)(label)?label:"",className:"wea-form-item-label text-elli "+(type=="card"?"card":"")+"\n                "+(colon?"colon":""),style:(0,_extends3.default)({width:labelCol.span/24*100+"%"},labelStyle||{})},label)),_react2.default.createElement(_antd.Col,(0,_extends3.default)({},wrapperCol,{ecId:ecId+"_Col@dungi3"}),_react2.default.createElement("div",{className:"wea-form-item-wrapper",style:itemWeapperStyle},children,error&&showError&&_react2.default.createElement("span",{ecId:ecId+"_span@em0xfi",ref:function ref(_ref3){return _this3.errorRef=_ref3;},className:"error-tip "+(tipPosition=="bottom"?"tip-bottom":""),style:this.getErrorStyle()// style={errorStyle}
},_react2.default.createElement(_antd.Icon,{type:"exclamation-circle",ecId:ecId+"_Icon@c0xnsk"}),_react2.default.createElement("span",{className:"tip-msg",dangerouslySetInnerHTML:{__html:error}})))));}}]);return main;}(_react2.default.Component);var Com=(0,_middleware2.default)(main,"WeaFormItem");exports.default=Com;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(69)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(219);
var toPrimitive = __webpack_require__(158);
var dP = Object.defineProperty;

exports.f = __webpack_require__(48) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 959));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Com;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Encry=exports.EncryBase=exports.ENCRYPTION_CODE_ICON=exports.ENCRYPTION_CODE=exports.ENCRYPTION=exports.DESENSITIZATION=undefined;var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;exports.desensitization=desensitization;exports.encryption=encryption;exports.doReplaceAll=doReplaceAll;exports.replaceByIndex=replaceByIndex;exports.getIndexFromShowArrays=getIndexFromShowArrays;exports.richfilter=richfilter;exports.matchDesensitization=matchDesensitization;exports.replaceDesensitization=replaceDesensitization;exports.replaceEncryption=replaceEncryption;var _react=__webpack_require__(1);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _callApi=__webpack_require__(17);var _message=__webpack_require__(348);var _message2=_interopRequireDefault(_message);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatMultiLang=_weaLocaleProvider2.default.formatMultiLang;var DESENSITIZATION=exports.DESENSITIZATION="desensitization__";var ENCRYPTION=exports.ENCRYPTION="encryption__";var ENCRYPTION_CODE=exports.ENCRYPTION_CODE="****";var ENCRYPTION_CODE_ICON=exports.ENCRYPTION_CODE_ICON="ENCRYPTION_CODE_ICON";function desensitization(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";return typeof value==="string"&&value.indexOf(DESENSITIZATION)!==-1;}function encryption(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";return typeof value==="string"&&value.indexOf(ENCRYPTION)!==-1;}function doReplaceAll(datas,value,replaceValue){if(datas){datas.forEach(function(data){value=value.replace(data,replaceValue);});}return value;}function replaceByIndex(newData,keys,newKeyWords,index){var result="";var datas=newData.split(keys);datas.forEach(function(data,i){if(i===index){result+=data+newKeyWords;}else if(i<datas.length-1){result+=data+keys;}else{result+=data;}});return result;}function getIndexFromShowArrays(index,showArrays){var endIndex=0;var showArray=showArrays.filter(function(v,i){return i<index&&v!=="****";});if(showArray){endIndex=showArray.length;}return index-endIndex;}function richfilter(data,keyWords,index,newKeyWord,noDesensitization,noIcon){var newData=data,newKeyWords=noDesensitization?"":newKeyWord?newKeyWord:noIcon?ENCRYPTION_CODE:ENCRYPTION_CODE+"${"+ENCRYPTION_CODE_ICON+"_"+index+"}",nodeNum=-1,charNum=-1,keys=newKeyWord?keyWords:new RegExp(keyWords,"g"),nodes=new RegExp("<.*?>","ig"),//匹配html元素
chars=new RegExp("&.*?;","ig"),//匹配转义字符
oldNodes=newData.match(nodes),//存放html元素的数组
oldChars=newData.match(chars);//存放转义字符的数组
newData=newData.replace(nodes,"{~}");//替换html标签
newData=newData.replace(chars,"{~~}");//替换转义字符
if(newKeyWord){newData=replaceByIndex(newData,keys,newKeyWords,index);}else{newData=newData.replace(keys,newKeyWords);//替换key
}newData=newData.replace(/{~}/g,function(){//恢复html标签
nodeNum++;return oldNodes[nodeNum];});newData=newData.replace(/{~~}/g,function(){//恢复html标签
charNum++;return oldChars[charNum];});return newData;}function matchDesensitization(value,bool){var exp=bool?/\*\*\*\*/:DESENSITIZATION+"__random__[A-Z0-9]{32}";var patt=bool?exp:new RegExp(exp,"g");return value.match(patt);}function replaceDesensitization(value,noIcon){var matches=matchDesensitization(value);var dataFilter=value;if(matches){matches.forEach(function(keyWords,index){dataFilter=richfilter(dataFilter,keyWords,index,"",false,noIcon);});}return dataFilter;}function replaceEncryption(value){var patt=new RegExp(ENCRYPTION+"__random__[A-Z0-9]{32}","g");var matches=value.match(patt);var dataFilter=value;if(matches){matches.forEach(function(keyWords,index){dataFilter=richfilter(dataFilter,keyWords,index,ENCRYPTION_CODE);});}return dataFilter;}var EncryBase=exports.EncryBase=(_temp=_class=function(_Component){(0,_inherits3.default)(EncryBase,_Component);function EncryBase(props){(0,_classCallCheck3.default)(this,EncryBase);var _this=(0,_possibleConstructorReturn3.default)(this,(EncryBase.__proto__||(0,_getPrototypeOf2.default)(EncryBase)).call(this,props));_this.init=function(value,decryptValue){_this.setState({decryptValue:decryptValue,realVal:replaceEncryption(replaceDesensitization(_this.transToHTML(value||""))),valIndex:0,clickIndex:0,desValue:matchDesensitization(value||""),// 存放需解密的数据
showArrays:_this.initShowArrays(value||""),// 存放加密及解密数据
canClick:true});};_this.initShowArrays=function(value){var matches=matchDesensitization(value);if(value&&matches){return new Array(matches.length).fill(ENCRYPTION_CODE);}return[];};_this.transToHTML=function(){var val=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var result=val.replace(/gt;/g,">").replace(/&lt;/g,"<").replace(/\n/g,"<br/>").replace(/\r/g,"<br/>").replace(/&nbsp;/g," ").replace(/&apos;/g,"'").replace(/&quot;/g,'"');return result;};_this.transFormHtml=function(value){var patt=new RegExp(DESENSITIZATION+"__random__[A-Z0-9]{32}","g");return value.match(patt);};_this.getEncryptDesensitizationInfo=function(params){var _this$props=_this.props,onClick=_this$props.onClick,visibleCallback=_this$props.visibleCallback,_this$props$customPar=_this$props.customParams,customParams=_this$props$customPar===undefined?{}:_this$props$customPar;var _this$state=_this.state,clickIndex=_this$state.clickIndex,realVal=_this$state.realVal,desValue=_this$state.desValue;var value=desValue[clickIndex];if(params&&params.status==="1"){var param={token:params.token,value:value};(0,_callApi.callApi)("/api/encrypt/desensitization/getEncryptDesensitizationInfo","POST",(0,_extends3.default)({},param,customParams)).then(function(data){if(data.status==="1"){_this.doChangeValue(realVal,"****",'<span class="encry-value-'+clickIndex+'">'+data.value+"</span>");if(typeof onClick==="function")onClick(data.value);}else{_message2.default.error(data.msg);}_this.setState({canClick:true});// canClick 释放禁止点击标记
if(typeof visibleCallback==="function")visibleCallback(false);});}else{_this.setState({canClick:true});// canClick 释放禁止点击标记
if(typeof visibleCallback==="function")visibleCallback(false);}};_this.doChangeValue=function(realVal,md,replaceVal){var _this$state2=_this.state,valIndex=_this$state2.valIndex,showArrays=_this$state2.showArrays,clickIndex=_this$state2.clickIndex;showArrays[clickIndex]=replaceVal;var dataFilter=richfilter(realVal,md,valIndex,replaceVal);_this.setState({realVal:dataFilter,showArrays:showArrays});};_this.changeShow=function(e,index){e&&e.stopPropagation&&e.stopPropagation();e&&e.preventDefault&&e.preventDefault();if(_this.state.encryBaseIndex!==e.target.getAttribute("attrIndex"))return;var canClick=_this.state.canClick;if(!canClick)return;_this.setState({canClick:false},function(){// 禁止点击事件，防止多次点击
var _this$state3=_this.state,realVal=_this$state3.realVal,desValue=_this$state3.desValue;var showArrays=_this.state.showArrays;var _this$props$customPar2=_this.props.customParams,customParams=_this$props$customPar2===undefined?{}:_this$props$customPar2;if(showArrays[index]===ENCRYPTION_CODE){// 解密过程
var matches=matchDesensitization(realVal,true);if(matches&&matches.length>0){var valIndex=getIndexFromShowArrays(index,showArrays);_this.setState({valIndex:valIndex,clickIndex:index},function(){if(typeof window.doCheckSecondaryVerify4ec==="function"){var visibleCallback=_this.props.visibleCallback;if(typeof visibleCallback==="function")visibleCallback(true);window.doCheckSecondaryVerify4ec((0,_extends3.default)({value:desValue[index]},customParams),_this.getEncryptDesensitizationInfo);}});}}else{// 加密过程
var exp=showArrays[index];showArrays[index]=ENCRYPTION_CODE;var realVals=realVal.split(exp);var result=realVals[0]+ENCRYPTION_CODE+realVals[1];_this.setState({realVal:result,showArrays:showArrays,canClick:true});// canClick 释放禁止点击标记
var onEncry=_this.props.onEncry;if(typeof onEncry==="function")onEncry(result);}});};_this.getShowVal=function(showVal,keyWords,index,showIndexs){var showArrays=_this.state.showArrays;var _this$props2=_this.props,noDesensitization=_this$props2.noDesensitization,_this$props2$ecId=_this$props2.ecId,ecId=_this$props2$ecId===undefined?"":_this$props2$ecId;var encryIcon=showArrays[index]&&showArrays[index]===ENCRYPTION_CODE?"<span class='icon-coms-hide' ecid='"+ecId+"@j6h774'"+"attrIndex= "+_this.state.encryBaseIndex+" onclick='javascript: window.encryChangeShow"+_this.state.encryBaseIndex+"(event,"+index+")'></span>":"<span class='icon-coms-Supervise' ecid='"+ecId+"@j6h774'"+"attrIndex= "+_this.state.encryBaseIndex+" onclick='javascript: window.encryChangeShow"+_this.state.encryBaseIndex+"(event,"+index+")'></span>";showVal=richfilter(showVal,keyWords,0,encryIcon,noDesensitization);var matches=showVal.match(/\${ENCRYPTION_CODE_ICON_[0-9]}/);index++;if(matches)showVal=_this.getShowVal(showVal,matches[0],index,showIndexs);return showVal;};_this.canClick=function(){var showArrays=_this.state.showArrays;var _this$props$controlCl=_this.props.controlClick,controlClick=_this$props$controlCl===undefined?"0":_this$props$controlCl;if(controlClick==="0")return true;else if(controlClick==="1"&&showArrays.find(function(val){return val!==ENCRYPTION_CODE;}))return true;else if(controlClick==="2"&&!showArrays.find(function(val){return val===ENCRYPTION_CODE;}))return true;return false;};_this.clearDefaultval=function(e){e&&e.stopPropagation&&e.stopPropagation();e&&e.preventDefault&&e.preventDefault();var onClick=_this.props.onClick;_this.setState({decryptValue:""},function(){if(typeof onClick==="function")onClick("");});};_this.filterLabel=function(showVal){if(desensitization(showVal)){var matches=matchDesensitization(showVal);if(matches&&matches.length>0){showVal=doReplaceAll(matches,showVal,"****");}}if(encryption(showVal)){var patt=new RegExp(ENCRYPTION+"__random__[A-Z0-9]{32}","g");var _matches=value.match(patt);if(_matches&&_matches.length>0){showVal=doReplaceAll(_matches,showVal,"****");}}return showVal;};_this.getDefaultRender=function(){var _this$state4=_this.state,realVal=_this$state4.realVal,decryptValue=_this$state4.decryptValue;var _this$props3=_this.props,value=_this$props3.value,fieldName=_this$props3.fieldName,style=_this$props3.style,className=_this$props3.className,prefixCls=_this$props3.prefixCls,resProps=(0,_objectWithoutProperties3.default)(_this$props3,["value","fieldName","style","className","prefixCls"]);var hasBorder=resProps.hasBorder,underline=resProps.underline,helpfulTip=resProps.helpfulTip,helpfulTipProps=resProps.helpfulTipProps,encryType=resProps.encryType,valueProps=resProps.valueProps;var showValue=_this.canClick();var showVal=realVal;if(!showValue)showVal=showVal.replace(/javascript:/g,"javascript: function(){};");// 禁止标签上带的方法
var matches=showVal.match(/\${ENCRYPTION_CODE_ICON_[0-9]}/);var showIndexs=[];if(matches&&matches[0]){showVal=_this.getShowVal(showVal,matches[0],0,showIndexs);}// 过滤标签中的加密数据
showVal=_this.filterLabel(showVal);if(encryType==="INPUT"){var readonly=(0,_classnames2.default)({border:hasBorder,underline:underline});return React.createElement("div",{className:"wea-field-readonly "+prefixCls+" "+readonly+" "+(_this.props.className||""),style:style},decryptValue?React.createElement("span",(0,_extends3.default)({className:"child-item wdb"},valueProps,{onClick:showValue&&valueProps&&valueProps.onClick}),React.createElement("span",{dangerouslySetInnerHTML:{__html:formatMultiLang(decryptValue)}}),React.createElement("span",{"class":"icon-coms-Supervise",ecId:_this.props.ecId+"_span@a142aa",onClick:_this.clearDefaultval})):React.createElement("span",(0,_extends3.default)({className:"child-item wdb"},valueProps,{ecId:(_this.props.ecId||"")+"_span@gbwz1t",onClick:showValue&&valueProps&&valueProps.onClick,dangerouslySetInnerHTML:{__html:formatMultiLang(showVal)}})),helpfulTip&&React.createElement(WeaHelpfulTip,(0,_extends3.default)({ecId:(_this.props.ecId||"")+"_WeaHelpfulTip@ggbsaw",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)));}return React.createElement("div",{className:prefixCls+"  "+className,style:style,id:fieldName,ecId:(_this.props.ecId||"")+"_WeaTools_Encry@g0kzbs"},decryptValue?React.createElement("span",(0,_extends3.default)({},valueProps,{onClick:showValue&&valueProps&&valueProps.onClick}),React.createElement("span",{dangerouslySetInnerHTML:{__html:formatMultiLang(decryptValue)}}),React.createElement("span",{"class":"icon-coms-Supervise",ecId:_this.props.ecId+"_span@2479aA",onClick:_this.clearDefaultval})):React.createElement("span",(0,_extends3.default)({},valueProps,{ecId:(_this.props.ecId||"")+"_span@e0vu9a",onClick:showValue&&valueProps&&valueProps.onClick,dangerouslySetInnerHTML:{__html:formatMultiLang(showVal)}})));};_this.state={showValue:false,valIndex:0,clickIndex:0,desValue:matchDesensitization(props.value||""),// 存放需解密的数据
showArrays:_this.initShowArrays(props.value||""),// 存放加密及解密数据
realVal:"",encryBaseIndex:Math.random().toString(36).substr(2,6),canClick:true,decryptValue:props.decryptValue||""};return _this;}(0,_createClass3.default)(EncryBase,[{key:"componentDidMount",value:function componentDidMount(){window["encryChangeShow"+this.state.encryBaseIndex]=this.changeShow;var decryptValue=this.props.decryptValue;this.setState({decryptValue:decryptValue,realVal:replaceEncryption(replaceDesensitization(this.transToHTML(this.props.value||"")))});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _value=this.props.value;var value=nextProps.value,decryptValue=nextProps.decryptValue;if(value!==_value){this.init(value,decryptValue);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){window["encryChangeShow"+this.state.encryBaseIndex]=null;}// 仅render使用，用于渲染展示图标
}]);return EncryBase;}(_react.Component),_class.defaultProps={className:"",prefixCls:"wea-encry-base",noDesensitization:false,customParams:{}},_temp);var Encry=exports.Encry=function(_EncryBase){(0,_inherits3.default)(Encry,_EncryBase);function Encry(){(0,_classCallCheck3.default)(this,Encry);return(0,_possibleConstructorReturn3.default)(this,(Encry.__proto__||(0,_getPrototypeOf2.default)(Encry)).apply(this,arguments));}(0,_createClass3.default)(Encry,[{key:"render",value:function render(){return this.getDefaultRender();}}]);return Encry;}(EncryBase);exports.default=EncryBase;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);__webpack_require__(498);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=main.__proto__||(0,_getPrototypeOf2.default)(main)).call.apply(_ref,[this].concat(args))),_this),_this.transferTitle=function(title){return typeof title==="string"?React.createElement("div",{dangerouslySetInnerHTML:{__html:title}}):title;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(main,[{key:"render",value:function render(){var _props=this.props,placement=_props.placement,isCenter=_props.isCenter,title=_props.title,width=_props.width,style=_props.style,ecId=_props.ecId,_props$className=_props.className,className=_props$className===undefined?"":_props$className;var centerClas=isCenter?"wea-helpful-tip-wrapper-center":"";return React.createElement("span",{ecId:ecId+"_span@umuiwi",className:"wea-helpful-tip "+className,style:style},React.createElement(_antd.Tooltip,(0,_extends3.default)({},this.props,{ecId:ecId+"_Tooltip@umuiwi",ref:"weatip",overlayClassName:"wea-helpful-tip-wrapper "+centerClas,triggerMaskClassName:"wea-helpful-tip-mask",placement:placement,arrowPointAtCenter:true,overlayStyle:{width:width||"auto"},title:this.transferTitle(title)||""}),this.props.children||React.createElement("em",{className:"icon-coms-Explain"})));}}]);return main;}(React.Component);var Com=(0,_middleware2.default)(main,"WeaHelpfulTip");exports.default=Com;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_54__;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 952));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Com;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 955));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Com;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(164);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(49);
var createDesc = __webpack_require__(90);
module.exports = __webpack_require__(48) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(208);
var defined = __webpack_require__(156);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ss=exports.ls=undefined;var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ls=exports.ls={set:function set(key,val){if((typeof val==='undefined'?'undefined':(0,_typeof3.default)(val))==='object'){try{window.localStorage[key]=(0,_stringify2.default)(val);}catch(e){window.localStorage[key]="";}}else{window.localStorage[key]=val;}},getStr:function getStr(key){return window.localStorage[key]||'';},getJSONObj:function getJSONObj(key){if(!window.localStorage[key])return null;try{return JSON.parse(window.localStorage[key]);}catch(e){return{};}}};var ss=exports.ss={set:function set(key,val){if((typeof val==='undefined'?'undefined':(0,_typeof3.default)(val))==='object'){try{window.sessionStorage[key]=(0,_stringify2.default)(val);}catch(e){window.sessionStorage[key]="";}}else{window.sessionStorage[key]=val;}},getStr:function getStr(key){return window.sessionStorage[key]||'';},getJSONObj:function getJSONObj(key){if(!window.sessionStorage[key])return null;try{return JSON.parse(window.sessionStorage[key]);}catch(e){return{};}}};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(74),
    getRawTag = __webpack_require__(407),
    objectToString = __webpack_require__(408);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(448),
    getValue = __webpack_require__(451);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(180), __webpack_require__(181));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(185);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _weaTextareaNormal=__webpack_require__(211);var _weaTextareaNormal2=_interopRequireDefault(_weaTextareaNormal);var _weaTextareaLocale=__webpack_require__(256);var _weaTextareaLocale2=_interopRequireDefault(_weaTextareaLocale);var _callApi=__webpack_require__(17);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _weaTextareaAuth=__webpack_require__(125);var _weaTextareaAuth2=_interopRequireDefault(_weaTextareaAuth);var _Encry=__webpack_require__(51);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=(_temp2=_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=main.__proto__||(0,_getPrototypeOf2.default)(main)).call.apply(_ref,[this].concat(args))),_this),_this.focus=function(){_this.form&&_this.form.focus&&_this.form.focus();_this.multilang&&_this.multilang.focus&&_this.multilang.focus();_this.refs.textareaNormal&&_this.refs.textareaNormal.focus&&_this.refs.textareaNormal.focus();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(main,[{key:"componentDidMount",value:function componentDidMount(){var isMulti=window.localStorage.getItem("activeLanguageIds");if(this.props.inputType.toUpperCase()==="MULTILANG"){if(isMulti===null){(0,_callApi.callApi)("/api/system/language/base/getActiveLanguage","GET").then(function(res){if(res.activeLanguageIds)window.localStorage.setItem("activeLanguageIds",(0,_stringify2.default)(res.activeLanguageIds));});}}}},{key:"setValue",value:function setValue(){var v=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";this.refs.textareaNormal&&this.refs.textareaNormal.setValue(v);this.multilang&&this.multilang.setValue&&this.multilang.setValue(v);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,children=_props.children,resProps=(0,_objectWithoutProperties3.default)(_props,["children"]);var inputType=resProps.inputType,ecId=resProps.ecId;var isMulti=window.localStorage.getItem("activeLanguageIds")||"[7]";try{isMulti=JSON.parse(isMulti);}catch(error){isMulti=[];console.error("获取多语言配置信息失败",error);}var value=resProps.value;if((0,_Encry.desensitization)(value)){return[_react2.default.createElement(_weaTextareaAuth2.default,(0,_extends3.default)({className:"wea-textarea-normal wea-field-readonly"},resProps,{ecId:(this.props.ecId||"")+"_WeaTextareaAuth@06v4ui"})),children];}if((0,_Encry.encryption)(value)){value=(0,_Encry.replaceEncryption)(value);}if(inputType.toUpperCase()=="FORM"){return[_react2.default.createElement("input",{ecId:ecId+"_input@zheryx",ref:function ref(_ref2){return _this2.form=_ref2;},"class":this.props.className,style:this.props.style}),children];}if(inputType.toUpperCase()==="MULTILANG"&&isMulti.length>1){return[_react2.default.createElement(_weaTextareaLocale2.default,(0,_extends3.default)({ref:function ref(_ref3){return _this2.multilang=_ref3;}},resProps,{ecId:ecId+"_WeaTextareaLocale@gu1lgm"})),children];}return[_react2.default.createElement(_weaTextareaNormal2.default,(0,_extends3.default)({ref:"textareaNormal"},resProps,{ecId:ecId+"_WeaTextareaNormal@fjf7xb"})),children];}}]);return main;}(_react2.default.Component),_class.defaultProps={inputType:"NORMAl",className:"",style:{},overlayClassName:""},_class.propTypes={inputType:_react2.default.PropTypes.string},_temp2);var Com=(0,_middleware2.default)(main,"WeaTextarea");exports.default=Com;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40),
    now = __webpack_require__(496),
    toNumber = __webpack_require__(149);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(105);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(156);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(25),
    isLength = __webpack_require__(169);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["clsx"] = clsx;
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(41);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
(function(){"use strict";var scopedWindow=function(){return this||(1,eval)("this");}();var $=scopedWindow.$;var _baron=_baron2;// Stored baron value for noConflict usage
var Item={};var pos=["left","top","right","bottom","width","height"];// Global store for all baron instances (to be able to dispose them on html-nodes)
var instances=[];var origin={v:{// Vertical
x:"Y",pos:pos[1],oppos:pos[3],crossPos:pos[0],crossOpPos:pos[2],size:pos[5],crossSize:pos[4],crossMinSize:"min-"+pos[4],crossMaxSize:"max-"+pos[4],client:"clientHeight",crossClient:"clientWidth",scrollEdge:"scrollLeft",offset:"offsetHeight",crossOffset:"offsetWidth",offsetPos:"offsetTop",scroll:"scrollTop",scrollSize:"scrollHeight"},h:{// Horizontal
x:"X",pos:pos[0],oppos:pos[2],crossPos:pos[1],crossOpPos:pos[3],size:pos[4],crossSize:pos[5],crossMinSize:"min-"+pos[5],crossMaxSize:"max-"+pos[5],client:"clientWidth",crossClient:"clientHeight",scrollEdge:"scrollTop",offset:"offsetWidth",crossOffset:"offsetHeight",offsetPos:"offsetLeft",scroll:"scrollLeft",scrollSize:"scrollWidth"}};// Some ugly vars
var opera12maxScrollbarSize=17;// I hate you https://github.com/Diokuz/baron/issues/110
var macmsxffScrollbarSize=15;var macosxffRe=/[\s\S]*Macintosh[\s\S]*\) Gecko[\s\S]*/;var isMacFF=macosxffRe.test(scopedWindow.navigator&&scopedWindow.navigator.userAgent);// removeIf(production)
var log=function log(){// baron.fn.log.apply(this, arguments);
};var liveBarons=0;var shownErrors={liveTooMany:false,allTooMany:false};// endRemoveIf(production)
// window.baron and jQuery.fn.baron points to this function
function _baron2(user){var tryNode=user&&user[0]||user;var isNode=tryNode instanceof HTMLElement;var params=isNode?{root:user}:user;var jQueryMode;var roots;var withParams=!!params;var defaultParams={$:scopedWindow.jQuery,direction:"v",barOnCls:"_scrollbar",resizeDebounce:0,event:function event(elem,_event,func,mode){params.$(elem)[mode||"on"](_event,func);},cssGuru:false,impact:"scroller",position:"static"};params=params||{};// Extending default params by user-defined params
for(var key in defaultParams){if(params[key]===undefined){params[key]=defaultParams[key];}}// removeIf(production)
if(!params.$){log("error",["no jQuery nor params.$ detected","https://github.com/Diokuz/baron/blob/master/docs/logs/no-jquery-detected.md"].join(", "),params);}if(params.position=="absolute"&&params.impact=="clipper"){log("error",["Simultaneous use of `absolute` position and `clipper` impact values detected.","Those values cannot be used together.","See more https://github.com/Diokuz/baron/issues/138"].join(" "),params);}// endRemoveIf(production)
// this - something or jQuery instance
jQueryMode=params.$&&this instanceof params.$;if(params._chain){roots=params.root;}else if(jQueryMode){params.root=roots=this;}else if(params.$){roots=params.$(params.root||params.scroller);}else{roots=[];// noop mode, like jQuery when no matched html-nodes found
}var instance=new _baron2.fn.constructor(roots,params,withParams);if(instance.autoUpdate){instance.autoUpdate();}return instance;}function arrayEach(_obj,iterator){var i=0;var obj=_obj;if(obj.length===undefined||obj===scopedWindow)obj=[obj];while(obj[i]){iterator.call(this,obj[i],i);i++;}}// shortcut for getTime
function getTime(){return new Date().getTime();}// removeIf(production)
_baron2._instances=instances;// endRemoveIf(production)
_baron2.fn={constructor:function constructor(roots,totalParams,withParams){var params=clone(totalParams);// Intrinsic params.event is not the same as totalParams.event
params.event=function(elems,e,func,mode){arrayEach(elems,function(elem){totalParams.event(elem,e,func,mode);});};this.length=0;arrayEach.call(this,roots,function(root,i){var attr=manageAttr(root,params.direction);var id=+attr;// Could be NaN
// baron() can return existing instances,
// @TODO update params on-the-fly
// https://github.com/Diokuz/baron/issues/124
if(id==id&&attr!==null&&instances[id]){// removeIf(production)
if(withParams){log("error",["repeated initialization for html-node detected","https://github.com/Diokuz/baron/blob/master/docs/logs/repeated.md"].join(", "),totalParams.root);}// endRemoveIf(production)
this[i]=instances[id];}else{var perInstanceParams=clone(params);// root and scroller can be different nodes
if(params.root&&params.scroller){perInstanceParams.scroller=params.$(params.scroller,root);if(!perInstanceParams.scroller.length){// endRemoveIf(production)
return;// removeIf(production)
}}else{perInstanceParams.scroller=root;}perInstanceParams.root=root;this[i]=init(perInstanceParams);}this.length=i+1;});this.params=params;},dispose:function dispose(){var params=this.params;arrayEach(this,function(instance,index){instance.dispose(params);instances[index]=null;});this.params=null;},update:function update(){var args=arguments;arrayEach(this,function(instance){// instance cannot be null, because it is stored by user
instance.update.apply(instance,args);});},// Restriction: only the same scroller can be used
baron:function baron(params){params.root=[];if(this.params.root){params.scroller=this.params.scroller;}arrayEach.call(this,this,function(elem){params.root.push(elem.root);});params.direction=this.params.direction=="v"?"h":"v";params._chain=true;return _baron2(params);}};function manageEvents(item,eventManager,mode){// Creating new functions for one baron item only one time
item._eventHandlers=item._eventHandlers||[{// onScroll:
element:item.scroller,handler:function handler(e){item.scroll(e);},type:"scroll"},{// css transitions & animations
element:item.root,handler:function handler(){item.update();},type:"transitionend animationend"},{// onKeyup (textarea):
element:item.scroller,handler:function handler(){item.update();},type:"keyup"},{// onMouseDown:
element:item.bar,handler:function handler(e){e.preventDefault();// Text selection disabling in Opera
item.selection();// Disable text selection in ie8
item.drag.now=1;// Save private byte
if(item.draggingCls){$(item.root).addClass(item.draggingCls);}},type:"touchstart mousedown"},{// onMouseUp:
element:document,handler:function handler(){item.selection(1);// Enable text selection
item.drag.now=0;if(item.draggingCls){$(item.root).removeClass(item.draggingCls);}},type:"mouseup blur touchend"},{// onCoordinateReset:
element:document,handler:function handler(e){if(e.button!=2){// Not RM
item._pos0(e);}},type:"touchstart mousedown"},{// onMouseMove:
element:document,handler:function handler(e){if(item.drag.now){item.drag(e);}},type:"mousemove touchmove"},{// @TODO make one global listener
// onResize:
element:scopedWindow,handler:function handler(){item.update();},type:"resize"},{// @todo remove
// sizeChange:
element:item.root,handler:function handler(){item.update();},type:"sizeChange"},{// Clipper onScroll bug https://github.com/Diokuz/baron/issues/116
element:item.clipper,handler:function handler(){item.clipperOnScroll();},type:"scroll"}];arrayEach(item._eventHandlers,function(event){if(event.element){eventManager(event.element,event.type,event.handler,mode);}});// if (item.scroller) {
//     event(item.scroller, 'scroll', item._eventHandlers.onScroll, mode)
// }
// if (item.bar) {
//     event(item.bar, 'touchstart mousedown', item._eventHandlers.onMouseDown, mode)
// }
// event(document, 'mouseup blur touchend', item._eventHandlers.onMouseUp, mode)
// event(document, 'touchstart mousedown', item._eventHandlers.onCoordinateReset, mode)
// event(document, 'mousemove touchmove', item._eventHandlers.onMouseMove, mode)
// event(window, 'resize', item._eventHandlers.onResize, mode)
// if (item.root) {
//     event(item.root, 'sizeChange', item._eventHandlers.onResize, mode)
//     // Custon event for alternate baron update mechanism
// }
}// set, remove or read baron-specific id-attribute
// @returns {String|null} - id node value, or null, if there is no attr
function manageAttr(node,direction,mode,id){var attrName="data-baron-"+direction+"-id";if(mode=="on"){node.setAttribute(attrName,id);}else if(mode=="off"){node.removeAttribute(attrName);}return node.getAttribute(attrName);}function init(params){// __proto__ of returning object is baron.prototype
var out=new Item.prototype.constructor(params);manageEvents(out,params.event,"on");manageAttr(out.root,params.direction,"on",instances.length);instances.push(out);// removeIf(production)
liveBarons++;if(liveBarons>100&&!shownErrors.liveTooMany){log("warn",["You have too many live baron instances on page ("+liveBarons+")!","Are you forget to dispose some of them?","All baron instances can be found in baron._instances:"].join(" "),instances);shownErrors.liveTooMany=true;}if(instances.length>1000&&!shownErrors.allTooMany){log("warn",["You have too many inited baron instances on page ("+instances.length+")!","Some of them are disposed, and thats good news.","but baron.init was call too many times, and thats is bad news.","All baron instances can be found in baron._instances:"].join(" "),instances);shownErrors.allTooMany=true;}// endRemoveIf(production)
out.update();return out;}function clone(_input){var output={};var input=_input||{};for(var key in input){if(input.hasOwnProperty(key)){output[key]=input[key];}}return output;}function fire(eventName){if(this.events&&this.events[eventName]){for(var i=0;i<this.events[eventName].length;i++){var args=Array.prototype.slice.call(arguments,1);this.events[eventName][i].apply(this,args);}}}Item.prototype={// underscore.js realization
// used in autoUpdate plugin
_debounce:function _debounce(func,wait){var self=this,timeout,// args, // right now there is no need for arguments
// context, // and for context
timestamp;// result // and for result
var later=function later(){if(self._disposed){clearTimeout(timeout);timeout=self=null;return;}var last=getTime()-timestamp;if(last<wait&&last>=0){timeout=setTimeout(later,wait-last);}else{timeout=null;// result = func.apply(context, args)
func();// context = args = null
}};return function(){// context = this
// args = arguments
timestamp=getTime();if(!timeout){timeout=setTimeout(later,wait);}// return result
};},constructor:function constructor(params){var _$,barPos,scrollerPos0,track,resizePauseTimer,scrollingTimer,resizeLastFire,oldBarSize;resizeLastFire=getTime();_$=this.$=params.$;this.event=params.event;this.events={};function getNode(sel,context){return _$(sel,context)[0];// Can be undefined
}// DOM elements
this.root=params.root;// Always html node, not just selector
this.scroller=getNode(params.scroller);// removeIf(production)
if(this.scroller.tagName=="body"){log("error",["Please, do not use BODY as a scroller.","https://github.com/Diokuz/baron/blob/master/docs/logs/do-not-use-body.md"].join(", "),params);}// endRemoveIf(production)
this.bar=getNode(params.bar,this.root);track=this.track=getNode(params.track,this.root);if(!this.track&&this.bar){track=this.bar.parentNode;}this.clipper=params.notParentClipper&&params.clipper||this.scroller.parentNode;// Parameters
this.direction=params.direction;this.rtl=params.rtl;this.origin=origin[this.direction];this.barOnCls=params.barOnCls;this.scrollingCls=params.scrollingCls;this.draggingCls=params.draggingCls;this.impact=params.impact;this.position=params.position;this.rtl=params.rtl;this.barTopLimit=0;this.resizeDebounce=params.resizeDebounce;// Updating height or width of bar
function setBarSize(_size){var barMinSize=this.barMinSize||20;var size=_size;if(size>0&&size<barMinSize){size=barMinSize;}if(this.bar){_$(this.bar).css(this.origin.size,parseInt(size,10)+"px");}}// Updating top or left bar position
function posBar(_pos){if(this.bar){var was=_$(this.bar).css(this.origin.pos),will=+_pos+"px";if(will&&will!=was){_$(this.bar).css(this.origin.pos,will);}}}// Free path for bar
function k(){return track[this.origin.client]-this.barTopLimit-this.bar[this.origin.offset];}// Relative content top position to bar top position
function relToPos(r){return r*k.call(this)+this.barTopLimit;}// Bar position to relative content position
function posToRel(t){return(t-this.barTopLimit)/k.call(this);}// Cursor position in main direction in px // Now with iOs support
this.cursor=function(e){return e["client"+this.origin.x]||(((e.originalEvent||e).touches||{})[0]||{})["page"+this.origin.x];};// Text selection pos preventing
function dontPosSelect(){return false;}this.pos=function(x){// Absolute scroller position in px
var ie="page"+this.origin.x+"Offset",key=this.scroller[ie]?ie:this.origin.scroll;if(x!==undefined)this.scroller[key]=x;return this.scroller[key];};this.rpos=function(r){// Relative scroller position (0..1)
var free=this.scroller[this.origin.scrollSize]-this.scroller[this.origin.client],x;if(r){x=this.pos(r*free);}else{x=this.pos();}return x/(free||1);};// Switch on the bar by adding user-defined CSS classname to scroller
this.barOn=function(dispose){if(this.barOnCls){var noScroll=this.scroller[this.origin.client]>=this.scroller[this.origin.scrollSize];if(dispose||noScroll){if(_$(this.root).hasClass(this.barOnCls)){_$(this.root).removeClass(this.barOnCls);}}else if(!_$(this.root).hasClass(this.barOnCls)){_$(this.root).addClass(this.barOnCls);}}};this._pos0=function(e){scrollerPos0=this.cursor(e)-barPos;};this.drag=function(e){var rel=posToRel.call(this,this.cursor(e)-scrollerPos0);var sub=this.scroller[this.origin.scrollSize]-this.scroller[this.origin.client];this.scroller[this.origin.scroll]=rel*sub;};// Text selection preventing on drag
this.selection=function(enable){this.event(document,"selectpos selectstart",dontPosSelect,enable?"off":"on");};// onResize & DOM modified handler
// also fires on init
// Note: max/min-size didnt sets if size did not really changed (for example, on init in Chrome)
this.resize=function(){var self=this;var minPeriod=self.resizeDebounce===undefined?300:self.resizeDebounce;var delay=0;if(getTime()-resizeLastFire<minPeriod){clearTimeout(resizePauseTimer);delay=minPeriod;}function upd(){var offset=self.scroller[self.origin.crossOffset];var client=self.scroller[self.origin.crossClient];var padding=0;var was,will;// https://github.com/Diokuz/baron/issues/110
if(isMacFF){padding=macmsxffScrollbarSize;// Opera 12 bug https://github.com/Diokuz/baron/issues/105
}else if(client>0&&offset===0){// Only Opera 12 in some rare nested flexbox cases goes here
// Sorry guys for magic,
// but I dont want to create temporary html-nodes set
// just for measuring scrollbar size in Opera 12.
// 17px for Windows XP-8.1, 15px for Mac (really rare).
offset=client+opera12maxScrollbarSize;}if(offset){// if there is no size, css should not be set
self.barOn();if(self.impact=="scroller"){// scroller
var delta=offset-client+padding;// `static` position works only for `scroller` impact
if(self.position=="static"){// static
was=self.$(self.scroller).css(self.origin.crossSize);will=self.clipper[self.origin.crossClient]+delta+"px";if(was!=will){self._setCrossSizes(self.scroller,will);}}else{// absolute
var css={};var key=self.rtl?"Left":"Right";if(self.direction=="h"){key="Bottom";}css["padding"+key]=delta+"px";self.$(self.scroller).css(css);}}else{// clipper
was=self.$(self.clipper).css(self.origin.crossSize);will=client+"px";if(was!=will){self._setCrossSizes(self.clipper,will);}}}else{// do nothing (display: none, or something)
}Array.prototype.unshift.call(arguments,"resize");fire.apply(self,arguments);resizeLastFire=getTime();}if(delay){resizePauseTimer=setTimeout(upd,delay);}else{upd();}};this.updatePositions=function(force){var newBarSize,self=this;if(self.bar){newBarSize=(track[self.origin.client]-self.barTopLimit)*self.scroller[self.origin.client]/self.scroller[self.origin.scrollSize];// Positioning bar
if(force||parseInt(oldBarSize,10)!=parseInt(newBarSize,10)){setBarSize.call(self,newBarSize);oldBarSize=newBarSize;}barPos=relToPos.call(self,self.rpos());posBar.call(self,barPos);}Array.prototype.unshift.call(arguments,"scroll");fire.apply(self,arguments);};// onScroll handler
this.scroll=function(){var self=this;self.updatePositions();if(self.scrollingCls){if(!scrollingTimer){self.$(self.root).addClass(self.scrollingCls);}clearTimeout(scrollingTimer);scrollingTimer=setTimeout(function(){self.$(self.root).removeClass(self.scrollingCls);scrollingTimer=undefined;},300);}};// https://github.com/Diokuz/baron/issues/116
this.clipperOnScroll=function(){// WTF is this line? https://github.com/Diokuz/baron/issues/134
// if (this.direction == 'h') return
// assign `initial scroll position` to `clipper.scrollLeft` (0 for ltr, ~20 for rtl)
if(!this.rtl){this.clipper[this.origin.scrollEdge]=0;}else{this.clipper[this.origin.scrollEdge]=this.clipper[this.origin.scrollSize];}};// Flexbox `align-items: stretch` (default) requires to set min-width for vertical
// and max-height for horizontal scroll. Just set them all.
// http://www.w3.org/TR/css-flexbox-1/#valdef-align-items-stretch
this._setCrossSizes=function(node,size){var css={};css[this.origin.crossSize]=size;css[this.origin.crossMinSize]=size;css[this.origin.crossMaxSize]=size;this.$(node).css(css);};// Set common css rules
this._dumbCss=function(on){if(params.cssGuru)return;var overflow=on?"hidden":null;var msOverflowStyle=on?"none":null;this.$(this.clipper).css({overflow:overflow,msOverflowStyle:msOverflowStyle,position:this.position=="static"?"":"relative"});var scroll=on?"scroll":null;var axis=this.direction=="v"?"y":"x";var scrollerCss={};scrollerCss["overflow-"+axis]=scroll;scrollerCss["box-sizing"]="border-box";scrollerCss.margin="0";scrollerCss.border="0";if(this.position=="absolute"){scrollerCss.position="absolute";scrollerCss.top="0";if(this.direction=="h"){scrollerCss.left=scrollerCss.right="0";}else{scrollerCss.bottom="0";scrollerCss.right=this.rtl?"0":"";scrollerCss.left=this.rtl?"":"0";}}this.$(this.scroller).css(scrollerCss);};// onInit actions
this._dumbCss(true);if(isMacFF){var padding="paddingRight";var css={};// getComputedStyle is ie9+, but we here only in f ff
var paddingWas=scopedWindow.getComputedStyle(this.scroller)[[padding]];if(params.direction=="h"){padding="paddingBottom";}else if(params.rtl){padding="paddingLeft";}var numWas=parseInt(paddingWas,10);if(numWas!=numWas)numWas=0;css[padding]=macmsxffScrollbarSize+numWas+"px";_$(this.scroller).css(css);}return this;},// fires on any update and on init
update:function update(params){// removeIf(production)
if(this._disposed){log("error",["Update on disposed baron instance detected.","You should clear your stored baron value for this instance:",this].join(" "),params);}// endRemoveIf(production)
fire.call(this,"upd",params);// Update all plugins' params
this.resize(1);this.updatePositions(1);return this;},// One instance
dispose:function dispose(params){// removeIf(production)
if(this._disposed){log("error","Already disposed:",this);}liveBarons--;// endRemoveIf(production)
manageEvents(this,this.event,"off");manageAttr(this.root,params.direction,"off");if(params.direction=="v"){this._setCrossSizes(this.scroller,"");}else{this._setCrossSizes(this.clipper,"");}this._dumbCss(false);this.barOn(true);fire.call(this,"dispose");this.root=null;this.scroller=null;this.bar=null;this.clipper=null;this.track=null;this._eventHandlers=null;this.barOn=null;this._dumbCss=null;this.event=null;this.events=null;this.resize=null;this._pos0=null;this.rpos=null;this.pos=null;this.drag=null;this.clipperOnScroll=null;this.scroll=null;this.selection=null;this.updatePositions=null;this._setCrossSizes=null;this.cursor=null;this.$=null;this._disposed=true;},on:function on(eventName,func,arg){var names=eventName.split(" ");for(var i=0;i<names.length;i++){if(names[i]=="init"){func.call(this,arg);}else{this.events[names[i]]=this.events[names[i]]||[];this.events[names[i]].push(function(userArg){func.call(this,userArg||arg);});}}}};_baron2.fn.constructor.prototype=_baron2.fn;Item.prototype.constructor.prototype=Item.prototype;// Use when you need "baron" global var for another purposes
_baron2.noConflict=function(){scopedWindow.baron=_baron;// Restoring original value of "baron" global var
return _baron2;};_baron2.version="2.3.1";// No AMD support, need it? Notify me.
if(true){module.exports=_baron2;// @todo webpack
__webpack_require__(509);__webpack_require__(510);__webpack_require__(511);__webpack_require__(512);}else{window.baron=_baron2;if($&&$.fn){// Adding baron to jQuery as plugin
$.fn.baron=_baron2;}}})();

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_Index */
/* unused harmony export bpfrpt_proptype_PositionInfo */
/* unused harmony export bpfrpt_proptype_ScrollPosition */
/* unused harmony export bpfrpt_proptype_SizeAndPositionInfo */
/* unused harmony export bpfrpt_proptype_SizeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_Index =  true ? null : {
  index: PropTypes.number.isRequired
};
var bpfrpt_proptype_PositionInfo =  true ? null : {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollPosition =  true ? null : {
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};







/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getNodeFromPath=exports.getRowIndexFromId=exports.addNode=exports.deleteNode=exports.updateNode=exports.deleteNodeFromTree=exports.replaceNodeFromTree=exports.getNodeRenderOptions=exports.getFlattenedTree=undefined;var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getFlattenedTree=__webpack_require__(190);Object.defineProperty(exports,"getFlattenedTree",{enumerable:true,get:function get(){return _getFlattenedTree.getFlattenedTree;}});var _reselect=__webpack_require__(295);var _lodash=__webpack_require__(666);var _lodash2=_interopRequireDefault(_lodash);var _lodash3=__webpack_require__(667);var _lodash4=_interopRequireDefault(_lodash3);var _contants=__webpack_require__(191);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getNodeRenderOptions=exports.getNodeRenderOptions=(0,_reselect.createSelector)(function(node){return(node.state||{}).expanded;},function(node){return(node.state||{}).favorite;},function(node){return(node.state||{}).deletable;},function(node){return node.children;},function(expanded,favorite,deletable){var children=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];return{hasChildren:!!children.length,isExpanded:!!expanded,isFavorite:!!favorite,isDeletable:!!deletable};});var FLATTEN_TREE_PROPERTIES=["deepness","parents"];var NODE_OPERATION_TYPES={CHANGE_NODE:"CHANGE_NODE",DELETE_NODE:"DELETE_NODE"};var NODE_CHANGE_OPERATIONS={CHANGE_NODE:function CHANGE_NODE(nodes,updatedNode){return nodes.map(function(n){return n.id===updatedNode.id?(0,_lodash2.default)((0,_extends3.default)({},updatedNode,n.children&&{children:[].concat((0,_toConsumableArray3.default)(n.children))}),FLATTEN_TREE_PROPERTIES):n;});},DELETE_NODE:function DELETE_NODE(nodes,updatedNode){return nodes.filter(function(n){return n.id!==updatedNode.id;});}};var replaceNodeFromTree=exports.replaceNodeFromTree=function replaceNodeFromTree(nodes,updatedNode){var operation=arguments.length>2&&arguments[2]!==undefined?arguments[2]:NODE_OPERATION_TYPES.CHANGE_NODE;if(!NODE_CHANGE_OPERATIONS[operation]){return nodes;}var parents=updatedNode.parents;if(!parents.length){return NODE_CHANGE_OPERATIONS[operation](nodes,updatedNode);}var parentIndex=(0,_lodash4.default)(nodes,function(n){return n.id===parents[0];});var preSiblings=nodes.slice(0,parentIndex);var postSiblings=nodes.slice(parentIndex+1);return[].concat((0,_toConsumableArray3.default)(preSiblings),[(0,_extends3.default)({},nodes[parentIndex],nodes[parentIndex].children?{children:replaceNodeFromTree(nodes[parentIndex].children,(0,_extends3.default)({},updatedNode,{parents:parents.slice(1)}),operation)}:{})],(0,_toConsumableArray3.default)(postSiblings));};var deleteNodeFromTree=exports.deleteNodeFromTree=function deleteNodeFromTree(nodes,deletedNode){return replaceNodeFromTree(nodes,deletedNode,NODE_OPERATION_TYPES.DELETE_NODE);};var updateNode=exports.updateNode=function updateNode(originalNode,newState){return{node:(0,_extends3.default)({},originalNode,{state:(0,_extends3.default)({},originalNode.state,newState)}),type:_contants.UPDATE_TYPE.UPDATE};};var deleteNode=exports.deleteNode=function deleteNode(node){return{node:node,type:_contants.UPDATE_TYPE.DELETE};};var addNode=exports.addNode=function addNode(node){return{node:node,type:_contants.UPDATE_TYPE.ADD};};var getRowIndexFromId=exports.getRowIndexFromId=function getRowIndexFromId(flattenedTree,id,mainKey){return(0,_lodash4.default)(flattenedTree,function(node){return node[mainKey]===id&&id!==undefined&&node[mainKey]!==undefined;});};/**
 * Gets a node in the original tree from a provided path.
 *
 * @param {number|string[]} path - The id path to the node
 * @param {Object[]} tree - The Original tree
 */var getNodeFromPath=exports.getNodeFromPath=function getNodeFromPath(path,tree){var node=void 0;var nextLevel=tree;if(!Array.isArray(path)){throw new Error("path is not an array");}var _loop=function _loop(i){var id=path[i];var nextNode=nextLevel.find(function(n){return n.id===id;});if(!nextNode){throw new Error("Could not find node at "+path.join(","));}if(i===path.length-1&&nextNode.id===id){node=nextNode;}else{nextLevel=nextNode.children;}};for(var i=0;i<path.length;i++){_loop(i);}if(!node){throw new Error("Could not find node at "+path.join(","));}return node;};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _weaAssociativeSearch=__webpack_require__(252);var _util=__webpack_require__(311);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 960));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});Com.getKeys=_util.getKeys;Com.WeaAssociativeSearchMult=_weaAssociativeSearch.WeaAssociativeSearchMult;Com.WeaAssociativeSearch=_weaAssociativeSearch.WeaAssociativeSearch;Com.urlOfIframeInDialogCallBack={};exports.default=Com;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(253),
    baseEach = __webpack_require__(344),
    castFunction = __webpack_require__(503),
    isArray = __webpack_require__(21);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);__webpack_require__(610);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.state={showError:false};return _this;}(0,_createClass3.default)(main,[{key:"showError",value:function showError(){var _this2=this;this.setState({showError:true});setTimeout(function(){_this2.setState({showError:false});},2000);}},{key:"render",value:function render(){var showError=this.state.showError;var _props=this.props,ecId=_props.ecId,_props$tipPosition=_props.tipPosition,tipPosition=_props$tipPosition===undefined?"top":_props$tipPosition,_props$error=_props.error,error=_props$error===undefined?"":_props$error,children=_props.children,_props$className=_props.className,className=_props$className===undefined?"":_props$className,_props$style=_props.style,style=_props$style===undefined?{}:_props$style;return React.createElement("div",{className:"wea-error inline-block "+(error&&showError?"has-error":"")+" "+className,style:style},children,error&&showError&&React.createElement("span",{className:"error-tip "+(tipPosition=="bottom"?"tip-bottom":"")},React.createElement(_antd.Icon,{type:"exclamation-circle",ecId:ecId+"_Icon@d5n365"}),React.createElement("span",{className:"tip-msg",dangerouslySetInnerHTML:{__html:error}})));}}]);return main;}(React.Component);var Com=(0,_middleware2.default)(main,"WeaError");exports.default=Com;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.loadCss=undefined;var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadCss=exports.loadCss=function loadCss(){if(self!=_window2.default.getTop()){if(window.notThrowCss!==true){var topCss=[],currentCss=[],_loadCss=[];$("link").each(function(){if($(this).attr("href")&&$(this).attr("href").indexOf("?")>-1){currentCss.push($(this).attr("href").slice(0,$(this).attr("href").indexOf("?")));}else{currentCss.push($(this).attr("href"));}});$(_window2.default.getTop().document).find("link").each(function(){if($(this).attr("href")&&$(this).attr("href").indexOf("?")>-1){topCss.push($(this).attr("href").slice(0,$(this).attr("href").indexOf("?")));}else{topCss.push($(this).attr("href"));}});currentCss.forEach(function(item){if(topCss.indexOf(item)<0){_loadCss.push(item);}});_loadCss.forEach(function(item){_window2.default.getTop().document.head.appendChild($("<link rel=\"stylesheet\" type=\"text/css\" href=\""+item+"\">")[0]);});}}};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(389)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(207)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(245),
    baseKeys = __webpack_require__(235),
    isArrayLike = __webpack_require__(71);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _callApi=__webpack_require__(17);var _forEach=__webpack_require__(81);var _forEach2=_interopRequireDefault(_forEach);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _debounce=__webpack_require__(67);var _debounce2=_interopRequireDefault(_debounce);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _random=__webpack_require__(97);var _random2=_interopRequireDefault(_random);var _OGroup=__webpack_require__(504);var _OGroup2=_interopRequireDefault(_OGroup);var _uniq=__webpack_require__(65);var _uniq2=_interopRequireDefault(_uniq);var _weaHrmlist=__webpack_require__(205);var _weaHrmlist2=_interopRequireDefault(_weaHrmlist);var _weaHelpfulTip=__webpack_require__(52);var _weaHelpfulTip2=_interopRequireDefault(_weaHelpfulTip);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Option=_antd.Select.Option;var getLabel=_weaLocaleProvider2.default.getLabel,formatMultiLang=_weaLocaleProvider2.default.formatMultiLang;var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.state={data:[],value:[],loading:false,focus:false,dropdownWidth:200,hrmlist:[],hrmlistVisible:false};_this.selectedData={};return _this;}(0,_createClass3.default)(main,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextState){this.props.isClearData!==nextProps.isClearData&&this.clear();if(this.props.defaultFocus!==nextProps.defaultFocus&&nextProps.defaultFocus){this.setState({focus:true});}}// shouldComponentUpdate(nextProps,nextState) {
//   return !isEqual(this.props.datas, nextProps.datas)
//     || !isEqual(this.props.selectedValues, nextProps.selectedValues)
//     || this.props.type !== nextProps.type
//     || this.props.style !== nextProps.style
//     || this.props.inputName !== nextProps.inputName
//     || this.props.inputId !== nextProps.inputId
//     || this.props.viewAttr !== nextProps.viewAttr
//     || this.props.defaultFocus !== nextProps.defaultFocus
//     || this.state.value !== nextState.value
//     || !isEqual(this.state.data, nextState.data)
//     || this.state.loading !== nextState.loading;
// }
},{key:"componentDidUpdate",value:function componentDidUpdate(){var dom=this.refs.searchWrapperMui;if(this.state.focus){$(dom).find(".ant-select-search--inline").css("minWidth","10px");$(dom).find("input").focus();}else{$(dom).find(".ant-select-search--inline").css("minWidth","0px");}}},{key:"componentDidMount",value:function componentDidMount(){var dropdownWidth=this.state.dropdownWidth;var w=$(this.refs.searchWrapperMui).outerWidth();if(dropdownWidth<w){this.setState({dropdownWidth:w});}}},{key:"focus",value:function focus(){this.refs.select.refs.rcSelect.onPlaceholderClick&&this.refs.select.refs.rcSelect.onPlaceholderClick();}},{key:"clear",value:function clear(){this.setState({data:[]});this.selectedData={};}},{key:"isCrm",value:function isCrm(){var type=this.props.type||1;return type===1||type===17||type==="1"||type==="17";}},{key:"getData",value:function getData(){var _this2=this;var name=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var _props=this.props,type=_props.type,oldUrl=_props.oldUrl,completeURL=_props.completeURL;var url=completeURL||"/api/public/browser/complete/"+type+"?";var method="GET";type=type||1;if(type=="17"){method="POST";}if(oldUrl){url="/api/ec/api/data/search?type="+type+"&";}if((0,_trim2.default)(name)){(0,_callApi.callApi)(url+"q="+encodeURIComponent((0,_trim2.default)(name)),method).then(function(res){var resD=(0,_isString2.default)(res.datas)&&res.datas.length>0?JSON.parse(res.datas):res.datas;if(oldUrl)resD=res;resD=resD||[];if(_this2.isCrm()){// 需要过滤已选中数据（部门，分组）
var filterDatas=[];var selectIds=[];var _props2=_this2.props,datas=_props2.datas,selectedValues=_props2.selectedValues;selectedValues&&selectedValues.forEach(function(k){var target=datas[k];if(target.type==="resource"){selectIds.push(target.id);}else{selectIds=selectIds.concat(k.split(","));}});resD.forEach(function(item){item.type="resource";item.nodeid="resource_"+item.id+"x";item.lastname=item.name;if(selectIds.indexOf(item.id)===-1){filterDatas.push(item);}});resD=filterDatas;}_this2.setState({data:resD,loading:false,activeKey:_this2.getActiveKey(resD)});});}else{this.setState({data:[],loading:false,activeKey:""});}}},{key:"getActiveKey",value:function getActiveKey(data){var _props$selectedValues=this.props.selectedValues,selectedValues=_props$selectedValues===undefined?[]:_props$selectedValues;var v="";if(data&&data.length>0){var target=data.filter(function(d){return selectedValues.indexOf(d.id)==-1;});if(!(0,_isEmpty2.default)(target))v=target[0].id;}return v;}},{key:"getItemById",value:function getItemById(id){var data=this.state.data;var datas=this.props.datas;if(datas[id])return datas[id];if(!(0,_isEmpty2.default)(data)){for(var i=0;i<data.length;i++){if(id===data[i].id)return data[i];}}}},{key:"handleChange",value:function handleChange(values){var _this3=this;this.selectedData={};values.forEach(function(v){var item=_this3.getItemById(v);if(item)_this3.selectedData[v]=item;});this.props.onChange&&this.props.onChange(values,this.selectedData);if(this.hasAll()&&values.length===0){this.props.dropAllUserGroup&&this.props.dropAllUserGroup();}this.setState({activeKey:""});}},{key:"handleBlur",value:function handleBlur(){this.setState({activeKey:""});this.setState({data:[]});this.props.onBlur&&this.props.onBlur();}},{key:"handleFocus",value:function handleFocus(){this.setState({focus:true});this.props.onFocus&&this.props.onFocus();}},{key:"handleSearch",value:function handleSearch(value){var type=this.props.type;if(this.hasAll()||type==="141"){return;}this.setState({loading:true});this.getData(value);this.props.onSearch&&this.props.onSearch(value);}},{key:"handleClick",value:function handleClick(e){e&&e.preventDefault();if(this.props.onBeforeFocusCheck){var cb=this.handleClickInner.bind(this);this.props.onBeforeFocusCheck(cb);}else{this.handleClickInner(e);}}},{key:"handleClickInner",value:function handleClickInner(e){var _props3=this.props,datas=_props3.datas,selectedValues=_props3.selectedValues;if(this.props.clickCallback){if(this.hasAll()){return;}this.props.clickCallback(selectedValues,datas);}}},{key:"getName",value:function getName(item){var _props4=this.props,inputName=_props4.inputName,hideNum=_props4.hideNum;var name=void 0;if(item){if(this.isCrm()){if(item.type==="all"){if(hideNum){return""+(item.lastname||item.name);}return(item.lastname||item.name)+"("+item.count+")";}if(item.type!=="resource"){if(hideNum){return""+(item.lastname||item.name);}return(item.lastname||item.name)+"("+(item.users||[]).length+")";}name=item.lastname||item.name;}else{if(inputName){name=item[inputName+"span"]||item[inputName];}name=name||item.name;}}return name;}},{key:"selectedClickHandler",value:function selectedClickHandler(e,data){var item=void 0;if(this.isReadOnly()){item=data;}else{item=this.props.datas[data.key];}if(this.isCrm()){if(item.type==="resource"){window.openhrm(item.id);window.pointerXY(e.nativeEvent);return;}if(item.type!=="resource"&&item.type!=="all"){var target=jQuery(e.nativeEvent.target);var parent=jQuery(this.refs.searchWrapperMui);var y=target.offset().top;var x=target.offset().left;var py=parent.offset().top;var px=parent.offset().left;var style={top:y-py+25,left:x-px};if(!(0,_isEmpty2.default)(item.users)){this.setState({hrmlist:item.users,hrmlistVisible:true,hrmlistStyle:style});}e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();}}else{var _props5=this.props,linkUrl=_props5.linkUrl,inputId=_props5.inputId;if(linkUrl){var url=""+linkUrl+(item[inputId]||item.id);window.open(url);}}}//只读
},{key:"isReadOnly",value:function isReadOnly(){var viewAttr=this.props.viewAttr;return viewAttr===1||viewAttr==="1";}// 处理所有人
},{key:"hasAll",value:function hasAll(){var datas=this.props.datas;var tag=false;(0,_forEach2.default)(datas,function(value,key){if(value.type==="all"){tag=true;}});return tag;}},{key:"addOnClick",value:function addOnClick(){this.props.addOnClick&&this.props.addOnClick();}},{key:"countCrm",value:function countCrm(){var _props6=this.props,datas=_props6.datas,selectedValues=_props6.selectedValues,_props6$selectTypes=_props6.selectTypes,selectTypes=_props6$selectTypes===undefined?[]:_props6$selectTypes,_props6$allDatas=_props6.allDatas,allDatas=_props6$allDatas===undefined?[]:_props6$allDatas;var count=0;var ids=[];selectedValues&&selectedValues.forEach(function(v,index){var dataV=datas[v];var type=selectTypes[index];if(type){var tempDataV=allDatas.find(function(k){return k.id===v&&k.type===type;});if(tempDataV)dataV=tempDataV;}var item=dataV;if(item.type==="all"){count+=item.count;}else if(item.type!=="resource"){item.users&&item.users.forEach(function(u){return ids.push(u.id);});}else{ids.push(item.id);}});count+=(0,_uniq2.default)(ids).length;return count;}},{key:"showCount",value:function showCount(){var bool=false;var _props7=this.props,datas=_props7.datas,selectedValues=_props7.selectedValues,_props7$selectTypes=_props7.selectTypes,selectTypes=_props7$selectTypes===undefined?[]:_props7$selectTypes,_props7$allDatas=_props7.allDatas,allDatas=_props7$allDatas===undefined?[]:_props7$allDatas;var resources=[];var groups=[];selectedValues&&selectedValues.forEach(function(v,index){var dataV=datas[v];var type=selectTypes[index];if(type){var tempDataV=allDatas.find(function(k){return k.id===v&&k.type===type;});if(tempDataV)dataV=tempDataV;}var item=dataV;if(item.type==="all"){}else if(item.type!=="resource"){groups.push(item);}else{resources.push(item);}});if(groups.length>1)bool=true;if(groups.length==1&&resources.length>0)bool=true;return bool;}},{key:"render",value:function render(){var _this4=this;var _props8=this.props,whiteBackground=_props8.whiteBackground,_props8$hasScroll=_props8.hasScroll,hasScroll=_props8$hasScroll===undefined?true:_props8$hasScroll,mr0=_props8.mr0,customIconTip=_props8.customIconTip,customIcon=_props8.customIcon,showTitle=_props8.showTitle,underline=_props8.underline,fieldName=_props8.fieldName,hasBorder=_props8.hasBorder,layout=_props8.layout,_props8$style=_props8.style,style=_props8$style===undefined?{}:_props8$style,datas=_props8.datas,viewAttr=_props8.viewAttr,maxBrowerHeight=_props8.maxBrowerHeight,resize=_props8.resize,linkUrl=_props8.linkUrl,isDetail=_props8.isDetail,hasAddBtn=_props8.hasAddBtn,_props8$hasAddGroup=_props8.hasAddGroup,hasAddGroup=_props8$hasAddGroup===undefined?false:_props8$hasAddGroup,hideOps=_props8.hideOps,hideSelect=_props8.hideSelect,helpfulTip=_props8.helpfulTip,helpfulTipProps=_props8.helpfulTipProps,valueWarp=_props8.valueWarp,hideNum=_props8.hideNum,className=_props8.className,_props8$noTooltip=_props8.noTooltip,noTooltip=_props8$noTooltip===undefined?false:_props8$noTooltip;var _state=this.state,hrmVisible=_state.hrmVisible,dropdownWidth=_state.dropdownWidth,activeKey=_state.activeKey;var props=this.props;var _props9=this.props,selectedValues=_props9.selectedValues,_props9$allDatas=_props9.allDatas,allDatas=_props9$allDatas===undefined?[]:_props9$allDatas,_props9$selectTypes=_props9.selectTypes,selectTypes=_props9$selectTypes===undefined?[]:_props9$selectTypes;var clsname=(0,_classnames2.default)((0,_defineProperty3.default)({required:(viewAttr===3||viewAttr==="3")&&(0,_isEmpty2.default)(selectedValues),mr15:/^field/.test(fieldName)||viewAttr=="3"&&(0,_isEmpty2.default)(selectedValues),mr0:mr0,resize:resize,"wea-associative-click":this.isCrm()||!(0,_isEmpty2.default)(linkUrl)||props.linked,custom:hasAddBtn||customIcon,"ext-btn":hasAddBtn||customIcon||!this.isReadOnly()&&hasAddGroup,border:hasBorder,white:whiteBackground,underline:underline,hideops:hideOps,"value-warp":valueWarp},""+className,className));var cStyle=(0,_extends3.default)({},style);cStyle.textDecoration="none";var HrmListContent=_react2.default.createElement(_weaHrmlist2.default,{ecId:this.props.ecId+"_WeaHrmlist@q5nffs",list:this.state.hrmlist,onVisibleChange:function onVisibleChange(v){return _this4.setState({hrmlistVisible:v});},style:this.state.hrmlistStyle,visible:this.state.hrmlistVisible,ref:"weaHrmlist"});if(this.isReadOnly()){var arr=[];selectedValues&&selectedValues.map(function(v,index){var dataV=datas[v];var type=selectTypes[index];if(type){var tempDataV=allDatas.find(function(k){return k.id===v&&k.type===type;});if(tempDataV)dataV=tempDataV;}var item=_this4.getName(dataV);if(!(0,_isString2.default)(item)){arr.push(_react2.default.createElement("a",{ecId:_this4.props.ecId+"_a@zji6un@"+index,className:"child-item wdb",onClick:function onClick(e){return _this4.selectedClickHandler(e,dataV);}},item));}else{arr.push(_react2.default.createElement("a",{ecId:_this4.props.ecId+"_a@867zdb@"+index,className:"child-item wdb",onClick:function onClick(e){return _this4.selectedClickHandler(e,dataV);},dangerouslySetInnerHTML:{__html:item}}));}});return _react2.default.createElement("span",{id:this.props.fieldName+"span",className:"wea-associative-search wea-field-readonly "+clsname+" "+(this.props.cls||""),style:style,ref:"searchWrapperMui"},arr,!hideNum&&this.isCrm()&&this.showCount()&&_react2.default.createElement("span",{style:{color:"#bfbfc0"}},"(",getLabel(385618,"共$s人").replace(/\$s/,this.countCrm()),")"),hasAddBtn&&_react2.default.createElement("div",{className:"ant-input-group-wrap extbtn"},_react2.default.createElement(_antd.Icon,{ecId:this.props.ecId+"_Icon@m52rs5",className:"add-icon",type:"plus",onClick:this.addOnClick.bind(this)})),customIcon&&_react2.default.createElement("div",{className:"ant-input-group-wrap extbtn custom"},customIconTip?_react2.default.createElement(_antd.Tooltip,{placement:"bottom",title:customIconTip,ecId:this.props.ecId+"_Tooltip@vcowxp"},_react2.default.createElement("i",{ecId:this.props.ecId+"_i@brh1ey",className:customIcon+" add-icon",onClick:this.addOnClick.bind(this)})):_react2.default.createElement("i",{ecId:this.props.ecId+"_i@sip77n",className:customIcon+" add-icon",onClick:this.addOnClick.bind(this)})),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:this.props.ecId+"_WeaHelpfulTip@0iyxg7",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)),_react2.default.createElement(_antd.Popover,{ecId:this.props.ecId+"_Popover@h1ymds",placement:"bottomLeft",title:"",trigger:"click",content:HrmListContent,visible:this.state.hrmlistVisible,onVisibleChange:function onVisibleChange(v){return _this4.setState({hrmlistVisible:v});},getTooltipContainer:function getTooltipContainer(){return _this4.refs.searchWrapperMui;},overlayClassName:"hrmlist-wrapper"},_react2.default.createElement("div",{className:"hrmlistDom"},"\xA0")));}var _data=this.state.data;var optionsError=false;var options=_data.filter(function(d){return!(selectedValues&&selectedValues.some(function(v){return v===d.id;}));}).map(function(d){return(0,_extends3.default)({},d,"showname"in d?{showname:formatMultiLang(d.showname)}:{},"name"in d?{name:formatMultiLang(d.name)}:{});}).map(function(d,index){if(!d.id){console&&console.error("\u6D4F\u89C8\u6309\u94AE\u810F\u6570\u636E "+d);optionsError=true;}var tooltip=noTooltip?"":d.title||_this4.getName(d);return _react2.default.createElement(Option,{value:d.id,key:(0,_random2.default)(1000000000),tooltip:tooltip,ecId:_this4.props.ecId+"_Option@mp16g9@"+index},_this4.getName(d));});optionsError&&(options=[]);var selectedError=false;selectedValues&&selectedValues.map(function(v,index){if(!v){console&&console.error("\u6D4F\u89C8\u6309\u94AE\u810F\u6570\u636E "+selectedValues);selectedError=true;}return options.unshift(_react2.default.createElement(Option,{ecId:_this4.props.ecId+"_Option@gcjxfu@"+index,value:v,key:(0,_random2.default)(1000000000),tooltip:_this4.getName(datas[v])},_this4.getName(datas[v])));});selectedError&&(selectedValues=[]);var select=_react2.default.createElement(_antd.Select,(0,_extends3.default)({selectedClickCB:this.selectedClickHandler.bind(this)},this.props,{ecId:this.props.ecId+"_Select@pdpyos",ref:"select",hasScroll:hasScroll,onInputBlur:function onInputBlur(){_this4.setState({focus:false});},className:valueWarp?"value-warp":"",maxHeight:maxBrowerHeight,hideSelected:true,transitionName:"",animation:"",defaultValue:selectedValues,value:selectedValues,multiple:true,placeholder:this.props.placeholder,notFoundContent:"",activeKey:activeKey,defaultActiveFirstOption:true,showArrow:false,filterOption:false,onFocus:this.handleFocus.bind(this),onChange:this.handleChange.bind(this),onSearch:!hideSelect&&(0,_debounce2.default)(this.handleSearch,400).bind(this),onBlur:this.handleBlur.bind(this),dropdownStyle:{minWidth:dropdownWidth},dropdownMenuStyle:{maxHeight:160},getPopupContainer:function getPopupContainer(){return _this4.props.getPopupContainer&&_this4.props.getPopupContainer()||layout||_window2.default.getTop().document.body;}}),options.filter(function(v){return!!v;}));// if (hideSelect) {
//   select = null;
// }
var singleTitle="";if(showTitle&&!(0,_isEmpty2.default)(selectedValues)&&!(0,_isEmpty2.default)(datas)){var escape2Html=function escape2Html(str){var arrEntities={lt:"<",gt:">",nbsp:" ",amp:"&",quot:'"'};return str.replace(/&(lt|gt|nbsp|amp|quot);/gi,function(all,t){return arrEntities[t];});};var temp=[];selectedValues.forEach(function(v){temp.push(_this4.getName(datas[v]));});singleTitle=escape2Html(temp.join(","));}var disabled=this.hasAll();var content=_react2.default.createElement(_OGroup2.default,{ecId:this.props.ecId+"_OGroup@s5zq6r",isshowoperategroup:hrmVisible,handleVisibleChange:this.handleVisibleChange.bind(this),setOperatorIds:this.crmAddcb.bind(this)});return _react2.default.createElement("div",{title:singleTitle,className:"wea-associative-search wea-associative-search-mult "+clsname,style:cStyle,ref:"searchWrapperMui"},select,_react2.default.createElement(_antd.Icon,{ecId:this.props.ecId+"_Icon@hy9uh9",type:"loading",style:{display:this.state.loading?"block":"none"}}),!hideOps&&_react2.default.createElement("div",{className:"ant-input-group-wrap"},disabled?_react2.default.createElement(_antd.Button,{type:"ghost",icon:"search",ecId:this.props.ecId+"_Button@yu6txn",disabled:true}):_react2.default.createElement(_antd.Button,{type:"ghost",icon:"search",ecId:this.props.ecId+"_Button@w0f57k",onClick:this.handleClick.bind(this)})),hasAddBtn&&_react2.default.createElement("div",{className:"ant-input-group-wrap extbtn custom"},_react2.default.createElement(_antd.Icon,{className:"add-icon",type:"plus",ecId:this.props.ecId+"_Icon@awj8nc",onClick:this.addOnClick.bind(this)})),customIcon&&_react2.default.createElement("div",{className:"ant-input-group-wrap extbtn custom"},customIconTip?_react2.default.createElement(_antd.Tooltip,{placement:"bottom",title:customIconTip,ecId:this.props.ecId+"_Tooltip@9cx7vh"},_react2.default.createElement("i",{ecId:this.props.ecId+"_i@t43hs7",className:customIcon+" add-icon",onClick:this.addOnClick.bind(this)})):_react2.default.createElement("i",{ecId:this.props.ecId+"_i@4ixsph",className:customIcon+" add-icon",onClick:this.addOnClick.bind(this)})),this.isCrm()&&hasAddGroup&&_react2.default.createElement("div",{className:"ant-input-group-wrap extbtn hasAddGroup"},_react2.default.createElement(_antd.Popover,{ecId:this.props.ecId+"_Popover@ivartz",placement:"bottomLeft",title:"",overlayClassName:"wea-hrm-group-popover",content:content,trigger:"click",visible:hrmVisible,onVisibleChange:this.handleVisibleChange.bind(this),getTooltipContainer:function getTooltipContainer(){return _this4.refs.searchWrapperMui;}},disabled?_react2.default.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@2436co",type:"primary",title:getLabel(84511,"快捷选择人员"),size:"small",disabled:true},_react2.default.createElement("i",{className:"icon-coms-HumanResources"})):_react2.default.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@6j3r6t",type:"primary",title:getLabel(84511,"快捷选择人员"),size:"small",onClick:this.hrmOnClick.bind(this)},_react2.default.createElement("i",{className:"icon-coms-HumanResources"})))),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:this.props.ecId+"_WeaHelpfulTip@ipmweg",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)),_react2.default.createElement(_antd.Popover,{ecId:this.props.ecId+"_Popover@ixi3eo",placement:"bottomLeft",title:"",trigger:"click",content:HrmListContent,visible:this.state.hrmlistVisible,onVisibleChange:function onVisibleChange(v){return _this4.setState({hrmlistVisible:v});},getTooltipContainer:function getTooltipContainer(){return _this4.refs.searchWrapperMui;},overlayClassName:"hrmlist-wrapper"},_react2.default.createElement("div",{className:"hrmlistDom"},"\xA0")));}},{key:"handleVisibleChange",value:function handleVisibleChange(visible){this.setState({hrmVisible:visible});}},{key:"hrmOnClick",value:function hrmOnClick(){this.setState({hrmVisible:true});}},{key:"crmAddcb",value:function crmAddcb(data){var datas=[];if(data.isAllUser){datas.push({type:"all",count:data.count,ids:data.ids,lastname:getLabel(1340,"所有人")});}else{datas=data.datas;}this.props.appendSearchValues&&this.props.appendSearchValues(datas,true);}}]);return main;}(_react2.default.Component);exports.default=main;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Row from '../../../_antd1.11.2/row'
// import Col from '../../../_antd1.11.2/col'
// import Icon from '../../../_antd1.11.2/icon'
var WeaSearchBrowserBox=function(_React$Component){(0,_inherits3.default)(WeaSearchBrowserBox,_React$Component);function WeaSearchBrowserBox(props){(0,_classCallCheck3.default)(this,WeaSearchBrowserBox);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaSearchBrowserBox.__proto__||(0,_getPrototypeOf2.default)(WeaSearchBrowserBox)).call(this,props));_this.state={};return _this;}(0,_createClass3.default)(WeaSearchBrowserBox,[{key:"render",value:function render(){var _props=this.props,items=_props.items,onKeyDown=_props.onKeyDown;return React.createElement("div",{className:"wea-search-group",onKeyDown:onKeyDown},React.createElement(_antd.Row,{className:"wea-content"},items.map(function(item){var style={};if(item.hide){style.display="none";}return React.createElement(_antd.Col,{className:"wea-form-cell",span:24/item.colSpan,style:style},item.com);})));}}]);return WeaSearchBrowserBox;}(React.Component);exports.default=WeaSearchBrowserBox;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(221);
var enumBugKeys = __webpack_require__(161);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(447),
    Map = __webpack_require__(168),
    Promise = __webpack_require__(452),
    Set = __webpack_require__(238),
    WeakMap = __webpack_require__(453),
    baseGetTag = __webpack_require__(62),
    toSource = __webpack_require__(237);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelAnimationTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestAnimationTimeout; });
/* unused harmony export bpfrpt_proptype_AnimationTimeoutId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animationFrame__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  id: PropTypes.number.isRequired
};


var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["a" /* caf */])(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start = void 0;
  // wait for end of processing current event handler, because event handler may be long
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout);
    }
  };

  var frame = {
    id: Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout)
  };

  return frame;
};



/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellDataGetterParams */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRowRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRendererParams */
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellDataGetterParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  cellData: PropTypes.any,
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_HeaderRendererParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  disableSort: PropTypes.bool,
  label: PropTypes.any,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string
};
var bpfrpt_proptype_RowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  onRowMouseOver: PropTypes.func,
  onRowMouseOut: PropTypes.func,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};







/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(497),
    isIterateeCall = __webpack_require__(343),
    toFinite = __webpack_require__(246);

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

module.exports = random;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;// import TimePicker from '../../_antd1.11.2/time-picker';
// import isEmpty from 'lodash/isEmpty';
var _antd=__webpack_require__(8);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _format=__webpack_require__(182);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);/**
   * formatPattern
   * 1：HH:MI:SS
   * 2：HH:MI:SS AM/PM
   * 3：HH:MI
   * 4：HH:MI AM/PM
   * 5：HH时MI分SS秒
   * 6：HH时MI分
   * 7：HH时MI分SS秒 AM/PM
   * 8：HH时MI分 AM/PM
   **/function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.onChange=function(value,valuestring){_this.setState({value:valuestring});typeof _this.props.onChange==="function"&&_this.props.onChange(valuestring);};_this.state={value:"value"in props?props.value:null};return _this;}(0,_createClass3.default)(Main,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// if('value' in nextProps) {
if("value"in nextProps&&this.state.value!==nextProps.value){this.setState({value:nextProps.value});}}},{key:"isReadOnly",value:function isReadOnly(){var viewAttr=this.props.viewAttr;return viewAttr===1||viewAttr==="1";}},{key:"render",value:function render(){var _this2=this;var _props=this.props,className=_props.className,_props$style=_props.style,style=_props$style===undefined?{}:_props$style,children=_props.children,ecId=_props.ecId,resProps=(0,_objectWithoutProperties3.default)(_props,["className","style","children","ecId"]);var viewAttr=resProps.viewAttr,fieldName=resProps.fieldName,noInput=resProps.noInput,hasBorder=resProps.hasBorder,underline=resProps.underline,useSelfLayout=resProps.useSelfLayout,formatPattern=resProps.formatPattern,layout=resProps.layout;var req=(0,_classnames2.default)((0,_defineProperty3.default)({required:viewAttr==3&&!this.state.value,noInput:noInput},""+className,className));style.textDecoration="none";if(this.isReadOnly()){var readonly=(0,_classnames2.default)({border:hasBorder,underline:underline});return React.createElement("span",{className:"wea-field-readonly "+readonly,style:style},React.createElement("span",{className:"child-item wdb"},(0,_format.formatToTime)(this.state.value,formatPattern||3)),React.createElement("input",{ecId:ecId+"_input@pt2qng",type:"hidden",id:fieldName,name:fieldName,value:(0,_format.formatToTime)(this.state.value,formatPattern)}),children);}return React.createElement("span",{className:"wea-date-picker "+req,style:style,ref:"selfLayout"},React.createElement(_antd.TimePicker,(0,_extends3.default)({},resProps,{ecId:ecId+"_TimePicker@ag9qy3",getPopupContainer:function getPopupContainer(){if(useSelfLayout){return ReactDOM.findDOMNode(_this2.refs.selfLayout);}else{return layout||_window2.default.getTop().document.body;}},value:this.state.value,onChange:this.onChange,formatPattern:formatPattern||3})),React.createElement("input",{ecId:ecId+"_input@r7hnz3",type:"hidden",id:fieldName,name:fieldName,value:this.state.value}),children);}}]);return Main;}(React.Component),_class.defaultProps={format:"HH:mm",viewAttr:2,//显示属性 1(只读)/2(可编辑)/3(必填)
formatPattern:3,noInput:false,className:""},_class.propTypes={placeholder:React.PropTypes.string,size:React.PropTypes.isRequired,onChange:React.PropTypes.func,promptRequiredMark:React.PropTypes.number},_temp);var Com=(0,_middleware2.default)(Main,"WeaTimePicker");exports.default=Com;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(421), __esModule: true };

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}__webpack_require__(505);var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.state={height:0};return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,className=_props.className,typeClass=_props.typeClass,conClass=_props.conClass,conHeightNum=_props.conHeightNum;this.createScroll(className,typeClass,conClass,conHeightNum);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var _props2=this.props,className=_props2.className,typeClass=_props2.typeClass,conClass=_props2.conClass,conHeightNum=_props2.conHeightNum;if(prevProps.conHeightNum!=conHeightNum||prevProps.conClass!=conClass)this.createScroll(className,typeClass,conClass,conHeightNum);}},{key:"render",value:function render(){var _props3=this.props,typeClass=_props3.typeClass,className=_props3.className,children=_props3.children,style=_props3.style;return React.createElement("div",{className:className+" "+typeClass,style:style},children);}},{key:"createScroll",value:function createScroll(className,typeClass,conClass,conHeightNum){var that=this;var isIE8=window.navigator.appVersion.indexOf("MSIE 8.0")>=0;if(isIE8){if(!!conClass&&!!conHeightNum){var height=jQuery("."+conClass).height()-conHeightNum;jQuery("."+className).css({maxHeight:height+2+"px",overflowY:"scroll",overflowX:"hidden"});}}else{jQuery("."+className).scrollbar({onInit:function onInit(){if(!!conClass&&!!conHeightNum){var _height=jQuery("."+conClass).height()-conHeightNum;jQuery("."+className).css({"max-height":_height+"px"});}},onScroll:function onScroll(a,b,c,d){window.weaScrollTop={};weaScrollTop[className]=a.scroll;}});}}}]);return Main;}(React.Component);var Com=(0,_middleware2.default)(Main,"WeaScroll");exports.default=Com;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(553);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaRangePicker=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 958));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaRangePicker;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(204),
    baseUniq = __webpack_require__(185);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(49).f;
var has = __webpack_require__(61);
var TAG = __webpack_require__(30)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(393);
var global = __webpack_require__(29);
var hide = __webpack_require__(58);
var Iterators = __webpack_require__(73);
var TO_STRING_TAG = __webpack_require__(30)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/**
 * 工具函数
 **/// 随机字符串
var generateUUID=exports.generateUUID=function generateUUID(){var d=new Date().getTime();return'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){var r=(d+Math.random()*16)%16|0;d=Math.floor(d/16);return(c==="x"?r:r&0x7|0x8).toString(16);});};// 通过屏幕尺寸以及图片尺寸，计算出图片能在屏幕中完整显示的缩放比例
var calcFitScale=exports.calcFitScale=function calcFitScale(nodeRef,margin){var cw=clientWidth(),ch=clientHeight();var nw=nodeRef.naturalWidth+4*margin,nh=nodeRef.naturalHeight+4*margin;var windowRatio=cw/ch,naturalRatio=nw/nh;if(nw>=cw&&nh>=ch){return windowRatio>naturalRatio?ch/nh:cw/nw;}else if(nw>=cw&&nh<=ch){return cw/nw;}else if(nw<=cw&&nh>=ch){return ch/nh;}else if(nw<=cw&&nh<=ch){return 1;}};// 事件绑定
var addListenEventOf=exports.addListenEventOf=function addListenEventOf(event,handler){window.addEventListener(event,handler,true);};var removeListenEventOf=exports.removeListenEventOf=function removeListenEventOf(event,handler){window.removeEventListener(event,handler,true);};// 屏幕尺寸
var windowWidth=exports.windowWidth=function windowWidth(){return window.innerWidth;};var clientWidth=exports.clientWidth=function clientWidth(){return document.documentElement.clientWidth;};var windowHeight=exports.windowHeight=function windowHeight(){return window.innerHeight;};var clientHeight=exports.clientHeight=function clientHeight(){return document.documentElement.clientHeight;};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(62),
    isObjectLike = __webpack_require__(45);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(454),
    isObjectLike = __webpack_require__(45);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(41),
    stubFalse = __webpack_require__(455);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(231);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(458),
    listCacheDelete = __webpack_require__(459),
    listCacheGet = __webpack_require__(460),
    listCacheHas = __webpack_require__(461),
    listCacheSet = __webpack_require__(462);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(118);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(476);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ua=exports.UserAgent=undefined;var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _class,_temp;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UserAgent=exports.UserAgent=(_temp=_class=function(){function UserAgent(userAgent){var _this=this;(0,_classCallCheck3.default)(this,UserAgent);this.navigator=typeof window.navigator!=="undefined"?window.navigator:{};this.userAgent=window.navigator.userAgent||"";this.constants={engine:["WebKit","Trident","Gecko","Presto"],browser:["Safari","Chrome","Edge","IE","Firefox","Firefox Focus","Chromium","Opera","Vivaldi","Yandex","Arora","Lunascape","QupZilla","Coc Coc","Kindle","Iceweasel","Konqueror","Iceape","SeaMonkey","Epiphany","360","360SE","360EE","UC","QQBrowser","QQ","Baidu","Maxthon","Sogou","LBBROWSER","2345Explorer","TheWorld","XiaoMi","Quark","Qiyu","Wechat","Taobao","Alipay","Weibo","Douban","Suning","iQiYi","DingTalk","EMobile"],os:["Windows","Linux","Mac OS","Android","Ubuntu","FreeBSD","Debian","iOS","Windows Phone","BlackBerry","MeeGo","Symbian","Chrome OS","WebOS"],device:["Mobile","Tablet"]};this.device="PC";this.engine="";this.browser="";this.os="";this.init=function(){(0,_keys2.default)(_this.constants).forEach(function(key){_this.constants[key].forEach(function(constant){if(_this.match()[constant]){_this[key]=constant;}});});if(_this.browser==="Edge"){_this.engine="EdgeHTML";}else if(_this.browser==="Chrome"&&parseInt(_this.version,10)>27){_this.engine="Blink";}else if(_this.browser==="Opera"&&parseInt(_this.version,10)>12){_this.engine="Blink";}else if(_this.browser==="Yandex"){_this.engine="Blink";}};this.mime=function(option,value){var mimeTypes=_this.navigator.mimeTypes;for(var mt in mimeTypes){if(mimeTypes[mt][option]===value){return true;}}return false;};this.match=function(){var u=_this.userAgent;var m={// engine
Trident:u.indexOf("Trident")>-1||u.indexOf("NET CLR")>-1,Presto:u.indexOf("Presto")>-1,WebKit:u.indexOf("AppleWebKit")>-1,Gecko:u.indexOf("Gecko/")>-1,// browser
Safari:u.indexOf("Safari")>-1,Chrome:u.indexOf("Chrome")>-1||u.indexOf("CriOS")>-1,IE:u.indexOf("MSIE")>-1||u.indexOf("Trident")>-1,Edge:u.indexOf("Edge")>-1,Firefox:u.indexOf("Firefox")>-1||u.indexOf("FxiOS")>-1,"Firefox Focus":u.indexOf("Focus")>-1,Chromium:u.indexOf("Chromium")>-1,Opera:u.indexOf("Opera")>-1||u.indexOf("OPR")>-1,Vivaldi:u.indexOf("Vivaldi")>-1,Yandex:u.indexOf("YaBrowser")>-1,Arora:u.indexOf("Arora")>-1,Lunascape:u.indexOf("Lunascape")>-1,QupZilla:u.indexOf("QupZilla")>-1,"Coc Coc":u.indexOf("coc_coc_browser")>-1,Kindle:u.indexOf("Kindle")>-1||u.indexOf("Silk/")>-1,Iceweasel:u.indexOf("Iceweasel")>-1,Konqueror:u.indexOf("Konqueror")>-1,Iceape:u.indexOf("Iceape")>-1,SeaMonkey:u.indexOf("SeaMonkey")>-1,Epiphany:u.indexOf("Epiphany")>-1,"360":u.indexOf("QihooBrowser")>-1||u.indexOf("QHBrowser")>-1,"360EE":u.indexOf("360EE")>-1,"360SE":u.indexOf("360SE")>-1,UC:u.indexOf("UC")>-1||u.indexOf(" UBrowser")>-1,QQBrowser:u.indexOf("QQBrowser")>-1,QQ:u.indexOf("QQ/")>-1,Baidu:u.indexOf("Baidu")>-1||u.indexOf("BIDUBrowser")>-1,Maxthon:u.indexOf("Maxthon")>-1,Sogou:u.indexOf("MetaSr")>-1||u.indexOf("Sogou")>-1,LBBROWSER:u.indexOf("LBBROWSER")>-1,"2345Explorer":u.indexOf("2345Explorer")>-1,TheWorld:u.indexOf("TheWorld")>-1,XiaoMi:u.indexOf("MiuiBrowser")>-1,Quark:u.indexOf("Quark")>-1,Qiyu:u.indexOf("Qiyu")>-1,Taobao:u.indexOf("AliApp(TB")>-1,Alipay:u.indexOf("AliApp(AP")>-1,Wechat:u.indexOf("MicroMessenger")>-1,DingTalk:u.indexOf("AliApp(DingTalk")>-1,EMobile:u.indexOf("E-Mobile")>-1,Weibo:u.indexOf("Weibo")>-1,Douban:u.indexOf("com.douban.frodo")>-1,Suning:u.indexOf("SNEBUY-APP")>-1,iQiYi:u.indexOf("IqiyiApp")>-1,// os
Windows:u.indexOf("Windows")>-1,Linux:u.indexOf("Linux")>-1||u.indexOf("X11")>-1,"Mac OS":u.indexOf("Macintosh")>-1,Android:u.indexOf("Android")>-1||u.indexOf("Adr")>-1,Ubuntu:u.indexOf("Ubuntu")>-1,FreeBSD:u.indexOf("FreeBSD")>-1,Debian:u.indexOf("Debian")>-1,"Windows Phone":u.indexOf("IEMobile")>-1||u.indexOf("Windows Phone")>-1,BlackBerry:u.indexOf("BlackBerry")>-1||u.indexOf("RIM")>-1,MeeGo:u.indexOf("MeeGo")>-1,Symbian:u.indexOf("Symbian")>-1,iOS:u.indexOf("like Mac OS X")>-1,"Chrome OS":u.indexOf("CrOS")>-1,WebOS:u.indexOf("hpwOS")>-1,// device
Mobile:u.indexOf("Mobi")>-1||u.indexOf("iPh")>-1||u.indexOf("480")>-1,Tablet:u.indexOf("Tablet")>-1||u.indexOf("Pad")>-1||u.indexOf("Nexus 7")>-1};var is360=false;if(window.chrome){var chromeVision=Number(u.replace(/^.*Chrome\/([\d]+).*$/,"$1"));if(chromeVision>36&&window.showModalDialog){is360=true;}else if(chromeVision>45){is360=_this.mime("type","application/vnd.chromium.remoting-viewer");}}if(m.Mobile){m.Mobile=!(u.indexOf("iPad")>-1);}else if(is360){if(_this.mime("type","application/gameplugin")){m["360SE"]=true;}else if(_this.navigator&&_this.navigator.connection&&typeof _this.navigator.connection.saveData==="undefined"){m["360SE"]=true;}else{m["360EE"]=true;}}if(m.IE||m.Edge){var navigatorTop=window.screenTop-window.screenY;switch(navigatorTop){case 71:// 无收藏栏,贴边
case 99:// 有收藏栏,贴边
case 102:// 有收藏栏,非贴边
m["360EE"]=true;break;case 75:// 无收藏栏,贴边
case 74:// 无收藏栏,非贴边
case 105:// 有收藏栏,贴边
case 104:// 有收藏栏,非贴边
m["360SE"]=true;break;default:break;}}if(m.Baidu&&m.Opera){m.Baidu=false;}return m;};if(userAgent){this.userAgent=userAgent;}this.init();}(0,_createClass3.default)(UserAgent,[{key:"language",get:function get(){var g=this.navigator.browserLanguage||this.navigator.language;var arr=g.split("-");if(arr[1]){arr[1]=arr[1].toUpperCase();}return arr.join("_");}},{key:"version",get:function get(){var u=this.userAgent;var map={Safari:function Safari(){return u.replace(/^.*Version\/([\d.]+).*$/,"$1");},Chrome:function Chrome(){return u.replace(/^.*Chrome\/([\d.]+).*$/,"$1").replace(/^.*CriOS\/([\d.]+).*$/,"$1");},IE:function IE(){return u.replace(/^.*MSIE ([\d.]+).*$/,"$1").replace(/^.*rv:([\d.]+).*$/,"$1");},Edge:function Edge(){return u.replace(/^.*Edge\/([\d.]+).*$/,"$1");},Firefox:function Firefox(){return u.replace(/^.*Firefox\/([\d.]+).*$/,"$1").replace(/^.*FxiOS\/([\d.]+).*$/,"$1");},"Firefox Focus":function FirefoxFocus(){return u.replace(/^.*Focus\/([\d.]+).*$/,"$1");},Chromium:function Chromium(){return u.replace(/^.*Chromium\/([\d.]+).*$/,"$1");},Opera:function Opera(){return u.replace(/^.*Opera\/([\d.]+).*$/,"$1").replace(/^.*OPR\/([\d.]+).*$/,"$1");},Vivaldi:function Vivaldi(){return u.replace(/^.*Vivaldi\/([\d.]+).*$/,"$1");},Yandex:function Yandex(){return u.replace(/^.*YaBrowser\/([\d.]+).*$/,"$1");},Arora:function Arora(){return u.replace(/^.*Arora\/([\d.]+).*$/,"$1");},Lunascape:function Lunascape(){return u.replace(/^.*Lunascape[/\s]([\d.]+).*$/,"$1");},QupZilla:function QupZilla(){return u.replace(/^.*QupZilla[/\s]([\d.]+).*$/,"$1");},"Coc Coc":function CocCoc(){return u.replace(/^.*coc_coc_browser\/([\d.]+).*$/,"$1");},Kindle:function Kindle(){return u.replace(/^.*Version\/([\d.]+).*$/,"$1");},Iceweasel:function Iceweasel(){return u.replace(/^.*Iceweasel\/([\d.]+).*$/,"$1");},Konqueror:function Konqueror(){return u.replace(/^.*Konqueror\/([\d.]+).*$/,"$1");},Iceape:function Iceape(){return u.replace(/^.*Iceape\/([\d.]+).*$/,"$1");},SeaMonkey:function SeaMonkey(){return u.replace(/^.*SeaMonkey\/([\d.]+).*$/,"$1");},Epiphany:function Epiphany(){return u.replace(/^.*Epiphany\/([\d.]+).*$/,"$1");},"360":function _(){return u.replace(/^.*QihooBrowser\/([\d.]+).*$/,"$1");},"360SE":function SE(){var hash={"63":"10.0","55":"9.1","45":"8.1","42":"8.0","31":"7.0","21":"6.3"};var chromeVision=u.replace(/^.*Chrome\/([\d]+).*$/,"$1");return hash[chromeVision]||"";},"360EE":function EE(){var hash={"69":"11.0","63":"9.5","55":"9.0","50":"8.7","30":"7.5"};var chromeVision=u.replace(/^.*Chrome\/([\d]+).*$/,"$1");return hash[chromeVision]||"";},Maxthon:function Maxthon(){return u.replace(/^.*Maxthon\/([\d.]+).*$/,"$1");},QQBrowser:function QQBrowser(){return u.replace(/^.*QQBrowser\/([\d.]+).*$/,"$1");},QQ:function QQ(){return u.replace(/^.*QQ\/([\d.]+).*$/,"$1");},Baidu:function Baidu(){return u.replace(/^.*BIDUBrowser[\s/]([\d.]+).*$/,"$1");},UC:function UC(){return u.replace(/^.*UC?Browser\/([\d.]+).*$/,"$1");},Sogou:function Sogou(){return u.replace(/^.*SE ([\d.X]+).*$/,"$1").replace(/^.*SogouMobileBrowser\/([\d.]+).*$/,"$1");},LBBROWSER:function LBBROWSER(){var hash={"57":"6.5","49":"6.0","46":"5.9","42":"5.3","39":"5.2","34":"5.0","29":"4.5","21":"4.0"};var chromeVision=window.navigator.userAgent.replace(/^.*Chrome\/([\d]+).*$/,"$1");return hash[chromeVision]||"";},"2345Explorer":function Explorer(){return u.replace(/^.*2345Explorer\/([\d.]+).*$/,"$1");},TheWorld:function TheWorld(){return u.replace(/^.*TheWorld ([\d.]+).*$/,"$1");},XiaoMi:function XiaoMi(){return u.replace(/^.*MiuiBrowser\/([\d.]+).*$/,"$1");},Quark:function Quark(){return u.replace(/^.*Quark\/([\d.]+).*$/,"$1");},Qiyu:function Qiyu(){return u.replace(/^.*Qiyu\/([\d.]+).*$/,"$1");},Wechat:function Wechat(){return u.replace(/^.*MicroMessenger\/([\d.]+).*$/,"$1");},DingTalk:function DingTalk(){return u.replace(/^.*AliApp\(DingTalk\/([\d.]+).*$/,"$1");},EMobile:function EMobile(){return u.replace(/^.*E-Mobile\d+\/([\d.]+).*$/,"$1");},Taobao:function Taobao(){return u.replace(/^.*AliApp\(TB\/([\d.]+).*$/,"$1");},Alipay:function Alipay(){return u.replace(/^.*AliApp\(AP\/([\d.]+).*$/,"$1");},Weibo:function Weibo(){return u.replace(/^.*weibo__([\d.]+).*$/,"$1");},Douban:function Douban(){return u.replace(/^.*com.douban.frodo\/([\d.]+).*$/,"$1");},Suning:function Suning(){return u.replace(/^.*SNEBUY-APP([\d.]+).*$/,"$1");},iQiYi:function iQiYi(){return u.replace(/^.*IqiyiVersion\/([\d.]+).*$/,"$1");}};var fn=map[this.browser];var version="";if(typeof fn==="function"){version=fn();}return version===u?"":version;}},{key:"osVersion",get:function get(){var u=this.userAgent;var map={Windows:function Windows(){var v=u.replace(/^.*Windows NT ([\d.]+);.*$/,"$1");var hash={"6.4":"10","6.3":"8.1","6.2":"8","6.1":"7","6.0":"Vista","5.2":"XP","5.1":"XP","5.0":"2000"};return hash[v]||v;},Android:function Android(){return u.replace(/^.*Android ([\d.]+);.*$/,"$1");},iOS:function iOS(){return u.replace(/^.*OS ([\d_]+) like.*$/,"$1").replace(/_/g,".");},Debian:function Debian(){return u.replace(/^.*Debian\/([\d.]+).*$/,"$1");},"Windows Phone":function WindowsPhone(){return u.replace(/^.*Windows Phone( OS)? ([\d.]+);.*$/,"$2");},"Mac OS":function MacOS(){return u.replace(/^.*Mac OS X ([\d_]+).*$/,"$1").replace(/_/g,".");},WebOS:function WebOS(){return u.replace(/^.*hpwOS\/([\d.]+);.*$/,"$1");}};var fn=map[this.os];var osVersion="";if(typeof fn==="function"){osVersion=fn();}return osVersion===u?"":osVersion;}}]);return UserAgent;}(),_class.version="1.0.0",_temp);var uaa=new UserAgent();var ua=exports.ua={device:uaa.device,engine:uaa.engine,browser:uaa.browser,os:uaa.os,osVersion:uaa.osVersion,version:uaa.version,language:uaa.language};window.ua=ua;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _weaCustomNew=__webpack_require__(150);var _weaCustomNew2=_interopRequireDefault(_weaCustomNew);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaCollet=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 954));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var CustomCollect=function(_React$Component){(0,_inherits3.default)(CustomCollect,_React$Component);function CustomCollect(props){(0,_classCallCheck3.default)(this,CustomCollect);return(0,_possibleConstructorReturn3.default)(this,(CustomCollect.__proto__||(0,_getPrototypeOf2.default)(CustomCollect)).call(this,props));}(0,_createClass3.default)(CustomCollect,[{key:"render",value:function render(){return _react2.default.createElement(_weaCustomNew2.default,(0,_extends3.default)({ecId:this.props.ecId+"_WeaCustomNew@1eendk",_uuid:"0bd92b22-90f1-4d42-91a4-695adf976bc9",type:"collectCom"},this.props),_react2.default.createElement(WeaCollet,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_WeaCollet@gjnfz8"})));}}]);return CustomCollect;}(_react2.default.Component);var Com=(0,_middleware2.default)(CustomCollect,"WeaCollet");exports.default=Com;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _Encry=__webpack_require__(51);var EncryBase=_interopRequireWildcard(_Encry);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Encry=EncryBase.Encry;var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).apply(this,arguments));}(0,_createClass3.default)(Main,[{key:"render",value:function render(){return _react2.default.createElement(Encry,(0,_extends3.default)({},this.props,{prefixCls:"wea-textarea-auth",ecId:this.props.ecId+"_Encry@95do1g"}));}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(260),
    baseAssignValue = __webpack_require__(261);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(110);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;// import WeaCollect from "../wea-collect/ro";
// import SensitiveDialog from "./SensitiveDialog";
// import SensitiveDialog from "@SensitiveDialog";
var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _startsWith=__webpack_require__(354);var _startsWith2=_interopRequireDefault(_startsWith);var _WeaCollect=__webpack_require__(123);var _WeaCollect2=_interopRequireDefault(_WeaCollect);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _callApi=__webpack_require__(17);var _storage=__webpack_require__(60);var _base=__webpack_require__(272);var _base2=_interopRequireDefault(_base);var _util=__webpack_require__(134);var _WeaShowUrl=__webpack_require__(273);var _WeaShowUrl2=_interopRequireDefault(_WeaShowUrl);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var confirm=_antd.Modal.confirm;var Item=_antd.Menu.Item;var SubMenu=_antd.Menu.SubMenu;var RightMenu=(_temp=_class=function(_React$Component){(0,_inherits3.default)(RightMenu,_React$Component);function RightMenu(props){(0,_classCallCheck3.default)(this,RightMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(RightMenu.__proto__||(0,_getPrototypeOf2.default)(RightMenu)).call(this,props));_this.onItemClick=function(o,datas){datas.forEach(function(d,i){if(d.itemGroup&&d.itemGroup.length){d.itemGroup.forEach(function(g){d.allowSelect&&g.key===o.key&&typeof g.onClick==="function"&&g.onClick(o.key,i);});}else{d.key===o.key&&typeof d.onClick==="function"&&d.onClick(o.key);}});};_this.getMenuItemTitle=function(i){if(i.title||i.content&&typeof i.content==="string"){return i.title||i.content;}if(i.content&&i.content.props){if(i.content.props.title&&typeof i.content.props.title==="string"){return i.content.props.title;}if(i.content.props.children){if(typeof i.content.props.children==="string"){return i.content.props.children;}else if(i.content.props.children.props&&i.content.props.children.props.title){return i.content.props.children.props.title;}}}};_this.getMenu=function(datas,scrollNum,isScroll){var scrollHeight=datas.length>scrollNum?scrollNum*30+10:false;if(isScroll&&scrollHeight){return _react2.default.createElement(_weaNewScroll2.default,{ecId:_this.props.ecId+"_WeaNewScroll@a99n1j",height:scrollHeight},_react2.default.createElement(_antd.Menu,{ecId:_this.props.ecId+"_Menu@ztwi9a",mode:"vertical",onClick:function onClick(o){if(o.key==="collect"){_this.setState({collectVisable:true},function(){typeof _this.props.showCollect==="function"&&_this.props.showCollect(true);});}else if(o.key==="showURL"){_this.setState({urlVisible:true},function(){typeof _this.props.showUrlDialog==="function"&&_this.props.showUrlDialog(true);});}else{var onClick=_this.props.onClick;if(o.key!=="showHelp"&&o.key!=="copy"&&o.key!=="paste"&&o.key!=="uploadSensitive"){typeof onClick==="function"&&onClick(o.key);}_this.onItemClick(o,datas);}},id:"scroll_"+scrollNum},datas.map(function(d,i){if(d.itemGroup&&d.itemGroup.length){var hasSelect=false;if(d.selectKey&&d.selectKey.length){hasSelect=true;}var cls=(0,_classnames2.default)({"wea-submenu-selected":hasSelect&&true,"wea-submenu-unselected":!hasSelect&&true,"wea-submenu-scroll":scrollHeight&&true});return _react2.default.createElement(SubMenu,{ecId:_this.props.ecId+"_SubMenu@4ilit9@"+(d.key||i),key:d.key||i,title:_react2.default.createElement("span",null,_react2.default.createElement("span",{unselectable:"on",className:"wea-right-menu-icon"},d.icon),_react2.default.createElement("span",{unselectable:"on",title:d.title||d.content},d.content)),disabled:d.disabled,className:cls,onMouseEnter:function onMouseEnter(){return _this.handleMouseEnter();}},d.itemGroup.map(function(g){var key=g.key,disabled=g.disabled,icon=g.icon,title=g.title,content=g.content,itemGroupStyle=g.itemGroupStyle;return _react2.default.createElement(Item,{ecId:_this.props.ecId+"_Item@1esgtv@"+key,style:(0,_extends3.default)({},d.itemGroupStyle,{width:_this.props.width?_this.props.width:"auto",paddingLeft:hasSelect?"20px":null}),key:key,disabled:disabled},_react2.default.createElement("li",{unselectable:"on"},d.selectKey.find(function(i){return i===key;})&&_react2.default.createElement("span",{unselectable:"on",className:"wea-right-submenu-icon"},_react2.default.createElement("i",{className:"icon-coms-complete",style:{color:"#5BB5EF"}})),_react2.default.createElement("span",{unselectable:"on",className:"wea-right-menu-icon"},icon),_react2.default.createElement("span",{unselectable:"on",title:_this.getMenuItemTitle(g)},content)));}));}return _react2.default.createElement(Item,{ecId:_this.props.ecId+"_Item@pe81of@"+d.key,key:d.key||i,disabled:d.disabled},_react2.default.createElement("li",{unselectable:"on",className:"wea-right-menu-item"},_react2.default.createElement("span",{unselectable:"on",className:"wea-right-menu-icon"},d.icon),_react2.default.createElement("span",{unselectable:"on",title:_this.getMenuItemTitle(d)},d.content)));})));}return _react2.default.createElement(_antd.Menu,{ecId:_this.props.ecId+"_Menu@22357n",mode:"vertical",onClick:function onClick(o){if(o.key==="collect"){_this.setState({collectVisable:true},function(){typeof _this.props.showCollect==="function"&&_this.props.showCollect(true);});}else if(o.key==="showURL"){_this.setState({urlVisible:true},function(){typeof _this.props.showUrlDialog==="function"&&_this.props.showUrlDialog(true);});}else{var onClick=_this.props.onClick;if(o.key!=="showHelp"&&o.key!=="copy"&&o.key!=="paste"&&o.key!=="uploadSensitive"){typeof onClick==="function"&&onClick(o.key);}_this.onItemClick(o,datas);}}},datas.map(function(d,i){if(d.itemGroup&&d.itemGroup.length){var hasSelect=false;if(d.selectKey&&d.selectKey.length){hasSelect=true;}return _react2.default.createElement(SubMenu,{ecId:_this.props.ecId+"_SubMenu@6ja3sq@"+(d.key||i),key:d.key||i,title:_react2.default.createElement("span",null,_react2.default.createElement("span",{unselectable:"on",className:"wea-right-menu-icon"},d.icon),_react2.default.createElement("span",{unselectable:"on",title:d.title||d.content},d.content)),disabled:d.disabled,className:hasSelect?"wea-submenu-selected":"wea-submenu-unselected"},d.itemGroup.map(function(g){var key=g.key,disabled=g.disabled,icon=g.icon,title=g.title,content=g.content,itemGroupStyle=g.itemGroupStyle;return _react2.default.createElement(Item,{ecId:_this.props.ecId+"_Item@tfpo65@"+key,style:(0,_extends3.default)({},d.itemGroupStyle,{width:_this.props.width?_this.props.width:"auto",paddingLeft:hasSelect?"20px":null}),key:key,disabled:disabled},_react2.default.createElement("li",{unselectable:"on"},d.selectKey.find(function(i){return i===key;})&&_react2.default.createElement("span",{unselectable:"on",className:"wea-right-submenu-icon"},_react2.default.createElement("i",{className:"icon-coms-complete",style:{color:"#5BB5EF"}})),_react2.default.createElement("span",{unselectable:"on",className:"wea-right-menu-icon"},icon),_react2.default.createElement("span",{unselectable:"on",title:title||content},content)));}));}return _react2.default.createElement(Item,{ecId:_this.props.ecId+"_Item@eu37n0",key:d.key||i,disabled:d.disabled},_react2.default.createElement("li",{unselectable:"on",className:"wea-right-menu-item"},_react2.default.createElement("span",{unselectable:"on",className:"wea-right-menu-icon"},d.icon),_react2.default.createElement("span",{unselectable:"on",title:_this.getMenuItemTitle(d)},d.content)));}));};_this.getCollect=function(){return _react2.default.createElement(_WeaCollect2.default,(0,_extends3.default)({ecId:_this.props.ecId+"_WeaCollect@stnix4"},_this.props.collectParams,{visible:_this.state.collectVisable,onClose:function onClose(){return _this.setState({collectVisable:false});}}));};_this.getUrl=function(){return _react2.default.createElement(_WeaShowUrl2.default,{ecId:_this.props.ecId+"_ShowUrl@ywxvao",urlVisible:_this.state.urlVisible,maskClose:_this.state.maskClose,onCancel:function onCancel(){return _this.setState({urlVisible:false});}});};_this.handleMouseEnter=function(){setTimeout(function(){var scrollCom=document.getElementsByClassName("wea-submenu-scroll");for(var i=0,len=scrollCom.length;i<len;i++){var _top=scrollCom[i].offsetTop;var _scrollH=scrollCom[i].parentElement.parentElement.scrollTop;scrollCom[i].lastElementChild.style.top=_top-_scrollH+"px";}},100);};_this.onSave=function(params){WeaTools.callApi("/api/sensitive/saveSensitiveWordApprove","POST",(0,_extends3.default)({},params)).then(function(res){if(res.api_status){}});};_this.changeVisible=function(visible){_this.setState({sensitiveVisible:visible});};_this.instanceIsMounted=false;_this.state={collectVisable:false,urlVisible:false,// showUrlItem: false,
maskClose:_this.props.maskClose||false,sensitiveVisible:false,sensitiveWordFeedback:0};return _this;}(0,_createClass3.default)(RightMenu,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var showReport=this.props.showReport;// callApi("/api/ec/dev/app/getUserInfo", "GET").then(res => {
//   const { isAdmin, userid } = res;
//   this.setState({ showUrlItem: res.isAdmin });
// });
if(showReport&&!("sensitiveWordFeedback"in window)){(0,_callApi.callApi)("/api/sensitive/getSensitiveWordFeedback","GET").then(function(res){if(res.status){window.sensitiveWordFeedback=res.sensitiveWordFeedback;window.localStorage.setItem("sensitiveWordFeedback",res.sensitiveWordFeedback);_this2.setState({sensitiveWordFeedback:res.sensitiveWordFeedback});}});}this.instanceIsMounted=true;}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.instanceIsMounted=false;}},{key:"render",value:function render(){var _this3=this;var _props=this.props,_datas=_props.datas,collectParams=_props.collectParams,_props$inDialog=_props.inDialog,inDialog=_props$inDialog===undefined?false:_props$inDialog,helpParams=_props.helpParams,activeElement=_props.activeElement,selectionStart=_props.selectionStart,selectionEnd=_props.selectionEnd,isRM=_props.isRM,isScroll=_props.isScroll,scrollNum=_props.scrollNum,showReport=_props.showReport,showUrlItemProps=_props.showUrlItem;var _state=this.state,sensitiveVisible=_state.sensitiveVisible,sensitiveWordFeedback=_state.sensitiveWordFeedback;// const { showUrlItem } = this.state;
var showUrlItem=_storage.ls.getJSONObj("theme-account")&&_storage.ls.getJSONObj("theme-account").userid==="1";// localStorage.setItem(showCopyAndPaste, { showCopyAndPaste: 1 })
var showHelp=_storage.ls.getJSONObj("showHelp")||{showHelp:""};// const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
// const isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
// let isIE =
//   userAgent.indexOf("compatible") > -1 &&
//   userAgent.indexOf("MSIE") > -1 &&
//   !isOpera;
var showCopyAndPaste={showCopyAndPaste:""};var isIE=false;if(!!window.ActiveXObject||"ActiveXObject"in window){isIE=true;}// const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
// reIE.test(userAgent);
// const fIEVersion = parseFloat(RegExp["$1"]);
// if (fIEVersion == 7) {
//   isIE = true;
// } else if (fIEVersion == 8) {
//   isIE = true;
// } else if (fIEVersion == 9) {
//   isIE = true;
// } else if (fIEVersion == 10) {
//   isIE = true;
// } else if (fIEVersion == 11) {
//   isIE = true;
// }
// if (isIE) {
showCopyAndPaste=_storage.ls.getJSONObj("showCopyAndPaste")||{showCopyAndPaste:""};if(!isRM){showCopyAndPaste={showCopyAndPaste:""};}// }
var other=[];if(showReport&&(window.localStorage.sensitiveWordFeedback==1||sensitiveWordFeedback==1)){other.push({key:"uploadSensitive",icon:_react2.default.createElement("i",{className:"Icon-coms03-Sensitive-words"}),content:(0,_util.getLabel)(531499,"上报敏感词"),onClick:function onClick(){if(typeof window.reportSensitiveWord==="function"){window.reportSensitiveWord();}}});}collectParams&&other.push({key:"collect",icon:_react2.default.createElement("i",{className:"icon-coms-Collection"}),content:(0,_util.getLabel)("28111","收藏")});(showHelp.showHelp==="true"||helpParams.helpDocid&&helpParams.helpDocid!=="")&&other.push({key:"showHelp",icon:_react2.default.createElement("i",{className:"icon-coms-help"}),content:(0,_util.getLabel)(275,"帮助"),onClick:function onClick(){var url=window.location.hash,tabKeys=window.tabKeys||[],urlParamsIndex=0;url=url.replace("#/","");url=url.replace("main/","");url=url.slice(0,url.indexOf("?"));// 去掉_key
if((0,_startsWith2.default)(url,"portal")){inDialog?url="portal/menu":url="portal/summary";}Array.isArray(tabKeys)&&!(0,_isEmpty2.default)(tabKeys)&&tabKeys.forEach(function(v,l){var key=v.slice(v.indexOf("_key:")+5,v.indexOf("_name:")),name=v.slice(v.indexOf("_name:")+6);if(name!==""){url+=urlParamsIndex===0?"?":"&";// url += `key${urlParamsIndex}=${key},name${urlParamsIndex}=${name}`;
url+="key"+urlParamsIndex+"="+key;urlParamsIndex++;}});// const Base64 = WeaTools.Base64;
var src="https://www.e-cology.com.cn/formmode/apps/ktree/ktreeHelpE9.jsp?pathKey="+_base2.default.encode(url);!(0,_isEmpty2.default)((0,_keys2.default)(helpParams))&&(src="/spa/document/index.jsp?id="+helpParams.helpDocid);var userLanguage=window.e9_locale?window.e9_locale.userLanguage:7;window.open(src+"&lang="+userLanguage);}});showCopyAndPaste.showCopyAndPaste==="1"&&other.push({key:"copy",icon:_react2.default.createElement("i",{className:"icon-coms-copy"}),content:(0,_util.getLabel)("77","复制")+"(Ctrl+C)",onClick:function onClick(){document.execCommand("copy");}},{key:"paste",icon:_react2.default.createElement("i",{className:"icon-coms-Paste"}),content:(0,_util.getLabel)("16180","粘贴")+"(Ctrl+V)",onClick:function onClick(){if(window.clipboardData){var text=window.clipboardData.getData("Text")||"";var dom=document.querySelector("input:focus,textarea:focus");if(dom){var start=dom.selectionStart;var end=dom.selectionEnd;var domText=dom.value;dom.value=domText.substring(0,start)+text+domText.substring(end);if(dom.className.indexOf("ant-input")!==-1||dom.className==="ant-select-search__field"||dom.parentNode.parentNode.className.indexOf("wea-input-focus")!==-1||dom.parentNode.parentNode.className.indexOf("wea-textarea-normal")!==-1){// 文本框
dom.pasteValue=domText.substring(0,start)+text+domText.substring(end);dom.click();// 手动触发文本框中input点击事件
}}}else{// 流程只读库需要读到完整组件库 尴尬 如果完整未加载完还不会提示了
var doConfirm=window.antd&&window.antd.Modal?window.antd.Modal.confirm:confirm;var modal=doConfirm({title:(0,_util.getLabel)(132010,"信息提示"),content:(0,_util.getLabel)(531950,"非IE内核浏览器无法粘贴，请使用键盘快捷键（Ctrl+V）来完成。"),okCancel:false,okText:(0,_util.getLabel)("83446","确定"),onOk:function onOk(){if(activeElement){if(_this3.pasteAuto)clearTimeout(_this3.pasteAuto);activeElement.focus();setTimeout(function(){activeElement.setSelectionRange(selectionStart,selectionEnd);},0);}},onCancel:function onCancel(){if(activeElement){if(_this3.pasteAuto)clearTimeout(_this3.pasteAuto);activeElement.focus();setTimeout(function(){activeElement.setSelectionRange(selectionStart,selectionEnd);},0);}}});_this3.pasteAuto=setTimeout(function(){if(modal){modal.destroy();if(activeElement){activeElement.focus();setTimeout(function(){activeElement.setSelectionRange(selectionStart,selectionEnd);},0);}}if(_this3.pasteAuto)clearTimeout(_this3.pasteAuto);},6000);return false;}}});(showUrlItem||showUrlItemProps)&&other.push({key:"showURL",icon:_react2.default.createElement("i",{className:"icon-coms-PageAddress"}),content:(0,_util.getLabel)("21682","显示页面地址")});var datas=_datas.concat(other);if(typeof this.props.customMenu==="function"){this.props.customMenu(datas);}this.isEmpty=datas.length===0;if(datas.length===0)return null;var list=[_react2.default.createElement("iframe",{className:"wea-right-menu-iframe"}),_react2.default.createElement("div",{className:"wea-right-menu-icon-background"}),this.getMenu(datas,scrollNum,isScroll)];collectParams&&list.push(this.getCollect());showUrlItem&&list.push(this.getUrl());return list;}}]);return RightMenu;}(_react2.default.Component),_class.displayName="RightMenu",_class.defaultProps={datas:[],collectParams:undefined,helpParams:{},scrollNum:13},_temp);exports.default=RightMenu;

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* unused harmony export bpfrpt_proptype_RowRenderer */
/* unused harmony export bpfrpt_proptype_RenderedRows */
/* unused harmony export bpfrpt_proptype_Scroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


var bpfrpt_proptype_RowRendererParams =  true ? null : {
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_RowRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired,
  startIndex: PropTypes.number.isRequired,
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};






/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FlattenedNode=exports.Node=exports.NodeState=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var NodeState=exports.NodeState={expanded:_propTypes2.default.bool,deletable:_propTypes2.default.bool,favorite:_propTypes2.default.bool};var BasicNode={id:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]).isRequired,name:_propTypes2.default.string,state:_propTypes2.default.shape(NodeState)};var Node=exports.Node=(0,_extends3.default)({},BasicNode);Node.children=_propTypes2.default.arrayOf(_propTypes2.default.shape(Node));var FlattenedNode=exports.FlattenedNode=(0,_extends3.default)({},BasicNode,{deepness:_propTypes2.default.number.isRequired,parents:_propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]))});

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _antd=__webpack_require__(8);var _weaHelpfulTip=__webpack_require__(52);var _weaHelpfulTip2=_interopRequireDefault(_weaHelpfulTip);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatMultiLang=_weaLocaleProvider2.default.formatMultiLang;var main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.state={value:props.value?props.value:"0"};return _this;}(0,_createClass3.default)(main,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextState){if("value"in nextProps){this.setState({value:nextProps.value});}}},{key:"doChange",value:function doChange(e){var value=void 0;if(this.props.display=="switch"){value=e?"1":"0";}else{value=e.target.checked?"1":"0";}this.setState({value:value});this.props.onChange&&this.props.onChange(value);}},{key:"render",value:function render(){var _classNames;var _props=this.props,viewAttr=_props.viewAttr,fieldName=_props.fieldName,display=_props.display,content=_props.content,disabled=_props.disabled,ecId=_props.ecId,helpfulTip=_props.helpfulTip,helpfulTipProps=_props.helpfulTipProps,className=_props.className;var value=this.state.value;var req=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,""+className,className),(0,_defineProperty3.default)(_classNames,"required",viewAttr=="3"&&value!=="1"&&value!=="0"),_classNames));if(display=="switch"){return _react2.default.createElement("div",{ecId:ecId+"_div@4vpzoe",className:"wea-switch "+req,style:(0,_extends3.default)({width:32,height:25},this.props.style,{position:"relative"})},_react2.default.createElement(_antd.Switch,{ecId:ecId+"_Switch@zagisu",disabled:viewAttr==1||disabled,checked:value=="1",onChange:this.doChange.bind(this)}),_react2.default.createElement("input",{type:"hidden",id:fieldName,name:fieldName,value:value}),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:ecId+"_WeaHelpfulTip@ep8j08",style:{position:"absolute",right:-31,top:0},title:helpfulTip},helpfulTipProps)),this.props.children);}return _react2.default.createElement("div",{className:"wea-checkbox "+className,style:this.props.style,ecId:ecId+"_div@mo4ny1"},_react2.default.createElement(_antd.Checkbox,{ecId:ecId+"_Checkbox@8rcnct",disabled:viewAttr==1||disabled,checked:value=="1",indeterminate:value=="2",onChange:this.doChange.bind(this),className:"content"},content?formatMultiLang(content):null),_react2.default.createElement("input",{type:"hidden",id:fieldName,name:fieldName,value:value}),viewAttr=="3"&&value!=="1"&&value!=="0"&&_react2.default.createElement("span",{className:"wea-required-e9"},_react2.default.createElement("img",{src:(window.ecologyContentPath||"")+"/images/BacoError_wev9.png",align:"middle"})),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:ecId+"_WeaHelpfulTip@g027eb",style:{position:"absolute",right:-31,top:0},title:helpfulTip},helpfulTipProps)),this.props.children);}}]);return main;}(_react2.default.Component),_class.defaultProps={display:"normal",className:""},_temp);var Com=(0,_middleware2.default)(main,"WeaCheckbox");exports.default=Com;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _format=__webpack_require__(182);__webpack_require__(682);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaDatePicker=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 968));},loading:function loading(obj){if(obj&&obj.props){var _obj$props=obj.props,fieldName=_obj$props.fieldName,value=_obj$props.value,formatPattern=_obj$props.formatPattern,_obj$props$formatWith=_obj$props.formatWithZero,formatWithZero=_obj$props$formatWith===undefined?true:_obj$props$formatWith;var inputValue=value?(0,_format.formatToDate)(value,formatPattern||2,formatWithZero):value;return _react2.default.createElement("input",{ecId:obj.props.ecId+"_input@si3r8a",type:"hidden",id:fieldName,name:fieldName,value:inputValue});}return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaDatePicker;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getCommonLocale=exports.getLabel=undefined;var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var localeKey="e9_locale";var getLabel=exports.getLabel=function getLabel(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var defaultValue=arguments[1];var type=arguments[2];var loc=window[localeKey]||{};if(type){loc=loc[type];}else{loc=loc.label;}if(!loc)return defaultValue||"";var text=loc[id];if((0,_isString2.default)(id)&&id.indexOf(",")>-1){//支持逗号分割
text=id.split(",").reduce(function(t,c,i){return""+(i==1?loc[t]:t)+loc[c];});}if((0,_isString2.default)(text)&&text.indexOf("undefined")>-1&&defaultValue){text=defaultValue;// addLabelLog(id, defaultValue)
}var str=text||defaultValue;if(!text){// addLabelLog(id, defaultValue)
}return formatStr(str);};var getCommonLocale=exports.getCommonLocale=function getCommonLocale(){return{Popconfirm:{okText:getLabel(16631,"确认"),cancelText:getLabel(201,"取消"),justOkText:getLabel(383773,"知道了"),confirmTitle:getLabel(131329,"信息确认")},Pagination:{total:getLabel("83698","共"),totalUnit:getLabel("128218","条"),operates:getLabel("30585","操作"),items_per_page:getLabel("386261","条/页"),jump_to:getLabel("386262","跳至"),page:getLabel("30642","页"),first_page:getLabel("386263","第一页"),last_page:getLabel("386264","最后一页"),prev_page:getLabel("1258","上一页"),next_page:getLabel("1259","下一页"),prev_5:getLabel("386265","向前 5 页"),next_5:getLabel("386266","向后 5 页")},DatePicker:{lang:{placeholder:getLabel("27938","请选择日期"),rangePlaceholder:[getLabel("24978","开始日期"),getLabel("24980","结束日期")],today:getLabel("15537","今天"),now:getLabel("386451","此刻"),backToToday:getLabel("386452","返回今天"),ok:getLabel("826","确定"),clear:getLabel("311","清除"),month:getLabel("33452","月"),year:getLabel("26577","年"),previousMonth:getLabel("386453","上个月 (翻页上键)"),nextMonth:getLabel("386454","下个月 (翻页下键)"),monthSelect:getLabel("386455","选择月份"),yearSelect:getLabel("386456","选择年份"),decadeSelect:getLabel("386457","选择年代"),yearFormat:getLabel("386465","yyyy'年'"),monthFormat:getLabel("386466","M'月'"),dateFormat:getLabel("386467","yyyy'年'M'月'd'日'"),previousYear:getLabel("386458","上一年 (Control键加左方向键)"),nextYear:getLabel("386459","下一年 (Control键加右方向键)"),previousDecade:getLabel("386460","上一年代"),nextDecade:getLabel("386461","下一年代"),previousCentury:getLabel("386462","上一世纪"),nextCentury:getLabel("386463","下一世纪"),format:{eras:[getLabel("383357","公元前"),getLabel("383358","公元")],months:[getLabel("1492","一月"),getLabel("1493","二月"),getLabel("1494","三月"),getLabel("1495","四月"),getLabel("1496","五月"),getLabel("1497","六月"),getLabel("1498","七月"),getLabel("1499","八月"),getLabel("1800","九月"),getLabel("1801","十月"),getLabel("1802","十一月"),getLabel("1803","十二月")],shortMonths:[getLabel("25825","1月"),getLabel("25826","2月"),getLabel("25827","3月"),getLabel("25828","4月"),getLabel("25829","5月"),getLabel("25830","6月"),getLabel("25831","7月"),getLabel("25832","8月"),getLabel("25833","9月"),getLabel("25834","10月"),getLabel("25835","11月"),getLabel("25836","12月")],weekdays:[getLabel("24626","星期天"),getLabel("392","星期一"),getLabel("393","星期二"),getLabel("394","星期三"),getLabel("395","星期四"),getLabel("396","星期五"),getLabel("397","星期六")],shortWeekdays:[getLabel("16106","周日"),getLabel("16100","周一"),getLabel("16101","周二"),getLabel("16102","周三"),getLabel("16103","周四"),getLabel("16104","周五"),getLabel("16105","周六")],veryShortWeekdays:[getLabel("385820","日"),getLabel("385821","一"),getLabel("385822","二"),getLabel("385823","三"),getLabel("385824","四"),getLabel("385825","五"),getLabel("385826","六")],ampms:[getLabel("16689","上午"),getLabel("16690","下午")],datePatterns:["yyyy'年'M'月'd'日' EEEE","yyyy'年'M'月'd'日'","yyyy-M-d","yy-M-d"],timePatterns:["ahh'时'mm'分'ss'秒' 'GMT'Z","ahh'时'mm'分'ss'秒'","H:mm:ss","ah:mm"],dateTimePattern:"{date} {time}"}},timePickerLocale:{clear:getLabel("311","清除"),placeholder:getLabel("386464","请选择时间"),format:{eras:[getLabel("383357","公元前"),getLabel("383358","公元")],months:[getLabel("1492","一月"),getLabel("1493","二月"),getLabel("1494","三月"),getLabel("1495","四月"),getLabel("1496","五月"),getLabel("1497","六月"),getLabel("1498","七月"),getLabel("1499","八月"),getLabel("1800","九月"),getLabel("1801","十月"),getLabel("1802","十一月"),getLabel("1803","十二月")],shortMonths:[getLabel("25825","1月"),getLabel("25826","2月"),getLabel("25827","3月"),getLabel("25828","4月"),getLabel("25829","5月"),getLabel("25830","6月"),getLabel("25831","7月"),getLabel("25832","8月"),getLabel("25833","9月"),getLabel("25834","10月"),getLabel("25835","11月"),getLabel("25836","12月")],weekdays:[getLabel("24626","星期天"),getLabel("392","星期一"),getLabel("393","星期二"),getLabel("394","星期三"),getLabel("395","星期四"),getLabel("396","星期五"),getLabel("397","星期六")],shortWeekdays:[getLabel("16106","周日"),getLabel("16100","周一"),getLabel("16101","周二"),getLabel("16102","周三"),getLabel("16103","周四"),getLabel("16104","周五"),getLabel("16105","周六")],veryShortWeekdays:[getLabel("385820","日"),getLabel("385821","一"),getLabel("385822","二"),getLabel("385823","三"),getLabel("385824","四"),getLabel("385825","五"),getLabel("385826","六")],ampms:[getLabel("16689","上午"),getLabel("16690","下午")],datePatterns:["yyyy'年'M'月'd'日' EEEE","yyyy'年'M'月'd'日'","yyyy-M-d","yy-M-d"],timePatterns:["ahh'时'mm'分'ss'秒' 'GMT'Z","ahh'时'mm'分'ss'秒'","H:mm:ss","ah:mm"],dateTimePattern:"{date} {time}"},calendar:{timezoneOffset:8*60,firstDayOfWeek:1,minimalDaysInFirstWeek:1}}}};};var formatStr=function formatStr(str){return str.replace(/&quot;/g,'"');};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaAvatar=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 961));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaAvatar;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(703);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaScope=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 982));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaScope;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaSelectGroup=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(4/* limit */).then(__webpack_require__.bind(null, 986));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaSelectGroup;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * $Id: base64.js,v 2.15 2014/04/05 12:58:57 dankogai Exp dankogai $
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */

(function(global) {
    'use strict';
    // existing version for noConflict()
    var _Base64 = global.Base64;
    var version = "2.2.1";
    // if node.js, we use Buffer
    var buffer;
    if (typeof module !== 'undefined' && module.exports) {
        try {
            buffer = __webpack_require__(489).Buffer;
        } catch (err) {}
    }
    // constants
    var b64chars
        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
                                + fromCharCode(0x80 | (cc & 0x3f)))
                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
                   + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                   + fromCharCode(0x80 | ( cc         & 0x3f)));
        } else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                    + fromCharCode(0x80 | ( cc         & 0x3f)));
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
        ord = ccc.charCodeAt(0) << 16
            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
        chars = [
            b64chars.charAt( ord >>> 18),
            b64chars.charAt((ord >>> 12) & 63),
            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global.btoa ? function(b) {
        return global.btoa(b);
    } : function(b) {
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = buffer ?
        buffer.from ? function (u) {
            return (u.constructor === buffer.constructor ? u : buffer.from(u))
                .toString('base64')
        }
        :  function (u) {
            return (u.constructor === buffer.constructor ? u : new  buffer(u))
                .toString('base64')
        }
        : function (u) { return btoa(utob(u)) }
    ;
    var encode = function(u, urisafe) {
        return !urisafe
            ? _encode(String(u))
            : _encode(String(u)).replace(/[+\/]/g, function(m0) {
                return m0 == '+' ? '-' : '_';
            }).replace(/=/g, '');
    };
    var encodeURI = function(u) { return encode(u, true) };
    // decoder stuff
    var re_btou = new RegExp([
        '[\xC0-\xDF][\x80-\xBF]',
        '[\xE0-\xEF][\x80-\xBF]{2}',
        '[\xF0-\xF7][\x80-\xBF]{3}'
    ].join('|'), 'g');
    var cb_btou = function(cccc) {
        switch(cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                |    ((0x3f & cccc.charCodeAt(1)) << 12)
                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
                |     (0x3f & cccc.charCodeAt(3)),
            offset = cp - 0x10000;
            return (fromCharCode((offset  >>> 10) + 0xD800)
                    + fromCharCode((offset & 0x3FF) + 0xDC00));
        case 3:
            return fromCharCode(
                ((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    |  (0x3f & cccc.charCodeAt(2))
            );
        default:
            return  fromCharCode(
                ((0x1f & cccc.charCodeAt(0)) << 6)
                    |  (0x3f & cccc.charCodeAt(1))
            );
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length,
        padlen = len % 4,
        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
        chars = [
            fromCharCode( n >>> 16),
            fromCharCode((n >>>  8) & 0xff),
            fromCharCode( n         & 0xff)
        ];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var atob = global.atob ? function(a) {
        return global.atob(a);
    } : function(a){
        return a.replace(/[\s\S]{1,4}/g, cb_decode);
    };
    var _decode = buffer ?
        buffer.from ? function(a) {
            return (a.constructor === buffer.constructor
                    ? a : buffer.from(a, 'base64')).toString();
        }
        : function(a) {
            return (a.constructor === buffer.constructor
                    ? a : new buffer(a, 'base64')).toString();
        }
        : function(a) { return btou(atob(a)) };
    var decode = function(a){
        return _decode(
            String(a).replace(/[-_]/g, function(m0) { return m0 == '-' ? '+' : '/' })
                .replace(/[^A-Za-z0-9\+\/]/g, '')
        );
    };
    var noConflict = function() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v){
            return {value:v,enumerable:false,writable:true,configurable:true};
        };
        global.Base64.extendString = function () {
            Object.defineProperty(
                String.prototype, 'fromBase64', noEnum(function () {
                    return decode(this)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64', noEnum(function (urisafe) {
                    return encode(this, urisafe)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64URI', noEnum(function () {
                    return encode(this, true)
                }));
        };
    }
    // that's it!
})(this);


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _callApi=__webpack_require__(17);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _debounce=__webpack_require__(67);var _debounce2=_interopRequireDefault(_debounce);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _random=__webpack_require__(97);var _random2=_interopRequireDefault(_random);var _weaHelpfulTip=__webpack_require__(52);var _weaHelpfulTip2=_interopRequireDefault(_weaHelpfulTip);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatMultiLang=_weaLocaleProvider2.default.formatMultiLang;var Option=_antd.Select.Option;var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.handleBlur=function(){_this.getData();_this.setState({activeKey:""});_this.props.onBlur&&_this.props.onBlur();};_this.handleFocus=function(){_this.setState({focus:true});_this.props.onFocus&&_this.props.onFocus();};_this.handleSelect=function(value){var item=_this.getItemById(value);if(!(0,_isEmpty2.default)(item)){_this.setState({value:[value],data:[item],activeKey:""});_this.updateValue(value);}};_this.handleDeselect=function(value){_this.setState({value:[],data:[],activeKey:""});_this.updateValue();};_this.handleClick=function(e){e&&e.preventDefault();if(_this.props.onBeforeFocusCheck){var cb=_this.handleClickInner.bind(_this);_this.props.onBeforeFocusCheck(cb);}else{_this.handleClickInner(e);}};_this.handleClickInner=function(e){if(_this.props.clickCallback){_this.props.clickCallback(_this.state.data);}};_this.addOnClick=function(){_this.props.addOnClick&&_this.props.addOnClick();};_this.onSelectChange=function(){};_this.onInputBlur=function(){return _this.setState({focus:false});};_this.state={data:[],value:[],loading:false,focus:false,dropdownWidth:200,activeKey:""};return _this;}// 根据ids 更新组件
(0,_createClass3.default)(main,[{key:"updateByIds",value:function updateByIds(ids,names){var type=this.props.type;if(ids&&names){this.setState({data:[{id:ids,name:names}],value:[ids]});}else{this.setState({data:[],value:[]});}}},{key:"componentDidMount",value:function componentDidMount(){var dropdownWidth=this.state.dropdownWidth;this.updateByIds(this.props.ids,this.props.names);var w=$(this.refs.searchWrapper).outerWidth();if(dropdownWidth<w){this.setState({dropdownWidth:w});}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextState){if(this.props.ids!==nextProps.ids&&nextProps.ids||this.props.names!==nextProps.names&&nextProps.names){this.updateByIds(nextProps.ids,nextProps.names);}if(this.props.defaultFocus!==nextProps.defaultFocus&&nextProps.defaultFocus){this.setState({focus:true});}this.props.isClearData!==nextProps.isClearData&&this.forceClear();}},{key:"componentDidUpdate",value:function componentDidUpdate(){var dom=this.refs.searchWrapper;if(this.state.focus){$(dom).find(".ant-select-search--inline").css("minWidth","10px");$(dom).find("input").focus();}else{$(dom).find(".ant-select-search--inline").css("minWidth","0px");}}},{key:"focus",value:function focus(){this.refs.select.refs.rcSelect.onPlaceholderClick&&this.refs.select.refs.rcSelect.onPlaceholderClick();}// shouldComponentUpdate(nextProps,nextState) {
//   return this.props.style !== nextProps.style
//     || this.props.isClearData !== nextProps.isClearData
//     || this.props.modalVisable !== nextProps.modalVisable
//     || this.props.ids !== nextProps.ids
//     || this.props.names !== nextProps.names
//     || this.props.inputId !== nextProps.inputId
//     || this.props.type !== nextProps.type
//     || this.props.viewAttr !== nextProps.viewAttr
//     || this.props.defaultFocus !== nextProps.defaultFocus
//     || this.state.loading !== nextState.loading
//     || this.state.value !== nextState.value
//     || this.state.data !== nextState.data
//     || this.state.loading !== nextState.loading;
// }
},{key:"forceClear",value:function forceClear(){this.setState({data:[],value:[]});}},{key:"getData",value:function getData(){var _this2=this;var name=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var _props=this.props,_props$type=_props.type,type=_props$type===undefined?1:_props$type,oldUrl=_props.oldUrl,completeURL=_props.completeURL;var value=this.state.value;name=(0,_trim2.default)(name);var data=[];if(value.length>0){var item=this.getItemById(value[0]);data=[item];}this.setState({searchCache:name});var url=completeURL||"/api/public/browser/complete/"+type+"?";if(oldUrl){url="/api/ec/api/data/search?type="+type+"&";}if(name){(0,_callApi.callApi)(url+"q="+encodeURIComponent(name),"GET").then(function(res){if(_this2.state.searchCache!==name)return;var resD=(0,_isString2.default)(res.datas)&&res.datas.length>0?JSON.parse(res.datas):res.datas;if(oldUrl)resD=res;resD=resD||[];if(value.length>0&&resD.some(function(d){return d.id==value[0];})){data=[];}data=data.concat(resD);_this2.setState({data:data,loading:false,activeKey:_this2.getActiveKey(data)});});}else{this.setState({data:data,loading:false,activeKey:this.getActiveKey(data)});}}},{key:"getItemById",value:function getItemById(id){var data=this.state.data;var item={};if(!(0,_isEmpty2.default)(data)){for(var i=0;i<data.length;i++){if(id===data[i].id){return data[i];}}}return item;}},{key:"updateValue",value:function updateValue(value){if(this.props.onChange){var item=this.getItemById(value);this.props.onChange(value||"",item.nameSpan||item.name,[item]);}}// 处理单选
},{key:"isCrm",// 是否是人力浏览按钮
value:function isCrm(){var type=this.props.type||1;return type===1||type===17||type==="1"||type==="17";}//只读
},{key:"isReadOnly",value:function isReadOnly(){var viewAttr=this.props.viewAttr;return viewAttr===1||viewAttr==="1";}//处理点击
},{key:"selectedClickHandler",value:function selectedClickHandler(e){var item=this.state.data[0];if(this.isCrm()){window.openhrm(item.id);window.pointerXY(e.nativeEvent);}else{var _props2=this.props,linkUrl=_props2.linkUrl,inputId=_props2.inputId,onLinkClick=_props2.onLinkClick;if((0,_isFunction2.default)(onLinkClick)){onLinkClick(e,item);}else if(linkUrl){var url=""+linkUrl+(item[inputId]||item.id);window.open(url);}}}// 处理单选
},{key:"handleSearch",value:function handleSearch(value){this.setState({loading:true});this.getData(value);this.props.onSearch&&this.props.onSearch(value);}},{key:"getActiveKey",value:function getActiveKey(data){var v="";var value=this.state.value;if(data&&data.length>0){v=data[0].id;if(!(0,_isEmpty2.default)(value)){var target=data.filter(function(d){return d.id!==value[0];});if(!(0,_isEmpty2.default)(target))v=target[0].id;}}return v;}},{key:"readOnlyCallback",value:function readOnlyCallback(data,e){this.props.readOnlyCallback&&this.props.readOnlyCallback(data);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,value=_state.value,_data=_state.data,dropdownWidth=_state.dropdownWidth,activeKey=_state.activeKey;var _props3=this.props,whiteBackground=_props3.whiteBackground,customIconTip=_props3.customIconTip,mr0=_props3.mr0,customIcon=_props3.customIcon,underline=_props3.underline,_props3$showTitle=_props3.showTitle,showTitle=_props3$showTitle===undefined?false:_props3$showTitle,fieldName=_props3.fieldName,hasBorder=_props3.hasBorder,viewAttr=_props3.viewAttr,_props3$style=_props3.style,style=_props3$style===undefined?{}:_props3$style,tempTitle=_props3.tempTitle,cls=_props3.cls,resize=_props3.resize,isCity=_props3.isCity,linkUrl=_props3.linkUrl,hasAddBtn=_props3.hasAddBtn,hideSelect=_props3.hideSelect,modalVisable=_props3.modalVisable,_props3$hasScroll=_props3.hasScroll,hasScroll=_props3$hasScroll===undefined?true:_props3$hasScroll,layout=_props3.layout,hideOps=_props3.hideOps,helpfulTip=_props3.helpfulTip,helpfulTipProps=_props3.helpfulTipProps,className=_props3.className,_props3$noTooltip=_props3.noTooltip,noTooltip=_props3$noTooltip===undefined?false:_props3$noTooltip;var clss=cls||"";var cStyle=(0,_extends3.default)({},style);cStyle.textDecoration="none";var props=this.props;var clsname=(0,_classnames2.default)((0,_defineProperty3.default)({required:viewAttr=="3"&&(0,_isEmpty2.default)(value),mr15:/^field/.test(fieldName)||viewAttr=="3"&&(0,_isEmpty2.default)(value),mr0:mr0,resize:resize,"wea-associative-click":this.isCrm()||!(0,_isEmpty2.default)(linkUrl)||props.linked,custom:hasAddBtn||customIcon,"ext-btn":hasAddBtn||customIcon,border:hasBorder,white:whiteBackground,underline:underline,hideops:hideOps},""+className,className));var data=_data.map(function(d){return(0,_extends3.default)({},d,{name:formatMultiLang(d.name)});});if(this.isReadOnly()){return _react2.default.createElement("span",{id:this.props.fieldName+"span",className:"wea-associative-search wea-field-readonly "+clsname+" "+clss,style:cStyle,ref:"searchWrapper"},!(0,_isEmpty2.default)(value)&&!(0,_isEmpty2.default)(data)&&(0,_isString2.default)(data[0].name)&&!this.props.readOnlyCallback&&_react2.default.createElement("a",{ecId:this.props.ecId+"_a@3502gw",className:"child-item wdb",onClick:function onClick(e){return _this3.selectedClickHandler(e);},title:data[0].name,dangerouslySetInnerHTML:{__html:data[0].name}}),!(0,_isEmpty2.default)(value)&&!(0,_isEmpty2.default)(data)&&(0,_isString2.default)(data[0].name)&&this.props.readOnlyCallback&&_react2.default.createElement("a",{ecId:this.props.ecId+"_a@w34ul7",className:"child-item wdb",title:data[0].name,onClick:this.readOnlyCallback.bind(this,data),dangerouslySetInnerHTML:{__html:data[0].name}}),!(0,_isEmpty2.default)(value)&&!(0,_isEmpty2.default)(data)&&!(0,_isString2.default)(data[0].name)&&!this.props.readOnlyCallback&&_react2.default.createElement("a",{ecId:this.props.ecId+"_a@l7s8e1",className:"child-item wdb",onClick:function onClick(e){return _this3.selectedClickHandler(e);}},data[0].name),!(0,_isEmpty2.default)(value)&&!(0,_isEmpty2.default)(data)&&!(0,_isString2.default)(data[0].name)&&this.props.readOnlyCallback&&_react2.default.createElement("a",{ecId:this.props.ecId+"_a@airybp",className:"child-item wdb",onClick:this.readOnlyCallback.bind(this,data)},data[0].name),hasAddBtn&&_react2.default.createElement("div",{className:"ant-input-group-wrap custom extbtn"},_react2.default.createElement(_antd.Icon,{ecId:this.props.ecId+"_Icon@clqb0y",className:"add-icon",type:"plus",onClick:this.addOnClick})),customIcon&&_react2.default.createElement("div",{className:"ant-input-group-wrap extbtn custom"},customIconTip?_react2.default.createElement(_antd.Tooltip,{ecId:this.props.ecId+"_Tooltip@yqbabz",placement:"bottom",title:customIconTip},_react2.default.createElement("i",{ecId:this.props.ecId+"_i@4huogv",className:customIcon+" add-icon",onClick:this.addOnClick})):_react2.default.createElement("i",{ecId:this.props.ecId+"_i@xesqup",className:customIcon+" add-icon",onClick:this.addOnClick})),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:this.props.ecId+"_WeaHelpfulTip@s5nvuc",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)));}var optionsError=false;var options=data.map(function(d,index){if(!d.id){console&&console.error("\u6D4F\u89C8\u6309\u94AE\u810F\u6570\u636E "+d);optionsError=true;}var tooltip=noTooltip?"":d.title||d.nameSpan||d.name;return _react2.default.createElement(Option,{ecId:_this3.props.ecId+"_Option@b176v2@"+index,value:d.id,key:(0,_random2.default)(1000000000),tooltip:tooltip},d.nameSpan||d.name);}).filter(function(v){return!!v;});optionsError&&(options=[]);var select=_react2.default.createElement(_antd.Select,(0,_extends3.default)({selectedClickCB:this.selectedClickHandler.bind(this)},this.props,{ecId:this.props.ecId+"_Select@fuymb1",onChange:this.onSelectChange// 覆盖onChange
,ref:"select",fieldName:fieldName,hasScroll:hasScroll,onInputBlur:this.onInputBlur,title:tempTitle,hideSelected:true,transitionName:"",animation:"",value:value,multiple:true,placeholder:this.props.placeholder,notFoundContent:"",activeKey:activeKey,defaultActiveFirstOption:true,showArrow:false,filterOption:false,onSelect:this.handleSelect,onBlur:this.handleBlur,onFocus:this.handleFocus,onDeselect:this.handleDeselect,onSearch:!hideSelect&&(0,_debounce2.default)(this.handleSearch,400).bind(this),selectedClose:true,dropdownStyle:{minWidth:dropdownWidth},dropdownMenuStyle:{maxHeight:160},getPopupContainer:function getPopupContainer(){return _this3.props.getPopupContainer&&_this3.props.getPopupContainer()||layout||_window2.default.getTop().document.body;}}),options);// if (hideSelect) {
//   select = null;
// }
var singleTitle="";if(showTitle&&!(0,_isEmpty2.default)(value)&&!(0,_isEmpty2.default)(data)&&(0,_isString2.default)(data[0].name)){var escape2Html=function escape2Html(str){var arrEntities={lt:"<",gt:">",nbsp:" ",amp:"&",quot:'"'};return str.replace(/&(lt|gt|nbsp|amp|quot);/gi,function(all,t){return arrEntities[t];});};singleTitle=escape2Html(data[0].name);}return _react2.default.createElement("div",{title:singleTitle,className:"wea-associative-search wea-associative-single "+clss+" "+clsname,style:cStyle,ref:"searchWrapper"},select,_react2.default.createElement(_antd.Icon,{ecId:this.props.ecId+"_Icon@w7js81",type:"loading",style:{display:this.state.loading?"block":"none"}}),!hideOps&&_react2.default.createElement("div",{className:"ant-input-group-wrap"},!isCity?_react2.default.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@m497rl",type:"ghost",icon:"search",onClick:this.handleClick}):_react2.default.createElement(_antd.Button,{ecId:this.props.ecId+"_rvln5u",type:"ghost",style:{paddingTop:"4px"},size:"small",onClick:this.handleClick},_react2.default.createElement("span",null,modalVisable?_react2.default.createElement("i",{className:"icon-coms-up"}):_react2.default.createElement("i",{className:"icon-coms-down"})))),hasAddBtn&&_react2.default.createElement("div",{className:"ant-input-group-wrap extbtn"},_react2.default.createElement(_antd.Icon,{ecId:this.props.ecId+"_Icon@p0x4ym",className:"add-icon",type:"plus",onClick:this.addOnClick})),customIcon&&_react2.default.createElement("div",{className:"ant-input-group-wrap extbtn custom"},customIconTip?_react2.default.createElement(_antd.Tooltip,{ecId:this.props.ecId+"_Tooltip@va0arq",placement:"bottom",title:customIconTip},_react2.default.createElement("i",{ecId:this.props.ecId+"_i@ronvrr",className:customIcon+" add-icon",onClick:this.addOnClick})):_react2.default.createElement("i",{ecId:this.props.ecId+"_i@ql5alr",className:customIcon+" add-icon",onClick:this.addOnClick})),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:this.props.ecId+"_WeaHelpfulTip@5bl6cs",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)));}}]);return main;}(_react2.default.Component);exports.default=main;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _isRegExp=__webpack_require__(347);var _isRegExp2=_interopRequireDefault(_isRegExp);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _weaHelpfulTip=__webpack_require__(52);var _weaHelpfulTip2=_interopRequireDefault(_weaHelpfulTip);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel,formatMultiLang=_weaLocaleProvider2.default.formatMultiLang;var pClasses=["isWeak","isWeak","isWeak","isWeak","isMiddle","isMiddle","isMiddle","isStrong","isStrong","isStrong","isStrong"];var tipsCon={getTips:function getTips(){return[getLabel(27310,"弱"),getLabel(27310,"弱"),getLabel(27310,"弱"),getLabel(27310,"弱"),getLabel(22987,"中"),getLabel(22987,"中"),getLabel(22987,"中"),getLabel(27309,"强"),getLabel(27309,"强"),getLabel(27309,"强"),getLabel(27309,"强")];}};// const tips = ['弱','弱','弱','弱','中','中','中','强','强','强','强']
function getPasswordStrength(v){var n=0;if(v.match(/\d/))n+=10;if(v.length>5)n+=20;if(v.match(/[a-z]+/))n+=20;if(v.match(/[A-Z]+/))n+=20;if(v.match(/[^\da-zA-Z]/))n+=30;return n;}function getPasswordStrengthCT(v){var isTip=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(v){var t=getPasswordStrength(v)/10;var tips=tipsCon.getTips();if(isTip)return tips[t];return pClasses[t];}}var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_initialiseProps.call(_this);_this.state={value:props.defaultValue||props.value};_this.needFocus=false;return _this;}(0,_createClass3.default)(Main,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps&&this.state.value!==nextProps.value){this.setState({value:nextProps.value});}if(this.props.defaultValue!==nextProps.defaultValue){this.setState({value:nextProps.defaultValue});}}},{key:"getValue",value:function getValue(){return(0,_trim2.default)(this.state.value);}},{key:"setValue",value:function setValue(){var v=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var value=this.state.value;var dom=this.refs.input.refs.input;dom.focus();value=dom.value.substr(0,dom.selectionStart)+v+dom.value.substring(dom.selectionStart,dom.value.length);this.setState({value:value},function(){return dom.focus();});(0,_isFunction2.default)(this.props.onChange)&&this.props.onChange(value);}},{key:"render",value:function render(){var value=this.state.value;var _props=this.props,className=_props.className,style=_props.style,viewAttr=_props.viewAttr,resProps=(0,_objectWithoutProperties3.default)(_props,["className","style","viewAttr"]);var fieldname=resProps.fieldname,hasBorder=resProps.hasBorder,underline=resProps.underline,tip=resProps.tip,passwordStrength=resProps.passwordStrength,textDecoration=resProps.textDecoration,helpfulTip=resProps.helpfulTip,helpfulTipProps=resProps.helpfulTipProps;// let theProps = cloneDeep(this.props);
// delete theProps.style;
// theProps.value = value;
var eles=void 0;var req=(0,_classnames2.default)({required:(viewAttr===3||viewAttr==="3")&&(0,_trim2.default)(value).length===0});var readonly=(0,_classnames2.default)({border:hasBorder,underline:underline});if(viewAttr=="1"){return _react2.default.createElement("div",{className:"wea-field-readonly "+readonly+" "+(this.props.className||""),style:style},_react2.default.createElement("span",{className:"child-item wdb",dangerouslySetInnerHTML:{__html:formatMultiLang(value)}}),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:this.props.ecId+"-WeaHelpfulTip0lapq6",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)));}else{eles=_react2.default.createElement(_antd.Input,(0,_extends3.default)({},resProps,{ecId:this.props.ecId+"_Input@y16ozl",autocomplete:"off",ref:"input",className:""+(textDecoration?"text-decoration":""),value:value,onChange:this.setText,onClick:this.onClick,onBlur:this.onBlur,onFocus:this.onFocus,onKeyDown:this.onKeyDown}));}return _react2.default.createElement("div",{className:"wea-input-normal "+req+" "+(this.props.className||""),style:style,ref:"inputNormal"},eles,tip&&_react2.default.createElement("div",{className:"input-tip",style:{marginLeft:14},dangerouslySetInnerHTML:{__html:tip}}),passwordStrength&&value&&_react2.default.createElement("div",{className:"password-strength-wrap"},_react2.default.createElement("span",{className:"password-strength "+getPasswordStrengthCT(value)}),getPasswordStrengthCT(value,true)),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:this.props.ecId+"_WeaHelpfulTip@q3wv5q",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)),_react2.default.createElement("input",{type:"hidden",id:fieldname,name:fieldname,value:value}));}}]);return Main;}(_react2.default.Component),_class.defaultProps={type:"text",passwordStrength:false},_initialiseProps=function _initialiseProps(){var _this2=this;this.setText=function(e){var props=_this2.props;e.preventDefault();e.stopPropagation();var value=e.target.value;if(props.length&&value.length>props.length){value=value.substring(0,props.length);}if(props.stringLength&&_weaTools2.default.getStringLength(value)>props.stringLength){value=_weaTools2.default.getStringByLength(value,props.stringLength);}if(!(0,_isEmpty2.default)(value)&&props.regExp){var regExp="";if((0,_isRegExp2.default)(props.regExp))regExp=props.regExp;if((0,_isString2.default)(props.regExp))regExp=new RegExp(props.regExp);if(regExp&&!regExp.test(value)){value=_this2.state.value||"";}}_this2.setState({value:value});(0,_isFunction2.default)(_this2.props.onChange)&&_this2.props.onChange(value);};this.onClick=function(e,value){e.preventDefault();e.stopPropagation();_this2.props.onClick&&_this2.props.onClick(e.target.value);if(value&&(!!window.ActiveXObject||"ActiveXObject"in window)){// 处理ie下右键粘贴到文本框没有触发onchange问题
(0,_isFunction2.default)(_this2.props.onChange)&&_this2.props.onChange(value);}};this.onBlur=function(e){var props=_this2.props;e.preventDefault();e.stopPropagation();var value=e.target.value;if(props.filter){value=props.filter(value);if(e.target.value!==value){_this2.setState({value:value},function(){(0,_isFunction2.default)(props.onChange)&&props.onChange(value);});}}props.onBlur&&props.onBlur(value);// 多语言模式下内部使用的 customBlur不需要再次触发, 在多语言中已经触发 modeSource={"weaInputLocale"}
if(props.modeSource!=="weaInputLocale"){typeof props.customBlur==="function"&&props.customBlur(value.toString());}};this.onFocus=function(e){var input=e.target;if(_this2.props.onBeforeFocusCheck){if(!_this2.needFocus){input.blur();_this2.needFocus=true;}var cb=function cb(){if(_this2.needFocus){input.focus();_this2.needFocus=false;}_this2.onFocusInner(input);};_this2.props.onBeforeFocusCheck(cb,function(){input.blur();});}else{_this2.onFocusInner(input);}};this.onFocusInner=function(input){// 火狐下阻止事件会导致光标丢失
// e.preventDefault();
// e.stopPropagation();
// 处理ie下光标出现在文本最前面
var selectionStart=input.value.length;var selectionEnd=input.value.length;if(input.setSelectionRange){input.focus();input.setSelectionRange(selectionStart,selectionEnd);}else if(input.createTextRange){var range=input.createTextRange();range.collapse(true);range.moveEnd("character",selectionEnd);range.moveStart("character",selectionStart);range.select();}_this2.props.onFocus&&_this2.props.onFocus(input.value);};this.onKeyDown=function(e){var onKeyDown=_this2.props.onKeyDown;typeof onKeyDown==="function"&&onKeyDown(e);if(e.keyCode==13){var _props2=_this2.props,onEnter=_props2.onEnter,onEnterSearch=_props2.onEnterSearch;var value=e.target.value;typeof onEnterSearch==="function"&&onEnterSearch(value);// 高级搜索传参
typeof onEnter==="function"&&onEnter(value);}};},_temp);exports.default=Main;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(234),
    baseIteratee = __webpack_require__(204),
    toInteger = __webpack_require__(203);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaColorPicker=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(5/* limit */).then(__webpack_require__.bind(null, 969));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaColorPicker;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(44);
var dPs = __webpack_require__(332);
var enumBugKeys = __webpack_require__(161);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(157)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(222).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(155);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(92);
var TAG = __webpack_require__(30)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(234),
    baseIsNaN = __webpack_require__(413),
    strictIndexOf = __webpack_require__(414);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(111);
var createDesc = __webpack_require__(90);
var toIObject = __webpack_require__(59);
var toPrimitive = __webpack_require__(158);
var has = __webpack_require__(61);
var IE8_DOM_DEFINE = __webpack_require__(219);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(48) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(233),
    isObject = __webpack_require__(40),
    isSymbol = __webpack_require__(110);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaCustomNew=function(_React$Component){(0,_inherits3.default)(WeaCustomNew,_React$Component);function WeaCustomNew(){(0,_classCallCheck3.default)(this,WeaCustomNew);return(0,_possibleConstructorReturn3.default)(this,(WeaCustomNew.__proto__||(0,_getPrototypeOf2.default)(WeaCustomNew)).apply(this,arguments));}(0,_createClass3.default)(WeaCustomNew,[{key:"render",value:function render(){return this.props.children;}}]);return WeaCustomNew;}(React.Component);var Com=(0,_middleware2.default)(WeaCustomNew,"WeaCustomNew");exports.default=Com;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _Encry=__webpack_require__(51);var EncryBase=_interopRequireWildcard(_Encry);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Encry=EncryBase.Encry;var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).apply(this,arguments));}(0,_createClass3.default)(Main,[{key:"render",value:function render(){return _react2.default.createElement(Encry,(0,_extends3.default)({},this.props,{prefixCls:"wea-input-auth",ecId:this.props.ecId+"_Encry@3dsdq6",encryType:"INPUT"}));}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _weaTimePicker=__webpack_require__(98);var _weaTimePicker2=_interopRequireDefault(_weaTimePicker);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.state={startValue:"",endValue:""};if(!(0,_isEmpty2.default)(props.value)){if(props.value[0]!==undefined)_this.state.startValue=props.value[0];if(props.value[1]!==undefined)_this.state.endValue=props.value[1];}return _this;}(0,_createClass3.default)(Main,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps){var startValue="",endValue="";if(!(0,_isEmpty2.default)(nextProps.value)){startValue=nextProps.value[0];endValue=nextProps.value[1];}this.setState({startValue:startValue,endValue:endValue});}}},{key:"onChangeL",value:function onChangeL(value){this.setState({startValue:value});var _state$endValue=this.state.endValue,endValue=_state$endValue===undefined?"":_state$endValue;var resp=[value,endValue];if(!value&&!endValue)resp=[];this.props.onChange&&this.props.onChange(resp);}},{key:"onChangeR",value:function onChangeR(value){this.setState({endValue:value});var _state$startValue=this.state.startValue,startValue=_state$startValue===undefined?"":_state$startValue;var resp=[startValue,value];if(!value&&!startValue)resp=[];this.props.onChange&&this.props.onChange(resp);}},{key:"isEmpty",value:function isEmpty(v){return v===""||v==null;}},{key:"render",value:function render(){var _classNames;var _state=this.state,startValue=_state.startValue,endValue=_state.endValue;var _props=this.props,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style,children=_props.children,ecId=_props.ecId,resProps=(0,_objectWithoutProperties3.default)(_props,["className","style","children","ecId"]);var noInput=resProps.noInput,_resProps$needDivisio=resProps.needDivision,needDivision=_resProps$needDivisio===undefined?true:_resProps$needDivisio;var cStyle={};var viewAttr=resProps.viewAttr;if(viewAttr=="3")delete resProps.viewAttr;if(!noInput)cStyle.width=100;var req=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,""+className,className),(0,_defineProperty3.default)(_classNames,"required",viewAttr=="3"&&(this.isEmpty(startValue)||this.isEmpty(endValue))),_classNames));return React.createElement("div",{className:"wea-scope "+req,style:style},React.createElement(_weaTimePicker2.default,(0,_extends3.default)({style:cStyle},resProps,{ecId:ecId+"_WeaTimePicker@97p46v",value:startValue,onChange:this.onChangeL.bind(this)})),React.createElement("span",{style:{padding:"0 4px"}},needDivision&&"-"),React.createElement(_weaTimePicker2.default,(0,_extends3.default)({style:cStyle},resProps,{ecId:ecId+"_WeaTimePicker@wyhgyh",value:endValue,onChange:this.onChangeR.bind(this)})),children);}}]);return Main;}(React.Component);var Com=(0,_middleware2.default)(Main,"WeaTimeRangePicker");exports.default=Com;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);__webpack_require__(685);var _rcReactDragula=__webpack_require__(686);var _rcReactDragula2=_interopRequireDefault(_rcReactDragula);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _findIndex=__webpack_require__(141);var _findIndex2=_interopRequireDefault(_findIndex);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaDragula=function(_React$Component){(0,_inherits3.default)(WeaDragula,_React$Component);function WeaDragula(props){(0,_classCallCheck3.default)(this,WeaDragula);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaDragula.__proto__||(0,_getPrototypeOf2.default)(WeaDragula)).call(this,props));_this.initDragula=function(){var _this$props=_this.props,container=_this$props.container,canDrag=_this$props.canDrag,direction=_this$props.direction,onDrop=_this$props.onDrop,getKeyFromDom=_this$props.getKeyFromDom,getKeyFromData=_this$props.getKeyFromData;if(typeof container=="string"){container=jQuery(container,ReactDOM.findDOMNode(_this))[0];}else if((0,_isFunction2.default)(container)){container=container();}var containerDocument=container?container.ownerDocument:document;if(!container){_this.dragulaTimeout=setTimeout(function(){if(!_this.drake)_this.initDragula();},500);return;}if(_this.dragulaTimeout){clearTimeout(_this.dragulaTimeout);}_this.drake=(0,_rcReactDragula2.default)([container],{isContainer:function isContainer(el){return false;},moves:function moves(el,source,handle,sibling){return(0,_isFunction2.default)(canDrag)?canDrag(handle,el,source,sibling):canDrag;},mirrorContainer:container,direction:direction,// doc: document,
doc:containerDocument});_this.drake.on("drop",function(el,target,source,sibling){var datas=_this.props.datas;if(Array.isArray(datas)&&(0,_isFunction2.default)(getKeyFromDom)&&(0,_isFunction2.default)(getKeyFromData)&&(0,_isFunction2.default)(onDrop)){var _this$state=_this.state,page=_this$state.page,pageSize=_this$state.pageSize;var dataKey=getKeyFromDom(el),downKey=sibling?getKeyFromDom(sibling):-1;if(downKey==dataKey){downKey=-1;}var dataIdx=(0,_findIndex2.default)(datas,function(data,index){return getKeyFromData(data,index)==dataKey;}),downIdx=downKey==-1?pageSize?page*pageSize:datas.length:(0,_findIndex2.default)(datas,function(data,index){return getKeyFromData(data,index)==downKey;});downIdx=downIdx>dataIdx?downIdx-1:downIdx;// tableEdit中拖拽更改第一页之后的数据效果不对的问题
if(page&&pageSize&&page>1){// downIdx = downIdx + (page - 1) * pageSize;
dataIdx=dataIdx+(page-1)*pageSize;}var data=datas.splice(dataIdx,1)[0];data&&datas.splice(downIdx,0,data);// dataIdx:所拖拽的节点的原位置
// downIdx + 1: 拖拽节点放下来的位置。
onDrop([].concat((0,_toConsumableArray3.default)(datas)),dataIdx,downIdx,data);}else{(0,_isFunction2.default)(onDrop)&&onDrop(el,sibling,target,source);}});};_this.drake=null;_this.state={// tableEdit 多页情况下拖拽效果不对
page:props.page,pageSize:props.pageSize};return _this;}(0,_createClass3.default)(WeaDragula,[{key:"componentDidMount",value:function componentDidMount(){if(!this.drake)this.initDragula();}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var nextPage=nextProps.page,nextPageSize=nextProps.pageSize;var _state=this.state,page=_state.page,pageSize=_state.pageSize;if(nextPage&&nextPageSize&&(page!==nextPage||pageSize!==nextPageSize)){this.setState({page:nextPage,pageSize:nextPageSize});}}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(!this.drake)this.initDragula();}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.drake&&this.drake.destroy();}},{key:"render",value:function render(){return this.props.children;}}]);return WeaDragula;}(React.Component);WeaDragula.propTypes={container:React.PropTypes.any,//可拖拽区域
canDrag:React.PropTypes.any,//是否可拖拽，可以传方法，方法的传参为当前点击的节点。
onDrop:React.PropTypes.func,//拖拽结束时触发的方法，第1个参数是拖拽的DOM节点，第二个参数是所放下的位置下方的DOM节点。
datas:React.PropTypes.array,//数组
getKeyFromData:React.PropTypes.func,//从数组中获得key的方法。
getKeyFromDom:React.PropTypes.func//从Dom中获得key的方法
};var Com=(0,_middleware2.default)(WeaDragula,"WeaDragula");exports.default=Com;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.showImage=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _Wrapper=__webpack_require__(372);Object.defineProperty(exports,"showImage",{enumerable:true,get:function get(){return _Wrapper.showImage;}});var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaZmage=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 985));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaZmage;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
var document = __webpack_require__(29).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(53);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(160)('keys');
var uid = __webpack_require__(109);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(20);
var global = __webpack_require__(29);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(89) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(145);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(73);
module.exports = __webpack_require__(20).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(105);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(74),
    arrayMap = __webpack_require__(232),
    isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(110);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(39);
var core = __webpack_require__(20);
var fails = __webpack_require__(69);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(30);


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(20);
var LIBRARY = __webpack_require__(89);
var wksExt = __webpack_require__(166);
var defineProperty = __webpack_require__(49).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(456),
    baseUnary = __webpack_require__(94),
    nodeUtil = __webpack_require__(115);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(457),
    isObjectLike = __webpack_require__(45);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116),
    stackClear = __webpack_require__(463),
    stackDelete = __webpack_require__(464),
    stackGet = __webpack_require__(465),
    stackHas = __webpack_require__(466),
    stackSet = __webpack_require__(467);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(468),
    mapCacheDelete = __webpack_require__(475),
    mapCacheGet = __webpack_require__(477),
    mapCacheHas = __webpack_require__(478),
    mapCacheSet = __webpack_require__(479);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(173),
    setCacheAdd = __webpack_require__(480),
    setCacheHas = __webpack_require__(481);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(243),
    stubArray = __webpack_require__(244);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.formatToTime=exports.formatDate=exports.formatToDate=exports.formatOfZero=undefined;var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatOfZero=exports.formatOfZero=function formatOfZero(value){var formatWithZero=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(!formatWithZero&&value&&typeof value==="string"&&value.indexOf("-")>-1){// feat: 增是否显示数字前0处理
// 去掉日期前的0
var arr=value.split("-");var newArr=[];if(arr&&arr.length>0){arr.map(function(i){newArr.push(i.replace(/^0/,""));});}var str=newArr.join("-");return str;}return value;};var formatToDate=exports.formatToDate=function formatToDate(realVal,formatPattern){var formatWithZero=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var pattern=new RegExp("^\\d{2,4}-\\d{1,2}-\\d{1,2}$");if(!pattern.test(realVal)){return formatOfZero(realVal,formatWithZero);}/**
   * formatPattern
   * 1：yyyy/MM/dd
   * 2：yyyy-MM-dd
   * 3：yyyy年MM月dd日
   * 4：yyyy年MM月
   * 5：MM月dd日
   * 6：EEEE
   * 7：日期大写
   * 8：yyyy/MM/dd hh:mm a
   * 9：yyyy/MM/dd HH:mm
   */var arr=realVal.split("-");var year=arr[0];var month=arr[1];var day=arr[2];if(parseInt(month)>12||parseInt(day)>31||parseInt(year)<=0||parseInt(month)<=0||parseInt(day)<=0){return realVal;}if(year.length==2)year=formatWithZero?"00"+year:year;if(year.length==3)year=formatWithZero?"0"+year:year;if(month.length==1)month=formatWithZero?"0"+month:month;if(day.length==1)day=formatWithZero?"0"+day:day;realVal=year+"/"+month+"/"+day+" 00:00:00";if(new Date(realVal).toString().indexOf("undefined")>-1){//解决IE下类似不存在的日期2014-9-31通过new Date无法生成日期问题，chrome下默认取的下一天
return realVal;}switch(parseInt(formatPattern)){case 1:return formatDate(new Date(realVal),"yyyy/MM/dd",formatWithZero);case 2:return formatDate(new Date(realVal),"yyyy-MM-dd",formatWithZero);case 3:return formatDate(new Date(realVal),"yyyy年MM月dd日",formatWithZero);case 4:return formatDate(new Date(realVal),"yyyy年MM月",formatWithZero);case 5:return formatDate(new Date(realVal),"MM月dd日",formatWithZero);case 6:return formatDate(new Date(realVal),"wwww",formatWithZero);case 7:return dataToChinese(new Date(realVal));case 8:return formatDate(new Date(realVal),"yyyy/MM/dd h:m a",formatWithZero);case 9:return formatDate(new Date(realVal),"yyyy/MM/dd H:m",formatWithZero);default:return realVal;}};//日期格式
var formatDate=exports.formatDate=function formatDate(date,fmt){var formatWithZero=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;fmt=fmt||"yyyy-MM-dd HH:mm:ss";var hour=date.getHours();var noonStr="AM";if(hour>12){hour-=12;noonStr="PM";}var obj={Y:date.getFullYear(),// 年份，注意必须用getFullYear
y:date.getFullYear(),// 年份，注意必须用getFullYear
M:date.getMonth()+1,// 月份，注意是从0-11
d:date.getDate(),// 日期
q:Math.floor((date.getMonth()+3)/3),// 季度
w:date.getDay(),// 星期，注意是0-6
H:date.getHours(),// 24小时制
h:hour,// 12小时制
m:date.getMinutes(),// 分钟
s:date.getSeconds(),// 秒
S:date.getMilliseconds(),// 毫秒
a:noonStr};var week=["天","一","二","三","四","五","六"];for(var i in obj){fmt=fmt.replace(new RegExp(i+"+","g"),function(m){var val=obj[i]+"";if(i=="a")return val;if(i=="w")return(m.length>2?"星期":"周")+week[val];for(var j=0,len=val.length;j<m.length-len;j++){// val = "0" + val;
// 增加format是否带0的处理，默认带0 (年 月 日)
if(!((i=="Y"||i=="y"||i=="M"||i=="d")&&!formatWithZero)){val="0"+val;}}return m.length==1?val:val.substring(val.length-m.length);});}return fmt;};//日期中文
var dataToChinese=function dataToChinese(date){var arr=["〇","一","二","三","四","五","六","七","八","九"];var year=date.getFullYear();var month=date.getMonth()+1;var day=date.getDate();var tempYear=year.toString().split("").map(function(o){return arr[parseInt(o)];}).toString();return(tempYear+"年"+convertNumToChinese(month)+"月"+convertNumToChinese(day)+"日").replace(/\,/g,"");};var convertNumToChinese=function convertNumToChinese(num){var arr1=["","","二","三"];var arr2=["","一","二","三","四","五","六","七","八","九"];num=num<10?"0"+num.toString():num.toString();var first=parseInt(num.toString().split("")[0]);var second=parseInt(num.toString().split("")[1]);return arr1[first]+(first>0?"十":"")+arr2[second];};var formatToTime=exports.formatToTime=function formatToTime(realVal,formatPattern){var pattern=new RegExp("^(\\d{1,2}:\\d{1,2})(:\\d{1,2})?$");if(!pattern.test(realVal)){return realVal;}/**
   * formatPattern
   * 1：HH:MI:SS
   * 2：HH:MI:SS AM/PM
   * 3：HH:MI
   * 4：HH:MI AM/PM
   * 5：HH时MI分SS秒
   * 6：HH时MI分
   * 7：HH时MI分SS秒 AM/PM
   * 8：HH时MI分 AM/PM
   **/var realValArr=realVal.split(":");var hour=realValArr[0];var minute=realValArr[1];var second=realValArr[2]||"00";var separatorChar=":";var suffix=parseInt(hour)<12?" AM":" PM";switch(parseInt(formatPattern)){case 1:return hour+separatorChar+minute+separatorChar+second;case 2:return hour+separatorChar+minute+separatorChar+second+suffix;case 3:return hour+separatorChar+minute;case 4:return hour+separatorChar+minute+suffix;case 5:return hour+"时"+minute+"分"+second+"秒";case 6:return hour+"时"+minute+"分";case 7:return hour+"时"+minute+"分"+second+"秒"+suffix;case 8:return hour+"时"+minute+"分"+suffix;default:return realVal;}};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(245),
    baseKeysIn = __webpack_require__(556),
    isArrayLike = __webpack_require__(71);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(240);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(174),
    arrayIncludes = __webpack_require__(265),
    arrayIncludesWith = __webpack_require__(266),
    cacheHas = __webpack_require__(175),
    createSet = __webpack_require__(587),
    setToArray = __webpack_require__(176);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(110);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(11);









/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__["a" /* getMaxElementSize */])() : _ref$maxScrollSize,
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);




/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* unused harmony export bpfrpt_proptype_CellMeasurerCache */
/* unused harmony export bpfrpt_proptype_Positioner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PositionCache__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);













var emptyObject = {};

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Masonry, _React$PureComponent);

  function Masonry() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Masonry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Masonry.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Masonry)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isScrolling: false,
      scrollTop: 0
    }, _this._invalidateOnUpdateStartIndex = null, _this._invalidateOnUpdateStopIndex = null, _this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */](), _this._startIndex = null, _this._startIndexMemoized = null, _this._stopIndex = null, _this._stopIndexMemoized = null, _this._debounceResetIsScrollingCallback = function () {
      _this.setState({
        isScrolling: false
      });
    }, _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    }, _this._onScroll = function (event) {
      var height = _this.props.height;


      var eventScrollTop = event.currentTarget.scrollTop;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);

      // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
      if (eventScrollTop !== scrollTop) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._debounceResetIsScrolling();

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Masonry, [{
    key: 'clearCellPositions',
    value: function clearCellPositions() {
      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this.forceUpdate();
    }

    // HACK This method signature was intended for Grid

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var index = _ref2.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: 'recomputeCellPositions',
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;

      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoHeight = _props.autoHeight,
          cellCount = _props.cellCount,
          cellMeasurerCache = _props.cellMeasurerCache,
          cellRenderer = _props.cellRenderer,
          className = _props.className,
          height = _props.height,
          id = _props.id,
          keyMapper = _props.keyMapper,
          overscanByPixels = _props.overscanByPixels,
          role = _props.role,
          style = _props.style,
          tabIndex = _props.tabIndex,
          width = _props.width,
          rowDirection = _props.rowDirection;
      var _state = this.state,
          isScrolling = _state.isScrolling,
          scrollTop = _state.scrollTop;


      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;

      var startIndex = 0;
      var stopIndex = void 0;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, rowDirection === 'ltr' ? 'left' : 'right', left), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'position', 'absolute'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'top', top), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'width', cellMeasurerCache.getWidth(index)), _style)
        }));
      });

      // We need to measure additional cells for this layout
      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;

          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["default"])('ReactVirtualized__Masonry', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            boxSizing: 'border-box',
            direction: 'ltr',
            height: autoHeight ? 'auto' : height,
            overflowX: 'hidden',
            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
            position: 'relative',
            width: width,
            WebkitOverflowScrolling: 'touch',
            willChange: 'transform'
          }, style),
          tabIndex: tabIndex },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Masonry__innerScrollContainer',
            style: {
              width: '100%',
              height: estimateTotalHeight,
              maxWidth: '100%',
              maxHeight: estimateTotalHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            } },
          children
        )
      );
    }
  }, {
    key: '_checkInvalidateOnUpdate',
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var _startIndex = this._invalidateOnUpdateStartIndex;
        var _stopIndex = this._invalidateOnUpdateStopIndex;

        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null;

        // Query external layout logic for position of newly-measured cells
        this._populatePositionCache(_startIndex, _stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: '_debounceResetIsScrolling',
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_getEstimatedTotalHeight',
    value: function _getEstimatedTotalHeight() {
      var _props2 = this.props,
          cellCount = _props2.cellCount,
          cellMeasurerCache = _props2.cellMeasurerCache,
          width = _props2.width;


      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));

      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: '_invokeOnScrollCallback',
    value: function _invokeOnScrollCallback() {
      var _props3 = this.props,
          height = _props3.height,
          onScroll = _props3.onScroll;
      var scrollTop = this.state.scrollTop;


      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });

        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: '_invokeOnCellsRenderedCallback',
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var _onCellsRendered = this.props.onCellsRendered;


        _onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });

        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: '_populatePositionCache',
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _props4 = this.props,
          cellMeasurerCache = _props4.cellMeasurerCache,
          cellPositioner = _props4.cellPositioner;


      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            _left = _cellPositioner.left,
            _top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Masonry.defaultProps = {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
};
Masonry.propTypes =  true ? null : {
  autoHeight: PropTypes.bool.isRequired,
  cellCount: PropTypes.number.isRequired,
  cellMeasurerCache: function cellMeasurerCache() {
    return (typeof CellMeasurerCache === 'function' ? PropTypes.instanceOf(CellMeasurerCache).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellPositioner: function cellPositioner() {
    return (typeof Positioner === 'function' ? PropTypes.instanceOf(Positioner).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellRenderer: function cellRenderer() {
    return (typeof CellRenderer === 'function' ? PropTypes.instanceOf(CellRenderer).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
  id: PropTypes.string,
  keyMapper: function keyMapper() {
    return (typeof KeyMapper === 'function' ? PropTypes.instanceOf(KeyMapper).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  onCellsRendered: function onCellsRendered() {
    return (typeof OnCellsRenderedCallback === 'function' ? PropTypes.instanceOf(OnCellsRenderedCallback) : PropTypes.any).apply(this, arguments);
  },
  onScroll: function onScroll() {
    return (typeof OnScrollCallback === 'function' ? PropTypes.instanceOf(OnScrollCallback) : PropTypes.any).apply(this, arguments);
  },
  overscanByPixels: PropTypes.number.isRequired,
  role: PropTypes.string.isRequired,
  scrollingResetTimeInterval: PropTypes.number.isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
    }
  },
  tabIndex: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  rowDirection: PropTypes.string.isRequired
};


function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : {
  defaultHeight: PropTypes.number.isRequired,
  defaultWidth: PropTypes.number.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(Masonry);

/* harmony default export */ __webpack_exports__["a"] = (Masonry);

var bpfrpt_proptype_Positioner =  true ? null : PropTypes.func;





/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.doesChangeAffectFlattenedTree=exports.getFlattenedTreePaths=exports.getFlattenedTree=exports.nodeHasChildren=exports.isNodeExpanded=undefined;var _getIterator2=__webpack_require__(286);var _getIterator3=_interopRequireDefault(_getIterator2);var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var isNodeExpanded=exports.isNodeExpanded=function isNodeExpanded(node){return node.isopen;};var nodeHasChildren=exports.nodeHasChildren=function nodeHasChildren(node){return"isLeaf"in node&&!node.isLeaf||node.childs&&node.childs.length;};var getFlattenedTree=exports.getFlattenedTree=function getFlattenedTree(nodes){var parents=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var mainKey=arguments[2];return nodes.reduce(function(flattenedTree,node){var deepness=parents.length;var nodeWithHelpers=(0,_extends3.default)({},node,{deepness:deepness,parents:parents});if(!nodeHasChildren(node)||!isNodeExpanded(node)){return[].concat((0,_toConsumableArray3.default)(flattenedTree),[nodeWithHelpers]);}return[].concat((0,_toConsumableArray3.default)(flattenedTree),[nodeWithHelpers],(0,_toConsumableArray3.default)(getFlattenedTree(Array.isArray(node.childs)?node.childs:node.childs&&node.childs.datas,[].concat((0,_toConsumableArray3.default)(parents),[node[mainKey]]))));},[]);};var getFlattenedTreePaths=exports.getFlattenedTreePaths=function getFlattenedTreePaths(nodes){var parents=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var paths=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=(0,_getIterator3.default)(nodes),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var node=_step.value;var domid=node[mainKey];if(!nodeHasChildren(node)||!isNodeExpanded(node)){paths.push(parents.concat(domid));}else{paths.push(parents.concat(domid));paths.push.apply(paths,(0,_toConsumableArray3.default)(getFlattenedTreePaths(node.childs,[].concat((0,_toConsumableArray3.default)(parents),[domid]))));}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return paths;};var doesChangeAffectFlattenedTree=exports.doesChangeAffectFlattenedTree=function doesChangeAffectFlattenedTree(previousNode,nextNode){return isNodeExpanded(previousNode)!==isNodeExpanded(nextNode);};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var UPDATE_TYPE=exports.UPDATE_TYPE={ADD:0,DELETE:1,UPDATE:2};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.submitEvent=exports.KEY_CODES=exports.wrapKeyDownEvent=undefined;var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var wrapKeyDownEvent=exports.wrapKeyDownEvent=function wrapKeyDownEvent(availablekeys){return function(handler){return function(_ref){for(var _len=arguments.length,params=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){params[_key-1]=arguments[_key];}var keyCode=_ref.keyCode;if(keyCode in availablekeys){handler.apply(undefined,params);}};};};var KEY_CODES=exports.KEY_CODES={Backspace:8,Tab:9,Enter:13,Shift:16,Ctrl:17,Alt:18,PauseBreak:19,CapsLock:20,Escape:27,PageUp:33,PageDown:34,End:35,Home:36,LeftArrow:37,UpArrow:38,RightArrow:39,DownArrow:40,Insert:45,Delete:46,0:48,1:49,2:50,3:51,4:52,5:53,6:54,7:55,8:56,9:57,a:65,b:66,c:67,d:68,e:69,f:70,g:71,h:72,i:73,j:74,k:75,l:76,m:77,n:78,o:79,p:80,q:81,r:82,s:83,t:84,u:85,v:86,w:87,x:88,y:89,z:90,LeftWindowKey:91,RightWindowKey:92,SelectKey:93,NumPad0:96,NumPad1:97,NumPad2:98,NumPad3:99,NumPad4:100,NumPad5:101,NumPad6:102,NumPad7:103,NumPad8:104,NumPad9:105,Multiply:106,Add:107,Subtract:109,DecimalPoint:110,Divide:111,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F12:123,NumLock:144,ScrollLock:145,SemiColon:186,EqualSign:187,Comma:188,Dash:189,Period:190,ForwardSlash:191,GraveAccent:192,OpenBracket:219,BackSlash:220,CloseBracket:221,SingleQuote:222};var submitEvent=exports.submitEvent=wrapKeyDownEvent((0,_defineProperty3.default)({},KEY_CODES.Enter,null));

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Renderer=undefined;var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _nodeShapes=__webpack_require__(131);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Renderer=exports.Renderer={measure:_propTypes2.default.func,onChange:_propTypes2.default.func.isRequired,node:_propTypes2.default.shape(_nodeShapes.FlattenedNode),index:_propTypes2.default.number.isRequired};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaDragula=__webpack_require__(153);var _weaDragula2=_interopRequireDefault(_weaDragula);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);__webpack_require__(700);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=function(_React$Component){(0,_inherits3.default)(WeaTable,_React$Component);function WeaTable(props){(0,_classCallCheck3.default)(this,WeaTable);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaTable.__proto__||(0,_getPrototypeOf2.default)(WeaTable)).call(this,props));_this.getKeyFromDom=function(dom){return jQuery("span.wea-table-move",dom).attr("data-index");};_this.onDrop=function(datas){(0,_isFunction2.default)(_this.props.onDrop)&&_this.props.onDrop(datas);};_this.getColumns=function(){var columns=_this.props.columns;if(Array.isArray(columns)){columns=columns.map(function(col){if(col.isHtml){return(0,_extends3.default)({},col,{render:function render(text,record,index){return React.createElement("span",{dangerouslySetInnerHTML:{__html:text}});}});}return col;});if(_this.props.draggable){columns=[{key:"drag",dataIndex:"drag",width:60,render:function render(text,record,index){return React.createElement("span",{"data-index":_this.getRowKey(record,index),className:"icon-coms-move wea-table-move cursor-pointer"});}}].concat(columns);}}return columns;};_this.getRowKey=function(record,index){var rowKey=_this.props.rowKey;if(typeof rowKey==="function"){return rowKey(record,index);}return typeof record[rowKey]!=="undefined"?record[rowKey]:index;};return _this;}(0,_createClass3.default)(WeaTable,[{key:"render",value:function render(){if(this.props.draggable){var _props=this.props,dataSource=_props.dataSource,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style;return React.createElement(_weaDragula2.default,{ecId:this.props.ecId+"_WeaDragula@sjw8mh",container:".ant-table-tbody",canDrag:function canDrag(clickDom){return jQuery(clickDom).hasClass("wea-table-move");},datas:dataSource,getKeyFromData:this.getRowKey,getKeyFromDom:this.getKeyFromDom,onDrop:this.onDrop},React.createElement("div",{className:"wea-new-table wea-new-table-draggable "+className,style:style},React.createElement(_antd.Table,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_Table@8qp7am",columns:this.getColumns()}))));}else{return React.createElement("div",{className:"wea-new-table"},React.createElement(_antd.Table,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_Table@dhb9s7",columns:this.getColumns()})));}}}]);return WeaTable;}(React.Component);WeaTable.defaultProps={rowKey:"key",draggable:false};var Com=(0,_middleware2.default)(WeaTable,"WeaTable");exports.default=Com;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaInputSearch=__webpack_require__(46);var _weaInputSearch2=_interopRequireDefault(_weaInputSearch);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _objectAssign=__webpack_require__(99);var _objectAssign2=_interopRequireDefault(_objectAssign);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Tabs from '../../_antd1.11.2/tabs'
// import Row from '../../_antd1.11.2/row'
// import Col from '../../_antd1.11.2/col'
// import Input from '../../_antd1.11.2/input'
// import Button from '../../_antd1.11.2/button'
// import Menu from '../../_antd1.11.2/menu'
var getLabel=_weaLocaleProvider2.default.getLabel;var TabPane=_antd.Tabs.TabPane;var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.state={showSearchAd:props.showSearchAd||false};return _this;}(0,_createClass3.default)(main,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return nextProps.showSearchAd!==this.props.showSearchAd||nextState.showSearchAd!==this.state.showSearchAd||nextProps.buttonsAd!==this.props.buttonsAd||nextProps.searchsAd!==this.props.searchsAd||nextProps.searchType!==this.props.searchType||nextProps.searchsBaseValue!==this.props.searchsBaseValue;}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.showSearchAd!==nextProps.showSearchAd){this.setState({showSearchAd:nextProps.showSearchAd});}}},{key:"render",value:function render(){var that=this;var showSearchAd=this.state.showSearchAd;var _props=this.props,buttonsAd=_props.buttonsAd,searchsAd=_props.searchsAd,searchType=_props.searchType,searchsBaseValue=_props.searchsBaseValue,_props$height=_props.height,height=_props$height===undefined?300:_props$height,_props$leftDom=_props.leftDom,leftDom=_props$leftDom===undefined?"":_props$leftDom,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style;var searchBase=(""+searchType).indexOf("base")>=0;var searchAdvanced=(""+searchType).indexOf("advanced")>=0;return React.createElement("div",{className:"wea-tab wea-search-advance "+className,style:style},React.createElement(_antd.Row,null,React.createElement(_antd.Col,{style:{textAlign:"right"}},React.createElement("div",{className:"wea-search-tab"},leftDom,searchBase&&React.createElement(_weaInputSearch2.default,{value:searchsBaseValue,onSearch:this.onSearch.bind(this),onSearchChange:this.onSearchChange.bind(this)}),searchAdvanced&&React.createElement(_antd.Button,{type:"ghost",className:"wea-advanced-search",onClick:this.setShowSearchAd.bind(this,true)},getLabel("347","高级搜索"))))),React.createElement("div",{className:"wea-search-container",style:{display:showSearchAd?"block":"none"}},React.createElement(_antd.Button,{type:"ghost",className:"wea-advanced-search",onClick:this.setShowSearchAd.bind(this,false)},getLabel("347","高级搜索")),React.createElement("div",{className:"wea-advanced-searchsAd",style:{height:height}},searchsAd),React.createElement("div",{className:"wea-search-buttons"},React.createElement("div",{style:{textAlign:"center"}},buttonsAd&&buttonsAd.map(function(data){return React.createElement("span",{style:{marginLeft:15}},data);})))),React.createElement("div",{className:"mask-dark",style:{display:showSearchAd?"block":"none"}}),React.createElement("div",{className:"mask-wrapper",style:{display:showSearchAd?"block":"none"},onClick:this.setShowSearchAd.bind(this,false)}," "));}},{key:"onSearch",value:function onSearch(v){if(typeof this.props.onSearch=="function"){this.props.onSearch(v);}}},{key:"onSearchChange",value:function onSearchChange(v){if(typeof this.props.onSearchChange=="function"){this.props.onSearchChange(v);}}},{key:"setShowSearchAd",value:function setShowSearchAd(bool){this.setState({showSearchAd:bool});this.props.setShowSearchAd&&this.props.setShowSearchAd(bool);}}]);return main;}(React.Component);var Com=(0,_middleware2.default)(main,"WeaSearchAdvance");exports.default=Com;

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_196__;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(426), __esModule: true };

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(335);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _weaInputSearch=__webpack_require__(46);var _weaInputSearch2=_interopRequireDefault(_weaInputSearch);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var TabPane=_antd.Tabs.TabPane;var WeaTab=function(_React$Component){(0,_inherits3.default)(WeaTab,_React$Component);function WeaTab(props){(0,_classCallCheck3.default)(this,WeaTab);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaTab.__proto__||(0,_getPrototypeOf2.default)(WeaTab)).call(this,props));_this.updateLsPadding=function(){if(_this.weaTabRight){var lsPaddingRight=_this.state.lsPaddingRight;var clientWidth=_this.weaTabRight.clientWidth;if(lsPaddingRight!==clientWidth){_this.setState({lsPaddingRight:clientWidth});}}};_this.onSearch=function(v){if(typeof _this.props.onSearch==="function"){_this.props.onSearch(v);}};_this.onSearchChange=function(v){if(typeof _this.props.onSearchChange==="function"){_this.props.onSearchChange(v);}};_this.onChange=function(key){if(typeof _this.props.onChange==="function"){_this.props.onChange(key);}};_this.onMenuChange=function(o){if(typeof _this.props.onChange==="function"){_this.props.onChange(o.key);}};_this.getButtonsAd=function(){var _this$props=_this.props,onAdSearch=_this$props.onAdSearch,onAdReset=_this$props.onAdReset,onAdCancel=_this$props.onAdCancel;var ads=[_react2.default.createElement(_antd.Button,{ecId:_this.props.ecId+"_Button@hmef6z",type:"primary",onClick:function onClick(){typeof onAdSearch==="function"&&onAdSearch();_this.setShowSearchAd(false);}},getLabel(197,"搜索")),_react2.default.createElement(_antd.Button,{ecId:_this.props.ecId+"_Button@zl6d6m",type:"ghost",onClick:function onClick(){typeof onAdReset==="function"&&onAdReset();}},getLabel(2022,"重置")),_react2.default.createElement(_antd.Button,{ecId:_this.props.ecId+"_Button@crgfbp",type:"ghost",onClick:function onClick(){typeof onAdCancel==="function"&&onAdCancel();_this.setShowSearchAd(false);}},getLabel(31129,"取消"))];return ads;};_this.state={maskDarkB:0,maskDarkH:0,lsPaddingRight:0};_this.calc=false;_this.onMenuChange=_this.onMenuChange.bind(_this);_this.onChange=_this.onChange.bind(_this);_this.onSearch=_this.onSearch.bind(_this);_this.onSearchChange=_this.onSearchChange.bind(_this);return _this;}(0,_createClass3.default)(WeaTab,[{key:"componentDidUpdate",value:function componentDidUpdate(){var showSearchAd=this.props.showSearchAd;var _state=this.state,maskDarkB=_state.maskDarkB,maskDarkH=_state.maskDarkH;var h=this.getMaskDarkH();var b=this.getMaskDarkB();if(showSearchAd&&(h!==maskDarkH||b!==maskDarkB)){this.setState({maskDarkH:h,maskDarkB:b});}}},{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,onTabMounted=_props.onTabMounted,autoCalculateWidth=_props.autoCalculateWidth;onTabMounted&&onTabMounted();this.updateLsPadding(false);if(autoCalculateWidth){window.addEventListener("resize",this.updateLsPadding);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){var autoCalculateWidth=this.props.autoCalculateWidth;if(autoCalculateWidth){window.removeEventListener("resize",this.updateLsPadding);}}},{key:"setShowSearchAd",value:function setShowSearchAd(bool){if(typeof this.props.setShowSearchAd==="function"){this.props.setShowSearchAd(bool);}}},{key:"setShowSearchDrop",value:function setShowSearchDrop(bool){if(typeof this.props.setShowSearchDrop==="function"){this.props.setShowSearchDrop(bool);}}},{key:"getKey",value:function getKey(obj){var keyParams=this.props.keyParams;if(!keyParams){return"0";}if(!obj)return"";var theKey="";keyParams.forEach(function(name){theKey+=obj[name]+"_";});if(theKey&&theKey!==""){theKey=theKey.substring(0,theKey.length-1);}return theKey;}},{key:"render",value:function render(){var _this2=this;var _props2=this.props,_props2$className=_props2.className,className=_props2$className===undefined?"":_props2$className,_props2$style=_props2.style,style=_props2$style===undefined?{}:_props2$style,children=_props2.children,resProps=(0,_objectWithoutProperties3.default)(_props2,["className","style","children"]);var datas=resProps.datas,counts=resProps.counts,keyParam=resProps.keyParam,buttons=resProps.buttons,selectedKey=resProps.selectedKey,countParam=resProps.countParam,showSearchAd=resProps.showSearchAd,buttonsAd=resProps.buttonsAd,searchsAd=resProps.searchsAd,searchType=resProps.searchType,searchsBaseValue=resProps.searchsBaseValue,hasDropMenu=resProps.hasDropMenu,dropIcon=resProps.dropIcon,leftStyle=resProps.leftStyle,rightStyle=resProps.rightStyle,buttonsDrop=resProps.buttonsDrop,showSearchDrop=resProps.showSearchDrop,searchsDrop=resProps.searchsDrop,onlyShowRight=resProps.onlyShowRight,_resProps$type=resProps.type,type=_resProps$type===undefined?"line":_resProps$type,_onEdit=resProps.onEdit,_resProps$advanceHeig=resProps.advanceHeight,advanceHeight=_resProps$advanceHeig===undefined?300:_resProps$advanceHeig,_resProps$hasMask=resProps.hasMask,hasMask=_resProps$hasMask===undefined?true:_resProps$hasMask,_resProps$showAddBtn=resProps.showAddBtn,showAddBtn=_resProps$showAddBtn===undefined?false:_resProps$showAddBtn,_resProps$addBtnProps=resProps.addBtnProps,addBtnProps=_resProps$addBtnProps===undefined?{}:_resProps$addBtnProps,replaceLeft=resProps.replaceLeft,searchsBasePlaceHolder=resProps.searchsBasePlaceHolder,searchsBasePlaceHolderExtra=resProps.searchsBasePlaceHolderExtra,searchsAdQuick=resProps.searchsAdQuick,buttonsAdQuick=resProps.buttonsAdQuick,subMenuClass=resProps.subMenuClass,_resProps$autoCalcula=resProps.autoCalculateWidth,autoCalculateWidth=_resProps$autoCalcula===undefined?false:_resProps$autoCalcula;if(!this.loadSearchAd)this.loadSearchAd=showSearchAd;var _state2=this.state,maskDarkH=_state2.maskDarkH,maskDarkB=_state2.maskDarkB,lsPaddingRight=_state2.lsPaddingRight;var searchModlaBtns=buttonsAd||this.getButtonsAd();var tabType=type.indexOf("editable")>-1?"editable-card":type;var tabClassName=(0,_classnames2.default)({"wea-tab-edit":type==="editable-inline"});var isIE8=window.navigator.appVersion.indexOf("MSIE 8.0")>=0;// const isIE9 = window.navigator.appVersion.indexOf('MSIE 9.0') >= 0;
var searchBase=(""+searchType).indexOf("base")>=0;var searchAdvanced=(""+searchType).indexOf("advanced")>=0;var searchDrop=(""+searchType).indexOf("drop")>=0;var hasAddButton=type==="editable-inline"&&showAddBtn;var nowSelectedKey=selectedKey||selectedKey===0?selectedKey.toString():"";if(hasDropMenu&&datas){datas.forEach(function(data){var dataKey=data[keyParam]||data[keyParam]===0?data[keyParam].toString():"";var dropMenu=data.dropMenu;if(dropMenu){if(dataKey===nowSelectedKey){nowSelectedKey=[dataKey,"item_"+dataKey];}dropMenu.forEach(function(d){if(d.requestid===nowSelectedKey){nowSelectedKey=[dataKey,d.requestid];}});}});}var leftDom="";if(!onlyShowRight){if(hasDropMenu){leftDom=_react2.default.createElement(_antd.Menu,{mode:"horizontal",selectedKeys:nowSelectedKey,onClick:this.onMenuChange,ecId:this.props.ecId+"_Menu@o0llz6"},datas&&datas.map(function(data){var dataKey=data[keyParam]||data[keyParam]===0?data[keyParam].toString():"";var countKey=data[countParam];var showCount=counts&&data.showcount;var tab=showCount?_react2.default.createElement("span",null,data.title+(showCount?" (":""),showCount?_react2.default.createElement("span",{style:data.color?{color:data.color}:{}},counts[countKey]||"0"):"",showCount?")":""):data.title;var dropMenu=data.dropMenu;if(dropMenu){return _react2.default.createElement(_antd.Menu.SubMenu,{title:tab,key:dataKey,className:subMenuClass,onTitleClick:_this2.onMenuChange,ecId:_this2.props.ecId+"_Menu.SubMenu@cb0kfy@"+dataKey},_react2.default.createElement(_antd.Menu.Item,{style:{display:"none"},key:"item_"+dataKey,ecId:_this2.props.ecId+"_Menu.Item@ul947j"}),dropMenu.map(function(d){return _react2.default.createElement(_antd.Menu.Item,{key:d.requestid,ecId:_this2.props.ecId+"_Menu.Item@b24ujn@"+d.requestid},d.requestname);}));}else{return _react2.default.createElement(_antd.Menu.Item,{key:dataKey,ecId:_this2.props.ecId+"_Menu.Item@cxoc36"},tab);}}));}else{leftDom=[_react2.default.createElement(_antd.Tabs,(0,_extends3.default)({ecId:this.props.ecId+"_Tabs@w30llq"},resProps,{className:tabClassName,style:hasAddButton?{float:"left",maxWidth:"100%"}:null,type:tabType,defaultActiveKey:nowSelectedKey,activeKey:nowSelectedKey,onChange:this.onChange,onEdit:function onEdit(targetKey,action){typeof _onEdit==="function"&&_onEdit(targetKey,action);}}),datas&&datas.map(function(data){var dataKey=data[keyParam]||data[keyParam]===0?data[keyParam].toString():"";var countKey=data[countParam];var showCount=counts&&data.showcount;var tab=showCount?_react2.default.createElement("span",null,data.title+(showCount?" (":""),showCount?_react2.default.createElement("span",{style:data.color?{color:data.color}:{}},counts[countKey]||"0"):"",showCount?")":""):data.title;return _react2.default.createElement(TabPane,{ecId:_this2.props.ecId+"_TabPane@or9j4q@"+dataKey,tab:tab,className:tabClassName?tabClassName+"-pane"+(data.editable?"":"-nodel"):"",title:data.titleText||data.title,key:dataKey},data.com||"");})),showAddBtn&&_react2.default.createElement(_antd.Button,(0,_extends3.default)({ecId:this.props.ecId+"_Button@r2ibnd",type:"dashed",onClick:function onClick(){typeof _onEdit==="function"&&_onEdit(null,"add");},style:{marginRight:-45,color:"#999",padding:"6px 13px",marginTop:6}},addBtnProps),_react2.default.createElement("i",{className:"icon-coms-plus"}))].filter(Boolean);}}if(searchsAdQuick){leftDom=_react2.default.createElement(_antd.Row,{ecId:this.props.ecId+"_Row@oiy9j0"},_react2.default.createElement(_antd.Col,{ecId:this.props.ecId+"_Col@4laz7x",className:"wea-tab-search-ad-quick-left "+(buttonsAdQuick?"wea-tab-search-ad-quick-left-with-btns":""),span:24},searchsAdQuick),_react2.default.createElement(_antd.Col,{className:"wea-tab-search-ad-quick-right",ecId:this.props.ecId+"_Col@gei1k3"},buttonsAdQuick));}if(replaceLeft){leftDom=replaceLeft;}return _react2.default.createElement("div",{className:"wea-tab "+className+" "+(searchsAdQuick?"wea-tab-search-ad-quick":"")+" "+(searchAdvanced&&!searchBase?"wea-tab-search-ad":""),style:(0,_extends3.default)({},style,tabType==="card"?{backgroundColor:"#f4f4f4"}:{})},_react2.default.createElement(_antd.Row,{ecId:this.props.ecId+"_Row@xrxa2j"},_react2.default.createElement(_antd.Col,{ecId:this.props.ecId+"_Col@tehuvk",className:"wea-tab-left "+className+"-left",xs:isIE8?15:9,sm:9,md:12,lg:15,style:(0,_extends3.default)({},autoCalculateWidth?{paddingRight:lsPaddingRight}:{},leftStyle,hasAddButton?{paddingRight:45}:{})},leftDom),_react2.default.createElement(_antd.Col,{ecId:this.props.ecId+"_Col@m95ggc",className:"wea-tab-right "+className+"-right "+(searchsAdQuick?"wea-tab-right-search-ad-quick":""),xs:isIE8?9:15,sm:15,md:12,lg:9,style:(0,_extends3.default)({textAlign:"right"},rightStyle)},buttons||searchBase||searchAdvanced||searchDrop?_react2.default.createElement("div",{className:"wea-search-tab",ref:function ref(el){return _this2.weaTabRight=el;},ecId:this.props.ecId+"_div@rdrbqf"},buttons&&buttons.map(function(data,index){return _react2.default.createElement("span",{key:index,style:{marginLeft:15},ecId:_this2.props.ecId+"_span@6ll4by@"+index},data);}),searchBase&&_react2.default.createElement(_weaInputSearch2.default,{ecId:this.props.ecId+"_WeaInputSearch@2y993p",value:searchsBaseValue,placeholder:searchsBasePlaceHolder,placeholderExtra:searchsBasePlaceHolderExtra,onSearch:this.onSearch,onSearchChange:this.onSearchChange}),searchAdvanced&&_react2.default.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@oyu98w",type:"ghost",className:"wea-advanced-search text-elli",onClick:this.setShowSearchAd.bind(this,true)},getLabel("347","高级搜索")),searchDrop&&_react2.default.createElement("span",{style:{marginLeft:15}},dropIcon)):null)),_react2.default.createElement("div",{ecId:this.props.ecId+"_div@s0ihyg",className:"wea-search-container "+(searchsAdQuick?"wea-search-container-search-ad-quick":""),ref:"containerWrapper",style:{display:showSearchAd?"block":"none"}},_react2.default.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@mwhobe",type:"ghost",className:"wea-advanced-search text-elli",onClick:this.setShowSearchAd.bind(this,false)},getLabel("347","高级搜索")),_react2.default.createElement("div",{className:"wea-advanced-searchsAd",style:{height:advanceHeight}},this.loadSearchAd?searchsAd:null),_react2.default.createElement("div",{className:"wea-search-buttons"},_react2.default.createElement("div",{style:{textAlign:"center"}},searchModlaBtns&&searchModlaBtns.map(function(data,index){return _react2.default.createElement("span",{key:index,style:{marginLeft:15}},data);})))),hasMask&&_react2.default.createElement("div",{className:"mask-dark",style:{display:showSearchAd?"block":"none",height:maskDarkH,bottom:maskDarkB}}),hasMask&&_react2.default.createElement("div",{ecId:this.props.ecId+"_div@zd2wix",className:"mask-wrapper",style:{display:showSearchAd?"block":"none"},onClick:function onClick(){return _this2.props.hideSearchAd&&_this2.props.hideSearchAd();}}),_react2.default.createElement("div",{className:"wea-search-container",style:{display:showSearchDrop?"block":"none"}},_react2.default.createElement("span",{ecId:this.props.ecId+"_span@0epwmf",className:"wea-Drop-search",onClick:this.setShowSearchDrop.bind(this,false)},dropIcon),_react2.default.createElement("div",{className:"wea-advanced-searchsAd",style:{height:advanceHeight}},searchsDrop),_react2.default.createElement("div",{className:"wea-search-buttons"},_react2.default.createElement("div",{style:{textAlign:"center"}},buttonsDrop&&buttonsDrop.map(function(data,index){return _react2.default.createElement("span",{key:index,style:{marginLeft:15}},data);})))),children);}},{key:"getMaskDarkH",value:function getMaskDarkH(){var v=0;if(this.refs.containerWrapper){var dom=$(this.refs.containerWrapper);v=window.innerHeight-dom.height()-dom.offset().top-10;}return v;}},{key:"getMaskDarkB",value:function getMaskDarkB(){var v=0;if(this.refs.containerWrapper){var dom=$(this.refs.containerWrapper);this.calc=true;v=-dom.height()-this.getMaskDarkH();}return v;}}]);return WeaTab;}(_react2.default.Component);var Com=(0,_middleware2.default)(WeaTab,"WeaTab");exports.default=Com;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _toString=__webpack_require__(57);var _toString2=_interopRequireDefault(_toString);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _weaHelpfulTip=__webpack_require__(52);var _weaHelpfulTip2=_interopRequireDefault(_weaHelpfulTip);__webpack_require__(681);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _Encry=__webpack_require__(51);var _weaInputAuth=__webpack_require__(151);var _weaInputAuth2=_interopRequireDefault(_weaInputAuth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var maxNumber=999999999999999;var Main=(_temp2=_class=function(_React$PureComponent){(0,_inherits3.default)(Main,_React$PureComponent);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.onBlur=function(e){_this.props.onBlur&&_this.props.onBlur(e.target.value);},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:"render",value:function render(){var _props=this.props,value=_props.value,precision=_props.precision;var _props2=this.props,_props2$className=_props2.className,className=_props2$className===undefined?"":_props2$className,_props2$style=_props2.style,style=_props2$style===undefined?{}:_props2$style,children=_props2.children,resProps=(0,_objectWithoutProperties3.default)(_props2,["className","style","children"]);var viewAttr=resProps.viewAttr,hasBorder=resProps.hasBorder,underline=resProps.underline,tip=resProps.tip,ecId=resProps.ecId,hasInput=resProps.hasInput,alignRight=resProps.alignRight,helpfulTip=resProps.helpfulTip,helpfulTipProps=resProps.helpfulTipProps;var req=(0,_classnames2.default)({required:(viewAttr===3||viewAttr==="3")&&(0,_trim2.default)((0,_toString2.default)(value)).length===0});var readonly=(0,_classnames2.default)({border:hasBorder,underline:underline});// 加密数据处理
if(value!==""&&!isNaN(Number(precision))&&!((0,_Encry.desensitization)(value)||(0,_Encry.encryption)(value))){value=Number(value).toFixed(precision);// console.log(value, precision);
}if(viewAttr=="1"){if((0,_Encry.desensitization)(value)){return[_react2.default.createElement(_weaInputAuth2.default,(0,_extends3.default)({},resProps,{value:value})),children];}else if((0,_Encry.encryption)(value)){value=(0,_Encry.replaceEncryption)(value);}if(hasInput){var textAlign=(0,_classnames2.default)({right:alignRight});return _react2.default.createElement("div",{className:"wea-input-number "+className,style:style},_react2.default.createElement(_antd.Input,{ecId:ecId+"_Input@7iuyx2",className:"has-input "+textAlign,value:value,readOnly:true}),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:ecId+"_WeaHelpfulTip@7iuyx2",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)));}return _react2.default.createElement("div",{className:"wea-field-readonly "+readonly+" "+(this.props.className||""),style:style},_react2.default.createElement("span",{className:"child-item wdb",dangerouslySetInnerHTML:{__html:value}}),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:ecId+"_WeaHelpfulTip@p83jc8",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)));}return _react2.default.createElement("div",{className:"wea-input-number "+req+" "+className,style:style},_react2.default.createElement(_antd.InputNumber,(0,_extends3.default)({},resProps,{ecId:ecId+"_InputNumber@0ui38g",precision:this.props.precision||0,onBlur:this.onBlur})),tip&&_react2.default.createElement("div",{className:"input-tip",style:{marginLeft:14},dangerouslySetInnerHTML:{__html:tip}}),helpfulTip&&_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({ecId:ecId+"_WeaHelpfulTip@vx6jzd",style:{position:"absolute",right:-31,top:4},title:helpfulTip},helpfulTipProps)),children);}}]);return Main;}(_react2.default.PureComponent),_class.defaultProps={max:maxNumber},_temp2);var Com=(0,_middleware2.default)(Main,"WeaInputNumber");exports.default=Com;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaAlertPage=function(_React$Component){(0,_inherits3.default)(WeaAlertPage,_React$Component);function WeaAlertPage(props){(0,_classCallCheck3.default)(this,WeaAlertPage);return(0,_possibleConstructorReturn3.default)(this,(WeaAlertPage.__proto__||(0,_getPrototypeOf2.default)(WeaAlertPage)).call(this,props));}(0,_createClass3.default)(WeaAlertPage,[{key:"render",value:function render(){var _props=this.props,icon=_props.icon,iconSize=_props.iconSize,paddingTop=_props.paddingTop,top=_props.top,style=_props.style,minHeight=_props.minHeight,_props$className=_props.className,className=_props$className===undefined?"":_props$className,outStyle=_props.outStyle;var iconProps=iconSize?{style:{fontSize:iconSize+"px",lineHeight:iconSize+"px"}}:{};var conProps=void 0;if(style)conProps={className:"wea-alert-page-con",style:style};else if(top)conProps={className:"wea-alert-page-con top40",style:{top:top}};else if(paddingTop)conProps={className:"wea-alert-page-con",style:{paddingTop:paddingTop}};else conProps={className:"wea-alert-page-con top40"};return React.createElement("div",{className:"wea-alert-page "+className,style:(0,_extends3.default)({minHeight:minHeight+"px"},outStyle)},React.createElement("div",conProps,React.createElement("span",(0,_extends3.default)({className:"wea-alert-page-icon"},iconProps),icon?typeof icon==="string"?React.createElement("span",{className:icon}):icon:React.createElement("span",{className:"icon-coms-permission"},React.createElement("span",{className:"path1"}),React.createElement("span",{className:"path2"}),React.createElement("span",{className:"path3"}),React.createElement("span",{className:"path4"}),React.createElement("span",{className:"path5"}),React.createElement("span",{className:"path6"}),React.createElement("span",{className:"path7"}),React.createElement("span",{className:"path8"}),React.createElement("span",{className:"path9"}),React.createElement("span",{className:"path10"}),React.createElement("span",{className:"path11"}))),this.props.children));}}]);return WeaAlertPage;}(React.Component);// if (window.ecCom) {
//     window.ecCom.WeaAlertPage = WeaAlertPage;
// } else {
//     console.error("无法取到ecCom");
// }
WeaAlertPage.propTypes={icon:React.PropTypes.any,//图标，可以接受传字符串或组件
iconSize:React.PropTypes.number,//图标大小
paddingTop:React.PropTypes.string,//与上方的距离。
top:React.PropTypes.string,//与上方的距离。可以使用百分数，使用此属性时，position会被设为absolute,paddingTop不会生效。默认使用40%。
style:React.PropTypes.object//内部整体样式，包括图标.使用此属性时，paddingTop,top不会生效。
};WeaAlertPage.defaultProps={};var Com=(0,_middleware2.default)(WeaAlertPage,"WeaAlertPage");exports.default=Com;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _indexOld=__webpack_require__(552);var _indexOld2=_interopRequireDefault(_indexOld);var _indexMobx=__webpack_require__(575);var _indexMobx2=_interopRequireDefault(_indexMobx);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);return(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));}(0,_createClass3.default)(main,[{key:"render",value:function render(){return this.props.isMobx?React.createElement(_indexMobx2.default,this.props):React.createElement(_indexOld2.default,this.props);}}]);return main;}(React.Component),_class.defaultProps={isMobx:false},_temp);var Com=(0,_middleware2.default)(main,"WeaDateGroup");exports.default=Com;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(246);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(590),
    baseMatchesProperty = __webpack_require__(593),
    identity = __webpack_require__(122),
    isArray = __webpack_require__(21),
    property = __webpack_require__(600);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(607);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaHrmlist=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 962));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaHrmlist;

/***/ }),
/* 206 */
/***/ (function(module, exports) {



/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(89);
var $export = __webpack_require__(39);
var redefine = __webpack_require__(220);
var hide = __webpack_require__(58);
var Iterators = __webpack_require__(73);
var $iterCreate = __webpack_require__(390);
var setToStringTag = __webpack_require__(106);
var getPrototypeOf = __webpack_require__(223);
var ITERATOR = __webpack_require__(30)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(92);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(221);
var hiddenKeys = __webpack_require__(161).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaCollect=__webpack_require__(123);var _weaCollect2=_interopRequireDefault(_weaCollect);var _RightMenu=__webpack_require__(128);var _RightMenu2=_interopRequireDefault(_RightMenu);__webpack_require__(756);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var Item=_antd.Menu.Item;var WeaMoreButton=function(_React$Component){(0,_inherits3.default)(WeaMoreButton,_React$Component);function WeaMoreButton(props){(0,_classCallCheck3.default)(this,WeaMoreButton);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaMoreButton.__proto__||(0,_getPrototypeOf2.default)(WeaMoreButton)).call(this,props));_this.state={visible:_this.props.visible||false,collectVisable:false,showBtn:false};return _this;}(0,_createClass3.default)(WeaMoreButton,[{key:"componentDidMount",value:function componentDidMount(){if(this.RightMenu&&!this.RightMenu.isEmpty)this.setState({showBtn:true});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _state=this.state,visible=_state.visible,showBtn=_state.showBtn;var nState=null;"visible"in nextProps&&nextProps.visible!==visible&&(nState={visible:nextProps.visible});var showbtn=this.RightMenu&&!this.RightMenu.isEmpty;showbtn!==showBtn&&(nState={showBtn:showbtn});nState&&this.setState(nState);}},{key:"render",value:function render(){var _this2=this;var _state2=this.state,visible=_state2.visible,collectVisable=_state2.collectVisable,showBtn=_state2.showBtn;var _props=this.props,onVisibleChange=_props.onVisibleChange,collectParams=_props.collectParams,onLeaveMenu=_props.onLeaveMenu,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style;return React.createElement("div",{className:"wea-more-button "+className,ecId:this.props.ecId+"_div@2p3i4v",style:style,onMouseLeave:function onMouseLeave(){if(typeof onLeaveMenu==="function")onLeaveMenu();else{if(!_this2.props.visible)_this2.setState({visible:false});}}},React.createElement("div",{className:"wea-right-menu wea-more-button-menu "+(!visible&&"displayNone")},React.createElement(_RightMenu2.default,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_RightMenu@9swff7",ref:function ref(el){return _this2.RightMenu=el;}}))),React.createElement("div",{className:""+(!showBtn&&"displayNone")},React.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@v0fj3s",type:"ghost",onClick:function onClick(){if(typeof onVisibleChange==="function")onVisibleChange();else{if(!_this2.props.visible)_this2.setState({visible:!visible});}}},getLabel(17499,"更多"),React.createElement(_antd.Icon,{ecId:this.props.ecId+"_Icon@yu2ziw",type:"double-right",className:"wea-f12"}))));}}]);return WeaMoreButton;}(React.Component);var Com=(0,_middleware2.default)(WeaMoreButton,"WeaMoreButton");exports.default=Com;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 956));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Com;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends3=__webpack_require__(0);var _extends4=_interopRequireDefault(_extends3);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _classnames2=__webpack_require__(13);var _classnames3=_interopRequireDefault(_classnames2);var _RightMenu=__webpack_require__(128);var _RightMenu2=_interopRequireDefault(_RightMenu);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _storage=__webpack_require__(60);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaRightMenu=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaRightMenu,_React$Component);function WeaRightMenu(props){(0,_classCallCheck3.default)(this,WeaRightMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaRightMenu.__proto__||(0,_getPrototypeOf2.default)(WeaRightMenu)).call(this,props));_this.getUseMenu=function(){var useRightMenu=true;var useRightMenuLs=_storage.ls.getJSONObj("useRightMenu")||{useRightMenu:"true"};if("useRightMenu"in useRightMenuLs&&useRightMenuLs.useRightMenu==="0"){useRightMenu=false;}return useRightMenu;};_this.checkCrossOrigin=function(iframe){if(iframe.src&&/^http/.test(iframe.src)){var src=iframe.src.replace(/^http(s?):\/\//,"");if(src.indexOf(window.location.host)!==0){return false;}}if(/interface\/Entrance\.jsp/.test(iframe.src)){return false;}if(/em_cors_frame=1/.test(iframe.src)){return false;}return true;};_this.messageHandler=function(event){try{var data=JSON.parse(event.data);if(data.event=="oncontextmenu"){onIframeContextMenu(data.data);}if(data.event=="onIframeClick"){onIframeClick();}}catch(error){}};_this.docClick=function(){if(_this.instanceIsMounted){var visible=_this.state.visible;var handleVisible=_this.props.handleVisible;visible&&_this.setState({visible:false},function(){typeof handleVisible==="function"&&handleVisible(false);});}};_this.onIframeClick=function(){if(_this.instanceIsMounted){var visible=_this.state.visible;var handleVisible=_this.props.handleVisible;visible&&_this.setState({visible:false},function(){typeof handleVisible==="function"&&handleVisible(false);});}};_this.getSelection=function(){if(document.activeElement&&(document.activeElement.tagName==="INPUT"||document.activeElement.tagName==="TEXTAREA")){_this.setState({activeElement:document.activeElement,selectionStart:document.activeElement.selectionStart,selectionEnd:document.activeElement.selectionEnd});}};_this.onIframeContextMenu=function(params){var targetL=params.targetL;var targetT=params.targetT;var eventL=params.eventL;var eventT=params.eventT;var frameL=params.frameL;var frameT=params.frameT;_this.getSelection();var handleVisible=_this.props.handleVisible;_this.setState({targetL:targetL,targetT:targetT,eventL:eventL,eventT:eventT,visible:true},function(){typeof handleVisible==="function"&&handleVisible(true);});};_this.instanceIsMounted=false;_this.state={random:new Date().getTime()+"_"+Math.ceil(Math.random()*100000),visible:false,targetL:0,targetT:0,eventL:0,eventT:0,wrapL:0,wrapT:0,wrapW:0,wrapH:0,frameOffset:{},frameT:0,frameL:0,winW:document.body.clientWidth,winH:document.body.clientHeight,showRightMenu:true,activeElement:null,selectionStart:0,selectionEnd:0};_this.onContextMenu=_this.onContextMenu.bind(_this);return _this;}(0,_createClass3.default)(WeaRightMenu,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var useRightMenu=this.getUseMenu();if(!useRightMenu)return;this.instanceIsMounted=true;var _props$key=this.props.key,key=_props$key===undefined?"":_props$key;var _state=this.state,random=_state.random,frameOffset=_state.frameOffset;var iframes=$("#wea_right_menu_wrap_"+key+"_"+random).find("iframe");iframes.length>0&&iframes.each(function(index,frame){if(_this2.checkCrossOrigin(frame)){$(frame.contentWindow).load(function(){// doc ready 事件不稳定。。
frame.contentWindow[("wea_right_menu_"+key+"_"+random+"_frame_index").toLocaleUpperCase()]=index;_this2.setState({frameOffset:(0,_extends4.default)({},frameOffset,(0,_defineProperty3.default)({},index,$(frame).offset()))});frame.contentWindow.document.oncontextmenu=_this2.onContextMenu;_this2.onDocClick(frame.contentWindow.document);});}});this.onDocClick(document);// const onIframeContextMenu = this.onIframeContextMenu.bind(this);
// const onIframeClick = this.onIframeClick.bind(this);
window.addEventListener("message",this.messageHandler,false);if(this.RightMenu&&this.RightMenu.isEmpty)this.setState({showRightMenu:false});}},{key:"componentWillUpdate",value:function componentWillUpdate(nextProps,nextState,nextContext){if(nextState.visible!=this.state.visible){if(nextState.visible){window.onWeaDialogOpen&&window.onWeaDialogOpen();}else{window.onWeaDialogClose&&window.onWeaDialogClose();}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){var _this3=this;var useRightMenu=this.getUseMenu();if(!useRightMenu)return;this.instanceIsMounted=false;var _props$key2=this.props.key,key=_props$key2===undefined?"":_props$key2;var random=this.state.random;var iframes=$("#wea_right_menu_wrap_"+key+"_"+random).find("iframe");if(this.state.visible){window.onWeaDialogClose&&window.onWeaDialogClose();}iframes.length>0&&iframes.each(function(index,frame){if(frame.className!=="custompageIframe"&&_this3.checkCrossOrigin(frame)){_this3.offDocClick(frame.contentWindow.document);}});this.offDocClick(document);window.removeEventListener("message",this.messageHandler);}},{key:"onDocClick",value:function onDocClick(doc){doc.addEventListener("click",this.docClick);}},{key:"offDocClick",value:function offDocClick(doc){doc.removeEventListener("click",this.docClick);}},{key:"onContextMenu",value:function onContextMenu(e){var useRightMenu=this.getUseMenu();if(!useRightMenu)return;var isIframe=!e.nativeEvent;var _props=this.props,_props$key3=_props.key,key=_props$key3===undefined?"":_props$key3,disabled=_props.disabled,handleVisible=_props.handleVisible;if(!disabled){var _state2=this.state,random=_state2.random,frameOffset=_state2.frameOffset;var targetL=$(e.target).offset().left;var targetT=$(e.target).offset().top;var eventL=isIframe?e.offsetX:e.nativeEvent.clientX-targetL;var eventT=isIframe?e.offsetY:e.nativeEvent.clientY-targetT;var wrap=$("#wea_right_menu_wrap_"+key+"_"+random)||"";var wrapL=0;var wrapT=0;var wrapW=0;var wrapH=0;var _frameOffset=isIframe?frameOffset[e.view[("wea_right_menu_"+key+"_"+random+"_frame_index").toLocaleUpperCase()]]:{top:0,left:0};var frameT=_frameOffset.top;var frameL=_frameOffset.left;var winW=document.body.clientWidth;var winH=document.body.clientHeight;if(wrap&&wrap.offset){wrapL=wrap.offset().left;wrapT=wrap.offset().top;wrapW=wrap[0].offsetWidth;wrapH=wrap[0].offsetHeight;}this.getSelection();this.setState({targetL:targetL,targetT:targetT,eventL:eventL,eventT:eventT,wrapL:wrapL,wrapT:wrapT,wrapW:wrapW,wrapH:wrapH,frameT:frameT,frameL:frameL,winW:winW,winH:winH,visible:true},function(){typeof handleVisible==="function"&&handleVisible(true);});}e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();}},{key:"render",value:function render(){var _classnames,_this4=this;// datas 菜单数据  属性 icon: 图标 ，disabled: 禁用，content: 显示内容
var _props2=this.props,width=_props2.width,children=_props2.children,key=_props2.key,className=_props2.className,style=_props2.style,handleVisible=_props2.handleVisible;var _state3=this.state,visible=_state3.visible,random=_state3.random,targetL=_state3.targetL,targetT=_state3.targetT,eventL=_state3.eventL,eventT=_state3.eventT,wrapL=_state3.wrapL,wrapT=_state3.wrapT,wrapW=_state3.wrapW,wrapH=_state3.wrapH,frameT=_state3.frameT,frameL=_state3.frameL,winW=_state3.winW,winH=_state3.winH,showRightMenu=_state3.showRightMenu,activeElement=_state3.activeElement,selectionStart=_state3.selectionStart,selectionEnd=_state3.selectionEnd;var newWidth=width||($("#weaRrightMenu_"+key+"_"+random)[0]?$("#weaRrightMenu_"+key+"_"+random).width():400);var newHeight=$("#weaRrightMenu_"+key+"_"+random)[0]?$("#weaRrightMenu_"+key+"_"+random).height():400;var left=targetL-wrapL+eventL;var top=targetT-wrapT+eventT;left=left>=winW-wrapL-frameL-newWidth?winW-wrapL-newWidth-5:left>=wrapW-frameL-newWidth?wrapW-newWidth-2:left+frameL;top=top>=winH-wrapT-frameT-newHeight?winH-wrapT-newHeight-5:top>=wrapH-frameT-newHeight?wrapH-newHeight-2:top+frameT;var nowStyle=(0,_extends4.default)({display:visible?"block":"none",position:"absolute",// maxWidth: newWidth,
left:left,top:top},width?{width:width}:{});var cls=(0,_classnames3.default)((_classnames={},(0,_defineProperty3.default)(_classnames,"wea-right-menu",true),(0,_defineProperty3.default)(_classnames,"wea-right-menu-border",!showRightMenu),(0,_defineProperty3.default)(_classnames,"wea-right-menu-show",visible),_classnames));var useRightMenu=this.getUseMenu();return _react2.default.createElement("div",{ecId:this.props.ecId+"_div@tq9drh",className:"wea-right-menu-wrap "+className,id:"wea_right_menu_wrap_"+key+"_"+random,onContextMenu:this.onContextMenu,style:style},children,useRightMenu&&_react2.default.createElement("div",{ecId:this.props.ecId+"_div@f0lq50",className:cls,id:"weaRrightMenu_"+key+"_"+random,style:nowStyle,onClick:function onClick(){return _this4.setState({visible:false},function(){typeof handleVisible==="function"&&handleVisible(false);});}},_react2.default.createElement(_RightMenu2.default,(0,_extends4.default)({ecId:this.props.ecId+"_RightMenu@uwssvg"},this.props,{ref:function ref(el){return _this4.RightMenu=el;},activeElement:activeElement,selectionStart:selectionStart,selectionEnd:selectionEnd,isRM:true,showReport:true}))));}}]);return WeaRightMenu;}(_react2.default.Component),_class.displayName="WeaRightMenu",_class.RightMenu=_RightMenu2.default,_class.defaultProps={datas:[],width:0,key:"",collectParams:undefined,className:"",style:{}},_temp);var Com=(0,_middleware2.default)(WeaRightMenu,"WeaRightMenu");exports.default=Com;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _antd=__webpack_require__(8);var _weaInputSearch=__webpack_require__(46);var _weaInputSearch2=_interopRequireDefault(_weaInputSearch);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _ScrollTree=__webpack_require__(614);var _ScrollTree2=_interopRequireDefault(_ScrollTree);var _util=__webpack_require__(296);__webpack_require__(675);__webpack_require__(676);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _weaInputNormal=__webpack_require__(140);var _weaInputNormal2=_interopRequireDefault(_weaInputNormal);var _weaAvatar=__webpack_require__(135);var _weaAvatar2=_interopRequireDefault(_weaAvatar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var WeaTree=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaTree,_React$Component);function WeaTree(props){(0,_classCallCheck3.default)(this,WeaTree);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaTree.__proto__||(0,_getPrototypeOf2.default)(WeaTree)).call(this,props));_initialiseProps.call(_this);_this.state=(0,_extends3.default)({datas:[],datasShow:[],selectedKeys:[],searchValue:"",dataUrl:props.isLoadUser?props.loadUserUrl:props.dataUrl},_this.updateData(props,true));return _this;}(0,_createClass3.default)(WeaTree,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var state={};if(nextProps.datas!==undefined&&!(0,_isEqual2.default)((0,_util.getAllKeys)(this.props.datas,this.props.isOrg&&"nodeid"),(0,_util.getAllKeys)(nextProps.datas,nextProps.isOrg&&"nodeid"))){state=(0,_extends3.default)({},state,this.updateData(nextProps));}if(nextProps.expandedKeys!==undefined&&!(0,_isEqual2.default)(this.props.expandedKeys,nextProps.expandedKeys)){state=(0,_extends3.default)({},state,{expandedKeys:nextProps.expandedKeys});}this.setState(state);}},{key:"loadData",value:function loadData(node){var _this2=this;var props=this.props;var _props=this.props,loadData=_props.loadData,noCache=_props.noCache,isOrg=_props.isOrg;if(loadData&&(noCache||!node.isLoad)){if(!isOrg){return loadData((0,_cloneDeep2.default)(node),this).then(function(data){var datasShow=_this2.state.datasShow;var datas=_this2.formatData(data.datas||[]);_this2.addChildToNode(node,datasShow,datas);_this2.setState({datasShow:datasShow});props.onDatasChange&&props.onDatasChange(datas);});}else{var searchParams={type:node.type,id:node.id,isVirtual:node.isVirtual};return this.fetchData(searchParams,true,{},false,false,node);}}else{return new _promise2.default(function(resolve){resolve();});}}},{key:"fetchData",value:function fetchData(){var innerParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fetchChildNode=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var outerParams=arguments.length>2&&arguments[2]!==undefined?arguments[2]:this.props.params;var firstLoad=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var _this3=this;var expandAllChildrenOnSearch=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var node=arguments[5];var _state=this.state,dataUrl=_state.dataUrl,companysId=_state.companysId,value=_state.value;var _props2=this.props,onSelect=_props2.onSelect,isLoadAllSub=_props2.isLoadAllSub,isLoadSubDepartment=_props2.isLoadSubDepartment,isLoadUser=_props2.isLoadUser,_props2$vtreeMode=_props2.vtreeMode,vtreeMode=_props2$vtreeMode===undefined?false:_props2$vtreeMode,_props2$needDropMenu=_props2.needDropMenu,needDropMenu=_props2$needDropMenu===undefined?false:_props2$needDropMenu,defaultExpandedKeys=_props2.defaultExpandedKeys,defaultCheckedDatas=_props2.defaultCheckedDatas,defaultSelectedKeys=_props2.defaultSelectedKeys;var searchParams=(0,_extends3.default)({},outerParams,innerParams,{keyword:value});if(needDropMenu)searchParams.virtualCompanyid=companysId;if(isLoadAllSub||expandAllChildrenOnSearch&&value)searchParams.isLoadAllSub="1";if(isLoadSubDepartment)searchParams.isLoadSubDepartment="1";if(isLoadUser)searchParams.isLoadUser="1";if(!fetchChildNode){// 防止由于每次请求的根节点数据一致不会重新加载树
var root=[].concat((0,_toConsumableArray3.default)(this.state.treeData));if(root[0])root[0].needRefresh=true;this.setState({loading:true,treeData:root});}return new _promise2.default(function(resolve){_weaTools2.default.callApi(dataUrl,"GET",searchParams).then(function(data){var datasShow=_this3.state.datasShow;_this3.addChildToNode(node,datasShow,data);_this3.formatData(datasShow);_this3.setState({datasShow:datasShow});_this3.props.onDatasChange&&_this3.props.onDatasChange(data);});});}},{key:"onCheck",value:function onCheck(ks,e){var _this4=this;var props=this.props;var ids=[],nodeids=[],datas=[];ks&&ks.forEach(function(k){var target=_this4.treeMap[k];if(target&&target.treeKey==k){ids.push(target.id);target.nodeid&&nodeids.push(target.nodeid);datas.push(target);}});ids=uniq(ids);nodeids=uniq(nodeids);this.setState({checkedKeys:!(0,_isEmpty2.default)(nodeids)?nodeids:ids});props.onCheck&&props.onCheck(ids,datas,e);}},{key:"onRadioCheck",value:function onRadioCheck(key){var props=this.props;this.setState({radioCheckedKey:this.treeMap[key].nodeid||this.treeMap[key].id});props.onRadioCheck&&props.onRadioCheck(this.treeMap[key].id,this.treeMap[key].nodeid,this.treeMap[key]);}},{key:"renderOps",value:function renderOps(item){var _this5=this;var _props3=this.props,ops=_props3.ops,deleteText=_props3.deleteText,ecId=_props3.ecId;if(ops||item.ops){var os=item.ops||ops;return _react2.default.createElement("div",{className:"ops-wrapper inline-block"},os.map(function(o,idx){return _react2.default.createElement(_antd.Tooltip,{ecId:ecId+"_Tooltip@8ux43f",placement:"bottom",title:_this5.getName(o)},_react2.default.createElement("i",{ecId:ecId+"_i@srcxgl",className:_this5.getIcon(o)+" ops-icon",onClick:function onClick(e){e.preventDefault();e.stopPropagation();_this5.opsHandler(item,o);}}));}));}}},{key:"render",value:function render(){var _state2=this.state,datasShow=_state2.datasShow,searchValue=_state2.searchValue;var _props4=this.props,prefixCls=_props4.prefixCls,className=_props4.className,style=_props4.style,loading=_props4.loading,searchLabel=_props4.searchLabel,noDataLabel=_props4.noDataLabel,_props4$needSearch=_props4.needSearch,needSearch=_props4$needSearch===undefined?true:_props4$needSearch,isOrg=_props4.isOrg,ecId=_props4.ecId;return _react2.default.createElement("div",{className:prefixCls+" "+className,style:style},_react2.default.createElement(_antd.Spin,{ecId:ecId+"_Spin@kd6ui2",spinning:loading},needSearch&&!isOrg&&_react2.default.createElement("div",{className:prefixCls+"-search"},_react2.default.createElement("span",{ecId:ecId+"_span@im1g47",className:prefixCls+"-search-label",onClick:this.onSearchLabelClick},searchLabel!==void 0?searchLabel:getLabel("21979","全部类型")),_react2.default.createElement(_weaInputSearch2.default,{ecId:ecId+"_WeaInputSearch@g1iewa",value:searchValue,onSearchChange:this.onSearchChange})),_react2.default.createElement("div",{className:prefixCls+"-scroll",style:isOrg?{height:"100%"}:null},!datasShow.length&&!loading?_react2.default.createElement("p",{className:prefixCls+"-noData"},_react2.default.createElement("i",{className:"icon-coms-Invalid"}),noDataLabel!==void 0?noDataLabel:getLabel("83553","暂无数据")):this.getTree(datasShow))));}}]);return WeaTree;}(_react2.default.Component),_class.defaultProps={prefixCls:"wea-left-tree",className:"",datas:[],dataUrl:"/api/hrm/base/getHrmSearchTree",loadUserUrl:"/api/hrm/base/getHrmSearchTree?isLoadUser=1",counts:{},countsType:[],itemMainKey:"domid",defaultExpandLevel:2,asyncLoad:false,searchKeys:["name","ecologyPinyinSearch"],onlyShowFav:false,showCollect:false,loading:false,ops:[],isOrg:false},_initialiseProps=function _initialiseProps(){var _this6=this;this.updateData=function(props,expanded){var _ref=props||_this6.props,datas=_ref.datas,defaultExpandLevel=_ref.defaultExpandLevel,_e=_ref.expandedKeys,isOrg=_ref.isOrg;// let _datas = cloneDeep(datas);
var _datas=datas;_this6.formatData(_datas);var datasShow=!isOrg?[].concat((0,_toConsumableArray3.default)(_datas)):[_datas];var expandedKeys=(_e&&_e.length)>0?_e:_this6.state&&_this6.state.expandedKeys&&_this6.state.expandedKeys.length>0?_this6.state.expandedKeys:(0,_util.getAllKeys)((0,_util.getDefautDatasShow)(_datas,defaultExpandLevel-1),isOrg?"nodeid":"domid").keys;// if (asyncLoad) {
//   datasShow = getDefautDatasShow(_datas, defaultExpandLevel);
//   const total = getAllKeys(_datas, itemMainKey).num;
//   const _total = getAllKeys(datasShow, itemMainKey).num;
//   if (forceAsyn || (_total > 300 && total > 500)) {
//     datasShow = getDefautDatasShow(_datas, 1);
//     expandedKeys = [];
//   }
// }
return(0,_extends3.default)({datas:_datas,datasShow:datasShow},defaultExpandLevel||expanded?{expandedKeys:expandedKeys}:{});};this.formatData=function(data){(0,_util.traverTree)(data,function(obj){var props=_this6.props;if(obj.deleted)return;obj.nodeid=obj.nodeid||obj.domid||obj.id;!obj.domid&&(obj.domid=obj.nodeid);if(props.rowKey){obj.nodeid=obj[props.rowKey];}if(props.renderNodeId)obj.nodeid=props.renderNodeId(obj);obj.id=obj.id||obj.key;obj.childs=obj.childs||[];if(!(0,_isEmpty2.default)(obj.children)){obj.childs=obj.children;delete obj.children;}if(!(0,_isEmpty2.default)(obj.subs)){obj.childs=obj.subs;delete obj.subs;}var isLeaf=true;if("isLeaf"in obj&&obj.isLeaf){isLeaf=true;}else if(obj.isParent||obj.haschild)isLeaf=false;obj.isLeaf=isLeaf;if(!obj.isLeaf&&!(0,_isEmpty2.default)(obj.childs)){obj.isLoad=true;}if(!obj.isCheck&&props.isOrg){obj.isCheck=false;}});return data;};this.addChildToNode=function(node,data,childs){var _props5=_this6.props,rowKey=_props5.rowKey,itemMainKey=_props5.itemMainKey;(0,_util.traverTree)(data,function(obj){if(rowKey&&node[rowKey]===obj[rowKey]||node.id===obj.id&&node.name===obj.name){var _c=Array.isArray(childs)?childs:childs.datas&&childs.datas;obj.childs=_c;return true;}return false;});};this.expandTreeNode=function(node){var _props6=_this6.props,itemMainKey=_props6.itemMainKey,loadData=_props6.loadData,noCache=_props6.noCache,isOrg=_props6.isOrg,isLoadAllSub=_props6.isLoadAllSub;var _state$expandedKeys=_this6.state.expandedKeys,expandedKeys=_state$expandedKeys===undefined?[]:_state$expandedKeys;var isopen=!node.isopen;var newExpandedKeys=[].concat((0,_toConsumableArray3.default)(expandedKeys));if(isopen){newExpandedKeys.push(node[itemMainKey]);}else{newExpandedKeys=newExpandedKeys.filter(function(key){return key!=node[itemMainKey];});}if(isopen&&((0,_isEmpty2.default)(node.childs)||noCache)&&loadData&&!(isOrg&&isLoadAllSub)){_this6.loadData(node).then(function(){_this6.forceUpdate();});}_this6.onExpand(newExpandedKeys,{node:node,expanded:isopen});};this.onExpand=function(expandedKeys,target){var onExpand=_this6.props.onExpand;_this6.setState({expandedKeys:expandedKeys});target=target||{node:null,expanded:false};typeof onExpand==="function"&&onExpand(expandedKeys,target);};this.onSelect=function(keys,countsType,node){var _props7=_this6.props,counts=_props7.counts,onSelect=_props7.onSelect,isOrg=_props7.isOrg;var key=keys&&keys.length>0?keys[0]:"";_this6.setState({selectedKeys:keys});if(typeof onSelect==="function"&&key){// 为兼容目前antd左侧树已存在功能 伪造eventNode数据
var eventNode={event:"select",node:{props:(0,_extends3.default)({},node,{browserTree:true,data:{domid:node.domid,haschild:node.haschild,isopen:node.isopen,key:node.key,name:node.name,isLeaf:node.isLeaf},isLeaf:node.isLeaf,level:node.deepness,children:node.childs})},selected:true,selectedNodes:[{key:key,props:{browserTree:true,data:{domid:node.domid,haschild:node.haschild,isopen:node.isopen,key:node.key,name:node.name,isLeaf:node.isLeaf},isLeaf:node.isLeaf,level:node.deepness,children:node.childs}}]};onSelect(isOrg?keys:key,counts?counts[key]:"",eventNode);}};this.onSearchLabelClick=function(){var onSearchLabelClick=_this6.props.onSearchLabelClick;typeof onSearchLabelClick==="function"&&onSearchLabelClick();};this.onSearchChange=function(v){var _props8=_this6.props,onSearchChange=_props8.onSearchChange,defaultExpandLevel=_props8.defaultExpandLevel,asyncLoad=_props8.asyncLoad,searchKeys=_props8.searchKeys,isOrg=_props8.isOrg;var _state3=_this6.state,datas=_state3.datas,expandedKeys=_state3.expandedKeys;var datasShow=v?(0,_util.filterDatas)((0,_cloneDeep2.default)(datas),v,searchKeys):asyncLoad?(0,_util.getDefautDatasShow)(datas,1):[].concat((0,_toConsumableArray3.default)(datas));_this6.setState({searchValue:v,datasShow:datasShow,expandedKeys:v?expandedKeys:asyncLoad?[]:(0,_util.getAllKeys)((0,_util.getDefautDatasShow)(datas,defaultExpandLevel-1),isOrg?"nodeid":"domid").keys});typeof onSearchChange==="function"&&onSearchChange(v);};this.onCollect=function(data,e){var _props9=_this6.props,onCollect=_props9.onCollect,onlyShowFav=_props9.onlyShowFav,itemMainKey=_props9.itemMainKey;typeof onCollect==="function"&&onCollect(data).then(function(res){if(res.status===1){if(!res.hasDoFavToDatas){var datasShow=(0,_util.doFavEdit)(_this6.state.datasShow,data[itemMainKey]);if(onlyShowFav)datasShow=(0,_util.doNoFavDelete)(datasShow);_this6.setState({datasShow:datasShow});}_antd.message.success(res.msg||(data.fav?getLabel("129248","取消成功"):getLabel("383218","收藏成功"))+"\uFF01");}else{_antd.message.warning(res.msg||""+(data.fav?getLabel("385902","取消失败，请重试！"):getLabel("385472","收藏失败，请重试！")));}});e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();};this.onTitleNumClick=function(keys,countsType,e){_this6.onSelect(keys,countsType);e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();};this.titleHoverIn=function(countsTypeShow,e){$(e.target).closest(".wea-tree-wrap").find(".ant-tree-node-content-wrapper .titleNum").each(function(index,item){$(item).find(".wf-isshow").css({display:"inline-block"});$(item).find("span").each(function(i,m){$(m).css({"background-color":countsTypeShow[i].color,color:"#fff"});});});};this.titleHoverOut=function(countsTypeShow,e){$(e.target).closest(".wea-tree-wrap").find(".ant-tree-node-content-wrapper .titleNum").each(function(index,item){$(item).find(".wf-isshow").css({display:"none"});$(item).find("span").each(function(i,m){$(m).css({color:countsTypeShow[i].color,"background-color":"transparent"});});});};this.getTitle=function(data){var _props10=_this6.props,showCollect=_props10.showCollect,itemMainKey=_props10.itemMainKey,counts=_props10.counts,countsType=_props10.countsType,ops=_props10.ops,prefixCls=_props10.prefixCls,isOrg=_props10.isOrg,isLoadUser=_props10.isLoadUser,ecId=_props10.ecId;var countsTypeShow=[];var notShowEm=0;var keys=[data[itemMainKey]];var flowSpan=showCollect?[_react2.default.createElement("i",{ecId:ecId+"_i@ofsg5r",title:""+(data.fav?getLabel("129753","取消收藏"):getLabel("22255","添加收藏")),className:"icon-coms-Collection"+(data.fav?"2":""),style:data.fav?{color:"#ffa741"}:{},onClick:function onClick(e){return _this6.onCollect(data,e);}})]:[];countsType&&countsType.forEach(function(c,index){var num=counts&&counts[data[itemMainKey]]?counts[data[itemMainKey]][c.name]?counts[data[itemMainKey]][c.name]:"":"";if(num&&num!=="0"){notShowEm++;countsTypeShow.push(c);if(notShowEm!==1){flowSpan.push(_react2.default.createElement("em",{className:c.isshow?"":"wf-isshow",style:{display:c.isshow?"inline":"none"}}," ","/"," "));}flowSpan.push(_react2.default.createElement("span",{ecId:ecId+"_span@7imgrn@"+index,title:c.title,className:c.isshow?"":"wf-isshow",style:{color:c.color,display:c.isshow?"inline-block":"none"},onClick:function onClick(e){return _this6.onTitleNumClick(keys,c,e);}},num));}});ops&&ops.length>0&&ops.forEach(function(op){flowSpan.push(_react2.default.createElement("div",{ecId:ecId+"_div@p6rnho@"+op.key,className:prefixCls+"-ops",key:op.key,onClick:function onClick(){return typeof op.onClick==="function"&&op.onClick(data);}},op.show));});return _react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@h03gqs",onMouseEnter:function onMouseEnter(e){return _this6.titleHoverIn(countsTypeShow,e);},onMouseLeave:function onMouseLeave(e){return _this6.titleHoverOut(countsTypeShow,e);}},isOrg&&isLoadUser?_this6.renderTitle(data):_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@86bc4u",span:"24",className:"titleText text-elli",title:data.name},data.name),_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@3puc7k",span:"24",className:"titleNum"},_react2.default.createElement("div",null,flowSpan)));};this.renderTitle=function(item){var _props11=_this6.props,renderNode=_props11.renderNode,renderItem=_props11.renderItem,operations=_props11.operations,ecId=_props11.ecId;var title=_react2.default.createElement("div",{className:"text-elli",style:{paddingRight:25},title:item.title||item.name,ecId:ecId+"_div@n2owz6@"+(item.title||item.name)},item.displayName||item.name);if(item.displayType=="portrait"){var requestParams=void 0;try{if(item.requestParams){requestParams=JSON.parse(item.requestParams);}}catch(e){}title=_react2.default.createElement("div",{className:"text-elli",style:{height:34}},_react2.default.createElement(_weaAvatar2.default,{ecId:ecId+"_WeaAvatar@koc9pl@"+item.id,style:{width:26,height:26,borderRadius:15,padding:"1px"},userId:item.id,key:item.id,requestParams:requestParams}),_react2.default.createElement("span",{style:{paddingLeft:10,verticalAlign:"top"},title:item.displayName||item.name},item.displayName||item.name));}if(renderNode){title=renderNode(item);}if(renderItem){title=renderItem(item);}title=_react2.default.createElement("div",{"class":"wea-tree-node-wrapper text-elli"},title,_this6.renderOps(item));if(item.displayType=="add"){title=_react2.default.createElement("div",{"class":"wea-tree-node-wrapper"},_react2.default.createElement(_weaInputNormal2.default,{ecId:ecId+"_WeaInput@g9w1hq",ref:"input",style:{width:150},onBlur:function onBlur(v){return _this6.addHandler(v,item);}}));}if(item.displayType=="edit"){title=_react2.default.createElement("div",{"class":"wea-tree-node-wrapper"},_react2.default.createElement(_weaInputNormal2.default,{ecId:ecId+"_WeaInput@wwzkdy",ref:"input",style:{width:150},value:item.name,onBlur:function onBlur(v){return _this6.editHandler(v,item);}}));}return title;};this.getTree=function(datas){return _react2.default.createElement(_ScrollTree2.default,(0,_extends3.default)({},_this6.props,_this6.state,{ecId:_this6.props.ecId+"_ScrollTree@clhz3h",itemMainKey:_this6.props.isOrg?"nodeid":_this6.props.itemMainKey,datas:datas,getTitle:_this6.getTitle,onCheck:_this6.onCheck,onRadioCheck:_this6.onRadioCheck,onExpand:_this6.expandTreeNode,onSelect:function onSelect(node,e){return _this6.onSelect([node[_this6.props.itemMainKey]],e,node);}}));};},_temp);exports.default=WeaTree;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);__webpack_require__(680);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaDropdown=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 966));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});WeaDropdown.ButtonSelect=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 967));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaDropdown;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(684);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import middleware from "../../middleware";
var WeaCascader=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 948));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});WeaCascader.WeaCustomField=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 983));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});// const Com = middleware(WeaCascader, "WeaCascader");
exports.default=WeaCascader;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Browser=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 970));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var Upload=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 949));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var BrowserList=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 972));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var At=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 973));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var WordImport=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 974));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var ImageUpload=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 975));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var VideoUpload=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 976));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var MapLocation=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 977));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var FormatAll=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 979));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default={Browser:Browser,Upload:Upload,BrowserList:BrowserList,At:At,WordImport:WordImport,ImageUpload:ImageUpload,VideoUpload:VideoUpload,MapLocation:MapLocation,FormatAll:FormatAll};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class2,_temp2;var _$=__webpack_require__(196);var _$2=_interopRequireDefault(_$);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(38);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _antd=__webpack_require__(8);var _callApi=__webpack_require__(17);var _emTools=__webpack_require__(298);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);var _Encry=__webpack_require__(51);var _weaQrcode=__webpack_require__(299);var _weaQrcode2=_interopRequireDefault(_weaQrcode);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _weaAlertPage=__webpack_require__(201);var _weaAlertPage2=_interopRequireDefault(_weaAlertPage);var _util=__webpack_require__(300);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _weaTextareaAuth=__webpack_require__(125);var _weaTextareaAuth2=_interopRequireDefault(_weaTextareaAuth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var win=_window2.default.getTop();if(window.location.href.indexOf("em_auth_userid")>=0){win=window;}var doc=win.document;var bodyWrap=doc.createElement("div");bodyWrap.id="wea_popover_hrm_inbody";doc.body.appendChild(bodyWrap);var instances=[];var wrap=null;var target=null;var props={inDialog:false,hasParent:false,// 接口
userid:"",userinfo:"",fieldInfo:"",validate:{},emJoinStatus:window.emJoinStatus||{},bigImgWidth:142,bigImgHeight:274,// 内部
// visible: false,
showSQR:false,loading:true,imgLoading:false,showBigImg:false,hasRight:true,// 定位
x:-1000,y:-1000,targetHeight:0,targetWidth:0,pWidth:0,pHeight:0,pTop:0,pLeft:0,winW:doc.body.clientWidth,winH:doc.body.clientHeight};var getInstances=function getInstances(){var instance=instances.filter(function(_ref){var p=_ref.p,c=_ref.c;return p.isEqualNode(wrap);});if(instance.length===1)return instance[0];return null;};var getParentStyle=function getParentStyle(){var wraps=(0,_$2.default)(target).closest(".wea-popover-hrm-relative-parent");props.inDialog=false;if(wraps.length===1){wrap=wraps[0];if(!getInstances()){instances.push({p:wrap,c:null});}props.hasParent=true;props.pWidth=wraps.width();props.pHeight=wraps.height();props.pTop=wraps.offset().top;props.pLeft=wraps.offset().left;var dialog=wraps.closest(".ant-modal-body");if(dialog.length===1){props.inDialog=true;wrap=bodyWrap;if(!getInstances()){instances.push({p:wrap,c:null});}props.pWidth=0;props.pHeight=0;props.pTop=0;props.pLeft=0;}}else{wrap=bodyWrap;if(!getInstances()){instances.push({p:wrap,c:null});}props.pWidth=0;props.pHeight=0;props.pTop=0;props.pLeft=0;}};var Card=function(_React$Component){(0,_inherits3.default)(Card,_React$Component);function Card(){var _ref2;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Card);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref2=Card.__proto__||(0,_getPrototypeOf2.default)(Card)).call.apply(_ref2,[this].concat(args))),_this),_this.state={visible:false},_this.onResize=function(){getParentStyle();_this.forceUpdate();},_this.handleHashChange=function(){_this.setState({visible:false});// props.visible = false;
// this.forceUpdate();
},_this.clickHandle=function(e){if(!e.target.isEqualNode(target)&&(0,_$2.default)(_this.refs.wea_popover_hrm_card).find(e.target).length===0){// 点击的不是触发节点 && 节点不在当前卡片上
_this.setState({visible:false});// props.visible = false;
// this.forceUpdate();
}},_this.onLoad=function(e){var bigImgWidth=e.target.naturalWidth||142;var bigImgHeight=e.target.naturalHeight||274;// 图片防压缩处理
if(_this.smallImg&&bigImgWidth/bigImgHeight!==2/3){var stl=_this.smallImg.getAttribute("style");var newStl=bigImgWidth/bigImgHeight>2/3?"width:100%;height:auto;":"height:100%;width:auto;";_this.smallImg.setAttribute("style",stl?stl+";"+newStl:newStl);}props=(0,_extends3.default)({},props,{bigImgWidth:bigImgWidth,bigImgHeight:bigImgHeight});_this.forceUpdate();},_this.onError=function(){if(props.userinfo){props.userinfo.userimg=_util.defaultIcon[props.userinfo.sex];_this.forceUpdate();}},_this.onPopoverHrmCusBtnClick=function(type){var _props=props,userid=_props.userid;(0,_emTools.getEmAudioOrVideo)(userid,type==="voice"?1:2,function(){_this.setState({visible:false,showGroupModal:false});});},_this.getThemeThemeInfoCls=function(){var themeThemeInfo=window.localStorage["theme-themeInfo"];var languageidweaver=window.localStorage["languageidweaver"];var themeThemeInfoCls="";if(themeThemeInfo&&languageidweaver!="7"){themeThemeInfo=JSON.parse(themeThemeInfo);var themeFontSize=themeThemeInfo.themeFontSize||"12";themeThemeInfoCls="wea-popover-hrm-info-en-f"+themeFontSize;}return themeThemeInfoCls;},_this.getTitle=function(value){if((0,_Encry.desensitization)(value)){// value = ENCRYPTION_CODE;
value="";}else if((0,_Encry.encryption)(value)){// value = replaceEncryption(value);
value="";}return value;},_this.getValue=function(value){if((0,_Encry.desensitization)(value)){return _react2.default.createElement(_weaTextareaAuth2.default,{style:{display:"inline-block"},ecId:(_this.props.ecId||"")+"_WeaTextareaAuth@1m5zxf",value:value});}else if((0,_Encry.encryption)(value)){value=(0,_Encry.replaceEncryption)(value);}return value;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Card,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.timer=setTimeout(function(){_this2.setState({visible:true});//   props.visible = true;
//   this.forceUpdate();
if(_this2.timer){clearTimeout(_this2.timer);}},100);window.document.addEventListener("click",this.clickHandle);window.addEventListener("resize",this.onResize);window.addEventListener("hashchange",this.handleHashChange);if(win!==window){doc.addEventListener("click",this.clickHandle);win.addEventListener("resize",this.onResize);win.addEventListener("hashchange",this.handleHashChange);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.timer){clearTimeout(this.timer);}window.document.removeEventListener("click",this.clickHandle);window.removeEventListener("resize",this.onResize);window.removeEventListener("hashchange",this.handleHashChange);if(win!==window){doc.removeEventListener("click",this.clickHandle);win.removeEventListener("resize",this.onResize);win.removeEventListener("hashchange",this.handleHashChange);}}},{key:"render",value:function render(){var _this3=this;var _props2=this.props,className=_props2.className,style=_props2.style;var _props3=props,userid=_props3.userid,userinfo=_props3.userinfo,fieldInfo=_props3.fieldInfo,showSQR=_props3.showSQR,x=_props3.x,y=_props3.y,targetHeight=_props3.targetHeight,loading=_props3.loading,imgLoading=_props3.imgLoading,pTop=_props3.pTop,pLeft=_props3.pLeft,winW=_props3.winW,winH=_props3.winH,validate=_props3.validate,showBigImg=_props3.showBigImg,bigImgWidth=_props3.bigImgWidth,bigImgHeight=_props3.bigImgHeight,emJoinStatus=_props3.emJoinStatus,hasRight=_props3.hasRight,hasParent=_props3.hasParent,inDialog=_props3.inDialog;var _emJoinStatus=emJoinStatus?window.emJoinStatus:{};var visible=this.state.visible;var _pLeft=pLeft||0;var _pTop=pTop||0;var gender={"Mr.":""+getLabel("28473","男"),"Ms.":""+getLabel("28474","女")};var sex={"Mr.":"icon-coms-men","Ms.":"icon-coms-women"};// Dialog dragable using translate, so position fixed & top + 50(title)
var nowStyle=hasParent?{// display: visible ? 'block' : 'none',
// opacity: visible ? 1 : 0,
position:inDialog?"fixed":"absolute",left:winW-x<=450?winW-450:x-_pLeft,top:winH-y<=280?y-280-_pTop:y+targetHeight-_pTop}:{// display: visible ? 'block' : 'none',
// opacity: visible ? 1 : 0,
position:"fixed",left:winW-x<=450?winW-450:x,top:winH-y<=280?y-280:y+targetHeight};nowStyle.transformOrigin=(x-_pLeft-nowStyle.left)/424*100+"% "+(y<=nowStyle.top+_pTop?0:"100%");var bigHeight=bigImgHeight>winH*0.8?winH*0.8:bigImgHeight;var bigWidth=bigHeight*bigImgWidth/bigImgHeight;var bigImgStyle=showBigImg?{width:bigWidth,height:bigHeight,left:nowStyle.left+bigWidth>=winW-(hasParent?_pLeft:0)?winW-(hasParent?_pLeft:0)-bigWidth-nowStyle.left-20:bigWidth>142?(bigWidth-142)/2>nowStyle.left+_pLeft?-(nowStyle.left+_pLeft-20):(142-bigWidth)/2:-2,top:nowStyle.top+bigHeight>=winH-(hasParent?_pTop:0)?winH-(hasParent?_pTop:0)-bigHeight-nowStyle.top-20:bigHeight>214?(214-bigHeight)/2:-2,opacity:1,transformOrigin:"50% 50%",transition:"all .3s cubic-bezier(.645,.045,.355,1)"}:{width:"100%",height:"100%",left:0,top:0,opacity:0,transition:"all .2s cubic-bezier(.645,.045,.355,1)"};var cls=(0,_classnames2.default)(className,"wea-popover-hrm-wrapper","wea-popover-hrm-wrapper-"+(visible?"show":"hide"));var themeThemeInfoCls=this.getThemeThemeInfoCls();var defaultRightInfo=_react2.default.createElement("div",{className:"wea-popover-hrm-info "+(window.localStorage["languageidweaver"]!="7"&&"wea-popover-hrm-info-en")+" "+themeThemeInfoCls},_react2.default.createElement("p",null,_react2.default.createElement("span",{title:getLabel("27511","部门")},getLabel("27511","部门"),":"),_react2.default.createElement("a",{href:(window.ecologyContentPath||"")+"/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=department&id="+userinfo.departmentid,target:"_blank"// className='text-elli'
,title:this.getTitle(userinfo.departmentName)},this.getValue(userinfo.departmentName))),_react2.default.createElement("p",null,_react2.default.createElement("span",{title:getLabel("33553","分部")},getLabel("33553","分部"),":"),_react2.default.createElement("a",{href:(window.ecologyContentPath||"")+"/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=subcompany&id="+userinfo.subcompanyid1,target:"_blank",title:this.getTitle(userinfo.subcompanyName)},this.getValue(userinfo.subcompanyName))),_react2.default.createElement("p",null,_react2.default.createElement("span",{title:getLabel("6086","岗位")},getLabel("6086","岗位"),":"),_react2.default.createElement("a",{href:(window.ecologyContentPath||"")+"/spa/hrm/engine.html#/hrmengine/posts?id="+userinfo.jobtitle,target:"_blank",title:this.getTitle(userinfo.jobtitleName)},this.getValue(userinfo.jobtitleName))),_react2.default.createElement("p",null,_react2.default.createElement("span",{title:getLabel("596","上级")},getLabel("596","上级"),":"),_react2.default.createElement("a",{href:(window.ecologyContentPath||"")+"/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/"+userinfo.managerid,target:"_blank",title:this.getTitle(userinfo.managerName)},this.getValue(userinfo.managerName))),_react2.default.createElement("p",null,_react2.default.createElement("span",{title:getLabel("23247","状态")},getLabel("23247","状态"),":"),_react2.default.createElement("span",{title:this.getTitle(userinfo.statusName)},this.getValue(userinfo.statusName))),_react2.default.createElement("p",null,_react2.default.createElement("span",{title:getLabel("422","手机")},getLabel("422","手机"),":"),_react2.default.createElement("span",{title:this.getTitle(userinfo.mobile)},this.getValue(userinfo.mobile))),_react2.default.createElement("p",null,_react2.default.createElement("span",{title:getLabel("421","电话")},getLabel("421","电话"),":"),_react2.default.createElement("span",{title:this.getTitle(userinfo.telephone)},this.getValue(userinfo.telephone))),_react2.default.createElement("p",null,_react2.default.createElement("span",{title:getLabel("71","邮件")},getLabel("71","邮件"),":"),_react2.default.createElement("span",{title:this.getTitle(userinfo.email)},this.getValue(userinfo.email))));if(fieldInfo){var infoList=[];var _style={};if(fieldInfo.length<8){var extHeight=(8-fieldInfo)*25;_style={marignTop:Math.floor(extHeight/fieldInfo.length)};}fieldInfo.forEach(function(element){infoList.push(_react2.default.createElement("p",{style:_style},_react2.default.createElement("span",{title:element.fieldlabel},element.fieldlabel,":"),element.linkurl?_react2.default.createElement("a",{href:element.linkurl,target:"_blank",title:_this3.getTitle(element.fieldvalue)},_this3.getValue(element.fieldvalue)):_react2.default.createElement("span",{title:_this3.getTitle(element.fieldvalue)},_this3.getValue(element.fieldvalue))));});defaultRightInfo=_react2.default.createElement("div",{className:"wea-popover-hrm-info "+(window.localStorage["languageidweaver"]!="7"&&"wea-popover-hrm-info-en")+" "+themeThemeInfoCls},infoList);}var showSendMsgBtn=(0,_typeof3.default)(validate.hasEmessage)==="object"&&"isValidate"in validate.hasEmessage?validate.hasEmessage.isValidate:_emJoinStatus.status&&_emJoinStatus.joinStatus&&_emJoinStatus.emSwitch!=="0";return _react2.default.createElement("div",{ref:"wea_popover_hrm_card",className:cls,style:(0,_extends3.default)({},nowStyle,style)},_react2.default.createElement("i",{title:"关闭",className:"icon-coms-Clear",onClick:function onClick(e){props=(0,_extends3.default)({},props,{// visible: false,
showBigImg:false,showSQR:false});_this3.state.visible=false;_this3.forceUpdate();e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();}}),_react2.default.createElement(_antd.Spin,{spinning:loading},hasRight?window.renderPopoverHrmContent?window.renderPopoverHrmContent((0,_extends3.default)({},props)):userinfo?_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{className:"wea-popover-hrm-left"},_react2.default.createElement("div",{className:"wea-popover-hrm-left-img-wrap"},_react2.default.createElement("div",{className:"wea-popover-hrm-left-img-wrap-small"},_react2.default.createElement("img",{ref:function ref(_ref3){return _this3.smallImg=_ref3;},className:"wea-popover-hrm-userimg wea-popover-hrm-userimg-small",alt:"",src:imgLoading?"/images/messageimages/temp/loading_wev8.gif":userinfo.userimg,onError:this.onError,onLoad:this.onLoad,onClick:function onClick(){if(!imgLoading){props.showBigImg=true;_this3.forceUpdate();}}})),_react2.default.createElement("img",{alt:"",className:"wea-popover-hrm-userimg "+(showBigImg?"wea-popover-hrm-userimg-big":""),style:bigImgStyle,src:userinfo.userimg,onClick:function onClick(){if(!imgLoading){props.showBigImg=!showBigImg;_this3.forceUpdate();}},onError:this.onError}),_react2.default.createElement("div",{className:"wea-popover-hrm-sqr",style:{display:showSQR?"block":"none"}},_react2.default.createElement(_weaQrcode2.default,{text:(0,_util.createQRCode)(userinfo),size:105,level:"L"}),_react2.default.createElement("p",null,getLabel("385903","扫描添加联系人"))),validate[37]&&validate[37].isValidate?_react2.default.createElement("div",{className:"wea-popover-hrm-left-corner",title:showSQR?getLabel("1290","返回"):validate[37].validateName,onClick:function onClick(e){props.showSQR=!showSQR;_this3.forceUpdate();// 暂时未测出哪个管用。。
e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();}},_react2.default.createElement("i",{className:"icon-coms-"+(showSQR?"Revoke2":"Scan")})):null,window.showPopoverHrmCusBtn&&_react2.default.createElement("div",{className:"wea-popover-hrm-left-video"},_react2.default.createElement("div",{className:"wea-popover-hrm-left-video-item",onClick:function onClick(){return _this3.onPopoverHrmCusBtnClick("voice");}},_react2.default.createElement("div",{className:"wea-popover-hrm-left-video-item-content"},_react2.default.createElement("i",{className:"icon-coms02-coms-voice"}))),_react2.default.createElement("div",{className:"wea-popover-hrm-left-video-item",onClick:function onClick(){return _this3.onPopoverHrmCusBtnClick("video");}},_react2.default.createElement("div",{className:"wea-popover-hrm-left-video-item-content"},_react2.default.createElement("i",{className:"icon-coms02-coms-Video"}))))),_react2.default.createElement("div",{className:"wea-popover-hrm-left-btns"},showSendMsgBtn?_react2.default.createElement("span",{className:"wea-popover-hrm-left-btns-btn",onClick:function onClick(){return(0,_util.sendMsgToPC)(userid,0,"","");}},_react2.default.createElement("i",{className:"icon-coms-Send-message",title:validate.hasEmessage.validateName})):null,validate[31]&&validate[31].isValidate?_react2.default.createElement("span",{className:"wea-popover-hrm-left-btns-btn"},_react2.default.createElement("i",{className:"icon-coms-message-o",title:validate[31].validateName,onClick:function onClick(){return window.open((window.ecologyContentPath||"")+"/spa/smallApp/static/index.html#/main/sms/SendSms?hrmid="+userid);}})):null,validate[19]&&validate[19].isValidate?_react2.default.createElement("span",{className:"wea-popover-hrm-left-btns-btn"},_react2.default.createElement("i",{className:"icon-coms-Send-emails",title:validate[19].validateName,onClick:function onClick(){return window.open((window.ecologyContentPath||"")+"/spa/email/static/index.html#/main/email/new?fromPage=hrmCard&internaltonew="+(0,_stringify2.default)([{id:userid,type:"resource"}]));}})):null,validate[32]&&validate[32].isValidate?_react2.default.createElement("span",{className:"wea-popover-hrm-left-btns-btn"},_react2.default.createElement("i",{className:"icon-coms-New-schedule-o",title:validate[32].validateName,onClick:function onClick(){return window.open((window.ecologyContentPath||"")+"/spa/workplan/static/index.html#/main/wp/workPlanCreateSingle?type=create&selectedUser="+userid);}})):null)),_react2.default.createElement(_antd.Col,{className:"wea-popover-hrm-right"},_react2.default.createElement("div",{className:"wea-popover-hrm-title"},_react2.default.createElement("a",{href:(window.ecologyContentPath||"")+"/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/"+userid,title:userinfo.lastname,target:"_blank",className:"wea-f14",style:{color:"#2db7f5"}},userinfo.lastname),_react2.default.createElement("em",{title:""+gender[userinfo.sex],className:sex[userinfo.sex]}),_react2.default.createElement("span",{title:this.getTitle(userinfo.workcode)},this.getValue(userinfo.workcode))),_react2.default.createElement(_weaNewScroll2.default,{height:205},defaultRightInfo),_react2.default.createElement("div",{className:"wea-popover-hrm-bottom"},userinfo.isOnline&&userinfo.ip?[_react2.default.createElement("span",{className:"wea-popover-hrm-info-online"}),userinfo.ip]:null))):_react2.default.createElement("div",{style:{width:428,height:274}}):_react2.default.createElement(_weaAlertPage2.default,null,_react2.default.createElement("p",null,getLabel(2012,"对不起，您暂时没有权限！")))));}}]);return Card;}(_react2.default.Component);window.pointerXY=function(e){target=e.target;getParentStyle();var middle=wrap.querySelector(".wea-popover-hrm-middle");if(!middle){middle=doc.createElement("div");middle.className="wea-popover-hrm-middle";wrap.appendChild(middle);}var iframeOffsetX=0;var iframeOffsetY=0;var iframeOffset=(0,_$2.default)(window.frameElement).offset();if(window.frameElement){iframeOffsetX=iframeOffset.left;iframeOffsetY=iframeOffset.top;}props.x=(0,_$2.default)(e.target).offset().left+iframeOffsetX;props.y=(0,_$2.default)(e.target).offset().top+iframeOffsetY;props.targetWidth=e.target.offsetWidth;props.targetHeight=e.target.offsetHeight;props.winW=doc.body.clientWidth;props.winH=doc.body.clientHeight;var instance=getInstances();if(instance.c){instance.c.state.visible=true;// props.visible = true;
}(0,_reactDom.render)(_react2.default.createElement(Card,{ref:function ref(el){instance.c=el;}}),middle);e.stopPropagation&&e.stopPropagation();};var times=0;var timer=null;window.openhrm=function(id){timer=setTimeout(function(){var instance=getInstances();if(props.userid!==id){var oldTimes=times;var initStates={loading:true,imgLoading:true,userid:id,userinfo:"",fieldInfo:"",showBigImg:false};props=(0,_extends3.default)({},props,initStates);instance&&instance.c&&instance.c.forceUpdate();times++;(0,_callApi.callApi)("/api/hrm/simpleinfo/getHrmSimpleInfo","GET",{userid:id}).then(function(res){var newState={loading:false,hasRight:true};props=(0,_extends3.default)({},props,newState);if(instance&&instance.c){if(res.status=="1"){var insNow=getInstances();if(oldTimes+1===times&&insNow.p.isEqualNode(instance.p)){if(res.hasRight===false||res.hasRight==="false"){newState=(0,_extends3.default)({},newState,{hasRight:false});}else{var userinfo=res.simpleInfo,validate=res.validate,fieldInfo=res.fieldInfo;userinfo.userimg=validate[36]&&validate[36].isValidate&&userinfo.messageUrls?userinfo.messageUrls:_util.defaultIcon[userinfo.sex];var img=new Image();img.onload=img.onerror=function(){props.imgLoading=false;instance.c.forceUpdate();};img.src=userinfo.userimg;newState=(0,_extends3.default)({},newState,{userinfo:userinfo,validate:validate,fieldInfo:fieldInfo||""});}props=(0,_extends3.default)({},props,newState);instance.c.forceUpdate();}else{instance.c.setState({visible:false});}}else{_antd.message.error("人力卡片接口错误！");instance.c.forceUpdate();}}});}else if(instance&&instance.c){props.loading=false;instance.c.forceUpdate();}timer&&clearTimeout(timer);},0);};var WeaPopoverHrm=(_temp2=_class2=function(_React$Component2){(0,_inherits3.default)(WeaPopoverHrm,_React$Component2);function WeaPopoverHrm(){(0,_classCallCheck3.default)(this,WeaPopoverHrm);return(0,_possibleConstructorReturn3.default)(this,(WeaPopoverHrm.__proto__||(0,_getPrototypeOf2.default)(WeaPopoverHrm)).apply(this,arguments));}(0,_createClass3.default)(WeaPopoverHrm,[{key:"render",value:function render(){var _props4=this.props,children=_props4.children,className=_props4.className,style=_props4.style;if(!children){return null;}return _react2.default.createElement("div",{className:"wea-popover-hrm-relative-parent "+(className||""),style:style,onClick:function onClick(e){e.stopPropagation&&e.stopPropagation();}},children||null);}}]);return WeaPopoverHrm;}(_react2.default.Component),_class2.sendMsgToPC=_util.sendMsgToPC,_class2.Card=Card,_temp2);var Com=(0,_middleware2.default)(WeaPopoverHrm,"WeaPopoverHrm");exports.default=Com;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;// 橡皮擦
var dotSizeErase={xxs:16.0,xs:16.0,sm:32.0,md:32.0,lg:48.0,xl:48.0};// 笔触
var dotsize={xxs:2.0,xs:3.0,sm:5.0,md:6.0,lg:9.0,xl:10.0};// 手写模式笔触
var dotsizemin={xxs:1,xs:1.2,sm:1.4,md:1.6,lg:1.8,xl:2};// 笔触尺寸
var brushs=["xxs","xs","sm","md","lg","xl"];// 功能按钮
var getExtraBtns=function getExtraBtns(){return[{key:"newLine",icon:"icon-coms-huanhang",name:getLabel(126869,"换行")},{key:"eraser",icon:"icon-coms-xiangpi",name:getLabel(513962,"橡皮擦")},{key:"cancel",icon:"icon-coms-Revoke2",name:getLabel(23757,"撤销")},{key:"clear",icon:"icon-coms-delete",name:getLabel(500578,"清空")}];};//字体颜色
var normalColors=["#000","#f44483","#ba58d1","#2e6fd1","#da4045","#70bc99","#00a661","#da4044","#d53365","#de3b99","#7e57bb","#2989ad","#54c9f4","#67d8b6","#f9c95f","#fe475d","#8269d9","#c9ae00","#ff8015","#f73a53","#c7436f","#dda1f2","#8d7ee2","#8aafdd"];exports.default={dotsize:dotsize,dotsizemin:dotsizemin,brushs:brushs,extraBtns:getExtraBtns(),normalColors:normalColors,dotSizeErase:dotSizeErase};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(48) && !__webpack_require__(69)(function () {
  return Object.defineProperty(__webpack_require__(157)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(58);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(61);
var toIObject = __webpack_require__(59);
var arrayIndexOf = __webpack_require__(391)(false);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(29).document;
module.exports = document && document.documentElement;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(61);
var toObject = __webpack_require__(70);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(44);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(73);
var ITERATOR = __webpack_require__(30)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(44);
var aFunction = __webpack_require__(105);
var SPECIES = __webpack_require__(30)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(68);
var invoke = __webpack_require__(396);
var html = __webpack_require__(222);
var cel = __webpack_require__(157);
var global = __webpack_require__(29);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(92)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(44);
var isObject = __webpack_require__(53);
var newPromiseCapability = __webpack_require__(163);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(30)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 232 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(409);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(112),
    nativeKeys = __webpack_require__(446);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(174),
    arraySome = __webpack_require__(340),
    cacheHas = __webpack_require__(175);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(41);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(242),
    getSymbols = __webpack_require__(178),
    keys = __webpack_require__(85);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(177),
    isArray = __webpack_require__(21);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 243 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(485),
    isArguments = __webpack_require__(113),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(114),
    isIndex = __webpack_require__(179),
    isTypedArray = __webpack_require__(170);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(149);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ssoLogout=exports.checkCustomSSO=exports.checkSSO=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _loadjs=__webpack_require__(54);var _loadjs2=_interopRequireDefault(_loadjs);var _getUrlParams=__webpack_require__(248);var _getUrlParams2=_interopRequireDefault(_getUrlParams);var _callApi=__webpack_require__(17);var caUtil=_interopRequireWildcard(_callApi);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);var _getOsInfo=__webpack_require__(249);var _getOsInfo2=_interopRequireDefault(_getOsInfo);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var callApi=caUtil.callApi;var checkSSO=exports.checkSSO=function checkSSO(path){var checkCustom=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return new _promise2.default(function(rs,rj){if(!window.ssoChecked&&!window.isAdminIndex){if(/.*em_auth_code.*/.test(window.location.href)){if(window.ssoChecking){var interval=setInterval(function(){if(window.ssoChecking){return;}else{clearInterval(interval);rs();}},500);}else{var params=(0,_getUrlParams2.default)();window.ssoChecking=true;callApi("/api/ec/dev/app/test","GET",(0,_extends3.default)({em_auth_code:params["em_auth_code"],em_auth_userid:params["em_auth_userid"],timeZoneOffset:new Date().getTimezoneOffset()},params)).then(function(res){window.ssoChecked=true;window.ssoChecking=false;if(res.emaccesstk){window.localStorage["emaccesstk"]=res.emaccesstk;}if(res.languageType){window.localStorage["languageidweaver"]=res.languageType;}if(!res.status){window.location.href=""+(window.ecologyContentPath||"")+"/wui/index.html";rs();}else{var initEm=function initEm(res,rs){setTimeout(function(){//init emobile config
if(window.em){em.config({corpId:res.em_corpid,//必填，企业的corpId
appId:""// 非必填，应用ID
});em.ready(function(){window.localStorage.emobile_ec_id=res.ec_id;em.setPageReload({setvalue:2,// 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
success:function success(res){// 如：{"errMsg":"setHoldPage:ok"}
//alert(res.errMsg);
}});});(0,_getOsInfo2.default)(function(){rs();});}},100);};var timestamp=new Date().getTime();var emUrl=res.em_url_open+"/open/js/jem.js?_key="+timestamp;if(/wxExternalAddressEnable=1/.test(window.location.href)||window.localStorage["wxExternalAddressEnable"]=="1"){emUrl=window.location.protocol+"//"+window.location.host+"/open/js/jem.js?_key="+timestamp;window.localStorage["wxExternalAddressEnable"]="1";}_loadjs2.default.isDefined("em")?_loadjs2.default.ready("em",initEm.bind(undefined,res,rs)):(0,_loadjs2.default)(emUrl,"em",initEm.bind(undefined,res,rs));}});}}else{if(checkCustom){if(!window.e9ecComConfig){if(window.e9ssoPCConfig&&window.e9ssoPCConfig.inUse&&window.e9ssoPCConfig.customInit){window.e9ssoPCConfig.customInit().then(function(){checkCustomSSO(path).then(function(){(0,_getOsInfo2.default)(function(){rs();});});});}else{checkCustomSSO(path).then(function(){(0,_getOsInfo2.default)(function(){rs();});});}}else{if(window.e9ssoPCConfig&&window.e9ssoPCConfig.inUse&&window.e9ssoPCConfig.customInit){window.e9ssoPCConfig.customInit().then(function(){checkCustomSSO(path).then(function(){(0,_getOsInfo2.default)(function(){rs();});});});}else{checkCustomSSO(path).then(function(){(0,_getOsInfo2.default)(function(){rs();});});}}}else{(0,_getOsInfo2.default)(function(){rs();});}}}else{(0,_getOsInfo2.default)(function(){rs();});}});};var checkCustomSSO=exports.checkCustomSSO=function checkCustomSSO(path){return new _promise2.default(function(rs,rj){if(!window.ssoCustomChecked&&!window.isAdminIndex){window.ssoCustomChecked=true;if(window.customSSOConfig){if(window.customSSOConfig.inUse){var params=(0,_getUrlParams2.default)();var checkSessionParams={};if(window.customSSOConfig.sessionCheckApiParams){var sessionParams=window.customSSOConfig.sessionCheckApiParams.split(",");sessionParams.forEach(function(element){checkSessionParams[element]=params[element];});}callApi(window.customSSOConfig.sessionCheckApi,window.customSSOConfig.sessionCheckApiType||"GET",checkSessionParams).then(function(res){if(res.status&&!res.hasSession){var getQueryVariable=function getQueryVariable(variable){var query=window.location.search.substring(1);var vars=query.split("&");for(var i=0;i<vars.length;i++){var pair=vars[i].split("=");if(pair[0]==variable){return pair[1];}}return false;};var servicePath=path||window.location.pathname+window.location.search+window.location.hash;if(/\/wui\/index\.html\#\/\?/.test(servicePath)){servicePath="/wui/index.html#/main";}if(/\/spa\/portal\/public\/index\.html#\/licensesubmit\?display=page/.test(window.location.href)){rs();}var service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?path="+encodeURIComponent(servicePath);if(getQueryVariable("languid")){service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?languid="+getQueryVariable("languid")+"&path="+encodeURIComponent(servicePath);}var paramsMark="?";if(window.customSSOConfig.serverLoginUrl.indexOf("?")!==-1){paramsMark="&";}window.localStorage["casPath"]=""+window.customSSOConfig.serverLoginUrl+paramsMark+"service="+encodeURIComponent(service);window.location.href=""+window.customSSOConfig.serverLoginUrl+paramsMark+"service="+encodeURIComponent(service);// window.location.href = service;
rs();}else{if(res.status&&res.hasSession){if(/.*\/login\/OALogin\.jsp.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index(-admin)?\.html.*#\/\?.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index(-admin)?\.html$/.test(_window2.default.getTop().location.href)){// 第三方集成登录的场景下 登录页如果系统session还未清除 则自动跳转
_window2.default.getTop().location.href=""+(window.ecologyContentPath||"")+"/wui/index.html#/main";}}(0,_getOsInfo2.default)(function(){rs();});}});}else{(0,_getOsInfo2.default)(function(){rs();});}}else{(0,_getOsInfo2.default)(function(){rs();});}}else{(0,_getOsInfo2.default)(function(){rs();});}});};var ssoLogout=exports.ssoLogout=function ssoLogout(logoutRes){if(window.eventRegister.list["emLogoutEvent"]){window.eventRegister.startList("emLogoutEvent",function(){// success
},function(){// fail
});}else{getLogoutUrl(logoutRes);}};var getLogoutUrl=function getLogoutUrl(logoutRes,isEngine){if(logoutRes.status==true){if(window.customSSOConfig&&window.customSSOConfig.inUse){if(window.customSSOConfig.serverLogoutUrl){if(window.customSSOConfig.serverLogoutAjax){// TODO
}else{window.location.href=window.customSSOConfig.serverLogoutUrl;}}else{if(window.weaHistory&&location.href.indexOf("engine.html")==-1){window.weaHistory.push({pathname:"/"});}else{window.location.href=""+(window.ecologyContentPath||"")+"/wui/index.html";}}}else{if(logoutRes.casLogoutUrl){var split="?";if(logoutRes.casLogoutUrl.indexOf("?")>-1){split="&";}window.location.href=logoutRes.casLogoutUrl+split+"e9timestamp="+new Date().getTime();}else{if(window.weaHistory&&location.href.indexOf("engine.html")==-1){window.weaHistory.push({pathname:"/"});}else{window.location.href=""+(window.ecologyContentPath||"")+"/wui/index.html";}}}}};window.onLogoutCallback=function(){window.localStorage["e9_locale"]=null;window.ssoChecked=false;window.e9_locale=null;if(window.emClient){emClient.logout();}};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function getFrameParams(){var url=window.location.href;var urlParams=url.slice(url.indexOf('?')+1).split('&');var params=[];urlParams.forEach(function(element){var datas=element.split('=');params[datas[0]]=datas[1];});return params;}module.exports=getFrameParams;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _callApi=__webpack_require__(17);var _storage=__webpack_require__(60);function getOs(cb){(0,_callApi.callApi)("/api/system/info/getOSinfo","GET",{}).then(function(res){if(res.status){_storage.ls.set("getOsInfo",res);var defaultLinkMode=res.defaultLinkMode,dragColumns=res.dragColumns,uploadSuffixLimit=res.uploadSuffixLimit,prohibitDownload=res.prohibitDownload,languageVersion=res.languageVersion;if(res.languageType){window.localStorage["languageidweaver"]=res.languageType;}window.localStorage.setItem("ec_open_rewrite",defaultLinkMode);window.localStorage.setItem("dragColumns_WeaTable",dragColumns);window.localStorage.setItem("uploadSuffixLimit",uploadSuffixLimit);window.localStorage.setItem("prohibitDownload",prohibitDownload);window.localStorage.setItem("languageVersion",languageVersion);}var browserConfig=res.browserConfig;if(browserConfig){var timeInterval=browserConfig.timeInterval,typeList=browserConfig.typeList,defaultPageSize=browserConfig.defaultPageSize,pageConfigList=browserConfig.pageConfigList,defaultCountry=browserConfig.defaultCountry;// 保存浏览按钮的设置
window.ecBrowserConfig=browserConfig;// 获取浏览按钮显示设置
window.ecBrowserDisplayStyle=typeList||[];// 获取系统时间间隔设置
window.ecTimePickerMinuteStep=timeInterval||1;// 获取浏览按钮默认显示条数
window.ecBrowserDisplayPageSize=defaultPageSize||10;// 获取浏览按钮显示条数配置
window.ecBrowserDisplayConfigList=pageConfigList||[];// 获取城市浏览框默认国家配置
window.ecBrowserDefaultCountry=defaultCountry;}cb();}).catch(function(err){// window.console && window.console.log('err: ', err);
});// window.localStorage.removeItem("ec_open_rewrite");
}module.exports=getOs;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _class,_temp,_initialiseProps;var _callApi=__webpack_require__(17);var caUtil=_interopRequireWildcard(_callApi);var _html2image=__webpack_require__(251);var _userAgent=__webpack_require__(121);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var callApi=caUtil.callApi;var instance=null;var getHash=function getHash(){return Math.random().toString(36).substr(2,6);};var WaterMark=(_temp=_class=function WaterMark(options){(0,_classCallCheck3.default)(this,WaterMark);_initialiseProps.call(this);var win=this.getWindow(options);if(win.e9WatermarkLoaded)return;win.e9WatermarkLoaded=true;this.loaded=true;this.updateOptions(options);}// 检测options是否有修改
// 判断重新生成dom条件
,_initialiseProps=function _initialiseProps(){var _this=this;this.type="text";this.len=0;this.html="";this.timer=null;this.destoryed=false;this.wrapId="wea_watermark_wrap";this.prefixCls="wea_watermark";this.options={// text / img
text:"WATERMARK",fontStyle:"font-size:18px;color:#000;",src:"",width:200,height:150,rotate:-15,alpha:0.15,interval:2000,intervalCheck:true,clickCheck:true};this.updateOptions=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.loaded)return;if(!_this.checkOptions(options))return;_this.destoryed=false;_this.setOptions(options);_this.canvas=new _html2image.WaterMarkCanvas(options);_this.update();};this.checkOptions=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var flag=false;for(var key in options){if(options.hasOwnProperty(key)){if(options[key]!==_this.options[key]){flag=true;break;}}}return flag;};this.handleClick=function(){if(_this.checkChange()){_this.update();}else if(_this.checkCanvasChange()){_this.rerenderCanvas();}};this.des=function(){clearInterval(_this.timer);if(_this.observeDomInstance)_this.observeDomInstance.disconnect();if(_this.window&&_this.window.e9WatermarkLoaded){_this.destoryed=true;window.top.onresize=undefined;_this.window.e9WatermarkLoaded=false;_this.doc.removeEventListener("click",_this.handleClick);_this.removeEle(_this.wrapId);_this.removeEle(_this.canvasImgCls);}};this.removeEle=function(selectorId){var ele=_this.doc.getElementById(selectorId);if(ele){_this.doc.body.removeChild(ele);}};this.checkChange=function(){var wrap=_this.doc.getElementById(_this.wrapId);return!wrap||wrap.innerHTML!==_this.html;};this.checkCanvasChange=function(){var canvasImg=_this.doc.getElementById(_this.canvasImgCls);return _this.canvasImg&&(!canvasImg||canvasImg!==_this.canvasImg);};this.getWindow=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var win=void 0;if(options.window&&options.window.document&&options.window.document.body){win=options.window;}win=win||window.top;return win;};this.setOptions=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.options=(0,_extends3.default)({},_this.options,options);var _options=_this.options,intervalCheck=_options.intervalCheck,interval=_options.interval,clickCheck=_options.clickCheck;_this.window=_this.getWindow(_this.options);_this.doc=_this.window.document;if(_this.timer){clearInterval(_this.timer);}if(intervalCheck){_this.timer=setInterval(function(){return _this.handleClick();},interval);}if(clickCheck){_this.doc.addEventListener("click",_this.handleClick);}else{_this.doc.removeEventListener("click",_this.handleClick);}window.top.onresize=function(){_this.update(_this.options);};// 给当前页面添加关闭销毁事件
window.onunload=function(){_this.des();};return true;};this.isUpdate=function(marks){var _options2=_this.options,alpha=_options2.alpha,rotate=_options2.rotate;if(!marks||marks.length===0){// 初始化
return true;}else if(marks.length!=_this.len){// 修改宽高的值
return true;}else if(marks[0].style.transform!=="rotate("+rotate+"deg)"){// 修改旋转角度
return true;}else if(marks[0].style.opacity!==alpha){// 修改透明度
return true;}return false;};this.update=function(type){var _options3=_this.options,src=_options3.src,alpha=_options3.alpha,rotate=_options3.rotate,text=_options3.text,fontStyle=_options3.fontStyle;if(_this.destoryed)return;var _options4=_this.options,width=_options4.width,height=_options4.height;width=width>0?width:200;height=height>0?height:150;var wrap=_this.doc.getElementById(_this.wrapId);if(wrap){// 每次更新时需要将原先的水印节点去掉，重新生成水印
_this.removeEle(_this.wrapId);}wrap=_this.doc.createElement("div");wrap.id=_this.wrapId;wrap.style.position="relative";wrap.style.overflow="hidden";_this.doc.body.appendChild(wrap);var bg=_this.doc.getElementById(_this.prefixCls);if(!bg){bg=_this.doc.createElement("div");bg.id=_this.prefixCls;bg.style.display="block";bg.style.pointerEvents="none";bg.style.position="absolute";// bg.style.width = "100%";
// bg.style.height = "100%";
bg.style.zIndex=99999;bg.style.top=0;bg.style.left=0;bg.style.textAlign="center";wrap.appendChild(bg);}// 检测图片是否有效
if(src&&type!=="text"){_this.type="img";var img=_this.doc.getElementById("wea_watremark_img_test");if(!img){img=_this.doc.createElement("img");img.id="wea_watremark_img_test";img.style.display="none";img.onerror=function(){_this.type="text";_this.update(_this.type);};_this.doc.body.appendChild(img);}img.src=src;}else{_this.type="text";}var w=_this.doc.documentElement.clientWidth;var h=_this.doc.documentElement.clientHeight;var x=Math.ceil(w/width);var y=Math.ceil(h/height);_this.len=x*y+2;var marks=_this.doc.querySelectorAll(".wea-watremark-mark");if(_this.isUpdate(marks)){bg.innerHTML="";for(var i=0;i<_this.len;i++){var mark=_this.doc.createElement("div");mark.className="wea-watremark-mark";mark.style.width=width+"px";mark.style.height=height+"px";mark.style.pointerEvents="none";mark.style.zIndex=-1;mark.style.float="left";mark.style.overflow="visible";mark.style.opacity=alpha;mark.style.transform="rotate("+rotate+"deg)";mark.style["-ms-transform"]="rotate("+rotate+"deg)";mark.style.position="relative";bg.appendChild(mark);}marks=_this.doc.querySelectorAll(".wea-watremark-mark");}Array.prototype.forEach.call(marks,function(m,i){if((i+1)%x===0){m.style.marginRight="-"+width+"px";}else{m.style.marginRight="0";}if(_this.type==="text"){m.innerHTML="<div style=\"width:100%;position:absolute;top:50%;transform:translateY(-50%);\"><p style=\"pointer-events:none;"+fontStyle+"\">"+text+"</p></div>";}else{m.innerHTML="<img class=\"wea_watremark_img\" alt=\"\" src=\""+src+"\" style=\"position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);pointer-events:none;max-width:100%;max-height:100%;\"></img>";}});_this.html=wrap.innerHTML;_this.updateCanvas();};this.updateCanvas=function(){_this.canvas.loadWatermarkWithCanvas(_this.prefixCls,_this.doc,_this.renderCanvasImg);};this.rerenderCanvas=function(){_this.canvas.loadWatermarkToImage(undefined,_this.doc,_this.renderCanvasImg);};this.renderCanvasImg=function(imgEle){if(!imgEle||_this.destoryed)return;if(_this.window&&!_this.window.e9WatermarkLoaded)return;/* 如果当前没有开启水印，则不渲染水印 */if(_this.observeDomInstance)_this.observeDomInstance.disconnect();_this.removeEle(_this.canvasImgCls);_this.canvasImgCls=_this.prefixCls+"_"+getHash();imgEle.id=_this.canvasImgCls;_this.canvasImg=imgEle;_this.doc.body.appendChild(imgEle);_html2image.WaterMarkCanvas.wait(function(){return _this.doc.getElementById(_this.canvasImgCls);},function(){_this.observeDomInstance=_this.observeDom(_this.canvasImgCls,undefined,function(){_this.rerenderCanvas();});});};this.observeDom=function(selectorId,config,callback){// Firefox和Chrome早期版本中带有前缀
var MutationObserver=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver;// 选择目标节点
var target=_this.doc.getElementById(selectorId);// 创建观察者对象
var observer=new MutationObserver(callback);// 配置观察选项:
config=config||{attributes:true,childList:false,characterData:false};// 传入目标节点和观察选项
observer.observe(target,config);// 随后,你还可以停止观察
// observer.disconnect();
return observer;};},_temp);var WM=function WM(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(instance){instance.updateOptions(options);}else{instance=new WaterMark(options);}};// 清除水印
WM.destory=function(){if(instance){instance.des();instance=null;}};// 格式化文档水印文本内容
function formatContent(options){var text=options.wmcontent||"";var fontStyle="font-family:"+(options.familyname||"微软雅黑")+";font-size:"+(options.fontsize||14)+"px;color:"+(options.color||"#000")+";text-align:"+(options.align||"left");// let lines = "";
// 处理多行文本的换行
// text
//   .split("\n")
//   .forEach(line => (lines += `<p style="${fontStyle}">` + line + "</p>"));
// text = lines;
text=text.replace(/<p>/g,"<p style=\""+fontStyle+"\">");return text;}// 处理水印设置内容
var handleWMSetting=function handleWMSetting(){var wmSetting=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var rotate=-Number(wmSetting.rotate);var alpha=Number(wmSetting.opacity)/100;var options={src:wmSetting.watermarktype=="2"?(window.ecologyContentPath||"")+"/weaver/weaver.file.FileDownload?fileid="+wmSetting.imageid:"",text:wmSetting.watermarktype=="1"?params&&params.document?formatContent(wmSetting):wmSetting.wmcontent:"",width:wmSetting.wmwidth>0?wmSetting.wmwidth:200,height:wmSetting.wmheight>0?wmSetting.wmheight:150,rotate:rotate,alpha:alpha};return options;};// 处理水印黑白名单规则
var handleSettingByHash=function handleSettingByHash(wmSetting){var pathname=window.location.pathname||"";var hash=window.location.hash||"";var index=hash.indexOf("?");index=index!==-1?index:hash.length-1;var href=pathname+hash.substring(0,index);if(wmSetting){var isopen=wmSetting.isopen,whitelist=wmSetting.whitelist,blacklist=wmSetting.blacklist;var list=isopen===1||isopen==="1"?blacklist:whitelist;var match=(list||[]).findIndex(function(value){return new RegExp(value).test(href);});if(match!==-1){isopen===1||isopen==="1"?WM.destory():WM(handleWMSetting(wmSetting));}else{isopen===1||isopen==="1"?WM(handleWMSetting(wmSetting)):WM.destory();}}};// 设置系统默认全局水印
WM.getSystemSetting=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cb=arguments[1];if(_userAgent.ua.browser==="IE"&&parseInt(_userAgent.ua.version,10)<11)return;callApi("/api/doc/console/wmsystemsetting/getwmsetting?isconvert=1","GET",params).then(cb&&typeof cb==="function"?cb:function(res){var wmSetting=res.wmSetting;WM.wmSetting=wmSetting;handleSettingByHash(wmSetting);}).catch(function(){});};// 处理hash变化
var handleHashChange=function handleHashChange(){handleSettingByHash(WM.wmSetting);};// 监听哈希变化
if("onhashchange"in window){if(window.addEventListener){window.removeEventListener("hashchange",handleHashChange);window.addEventListener("hashchange",handleHashChange);}else if(window.attachEvent){window.detachEvent("onhashchange",handleHashChange);window.attachEvent("onhashchange",handleHashChange);}else{window.onhashchange=handleHashChange;}}WM.handleHashChange=handleHashChange;WM.handleWMSetting=handleWMSetting;WM.handleSettingByHash=handleSettingByHash;WM.formatContent=formatContent;WM.WaterMarkClass=WaterMark;exports.default=WM;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Canvas2Image=exports.WaterMarkCanvas=undefined;var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _class,_temp;var _html2canvas=__webpack_require__(493);var _html2canvas2=_interopRequireDefault(_html2canvas);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WaterMarkCanvas=exports.WaterMarkCanvas=(_temp=_class=function WaterMarkCanvas(options){var _this=this;(0,_classCallCheck3.default)(this,WaterMarkCanvas);this.drawCanvas=function(){//Draw canvas
var canvas=document.createElement("canvas");canvas.style.width=WaterMarkCanvas.CANVAS_WIDTH+"px";canvas.style.height=WaterMarkCanvas.CANVAS_HEIGHT+"px";canvas.width=WaterMarkCanvas.CANVAS_WIDTH;canvas.height=WaterMarkCanvas.CANVAS_HEIGHT;canvas.id=_this.wmId;canvas.style.display="block";canvas.style.pointerEvents="none";canvas.style.position="fixed";canvas.style.zIndex=99999;canvas.style.top=0;canvas.style.left=0;canvas.style.textAlign="center";return canvas;};this.drawTextWatermark=function(options){var windowWidth=window.innerWidth;var windowHeight=window.innerHeight;var canvas=_this.drawCanvas();var ctx=canvas.getContext("2d");ctx.clearRect(0,0,WaterMarkCanvas.CANVAS_WIDTH,WaterMarkCanvas.CANVAS_HEIGHT);ctx.save();ctx.scale(WaterMarkCanvas.CANVAS_WIDTH/windowWidth,WaterMarkCanvas.CANVAS_HEIGHT/windowHeight);var width=_this.options.width>0?_this.options.width:200;var height=_this.options.height>0?_this.options.height:150;var rotate=(_this.options.rotate||0)/360*Math.PI;var text=_this.options.text;var w=WaterMarkCanvas.CANVAS_WIDTH;var h=WaterMarkCanvas.CANVAS_HEIGHT;var x=Math.ceil(w/width);var y=Math.ceil(h/height);ctx.textAlign="center";// ctx.font= 'px yahei';
ctx.globalAlpha=_this.options.alpha;ctx.rotate(rotate);for(var i=0;i<x;i+=1){for(var j=0;j<y;j+=1){ctx.fillText(text,i*width,j*height,width);}}ctx.restore();document.body.appendChild(canvas);};this.loadWatermarkWithCanvas=function(watermarkContentId,layout,callback){layout=layout||document;WaterMarkCanvas.wait(function(){return layout.getElementById(watermarkContentId);},function(){var getPixelRatio=function getPixelRatio(context){// 闁兼儳鍢茶ぐ鍥╂媼閹屾У闁汇劌鍤xelRatio
var backingStore=context.backingStorePixelRatio||context.webkitBackingStorePixelRatio||context.mozBackingStorePixelRatio||context.msBackingStorePixelRatio||context.oBackingStorePixelRatio||context.backingStorePixelRatio||1;return(window.devicePixelRatio||1)/backingStore;};var shareContent=layout.getElementById(watermarkContentId);var width=shareContent.offsetWidth;var height=shareContent.offsetHeight;var canvas=document.createElement("canvas");var context=canvas.getContext("2d");// 閻忓繐鎽禷nvas闁汇劌瀚鎰板闯閵婏箑鈷栧棰濇箳ixelRatio闁稿﹤绋勭槐婵嬪礃瀹ュ懐娈洪柣銏ｎ嚙缁旈绱撻埡鍌涙澒闁挎稑鑻惃銏ゅ炊閹冨壖闁衡偓閹佷海PixelRatio闁稿﹤绋勭槐婵嬫⒓閸欏鍓鹃悗鐢靛帶閸ゎ參鎯冮崟顐ｇ闁绘娲﹁啯缂侇垽鎷�
var scale=getPixelRatio(context);context.scale(scale,scale);WaterMarkCanvas.setWAH(canvas,width*scale,height*scale);var opts={backgroundColor:null,scale:scale,canvas:canvas,width:width,height:height,useCORS:true,dpi:window.devicePixelRatio,ignoreElements:function ignoreElements(element){/* 鏉╁洦鎶ら崶鍓у娑撳娴囬幓鎺嶆閻ㄥ埇frame閿涘矂妲诲銏犳禈閻楀洭鍣告径宥勭瑓鏉炰粙妫舵０锟� */if(element.id=="downloadFrame"){return true;}/* 去除非水印的图片元素，防止验证码图片重复请求 */if(element.tagName==="IMG"&&element.className!=="wea_watremark_img"){return true;}if(element.nodeName==="IFRAME"){/* 过滤 EMobile 聊天工具 */if(element.className==="eMobile-iframe"){return true;}/* 过滤iframe的src中带接口的，一般为下载工具 */if(element.src&&/\/api\//.test(element.src)){return true;}}}};(0,_html2canvas2.default)(shareContent,opts).then(function(canvas){_this.canvas=canvas;var context=canvas.getContext("2d");// 闁稿繑濞婂Λ鎾箮濡ゅ懏鏆滃璇茬仢閼革拷
context.mozImageSmoothingEnabled=false;context.webkitImageSmoothingEnabled=false;context.msImageSmoothingEnabled=false;context.imageSmoothingEnabled=false;_this.cache.width=width;_this.cache.height=height;_this.cache.scale=scale;_this.loadWatermarkToImage(canvas,callback);});});};this.loadWatermarkToImage=function(canvas,callback){canvas=canvas||_this.canvas;// canvas閺夌儐鍓欑€靛弶绋夐崫鍕闁绘鎷�
var newImg=Canvas2Image.convertToImage(canvas);// 缂備焦鐟ュù姗€鎮ч崶顏嶅晭缂傚喚鍠栫敮顐ｆ叏鐎ｎ剚鐣遍悗閫涚矙閻濓拷
newImg.style.all="initial";WaterMarkCanvas.setWAH(newImg,_this.cache.width,_this.cache.height);WaterMarkCanvas.setStyle(newImg,{display:"block",pointerEvents:"none",textAlign:"center",position:"fixed",zIndex:99999,top:0,left:0});if(callback)callback(newImg,canvas);};this.wmId="wea_watremark_"+parseInt(Math.random()*1000);this.options=options;this.cache={};}// 缂備焦锚閸╂anvas闁哄秴鍢茬槐锟�
// 缂備焦锚閸╂寮崶銊︽嫳婵ɑ娼欏畵锟�
// 閻忓繐妫欑€垫氨鈧鐡皁m闁稿繐鍟扮粈锟�闁汇垻鍠愰崹姝漚nvas闁搞儱澧芥晶锟�
,_class.CANVAS_WIDTH=1600,_class.CANVAS_HEIGHT=900,_class.setStyle=function(ele,style){if(!ele||!ele.style)return;for(var styleKey in style){if(style.hasOwnProperty(styleKey)){ele.style[styleKey]=style[styleKey];}}},_class.setWAH=function(ele,width,height){if(!ele)return;ele.width=width;ele.height=height;ele.style.width=width+"px";ele.style.height=height+"px";},_class.wait=function(getEle,func,times,interval){if(typeof getEle!=="function")return;var _times=times||-1,//100婵炲棴鎷�
_interval=interval||20,//20婵綆鍋嗛～妤€袙韫囨棏鍋�
_self=this,_iIntervalID;//閻庤纰嶅鍌炲闯閳侯櫔
if(getEle()){//濠碘€冲€归悘澶婎啅閼碱剛鐥呴柤鎯у槻瑜板洭宕氭０浣哄晩闁挎稑鑻銊╂儎鐎涙ê澶嶉柟绗涘棭鏀介柛鎴ｅГ閺嗭拷
func&&func.call(this);}else{_iIntervalID=setInterval(function(){if(!_times){//闁哄嫸鎷�0閻忓繘浜堕埀顑藉亾闁告埊鎷�
clearInterval(_iIntervalID);}_times<=0||_times--;//濠碘€冲€归悘澶愬及椤栨侗鍔€闁轰焦婢樺锟� --
if(getEle()){// 闁告劕绉甸濂告焻婢跺顏�,闁告帇鍊栭弻鍥及椤栨碍鍎婇柛娆愮墪閸╋拷
func&&func.call(_self);clearInterval(_iIntervalID);}},_interval);}return this;},_temp);/**
 * covert canvas to image
 * and save the image file
 */var Canvas2Image=exports.Canvas2Image=function(){// check if support sth.
var $support=function(){var canvas=document.createElement("canvas"),ctx=canvas.getContext("2d");return{canvas:!!ctx,imageData:!!ctx.getImageData,dataURL:!!canvas.toDataURL,btoa:!!window.btoa};}();var downloadMime="image/octet-stream";function scaleCanvas(canvas,width,height){var w=canvas.width,h=canvas.height;if(width==undefined){width=w;}if(height==undefined){height=h;}var retCanvas=document.createElement("canvas");var retCtx=retCanvas.getContext("2d");retCanvas.width=width;retCanvas.height=height;retCtx.drawImage(canvas,0,0,w,h,0,0,width,height);return retCanvas;}function getDataURL(canvas,type,width,height){canvas=scaleCanvas(canvas,width,height);return canvas.toDataURL(type);}function saveFile(strData){document.location.href=strData;}function genImage(strData){var img=document.createElement("img");img.src=strData;return img;}function fixType(type){type=type.toLowerCase().replace(/jpg/i,"jpeg");var r=type.match(/png|jpeg|bmp|gif/)[0];return"image/"+r;}function encodeData(data){if(!window.btoa){throw"btoa undefined";}var str="";if(typeof data=="string"){str=data;}else{for(var i=0;i<data.length;i++){str+=String.fromCharCode(data[i]);}}return btoa(str);}function getImageData(canvas){var w=canvas.width,h=canvas.height;return canvas.getContext("2d").getImageData(0,0,w,h);}function makeURI(strData,type){return"data:"+type+";base64,"+strData;}/**
   * create bitmap image
   * 闂佸湱枪椤﹂亶宕ｆ惔锝嗗枂闁告洦鍋勯悘鐔兼煟閵忋垹鏋戦柛銊﹀哺瀹曞爼宕滆椤ｅ鏌涘┑鍡櫺㈢紒銊ュ级瀵板嫰寮堕幋鐐差伅闂佸憡绻傜粔瀵歌姳閸欏濯撮柨鐕傛嫹
   */var genBitmapImage=function genBitmapImage(oData){//
// BITMAPFILEHEADER: http://msdn.microsoft.com/en-us/library/windows/desktop/dd183374(v=vs.85).aspx
// BITMAPINFOHEADER: http://msdn.microsoft.com/en-us/library/dd183376.aspx
//
var biWidth=oData.width;var biHeight=oData.height;var biSizeImage=biWidth*biHeight*3;var bfSize=biSizeImage+54;// total header size = 54 bytes
//
//  typedef struct tagBITMAPFILEHEADER {
//  	WORD bfType;
//  	DWORD bfSize;
//  	WORD bfReserved1;
//  	WORD bfReserved2;
//  	DWORD bfOffBits;
//  } BITMAPFILEHEADER;
//
var BITMAPFILEHEADER=[// WORD bfType -- The file type signature; must be "BM"
0x42,0x4d,// DWORD bfSize -- The size, in bytes, of the bitmap file
bfSize&0xff,bfSize>>8&0xff,bfSize>>16&0xff,bfSize>>24&0xff,// WORD bfReserved1 -- Reserved; must be zero
0,0,// WORD bfReserved2 -- Reserved; must be zero
0,0,// DWORD bfOffBits -- The offset, in bytes, from the beginning of the BITMAPFILEHEADER structure to the bitmap bits.
54,0,0,0];//
//  typedef struct tagBITMAPINFOHEADER {
//  	DWORD biSize;
//  	LONG  biWidth;
//  	LONG  biHeight;
//  	WORD  biPlanes;
//  	WORD  biBitCount;
//  	DWORD biCompression;
//  	DWORD biSizeImage;
//  	LONG  biXPelsPerMeter;
//  	LONG  biYPelsPerMeter;
//  	DWORD biClrUsed;
//  	DWORD biClrImportant;
//  } BITMAPINFOHEADER, *PBITMAPINFOHEADER;
//
var BITMAPINFOHEADER=[// DWORD biSize -- The number of bytes required by the structure
40,0,0,0,// LONG biWidth -- The width of the bitmap, in pixels
biWidth&0xff,biWidth>>8&0xff,biWidth>>16&0xff,biWidth>>24&0xff,// LONG biHeight -- The height of the bitmap, in pixels
biHeight&0xff,biHeight>>8&0xff,biHeight>>16&0xff,biHeight>>24&0xff,// WORD biPlanes -- The number of planes for the target device. This value must be set to 1
1,0,// WORD biBitCount -- The number of bits-per-pixel, 24 bits-per-pixel -- the bitmap
// has a maximum of 2^24 colors (16777216, Truecolor)
24,0,// DWORD biCompression -- The type of compression, BI_RGB (code 0) -- uncompressed
0,0,0,0,// DWORD biSizeImage -- The size, in bytes, of the image. This may be set to zero for BI_RGB bitmaps
biSizeImage&0xff,biSizeImage>>8&0xff,biSizeImage>>16&0xff,biSizeImage>>24&0xff,// LONG biXPelsPerMeter, unused
0,0,0,0,// LONG biYPelsPerMeter, unused
0,0,0,0,// DWORD biClrUsed, the number of color indexes of palette, unused
0,0,0,0,// DWORD biClrImportant, unused
0,0,0,0];var iPadding=(4-biWidth*3%4)%4;var aImgData=oData.data;var strPixelData="";var biWidth4=biWidth<<2;var y=biHeight;var fromCharCode=String.fromCharCode;do{var iOffsetY=biWidth4*(y-1);var strPixelRow="";for(var x=0;x<biWidth;x++){var iOffsetX=x<<2;strPixelRow+=fromCharCode(aImgData[iOffsetY+iOffsetX+2])+fromCharCode(aImgData[iOffsetY+iOffsetX+1])+fromCharCode(aImgData[iOffsetY+iOffsetX]);}for(var c=0;c<iPadding;c++){strPixelRow+=String.fromCharCode(0);}strPixelData+=strPixelRow;}while(--y);var strEncoded=encodeData(BITMAPFILEHEADER.concat(BITMAPINFOHEADER))+encodeData(strPixelData);return strEncoded;};/**
   * saveAsImage
   * @param canvasElement
   * @param {String} image type
   * @param {Number} [optional] png width
   * @param {Number} [optional] png height
   */var saveAsImage=function saveAsImage(canvas,width,height,type){if($support.canvas&&$support.dataURL){if(typeof canvas=="string"){canvas=document.getElementById(canvas);}if(type==undefined){type="png";}type=fixType(type);if(/bmp/.test(type)){var data=getImageData(scaleCanvas(canvas,width,height));var strData=genBitmapImage(data);saveFile(makeURI(strData,downloadMime));}else{var strData=getDataURL(canvas,type,width,height);saveFile(strData.replace(type,downloadMime));}}};var convertToImage=function convertToImage(canvas,width,height,type){if($support.canvas&&$support.dataURL){if(typeof canvas=="string"){canvas=document.getElementById(canvas);}if(type==undefined){type="png";}type=fixType(type);if(/bmp/.test(type)){var data=getImageData(scaleCanvas(canvas,width,height));var strData=genBitmapImage(data);return genImage(makeURI(strData,"image/bmp"));}else{var strData=getDataURL(canvas,type,width,height);return genImage(strData);}}};return{saveAsImage:saveAsImage,saveAsPNG:function saveAsPNG(canvas,width,height){return saveAsImage(canvas,width,height,"png");},saveAsJPEG:function saveAsJPEG(canvas,width,height){return saveAsImage(canvas,width,height,"jpeg");},saveAsGIF:function saveAsGIF(canvas,width,height){return saveAsImage(canvas,width,height,"gif");},saveAsBMP:function saveAsBMP(canvas,width,height){return saveAsImage(canvas,width,height,"bmp");},convertToImage:convertToImage,convertToPNG:function convertToPNG(canvas,width,height){return convertToImage(canvas,width,height,"png");},convertToJPEG:function convertToJPEG(canvas,width,height){return convertToImage(canvas,width,height,"jpeg");},convertToGIF:function convertToGIF(canvas,width,height){return convertToImage(canvas,width,height,"gif");},convertToBMP:function convertToBMP(canvas,width,height){return convertToImage(canvas,width,height,"bmp");}};}();

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WeaAssociativeSearchMult=exports.WeaAssociativeSearch=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaAssociativeSearch=(0,_reactLoadable2.default)({loader:function loader(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 139));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var WeaAssociativeSearchMult=(0,_reactLoadable2.default)({loader:function loader(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 87));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);return(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));}(0,_createClass3.default)(main,[{key:"render",value:function render(){var props=this.props;if(props.mult){delete props.mult;return React.createElement(WeaAssociativeSearchMult,props);}return React.createElement(WeaAssociativeSearch,props);}}]);return main;}(React.Component);var Com=(0,_middleware2.default)(main,"WeaAssociativeSearch");exports.WeaAssociativeSearch=WeaAssociativeSearch;exports.WeaAssociativeSearchMult=WeaAssociativeSearchMult;exports.default=Com;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(124));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 957));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Com;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(541)();
}


/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(261),
    eq = __webpack_require__(118);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(262);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(177),
    getPrototype = __webpack_require__(264),
    getSymbols = __webpack_require__(178),
    stubArray = __webpack_require__(244);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(236);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(146);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(270),
    toKey = __webpack_require__(127);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isKey = __webpack_require__(186),
    stringToPath = __webpack_require__(594),
    toString = __webpack_require__(57);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.15.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var version = "1.15.0";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !! /*@__PURE__*/navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        this.forRepaintDummy = repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.forEach(function (p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var _excluded = ["evt"];

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, _excluded);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable)) return;
    var rect = getRect(sortable),
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists && !ChromeForAndroid) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    } // Safari ignores further event handling after mousedown


    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.removeAttribute("id");
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread2({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // Insert to end of list
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // if there is a last element, it is the target


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();

          if (elLastChild && elLastChild.nextSibling) {
            // the last draggable element is not the last node
            el.insertBefore(dragEl, elLastChild.nextSibling);
          } else {
            el.appendChild(dragEl);
          }

          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        // Insert to start of list
        var firstChild = getChild(el, 0, options, true);

        if (firstChild === dragEl) {
          return completed(false);
        }

        target = firstChild;
        targetRect = getRect(target);

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order, useAnimation) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsFirst(evt, vertical, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (!sortable.options.avoidImplicitDeselect) {
      if (sortable.options.supportPointer) {
        on(document, 'pointerup', this._deselectMultiDrag);
      } else {
        on(document, 'mouseup', this._deselectMultiDrag);
        on(document, 'touchend', this._deselectMultiDrag);
      }
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      avoidImplicitDeselect: false,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvent: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvent: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvent: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        folding = false; // Do not "unfold" after around dragEl if reverted

        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvent: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _jsBase=__webpack_require__(138);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Base64WithLocale=(0,_extends3.default)({},_jsBase.Base64,{decode:function decode(str){var base64Str=_jsBase.Base64.decode(str);return _weaLocaleProvider2.default.formatMultiLang(base64Str);}});exports.default=Base64WithLocale;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 963));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});// import Com from './ShowUrl';
exports.default=Com;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Draggable=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 964));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:"render",value:function render(){return _react2.default.createElement(Draggable,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_Draggable@e2wlgv"}));}}]);return Main;}(_react2.default.Component);var Com=(0,_middleware2.default)(Main,"WeaDraggable");exports.default=Com;

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);








/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ArrowKeyStepper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ArrowKeyStepper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollToColumn: 0,
      scrollToRow: 0
    }, _this._columnStartIndex = 0, _this._columnStopIndex = 0, _this._rowStartIndex = 0, _this._rowStopIndex = 0, _this._onKeyDown = function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;


      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }, _this._onSectionRendered = function (_ref2) {
      var columnStartIndex = _ref2.columnStartIndex,
          columnStopIndex = _ref2.columnStopIndex,
          rowStartIndex = _ref2.rowStartIndex,
          rowStopIndex = _ref2.rowStopIndex;

      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: 'setScrollIndexes',
    value: function setScrollIndexes(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;

      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;

      var _getScrollState2 = this._getScrollState(),
          scrollToColumn = _getScrollState2.scrollToColumn,
          scrollToRow = _getScrollState2.scrollToRow;

      return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](
        'div',
        { className: className, onKeyDown: this._onKeyDown },
        children({
          onSectionRendered: this._onSectionRendered,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        })
      );
    }
  }, {
    key: '_getScrollState',
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: '_updateScrollState',
    value: function _updateScrollState(_ref4) {
      var scrollToColumn = _ref4.scrollToColumn,
          scrollToRow = _ref4.scrollToRow;
      var _props2 = this.props,
          isControlled = _props2.isControlled,
          onScrollToChange = _props2.onScrollToChange;


      if (typeof onScrollToChange === 'function') {
        onScrollToChange({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }

      if (!isControlled) {
        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return null;
      }

      if (nextProps.scrollToColumn !== prevState.scrollToColumn || nextProps.scrollToRow !== prevState.scrollToRow) {
        return {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow
        };
      }

      return null;
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

ArrowKeyStepper.defaultProps = {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
ArrowKeyStepper.propTypes =  true ? null : {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  columnCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  isControlled: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['cells', 'edges']).isRequired,
  onScrollToChange: PropTypes.func,
  rowCount: PropTypes.number.isRequired,
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(ArrowKeyStepper);

/* harmony default export */ __webpack_exports__["a"] = (ArrowKeyStepper);




/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clsx__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dom_helpers_scrollbarSize__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);



















/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props));

    _this._onGridRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])(false);
    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;
    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;
    _this._renderedColumnStartIndex = 0;
    _this._renderedColumnStopIndex = 0;
    _this._renderedRowStartIndex = 0;
    _this._renderedRowStopIndex = 0;
    _this._styleCache = {};
    _this._cellCache = {};

    _this._debounceScrollEndedCallback = function () {
      _this._disablePointerEventsTimeoutId = null;
      // isScrolling is used to determine if we reset styleCache
      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    };

    _this._invokeOnGridRenderedHelper = function () {
      var onSectionRendered = _this.props.onSectionRendered;


      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    };

    var columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });

    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,

        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,

        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,

      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }
    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: 'getTotalRowsHeight',
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }

    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: 'getTotalColumnsWidth',
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;
      var instanceProps = this.state.instanceProps;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionHorizontal;
        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: _scrollDirectionHorizontal,
          scrollDirectionVertical: _scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;
      var instanceProps = this.state.instanceProps;

      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;
      var instanceProps = this.state.instanceProps;


      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._styleCache = {};
      this._cellCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;
      var instanceProps = this.state.instanceProps;

      // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.
      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prevState, { needToResetStyleCache: false });
          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }

      // refs don't work in `react-test-renderer`
      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }
        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop,
          instanceProps = _state.instanceProps;
      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          autoContainerWidth = _props6.autoContainerWidth,
          autoHeight = _props6.autoHeight,
          autoWidth = _props6.autoWidth,
          className = _props6.className,
          containerProps = _props6.containerProps,
          containerRole = _props6.containerRole,
          containerStyle = _props6.containerStyle,
          height = _props6.height,
          id = _props6.id,
          noContentRenderer = _props6.noContentRenderer,
          role = _props6.role,
          style = _props6.style,
          tabIndex = _props6.tabIndex,
          width = _props6.width;
      var _state2 = this.state,
          instanceProps = _state2.instanceProps,
          needToResetStyleCache = _state2.needToResetStyleCache;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      }

      // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset
      if (!this.state.isScrolling) {
        this._resetStyleCache();
      }

      // calculate children to render here
      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
        'div',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          ref: this._setScrollingContainerRef
        }, containerProps, {
          'aria-label': this.props['aria-label'],
          'aria-readonly': this.props['aria-readonly'],
          className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["default"])('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex }),
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            role: containerRole,
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle) },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;


      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });

        // update the indices
        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_handleInvalidatedGridSize',


    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _props7 = _this3.props,
              height = _props7.height,
              onScroll = _props7.onScroll,
              width = _props7.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        _onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: 'scrollToPosition',


    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0;

        // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps;

      // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;
      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });

      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, {
          isScrolling: false
        });
      }

      var maybeStateA = void 0;
      var maybeStateB = void 0;

      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });

      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow;

      // getting scrollBarSize (moved from componentWillMount)
      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, newState, maybeStateA, maybeStateB);
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: '_getScrollToPositionStateUpdate',


    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }
      return null;
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;


      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;

        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollLeftForScrollToColumnStateUpdate',
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
      return null;
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;


      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollTopForScrollToRowStateUpdate',
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
      return null;
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__["a" /* default */],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: __WEBPACK_IMPORTED_MODULE_15_dom_helpers_scrollbarSize__["a" /* default */],
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["c" /* default */],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
};
Grid.propTypes =  true ? null : {
  "aria-label": PropTypes.string.isRequired,
  "aria-readonly": PropTypes.bool,


  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: PropTypes.bool.isRequired,


  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: PropTypes.bool.isRequired,


  /** Responsible for rendering a cell given an row and column index.  */
  cellRenderer: function cellRenderer() {
    return (typeof bpfrpt_proptype_CellRenderer === 'function' ? bpfrpt_proptype_CellRenderer.isRequired ? bpfrpt_proptype_CellRenderer.isRequired : bpfrpt_proptype_CellRenderer : PropTypes.shape(bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a group of cells given their index ranges.  */
  cellRangeRenderer: function cellRangeRenderer() {
    return (typeof bpfrpt_proptype_CellRangeRenderer === 'function' ? bpfrpt_proptype_CellRangeRenderer.isRequired ? bpfrpt_proptype_CellRangeRenderer.isRequired : bpfrpt_proptype_CellRangeRenderer : PropTypes.shape(bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },


  /** Optional custom CSS class name to attach to root Grid element.  */
  className: PropTypes.string,


  /** Number of columns in grid.  */
  columnCount: PropTypes.number.isRequired,


  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  columnWidth: function columnWidth() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Unfiltered props for the Grid container. */
  containerProps: PropTypes.object,


  /** ARIA role for the cell-container.  */
  containerRole: PropTypes.string.isRequired,


  /** Optional inline style applied to inner cell-container */
  containerStyle: PropTypes.object.isRequired,


  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: PropTypes.object,


  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: PropTypes.number.isRequired,


  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Exposed for testing purposes only.  */
  getScrollbarSize: PropTypes.func.isRequired,


  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  height: PropTypes.number.isRequired,


  /** Optional custom id to attach to root Grid element.  */
  id: PropTypes.string,


  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: PropTypes.bool,


  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  isScrollingOptOut: PropTypes.bool.isRequired,


  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  noContentRenderer: function noContentRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: PropTypes.func.isRequired,


  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  onSectionRendered: PropTypes.func.isRequired,


  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: PropTypes.number.isRequired,


  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** ARIA role for the grid element.  */
  role: PropTypes.string.isRequired,


  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Number of rows in grid.  */
  rowCount: PropTypes.number.isRequired,


  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Horizontal offset. */
  scrollLeft: PropTypes.number,


  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  scrollToColumn: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToRow: PropTypes.number.isRequired,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  width: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__["polyfill"])(Grid);
/* harmony default export */ __webpack_exports__["a"] = (Grid);
















/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCROLL_DIRECTION_FORWARD; });
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}



/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028
      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollbarSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canUseDOM__ = __webpack_require__(626);

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (__WEBPACK_IMPORTED_MODULE_0__canUseDOM__["a" /* default */]) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_ScrollIndices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_ScrollIndices =  true ? null : {
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};



/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);









var AutoSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var win = _this._window || window;
        var _style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // uses any instead of Window because Flow doesn't have window type


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])(nonce, this._window);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        {
          className: className,
          ref: this._setRef,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, outerStyle, style) },
        children(childParams)
      );
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
AutoSizer.propTypes =  true ? null : {
  /** Function responsible for rendering children.*/
  children: PropTypes.func.isRequired,


  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  className: PropTypes.string,


  /** Default height to use for initial render; useful for SSR */
  defaultHeight: PropTypes.number,


  /** Default width to use for initial render; useful for SSR */
  defaultWidth: PropTypes.number,


  /** Disable dynamic :height property */
  disableHeight: PropTypes.bool.isRequired,


  /** Disable dynamic :width property */
  disableWidth: PropTypes.bool.isRequired,


  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: PropTypes.string,


  /** Callback to be invoked on-resize */
  onResize: PropTypes.func.isRequired,


  /** Optional inline style */
  style: PropTypes.object
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/

function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__ = __webpack_require__(631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__["a"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a" /* default */]);


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellMeasureCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellMeasureCache =  true ? null : {
  hasFixedWidth: PropTypes.func.isRequired,
  hasFixedHeight: PropTypes.func.isRequired,
  has: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};



/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_clsx__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);











/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(List, _React$PureComponent);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
      var parent = _ref2.parent,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          isScrolling = _ref2.isScrolling,
          isVisible = _ref2.isVisible,
          key = _ref2.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    }, _this._setRef = function (ref) {
      _this.Grid = ref;
    }, _this._onScroll = function (_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = _this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }, _this._onSectionRendered = function (_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref5) {
      var alignment = _ref5.alignment,
          index = _ref5.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            _scrollTop = _Grid$getOffsetForCel.scrollTop;

        return _scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = Object(__WEBPACK_IMPORTED_MODULE_9_clsx__["default"])('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

List.defaultProps = {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_7__Grid__["b" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
List.propTypes =  true ? null : {
  "aria-label": PropTypes.string,


  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /** Optional CSS class name */
  className: PropTypes.string,


  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Height constraint for list (determines how many actual rows are rendered) */
  height: PropTypes.number.isRequired,


  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: function noRowsRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /** Callback invoked with information about the slice of rows that were just rendered.  */

  onRowsRendered: PropTypes.func.isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: function rowRenderer() {
    return (typeof bpfrpt_proptype_RowRenderer === 'function' ? bpfrpt_proptype_RowRenderer.isRequired ? bpfrpt_proptype_RowRenderer.isRequired : bpfrpt_proptype_RowRenderer : PropTypes.shape(bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },


  /** Number of rows in list. */
  rowCount: PropTypes.number.isRequired,


  /** See Grid#scrollToAlignment */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of list */
  width: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (List);













/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(650), __esModule: true };

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(96);


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(96);


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'div',
    { className: className, role: 'row', style: style },
    columns
  );
}
defaultHeaderRowRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRowRendererParams;



/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;

  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'span',
    {
      className: 'ReactVirtualized__Table__headerTruncatedText',
      key: 'label',
      title: typeof label === 'string' ? label : null },
    label
  )];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], { key: 'SortIndicator', sortDirection: sortDirection }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRendererParams;



/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clsx__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortDirection__ = __webpack_require__(130);





/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;

  var classNames = Object(__WEBPACK_IMPORTED_MODULE_0_clsx__["default"])('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].DESC
  });

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](
    'svg',
    { className: classNames, width: 18, height: 18, viewBox: '0 0 24 24' },
    sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 14l5-5 5 5z' }) : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 10l5 5 5-5z' }),
    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
}

SortIndicator.propTypes =  false ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;

  var a11yProps = { 'aria-rowindex': index + 1 };

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({ event: event, index: index, rowData: rowData });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
      className: className,
      key: key,
      role: 'row',
      style: style }),
    columns
  );
}
defaultRowRenderer.propTypes =  true ? null : bpfrpt_proptype_RowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_RowRendererParams;



/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SortDirection__ = __webpack_require__(130);











/**
 * Describes the header and cell contents of a table column.
 */

var Column = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _React$Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Column.defaultProps = {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__["a" /* default */],
  defaultSortDirection: __WEBPACK_IMPORTED_MODULE_9__SortDirection__["a" /* default */].ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__["a" /* default */],
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Column);
Column.propTypes =  false ? {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,

  /** Optional id to set on the column header */
  id: PropTypes.string,

  /** Header label for this column */
  label: PropTypes.node,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_onScroll__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dimensions__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);












/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WindowScroller.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WindowScroller)).call.apply(_ref, [this].concat(args))), _this), _this._window = getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }), _this._registerChild = function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }
      _this._child = element;
      _this.updatePosition();
    }, _this._onChildScroll = function (_ref2) {
      var scrollTop = _ref2.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    }, _this._registerResizeListener = function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    }, _this._unregisterResizeListener = function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    }, _this._onResize = function () {
      _this.updatePosition();
    }, _this.__handleWindowScrollEvent = function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;


      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        var scrollOffset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["c" /* getScrollOffset */])(scrollElement);
        var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });

        onScroll({
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });
      }
    }, _this.__resetIsScrolling = function () {
      _this.setState({
        isScrolling: false
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: 'updatePosition',
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _state = this.state,
          height = _state.height,
          width = _state.width;


      var thisNode = this._child || __WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"](this);
      if (thisNode instanceof Element && scrollElement) {
        var offset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["b" /* getPositionOffset */])(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(scrollElement, this.props);
      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;

      this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__["a" /* default */])();

      this.updatePosition(scrollElement);

      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);
        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;


      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);

        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, prevScrollElement);
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);
        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;
      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollTop = _state2.scrollTop,
          scrollLeft = _state2.scrollLeft,
          height = _state2.height,
          width = _state2.width;


      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }

    // Referenced by utils/onScroll


    // Referenced by utils/onScroll

  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

WindowScroller.defaultProps = {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
};
WindowScroller.propTypes =  true ? null : {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,


  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: PropTypes.func.isRequired,


  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
  onScroll: PropTypes.func.isRequired,


  /** Element to attach scroll event listeners. Defaults to window. */
  scrollElement: PropTypes.oneOfType([PropTypes.any, function () {
    return (typeof Element === 'function' ? PropTypes.instanceOf(Element) : PropTypes.any).apply(this, arguments);
  }]),

  /**
   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
   */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Height used for server-side rendering */
  serverHeight: PropTypes.number.isRequired,


  /** Width used for server-side rendering */
  serverWidth: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (WindowScroller);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);exports.objToArray=objToArray;exports.getKeys=getKeys;exports.filterDatas=filterDatas;exports.changeValue=changeValue;exports.traverTree=traverTree;exports.addLeaf=addLeaf;exports.getDefautDatasShow=getDefautDatasShow;exports.getAllKeys=getAllKeys;exports.doFavEdit=doFavEdit;exports.doNoFavDelete=doNoFavDelete;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function objToArray(obj){if(obj&&!Array.isArray(obj)){var arr=[];arr.push(obj);obj=arr;}return obj;}function getKeys(datas){var itemMainKey=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"domid";datas=objToArray(datas);return datas.map(function(data){return data[itemMainKey];});}function filterDatas(data,v){var searchKeys=arguments.length>2&&arguments[2]!==undefined?arguments[2]:["name","ecologyPinyinSearch"];if(!v)return data;return data.map(function(d){var _d=(0,_extends3.default)({},d);var keys=searchKeys.filter(function(key){return d[key]&&d[key].toLowerCase().indexOf(v.toLowerCase())>=0;});if(keys.length>0){var _childs=d.childs?filterDatas([].concat((0,_toConsumableArray3.default)(d.childs)),v,searchKeys):null;_d.isFind=true;_d.isLeaf=!(_childs&&_childs.length);_d.isParent=!_d.isLeaf;if(_childs&&_childs.length){_d.childs=_childs;}else{delete _d.childs;}}else if(d.childs&&d.childs.length>0){var childs=filterDatas(d.childs,v,searchKeys);var _childs2=childs.filter(function(c){return c.isFind;});if(_childs2.length===0){_d.isFind=false;}else{_d.isFind=true;_d.childs=childs;}}else{_d.isFind=false;}return _d;}).filter(function(c){return c.isFind;});}function changeValue(data,itemMainKey,id,key,value){data.forEach(function(d){if(d[itemMainKey]===id){d[key]=value;return;}if(d.childs&&!!d.childs.length){changeValue(d.childs,itemMainKey,id,key,value);}});}function traverTree(data){var handler=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){return false;};var parent=arguments[2];if(!data)return;if(Array.isArray(data)){data.forEach(function(d){return traverTree(d,handler,parent);});}else{if(!handler(data,parent)&&data.childs){traverTree(data.childs,handler,data);}}}// 添加节点是否可展开标识，即是否有子集
function addLeaf(datas){datas=objToArray(datas);return datas.map(function(data){var _data=(0,_extends3.default)({},data);if("isLeaf"in data)return _data;if(data.childs&&data.childs.length>0){_data.isLeaf=false;_data.childs=addLeaf(data.childs);}else{_data.isLeaf=true;}return _data;});}// 获取 maxLev 级树的数据
function getDefautDatasShow(datas,maxLev){var lev=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;datas=objToArray(datas);return lev>maxLev?[]:datas.map(function(data){var _data=(0,_extends3.default)({},data);if(_data.childs&&_data.childs.length>0){_data.childs=getDefautDatasShow(data.childs,maxLev,lev+1);}return _data;});}// 获取总数，和每一叉树的所有 key
function getAllKeys(datas){var itemMainKey=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"domid";datas=objToArray(datas);var num=datas.length;var keys=getKeys(datas,itemMainKey);var childs=datas.map(function(data){var _obj2;var obj=(_obj2={},(0,_defineProperty3.default)(_obj2,itemMainKey,data[itemMainKey]),(0,_defineProperty3.default)(_obj2,"childs",[]),(0,_defineProperty3.default)(_obj2,"keys",[]),_obj2);if(data.childs&&data.childs.length>0){var _obj=getAllKeys(data.childs,itemMainKey);num+=_obj.num;obj.num=_obj.num;obj.childs=[].concat((0,_toConsumableArray3.default)(_obj.childs));obj.keys=[].concat((0,_toConsumableArray3.default)(_obj.keys));keys=keys.concat(_obj.keys);}return obj;});return{num:num,childs:childs,keys:keys};}// 点击收藏 更改收藏状态
function doFavEdit(datas,domid){var itemMainKey=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"domid";datas=objToArray(datas);return datas.map(function(data){var _data=(0,_extends3.default)({},data);if(data[itemMainKey]===domid){_data.fav=!_data.fav;}else if(data.childs&&data.childs.length>0){_data.childs=doFavEdit(data.childs,domid);}return _data;});}// 删除不包含收藏节点的子集
function doNoFavDelete(datas){datas=objToArray(datas);return datas.map(function(data){var _data=(0,_extends3.default)({},data);_data.hasChildFav=false;if(data.childs&&data.childs.length>0){var childs=doNoFavDelete(data.childs);var _childs=childs.filter(function(c){return c.fav||c.hasChildFav;});if(_childs.length>0){_data.hasChildFav=true;_data.childs=_childs;}else{_data.isLeaf=true;_data.childs=[];}}return _data;}).filter(function(c){return c.fav||c.hasChildFav;});}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.createDing=exports.checkDing=exports.getEmAudioOrVideo=exports.checkJoin=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _antd=__webpack_require__(8);var _callApi=__webpack_require__(17);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var checkJoin=exports.checkJoin=function checkJoin(){if(window.emJoinStatus){// return window.emJoinStatus;
return new _promise2.default(function(rs,rj){rs(window.emJoinStatus);});}else{return(0,_callApi.callApi)("/api/ec/dev/app/checkJoin","GET",{}).then(function(res){if(res.status==true){window.emJoinStatus=res;return window.emJoinStatus;}else{window.emJoinStatus={status:false,joinStatus:false,emSwitch:"0",shareSwitch:"0",webSwitch:"0",wxWorkShareSwitch:"0",dingTalkShareSwitch:"0"};return window.emJoinStatus;}});}};checkJoin();window.em_checkJoin=checkJoin;// 调用em语音视频功能
var getEmAudioOrVideo=exports.getEmAudioOrVideo=function getEmAudioOrVideo(id,type,callback){if(window.customEmAudioOrVideo){window.customEmAudioOrVideo(id,type);}else{var params={touserids:id,msginfo:[{objectName:"FW:VideoMsg",type:type//1表示音频，2表示视频
}]};(0,_callApi.callApi)("/api/ec/dev/share/openConversation","POST",{data:(0,_stringify2.default)(params)}).then(function(result){if(result.status&&result.data.errcode===0){typeof callback==="function"&&callback(result);}else{_antd.message.error(result.data&&result.data.errmsg?result.data.errmsg:getLabel("515835","调用em接口失败"));}});}};// 判断是否显示ding
var checkDing=exports.checkDing=function checkDing(){return window.em&&window.em.checkJsApi("dingCreate");};// ding
var createDing=exports.createDing=function createDing(params,sucessCallback,failCallback){(0,_callApi.callApi)("/api/ec/dev/app/test","GET",{}).then(function(res){var corpId=res.em_corpid;window.em.dingCreate((0,_extends3.default)({corpId:corpId},params,{success:function success(res){if(sucessCallback&&typeof sucessCallback==="function"){sucessCallback(res);}},fail:function fail(err){_antd.message.error(err);if(failCallback&&typeof failCallback==="function"){failCallback(err);}}}));});};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaQRcode=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 971));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaQRcode;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.createQRCode=exports.utf16To8=exports.defaultIcon=undefined;var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);exports.sendMsgToPC=sendMsgToPC;var _antd=__webpack_require__(8);var _callApi=__webpack_require__(17);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var defaultIcon=exports.defaultIcon={"Mr.":"/images/messageimages/temp/man_wev8.png","Ms.":"/images/messageimages/temp/women_wev8.png"};var utf16To8=exports.utf16To8=function utf16To8(str){var len=str.length;var out="";for(var i=0;i<len;i++){var c=str.charCodeAt(i);if(c>=0x0001&&c<=0x007f){out+=str.charAt(i);}else if(c>0x07ff){out+=String.fromCharCode(0xe0|c>>12&0x0f);out+=String.fromCharCode(0x80|c>>6&0x3f);out+=String.fromCharCode(0x80|c>>0&0x3f);}else{out+=String.fromCharCode(0xc0|c>>6&0x1f);out+=String.fromCharCode(0x80|c>>0&0x3f);}}return out;};var createQRCode=exports.createQRCode=function createQRCode(userinfo){var txt="BEGIN:VCARD \nVERSION:3.0 \nN:"+userinfo.lastname+" \n"+("TEL;CELL;VOICE:"+userinfo.mobile+" \n")+("TEL;WORK;VOICE:"+userinfo.telephone+" \n")+("EMAIL:"+userinfo.email+" \n")+("TITLE:"+userinfo.jobtitleName+" \n")+("ROLE:"+userinfo.departmentName+" \n")+("ADR;WORK:"+userinfo.locationName+" \nEND:VCARD");return utf16To8(txt);};/**
 * 调用e-message发起会话
 * (em6)
 * @param conventioners  参与会话人员，群，（多个用逗号分隔）
 * @param openType 会话创建类型 0：单聊   1：群聊（一般用不到）  2：创建新的群聊
 * @param groupName 群聊名称
 * @param extra 可选,消息体中内容 extra中的msgType 要推送的消息类型，1表示RC:TxtMsg 文本消息，2表示 RC:ImgMsg图片消息  6表示分享类型消息 FW:CustomShareMsg
 *
 * em7接口说明： http://192.168.1.241:8076/web/#/1?page_id=256
 */function sendMsgToPC(conventioners,openType,groupName,extra,successCallBack,errorCallBack){if(window.emJoinStatus.joinStatus&&window.emJoinStatus.emSwitch==="1"){// em7
openEM7(conventioners,openType,groupName,extra,successCallBack,errorCallBack);}else{// em6
openEM6(conventioners,openType,groupName,extra,successCallBack,errorCallBack);}}var openEM6=function openEM6(conventioners,openType,groupName,extra,successCallBack,errorCallBack){$.ajax({url:"/social/im/SocialIMOperation.jsp?operation=openPCconversation",data:{conventioners:conventioners,openType:openType,groupName:groupName,extra:extra},type:"post",dataType:"json",contentType:"application/x-www-form-urlencoded; charset=utf-8",success:function success(data){if(data!=null){if(data.pcStatus==0&&data.webStatus==0){// pc和web都不在
_antd.Modal.warning({title:getLabel("15172","系统提示"),content:getLabel("386482","检查到您的web端和客户端的e-message不在线，请打开任意一端进行会话！")});}else if(data.webStatus==1){// web在线
if(_window2.default.getTop().$("#socialIMFrm").length>0){}else{if(!!window.ActiveXObject||"ActiveXObject"in window){_antd.message.error(getLabel("520784","您发起的e-message聊天已经建立，请到主页进行消息发送！"));}}}else{// pc在线不作判断
}typeof successCallBack==="function"&&successCallBack(data);}else{_antd.message.error(getLable("386484,","对话创建失败！"));typeof errorCallBack==="function"&&errorCallBack();}},error:function error(XMLHttpRequest,textStatus,errorThrown){_antd.message.error(getLable("386485","请求发送失败，请您检查当前网络！"));typeof errorCallBack==="function"&&errorCallBack();}});};var openEM7=function openEM7(conventioners,openType,groupName,extra,successCallBack,errorCallBack){var datas={};if(openType=="0"){// 单聊
datas={touserids:conventioners};}if(openType=="1"){// 群聊
datas={togroupids:conventioners};}if(openType=="2"){// 创建新的群聊
datas={create_group_members:conventioners};if(groupName&&groupName!==""){datas=(0,_extends3.default)({},datas,{create_group_name:groupName});}}(0,_callApi.callApi)("/api/ec/dev/share/openConversation","POST",{data:(0,_stringify2.default)(datas)}).then(function(result){if(result.status&&result.data.errcode===0){typeof successCallBack==="function"&&successCallBack(result);}else{_antd.message.error(result.data&&result.data.errmsg||getLable("386484","对话创建失败！"));typeof errorCallBack==="function"&&errorCallBack();}});};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[/* 1: /cloudstore/resource/pc/com/v1/ecCommin-1.css */"icon-xxx-form-Forward","icon-xxx-form-Opinion","icon-xxx-form-Quote","icon-xxx-form-top","icon-New-Flow-01","icon-New-Flow-02","icon-New-Flow-03","icon-New-Flow-04","icon-New-Flow-05","icon-New-Flow-06","icon-New-Flow-07","icon-New-Flow-08","icon-New-Flow-09","icon-New-Flow-10","icon-Achievements-Assessment","icon-communication-WeChat","icon-cooperation-Communicate","icon-cooperation-daily","icon-cooperation-ecology","icon-cooperation-emessage","icon-cooperation-emobile","icon-cooperation-eoffice","icon-cooperation-eteams","icon-cooperation-Task-cooperation","icon-customer-channel","icon-customer-feedback","icon-customer-partner","icon-customer-plug-in-unit","icon-customer-transfer","icon-Demonstration-Administration","icon-Demonstration-Backstage","icon-Demonstration-Execution-platform","icon-Demonstration-Experience-Edition","icon-Demonstration-Government-version","icon-Demonstration-Group-Edition","icon-Demonstration-industry","icon-Demonstration-special-demo","icon-Demonstration-Summary","icon-execution-platform-assessment","icon-execution-platform-cooperation","icon-execution-platform-plan","icon-execution-platform-target","icon-Integrate-Account-Settings","icon-Integrate-Agent","icon-Integrate-Drive","icon-Integrate-ecology-demo","icon-Integrate-elearning","icon-Integrate-email","icon-Integrate-eoffice-demo","icon-Integrate-eweaver-demo","icon-Integrate-Examination","icon-Integrate-faq","icon-Integrate-Fax","icon-Integrate-industry-demo","icon-Integrate-Integrate-demo","icon-Integrate-Landing-instructions","icon-Integrate-Report-form","icon-Integrate-special-demo","icon-Integrate-video-conferencing","icon-knowledge-books","icon-knowledge-expert","icon-knowledge-Full-text-search","icon-knowledge-map","icon-knowledge-patch","icon-knowledge-Q-n-A","icon-knowledge-tool","icon-Personnel-Bind-on-Account","icon-Personnel-Cockpit","icon-Personnel-recruit","icon-Personnel-Train2","icon-process-scene","icon-schedule-time","icon-login-Return","icon-login-accounts","icon-login-Password","icon-login-QR-code","icon-login-skin","icon-New-Flow-1","icon-New-Flow-2","icon-New-Flow-Letter","icon-New-Flow-menu","icon-New-Flow-type","icon-New-Flow-Administration","icon-New-Flow-agent","icon-New-Flow-Assets","icon-New-Flow-channel","icon-New-Flow-Collection","icon-New-Flow-contract","icon-New-Flow-Customer-service","icon-New-Flow-daily","icon-New-Flow-document","icon-New-Flow-leading-in","icon-New-Flow-market","icon-New-Flow-Personnel-matters","icon-New-Flow-printing","icon-New-Flow-project","icon-New-Flow-sales","icon-New-Flow-summary","icon-New-Flow-task","icon-New-Flow-Train","icon-New-Flow-upgrade","icon-accounts-Password","icon-accounts-quit","icon-accounts-Set-up","icon-accounts-skin","icon-album-homepage","icon-album-space","icon-Assets-Administration","icon-Assets-Asset-information","icon-Assets-Check","icon-Assets-My-assets","icon-Assets-search","icon-Assets-Storage","icon-car-Apply","icon-car-maintenance","icon-car-search","icon-car-Use-situation","icon-communication-Administration","icon-communication-binding","icon-communication-message","icon-communication-Newly-build","icon-communication-Send-out","icon-communication-vote","icon-communication-wechat","icon-cooperation-apply","icon-cooperation-approval","icon-cooperation-communication","icon-cooperation-monitor","icon-cooperation-my","icon-cooperation-platform","icon-cooperation-search","icon-cooperation-theme","icon-custom-service-investigation","icon-custom-service-research","icon-customer-birthday","icon-customer-contact","icon-customer-contacts","icon-customer-contract","icon-customer-lookup","icon-customer-mailing-list","icon-customer-manager","icon-customer-me","icon-customer-meeting","icon-customer-monitor","icon-customer-new","icon-customer-share","icon-Document-Already-in-box","icon-Document-Already-posting","icon-Document-Draft","icon-Document-inbox","icon-Document-monitor-inbox","icon-Document-monitor-send","icon-Document-My-in-box","icon-Document-My-posting","icon-Document-Receive","icon-Document-register","icon-Document-search-inbox","icon-Document-search-send","icon-Document-send-box","icon-Document-send","icon-Document-todo-inbox","icon-Document-todo-posting","icon-Gateway-Cloud-Bridge","icon-Gateway-company","icon-gateway-currency","icon-gateway-default","icon-Gateway-Marketing","icon-Gateway-personal","icon-Gateway-product","icon-gateway-technology","icon-knowledge-catalog","icon-knowledge-copy","icon-knowledge-fictitious","icon-knowledge-file","icon-knowledge-new-file","icon-knowledge-new","icon-knowledge-subscribe","icon-mail-contacts","icon-mail-delete","icon-mail-draft","icon-mail-enclosure","icon-mail-folder","icon-mail-inbox","icon-mail-label","icon-mail-send","icon-mail-star","icon-mail-todo","icon-meeting-cycle","icon-meeting-report-form","icon-meeting-room","icon-meeting-schedule","icon-meeting-task","icon-microblog-follow","icon-microblog-My","icon-microblog-Report-form","icon-microblog-Set-up","icon-news-Notice","icon-Personnel-Assessment","icon-Personnel-Check-work-attendance","icon-Personnel-My-card","icon-Personnel-new","icon-Personnel-On-line","icon-Personnel-Password","icon-Personnel-search","icon-Personnel-subordinate","icon-Personnel-Train","icon-Personnel-wages","icon-process-agent","icon-process-custom-query","icon-process-done","icon-process-monitor","icon-process-new","icon-process-query","icon-process-request","icon-process-supervise","icon-process-todo","icon-project-approval","icon-project-implement","icon-project-import","icon-project-my","icon-project-new","icon-project-query","icon-project-risk","icon-project-task","icon-project-todo","icon-report-form-meeting","icon-report-form-personnel","icon-schedule-all","icon-schedule-Communicate","icon-schedule-cycle","icon-schedule-My-schedule","icon-schedule-search","icon-schedule-Share","icon-search--flow-path","icon-search-asset","icon-search-communion","icon-search-cooperation","icon-search-Customer","icon-search-File","icon-search-item","icon-search-mail","icon-search-personnel","icon-search-search","icon-toolbar--pluggable-unit","icon-toolbar-Application-Center","icon-toolbar-control","icon-toolbar-doc","icon-toolbar-edition","icon-toolbar-know","icon-toolbar-license","icon-toolbar-Organization-list","icon-top-Arrow","icon-top-Collection","icon-top-Common","icon-top-emessage","icon-top-emobile","icon-top-home","icon-top-menu","icon-top-more","icon-top-news","icon-top-search","icon-top-Sign-sign-off","icon-coms-Message-center","icon-coms-Restore","icon-coms-Revocation","icon-coms-Delete","icon-coms-baiban","icon-coms-xiangpi","icon-coms-shouxie","icon-coms-huanhang","icon-coms-M","icon-coms-xiu","icon-coms-xia","icon-coms-shang","icon-coms-man","icon-coms-Anonymity","icon-coms-women1","icon-coms-government","icon-coms-up-001","icon-coms-down-001","icon-coms-and","icon-coms-changyong","icon-coms-or","icon-coms-shanchu","icon-coms-tianjia","icon-coms-release","icon-coms-men","icon-coms-women","icon-coms-Pending-push","icon-coms-authentication-center","icon-coms-biangengrizhi","icon-coms-danweishezhi","icon-coms-denglurizhi","icon-coms-fawen","icon-coms-rizhizhongxin","icon-coms-shoufawenrizhi","icon-coms-shouwen","icon-coms-yonghu","icon-coms-switch","icon-coms-line-2","icon-coms-line-1","icon-coms-shengji","icon-coms-daiban1","icon-coms-daiban","icon-coms-muluquanxian","icon-coms-mulujibenxinxi","icon-coms-mubanshezhi","icon-coms-banbenshezhi","icon-coms-bianhaoguize","icon-coms-Flag","icon-coms-move2","icon-coms-Service","icon-coms-language","icon-coms-Bar","icon-coms-Funnel","icon-coms-Gauge","icon-coms-Heatmap","icon-coms-Line","icon-coms-Map","icon-coms-Pie","icon-coms-Radar","icon-coms-Scatter","icon-coms-more","icon-coms-lcontract","icon-coms-deblock","icon-coms-Sealed","icon-coms-register","icon-coms-All-unfolding","icon-coms-All-contraction","icon-coms-synchronization","icon-coms-Update-synchronization","icon-coms-Save-as","icon-coms-complete","icon-coms-Synchro","icon-coms-classification","icon-coms-form-sap-1","icon-coms-Catalog","icon-coms-screen","icon-coms-screen2","icon-coms-Interface","icon-coms-replace","icon-coms-Department-number-hide","icon-coms-display","icon-coms-hide","icon-coms-form","icon-coms-20","icon-coms-19","icon-coms-18","icon-coms-17","icon-coms-16","icon-coms-15","icon-coms-14","icon-coms-13","icon-coms-12","icon-coms-11","icon-coms-10","icon-coms-9","icon-coms-8","icon-coms-7","icon-coms-6","icon-coms-5","icon-coms-4","icon-coms-3","icon-coms-2","icon-coms-1","icon-coms-Big-screen-sign","icon-coms-Sign","icon-coms-Web-service","icon-coms-Narrow","icon-coms-Enlarge","icon-coms-Left","icon-coms-Right","icon-coms-Proportion","icon-coms-Net-growth","icon-coms-Loss","icon-coms-Department-number","icon-coms-Delayed","icon-coms-Selected","icon-coms-Rightmenu-Revoke","icon-coms-Bold","icon-coms-Upload-successfully","icon-coms-Upload-successfully-o","icon-coms-Explain","icon-coms-menu-Receive","icon-coms-right","icon-coms-NoData","icon-coms-break-link","icon-coms-Italic","icon-coms-currency-Task","icon-coms-currency-Process","icon-coms-currency-Enclosure","icon-coms-currency-Customer","icon-coms-link","icon-coms-Quote","icon-coms-strikethrough","icon-coms-Underline","icon-coms-currency","icon-coms-Refresh","icon-coms-upload","icon-coms-download2","icon-coms-upper","icon-coms-Top-floor","icon-coms-text","icon-coms-Revoke2","icon-coms-redo","icon-coms-pic","icon-coms-lower","icon-coms-bottom-floor","icon-coms-background","icon-coms-Reset","icon-coms-Right-alignment","icon-coms-Center","icon-coms-alignment","icon-coms-Align-left","icon-coms-Add-to-o","icon-coms-CancelConcern","icon-coms-blog","icon-coms-car","icon-coms-common","icon-coms-cowork","icon-coms-crm","icon-coms-cs","icon-coms-demo","icon-coms-doc","icon-coms-email","icon-coms-fa","icon-coms-home","icon-coms-hrm","icon-coms-implement","icon-coms-investigate","icon-coms-kpi","icon-coms-license","icon-coms-meeting","icon-coms-message","icon-coms-news","icon-coms-official","icon-coms-Next-step","icon-coms-Last-step","icon-coms-go-back","icon-coms-search","icon-coms-Advice","icon-coms-Approval","icon-coms-Batch-delete","icon-coms-Batch-sharing","icon-coms-batch","icon-coms-Collection","icon-coms-copy","icon-coms-Custom","icon-coms-delete","icon-coms-Detailed","icon-coms-edit","icon-coms-Edition","icon-coms-Enable","icon-coms-photo","icon-coms-project","icon-coms-reportform","icon-coms-satisfaction","icon-coms-schedule","icon-coms-store","icon-coms-workflow","icon-coms-ws","icon-coms-AuthorityCenter-o","icon-coms-AuthorityCenter","icon-coms-CloudStore-o","icon-coms-CloudStore","icon-coms-content-o","icon-coms-integration-o","icon-coms-integration","icon-coms-Journal-o","icon-admin-portal-Journal2","icon-coms-MobileEngine-o","icon-coms-MobileEngine","icon-coms-ModelingEngine-o","icon-coms-ModelingEngine","icon-coms-Modular-o","icon-coms-Modular","icon-coms-operation-o","icon-coms-operation","icon-coms-portal-o","icon-coms-portal","icon-coms-Workflow-o","icon-coms-Workflow","icon-coms-export","icon-coms-File","icon-coms-Flow-setting","icon-coms-Forcible","icon-coms-help","icon-coms-Journal","icon-coms-leading-in","icon-coms-Need-feedback","icon-coms-New-Flow","icon-coms-overtime","icon-coms-PageAddress","icon-coms-Paste","icon-coms-Preservation","icon-coms-Print-log","icon-coms-Print","icon-coms-Reopen","icon-coms-Return","icon-coms-Revoke","icon-coms-Supervise","icon-coms-suspend","icon-coms-task-list","icon-coms-Trigger-process","icon-coms-Turn-to-do-need-feedback","icon-coms-WeChat","icon-coms-BatchEditing-Hot","icon-coms-Headquarters","icon-coms-LargeArea","icon-coms-transfer","icon-coms-Add-to-hot","icon-coms-Add-to","icon-coms-form-delete","icon-coms-form-sap","icon-coms-AddTo","icon-coms-download","icon-coms-HumanResources","icon-coms-DisplaySubordinates","icon-coms-NoAccountNoDisplay","icon-coms-NoDisplayOfSubordinates","icon-coms-ShowNoAccount","icon-coms-down","icon-coms-up","icon-coms-Branch","icon-coms-Headquarters-o","icon-coms-Batch-add-hot","icon-coms-Batch-add","icon-coms-Browse-box-add-all","icon-coms-Browse-box-Add-to","icon-coms-Browse-box-Delete-all","icon-coms-Browse-box-delete","icon-coms-copy-hot","icon-coms-form-copy","icon-coms-form-delete-hot","icon-coms-down2","icon-coms-up2","icon-coms-organization-down","icon-coms-organization-right","icon-coms-contrast-hot","icon-coms-contrast","icon-coms-Prompt","icon-coms-Relevant-project","icon-coms-Approval-o","icon-coms-Relevant-Customer","icon-coms-ID-Photo","icon-coms-Finance","icon-coms-e-message","icon-coms-Collection2","icon-coms-Planning-tasks","icon-coms-synergism","icon-coms-plus","icon-coms-locking-o","icon-coms-unlock","icon-coms-locking","icon-coms-little-e","icon-coms-Scan","icon-coms-New-schedule","icon-coms-Send-emails","icon-coms-Send-message","icon-coms-message-o","icon-coms-position","icon-coms-positive-sequence","icon-coms-Reverse","icon-uniEA15","icon-coms-at","icon-coms--postil","icon-coms-Related-account","icon-coms-Good","icon-coms-top","icon-coms-Subscribe","icon-coms-Read","icon-coms-move","icon-coms-List-display","icon-coms-chart","icon-coms-Cancel-top","icon-coms-Batch-download","icon-coms-Invalid","icon-coms-Clear","icon-coms-Tile","icon-coms-Tile-o","icon-coms-List","icon-coms-Column","icon-coms-category","icon-coms-plate","icon-coms-blank","icon-coms-Relevant-task","icon-coms-Release","icon-coms-New-schedule-o","icon-coms-New-customer","icon-uniEA57","icon-coms-contact","icon-coms-Business-opportunity","icon-coms-birthday","icon-coms-Relevant-workflow","icon-coms-word2","icon-coms-rar2","icon-coms-ppt2","icon-coms-pic2","icon-coms-pdf2","icon-coms-html2","icon-coms-excel2","icon-coms-Enclosure","icon-coms-currency2","icon-coms-New-SMS","icon-portal-AuthorityCenter-o","icon-portal-blog-o","icon-portal-car-o","icon-portal-common-o","icon-portal-cowork-o","icon-portal-crm-o","icon-portal-cs-o","icon-portal-demo-o","icon-portal-doc-o","icon-portal-email-o","icon-portal-fa-o","icon-portal-hrm-o","icon-portal-implement-o","icon-portal-Workflow","icon-portal-investigate-o","icon-portal-kpi-o","icon-portal-license-o","icon-portal-meeting-o","icon-portal-schedule-o","icon-portal-portal","icon-portal-operation","icon-portal-Modular","icon-portal-ModelingEngine","icon-portal-MobileEngine","icon-portal-Journal","icon-portal-integration","icon-portal-CloudStore","icon-portal-AuthorityCenter","icon-portal-Workflow-o","icon-portal-portal-o","icon-portal-operation-o","icon-portal-Modular-o","icon-portal-ModelingEngine-o","icon-portal-MobileEngine-o","icon-portal-Journal-o","icon-portal-integration-o","icon-portal-content-o","icon-portal-CloudStore-o","icon-portal-news-o","icon-portal-official-o","icon-portal-photo-o","icon-portal-project-o","icon-portal-reportform-o","icon-portal-satisfaction-o","icon-portal-si-o","icon-portal-ws-o","icon-portal-blog","icon-portal-car","icon-portal-common","icon-portal-cowork","icon-portal-crm","icon-portal-cs","icon-portal-demo","icon-portal-doc","icon-portal-email","icon-portal-fa","icon-portal-home","icon-portal-hrm","icon-portal-implement","icon-portal-investigate","icon-portal-kpi","icon-portal-license","icon-portal-meeting","icon-portal-message","icon-portal-news","icon-portal-official","icon-portal-photo","icon-portal-project","icon-portal-reportform","icon-portal-satisfaction","icon-portal-schedule","icon-portal-si","icon-portal-store","icon-portal-workflow","icon-portal-ws","icon-coms02-didi","icon-coms02-Initialization","icon-coms02-coms-Help-center","icon-coms02-coms-Authentication-server","icon-coms02-coms-Application-management","icon-coms02-Others","icon-coms02-Business-hospitality","icon-coms02-Meal-supplement","icon-coms02-communication","icon-coms02-Office","icon-coms02-Traffic","icon-coms02-Aircraft","icon-coms02-Train","icon-coms02-Bus","icon-coms02-Replenish-oil","icon-coms02-Accommodation","icon-coms02-ding","icon-coms02-Handwritten-signature-approval","icon-coms02-Negative-comment","icon-coms02-Negative-comment-o","icon-coms02-Finance-Wrong","icon-coms02-Finance-right","icon-coms02-coms-qiyuesuo","icon-coms02-coms-White-list","icon-coms02-Warning-01","icon-coms02-icon-Special-concern","icon-coms02-coms-Intelligent-prediction1","icon-coms02-coms-right-branch","icon-coms02-coms-left-branch","icon-coms02-Highlight","icon-coms02-Data-bar","icon-coms02-Greater-than","icon-coms02-Less-than","icon-coms02-Between","icon-coms02-Equal-to","icon-coms02-Text-contains","icon-coms02-Date","icon-coms02-Repeat-value","icon-coms02-coms-initialize","icon-coms02-coms-End","icon-coms02-coms-node","icon-coms02-coms-Intelligent-prediction","icon-coms02-Clearing-formula","icon-coms02-coms-voice","icon-coms02-coms-Video","icon-coms02-coms-Row-operation","icon-coms02-Reference","icon-coms02-preview","icon-coms02-Send-it-to-Weibo","icon-coms02-Custom-attribute","icon-coms02-Paste","icon-coms02-Style","icon-coms02-Lower-alignment","icon-coms02-Set-dimension","icon-coms02-Up-alignment","icon-coms02-Delete","icon-coms02-Clear-content1","icon-coms02-Clear-format1","icon-coms02-Line-width","icon-coms02-Box-selection","icon-coms02-Center-alignment","icon-coms02-Shear","icon-coms02-icon","icon-coms02-Row-height","icon-coms02-Formula-list","icon-coms02-Replication","icon-coms02-Paragraph-Left-alignment","icon-coms02-Paragraph-Right-alignment","icon-coms02-Paragraph-Center-alignment","icon-coms02-insert","icon-coms02-Merge-cell","icon-coms02-Template-initialization","icon-coms02-Clear-format","icon-coms02-Clear","icon-coms02-Display-table","icon-coms02-Format-brush","icon-coms02-coms2-Batch-export","icon-coms02-coms2-export","icon-coms02-Language","icon-coms02-Plug-in","icon-coms02-Overall-Arrangement","icon-coms02-Knowledge-tree","icon-coms02-Version","icon-coms02-e-mobile","icon-coms02-e-todo","icon-coms02-Font-setting","icon-coms02-Exit","icon-coms02-Theme-center","icon-coms02-authentication-center","icon-coms02-Explain","icon-coms02-locking-o","icon-coms02-currency","icon-coms02-Headquarters","icon-coms02-portal-ModelingEngine","icon-coms02-Full-selection","icon-coms02-Character-box","icon-coms02-word-Import","icon-coms02-Secondary-account-number","icon-coms02-Main-account-number","icon-coms02-initialize","icon-coms02-verification-code","icon-coms02-password","icon-coms02-user","icon-coms02-Derived","icon-coms02-Import","icon-coms02-Bank-Card","icon-coms02-Enterprise-integration","icon-coms02-top-news2","icon-coms02-Data-center","icon-coms02-icon-Revoked","icon-coms02-icon-Start","icon-coms02-icon-Completion","icon-coms02-icon-Completion-o","icon-coms02-icon-List-view","icon-coms02-icon-Classified-view","icon-coms02-icon-Hierarchical-view","icon-coms02-hide","icon-coms02-Warning","icon-coms02-rest","icon-coms02-work","icon-coms02-Exit-full-screen","icon-coms02-core-mail","icon-coms02-exmail-qq","icon-coms02-Label","icon-coms02-Choice","icon-coms02-download","icon-coms02-Report-form","icon-coms02-Check-work-attendance","icon-coms02-Positioning","icon-coms02-Cancel-leave","icon-coms02-backward","icon-coms02-Forward","icon-coms02-Sort","icon-coms02-Preview-1","icon-coms02-like-o","icon-coms02-like","icon-coms02-up-arrow","icon-coms02-ali-mail","icon-coms02-wangyi","icon-coms02-Exchange","icon-coms02-Save-as-template","icon-coms02-Add-to","icon-coms02-Initialize-template","icon-coms02-Mobile-template","icon-coms02-Template-import","icon-coms02-coms-preview","icon-coms02-To-be-read","icon-coms02-overtime","icon-coms02-make-a-copy-for","icon-coms02-Be-returned","icon-coms02-My-concern","icon-coms02-feedback","icon-coms02-Supervise","icon-coms02-Unread","icon-coms02-Pending-disposal","icon-coms02-all","icon-coms02-Robot","icon-coms02-Automatic-processing","icon-coms02-Seal","icon-coms02-Translation","icon-coms02-pdf","icon-coms02-Consultation","icon-coms02-Circulate","icon-coms02-Property-settings","icon-coms02-split","icon-coms02-oauth","icon-coms02-Forward-1","icon-coms02-Map-switching","icon-coms02-Save-as","icon-coms02-Portrait-of-personnel","icon-coms02-thumbnail","icon-coms02-Signature-verification","icon-coms02-Sign-off","icon-coms02-narrow","icon-coms02-enlarge","icon-coms02-topology","icon-coms02-Template-import1","icon-coms02-vote","icon-coms02-anti-clockwise","icon-coms02-coms-save-and-synchronize","icon-coms02-Hide-data","icon-coms02-Display-data","icon-coms02-Minus-sign","icon-coms02-countersign","icon-coms02-Replace-attachment","icon-coms02-edition","Icon-coms03-Conference-room-large-screen","Icon-coms03-rest","Icon-coms03-Waiting","Icon-coms03-Automatic-processing","Icon-coms03-Batch-forwarding","Icon-coms03-Release-preparation","Icon-coms03-leading-in","Icon-coms03-edesign","Icon-coms03-Sensitive-word-search","Icon-coms03-Sample-text-list","Icon-coms03-Red-formwork","Icon-coms03-communication-1","Icon-coms03-computer","Icon-coms03-demo","Icon-coms03-check-work-attendance","Icon-coms03-clue","Icon-coms03-examine","Icon-coms03-see","Icon-coms03-Sensitive-words","Icon-coms03-down","Icon-coms03-up","Icon-coms03-Sensitive-words-1","Icon-coms03-Robot-node","Icon-coms03-right","Icon-coms03-Change-form","Icon-coms03-Change-the-style"];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaInputSearch=__webpack_require__(46);var _weaInputSearch2=_interopRequireDefault(_weaInputSearch);var _objectAssign=__webpack_require__(99);var _objectAssign2=_interopRequireDefault(_objectAssign);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Tabs from '../../_antd1.11.2/tabs'
// import Row from '../../_antd1.11.2/row'
// import Col from '../../_antd1.11.2/col'
// import Input from '../../_antd1.11.2/input'
// import Button from '../../_antd1.11.2/button'
// import Menu from '../../_antd1.11.2/menu'
var getLabel=_weaLocaleProvider2.default.getLabel;var TabPane=_antd.Tabs.TabPane;var isIE8=window.navigator.appVersion.indexOf("MSIE 8.0")>=0;var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.state={showSearchAd:props.showSearchAd||false};return _this;}(0,_createClass3.default)(main,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return nextProps.showSearchAd!==this.props.showSearchAd||nextState.showSearchAd!==this.state.showSearchAd||nextProps.buttonsAd!==this.props.buttonsAd||nextProps.searchsAd!==this.props.searchsAd||nextProps.searchType!==this.props.searchType||nextProps.searchsBaseValue!==this.props.searchsBaseValue;}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.showSearchAd!==nextProps.showSearchAd){this.setState({showSearchAd:nextProps.showSearchAd});}}},{key:"render",value:function render(){var _this2=this;var that=this;var showSearchAd=this.state.showSearchAd;var _props=this.props,buttonsAd=_props.buttonsAd,searchsAd=_props.searchsAd,searchsBaseValue=_props.searchsBaseValue,tabs=_props.tabs,buttons=_props.buttons,addSelect=_props.addSelect,searchType=_props.searchType,height=_props.height,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style;var searchBase=(""+searchType).indexOf("base")>=0;var searchAdvanced=(""+searchType).indexOf("advanced")>=0;return React.createElement("div",{className:"wea-tab "+className,style:style},React.createElement(_antd.Row,null,React.createElement(_antd.Col,{xs:isIE8?15:12},tabs),React.createElement(_antd.Col,{xs:isIE8?9:12,style:{textAlign:"right"}},React.createElement("div",{className:"wea-search-tab"},buttons&&buttons.map(function(data){return React.createElement("span",{style:{marginLeft:15}},data);}),addSelect?addSelect:"",React.createElement("div",{className:"advance-search-wrapper"},searchBase&&React.createElement(_weaInputSearch2.default,{value:searchsBaseValue,onSearch:this.onSearch.bind(this),onSearchChange:this.onSearchChange.bind(this)}),searchAdvanced&&React.createElement(_antd.Button,{type:"ghost",className:"wea-advanced-search",onClick:this.setShowSearchAd.bind(this,true)},getLabel(347,"高级搜索")))))),React.createElement("div",{className:"wea-search-container",style:{display:showSearchAd?"block":"none"}},React.createElement(_antd.Button,{type:"ghost",className:"wea-advanced-search",onClick:this.setShowSearchAd.bind(this,false)},getLabel(347,"高级搜索")),React.createElement("div",{className:"wea-advanced-searchsAd",style:{maxHeight:height}},searchsAd),React.createElement("div",{className:"wea-search-buttons"},React.createElement("div",{style:{textAlign:"center"}},buttonsAd&&buttonsAd.map(function(data){return React.createElement("span",{style:{marginLeft:15}},data);})))),React.createElement("div",{className:"mask-dark",style:{display:showSearchAd?"block":"none"}}),React.createElement("div",{className:"mask-wrapper",style:{display:showSearchAd?"block":"none"},onClick:function onClick(){return _this2.props.hideSearchAd&&_this2.props.hideSearchAd();}}," "));}},{key:"onSearch",value:function onSearch(v){if(typeof this.props.onSearch=="function"){this.props.onSearch(v);}}},{key:"onSearchChange",value:function onSearchChange(v){if(typeof this.props.onSearchChange=="function"){this.props.onSearchChange(v);}}},{key:"setShowSearchAd",value:function setShowSearchAd(bool){this.setState({showSearchAd:bool});this.props.setShowSearchAd&&this.props.setShowSearchAd(bool);}}]);return main;}(React.Component);var Com=(0,_middleware2.default)(main,"WeaBrowserSearch");exports.default=Com;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TransferOperation=function(_React$Component){(0,_inherits3.default)(TransferOperation,_React$Component);function TransferOperation(){(0,_classCallCheck3.default)(this,TransferOperation);return(0,_possibleConstructorReturn3.default)(this,(TransferOperation.__proto__||(0,_getPrototypeOf2.default)(TransferOperation)).apply(this,arguments));}(0,_createClass3.default)(TransferOperation,[{key:"render",value:function render(){var _props=this.props,moveToLeft=_props.moveToLeft,moveToRight=_props.moveToRight,leftArrowText=_props.leftArrowText,rightArrowText=_props.rightArrowText,leftActive=_props.leftActive,rightActive=_props.rightActive,className=_props.className,leftAllActive=_props.leftAllActive,moveAllToLeft=_props.moveAllToLeft,rightAllActive=_props.rightAllActive,moveAllToRight=_props.moveAllToRight,leftActiveTitle=_props.leftActiveTitle,rightActiveTitle=_props.rightActiveTitle,leftAllActiveTitle=_props.leftAllActiveTitle,rightAllActiveTitle=_props.rightAllActiveTitle;var moveToRightButton=_react2.default.createElement(_antd.Button,{type:"primary",size:"small",disabled:!rightActive,onClick:moveToRight},_react2.default.createElement("span",{title:rightActiveTitle},_react2.default.createElement("i",{className:"icon-coms-Browse-box-Add-to"})));var moveToLeftButton=_react2.default.createElement(_antd.Button,{type:"primary",size:"small",disabled:!leftActive,onClick:moveToLeft},_react2.default.createElement("span",{title:leftActiveTitle},_react2.default.createElement("i",{className:"icon-coms-Browse-box-delete"})));var moveAllToRightButton=_react2.default.createElement(_antd.Button,{type:"primary",size:"small",disabled:!leftAllActive,onClick:moveAllToRight},_react2.default.createElement("span",{title:leftAllActiveTitle},_react2.default.createElement("i",{className:"icon-coms-Browse-box-add-all"})));var moveAllToLeftButton=_react2.default.createElement(_antd.Button,{type:"primary",size:"small",disabled:!rightAllActive,onClick:moveAllToLeft},_react2.default.createElement("span",{title:rightAllActiveTitle},_react2.default.createElement("i",{className:"icon-coms-Browse-box-Delete-all"})));return _react2.default.createElement("div",{className:className},moveToRightButton,moveToLeftButton,moveAllToRight&&moveAllToRightButton,moveAllToLeftButton);}}]);return TransferOperation;}(_react2.default.Component);exports.default=TransferOperation;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _uniqBy=__webpack_require__(104);var _uniqBy2=_interopRequireDefault(_uniqBy);var _debounce=__webpack_require__(67);var _debounce2=_interopRequireDefault(_debounce);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _weaInputSearch=__webpack_require__(46);var _weaInputSearch2=_interopRequireDefault(_weaInputSearch);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var TreeNode=_antd.Tree.TreeNode;var timeout=null;var text=function text(item,field){var text="";if(item[field]!==undefined){text=item[field];}if(item[field+"span"]!==undefined){text=item[field+"span"];}return text;};var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this2=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this2.state={key:""};return _this2;}(0,_createClass3.default)(main,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return this.props.data!==nextProps.data||this.state.key!==nextState.key||this.props.checkedKeys!==nextProps.checkedKeys;}},{key:"count",value:function count(item){if(item.type==="all")return item.count;return(item.users||[]).length;}},{key:"generateTreeNodes",value:function generateTreeNodes(){var _this3=this;var _props=this.props,data=_props.data,inputId=_props.inputId,inputName=_props.inputName,inputTop=_props.inputTop,inputBottom=_props.inputBottom,type=_props.type,hideNum=_props.hideNum;var key=this.state.key;var treeNodes=[];var showData=[].concat((0,_toConsumableArray3.default)(data));if(type==1||type==17){if((0,_trim2.default)(key)){showData=data.filter(function(item){var bool=false;bool=item.lastname.indexOf((0,_trim2.default)(key))>-1;if(!bool&&item.pingyinname){bool=item.pingyinname.indexOf((0,_trim2.default)(key))>-1;}return bool;});}this.nodeIds=[];this.nodeObj={};showData.map(function(item){var title=null;var crmNames=[];if(item.departmentname)crmNames.push(item.departmentname);if(item.supsubcompanyname)crmNames.push(item.supsubcompanyname);if(item.subcompanyname)crmNames.push(item.subcompanyname);item.crmNames=crmNames.join("／");if(item.type=="subcom"||item.type=="com"){title=React.createElement("div",{className:"tree-title"},React.createElement("i",{className:"icon-process-scene"}),React.createElement("span",{title:item.lastname},item.lastname),!hideNum&&"("+_this3.count(item)+")");}else if(item.type=="dept"){title=React.createElement("div",{className:"tree-title"},React.createElement("i",{className:"icon-mail-folder"})," ",React.createElement("span",{title:item.lastname},item.lastname),!hideNum&&"("+_this3.count(item)+")");}else if(item.type=="resource"){title=React.createElement("div",{className:"tree-title resource"},React.createElement("img",{className:"wea-tree-hr-portrait",src:item.icon,onError:function onError(){return item.icon=(window.ecologyContentPath||"")+"/cloudstore/resource/pc/com/images/portrait_default.jpg";},alt:"img"}),React.createElement("div",{className:"resource-content breakall"},React.createElement("div",null,inputTop||inputBottom?(inputTop||[]).map(function(field){return React.createElement("span",{style:{marginRight:5},dangerouslySetInnerHTML:{__html:text(item,field)}});}):[React.createElement("span",{className:"lastname",title:item.lastname},item.lastname),React.createElement("span",{className:"jobtitlename gray",title:item.jobtitlename},item.jobtitlename)]),React.createElement("div",null,inputTop||inputBottom?(inputBottom||[]).map(function(field){return React.createElement("span",{style:{marginRight:5},dangerouslySetInnerHTML:{__html:text(item,field)}});}):React.createElement("div",{className:"overflow gray",title:item.crmNames},item.crmNames))));}else{title=React.createElement("div",{className:"tree-title"},React.createElement("i",{className:"icon-process-scene"}),React.createElement("span",{title:item.lastname},item.lastname),!hideNum&&"("+_this3.count(item)+")");}treeNodes.push(React.createElement(TreeNode,{title:title,name:item.lastname,jobtitlename:item.jobtitlename,key:item.nodeid,isLeaf:true,id:item.id,type:item.type}));_this3.nodeIds.push(item.nodeid);_this3.nodeObj[item.nodeid]=item;});}else if(inputId){if((0,_trim2.default)(key)){showData=showData.filter(function(item){// return encodeURI(item[inputTop[0]]).indexOf(encodeURI(trim(key))) > -1;
if(inputTop.length>0){return item[inputTop[0]].indexOf((0,_trim2.default)(key))>-1;}else{return item[inputName]&&item[inputName].indexOf((0,_trim2.default)(key))>-1;}});}showData=(0,_uniqBy2.default)(showData,inputId||"id");this.nodeIds=[];this.nodeObj={};showData.map(function(item){var top=[];var bottom=[];inputTop&&inputTop.forEach(function(field){top.push(React.createElement("span",{style:{marginRight:"5px"},dangerouslySetInnerHTML:{__html:text(item,field)}}));});inputBottom&&inputBottom.forEach(function(field){bottom.push(React.createElement("span",{style:{marginRight:"5px"},dangerouslySetInnerHTML:{__html:text(item,field)}}));});var title=React.createElement("div",null,React.createElement("div",{className:"item-wrap"},React.createElement("div",{className:"item-top"},top),React.createElement("div",{className:"item-bottom"},bottom)));treeNodes.push(React.createElement(TreeNode,{title:title,key:item[inputId],isLeaf:true}));_this3.nodeIds.push(item[inputId]);_this3.nodeObj[item[inputId]]=item;});}return treeNodes;}},{key:"onSearchChange",value:function onSearchChange(v){this.setState({key:v});}},{key:"reset",value:function reset(){this.setState({key:""});}},{key:"checkHandler",value:function checkHandler(v,p){var _this=this;// 取消上次延时未执行的方法
clearTimeout(timeout);//执行延时
timeout=setTimeout(function(){_this.props.checkedCb&&_this.props.checkedCb(v);},200);}},{key:"onDoubleClick",value:function onDoubleClick(key){clearTimeout(timeout);this.props.onDoubleClick&&this.props.onDoubleClick(key);}},{key:"onDragStart",value:function onDragStart(obj){clearTimeout(timeout);this.props.checkedCb&&this.props.checkedCb([]);}},{key:"onDrop",value:function onDrop(obj){var _this4=this;var dragNodes=obj.dragNodesKeys;var targetNode=obj.node.props.eventKey;var result=[];this.nodeIds.filter(function(item){return dragNodes.indexOf(item)===-1;}).forEach(function(id){if(id===targetNode){dragNodes.forEach(function(drag){result.push(_this4.nodeObj[drag]);});}result.push(_this4.nodeObj[id]);});this.props.onDrag&&this.props.onDrag(result);}},{key:"render",value:function render(){var _props2=this.props,checkedKeys=_props2.checkedKeys,height=_props2.height;var treeNodes=this.generateTreeNodes();return React.createElement("div",{className:"wea-transfer-right"},React.createElement(_weaInputSearch2.default,{onSearchChange:(0,_debounce2.default)(this.onSearchChange,200).bind(this),placeholder:getLabel(83788,"请输入关键字搜索"),value:this.state.key}),React.createElement("div",null,React.createElement(_weaNewScroll2.default,{height:height||400},React.createElement(_antd.Tree,{className:"transfer-tree",draggable:true,onDragStart:this.onDragStart.bind(this),onDrop:this.onDrop.bind(this),onSelect:this.checkHandler.bind(this),onDoubleClick:this.onDoubleClick.bind(this),selectedKeys:checkedKeys,multiple:true,async:true,selectable:true},treeNodes))));}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _class,_temp,_initialiseProps;var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 插值工具函数
 * 传入一个目标值，然后会循环调用初始化中传入的 poster 函数，返回生成的中间值
 * 使用方式
 * 1. 初始化
 * const lerp = new Lerp({
 *     data: {x: 0, y: 0},
 *     poster: (curr, diff) => {}
 * })
 * 2. 启动
 * lerp.go({
 *     x: imgPosX,
 *     y: imgPosY
 * })
 * 3. 中断
 * lerp.stop()
 **/var Lerp=(_temp=_class=function Lerp(_ref){var data=_ref.data,poster=_ref.poster;(0,_classCallCheck3.default)(this,Lerp);_initialiseProps.call(this);// 是否正在执行插值循环
this.looping=false;// 目标池
this.pool=data||{value:0// 当前值
};this.current=data||{value:0// 发送器
};this._postValue=poster||this._postValue;// 插值系数
this.attr=0.25;// 定时器引用
this._timer=null;}// *******
// 接口方法
// *******
// 启动循环
// 终止循环
// *******
// 内部方法
// *******
// 执行循环
// *******
// 插值函数
// *******
// 线性插值
// *******
// 重载函数
// *******
// 发送器
// 前置函数
// 后置函数
,_initialiseProps=function _initialiseProps(){var _this=this;this.to=function(_ref2){var data=_ref2.data,before=_ref2.before,after=_ref2.after,attr=_ref2.attr;// 更新参数
_this.pool=data||_this.pool;// 前置与后置函数
_this._before=before||_this._before;_this._after=after||_this._after;// 插值系数
_this.attr=attr||_this.attr;// 启动循环
_this._startLoop();};this.stop=this._stopLoop;this._startLoop=function(){!_this.looping&&_this._runLoop();_this.looping=true;};this._runLoop=function(){_this._before();_this._timer=window.requestAnimationFrame(_this._loop);// IE9支持
// if (isFunction(window.requestAnimationFrame)) {
// this._timer = window.requestAnimationFrame(this._loop)
// } else {
//   this._loop();
// }
};this._loop=function(){// 插值
var pulse={};for(var key in _this.pool){pulse[key]=_this._lerp(_this.current[key],_this.pool[key]);}// 更新当前值
for(var _key in _this.current){_this.current[_key]+=pulse[_key];}// 发送计算结果
_this._postValue(_this.current,pulse);// 根据处理结果选择是否需要继续迭代
var needLoop=false;for(var _key2 in _this.current){if(Math.abs(_this.pool[_key2]-_this.current[_key2])>0.0005){needLoop=true;}}needLoop?_this._runLoop():_this._stopLoop();};this._stopLoop=function(){// IE9处理
if((0,_isFunction2.default)(window.cancelAnimationFrame)){_this.looping&&window.cancelAnimationFrame(_this._timer);}else{}_this.looping=false;_this._after();};this._lerp=function(src,dest){return(dest-src)*_this.attr;};this._postValue=function(curr,diff){};this._before=function(){};this._after=function(){};},_temp);exports.default=Lerp;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _weaError=__webpack_require__(82);var _weaError2=_interopRequireDefault(_weaError);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _weaDialog=__webpack_require__(55);var _weaDialog2=_interopRequireDefault(_weaDialog);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _Search=__webpack_require__(718);var _Search2=_interopRequireDefault(_Search);var _constant=__webpack_require__(719);var _constant2=_interopRequireDefault(_constant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLoginConditions=_constant2.default.getLoginConditions;var getLabel=_weaLocaleProvider2.default.getLabel;var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.initConditions=function(){if(_this.state.visible){_this.setState({loginCondtions:getLoginConditions({account:_this.state.csAccount,password:_this.state.csPassword,explain:getLabel("82279","点击查看")},{account:getLabel("517387","云商店账号"),password:getLabel("518771","云商店账号密码"),explain:getLabel("518772","云商店登录和分享说明")})});}};_this.onCancel=function(){var onCancel=_this.props.onCancel;_this.setState({visible:false});typeof onCancel==="function"&&onCancel();};_this.changeCondition=function(fields){if(fields.account){_this.setState({csAccount:fields.account.value});}if(fields.password){_this.setState({csPassword:fields.password.value});}};_this.checkNull=function(val){return!val||val==="";};_this.bindToken=function(){var _this$state=_this.state,csAccount=_this$state.csAccount,csPassword=_this$state.csPassword;var pass=true;if(_this.checkNull(csAccount)){_this.WeaEcodeUploadLogin_account.showError();pass=false;}if(_this.checkNull(csPassword)){_this.WeaEcodeUploadLogin_password.showError();pass=false;}if(pass){_this.setState({loading:true});_weaTools2.default.callApi("/api/ecode/demo/bindTokens","POST",{account:csAccount,password:csPassword}).then(function(data){_this.setState({loading:false});if(data.api_status){_weaTools2.default.ls.set("csToken",data.cs_token);_this.onCancel();}else{_antd.message.error(data.msg);}});}};_this.state={visible:props.visible||false,csAccount:"",csPassword:"",loginCondtions:getLoginConditions(),loading:false};return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var visible=this.props.visible;this.setState({visible:visible},function(){_this2.initConditions();});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;var visible=nextProps.visible;var _visible=this.props.visible;if(visible!==_visible){this.setState({visible:visible},function(){_this3.initConditions();});}}},{key:"render",value:function render(){var _this4=this;var _props=this.props,prefixCls=_props.prefixCls,modalStyle=_props.modalStyle,icon=_props.icon,iconBgcolor=_props.iconBgcolor;var _state=this.state,visible=_state.visible,loading=_state.loading,loginCondtions=_state.loginCondtions;var buttons=[React.createElement(_antd.Button,{type:"primary",key:"ok",loading:loading,onClick:this.bindToken},getLabel("83446","确定")),React.createElement(_antd.Button,{key:"cancel",onClick:this.onCancel},getLabel("201","取消"))];return React.createElement("div",{className:prefixCls},React.createElement(_weaDialog2.default,{destroyBodyOnClose:true,style:modalStyle,visible:visible,title:getLabel("518774","登录云商店"),icon:icon,iconBgcolor:iconBgcolor,maskClosable:false,buttons:buttons,onCancel:this.onCancel},React.createElement(_Search2.default,{browserConditions:loginCondtions,changeCondition:this.changeCondition,ref:function ref(el){return _this4.ecodeUploadLogin=el;},errorCom:function errorCom(field,children){return React.createElement(_weaError2.default,{ref:function ref(el){return _this4["WeaEcodeUploadLogin_"+field.domkey]=el;},className:"wea-ecode-upload-errorTip",error:""+field.label+getLabel("386957",":attribute 未填写").replace(/:attribute/,""),tipPosition:"bottom"},children);}})));}}]);return Main;}(React.Component),_class.defaultProps={prefixCls:"wea-ecode-login",modalStyle:{width:600}},_temp);exports.default=Main;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 988));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Com;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);__webpack_require__(749);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(){(0,_classCallCheck3.default)(this,main);return(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).apply(this,arguments));}(0,_createClass3.default)(main,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return this.props.type!==nextProps.type||this.props.className!==nextProps.className||this.props.viewAttr!==nextProps.viewAttr||this.props.value!==nextProps.value;}},{key:"render",value:function render(){var _props=this.props,type=_props.type,finNum=_props.finNum,className=_props.className,style=_props.style,ecId=_props.ecId;var showTds=new Array();if(type===1){//财务表头
var _props2=this.props,fontSize=_props2.fontSize,label=_props2.label;if(!fontSize)fontSize="9pt";//字体大小为pt单位，默认9pt
var headArr=["分","角","元","十","百","千","万","十","百","千","亿","十"];for(var i=finNum-1;i>=0;i--){var itemBorder="fborder1";if(i===0)itemBorder="";else if(i===2)itemBorder="fborder2";else if((i-2)%3===0)itemBorder="fborder3";itemBorder="finborder "+itemBorder;showTds.push(React.createElement("td",{className:itemBorder},headArr[i]));}return React.createElement("div",{className:"wf-findiv",style:style},React.createElement("div",{className:"fintop"},label),React.createElement("div",{className:"finbottom"},React.createElement("table",{className:"fintable "+className},React.createElement("tr",null,showTds))),React.createElement("style",null,"."+className+" td{width:"+parseInt(fontSize.replace("pt",""))*2+"px;}"));}else if(type===2){//财务表览
var _props3=this.props,viewAttr=_props3.viewAttr,value=_props3.value,clickEvent=_props3.clickEvent;var valArr=this.transFinancialArr(value);for(var _i=finNum-1;_i>=0;_i--){var _itemBorder="fborder1";if(_i===0)_itemBorder="";else if(_i===2)_itemBorder="fborder2";else if((_i-2)%3===0)_itemBorder="fborder3";_itemBorder="finborder "+_itemBorder;showTds.push(React.createElement("td",{className:_itemBorder},valArr[_i]||""));}return React.createElement("div",{className:"wf-findiv",onClick:clickEvent,ecId:ecId+"-div@khjzgt"},React.createElement("table",{className:"fintable "+className},React.createElement("tr",null,showTds)));}else return React.createElement("span",null);}},{key:"transFinancialArr",value:function transFinancialArr(fieldVal){var valArr=new Array();if(fieldVal===""||fieldVal===null){if(this.props.viewAttr===3)//必填标示
valArr.push(React.createElement("span",{className:"wea-f14",style:{color:"red !important"}},"*"));return valArr;}fieldVal=fieldVal.replace(/,/g,"");var reg1=/^(-?\d+)(\.\d+)?$/;var reg2=/^(-?\d*)(\.\d+)$/;//解决类型-.22这种格式
if(reg1.test(fieldVal)||reg2.test(fieldVal)){fieldVal=parseFloat(fieldVal).toFixed(2);if(fieldVal.length>2&&fieldVal.substring(0,2)=="0."||fieldVal.length>3&&fieldVal.substring(0,3)=="-0."){fieldVal=fieldVal.replace("0.",".");}for(var i=fieldVal.length-1;i>=0;i--){var valc=fieldVal.charAt(i);if(valc!=".")valArr.push(valc);}}return valArr;}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.text=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);exports.joinArray=joinArray;exports.stopPropagation=stopPropagation;exports.getMethod=getMethod;exports.getValueWarp=getValueWarp;exports.getPageSize=getPageSize;exports.getSelectAllMaxSize=getSelectAllMaxSize;exports.filterHtmlInText=filterHtmlInText;var _userAgent=__webpack_require__(121);var _callApi=__webpack_require__(17);var _Encry=__webpack_require__(51);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 用于合并tabs
function joinArray(target,origin){var union=[];target.forEach(function(element){var originEle=origin.find(function(o){return o.key==element.key;})||{};union.push((0,_extends3.default)({},originEle,element,{dataParams:(0,_extends3.default)({},originEle.dataParams||{},element.dataParams||{}),browserProps:(0,_extends3.default)({},originEle.browserProps||{},element.browserProps||{})}));});return union;}// 阻止事件默认行为
function stopPropagation(e){if(!e)return;e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();if(e.nativeEvent){e.nativeEvent.stopImmediatePropagation&&e.nativeEvent.stopImmediatePropagation();e.nativeEvent.preventDefault&&e.nativeEvent.preventDefault();}}// 根据参数的长度来判断是否需要使用POST方式
function getMethod(){var url=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var uri=url+"?"+(0,_callApi.getFd)(params);var maxLength=_userAgent.ua.browser=="IE"?2000:6000;return uri.length>maxLength?"POST":"GET";}// 获取浏览按钮已选数据在输入框中是否需要换行显示
function getValueWarp(browserProps){if(!browserProps)return false;var type=browserProps.type,isSingle=browserProps.isSingle,dataParams=browserProps.dataParams;var browserConfig=window.ecBrowserConfig||{};var typeList=browserConfig.typeList;var types=typeList||[];var valueWarp=void 0;if(isSingle){valueWarp=false;}else if(type===162||type==="162"){// 自定义多选
valueWarp=types.indexOf(""+dataParams.type)!==-1;}else if(type===257||type==="257"){// 自定义树形多选
valueWarp=types.indexOf("tree."+dataParams.treeid)!==-1;}else{// 其他多选浏览按钮
valueWarp=types.indexOf(""+type)!==-1;}return valueWarp;}// 获取浏览按钮每页显示条数
function getPageSize(browserProps){if(!browserProps)return false;var type=browserProps.type,dataParams=browserProps.dataParams;var browserConfig=window.ecBrowserConfig||{};var pageConfigList=browserConfig.pageConfigList,dps=browserConfig.defaultPageSize;var configList=pageConfigList||[];var defaultPageSize=dps||10;var pageSize=defaultPageSize;configList.map(function(item){if(item.browserType==type){pageSize=item.pageSize;}else if(type==161||type==162){if(item.browserType==dataParams.type){pageSize=item.pageSize;}}});return pageSize;}var text=exports.text=function text(item,field,pure){var text="";if(item[field]!==undefined){text=item[field];}if(item[field+"span"]!==undefined){text=item[field+"span"];}if(!pure){if((0,_Encry.desensitization)(text)){return React.createElement(_Encry.Encry,{value:text});}else if((0,_Encry.encryption)(text)){text=(0,_Encry.replaceEncryption)(text);}}return text;};// 获取【全部添加】一次最多添加条数
function getSelectAllMaxSize(browserProps){if(!browserProps)return false;var type=browserProps.type;var browserConfig=window.ecBrowserConfig||{};var selectAllTypeList=browserConfig.selectAllTypeList,defaultSelectAllMaxSize=browserConfig.defaultSelectAllMaxSize;var typeList=selectAllTypeList||["17"];var maxSize=defaultSelectAllMaxSize||500;return typeList.indexOf(""+type)!==-1?maxSize:0;}// 过滤文本中的html标签
function filterHtmlInText(text){if(typeof text==="string"){return text.replace(/<[^<>]+>/g,"");}return text;}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(100);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);exports.getModuleRender=getModuleRender;exports.getSelectDefaultValue=getSelectDefaultValue;exports.getComponent=getComponent;exports.getParamsByConditions=getParamsByConditions;var _weaInput=__webpack_require__(56);var _weaInput2=_interopRequireDefault(_weaInput);var _weaTextarea=__webpack_require__(66);var _weaTextarea2=_interopRequireDefault(_weaTextarea);var _weaDateGroup=__webpack_require__(202);var _weaDateGroup2=_interopRequireDefault(_weaDateGroup);var _weaSelect=__webpack_require__(50);var _weaSelect2=_interopRequireDefault(_weaSelect);var _weaBrowser=__webpack_require__(80);var _weaBrowser2=_interopRequireDefault(_weaBrowser);var _weaCheckbox=__webpack_require__(132);var _weaCheckbox2=_interopRequireDefault(_weaCheckbox);var _weaSelectGroup=__webpack_require__(137);var _weaSelectGroup2=_interopRequireDefault(_weaSelectGroup);var _weaScope=__webpack_require__(136);var _weaScope2=_interopRequireDefault(_weaScope);var _weaDatePicker=__webpack_require__(133);var _weaDatePicker2=_interopRequireDefault(_weaDatePicker);var _weaTimePicker=__webpack_require__(98);var _weaTimePicker2=_interopRequireDefault(_weaTimePicker);var _weaRangePicker=__webpack_require__(102);var _weaRangePicker2=_interopRequireDefault(_weaRangePicker);var _weaTimeRangePicker=__webpack_require__(152);var _weaTimeRangePicker2=_interopRequireDefault(_weaTimeRangePicker);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _isArray=__webpack_require__(21);var _isArray2=_interopRequireDefault(_isArray);var _isObject=__webpack_require__(40);var _isObject2=_interopRequireDefault(_isObject);var _forEach=__webpack_require__(81);var _forEach2=_interopRequireDefault(_forEach);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var getBrowserValue=function getBrowserValue(field){if(!(0,_isEmpty2.default)(field.browserConditionParam)){var replacesDatas=field.browserConditionParam.replaceDatas||field.browserConditionParam.valueObj;if(!(0,_isEmpty2.default)(replacesDatas)){var values=[],names=[];replacesDatas.forEach(function(d){if(d){values.push(d.id);names.push(d.lastname||d.name);// 人力按钮特殊处理
}});return{value:values.join(","),valueSpan:names.join(","),valueObj:replacesDatas};}}};function getModuleRender(){var modules=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var key=arguments[1];var content=arguments[2];var context=arguments[3];var module=modules[key];if(module){if(typeof module==="function"){content=module(context);}content=module;}return content;}function getSelectDefaultValue(options,type){var value="";if(type==5){(0,_forEach2.default)(options,function(o){o.options&&(0,_forEach2.default)(o.options,function(option){if(option.selected)value=option.key;});});}else{// 获取单选和多选的初始值
var arr=[];(0,_forEach2.default)(options,function(option){if(option.selected){arr.push(option.key);}});value=arr.join(",");}return value;}function getComponent(){var conditionType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"input";var browserConditionParam=arguments[1];var domkey=arguments[2];var props=arguments[3];var field=arguments[4];var hasUnderline=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;var ct=conditionType.toUpperCase();var _props$form=props.form,getFieldProps=_props$form.getFieldProps,setFieldsValue=_props$form.setFieldsValue;if(ct=="RANGEPICKER"){return React.createElement(_weaRangePicker2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaRangePicker@bfgswf"},field.otherParams,getFieldProps(domkey[0],{initialValue:field.value}),{viewAttr:field.viewAttr}));}if(ct=="TIMERANGEPICKER"){return React.createElement(_weaTimeRangePicker2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaTimeRangePicker@qw3tb8"},field.otherParams,getFieldProps(domkey[0],{initialValue:field.value}),{viewAttr:field.viewAttr}));}if(ct=="INPUT"){return React.createElement(_weaInput2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaInput@f69azh"},getFieldProps(domkey[0],{initialValue:field.value}),field.otherParams,{length:field.length,viewAttr:field.viewAttr,hasBorder:!hasUnderline,underline:hasUnderline}));}if(ct=="TEXTAREA"){return React.createElement(_weaTextarea2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaTextarea@mxfafu"},field.otherParams,getFieldProps(domkey[0],{initialValue:field.value}),{length:field.length,minRows:field.minRows?field.minRows:2,maxRows:field.maxRows,viewAttr:field.viewAttr}));}if(ct=="SELECT"){return React.createElement(_weaSelect2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaSelect@9hp0z3"},field.otherParams,getFieldProps(domkey[0],{initialValue:getSelectDefaultValue(field.options)}),{detailtype:field.detailtype||1,options:field.options,viewAttr:field.viewAttr,hasBorder:!hasUnderline,underline:hasUnderline,onChange:function onChange(value){var nState={};nState[""+domkey[0]]=value;setFieldsValue(nState);}}));}if(ct=="BROWSER"){var showDropMenu=browserConditionParam.type=="4"||browserConditionParam.type=="164";// 部门分部显示维度菜单
var v="";var res=getBrowserValue(field);if(res&&res.value)v=res.value;var otherParams=browserConditionParam?browserConditionParam.otherParams:{};return React.createElement(_weaBrowser2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaBrowser@8jgtt1"},field.otherParams,{isAdSearch:true,hasBorder:!hasUnderline,underline:hasUnderline},browserConditionParam,otherParams,{replaceNotCtrl:true// 浏览按钮高级搜索里面的浏览按钮特殊处理
,showDropMenu:showDropMenu},getFieldProps(domkey[0],{initialValue:v}),{onChange:function onChange(value,valueSpan,valueObj){var nState={};nState[""+domkey[0]]=value;setFieldsValue(nState,valueSpan,valueObj);}}));}if(ct=="DATE"){var value="0";if(!(0,_isEmpty2.default)(field.value)){value=field.value[domkey[0]];}var datas=[{value:"0",name:getLabel(332,"全部")},{value:"1",name:getLabel(15537,"今天")},{value:"2",name:getLabel(15539,"本周")},{value:"3",name:getLabel(15541,"本月")},{value:"4",name:getLabel(21904,"本季")},{value:"5",name:getLabel(15384,"本年")},{value:"7",name:getLabel(27347,"上个月")},{value:"8",name:getLabel(81716,"上一年")},{value:"6",name:getLabel(32530,"指定日期范围")}];if(!(0,_isEmpty2.default)(field.options)){datas=[];field.options.forEach(function(o){datas.push({value:o.key,name:o.showname});});}return React.createElement(_weaDateGroup2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaDateGroup@e5kqa6"},field.otherParams,getFieldProps(domkey[0],{initialValue:value}),{datas:datas,form:props.form,values:field.value,domkey:domkey,viewAttr:field.viewAttr}));}if(ct=="CHECKBOX"){return React.createElement(_weaCheckbox2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaCheckbox@1duxce"},field.otherParams,getFieldProps(domkey[0],{initialValue:field.value}),{viewAttr:field.viewAttr}));}if(ct=="SWITCH"){return React.createElement(_weaCheckbox2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaCheckbox@wf4qql"},field.otherParams,getFieldProps(domkey[0],{initialValue:field.value}),{viewAttr:field.viewAttr,display:"switch"}));}if(ct=="SELECT_LINKAGE"){return React.createElement(_weaSelectGroup2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaSelectGroup@2ptte8"},field.otherParams,getFieldProps(domkey[0],{initialValue:getSelectDefaultValue(field.options)}),{selectWidth:field.selectWidth,options:field.options,selectLinkageDatas:field.selectLinkageDatas,form:props.form,domkey:domkey,viewAttr:field.viewAttr}));}if(ct=="SCOPE"){return React.createElement(_weaScope2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaScope@07426r",step:field.step},field.otherParams,getFieldProps(domkey[0]),{startValue:field.startValue,endValue:field.endValue,min:field.min,max:field.max,form:props.form,domkey:domkey,viewAttr:field.viewAttr}));}if(ct=="DATEPICKER"){return React.createElement(_weaDatePicker2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaDatePicker@4rtn76"},field.otherParams,getFieldProps(domkey[0],{initialValue:field.value}),{formatPattern:field.formatPattern||2,viewAttr:field.viewAttr,hasBorder:!hasUnderline,underline:hasUnderline}));}if(ct=="TIMEPICKER"){return React.createElement(_weaTimePicker2.default,(0,_extends3.default)({ecId:props.ecId+"_WeaTimePicker@5k8o3p"},field.otherParams,getFieldProps(domkey[0],{initialValue:field.value}),{formatPattern:field.formatPattern||3,viewAttr:field.viewAttr,hasBorder:!hasUnderline,underline:hasUnderline}));}}function getParamsByConditions(conditions){var params={};!(0,_isEmpty2.default)(conditions)&&conditions.forEach(function(c){var conditionType=c.conditionType;if(conditionType=="INPUT"){if(c.value)params[c.domkey[0]]=c.value;}if(conditionType=="SELECT"){var value=getSelectDefaultValue(c.options);if(value)params[c.domkey[0]]=value;}if(conditionType=="BROWSER"){if(!(0,_isEmpty2.default)(c.browserConditionParam)){var replacesDatas=c.browserConditionParam.replaceDatas;var values=[],_value=void 0;!(0,_isEmpty2.default)(replacesDatas)&&replacesDatas.forEach(function(d){values.push(d.id);});_value=values.join(",");if(_value)params[c.domkey[0]]=_value;}}if(conditionType=="DATE"){if(!(0,_isEmpty2.default)(c.value)&&(0,_isArray2.default)(c.domkey)&&(0,_isObject2.default)(c.value)){c.domkey.forEach(function(d){if(c.value[d]){params[d]=c.value[d];}});}}if(conditionType==="SELECT_LINKAGE"){var selectValue=getSelectDefaultValue(c.options);params[c.domkey[0]]=selectValue;if(c.selectLinkageDatas){var sld=c.selectLinkageDatas[selectValue];sld=sld?[sld]:[];params=(0,_assign2.default)(params,getParamsByConditions(sld));}}if(conditionType=="SCOPE"){if(c.startValue!==undefined)params[c.domkey[0]]=c.startValue;if(c.endValue!==undefined)params[c.domkey[1]]=c.endValue;}if(conditionType=="TIMERANGEPICKER"||conditionType=="RANGEPICKER"){if(c.value&&Array.isArray(c.value)){params[c.domkey[0]]=c.value;}}});return params;}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;// import Row from '../../_antd1.11.2/row'
// import Col from '../../_antd1.11.2/col'
// import Button from '../../_antd1.11.2/button'
// import Icon from '../../_antd1.11.2/icon'
// import message from '../../_antd1.11.2/message'
// import Modal from '../../_antd1.11.2/modal';
// import Progress from '../../_antd1.11.2/progress';
var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _loadjs=__webpack_require__(54);var _loadjs2=_interopRequireDefault(_loadjs);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _storage=__webpack_require__(60);var _callApi=__webpack_require__(17);var _userAgent=__webpack_require__(121);var _weaInput=__webpack_require__(56);var _weaInput2=_interopRequireDefault(_weaInput);var _weaTextarea=__webpack_require__(66);var _weaTextarea2=_interopRequireDefault(_weaTextarea);var _weaDragula=__webpack_require__(153);var _weaDragula2=_interopRequireDefault(_weaDragula);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);var _weaPopoverHrm=__webpack_require__(217);var _weaPopoverHrm2=_interopRequireDefault(_weaPopoverHrm);var _secLevelDialog=__webpack_require__(698);var _secLevelDialog2=_interopRequireDefault(_secLevelDialog);var _sensitiveDialog=__webpack_require__(699);var _sensitiveDialog2=_interopRequireDefault(_sensitiveDialog);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var confirm=_antd.Modal.confirm;// const casProtect = ls.getJSONObj("isOpenClassification") || false;
// import plupload from 'plupload';
// 全局没有问题，打包会 flash 初始化加载会失败 dom 节点都正常
// 下边是官方给出的解决方法，需要全局回调， https://github.com/moxiecode/plupload/issues/1494#issuecomment-317610380
// window.flash_callback_with_unique_name = function (event) {
//  plupload.Uploader.prototype.dispatchEvent(event);
// };
//
// plupload.ua.global_event_dispatcher = 'flash_callback_with_unique_name';
// 判断浏览器是否安装flash插件
var flashChecker=function flashChecker(){var hasFlash=0;// 是否安装了flash
var flashVersion=0;// flash版本
if(document.all){try{var swf=new ActiveXObject("ShockwaveFlash.ShockwaveFlash");var VSwf=swf.GetVariable("$version");flashVersion=parseInt(VSwf.split(" ")[1].split(",")[0]);}catch(e){confirm({title:getLabel(127354,"警告"),content:e+" "+getLabel(507489,"缺少补丁，无法检测您是否安装 flash 插件，请安装或更新 falsh插件！")});}hasFlash=1;}else{if(navigator.plugins&&navigator.plugins.length>0){var _swf=navigator.plugins["Shockwave Flash"];if(_swf){hasFlash=1;var words=_swf.description.split(" ");for(var i=0;i<words.length;++i){if(isNaN(parseInt(words[i])))continue;flashVersion=parseInt(words[i]);}}}}return{f:hasFlash,v:flashVersion};};var fileNameReg=/[\\\\/:*?\"<>|]/g;var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.getCurrentWindow=function(){if(_this.state.hasSetWindow){return window["setUploadWindow"+_this.state.containerId];}return _window2.default.getParent()!==window&&$(_this.refs.wrap).closest(".ant-modal").length>0?_window2.default.getTop():window;// return WindowFunc.getParent() !== window
//   ? WindowFunc.getTop()
//   : window;
};_this.getCurrentJQuery=function(){var currentWindow=_this.getCurrentWindow();return currentWindow.$||currentWindow.jQuery;};_this.resetListB=function(){var viewAttr=_this.props.viewAttr;var _this$state=_this.state,listT=_this$state.listT,listB=_this$state.listB;listB.forEach(function(file){_this.uploader&&_this.uploader.removeFile(file.id);});_this.setState({listB:[]});typeof _this.props.getShowListDatas==="function"&&_this.props.getShowListDatas(listT,[]);var required=viewAttr===3&&listT.length===0;typeof _this.props.onUploading==="function"&&_this.props.onUploading(required?"true":"false");};_this.clearAllFiles=function(){// 仅删除下部的，批量上传有效
confirm({title:getLabel(385911,"确定要删除所有吗？"),content:"",onOk:function onOk(){var viewAttr=_this.props.viewAttr;var _this$state2=_this.state,listT=_this$state2.listT,listB=_this$state2.listB;listB.forEach(function(file){_this.uploader&&_this.uploader.removeFile(file.id);});_this.setState({listB:[]});typeof _this.props.getShowListDatas==="function"&&_this.props.getShowListDatas(listT,[]);var required=viewAttr===3&&listT.length===0;typeof _this.props.onUploading==="function"&&_this.props.onUploading(required?"true":"false");}});};_this.cancleUpload=function(){confirm({title:getLabel(508772,"确定要取消上传吗？"),content:"",onOk:function onOk(){var viewAttr=_this.props.viewAttr;var _this$state3=_this.state,listT=_this$state3.listT,listB=_this$state3.listB;listB.forEach(function(file){_this.uploader&&_this.uploader.removeFile(file.id);});_this.setState({listB:[]});typeof _this.props.getShowListDatas==="function"&&_this.props.getShowListDatas(listT,[]);var required=viewAttr===3&&listT.length===0;typeof _this.props.onUploading==="function"&&_this.props.onUploading(required?"true":"false");}});};_this.onDrop=function(p,newList){// this.setState({ [p]: newList });
// WeaDragula modify the memory directy -> this.state
if(p==="listT")_this.onChange(newList);};_this.getWeaDragulaProps=function(p){var _this$props=_this.props,autoUpload=_this$props.autoUpload,listType=_this$props.listType;var isDetail=autoUpload;if("isDetail"in _this.props){isDetail=_this.props.isDetail;}return{container:function container(){return _this.refs[p];},datas:_this.state[p],canDrag:function canDrag(target){// set modal transform 'inherit' to fix position
var modal=$(_this.wrap).closest(".ant-modal.react-draggable");modal.length===1&&(modal[0].style.transform="inherit");return $(target).hasClass("wea-upload-move");},getKeyFromData:function getKeyFromData(record){return record.fileid||record.id;},getKeyFromDom:function getKeyFromDom(r){return $("span.wea-upload-move",r).attr("data-index");},onDrop:function onDrop(){for(var _len=arguments.length,arg=Array(_len),_key=0;_key<_len;_key++){arg[_key]=arguments[_key];}return _this.onDrop.apply(_this,[p].concat(arg));},direction:!isDetail&&listType==="img"?"horizontal":"vertical"};};_this.onEdit=function(p,v,d){var value=v;if(fileNameReg.test(value)){value=v.replace(fileNameReg,"");}var newName="";var newList=_this.state[p].map(function(file){var oname=file.filename||file.name;var str=oname.match(/\.[^\.]+$/);var name=""+value+(str?str[0]:"");var newFile=(0,_extends3.default)({},file);delete newFile.WEA_UPLOAD_EDITABLE;if((file.fileid&&file.fileid===d.fileid||file.id&&file.id===d.id)&&value){newName=name;newFile.filename=name;newFile.name=name;if(p==="listB"){newFile.WEA_NATIVE_FILE.target_name=name;newFile.WEA_NATIVE_FILE.name=name;}}return newFile;});_this.setState((0,_defineProperty3.default)({},p,newList));if(p==="listT"&&newName){_this.onChange(newList);(0,_callApi.callApi)("/api/doc/acc/rename","POST",{imagefileid:d.imagefileid||d.fileid,imagefilename:newName});}if(newName&&typeof _this.props.onFileNameEdit==="function"){_this.props.onFileNameEdit(newName,d);}};_this.canEdit=function(p,d){_this.setState((0,_defineProperty3.default)({},p,_this.state[p].map(function(file){var newFile=(0,_extends3.default)({},file);if(file.fileid&&file.fileid===d.fileid||file.id&&file.id===d.id){newFile.WEA_UPLOAD_EDITABLE=true;_this.editInputTimer=setTimeout(function(){var wi=_this.refs[p==="listT"?d.fileid:d.id];if(wi&&wi.refs.inputNormal){wi.refs.inputNormal.refs.input.refs.input.focus();_this.editInputTimer=clearTimeout(wi);}if(wi&&wi.refs.textareaNormal){wi.refs.textareaNormal.refs.input.refs.input.focus();wi.refs.textareaNormal.setCursorInEnd(wi.refs.textareaNormal.refs.input.refs.input);_this.editInputTimer=clearTimeout(wi);}},0);}return newFile;})));};_this.onEditSec=function(params,showname){var _this$props2=_this.props,modifySecUrl=_this$props2.modifySecUrl,needModifyDocSec=_this$props2.needModifyDocSec;var _this$state4=_this.state,currentFile=_this$state4.currentFile,editFile=_this$state4.editFile,listT=_this$state4.listT;var otherParams={};if(needModifyDocSec){otherParams={ismodifydoc:1,docid:currentFile.fileid};}(0,_callApi.callApi)(modifySecUrl,"POST",(0,_extends3.default)({imagefileid:editFile},otherParams,params)).then(function(res){if(res.api_status){var _currentFile=void 0;var newList=listT.map(function(item){if((item.fileid&&item.fileid===editFile||item.imagefileid&&item.imagefileid===editFile)&&res.secretLevelValidityValue){_currentFile=item;item.secretLevel=params.secretLevel;item.secretLevelValidityValue=res.secretLevelValidityValue;item.secretLevelValidity=params.secretLevelValidity;}return item;});_this.onChange(newList);_this.setState({listT:newList,editFile:"",visible:false,isEditSec:false,currentFile:{}});if(typeof _this.props.onEditSecLevel==="function"){_this.props.onEditSecLevel(res,editFile,_currentFile,newList);//接口返回，修改的文件id，修改的文件数据，所有数据
}}});};_this.editSecLevel=function(d){_this.setState({visible:true,isEditSec:true,editFile:d.imagefileid||d.fileid,currentFile:d});};_this.onForceUpdate=function(){var _this$props3=_this.props,showUploader=_this$props3.showUploader,showUploadTime=_this$props3.showUploadTime;if(showUploader||showUploadTime){_this.forceUpdate();}};_this.getDefaultListB=function(){var _this$props4=_this.props,showListTop=_this$props4.showListTop,viewAttr=_this$props4.viewAttr,sortable=_this$props4.sortable,ecId=_this$props4.ecId;if(showListTop){if(viewAttr!==1&&sortable){return _react2.default.createElement(_weaDragula2.default,(0,_extends3.default)({},_this.getWeaDragulaProps("listT"),{ecId:ecId+"_WeaDragula@6q76o9"}),_this.renderlistT());}return _this.renderlistT();}return null;};_this.checkSecLevel=function(){var _this$props5=_this.props,casProtect=_this$props5.casProtect,secLevel=_this$props5.secLevel,secLevelInfo=_this$props5.secLevelInfo;if(!casProtect||casProtect=="false"||secLevel=="4")return;if(secLevel){_this.setState({visible:true});}else if(casProtect){_antd.message.error(secLevelInfo);}};_this.changeVisible=function(visible){// this.setState({ visible });
};_this.changeSensiVisible=function(visible){_this.setState({sensitiveVisible:visible,sensitiveList:[]});if(!visible){// 修复富文本上传敏感词提示框自动消失问题
typeof _this.props.onUploading==="function"&&_this.props.onUploading("uploaded");}};_this.onSave=function(params){var _this$props6=_this.props,uploadParams=_this$props6.uploadParams,uploadId=_this$props6.uploadId;var containerId=_this.state.containerId;var resetOptions={};var jq=_this.getCurrentJQuery();resetOptions.multipart_params=(0,_extends3.default)({},uploadParams,params,{ts:new Date().getTime()});(0,_keys2.default)(resetOptions).length>0&&_this.resetUploaderOption(resetOptions,false);if(_this.isIE9){jq("#container_"+uploadId+"_"+containerId+" object").css("display","block");jq("#container_"+uploadId+"_"+containerId+" object").click();}else{// jq(`#container_${uploadId}_${containerId} input`).attr("disabled", false);
// jq(`#container_${uploadId}_${containerId} input`).click();
jq("#container_"+uploadId+"_"+containerId+" input").attr("disabled",false);// 国产操做系统麒麟银行火狐浏览器中，改变 dom disabled 后立即触发 click 事件是不可行的
// 这里加个延迟，当 dom 的 disabled 确实改变为了 false 后，再触发 click
var In=setInterval(function(){if(jq("#container_"+uploadId+"_"+containerId+" input").attr("disabled")!=="disabled"||jq("#container_"+uploadId+"_"+containerId+" input").attr("disabled")!==true){jq("#container_"+uploadId+"_"+containerId+" input").click();_this.filePicker=true;clearInterval(In);}},100);}};_this.cancelEdit=function(){// this.setState({ isEditSec: false, editFile: "", currentFile: {} });
_this.setState({isEditSec:false,editFile:"",currentFile:{},visible:false});};_this.instanceIsMounted=false;_this.state={containerId:new Date().getTime()+"_"+Math.ceil(Math.random()*100000),listT:[],listB:[],colspan:0,width:0,hasSetWindow:false,scanLoading:false,visible:false,isEditSec:false,currentFile:{},sensitiveVisible:false,sensitiveList:[]};_this.isIE9=_userAgent.ua.browser==="IE"&&parseInt(_userAgent.ua.version)<10;_this.playImg=_this.playImg.bind(_this);_this.doDeleteB=_this.doDeleteB.bind(_this);_this.doDeleteT=_this.doDeleteT.bind(_this);return _this;}// 获取 window
(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.instanceIsMounted=true;var jq=this.getCurrentJQuery();var currentWindow=this.getCurrentWindow();var windowEcCom=currentWindow.ecCom;var load=windowEcCom?windowEcCom.WeaUpload.loadjs:_loadjs2.default;var _props=this.props,datas=_props.datas,uploadId=_props.uploadId,display=_props.display,_props$needCalculateW=_props.needCalculateWidth,needCalculateWidth=_props$needCalculateW===undefined?true:_props$needCalculateW,pluginVersion=_props.pluginVersion;var containerId=this.state.containerId;var cotWidth=jq("#"+uploadId+"_"+containerId).width()||0;var emWidth=jq(".excelMainTable")?jq(".excelMainTable").width():0;var docWidth=jq(currentWindow).width()||1;var denWidth=emWidth||docWidth;this.setState({listT:datas||[],colspan:cotWidth/denWidth,width:cotWidth===0||!needCalculateWidth?"100%":cotWidth});typeof this.props.getShowListDatas==="function"&&this.props.getShowListDatas(datas,this.state.listB);// async load file
var init=function init(){if(_this2.isIE9){display===true&&_this2.initUploader();}else{_this2.initUploader();}};load.isDefined("pluploadJS")?load.ready("pluploadJS",init):pluginVersion=="debug"?load([(window.ecologyContentPath||"")+"/cloudstore/resource/pc/plupload-2.3.6/js/moxie.js",(window.ecologyContentPath||"")+"/cloudstore/resource/pc/plupload-2.3.6/js/plupload.dev.js"],"pluploadJS",{success:init,async:false}):load((window.ecologyContentPath||"")+"/cloudstore/resource/pc/plupload-"+pluginVersion+"/js/plupload.full.min.js","pluploadJS",init);!load.isDefined("imcarouselJS")&&load([(window.ecologyContentPath||"")+"/social/js/drageasy/drageasy.js",(window.ecologyContentPath||"")+"/social/js/bootstrap/js/bootstrap.js",(window.ecologyContentPath||"")+"/social/im/js/IMUtil_wev8.js",(window.ecologyContentPath||"")+"/social/js/imcarousel/imcarousel.js"],"imcarouselJS");// : load('/cloudstore/resource/pc/plupload-2.3.6/plupload.full.min.js', 'pluploadJS', init);
// async load file
// if (window !== WindowFunc.getTop()) {
var topWindow=_window2.default.getTop();var topload=topWindow.ecCom?topWindow.ecCom.WeaUpload.loadjs:_loadjs2.default;// }
!topload.isDefined("imcarouselJS")&&topload([(window.ecologyContentPath||"")+"/social/js/drageasy/drageasy.js",(window.ecologyContentPath||"")+"/social/js/bootstrap/js/bootstrap.js",(window.ecologyContentPath||"")+"/social/im/js/IMUtil_wev8.js",(window.ecologyContentPath||"")+"/social/js/imcarousel/imcarousel.js"],"imcarouselJS");}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;var _props2=this.props,datas=_props2.datas,uploadUrl=_props2.uploadUrl,limitType=_props2.limitType,uploadParams=_props2.uploadParams,fileDataName=_props2.fileDataName,customOptions=_props2.customOptions,maxUploadSize=_props2.maxUploadSize,multiSelection=_props2.multiSelection,display=_props2.display,dragUpload=_props2.dragUpload,uploadId=_props2.uploadId,_props2$needCalculate=_props2.needCalculateWidth,needCalculateWidth=_props2$needCalculate===undefined?true:_props2$needCalculate,secLevel=_props2.secLevel,modifySecUrl=_props2.modifySecUrl,needCheckSec=_props2.needCheckSec,needModifyDocSec=_props2.needModifyDocSec;var _state=this.state,listT=_state.listT,containerId=_state.containerId;var nextPropDatas=nextProps.datas;var nextPropUploadUrl=nextProps.uploadUrl||"";var nextPropLimitType=nextProps.limitType||"";var nextPropUploadParams=nextProps.uploadParams||{};var nextPropMaxUploadSize=nextProps.maxUploadSize||0;var nextPropSecLevel=nextProps.secLevel||"";var nextPropMultiSelection=nextProps.multiSelection!==undefined?nextProps.multiSelection:true;var nextPropDisplay=nextProps.display===false?nextProps.display:true;var nextFileDataName=nextProps.fileDataName||"";var nextCustomOptions=nextProps.customOptions||{};var nextDragUpload=nextProps.dragUpload||false;var newLimitType="";var jq=this.getCurrentJQuery();var currentWindow=this.getCurrentWindow();if(nextProps.casProtect&&nextProps.casProtect!=="false"){if(nextPropSecLevel==="4"){if(this.isIE9){jq("#container_"+uploadId+"_"+containerId+" object").css("display","block");}else{jq("#container_"+uploadId+"_"+containerId+" input").attr("disabled",false);}}else{if(this.isIE9){jq("#container_"+uploadId+"_"+containerId+" object").css("display","none");}else{jq("#container_"+uploadId+"_"+containerId+" input[type=\"file\"]").attr("disabled",true);}if(this.filePicker){this.setState({visible:false});this.filePicker=false;}}}if(limitType!==nextPropLimitType||maxUploadSize!==nextPropMaxUploadSize){var uploadSuffixLimit=_storage.ls.getStr("uploadSuffixLimit")||"*.*";if(uploadSuffixLimit=="undefined"){uploadSuffixLimit="*.*";}if(uploadSuffixLimit=="*.*"){// 配置文件无限制
newLimitType=nextPropLimitType;}else{// 配置文件有限制
if(!nextPropLimitType){newLimitType=uploadSuffixLimit.replace(/;/g,",").replace(/\*./g,"");}else{// 取交集
var obj1=uploadSuffixLimit.replace(/;/g,",").replace(/\*./g,"").split(",");var obj2=nextPropLimitType.split(",");var intersection=obj2.filter(function(v){return obj1.some(function(s){return s.toLowerCase()===v.toLowerCase();});});newLimitType=intersection.join(",");if(!newLimitType){newLimitType="";}}}}if(this.isIE9&&display===false&&nextPropDisplay===true){!this.uploader&&this.initUploader();}if(display===false&&nextPropDisplay===true){var cotWidth=jq("#"+uploadId+"_"+containerId).width()||0;var emWidth=jq(".excelMainTable")?jq(".excelMainTable").width():0;var docWidth=jq(currentWindow).width()||1;var denWidth=emWidth||docWidth;this.setState({colspan:cotWidth/denWidth,width:cotWidth===0||!needCalculateWidth?"100%":cotWidth});}if(nextPropDatas&&!(0,_isEqual2.default)(datas,nextPropDatas)){this.setState({listT:nextPropDatas});typeof this.props.getShowListDatas==="function"&&this.props.getShowListDatas(nextPropDatas,this.state.listB);}var resetOptions={};if(uploadUrl!==nextPropUploadUrl){var reg=new RegExp("^"+window.ecologyContentPath+"");nextPropUploadUrl=reg.test(nextPropUploadUrl)?nextPropUploadUrl:(window.ecologyContentPath||"")+nextPropUploadUrl;resetOptions.url=nextPropUploadUrl;}if(limitType!==nextPropLimitType){resetOptions.filters={mime_types:newLimitType?[{title:"limitType",extensions:newLimitType.indexOf("jpg")>=0?""+newLimitType:newLimitType}]:[],prevent_duplicates:false// 不允许选取重复文件
};}if(maxUploadSize!==nextPropMaxUploadSize){var filters={max_file_size:nextPropMaxUploadSize+"mb"};resetOptions.filters={mime_types:newLimitType?[{title:"limitType",extensions:newLimitType.indexOf("jpg")>=0?""+newLimitType:newLimitType}]:[],prevent_duplicates:false// 不允许选取重复文件
};resetOptions.filters=resetOptions.filters?(0,_extends3.default)({},resetOptions.filters,filters):filters;}if(multiSelection!==nextPropMultiSelection){resetOptions.multi_selection=nextPropMultiSelection;}if(!(0,_isEqual2.default)(uploadParams,nextPropUploadParams)){resetOptions.multipart_params=(0,_extends3.default)({},nextPropUploadParams,{nextPropSecLevel:nextPropSecLevel,ts:new Date().getTime()});}if(nextProps.casProtect&&nextProps.casProtect!=="false"&&nextPropSecLevel==="4"&&secLevel!==nextPropSecLevel){resetOptions.multipart_params=(0,_extends3.default)({},resetOptions.multipart_params,{secretLevel:nextPropSecLevel,secretLevelValidity:""});}if(fileDataName!==nextFileDataName){resetOptions.file_data_name=nextFileDataName;}if(!(0,_isEqual2.default)(customOptions,nextCustomOptions)){resetOptions=(0,_extends3.default)({},resetOptions,nextCustomOptions);}if(!(0,_isEqual2.default)(dragUpload,nextDragUpload)){resetOptions.dragUpload=nextDragUpload;}(0,_keys2.default)(resetOptions).length>0&&this.resetUploaderOption(resetOptions);if(secLevel&&secLevel<nextPropSecLevel&&needCheckSec){var newDatas=nextPropDatas||listT||[];// 高密级调整为低密级
var fileids=newDatas.map(function(item){return item.imagefileid||item.fileid;});var otherParams={};if(needModifyDocSec){otherParams={ismodifydoc:1,docid:newDatas.map(function(item){return item.fileid;})};}if(fileids.length>0){var params=(0,_extends3.default)({imagefileid:fileids.join(","),secretLevel:nextProps.secLevel,secretLevelValidity:nextProps.secretLevelValidity||""},otherParams);(0,_callApi.callApi)(modifySecUrl,"POST",params).then(function(res){if(res.api_status){var newReDatas=newDatas.map(function(item){item.secretLevel=nextProps.secLevel;item.secretLevelValidity=nextProps.secretLevelValidity;item.secretLevelValidityValue=res.secretLevelValidityValue;return item;});_this3.onChange(newReDatas);_this3.setState({listT:newReDatas});}});}}}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.uploader&&this.uploader.refresh();var uploadId=this.props.uploadId;var containerId=this.state.containerId;var jq=this.getCurrentJQuery();if(this.props.casProtect&&this.props.casProtect!=="false"){if(this.props.secLevel==="4"){if(this.isIE9){jq("#container_"+uploadId+"_"+containerId+" object").css("display","block");}else{jq("#container_"+uploadId+"_"+containerId+" input").attr("disabled",false);}}else{if(this.isIE9){jq("#container_"+uploadId+"_"+containerId+" object").css("display","none");}else{jq("#container_"+uploadId+"_"+containerId+" input[type=\"file\"]").attr("disabled",true);}}if(this.filePicker){this.setState({visible:false});this.filePicker=false;}}// const list = this.refs.listT;
// let nodes = [];
// if (list) {
//   nodes = list.querySelectorAll(".wea-upload-list-content");
// }
// const { listT } = this.state;
// let ischange = false;
// if (nodes && nodes.length > 0) {
//   for (let i = 0; i < nodes.length; i++) {
//     let overflow = false;
//     if (listT[i] && "overflow" in listT[i]) {
//       overflow = listT[i].overflow;
//     }
//     if (
//       nodes[i].scrollWidth > nodes[i].clientWidth &&
//       !overflow &&
//       listT[i]
//     ) {
//       listT[i].overflow = true;
//       ischange = true;
//     } else if (nodes[i].scrollWidth <= nodes[i].clientWidth && overflow) {
//       listT[i].overflow = false;
//       ischange = true;
//     }
//   }
//   // nodes.forEach((item, index) => {
//   //   let overflow = false;
//   //   if (listT[index] && "overflow" in listT[index]) {
//   //     overflow = listT[index].overflow;
//   //   }
//   //   if (item.scrollWidth > item.clientWidth && !overflow && listT[index]) {
//   //     listT[index].overflow = true;
//   //     ischange = true;
//   //   } else if (item.scrollWidth <= item.clientWidth && overflow) {
//   //     listT[index].overflow = false;
//   //     ischange = true;
//   //   }
//   // });
// }
// if (ischange) {
//   this.setState({ listT });
// }
}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.instanceIsMounted=false;this.uploader&&this.uploader.unbindAll();this.uploader&&this.uploader.destroy();var _props$autoUpload=this.props.autoUpload,autoUpload=_props$autoUpload===undefined?true:_props$autoUpload;if(!autoUpload){window.startUploadAll=null;}}},{key:"onChange",value:function onChange(listT){var listB=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var list=[];listT.forEach(function(t){var fileExtendName=t.fileExtendName,fileid=t.fileid,filelink=t.filelink,filename=t.filename,filesize=t.filesize,imgSrc=t.imgSrc,loadlink=t.loadlink,showLoad=t.showLoad,showDelete=t.showDelete,isImg=t.isImg,imagefileid=t.imagefileid,fileID=t.fileID,appID=t.appID,username=t.username,uploaddate=t.uploaddate,userid=t.userid,fileidCode=t.fileidCode,size=t.size,secretLevel=t.secretLevel,secretLevelValidity=t.secretLevelValidity,secretLevelValidityValue=t.secretLevelValidityValue;list.push({fileExtendName:fileExtendName,fileid:fileid,filelink:filelink,filename:filename,filesize:filesize,imgSrc:imgSrc,loadlink:loadlink,showLoad:showLoad,showDelete:showDelete,isImg:isImg,imagefileid:imagefileid,fileID:fileID,appID:appID,username:username,uploaddate:uploaddate,userid:userid,fileidCode:fileidCode,size:size,secretLevel:secretLevel,secretLevelValidity:secretLevelValidity,secretLevelValidityValue:secretLevelValidityValue});});var ids=listT.map(function(t){return t.fileid;});this.setState({listT:listT});// 刷新序号
if(typeof this.props.onChange==="function"){this.props.onChange(ids,list,listT,listB);}}},{key:"getWidth",value:function getWidth(){var jq=this.getCurrentJQuery();var currentWindow=this.getCurrentWindow();var _props3=this.props,uploadId=_props3.uploadId,_props3$needCalculate=_props3.needCalculateWidth,needCalculateWidth=_props3$needCalculate===undefined?true:_props3$needCalculate;var _state2=this.state,containerId=_state2.containerId,colspan=_state2.colspan;var cotWidth=jq("#"+uploadId+"_"+containerId).width()||0;var emWidth=jq(".excelMainTable")?jq(".excelMainTable").width():0;var docWidth=jq(currentWindow).width()||1;var denWidth=emWidth||docWidth;var width=denWidth*colspan;width=width===0||cotWidth===0||!needCalculateWidth?"100%":width>cotWidth?cotWidth:width>800?800:width<170?170:width;this.setState({width:width});}},{key:"doUpload",value:function doUpload(){var listB=this.state.listB;typeof this.props.onUploading==="function"&&this.props.onUploading("uploading",listB);this.uploader&&this.uploader.start();}},{key:"doDeleteT",value:function doDeleteT(fileid){var _this4=this;// event.stopPropagation();
// 删除上部的，自动上传需调用onchange
var _props4=this.props,autoUpload=_props4.autoUpload,viewAttr=_props4.viewAttr;var _state3=this.state,listT=_state3.listT,listB=_state3.listB;var newListT=[].concat(listT);var title="";newListT.forEach(function(file){if(fileid===file.fileid){title=file.filename;}});newListT=newListT.filter(function(file){return fileid!==file.fileid;});var warnText=getLabel(385912,"确定要删除{title}吗？");confirm({title:warnText.slice(0,warnText.indexOf("{"))+title+warnText.slice(warnText.indexOf("}")+1),content:"",onOk:function onOk(){_this4.setState({listT:newListT});typeof _this4.props.getShowListDatas==="function"&&_this4.props.getShowListDatas(newListT,listB);typeof _this4.props.onDelete==="function"&&_this4.props.onDelete(newListT,listB);if(autoUpload){_this4.onChange(newListT,listB);}else{_this4.onChange(newListT,[]);var required=viewAttr===3&&newListT.length===0&&listB.length===0;typeof _this4.props.onUploading==="function"&&_this4.props.onUploading(required?"true":"false");}}});}},{key:"doDeleteB",value:function doDeleteB(id){var _this5=this;// 仅删除下部的，批量上传有效
var viewAttr=this.props.viewAttr;var _state4=this.state,listT=_state4.listT,listB=_state4.listB;var newListB=[].concat(listB);var title="";newListB.forEach(function(file){if(id===file.id){title=file.name;}});newListB=newListB.filter(function(file){return id!==file.id;});var warnText=getLabel(510362,"确定要取消上传{title}吗？");warnText=warnText.replace("{title}",title);confirm({title:warnText,content:"",onOk:function onOk(){_this5.uploader&&_this5.uploader.removeFile(id);_this5.setState({listB:newListB});typeof _this5.props.getShowListDatas==="function"&&_this5.props.getShowListDatas(listT,newListB);var required=viewAttr===3&&listT.length===0&&newListB.length===0;typeof _this5.props.onUploading==="function"&&_this5.props.onUploading(required?"true":"false");}});}},{key:"resetUploaderOption",value:function resetUploaderOption(options){var clear=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;this.uploader&&this.uploader.setOption(options);this.props.clearWhenReset&&clear&&this.resetListB();}},{key:"initUploader",value:function initUploader(){var _this6=this;var _props5=this.props,uploadId=_props5.uploadId,autoUpload=_props5.autoUpload,limitType=_props5.limitType,maxUploadSize=_props5.maxUploadSize,multiSelection=_props5.multiSelection,forceIE9Flash=_props5.forceIE9Flash,uploadParams=_props5.uploadParams,fileDataName=_props5.fileDataName,customOptions=_props5.customOptions,showErrorInfo=_props5.showErrorInfo,dragUpload=_props5.dragUpload,pluginVersion=_props5.pluginVersion,secLevel=_props5.secLevel,casProtect=_props5.casProtect;var uploadUrl=this.props.uploadUrl;var containerId=this.state.containerId;var newLimitType="";var uploadSuffixLimit=_storage.ls.getStr("uploadSuffixLimit")||"*.*";if(uploadSuffixLimit=="undefined"){uploadSuffixLimit="*.*";}if(uploadSuffixLimit=="*.*"){// 配置文件无限制
newLimitType=limitType;}else{// 配置文件有限制
if(!limitType){newLimitType=uploadSuffixLimit.replace(/;/g,",").replace(/\*./g,"");}else{// 取交集
var obj1=uploadSuffixLimit.replace(/;/g,",").replace(/\*./g,"").split(",");var obj2=limitType.split(",");var intersection=obj2.filter(function(v){return obj1.some(function(s){return s.toLowerCase()===v.toLowerCase();});});newLimitType=intersection.join(",");if(!newLimitType){newLimitType="";}}}var filters={mime_types:newLimitType?[{title:"limitType",extensions:newLimitType.indexOf("jpg")>=0?""+newLimitType:newLimitType}]:[],prevent_duplicates:false// 不允许选取重复文件
};if(maxUploadSize)filters.max_file_size=maxUploadSize+"mb";// 最大上传大小
var currentWindow=this.getCurrentWindow();var jq=this.getCurrentJQuery();// special for meeting
if(currentWindow.plupload===undefined){currentWindow=_window2.default.getTop();window["setUploadWindow"+containerId]=currentWindow;this.setState({hasSetWindow:true});}var newCustomOptions={};if(dragUpload){newCustomOptions=(0,_extends3.default)({drop_element:"browsebtn_"+uploadId+"_"+containerId},customOptions);}if(!/^http/.test(uploadUrl)){var reg=new RegExp("^"+window.ecologyContentPath+"");uploadUrl=reg.test(uploadUrl)?uploadUrl:(window.ecologyContentPath||"")+uploadUrl;}this.uploader=new currentWindow.plupload.Uploader((0,_extends3.default)({container:"container_"+uploadId+"_"+containerId,browse_button:"browsebtn_"+uploadId+"_"+containerId,runtimes:forceIE9Flash&&this.isIE9?"flash":"html5,html4,flash"},fileDataName?{file_data_name:fileDataName}:{},{multipart:true,// multipart/form-data的形式来上传文件
multipart_params:(0,_extends3.default)({},uploadParams,{secretLevel:secLevel,ts:new Date().getTime()}),chunk_size:"0",// 分片上传大小
url:uploadUrl,flash_swf_url:(window.ecologyContentPath||"")+"/cloudstore/resource/pc/plupload-"+pluginVersion+"/js/Moxie.swf",filters:filters,multi_selection:multiSelection},newCustomOptions,customOptions));// 初始化
this.uploader.init();// 绑定主要事件,state同步
// const uploadEvents = [
//  'PostInit', 'Browse', 'Refresh', 'StateChanged', 'QueueChanged', 'OptionChanged',
//  'BeforeUpload', 'UploadProgress', 'FileFiltered', 'FilesAdded',
//  'FilesRemoved', 'FileUploaded', 'ChunkUploaded',
//  'UploadComplete', 'Destroy', 'Error'
// ];
// 新增上传
this.uploader.bind("FilesAdded",function(up,files){var _props6=_this6.props,_props6$maxFilesNumbe=_props6.maxFilesNumber,maxFilesNumber=_props6$maxFilesNumbe===undefined?Infinity:_props6$maxFilesNumbe,_props6$totolMaxUploa=_props6.totolMaxUploadSize,totolMaxUploadSize=_props6$totolMaxUploa===undefined?Infinity:_props6$totolMaxUploa,limitType=_props6.limitType,mixUploadSize=_props6.mixUploadSize,replaceWhenOver=_props6.replaceWhenOver,prohibitType=_props6.prohibitType;var _state5=_this6.state,listT=_state5.listT,listB=_state5.listB;var newListB=listB.concat(files);if(totolMaxUploadSize&&totolMaxUploadSize!==Infinity){var total=0;listT.forEach(function(t){total+=t.filesizeByte||t.size||t.filesize&&(t.filesize.indexOf("M")!==-1?t.filesize.slice(0,-1)*1024*1024:t.filesize.indexOf("K")!==-1?t.filesize.slice(0,-1)*1024:t.filesize.slice(0,-1))||0;});newListB.forEach(function(b){total+=b.size;});if(total>totolMaxUploadSize*1024*1024){var errorMsg=getLabel(385913,"超出总大小{size}MB限制!");errorMsg=errorMsg.replace("{size}",totolMaxUploadSize);_antd.message.error(errorMsg,1.5);return;}}newListB=newListB.filter(function(file){if(file.size&&file.size<mixUploadSize*1024*1024){// 过滤低于最小上传大小限制的文件
var _errorMsg=getLabel(505898,"低于最小{size}MB限制!");_errorMsg=_errorMsg.replace("{size}",mixUploadSize);_antd.message.error(_errorMsg,1.5);return false;}else{return true;}});newListB=newListB.map(function(file){var newFile=(0,_extends3.default)({},file,{WEA_NATIVE_FILE:file});if(!newFile.progress){newFile.progress=1;}if(autoUpload)newFile.showProgress=true;return newFile;});var overflowNumber=newListB.length-maxFilesNumber;if(!replaceWhenOver&&newListB.length+listT.length>maxFilesNumber){newListB=newListB.slice(0,maxFilesNumber-listT.length);_this6.setState({listB:newListB});var _errorMsg2=getLabel(509549,"文件数量不能超过 {maxFilesNumber} 个");_errorMsg2=_errorMsg2.replace("{maxFilesNumber}",maxFilesNumber);_antd.message.error(_errorMsg2,1.5);}else{if(overflowNumber>0){// const removeList = [...newListB];
// removeList
//   .slice(1, overflowNumber)
//   .forEach(file => up.removeFile(file));
up.splice(0,overflowNumber);newListB=newListB.slice(-maxFilesNumber);}_this6.setState({listB:newListB});}var noLimitType=prohibitType.split(",").filter(function(item){return item!=="";});newListB=newListB.filter(function(file){var index=file.name.lastIndexOf(".");var suffix=index===-1?"":file.name.substr(index+1);if(noLimitType.some(function(item){return item.toLowerCase()===suffix.toLowerCase();})){// 过滤禁止上传的文件类型
var _errorMsg3=getLabel(385919,"上传文件类型错误，请重新上传!");_antd.message.error(_errorMsg3,1.5);_this6.uploader.removeFile(file.id);return false;}else{return true;}});_this6.setState({listB:newListB});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(_this6.state.listT,newListB);if(autoUpload&&newListB.length>0){_this6.doUpload();}else{typeof _this6.props.onUploading==="function"&&_this6.props.onUploading("false");}});// 删除文件
this.uploader.bind("FilesRemoved",function(up,rmFiles){var listB=_this6.state.listB;var newListB=[].concat(listB);rmFiles.forEach(function(rf){newListB=newListB.filter(function(file){return rf.id!==file.id;});});_this6.setState({listB:newListB});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(_this6.state.listT,newListB);});// 抛错
this.uploader.bind("Error",function(up,err){if(err.code===-500){console&&console.error(getLabel(385914,"上传组件初始化出错!"));}else if(err.code===-702){_antd.message.error(getLabel(385917,"文件大小超出组件所能处理的最大值，请重新上传!"),3);}else if(err.code===-600){if(showErrorInfo){_antd.message.error(err.file.size===0?getLabel("529543","上传文件大小不能为0，请重新上传"):getLabel(531974,"上传文件超出限制大小{max}，请重新上传!").replace("{max}",maxUploadSize+"M"),3);}else{confirm({className:"wea-upload-confirm-error-info",title:err.file.size===0?getLabel("529543","上传文件大小不能为0，请重新上传"):getLabel(531974,"上传文件超出限制大小{max}，请重新上传!").replace("{max}",maxUploadSize+"M"),content:err.file.name});}}else if(err.code===-601){if(limitType.toLowerCase()==="docx"){_antd.message.error(getLabel(505349,"仅支持docx文件，请上传docx文件!"),3);}else{_antd.message.error(getLabel(385919,"上传文件类型错误，请重新上传!"),3);}}else if(err.code===-602){_antd.message.error(getLabel(385920,"上传文件重复，请重新上传!"),3);}else if(err.code===-200){_antd.message.error(getLabel(385921,"上传接口出错，请重新上传!"),3);// console && console.error('上传组件出错，请联系管理员!');
}else{// message.error('上传组件出错，请联系管理员!',3);
// console && console.error('上传组件出错，请联系管理员!');
}if(err.file){var listB=_this6.state.listB;var newListB=[].concat(listB.filter(function(file){return file.id!==err.file.id;}));if(err.code===-600){err.file.error=err.file.size===0?getLabel("505710","文件为空"):getLabel(125378,"文件过大");}else if(err.code===-601){err.file.error=getLabel(127241,"类型错误");}else if(err.code===-200){err.file.error=getLabel(385916,"接口错误");}else{err.file.error=getLabel(129710,"未知错误");}if(autoUpload){err.file.progress=50;err.file.progressStatus="exception";err.file.showProgress=true;}newListB.push(err.file);_this6.setState({listB:newListB});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(_this6.state.listT,newListB);setTimeout(function(){var stlistB=_this6.state.listB;var stNewListB=[].concat(stlistB);stNewListB=stNewListB.filter(function(file){return!file.error;});_this6.setState({listB:stNewListB});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(_this6.state.listT,stNewListB);},2000);}});// 上传进度
this.uploader.bind("UploadProgress",function(up,pgFile){var listB=_this6.state.listB;var newListB=[].concat(listB);newListB=newListB.map(function(file){if(pgFile.id===file.id){var newFile=(0,_extends3.default)({},file);if(pgFile.percent!==undefined){if(pgFile.percent<=99){newFile.progress=pgFile.percent;}else{newFile.progress=99;}}else if(newFile.loaded&&newFile.size){var p=parseInt(newFile.loaded*100/newFile.size);newFile.progress=p;}else if(newFile.progress<90){newFile.progress+=10;}else{newFile.progress=99;}return newFile;}else{return file;}});_this6.setState({listB:newListB});typeof _this6.props.onUploading==="function"&&_this6.props.onUploading("uploading",newListB,_this6.uploader.total);typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(_this6.state.listT,newListB,_this6.uploader.total);});// 分片上传完成
// this.uploader.bind('ChunkUploaded', (up, ckFile, res) => {
//  console.log('分片上传完成 ChunkUploaded: ', ckFile, res)
// });
// 某个文件上传完
this.uploader.bind("FileUploaded",function(up,upFile,res){var upError=res.status!==200||!res.response||res.response&&(JSON.parse(res.response).status===false||JSON.parse(res.response).status==="false"||!JSON.parse(res.response).data);if(upError){var result=res.response&&JSON.parse(res.response);if(result.sensitiveInfo){var sensitiveList=_this6.state.sensitiveList;sensitiveList=sensitiveList.concat(result.sensitiveInfo);_this6.setState({sensitiveList:sensitiveList});}var listB=_this6.state.listB;var newListB=[].concat(listB);newListB=newListB.map(function(file){if(upFile.id===file.id){var newFile=(0,_extends3.default)({},file);newFile.error=!newFile.size?getLabel(505710,"文件为空"):res.response&&JSON.parse(res.response).msg?JSON.parse(res.response).msg:getLabel(385915,"上传服务器失败");newFile.progressStatus="exception";newFile.progress=100;newFile.showProgress=true;if(!newFile.size){_antd.message.error(newFile.name+" "+getLabel(505335,"为空文件，无法上传，请您重新选择"),3);}else{if(!result.sensitiveInfo){_antd.message.error(newFile.name+" "+newFile.error,3);}}return newFile;}else{return file;}});_this6.setState({listB:newListB});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(_this6.state.listT,newListB);typeof _this6.props.onUploading==="function"&&_this6.props.onUploading("error");typeof _this6.props.onUploaded==="function"&&_this6.props.onUploaded(_this6.state.listT,newListB);}else{var _listB=_this6.state.listB;var _newListB=[].concat(_listB);_newListB=_newListB.map(function(file){if(upFile.id===file.id){var newFile=(0,_extends3.default)({},file,JSON.parse(res.response).data);newFile.progress=100;return newFile;}else{return file;}});_this6.setState({listB:_newListB});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(_this6.state.listT,_newListB);typeof _this6.props.onUploaded==="function"&&_this6.props.onUploaded(_this6.state.listT,_newListB);}});// 全部文件上传完成
this.uploader.bind("UploadComplete",function(){setTimeout(function(){var maxFilesNumber=_this6.props.maxFilesNumber;var _state6=_this6.state,listT=_state6.listT,listB=_state6.listB,sensitiveList=_state6.sensitiveList;var find=false;listB.forEach(function(file){if(file.error)find=true;});if(sensitiveList.length>0){_this6.setState({sensitiveVisible:true});}if(find){setTimeout(function(){var nowListT=_this6.state.listT;var nowListB=_this6.state.listB;var newListB=[].concat(nowListB);newListB=newListB.filter(function(file){return!file.error;});var newListT=nowListT.concat(newListB);var overflowNumber=newListT.length-maxFilesNumber;overflowNumber>0&&(newListT=newListT.slice(-maxFilesNumber));_this6.onChange(newListT,newListB);_this6.setState({listT:newListT,listB:[]});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(newListT,[]);typeof _this6.props.onUploading==="function"&&sensitiveList.length==0&&_this6.props.onUploading("uploaded");typeof _this6.props.onUploaded==="function"&&_this6.props.onUploaded(newListT,[]);},2000);}else{var newListT=listT.concat(listB);var overflowNumber=newListT.length-maxFilesNumber;overflowNumber>0&&(newListT=newListT.slice(-maxFilesNumber));_this6.onChange(newListT,listB);_this6.setState({listT:newListT,listB:[]});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(newListT,[]);typeof _this6.props.onUploading==="function"&&sensitiveList.length==0&&_this6.props.onUploading("uploaded");typeof _this6.props.onUploaded==="function"&&_this6.props.onUploaded(newListT,[]);}},200);});// 全局调用
if(!autoUpload){var startUploadAllOld=void 0;if(typeof currentWindow.startUploadAll==="function"){startUploadAllOld=currentWindow.startUploadAll;}currentWindow.startUploadAll=function(){var listB=_this6.state.listB;if(listB.length>0){var newListB=[].concat(listB);newListB=newListB.map(function(file){var newFile=(0,_extends3.default)({},file);newFile.progress=1;newFile.showProgress=true;return newFile;});_this6.setState({listB:newListB});typeof _this6.props.getShowListDatas==="function"&&_this6.props.getShowListDatas(_this6.state.ListT,newListB);_this6.doUpload();}typeof startUploadAllOld==="function"&&startUploadAllOld();};}// flash 遮罩无法 hover 问题
this.uploader.bind("Init",function(){var _props7=_this6.props,getCurrentInstance=_props7.getCurrentInstance,secLevel=_props7.secLevel;if(typeof getCurrentInstance==="function"){getCurrentInstance(_this6);}if(_userAgent.ua.browser==="IE"&&parseInt(_userAgent.ua.version,10)<10){jq("#container_"+uploadId+"_"+containerId+">div.moxie-shim-flash").hover(function(){jq("button#browsebtn_"+uploadId+"_"+containerId).css({color:"#57c5f7",borderColor:"#57c5f7"});jq("i#browsebtn_"+uploadId+"_"+containerId).css({color:"#289cff"});},function(){jq("button#browsebtn_"+uploadId+"_"+containerId).css({color:"#000",borderColor:"#d9d9d9"});jq("i#browsebtn_"+uploadId+"_"+containerId).css({color:"#a8a8a8"});});}if(casProtect&&casProtect!="false"&&secLevel!="4"){// this.uploader.settings.browse_button[0].setAttribute('selectable', false)
if(_this6.isIE9){jq("#container_"+uploadId+"_"+containerId+" object").css("display","none");}else{jq("#container_"+uploadId+"_"+containerId+" input[type=\"file\"]").attr("disabled",true);}}});}},{key:"playImg",value:function playImg(d,e){var _this7=this;var jq=this.getCurrentJQuery();var fn=function fn(){// 图片轮播
var jq=_this7.getCurrentJQuery();var currentWindow=_this7.getCurrentWindow();var imgPool=[];var indexNum=0;jq(".formImgPlay").each(function(){imgPool.push(jq(this).attr("data-imgsrc")||jq(this).attr("src"));});for(var i=0;i<imgPool.length;i++){var imgSrc=!!jq(e.target).attr("data-imgsrc")?jq(e.target).attr("data-imgsrc"):jq(e.target).attr("src");if(imgSrc===imgPool[i]){var reg=new RegExp("^"+window.ecologyContentPath+"");imgPool[i]=reg.test(imgPool[i])?imgPool[i]:(window.ecologyContentPath||"")+imgPool[i];break;}else{indexNum++;}}// console.log("imgPool--",imgPool,"indexNum--",indexNum);
var languageId=7;if(window["e9_locale"]){languageId=window["e9_locale"].userLanguage;}IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,_window2.default.getTop(),languageId);};if(typeof this.props.onItemClick==="function"){this.props.onItemClick(jq(e.target).attr("data-imgsrc")||jq(e.target).attr("src"));}else if(typeof this.props.onCheckPreview==="function"){this.props.onCheckPreview(d,fn);}else{fn();}}},{key:"download",value:function download(downloadURL,d,e){var _this8=this;e&&e.stopPropagation&&e.stopPropagation();var fn=function fn(){var uploadId=_this8.props.uploadId;var _state$containerId=_this8.state.containerId,containerId=_state$containerId===undefined?"":_state$containerId;var frame=_this8.refs["download_"+uploadId+"_"+containerId];if(frame){var u=window.navigator.userAgent;// if (
//   u.indexOf("Windows") > -1 &&
//   (u.indexOf("Chrome") > -1 || u.indexOf("CriOS") > -1) &&
//   Number(u.replace(/^.*Chrome\/([\d]+).*$/, "$1")) === 73 &&
//   /^\/weaver\/weaver\.file\.FileDownload/.test(downloadURL) &&
//   /&download=1/.test(downloadURL)
// ) {
//   frame.onload = () => {
//     frame.onload = () => {};
//     frame.src = downloadURL;
//   };
//   frame.src = downloadURL.replace(/&download=1/, "");
// } else {
// }
var reg=new RegExp("^"+window.ecologyContentPath+"");downloadURL=reg.test(downloadURL)?downloadURL:(window.ecologyContentPath||"")+downloadURL;if(Number(u.replace(/^.*Chrome\/([\d]+).*$/,"$1"))>=73){window.open(downloadURL);}else{frame.src="";frame.src=downloadURL;}}};if(typeof this.props.onCustomDownload==="function"){this.props.onCustomDownload(downloadURL);}else if(typeof this.props.onCheckDownload==="function"){this.props.onCheckDownload(d,fn);}else{fn();}}},{key:"open",value:function open(url,d){var fn=function fn(){var reg=new RegExp("^"+window.ecologyContentPath+"");url=reg.test(url)?url:(window.ecologyContentPath||"")+url;openFullWindowHaveBar(url);};if(typeof this.props.onItemClick==="function"){this.props.onItemClick(url);}else if(typeof this.props.onCheckPreview==="function"){this.props.onCheckPreview(d,fn);}else{fn();}}},{key:"renderlistT",value:function renderlistT(){var _this9=this;var _props8=this.props,listType=_props8.listType,viewAttr=_props8.viewAttr,imgHeight=_props8.imgHeight,imgWidth=_props8.imgWidth,autoUpload=_props8.autoUpload,sortable=_props8.sortable,editable=_props8.editable,showOrder=_props8.showOrder,showUploader=_props8.showUploader,showUploadTime=_props8.showUploadTime,oneline=_props8.oneline,showHead=_props8.showHead,linkHrm=_props8.linkHrm,showEditButton=_props8.showEditButton,showLoadInFront=_props8.showLoadInFront,showFilesize=_props8.showFilesize,showFullName=_props8.showFullName,showSecLevel=_props8.showSecLevel,allowEditSec=_props8.allowEditSec,ecId=_props8.ecId,casProtect=_props8.casProtect,secLevelDisplayFormat=_props8.secLevelDisplayFormat;var isDetail=void 0;if("isDetail"in this.props){isDetail=this.props.isDetail;}else{isDetail=autoUpload;}var _state7=this.state,listT=_state7.listT,width=_state7.width;var reg=new RegExp("^"+window.ecologyContentPath+"");return _react2.default.createElement("div",{className:"wea-upload-list",ref:"listT",style:{padding:listT.length>0?"0 0 5px 0":0}},listT.map(function(d,index){var fileid=d.fileid,imgSrc=d.imgSrc,filelink=d.filelink,filename=d.filename,filesize=d.filesize,_d$loadlink=d.loadlink,loadlink=_d$loadlink===undefined?"":_d$loadlink,showLoad=d.showLoad,showDelete=d.showDelete,isImg=d.isImg,WEA_UPLOAD_EDITABLE=d.WEA_UPLOAD_EDITABLE,_d$overflow=d.overflow,overflow=_d$overflow===undefined?false:_d$overflow,username=d.username,uploaddate=d.uploaddate,userid=d.userid,secretLevel=d.secretLevel,secretLevelValidity=d.secretLevelValidity,secretLevelValidityValue=d.secretLevelValidityValue;var showSecName=secretLevelValidityValue||"";if(casProtect&&showSecLevel){var secretLabel=showSecName.indexOf("★")!==-1?showSecName.substring(0,showSecName.indexOf("★")):showSecName;if(secLevelDisplayFormat!==""){// 流程模块单独控制密级显示
showSecName=secLevelDisplayFormat==="0"?secretLevelValidity?secretLabel+"★"+secretLevelValidity:secretLabel:secretLabel;}}var hasEditButton=viewAttr!==1&&editable&&showEditButton?"wea-upload-list-item-file-hasedit"+(linkHrm?"-linkhrm":""):"";var showNameOrTime=(showUploader||showUploadTime)&&!isDetail&&oneline?"wea-upload-list-item-file-uploaded"+(linkHrm?"-linkhrm":""):"";var imgBtnMagrinLeft=(imgWidth&&imgWidth>90?imgWidth+10:100)/4-8;var imgBtnMagrinRight=(imgWidth&&imgWidth>90?imgWidth+10:100)/4-5;// 文件名过长时，编辑图标与下载删除等距显示 宽度加大
var itemOpsDivWidth=viewAttr!==1&&showDelete&&showLoad&&overflow&&editable&&showEditButton?"67px":viewAttr!==1&&showDelete||showLoad?"53px":"0px";var inputRight=-42;var paddingRight=115;if(showOrder){inputRight=inputRight-10;paddingRight+=10;}if(showLoadInFront){inputRight=inputRight-24;paddingRight+=24;}if(!imgSrc){inputRight+=16;paddingRight=paddingRight-10;}var inputRightPx=0-inputRight-22;var imgDom=isDetail?_react2.default.createElement("div",{className:"wea-upload-imgs-item wea-upload-imgs-item-h",key:fileid,style:{width:width,minWidth:imgWidth+70,height:imgHeight+10}},viewAttr!==1&&sortable?_react2.default.createElement("span",{"data-index":fileid,key:fileid,className:"icon-coms-move wea-upload-move cursor-pointer"}):null,_react2.default.createElement("img",{ecId:ecId+"_img@3xns4i@"+fileid,className:"formImgPlay",src:reg.test(imgSrc)?imgSrc:(window.ecologyContentPath||"")+imgSrc,onClick:function onClick(e){return _this9.playImg(d,e);},"data-imgsrc":reg.test(loadlink)?loadlink.replace("&download=1",""):(window.ecologyContentPath||"")+loadlink.replace("&download=1",""),style:{width:imgWidth,height:imgHeight,cursor:"pointer"}}),_react2.default.createElement("span",{style:{position:"absolute",right:0,top:5,width:60,lineHeight:imgHeight+"px"}},viewAttr!==1&&showDelete&&_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@z1i9nz@"+fileid,type:"cross",title:getLabel(91,"删除"),style:{float:"right",cursor:"pointer",fontSize:10,marginTop:imgHeight/2-5,marginRight:10},onClick:_this9.doDeleteT.bind(_this9,fileid)}),showLoad&&_react2.default.createElement("i",{ecId:ecId+"_i@k23m45@"+fileid,className:"icon-coms-download wea-upload-icon",title:getLabel(31156,"下载"),style:{float:"right",fontSize:16,marginTop:imgHeight/2-8,marginRight:10},onClick:function onClick(e){return _this9.download(loadlink,d,e);}}))):_react2.default.createElement("div",{className:"wea-upload-imgs-item wea-upload-imgs-item-v",key:fileid,style:{width:imgWidth&&imgWidth>90?imgWidth+10:100}},viewAttr!==1&&sortable?_react2.default.createElement("span",{"data-index":fileid,key:fileid,className:"icon-coms-move wea-upload-move cursor-pointer"}):null,_react2.default.createElement("img",{ecId:ecId+"_img@3b8ri8@"+fileid,className:"formImgPlay",src:reg.test(imgSrc)?imgSrc:(window.ecologyContentPath||"")+imgSrc,onClick:function onClick(e){return _this9.playImg(d,e);},"data-imgsrc":reg.test(loadlink)?loadlink.replace("&download=1",""):(window.ecologyContentPath||"")+loadlink.replace("&download=1",""),style:{width:imgWidth,height:imgHeight,cursor:"pointer"}}),_react2.default.createElement("p",{className:"wea-upload-imgs-item-v-ops",style:{textAlign:showLoad===(viewAttr!==1&&showDelete)?"left":"center"}},showLoad&&_react2.default.createElement("i",{ecId:ecId+"_i@zilzm0@"+fileid,className:"icon-coms-download wea-upload-icon",title:getLabel(31156,"下载"),style:{marginLeft:viewAttr!==1&&showDelete?imgBtnMagrinLeft:0},onClick:function onClick(e){return _this9.download(loadlink,d,e);}}),viewAttr!==1&&showDelete&&_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@knwgka@"+fileid,type:"cross",title:getLabel(91,"删除"),style:showLoad?{float:"right",marginTop:6,fontSize:10,cursor:"pointer",marginRight:imgBtnMagrinRight}:{marginTop:6,fontSize:10,cursor:"pointer"},onClick:_this9.doDeleteT.bind(_this9,fileid)})));var heightStyle=showFullName?{lineHeight:"20px",minHeight:"30px",paddingTop:"3px"}:{minHeight:"30px",lineHeight:"30px"};return listType==="img"?imgDom:_react2.default.createElement("div",{className:"wea-upload-list-item",key:fileid},_react2.default.createElement("div",{className:"wea-upload-list-item-file wea-upload-list-item-file wea-upload-list-item-file-t"+(isDetail?"-nosize":"")+" wea-upload-list-item-file-t-f"+(viewAttr===1&&(showUploader||showUploadTime)&&!isDetail&&oneline?linkHrm?"onlyread wea-upload-list-item-file-t-flinkhrm":"onlyread":"")// onMouseEnter={this.onForceUpdate}
,style:(0,_extends3.default)({width:width},heightStyle)},_react2.default.createElement("div",{className:viewAttr!==1&&editable&&!WEA_UPLOAD_EDITABLE?"wea-upload-list-item-file-editable "+showNameOrTime+" "+hasEditButton+" "+(showFullName?"wea-upload-list-item-file-showfullname":""):showNameOrTime+" wea-upload-list-item-file-noedit"},_react2.default.createElement("div",{className:"wea-upload-list-content",style:showFullName?{whiteSpace:"normal"}:{whiteSpace:"nowrap"}},_react2.default.createElement("div",{style:{display:"inline-block",float:"left"}},showOrder&&index+1+".",viewAttr!==1&&sortable?_react2.default.createElement("span",{"data-index":fileid,key:fileid,className:"icon-coms-move wea-upload-move cursor-pointer"}):null,showLoad&&showLoadInFront&&_react2.default.createElement("i",{ecId:ecId+"_i@nr68da@"+fileid,className:"icon-coms-download wea-upload-icon wea-upload-icon-loadfront",title:getLabel(31156,"下载"),style:{fontSize:15,margin:"7px 6px 0 3px"},onClick:function onClick(e){return _this9.download(loadlink,d,e);}}),imgSrc&&_react2.default.createElement("img",{src:reg.test(imgSrc)?imgSrc:(window.ecologyContentPath||"")+imgSrc,style:{width:16,height:16}})),viewAttr!==1&&WEA_UPLOAD_EDITABLE?showFullName?_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_weaTextarea2.default,{ref:fileid,ecId:ecId+"_WeaTextarea@pjtu61@"+fileid,style:{right:inputRight,paddingTop:"2px",paddingRight:"44px",top:"-20px",backgroundColor:"#fff"},title:getLabel(528241,"文件名不能包含")+" \\ / : * ? \" < > |",value:filename.replace(/\.[^\.]+$/,""),onBlur:function onBlur(v){return _this9.onEdit("listT",v,d);},onKeyDown:function onKeyDown(e){if(e.keyCode&&e.keyCode===13){_this9.onEdit("listT",e.target.value,d);e.preventDefault();}}}),(showUploader&&!oneline&&username||showUploadTime&&!oneline&&uploaddate||casProtect&&showSecLevel)&&_react2.default.createElement("div",{className:"wea-upload-list-item-twoline",style:{top:-10,right:-42}},showSecLevel&&casProtect&&!oneline&&showSecName&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploader"},viewAttr!==1&&allowEditSec?_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_weaPopoverHrm2.default,null),_react2.default.createElement("a",{style:{color:"#999",// marginLeft: 8,
cursor:"pointer"}// href={`javaScript:openhrm(${userid});`}
,ecId:ecId+"_a@8ayucr@"+fileid,onClick:function onClick(){return _this9.editSecLevel(d);}},showSecName)):_react2.default.createElement("span",{style:{color:"#999"// marginLeft: 8,
}},showSecName)),showUploader&&!oneline&&username&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploader"},userid?_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_weaPopoverHrm2.default,null),_react2.default.createElement("a",{style:{color:"#999",// marginLeft: 8,
cursor:"pointer"},ecId:ecId+"_a@9brja9@"+fileid,href:"javaScript:openhrm("+userid+");",onClick:function onClick(e){return window.pointerXY(e);}},username)):_react2.default.createElement("span",{style:{color:"#999"// marginLeft: 8,
}},username)),showUploadTime&&!oneline&&uploaddate&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploadtime"},_react2.default.createElement("span",{style:{color:"#999"// marginLeft: 8
}},uploaddate)))):_react2.default.createElement(_weaInput2.default,{ecId:ecId+"_WeaInput@xb6yon@"+fileid,ref:fileid,style:{right:inputRight,paddingRight:paddingRight,minHeight:"28px"},title:getLabel(528241,"文件名不能包含")+" \\ / : * ? \" < > |",value:filename.replace(/\.[^\.]+$/,""),onBlur:function onBlur(v){return _this9.onEdit("listT",v,d);},onKeyDown:function onKeyDown(e){if(e.keyCode&&e.keyCode===13){_this9.onEdit("listT",e.target.value,d);e.preventDefault();}}}):_react2.default.createElement("div",{style:{overflow:"hidden",textOverflow:"ellipsis"}},isImg?_react2.default.createElement("a",{ecId:ecId+"_a@snyv1p@"+fileid// href="javascript:void(0);"
,title:filename,onClick:function onClick(e){return _this9.playImg(d,e);},className:"formImgPlay wea-field-link",src:reg.test(filelink)?filelink:(window.ecologyContentPath||"")+filelink,"data-imgsrc":reg.test(loadlink)?loadlink.replace("&download=1",""):(window.ecologyContentPath||"")+loadlink.replace("&download=1",""),style:{wordBreak:"break-all"}},filename):_react2.default.createElement("a",{ecId:ecId+"_a@et8f5f@"+fileid,href:"javascript:void(0);",title:filename,onClick:_this9.open.bind(_this9,reg.test(filelink)?filelink:(window.ecologyContentPath||"")+filelink,d),className:"wea-field-link",style:{wordBreak:"break-all"}},filename),viewAttr!==1&&editable&&!WEA_UPLOAD_EDITABLE&&showEditButton&&showFullName&&_react2.default.createElement("i",{ecId:ecId+"_i@jrow9c@"+fileid,className:"icon-coms-edit cursor-pointer "+(showFullName?"showfullname-edit":""),style:{fontSize:15},onClick:function onClick(){return _this9.canEdit("listT",d);},title:getLabel(93,"编辑")}),(showUploader&&!oneline&&username||showUploadTime&&!oneline&&uploaddate||casProtect&&showSecLevel)&&showFullName&&_react2.default.createElement("div",{className:"wea-upload-list-item-twoline"},showSecLevel&&casProtect&&!oneline&&showSecName&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploader"},viewAttr!==1&&allowEditSec?_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_weaPopoverHrm2.default,{ecId:ecId+"_WeaPopoverHrm@fz0im8@"+fileid}),_react2.default.createElement("a",{ecId:ecId+"_a@ral85r@"+fileid,style:{color:"#999",cursor:"pointer"},onClick:function onClick(){return _this9.editSecLevel(d);}},showSecName)):_react2.default.createElement("span",{style:{color:"#999"}},showSecName)),showUploader&&!oneline&&username&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploader"},userid?_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_weaPopoverHrm2.default,{ecId:ecId+"_WeaPopoverHrm@lh1gaj@"+fileid}),_react2.default.createElement("a",{ecId:ecId+"_a@p4vttw@"+fileid,style:{color:"#999",// marginLeft: 8,
cursor:"pointer"},href:"javaScript:openhrm("+userid+");",onClick:function onClick(e){return window.pointerXY(e);}},username)):_react2.default.createElement("span",{style:{color:"#999"// marginLeft: 8,
}},username)),showUploadTime&&!oneline&&uploaddate&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploadtime"},_react2.default.createElement("span",{style:{color:"#999"// marginLeft: 8
}},uploaddate)))),showFilesize&&_react2.default.createElement("div",{className:"wea-upload-list-item-filesize"},_react2.default.createElement("span",{style:{color:"#999",marginLeft:8}},filesize))),viewAttr!==1&&editable&&!WEA_UPLOAD_EDITABLE&&showEditButton&&!showFullName&&_react2.default.createElement("i",{ecId:ecId+"_i@qftb3f@"+fileid,className:"icon-coms-edit cursor-pointer",style:{fontSize:15},onClick:function onClick(){return _this9.canEdit("listT",d);},title:getLabel(93,"编辑")}),!WEA_UPLOAD_EDITABLE&&showUploader&&!isDetail&&oneline&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploader"+(linkHrm?"-linkhrm":"")},userid?_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_weaPopoverHrm2.default,null),_react2.default.createElement("a",{ecId:ecId+"_a@b3jepf@"+fileid,style:{color:"#999",marginLeft:12,cursor:"pointer"},href:"javaScript:openhrm("+userid+");",onClick:function onClick(e){return window.pointerXY(e);}},username)):_react2.default.createElement("span",{style:{color:"#999",marginLeft:12}},username)),!WEA_UPLOAD_EDITABLE&&showUploadTime&&!isDetail&&oneline&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploadtime"+(linkHrm?"-linkhrm":"")},_react2.default.createElement("span",{style:{color:"#999",marginLeft:8}},uploaddate)),_react2.default.createElement("div",{className:"wea-upload-list-item-ops",style:{width:itemOpsDivWidth}},viewAttr!==1&&editable&&overflow&&!WEA_UPLOAD_EDITABLE&&showEditButton?_react2.default.createElement("i",{ecId:ecId+"_i@qlsk8a@"+fileid,className:"icon-coms-edit cursor-pointer",style:{fontSize:15},onClick:function onClick(){return _this9.canEdit("listT",d);},title:getLabel(93,"编辑")}):null,viewAttr!==1&&showDelete&&_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@sze8ep@"+fileid,type:"cross",title:getLabel(91,"删除"),style:{float:"right",margin:"7px 5px 0 3px",cursor:"pointer",fontSize:15},onClick:_this9.doDeleteT.bind(_this9,fileid)}),showLoad&&!showLoadInFront&&_react2.default.createElement("i",{ecId:ecId+"_i@krgpwf@"+fileid,className:"icon-coms-download wea-upload-icon",title:getLabel(31156,"下载"),style:{float:"right",fontSize:15,margin:"7px 6px 0 3px"},onClick:function onClick(e){return _this9.download(loadlink,d,e);}})))),(showUploader&&!oneline&&username||showUploadTime&&!oneline&&uploaddate||casProtect&&showSecLevel)&&!showFullName&&_react2.default.createElement("div",{className:"wea-upload-list-item-twoline",style:{paddingLeft:inputRightPx}},showSecLevel&&casProtect&&!oneline&&showSecName&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploader"},viewAttr!==1&&allowEditSec?_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_weaPopoverHrm2.default,{ecId:ecId+"_WeaPopoverHrm@0xikii@"+fileid}),_react2.default.createElement("a",{ecId:ecId+"_a@njw49v@"+fileid,style:{color:"#999",// marginLeft: 8,
cursor:"pointer"}// href={`javaScript:openhrm(${userid});`}
,onClick:function onClick(){return _this9.editSecLevel(d);}},showSecName)):_react2.default.createElement("span",{style:{color:"#999"// marginLeft: 8,
}},showSecName)),showUploader&&!oneline&&username&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploader"},userid?_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_weaPopoverHrm2.default,{ecId:ecId+"_WeaPopoverHrm@9ykess@"+fileid}),_react2.default.createElement("a",{ecId:ecId+"_a@4p671x@"+fileid,style:{color:"#999",// marginLeft: 8,
cursor:"pointer"},href:"javaScript:openhrm("+userid+");",onClick:function onClick(e){return window.pointerXY(e);}},username)):_react2.default.createElement("span",{style:{color:"#999"// marginLeft: 8,
}},username)),showUploadTime&&!oneline&&uploaddate&&_react2.default.createElement("div",{className:"wea-upload-list-item-uploadtime"},_react2.default.createElement("span",{style:{color:"#999"// marginLeft: 8
}},uploaddate))));}));}},{key:"renderlistB",value:function renderlistB(){var _this10=this;var _props9=this.props,autoUpload=_props9.autoUpload,sortable=_props9.sortable,editable=_props9.editable,ecId=_props9.ecId;var _state8=this.state,listB=_state8.listB,width=_state8.width;var isDetail=void 0;if("isDetail"in this.props){isDetail=this.props.isDetail;}else{isDetail=autoUpload;}var progressWidth=width-20;return _react2.default.createElement("div",{className:"wea-upload-list",ref:"listB",style:{padding:listB.length>0?"0 0 5px 0":0}},listB.map(function(d){if(!d){return;}var name=d.name,id=d.id,progress=d.progress,showProgress=d.showProgress,error=d.error,progressStatus=d.progressStatus,WEA_UPLOAD_EDITABLE=d.WEA_UPLOAD_EDITABLE;var status=error&&progressStatus?{status:progressStatus}:{};// 二开:有错误信息时不显示当前行 ecode控制
var errorClass=error==getLabel(125378,"文件过大")?"wea-upload-list-item-nodisplay":"";return _react2.default.createElement("div",{className:"wea-upload-list-item "+errorClass,key:id},_react2.default.createElement("div",{ecId:ecId+"_div@4g568y@"+id,className:"wea-upload-list-item-file wea-upload-list-item-file-b",style:error?{width:width,padding:"0 80px 0 0"}:{width:width},onClick:function onClick(){var file=d.getNative();var currentWindow=_this10.getCurrentWindow();if(currentWindow.e9ecComConfig&&currentWindow.e9ecComConfig.weaUploadLocalDownload){if("msSaveOrOpenBlob"in navigator){window.navigator.msSaveOrOpenBlob(file,file.name);}else if(currentWindow.URL){var url=currentWindow.URL.createObjectURL(file);// this.download(url);
var a=document.createElement("a");var filename=file.name;a.href=url;a.download=filename;a.click();currentWindow.URL.revokeObjectURL(url);}}}},_react2.default.createElement("div",{className:editable&&!WEA_UPLOAD_EDITABLE?"wea-upload-list-item-file-editable":"wea-upload-list-item-file-noedit"},_react2.default.createElement("div",null,!isDetail&&sortable?_react2.default.createElement("span",{"data-index":id,key:id,className:"icon-coms-move wea-upload-move cursor-pointer"}):null,!isDetail&&_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@plv4qm@"+id,type:"paper-clip",style:{marginRight:5}}),WEA_UPLOAD_EDITABLE?_react2.default.createElement(_weaInput2.default,{ecId:ecId+"_WeaInput@oj076m@"+id,ref:id,title:getLabel(528241,"文件名不能包含")+" \\ / : * ? \" < > |",value:name.replace(/\.[^\.]+$/,""),onBlur:function onBlur(v){return _this10.onEdit("listB",v,d);},onKeyDown:function onKeyDown(e){if(e.keyCode&&e.keyCode===13){_this10.onEdit("listB",e.target.value,d);e.preventDefault();}}}):_react2.default.createElement("span",{style:{cursor:"pointer"}},name))),error&&_react2.default.createElement("span",{style:{display:"inline-block",color:"#f00",position:"absolute",right:0,top:0}},"\uFF08"+error+"\uFF09"),!showProgress&&_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@6gtpza@"+id,type:"cross",className:"wea-upload-list-item-del",style:{fontSize:10},title:getLabel(91,"删除"),onClick:function onClick(e){_this10.doDeleteB(id);e.stopPropagation();}})),showProgress&&_react2.default.createElement("div",null,_react2.default.createElement(_antd.Progress,(0,_extends3.default)({style:{width:progressWidth},percent:progress,strokeWidth:3},status,{ecId:ecId+"_Progress@ixwg5r@"+id})),_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@sucw9e@"+id,type:"cross",className:"wea-upload-list-item-del",style:{fontSize:10},title:getLabel(91,"删除"),onClick:function onClick(e){_this10.doDeleteB(id);e.stopPropagation();}})));}));}},{key:"render",value:function render(){var _classNames,_this11=this;var _props10=this.props,uploadId=_props10.uploadId,uploadUrl=_props10.uploadUrl,category=_props10.category,viewAttr=_props10.viewAttr,showBatchLoad=_props10.showBatchLoad,value=_props10.value,maxUploadSize=_props10.maxUploadSize,mixUploadSize=_props10.mixUploadSize,btnSize=_props10.btnSize,batchLoadUrl=_props10.batchLoadUrl,showClearAll=_props10.showClearAll,showUpload=_props10.showUpload,errorMsg=_props10.errorMsg,style=_props10.style,children=_props10.children,RenderList=_props10.RenderList,RenderListB=_props10.RenderListB,useDefaultListB=_props10.useDefaultListB,showListTop=_props10.showListTop,showListBottom=_props10.showListBottom,sortable=_props10.sortable,maxFilesNumber=_props10.maxFilesNumber,showCancleUpload=_props10.showCancleUpload,className=_props10.className,showScan=_props10.showScan,showHead=_props10.showHead,oneline=_props10.oneline,listType=_props10.listType,autoUpload=_props10.autoUpload,customButton=_props10.customButton,requiredInfo=_props10.requiredInfo,showFilesize=_props10.showFilesize,secLevel=_props10.secLevel,ecId=_props10.ecId,casProtect=_props10.casProtect;var title=this.props.title||getLabel(128095,"上传附件");var _state9=this.state,listT=_state9.listT,listB=_state9.listB,containerId=_state9.containerId,scanLoading=_state9.scanLoading,width=_state9.width,visible=_state9.visible,isEditSec=_state9.isEditSec,currentFile=_state9.currentFile,sensitiveVisible=_state9.sensitiveVisible,sensitiveList=_state9.sensitiveList;var isDetail=void 0;if("isDetail"in this.props){isDetail=this.props.isDetail;}else{isDetail=autoUpload;}var disabled=maxFilesNumber===0||uploadUrl===""||viewAttr===1||category==="";var required=viewAttr===3&&listB.length===0&&listT.length===0;var req=(0,_classnames2.default)({required:required});var notShow=errorMsg!==""||uploadUrl===""||category==="";//将提醒组件使用者使用时哪些props可能未设置或未设置正确
var btn=null;if(children){btn=notShow?_react2.default.createElement("span",{ecId:ecId+"_span@ikshgk",onClick:function onClick(e){_antd.message.error(uploadUrl===""&&viewAttr!==1?getLabel(385922,"请设置文件上传服务器地址!"):category===""&&viewAttr!==1?getLabel(385923,"请设置文件上传目录!"):"",1000);var timer=setTimeout(function(){_antd.message.destroy();clearTimeout(timer);},1000);e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();}},children):_react2.default.createElement("span",{ecId:ecId+"_span@6czqi4",onClick:function onClick(e){if(_userAgent.ua.browser==="IE"&&parseInt(_userAgent.ua.version)<10&&!flashChecker().f){confirm({title:getLabel(127354,"警告"),content:getLabel(385924,"您的IE尚未安装flash插件，需安装后才能使用上传功能，现在安装？"),onOk:function onOk(){window.open("http://get.adobe.com/cn/flashplayer/");}});}// e.stopPropagation && e.stopPropagation();
// e.preventDefault && e.preventDefault();
e.nativeEvent&&e.nativeEvent.preventDefault();}},children," ");}var listNull=listT.length===0&&listB.length===0;var cls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,""+className,className),(0,_defineProperty3.default)(_classNames,"wea-field",/^field/.test(this.props.fieldName)),_classNames));var maxUploadSizeInfo=getLabel(385926,"最大{max}M/个");maxUploadSizeInfo=maxUploadSizeInfo.replace("{max}",maxUploadSize);var mixUploadSizeInfo=getLabel(506196,"最小{mix}M/个");mixUploadSizeInfo=mixUploadSizeInfo.replace("{mix}",mixUploadSize);return _react2.default.createElement("div",{className:"wea-upload "+cls,id:uploadId+"_"+containerId,style:style,ref:"wrap"},RenderList?_react2.default.createElement(RenderList,{ecId:ecId+"_RenderList@iuxa4d",datas:{listT:listT,listB:listB}}):"",children?_react2.default.createElement("div",{id:"container_"+uploadId+"_"+containerId,className:"wea-upload-container"},_react2.default.createElement("span",{ecId:ecId+"_span@gd3pdc",id:category?"browsebtn_"+uploadId+"_"+containerId:"",onClick:function onClick(e){return _this11.checkSecLevel(e);},style:{display:"inline-block"}},btn),_react2.default.createElement("input",{ecId:ecId+"_input@k0458z",type:"hidden",name:uploadId,id:uploadId,value:value}),required&&_react2.default.createElement("span",{className:"wea-required-e9",style:requiredInfo?{paddingLeft:"8px",top:0}:{top:0}},requiredInfo,_react2.default.createElement("img",{src:(window.ecologyContentPath||"")+"/images/BacoError_wev9.png",align:"middle"})),_react2.default.createElement("iframe",{ref:"download_"+uploadId+"_"+containerId,style:{display:"none"}})):_react2.default.createElement("span",null,_react2.default.createElement("div",null,showListTop?viewAttr!==1&&sortable?_react2.default.createElement(_react2.default.Fragment,null,showHead&&oneline&&!isDetail&&listT.length>0&&listType!=="img"&&_react2.default.createElement("div",{className:"wea-upload-list-thead",style:{width:width}},_react2.default.createElement("div",{className:"wea-upload-list-thead-filename"},getLabel(23752,"附件名称")),_react2.default.createElement("div",{className:"wea-upload-list-thead-username"},getLabel(26083,"上传人")),_react2.default.createElement("div",{className:"wea-upload-list-thead-uploadtime"},getLabel(23068,"上传时间")),showFilesize&&_react2.default.createElement("div",{className:"wea-upload-list-thead-filesize"},getLabel(2036,"大小"))),_react2.default.createElement(_weaDragula2.default,(0,_extends3.default)({},this.getWeaDragulaProps("listT"),{ecId:ecId+"_WeaDragula@7krxtv"}),this.renderlistT())):_react2.default.createElement(_react2.default.Fragment,null,showHead&&oneline&&!isDetail&&listT.length>0&&listType!=="img"&&_react2.default.createElement("div",{className:"wea-upload-list-thead",style:{width:width}},_react2.default.createElement("div",{className:"wea-upload-list-thead-filename"},getLabel(23752,"附件名称")),_react2.default.createElement("div",{className:"wea-upload-list-thead-username"},getLabel(26083,"上传人")),_react2.default.createElement("div",{className:"wea-upload-list-thead-uploadtime"},getLabel(23068,"上传时间")),showFilesize&&_react2.default.createElement("div",{className:"wea-upload-list-thead-filesize"},getLabel(2036,"大小"))),this.renderlistT()):null,errorMsg!==""?_react2.default.createElement("span",{style:{color:"#f00"}},errorMsg):uploadUrl===""&&viewAttr!==1?_react2.default.createElement("span",{style:{color:"#f00"}},getLabel(385922,"请设置文件上传服务器地址!")):category===""&&viewAttr!==1?_react2.default.createElement("span",{style:{color:"#f00"}},getLabel(385923,"请设置文件上传目录!")):"",_react2.default.createElement("div",{className:"wea-upload-container",style:notShow?{display:"inline-block",width:0,height:0,overflow:"hidden"}:viewAttr===1&&(!showBatchLoad||listNull)?{display:"none"}:{}},btnSize==="small"?_react2.default.createElement("span",{style:{display:"inline-block",verticalAlign:"middle"// position: "relative",
// top: 4
}},_react2.default.createElement("span",{id:"container_"+uploadId+"_"+containerId,style:viewAttr===1?{display:"inline-block",width:0,height:0,overflow:"hidden"}:{}},showUpload&&_react2.default.createElement("i",{ecId:ecId+"_i@c6eoju",id:"browsebtn_"+uploadId+"_"+containerId,className:"icon-coms-AddTo wea-upload-icon",title:title,onClick:function onClick(e){return _this11.checkSecLevel(e);},style:{margin:"0 5px 5px 0",float:"left"}}),customButton!==null?_react2.default.createElement("span",{ecId:ecId+"_span@49bgv3",onClick:function onClick(){return typeof _this11.props.customClick==="function"&&_this11.props.customClick(_this11.uploader);}},customButton):null,showClearAll&&!listNull&&_react2.default.createElement(_antd.Button,{ecId:ecId+"_Button@sgvb0a",type:"ghost",disabled:listB.length===0,shape:"circle-outline",icon:"cross",title:getLabel(385925,"清除所有"),style:{margin:"0 5px 5px 0",width:25,height:23},onClick:this.clearAllFiles}),showCancleUpload&&_react2.default.createElement(_antd.Button,{ecId:ecId+"_Button@fyl20v",type:"ghost",disabled:listB.length===0,shape:"circle-outline",icon:"cross",title:getLabel(126306,"取消上传"),style:{margin:"0 5px 5px 0",width:25,height:23},onClick:this.cancleUpload})),showBatchLoad&&!listNull&&_react2.default.createElement(_antd.Button,{ecId:ecId+"_Button@8rk3o3",type:"ghost",shape:"circle-outline",icon:"download",title:getLabel(32405,"全部下载"),style:{margin:"0 5px 5px 0"},onClick:this.download.bind(this,batchLoadUrl,listT)})):_react2.default.createElement("span",null,_react2.default.createElement("span",{id:"container_"+uploadId+"_"+containerId,style:viewAttr===1?{display:"inline-block",width:0,height:0,overflow:"hidden"}:{}},showUpload&&_react2.default.createElement(_antd.Button,{ecId:ecId+"_Button@2yh7pb",disabled:disabled,type:"ghost",id:"browsebtn_"+uploadId+"_"+containerId,onClick:function onClick(e){return _this11.checkSecLevel(e);},style:{margin:"0 5px 5px 0"}},_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@6i27sr",type:"upload"})," ",title),customButton!==null?_react2.default.createElement("span",{ecId:ecId+"_span@v1rscl",onClick:function onClick(){return typeof _this11.props.customClick==="function"&&_this11.props.customClick(_this11.uploader);}},customButton):null,showClearAll&&_react2.default.createElement(_antd.Button,{ecId:ecId+"_Button@mormdo",disabled:listB.length===0,type:"ghost",style:{margin:"0 5px 5px 0"},onClick:this.clearAllFiles.bind(this)},_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@x656f4",type:"cross"})," ",getLabel(385925,"清除所有")),showCancleUpload&&_react2.default.createElement(_antd.Button,{ecId:ecId+"_Button@s83w7p",disabled:listB.length===0,type:"ghost",style:{margin:"0 5px 5px 0"},onClick:this.cancleUpload},_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@z31r7k",type:"cross"})," ",getLabel(126306,"取消上传"))),showBatchLoad&&!listNull&&_react2.default.createElement(_antd.Button,{ecId:ecId+"_Button@zum1ki",type:"ghost",style:{margin:"0 5px 5px 0"},onClick:this.download.bind(this,batchLoadUrl,listT)},_react2.default.createElement(_antd.Icon,{ecId:ecId+"_Icon@1uyq9l",type:"download"})," ",getLabel(32405,"全部下载"))),_react2.default.createElement("span",{// className={`${req}`}
style:{position:"relative",display:"inline-block",marginBottom:5,marginRight:required?15:0}},viewAttr!==1&&!!maxUploadSize&&_react2.default.createElement("span",null,maxUploadSizeInfo),viewAttr!==1&&!!mixUploadSize&&_react2.default.createElement("span",null,"\xA0",mixUploadSizeInfo),required&&_react2.default.createElement("span",{className:"wea-required-e9",style:requiredInfo?{paddingLeft:"8px",top:0}:{top:0}},requiredInfo,_react2.default.createElement("img",{src:(window.ecologyContentPath||"")+"/images/BacoError_wev9.png",align:"middle"})))),showListBottom?viewAttr!==1&&sortable?_react2.default.createElement(_weaDragula2.default,(0,_extends3.default)({},this.getWeaDragulaProps("listB"),{ecId:ecId+"_WeaDragula@jx5myj"}),this.renderlistB()):this.renderlistB():null,_react2.default.createElement("input",{ecId:ecId+"_input@3psgqp",type:"hidden",name:uploadId,id:uploadId,value:value}),_react2.default.createElement("iframe",{ref:"download_"+uploadId+"_"+containerId,style:{display:"none"}}))),useDefaultListB?this.getDefaultListB():RenderListB?_react2.default.createElement(RenderListB,{ecId:ecId+"_RenderListB@kpy66p",datas:{listT:listT,listB:listB}}):"",casProtect&&_react2.default.createElement(_secLevelDialog2.default,{ecId:ecId+"_SecLevelDialog@acvypt",visible:visible,isEditSec:isEditSec,secLevel:secLevel,changeVisible:this.changeVisible,onSave:this.onSave,onEditSec:this.onEditSec,onCancel:this.cancelEdit,currentFile:currentFile}),_react2.default.createElement(_sensitiveDialog2.default,{visible:sensitiveVisible,sensitiveList:sensitiveList,changeSensiVisible:this.changeSensiVisible}));}}]);return Main;}(_react2.default.Component),_class.loadjs=_loadjs2.default,_class.fileNameReg=fileNameReg,_class.defaultProps={datas:undefined,autoUpload:true,uploadId:"",uploadUrl:"",uploadParams:{},multiSelection:true,forceIE9Flash:true,display:true,maxUploadSize:0,mixUploadSize:0,maxFilesNumber:Infinity,fileDataName:"",customOptions:{},limitType:"",listType:"list",viewAttr:2,imgHeight:50,imgWidth:50,category:"",showBatchLoad:false,value:"",btnSize:"default",batchLoadUrl:"",showClearAll:true,showUpload:true,errorMsg:"",style:{},RenderList:undefined,RenderListB:undefined,useDefaultListB:false,clearWhenReset:true,showListTop:true,showListBottom:true,sortable:true,editable:false,showOrder:false,showCancleUpload:false,oneline:false,className:"",replaceWhenOver:true,showErrorInfo:true,showEditButton:true,showUploader:false,showUploadTime:false,defaultErrorInfo:true,showScan:false,showHead:false,linkHrm:false,prohibitType:"",dragUpload:false,showLoadInFront:false,pluginVersion:"2.3.6",customButton:null,requiredInfo:"",showFilesize:true,showFullName:false,secLevel:"",secLevelInfo:"请填写密级",showSecLevel:true,modifySecUrl:"/api/doc/upload/ModifySecretLevel",allowEditSec:true,casProtect:false,secLevelDisplayFormat:"",needCheckSec:true,needModifyDocSec:true},_temp);var Com=(0,_middleware2.default)(Main,"WeaUpload");exports.default=Com;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(428), __esModule: true };

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(429), __esModule: true };

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(434), __esModule: true };

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(437), __esModule: true };

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(68);
var call = __webpack_require__(224);
var isArrayIter = __webpack_require__(225);
var anObject = __webpack_require__(44);
var toLength = __webpack_require__(144);
var getIterFn = __webpack_require__(162);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.formatImgOrVideo=exports.filterDomNode=exports.transStyleObjToString=exports.getAtwhoConfig=exports.getAtConfigInExtendsConfig=exports.connectDataWithDiv=exports.getConfig=exports.filterToolbar=exports.fillterToolbarStr=exports.checkDefaultFont=exports.getLang=exports.transVideo=exports.filterValueOfDiv=exports.clearEmptyChar=exports.getHash=exports.transfStr=exports.restoreSpeicalStr=exports.convertSpecialChar=undefined;var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _propType=__webpack_require__(330);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getUserLanguage=_weaLocaleProvider2.default.getUserLanguage;var convertSpecialChar=exports.convertSpecialChar=function convertSpecialChar(str){str=str.toString();str=str.replace(/<br>/gi,"\n");str=str.replace(/&nbsp;/gi," ");str=str.replace(/&lt;/gi,"<");str=str.replace(/&gt;/gi,">");str=str.replace(/&quot;/gi,'"');str=str.replace(/&amp;/gi,"&");return str;};var restoreSpeicalStr=exports.restoreSpeicalStr=function restoreSpeicalStr(str){str=str.toString();//需先转译
str=str.replace(/&/gi,"&amp;");str=str.replace(/</gi,"&lt;");str=str.replace(/>/gi,"&gt;");//后转译
str=str.replace(/\n/gi,"<br>");str=str.replace(/ /gi,"&nbsp;");str=str.replace(/\"/gi,"&quot;");return str;};// 内容转换
var transfStr=exports.transfStr=function transfStr(type,ids,list,lev2Type){var str="";list.forEach(function(item){if(type==="Upload"&&lev2Type==="image"){var imgSrc=item.imgSrc;if(window.ecologyContentPath&&imgSrc.indexOf(window.ecologyContentPath)<0){imgSrc=window.ecologyContentPath+imgSrc;}str+="<img src=\""+imgSrc+"\" alt=\"\" />&#8203;";}if(type==="Upload"&&(lev2Type==="file"||lev2Type==="list")){str+="<a onclick=\"ecCom.WeaRichText.opendoc1(this,"+item.fileid+")\" unselectable=\"off\""+'style="cursor:pointer;text-decoration:underline !important;margin-right:8px"'+("href=\"javascript:void(0);\" contenteditable=\"false\">"+item.filename+"</a>&#8203;");if(item.showLoad){str+="&nbsp;<a unselectable='off' contenteditable='false'"+("href='javascript:try{downloadFile(\""+item.loadlink+"\",\""+item.fileid+"\")}catch(e){window.open(\""+item.loadlink+"\")}' ")+("style='cursor:pointer;text-decoration:underline;margin-right:8px'>\u4E0B\u8F7D("+item.filesize+")</a><br>");}}if(type==="Browser"){str+="<a contenteditable='false' onclick=\"ecCom.WeaRichText.openAppLink(this,"+item.id+","+lev2Type+")\""+'href="javascript:void(0);" unselectable="off" contenteditable="false"'+'style="cursor:pointer;text-decoration:underline !important;margin-right:8px">'+((item.name||item.showname)+"</a>&#8203;");}});return str;};// hash 生成id
var getHash=exports.getHash=function getHash(){return Math.random().toString(36).substr(2,6);};var clearEmptyChar=exports.clearEmptyChar=function clearEmptyChar(data){return data.replace(/[\u200B-\u200D\uFEFF]/g,"").replace("&#8203;","");};// 过滤默认传入的带div的标签
var filterValueOfDiv=exports.filterValueOfDiv=function filterValueOfDiv(data){var preReg=new RegExp(/^<div id=\"wea_rich_text_default_font\"[^>]+\>/);if(preReg.test(data)){data=data.replace(preReg,"").replace(/<\/div>$/,"");}return data;};// fix: 编辑提交后的文档,视频无法删除问题
var transVideo=exports.transVideo=function transVideo(data){if(data&&data.indexOf("</video>")>-1){data=data.replace(/<\/video>/g,"</video>&#8203;");}return data;};// 当前系统语言
var getLang=exports.getLang=function getLang(){return{7:"zh-cn",8:"en",9:"zh"}[getUserLanguage()];};// 得到默认字体 默认字体大小相关属性
var checkDefaultFont=exports.checkDefaultFont=function checkDefaultFont(config){if(!config)return{};// 1、直接通过ckeditor的属性 fontSize_defaultLabel， font_defaultLabel传的配置
// 2、流程签字意见通过约定的属性fontSize_defaultSize， font_defaultFamily作为默认字体和字体大小的配置
var fontSize_defaultLabel=config.fontSize_defaultLabel,font_defaultLabel=config.font_defaultLabel,fontSize_defaultSize=config.fontSize_defaultSize,font_defaultFamily=config.font_defaultFamily,font_defaultWeight=config.font_defaultWeight;var fontFamily=font_defaultLabel||font_defaultFamily&&font_defaultFamily.split("/")[1]||"";var fontSize=fontSize_defaultLabel||fontSize_defaultSize&&fontSize_defaultSize.split("/")[1];return{hasDefaultFontFamily:fontFamily&&config.font_names.indexOf(fontFamily)>-1,fontFamily:fontFamily,hasDefaultFontSize:fontSize&&config.fontSize_sizes.indexOf(fontSize)>-1,fontSize:fontSize,font_defaultWeight:font_defaultWeight};};// 判断toolbar 是否有相关的配置属性
var fillterToolbarStr=exports.fillterToolbarStr=function fillterToolbarStr(toolbar,value){if(!toolbar||toolbar.length===0)return false;var str=(0,_stringify2.default)(toolbar);return str.indexOf(value)>-1;};// Maximize Image 扩展判断 （渲染组件内部代码）
var filterToolbar=exports.filterToolbar=function filterToolbar(toolbar){var toolbarArr=toolbar;var hasMaximize=fillterToolbarStr(toolbarArr,"Maximize");var hasImage=fillterToolbarStr(toolbarArr,"Image");var hasVideo=fillterToolbarStr(toolbarArr,"Html5video");if(hasMaximize||hasImage||hasVideo){toolbarArr=toolbarArr.map(function(tool){var _tool=Array.isArray(tool)?[].concat(tool):(0,_extends3.default)({},tool);if(Array.isArray(tool))_tool=tool.filter(function(item){return item!=="Maximize"&&item!=="Image"&&item!=="Html5video";});if(_tool.items)_tool.items=tool.items.filter(function(item){return item!=="Maximize"&&item!=="Image"&&item!=="Html5video";});return _tool;});}return toolbarArr;};// 获取最终ckConfig
var getConfig=exports.getConfig=function getConfig(ckConfig){var font_en=_propType.defultCkConfig.font_en,font_zh=_propType.defultCkConfig.font_zh,uploadUrl=_propType.defultCkConfig.uploadUrl;var defaultConfig=(0,_extends3.default)({},_propType.defultCkConfig,{language:getLang(),font_names:getLang()==="en"?font_en+font_zh:font_zh+font_en,uploadUrl:ckConfig.uploadUrl&&ckConfig.uploadUrl!==""?ckConfig.uploadUrl:uploadUrl});var extraPlugins=["filetools","pastetools","pastefromword","autolink","openlink","image2","imagepaste","uploadimage","tableresizerowandcolumn"];if(ckConfig.extraPlugins){var extra=ckConfig.extraPlugins.split(",");extraPlugins=[].concat((0,_toConsumableArray3.default)(extraPlugins),(0,_toConsumableArray3.default)(extra));}if(ckConfig.placeholder){// placeholder
extraPlugins=[].concat((0,_toConsumableArray3.default)(extraPlugins),["confighelper"]);}if((0,_stringify2.default)(ckConfig.toolbar).indexOf("textindent")>-1){// 首行缩进
extraPlugins=[].concat((0,_toConsumableArray3.default)(extraPlugins),["textindent"]);}var config=(0,_extends3.default)({},defaultConfig,ckConfig,{removePlugins:ckConfig.removePlugins?"magicline,"+ckConfig.removePlugins:"magicline",// magicline: 去掉红色分割线
extraPlugins:extraPlugins.join(","),toolbar:filterToolbar(ckConfig.toolbar)});var defaultFontPrams=checkDefaultFont(config);if(defaultFontPrams.hasDefaultFontFamily){config=(0,_extends3.default)({},config,{font_defaultLabel:defaultFontPrams.fontFamily,fontSize_defaultLabel:defaultFontPrams.fontSize});}return config;};// 获取默认字体 默认字体大小的div
var connectDataWithDiv=exports.connectDataWithDiv=function connectDataWithDiv(ckConfig,content){var _checkDefaultFont=checkDefaultFont(ckConfig),hasDefaultFontFamily=_checkDefaultFont.hasDefaultFontFamily,fontFamily=_checkDefaultFont.fontFamily,hasDefaultFontSize=_checkDefaultFont.hasDefaultFontSize,fontSize=_checkDefaultFont.fontSize,font_defaultWeight=_checkDefaultFont.font_defaultWeight;if((hasDefaultFontFamily||hasDefaultFontSize)&&content){var pre='<div id="wea_rich_text_default_font" style="';var style="";if(hasDefaultFontFamily){style+="font-family:"+fontFamily+";";}if(hasDefaultFontSize){style+="font-size:"+fontSize+";";}if(font_defaultWeight){style+="font-weight:"+font_defaultWeight+";";}content=""+pre+style+"\">"+content+"</div>";}return content;};// 过滤extentsConfig中 at相关配置
var getAtConfigInExtendsConfig=exports.getAtConfigInExtendsConfig=function getAtConfigInExtendsConfig(extentsConfig){return extentsConfig.filter(function(item){return item.name==="At";})[0];};// get atwho config
var getAtwhoConfig=exports.getAtwhoConfig=function getAtwhoConfig(extentsConfig,otherConfig){var configInExtendsConfig=getAtConfigInExtendsConfig(extentsConfig);var apiRequest=!configInExtendsConfig.data||configInExtendsConfig.data.length===0;// 是否走接口请求@数据 - 默认传了data表示渲染传入的数据
var atwhoConfig=(0,_extends3.default)({},configInExtendsConfig,_propType.defaultAtwhoConfig,otherConfig,{// 组件内部才能拿到的方法和事件
isEn:getLang()==="en",pageSize:configInExtendsConfig.pageSize||_propType.defaultAtwhoConfig.pageSize,apiRequest:apiRequest});if(!apiRequest){// 传入的data 匹配atwho.js 需要的数据格式
var allatids=",";var filterData=configInExtendsConfig.data.map(function(_ref){var uid=_ref.uid,data=_ref.data,datapy=_ref.datapy;if(allatids.indexOf(","+uid+",")===-1){allatids+=uid+",";return{id:uid,name:data,py:datapy};}});atwhoConfig=(0,_extends3.default)({},atwhoConfig,{data:filterData});}return atwhoConfig;};var transStyleObjToString=exports.transStyleObjToString=function transStyleObjToString(styleObj,filterName){var str="";if((0,_keys2.default)(styleObj).length>0){(0,_keys2.default)(styleObj).map(function(item){if(!filterName||item!==filterName){str+=item+":"+styleObj[item]+";";}});}return str;};var filterDomNode=exports.filterDomNode=function filterDomNode(children,fontStyleStr,pStyleStr){if(children.length>0){var tableTags=["TABLE","TBODY","THEAD","TFOOT","TR","COLGROUP"];for(var i=0;i<children.length;i++){var child=children[i];if(tableTags.indexOf(child.nodeName)>-1){// table相关（除了td）不处理
continue;}else if(child.nodeName==="P"){// p标签添加样式
child.setAttribute("style",pStyleStr);}else if(child.nodeName==="LI"){// td | li 添加文本样式,并保留之前的样式
var oldStyleStr=child.getAttribute("style");var oldStyleArr=oldStyleStr?oldStyleStr.split(";"):[];var fontStyleArr=fontStyleStr?fontStyleStr.split(";"):[];var newStyleArr=[].concat((0,_toConsumableArray3.default)(oldStyleArr),(0,_toConsumableArray3.default)(fontStyleArr));var newStyleStr=newStyleArr.join(";");child.setAttribute("style",newStyleStr);}else{// 移除其他标签的style属性
child.removeAttribute("style");}var newChildren=child.children;filterDomNode(newChildren,fontStyleStr,pStyleStr);}}};var formatImgOrVideo=exports.formatImgOrVideo=function formatImgOrVideo(list,display,style,wrapParams){if(list.length===0)return;var pStyleStr=wrapParams.pStyleStr,centerStyleStr=wrapParams.centerStyleStr,mormalStyleStr=wrapParams.mormalStyleStr,wrapStyle=wrapParams.wrapStyle;for(var i=0;i<list.length;i++){// 1: 配置img | video标签样式
var item=list[i];var styleStr=transStyleObjToString(style);item.setAttribute("style",styleStr);// 2: 配置包裹的p标签样式
if(display==="block"&&(typeof wrapStyle==="undefined"?"undefined":(0,_typeof3.default)(wrapStyle))==="object"){// 整行显示
var parent=item.parentNode;if(parent.nodeName==="P"){var childNodes=parent.childNodes;if(childNodes.length>0){var changed=false;// 标记当前的节点后的节点是否需要外包p标签
for(var k=0;k<childNodes.length;k++){var child=childNodes[k];if(child.nodeType===3){// 文本节点
child.nodeValue=clearEmptyChar(child.nodeValue).trim();if(child.nodeValue!==""){if(changed){var newP=document.createElement("p");newP.setAttribute("style",pStyleStr);$(child).wrap(newP);}else{parent.setAttribute("style",pStyleStr);changed=true;}}}else if(child.nodeType===1){// element节点
if(changed){var _newP=document.createElement("p");if(wrapStyle["text-align"]&&wrapStyle["text-align"]==="center"){_newP.setAttribute("style",centerStyleStr);}else{_newP.setAttribute("style",mormalStyleStr);}$(child).wrap(_newP);}else{if(wrapStyle["text-align"]&&wrapStyle["text-align"]==="center"){parent.setAttribute("style",centerStyleStr);}else{parent.setAttribute("style",mormalStyleStr);}changed=true;}}}}}}}};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _weaInputNormal=__webpack_require__(140);var _weaInputNormal2=_interopRequireDefault(_weaInputNormal);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _isArray=__webpack_require__(21);var _isArray2=_interopRequireDefault(_isArray);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _random=__webpack_require__(97);var _random2=_interopRequireDefault(_random);var _forEach=__webpack_require__(81);var _forEach2=_interopRequireDefault(_forEach);var _findIndex=__webpack_require__(141);var _findIndex2=_interopRequireDefault(_findIndex);var _uniq=__webpack_require__(65);var _uniq2=_interopRequireDefault(_uniq);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);__webpack_require__(678);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _weaAvatar=__webpack_require__(135);var _weaAvatar2=_interopRequireDefault(_weaAvatar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var confirm=_antd.Modal.confirm;var TreeNode=_antd.Tree.TreeNode;var newKey="ADD_NEW_NODE_KEY";var objToArray=function objToArray(obj){if(!(0,_isArray2.default)(obj)){var arr=[];arr.push(obj);obj=arr;}return(0,_cloneDeep2.default)(obj);};var count=0;var WeaTree=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaTree,_React$Component);function WeaTree(props){(0,_classCallCheck3.default)(this,WeaTree);var _this2=(0,_possibleConstructorReturn3.default)(this,(WeaTree.__proto__||(0,_getPrototypeOf2.default)(WeaTree)).call(this,props));_this2.state={datas:props.datas?objToArray(props.datas):[],checkStrictly:props.checkStrictly||false,spinning:false,radioCheckedKey:props.radioCheckedKey||"",expandedKeys:props.expandedKeys||[],selectedKeys:props.selectedKeys||[],checkedKeys:props.checkedKeys||[]};_this2.treeMap={};["onExpand","onSelect","onCheck","onRadioCheck",// "onDoubleClick",
"loadData","onDrop"].forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(WeaTree,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _state=this.state,datas=_state.datas,radioCheckedKey=_state.radioCheckedKey,expandedKeys=_state.expandedKeys,selectedKeys=_state.selectedKeys,checkedKeys=_state.checkedKeys,checkStrictly=_state.checkStrictly;if(!(0,_isEqual2.default)(this.props.datas,nextProps.datas)){datas=(0,_cloneDeep2.default)(objToArray(nextProps.datas));this.setState({datas:datas});}if("checkStrictly"in nextProps&&!(0,_isEqual2.default)(checkStrictly,nextProps.checkStrictly)){checkStrictly=nextProps.checkStrictly;this.setState({checkStrictly:checkStrictly});}if("radioCheckedKey"in nextProps&&!(0,_isEqual2.default)(radioCheckedKey,nextProps.radioCheckedKey)){radioCheckedKey=nextProps.radioCheckedKey;this.setState({radioCheckedKey:radioCheckedKey});}if("expandedKeys"in nextProps&&!(0,_isEqual2.default)(expandedKeys,nextProps.expandedKeys)){expandedKeys=nextProps.expandedKeys;this.setState({expandedKeys:expandedKeys});}if("selectedKeys"in nextProps&&!(0,_isEqual2.default)(selectedKeys,nextProps.selectedKeys)){selectedKeys=nextProps.selectedKeys;this.setState({selectedKeys:selectedKeys});}if("checkedKeys"in nextProps&&!(0,_isEqual2.default)(checkedKeys,nextProps.checkedKeys)){checkedKeys=nextProps.checkedKeys;this.setState({checkedKeys:checkedKeys});}}},{key:"loadData",value:function loadData(treeNode){var _this3=this;var props=this.props;var _props=this.props,loadData=_props.loadData,noCache=_props.noCache;if(loadData&&(noCache||!treeNode.props.data.isLoad)){return loadData((0,_cloneDeep2.default)(treeNode.props.data),this).then(function(data){var datas=_this3.state.datas;treeNode.props.data.children=data.datas;_this3.setState({datas:datas});props.onDatasChange&&props.onDatasChange(datas);});}else{return new _promise2.default(function(resolve){resolve();});}}},{key:"onDrop",value:function onDrop(e){var datas=this.state.datas;var props=this.props;var dragNodesKeys=e.dragNodesKeys,node=e.node;var dragNode=void 0;if(!(0,_isEmpty2.default)(dragNodesKeys)){dragNode=this.treeMap[dragNodesKeys.pop()];}var targetNode=this.treeMap[node.props.eventKey];if(dragNode&&!dragNode.dragDisabled){var dragNodeClone=(0,_cloneDeep2.default)(dragNode);delete dragNodeClone.isRoot;delete dragNodeClone.parentTreeKey;var list=void 0;if(targetNode.isRoot){list=datas;dragNodeClone.isRoot=true;}else{list=this.treeMap[targetNode.parentTreeKey].children;dragNodeClone.parentTreeKey=targetNode.parentTreeKey;}var idx=(0,_findIndex2.default)(list,function(l){return l.treeKey===targetNode.treeKey;});list.splice(idx+1,0,dragNodeClone);// add node
// let dragList;
// if (dragNode.isRoot) {
//   dragList = datas;
// } else {
//   dragList = this.treeMap[dragNode.parentTreeKey].children;
// }
// idx = findIndex(dragList, (l) =>l.treeKey === dragNode.treeKey);
// dragList.splice(idx, 1); // delete node
dragNode.deleted=true;this.setState({datas:datas},function(){props.onDrag&&props.onDrag(dragNode,targetNode,datas);});}}},{key:"onExpand",value:function onExpand(ks,e){var _this4=this;var props=this.props;var ids=[],nodeids=[],datas=[];ks&&ks.forEach(function(k){var target=_this4.treeMap[k];if(target&&target.treeKey==k){ids.push(target.id);target.nodeid&&nodeids.push(target.nodeid);datas.push(target);}});ids=(0,_uniq2.default)(ids);nodeids=(0,_uniq2.default)(nodeids);this.setState({expandedKeys:!(0,_isEmpty2.default)(nodeids)?nodeids:ids});props.onExpand&&props.onExpand(ids,nodeids,datas,e);}},{key:"onSelect",value:function onSelect(ks,e){var _this5=this;if((0,_isEmpty2.default)(ks))return;// 不支持取消选中
var props=this.props;var ids=[],nodeids=[],datas=[];ks&&ks.forEach(function(k){var target=_this5.treeMap[k];if(target&&target.treeKey==k){ids.push(target.id);target.nodeid&&nodeids.push(target.nodeid);datas.push(target);}});ids=(0,_uniq2.default)(ids);nodeids=(0,_uniq2.default)(nodeids);this.setState({selectedKeys:!(0,_isEmpty2.default)(nodeids)?nodeids:ids});props.onSelect&&props.onSelect(ids,nodeids,datas,e);}},{key:"onCheck",value:function onCheck(ks,e){var _this6=this;var props=this.props;var ids=[],nodeids=[],datas=[];ks&&ks.forEach(function(k){var target=_this6.treeMap[k];if(target&&target.treeKey==k){ids.push(target.id);target.nodeid&&nodeids.push(target.nodeid);datas.push(target);}});ids=(0,_uniq2.default)(ids);nodeids=(0,_uniq2.default)(nodeids);this.setState({checkedKeys:!(0,_isEmpty2.default)(nodeids)?nodeids:ids});// 点击check 展开节点 考虑到异步的case 暂时不开放功能
// let expandedKeys = this.getExpandedKeys();
// expandedKeys = uniq(expandedKeys.concat(ks));
// this.onExpand(expandedKeys);
props.onCheck&&props.onCheck(ids,nodeids,datas,e);}},{key:"onRadioCheck",value:function onRadioCheck(key){var props=this.props;this.setState({radioCheckedKey:this.treeMap[key].nodeid||this.treeMap[key].id});props.onRadioCheck&&props.onRadioCheck(this.treeMap[key].id,this.treeMap[key].nodeid,this.treeMap[key]);}// onDoubleClick(key) {
//   const { props } = this;
//   if (this.isCheckboxDisable(this.treeMap[key])) return;
//   props.onDoubleClick && props.onDoubleClick([this.treeMap[key]]);
// }
},{key:"focus",value:function focus(){var _this7=this;setTimeout(function(){var dom=$(_this7.refs.input.refs.input.refs.input);var t=dom.val();setTimeout(function(){dom.val("").focus().val(t);},10);},10);}},{key:"addRootNode",value:function addRootNode(){var _this8=this;var props=this.props;var _state2=this.state,datas=_state2.datas,expandedKeys=_state2.expandedKeys;var target={name:"",displayType:"add",isRoot:true,treeKey:newKey};this.treeMap[newKey]=(0,_cloneDeep2.default)(target);props.addToLast?datas.push(target):datas.unshift(target);this.setState({datas:datas},function(){_this8.focus();});props.onDatasChange&&props.onDatasChange(datas);}},{key:"opsHandler",value:function opsHandler(item,ops){var _this9=this;var props=this.props;var _state3=this.state,datas=_state3.datas,expandedKeys=_state3.expandedKeys;var passCheck=true;if(props.onOpsCheck){passCheck=props.onOpsCheck(ops.type,item);if(passCheck==false){return;}}if(ops.type=="add"){if(props.addHandler){props.addHandler(item);}else{if(!this.treeMap[newKey]){var target={name:"",displayType:"add",parentTreeKey:item.treeKey,treeKey:newKey};if(expandedKeys.indexOf(item.treeKey)==-1){expandedKeys.push(item.treeKey);this.onExpand(expandedKeys);}var _props2=this.props,loadData=_props2.loadData,noCache=_props2.noCache,addToLast=_props2.addToLast;// 判断有子节点先请求数据
if((item.isParent||item.haschild)&&((0,_isEmpty2.default)(item.children)||noCache)&&loadData){this.setState({spinning:true});loadData((0,_cloneDeep2.default)(item),this).then(function(data){item.children=data.datas||[];addToLast?item.children.push(target):item.children.unshift(target);_this9.treeMap[newKey]=(0,_cloneDeep2.default)(target);_this9.setState({datas:datas,spinning:false},function(){_this9.focus();});props.onDatasChange&&props.onDatasChange(datas);});}else{item.isParent=true;if(item.children&&(0,_isArray2.default)(item.children)){addToLast?item.children.push(target):item.children.unshift(target);}else{item.children=[target];}this.treeMap[newKey]=(0,_cloneDeep2.default)(target);this.setState({datas:datas},function(){_this9.focus();});props.onDatasChange&&props.onDatasChange(datas);}}}return;}if(ops.type=="edit"){if(props.editHandler){props.editHandler(item);}else{this.treeMap[item.treeKey].displayType="edit";this.setState({datas:datas},function(){_this9.focus();});props.onDatasChange&&props.onDatasChange(datas);}return;}var _this=this;if(ops.type=="delete"){if(props.deleteHandler){props.deleteHandler(item);}else{confirm({title:props.deleteConfirmText||getLabel("385830","\u786E\u8BA4\u8981\u5220\u9664\u201C$s\u201D\u5417\uFF1F").replace(/\$s/,item.name),onOk:function onOk(){_this.deleteHandler(item);}});}return;}props.opsHandler&&props.opsHandler(item,ops);}},{key:"editHandler",value:function editHandler(v,item){var _this10=this;var props=this.props;var datas=this.state.datas;if((0,_trim2.default)(v)){var beforeName=item.name;item.name=v;this.setState({spinning:true});props.onEdit&&props.onEdit(v,item).then(function(data){delete item.displayType;(0,_isFunction2.default)(props.validate)&&!props.validate(item)&&(item.name=beforeName);_this10.setState({datas:datas,spinning:false});props.onDatasChange&&props.onDatasChange(datas);},function(error){item.name=beforeName;delete item.displayType;_this10.setState({datas:datas,spinning:false});props.onDatasChange&&props.onDatasChange(datas);});}else{delete item.displayType;this.setState({datas:datas});props.onDatasChange&&props.onDatasChange(datas);}}},{key:"addHandler",value:function addHandler(v,item){var _this11=this;var props=this.props;var datas=this.state.datas;if((0,_trim2.default)(v)){this.setState({spinning:true});item.name=v;var params=item.isRoot?[v]:[v,this.treeMap[item.parentTreeKey]];props.onAdd&&props.onAdd.apply(props,params).then(function(data){(0,_forEach2.default)(data,function(v,k){item[k]=v;});delete item.displayType;delete item.treeKey;(0,_isFunction2.default)(props.validate)&&!props.validate(item)&&_this11.deleteHandler(item);_this11.setState({datas:datas,spinning:false});props.onDatasChange&&props.onDatasChange(datas);},function(error){item.deleted=true;_this11.setState({datas:datas,spinning:false});props.onDatasChange&&props.onDatasChange(datas);});}else{item.deleted=true;this.setState({datas:datas});props.onDatasChange&&props.onDatasChange(datas);}delete this.treeMap[newKey];}},{key:"deleteHandler",value:function deleteHandler(item){var props=this.props;var datas=this.state.datas;props.onDelete&&props.onDelete(item);item.deleted=true;this.setState({datas:datas});props.onDatasChange&&props.onDatasChange(datas);}},{key:"getIcon",value:function getIcon(cof){if(cof.icon)return cof.icon;if(cof.type=="delete"){return"icon-coms-delete";}if(cof.type=="edit"){return"icon-coms-edit";}if(cof.type=="add"){return"icon-coms-plus";}}},{key:"getName",value:function getName(cof){if(cof.name)return cof.name;if(cof.type=="delete"){return getLabel("91","删除");}if(cof.type=="edit"){return getLabel("26473","编辑");}if(cof.type=="add"){return getLabel("611","添加");}}},{key:"renderOps",value:function renderOps(item){var _this12=this;var _props3=this.props,ops=_props3.ops,ecId=_props3.ecId,deleteText=_props3.deleteText;if(ops||item.ops){var os=item.ops||ops;return React.createElement("div",{className:"ops-wrapper inline-block"},os.map(function(o,idx){return React.createElement(_antd.Tooltip,{ecId:ecId+"_Tooltip@pgvr3f",placement:"bottom",title:_this12.getName(o)},React.createElement("i",{ecId:ecId+"_i@8ekrbe",className:_this12.getIcon(o)+" ops-icon",onClick:function onClick(e){e.preventDefault();e.stopPropagation();_this12.opsHandler(item,o);}}));}));}}},{key:"renderTitle",value:function renderTitle(item){var _this13=this;var _props4=this.props,renderNode=_props4.renderNode,renderItem=_props4.renderItem,operations=_props4.operations,onDoubleClick=_props4.onDoubleClick,ecId=_props4.ecId;var title=React.createElement("div",{className:"text-elli",style:{paddingRight:25},title:item.title||item.name},item.icon&&React.createElement("i",{className:item.icon,style:{marginRight:"5px"}}),item.displayName||item.name);if(item.displayType=="portrait"){var requestParams=void 0;try{if(item.requestParams){requestParams=JSON.parse(item.requestParams);}}catch(e){}title=React.createElement("div",{className:"text-elli",style:{height:30},key:item.id},React.createElement(_weaAvatar2.default,{ecId:ecId+"_WeaAvatar@0h4iwg",style:{width:30,height:30,borderRadius:15,padding:"1px"},userId:item.id,requestParams:requestParams}),React.createElement("span",{style:{paddingLeft:10,verticalAlign:"top"},title:item.displayName||item.name},item.displayName||item.name));}if(renderNode){title=renderNode(item);}if(renderItem){title=renderItem(item);}title=React.createElement("div",{ecId:ecId+"_div@kpc2fg","class":"wea-tree-node-wrapper text-elli",onClick:function onClick(e){if(item.isCheck)return;count++;setTimeout(function(){if(count===1){// 单击
// onSelect(item, e);
// hasChildren && onExpand(item, e);
// stopPropagation(e);
}else if(count===2){// 双击
if(item.type!=="3"){typeof onDoubleClick==="function"&&onDoubleClick(item,e);}}count=0;},300);}},title,this.renderOps(item));if(item.displayType=="add"){title=React.createElement("div",{"class":"wea-tree-node-wrapper"},React.createElement(_weaInputNormal2.default,{ecId:ecId+"_WeaInput@wei0ss",ref:"input",style:{width:150},onBlur:function onBlur(v){return _this13.addHandler(v,item);}}));}if(item.displayType=="edit"){title=React.createElement("div",{"class":"wea-tree-node-wrapper"},React.createElement(_weaInputNormal2.default,{ref:"input",ecId:ecId+"_WeaInput@wimc26",style:{width:150},value:item.name,onBlur:function onBlur(v){return _this13.editHandler(v,item);}}));}return title;}},{key:"isCheckable",value:function isCheckable(item){var props=this.props;if(props.isCheckable){return props.isCheckable(item);}return true;}},{key:"isCheckboxDisable",value:function isCheckboxDisable(item){var props=this.props;if(props.isCheckboxDisable){return props.isCheckboxDisable(item);}return!item.canClick||false;}},{key:"isRadioDisable",value:function isRadioDisable(item){var props=this.props;if(props.isRadioDisable){return props.isRadioDisable(item);}return!item.canClick||false;}},{key:"isRadioChecked",value:function isRadioChecked(item){var bool=false;var radioCheckedKey=this.state.radioCheckedKey;if(radioCheckedKey){if((0,_isString2.default)(radioCheckedKey)){bool=item.id==radioCheckedKey||item.nodeid==radioCheckedKey;}else{bool=item.id==radioCheckedKey.id||item.nodeid==radioCheckedKey.id;}}return bool;}},{key:"getExpandedKeys",value:function getExpandedKeys(){var expandedKeys=this.state.expandedKeys;var keys=[];(0,_forEach2.default)(this.treeMap,function(v,key){if(expandedKeys.indexOf(v.id)>-1){keys.push(key);}if(expandedKeys.indexOf(v.nodeid)>-1){keys.push(key);}});return(0,_uniq2.default)(keys);}},{key:"getCheckedKeys",value:function getCheckedKeys(){var checkedKeys=this.state.checkedKeys;var keys=[];(0,_forEach2.default)(this.treeMap,function(v,key){if(checkedKeys.indexOf(v.id)>-1){keys.push(key);}if(checkedKeys.indexOf(v.nodeid)>-1){keys.push(key);}});return(0,_uniq2.default)(keys);}},{key:"getSelectedKeys",value:function getSelectedKeys(){var _props5=this.props,checkable=_props5.checkable,hasRadio=_props5.hasRadio;if(checkable||hasRadio)return[];var selectedKeys=this.state.selectedKeys;var keys=[];(0,_forEach2.default)(this.treeMap,function(v,key){if(selectedKeys.indexOf(v.id)>-1){keys.push(key);}if(selectedKeys.indexOf(v.nodeid)>-1){keys.push(key);}});return(0,_uniq2.default)(keys);}},{key:"renderNode",value:function renderNode(obj,parentObj,level){var _this14=this;var props=this.props;if(obj.deleted)return;obj.nodeid=obj.nodeid||obj.domid;if(props.rowKey){obj.nodeid=obj[props.rowKey];}if(props.renderNodeId)obj.nodeid=props.renderNodeId(obj);obj.id=obj.id||obj.key;// 生成随机值key
obj.treeKey=(obj.nodeid||obj.id)+"__"+(0,_random2.default)(1000);//判断节点层级
if(parentObj){obj.parentTreeKey=parentObj.treeKey;obj.treeKey=obj.parentTreeKey+"-"+obj.treeKey;}else{obj.isRoot=true;}if(!this.treeMap[obj.treeKey]&&obj.displayType!=="add"){this.treeMap[obj.treeKey]=obj;}if(!(0,_isEmpty2.default)(obj.childs)){obj.children=obj.childs;}if(!(0,_isEmpty2.default)(obj.subs)){obj.children=obj.subs;}if((obj.isParent||obj.haschild)&&!(0,_isEmpty2.default)(obj.children)){obj.isLoad=true;}var isLeaf=true;if(obj.isParent||obj.haschild)isLeaf=false;return React.createElement(TreeNode,(0,_extends3.default)({},obj,{level:level,browserTree:true,title:this.renderTitle(obj),key:obj.treeKey,isLeaf:isLeaf,checkable:this.isCheckable(obj),disableCheckbox:this.isCheckboxDisable(obj),disableRadio:this.isRadioDisable(obj),radioChecked:this.isRadioChecked(obj),data:obj,ecId:props.ecId+"_TreeNode@zg54nd"}),obj.children&&obj.children.map(function(chObj){return _this14.renderNode(chObj,obj,level+1);}).filter(function(v){return!!v;}));}},{key:"onAccountBtnClick",value:function onAccountBtnClick(){var _this15=this;var _state4=state,isAccount=_state4.isAccount;this.setState({isAccount:!isAccount},function(){_this15.props.onAccountBtnClick&&_this15.onAccountBtnClick(_this15.state.isAccount);});}},{key:"render",value:function render(){var _this16=this;var state=this.state,props=this.props;var checkStrictly=state.checkStrictly,isAccount=state.isAccount;this.treeMap={};var treeNodes=state.datas&&state.datas.map(function(obj){return _this16.renderNode(obj,null,0);}).filter(function(v){return!!v;});return React.createElement(_antd.Spin,{ecId:props.ecId+"_Spin@i37tzj",spinning:state.spinning},props.showCheckStrictly&&React.createElement(_antd.Button,{ecId:props.ecId+"_Button@qtpn7f",size:"small",className:"wea-tree-strictlybtn",onClick:function onClick(){props.onCheckStrictlyChange&&props.onCheckStrictlyChange(!checkStrictly);_this16.setState({checkStrictly:!checkStrictly},function(){if(!_this16.state.checkStrictly){var _checkedKeys=_this16.refs.weaTree.refs.rcTree.checkedKeys;if(Array.isArray(_checkedKeys)){_checkedKeys=_checkedKeys.slice();_this16.onCheck(_checkedKeys);}}});},title:props.checkStrictlyTitle||getLabel("128725","包含下级")},React.createElement("span",null,!checkStrictly?React.createElement("i",{className:"icon-coms-DisplaySubordinates",style:{color:"#2db7f5"}}):React.createElement("i",{className:"icon-coms-NoDisplayOfSubordinates"}))),props.showIsAccount&&React.createElement(_antd.Button,{ecId:props.ecId+"_Button@dkb29n",size:"small",onClick:this.onAccountBtnClick.bind(this),title:isAccount?getLabel(385568,"隐藏无账号人员"):getLabel(31504,"显示无账号人员")},React.createElement("span",null,isAccount?React.createElement("i",{className:"icon-coms-ShowNoAccount",style:{color:"#2db7f5"}}):React.createElement("i",{className:"icon-coms-NoAccountNoDisplay"}))),React.createElement(_antd.Tree,(0,_extends3.default)({},props,{ecId:props.ecId+"_Tree@8c59ph",ref:"weaTree",className:(props.className||"")+" wea-tree",needExpandChildren:true,clickNodeExpandChildren:!props.hasRadio&&!props.checkable,multiple:props.checkable,checkable:props.checkable,checkStrictly:checkStrictly,expandedKeys:this.getExpandedKeys()//展开受控
,checkedKeys:this.getCheckedKeys()//选中受控
,selectedKeys:this.getSelectedKeys()//点击受控
,onExpand:this.onExpand,onSelect:this.onSelect,onCheck:this.onCheck,onRadioCheck:this.onRadioCheck// onDoubleClick={this.onDoubleClick}
,onDrop:this.onDrop,loadData:props.loadAll?null:this.loadData}),treeNodes));}}]);return WeaTree;}(React.Component),_class.defaultProps={checkable:false,// 显示checkbox多选
hasRadio:false,// radio 单选
loadAll:false,// 默认异步加载
showCheckStrictly:false,// 父子节点关联btn 默认隐藏
noCache:false,// 每次展开节点是否接口
addToLast:false//添加在最后一个节点
},_temp);var Com=(0,_middleware2.default)(WeaTree,"WeaTree");exports.default=Com;

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(58);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(109)('meta');
var isObject = __webpack_require__(53);
var has = __webpack_require__(61);
var setDesc = __webpack_require__(49).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(69)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(494), __esModule: true };

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaProgress=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 953));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaProgress;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(57);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _sortablejs=__webpack_require__(271);var _sortablejs2=_interopRequireDefault(_sortablejs);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _reorder=__webpack_require__(677);var _reorder2=_interopRequireDefault(_reorder);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaSortable=function(_React$Component){(0,_inherits3.default)(WeaSortable,_React$Component);function WeaSortable(props){(0,_classCallCheck3.default)(this,WeaSortable);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaSortable.__proto__||(0,_getPrototypeOf2.default)(WeaSortable)).call(this,props));_this.initSortable=function(){var _this$props=_this.props,container=_this$props.container,draggableType=_this$props.draggableType,draggableIconContainer=_this$props.draggableIconContainer;if(typeof container=="string"){container=jQuery(container,ReactDOM.findDOMNode(_this))[0];}else if((0,_isFunction2.default)(container)){container=container();}if(!container){_this.sortableTimeout=setTimeout(function(){if(!_this.sortableEl)_this.initSortable();},500);return;}if(_this.sortableTimeout){clearTimeout(_this.sortableTimeout);}var sortableOptions={animation:150,ghostClass:"blue-background-class",onEnd:_this.onEnd};if(draggableType!=="row")sortableOptions=(0,_extends3.default)({},sortableOptions,{handle:draggableIconContainer});_this.sortableEl=new _sortablejs2.default(container,sortableOptions);};_this.onEnd=function(target){var _this$props2=_this.props,datas=_this$props2.datas,onDrop=_this$props2.onDrop;if(Array.isArray(datas)&&(0,_isFunction2.default)(onDrop)){var oldIndex=target.oldIndex,newIndex=target.newIndex;var moveItem=datas[oldIndex];var newDatas=(0,_reorder2.default)(datas,oldIndex,newIndex);onDrop(newDatas,oldIndex,newIndex,moveItem);}};_this.sortableEl=null;return _this;}(0,_createClass3.default)(WeaSortable,[{key:"componentDidMount",value:function componentDidMount(){if(!this.sortableEl)this.initSortable();}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var draggableType=nextProps.draggableType,datas=nextProps.datas;var _props=this.props,_dtype=_props.draggableType,_d=_props.datas;if(draggableType!==_dtype&&this.sortableEl){var newHandle=draggableType==="row"?"":".wea-table-move";this.sortableEl.option("handle",newHandle);}}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(!this.sortableEl)this.initSortable();}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.sortableEl&&this.sortableEl.destroy();}},{key:"render",value:function render(){return this.props.children;}}]);return WeaSortable;}(React.Component);WeaSortable.propTypes={container:React.PropTypes.any,//可拖拽区域
draggableIconContainer:React.PropTypes.any,//图标拖拽区域
onDrop:React.PropTypes.func,//拖拽结束时触发的方法，第1个参数是拖拽的DOM节点，第二个参数是所放下的位置下方的DOM节点。
draggableType:React.PropTypes.String,//拖拽类型
datas:React.PropTypes.array,//数组
children:React.PropTypes.any//包裹区域
};var Com=(0,_middleware2.default)(WeaSortable,"WeaNewDragula");exports.default=Com;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _Encry=__webpack_require__(51);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var text=function text(item,field){var text="";if(item[field]!==undefined){text=item[field];}if(item[field+"span"]!==undefined){text=item[field+"span"];}return text;};var timeout=null;var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this2=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this2.state={};return _this2;}(0,_createClass3.default)(main,[{key:"render",value:function render(){var _this3=this;var _props=this.props,datas=_props.datas,inputId=_props.inputId,inputTop=_props.inputTop,inputBottom=_props.inputBottom;this.dataObj={};var list=[];if(inputId){list=datas.map(function(item,index){item.id=item[inputId];//我的请求
_this3.dataObj[item.id]=item;var top=[];var bottom=[];inputTop&&inputTop.forEach(function(field){var value=text(item,field);if((0,_Encry.desensitization)(value)||(0,_Encry.encryption)(value)){top.push(React.createElement(_Encry.Encry,{style:{marginRight:"5px"},value:value}));}else{top.push(React.createElement("span",{style:{marginRight:"5px"},dangerouslySetInnerHTML:{__html:value}}));}});inputBottom&&inputBottom.forEach(function(field){var value=text(item,field);if((0,_Encry.desensitization)(value)||(0,_Encry.encryption)(value)){bottom.push(React.createElement(_Encry.Encry,{style:{marginRight:"5px"},value:value}));}else{bottom.push(React.createElement("span",{style:{marginRight:"5px"},dangerouslySetInnerHTML:{__html:text(item,field)}}));}});return React.createElement("li",{ecId:_this3.props.ecId+"_li@w81j8b@"+index,className:_this3.cls(item),onDoubleClick:_this3.onDoubleClick.bind(_this3,item),onClick:_this3.onClick.bind(_this3,item)},React.createElement("div",{className:"item-wrap wea-f12"},React.createElement("div",{className:"item-top"},top),React.createElement("div",{className:"item-bottom"},bottom)),React.createElement("div",{className:"icon-wrap"}),React.createElement("i",{className:"icon-coms-Selected"}));});}return React.createElement("div",{className:"wea-crm-list"},React.createElement("ul",{className:"wea-crm-list-wrapper"},list),list.length==0&&React.createElement("div",{className:"empty-tip",style:{color:"#999",paddingTop:30,textAlign:"center"}},getLabel(83320,"没有可显示的数据")));}},{key:"cls",value:function cls(item){var _props2=this.props,selectedKeys=_props2.selectedKeys,filterData=_props2.filterData,inputId=_props2.inputId;var cls=[];if(selectedKeys&&selectedKeys.indexOf(item.id)>-1){cls.push("selected");}if(filterData&&filterData.filter(function(d){return d[inputId]===item.id;}).length>0){cls.push("hide");}return cls.join(" ");}},{key:"onClick",value:function onClick(data){var _this4=this;if(data.isDevModule){var selectedKeys=this.props.selectedKeys;var keys=selectedKeys?[].concat((0,_toConsumableArray3.default)(selectedKeys)):[];var datas=[];keys.forEach(function(k){_this4.dataObj[k]&&datas.push(_this4.dataObj[k]);});this.props.onClick&&this.props.onClick(keys,datas,data);return;}var _this=this;// 取消上次延时未执行的方法
clearTimeout(timeout);//执行延时
timeout=setTimeout(function(){var selectedKeys=_this.props.selectedKeys;var keys=selectedKeys?[].concat((0,_toConsumableArray3.default)(selectedKeys)):[];var datas=[];if(keys.indexOf(data.id)>-1){keys=keys.filter(function(k){return k!==data.id;});}else{keys.push(data.id);}keys.forEach(function(k){_this.dataObj[k]&&datas.push(_this.dataObj[k]);});_this.props.onClick&&_this.props.onClick(keys,datas,data);},200);}},{key:"onDoubleClick",value:function onDoubleClick(data){if(data.isDevModule){return;}clearTimeout(timeout);this.props.onDoubleClick&&this.props.onDoubleClick([data]);}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.menuSelect=function(e){if(typeof _this.props.onSelect==="function"){_this.props.onSelect(e);_this.setState({value:e.key});}};_this.instanceIsMounted=false;_this.state={value:props.value||""};return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){this.instanceIsMounted=true;}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.value!==nextProps.value&&nextProps.value){this.setState({value:nextProps.value});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.instanceIsMounted=false;}},{key:"render",value:function render(){var _props=this.props,_props$dropMenu=_props.dropMenu,dropMenu=_props$dropMenu===undefined?[]:_props$dropMenu,defaultMenu=_props.defaultMenu,_props$adaptWidth=_props.adaptWidth,adaptWidth=_props$adaptWidth===undefined?false:_props$adaptWidth,_props$className=_props.className,className=_props$className===undefined?"":_props$className,outStyle=_props.outStyle;var value=this.state.value;var showName="";var menuItem=[];dropMenu.forEach(function(item){var width=$(".wea-drop-menu").width();var style=adaptWidth&&width?{width:width-7}:{};menuItem.push(_react2.default.createElement(_antd.Menu.Item,{key:item.companyid,title:item.name,style:style},item.name));menuItem.push(_react2.default.createElement(_antd.Menu.Divider,null));if(item.companyid===value){showName=item.name;}});var typeMenu=_react2.default.createElement(_antd.Menu,{className:"wea-browser-drop-menu max-height-large",onSelect:this.menuSelect,selectedKeys:[value]},menuItem);return _react2.default.createElement("div",{className:"wea-drop-menu "+className,style:(0,_extends3.default)({width:"100%"},outStyle)},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:24},_react2.default.createElement(_antd.Dropdown,{overlay:typeMenu,trigger:["click"]},_react2.default.createElement("a",{className:"ant-dropdown-link text-elli pr25"},_react2.default.createElement("i",{className:"icon-toolbar-Organization-list"}),_react2.default.createElement("span",{title:showName||defaultMenu||""},showName||defaultMenu||null," "),_react2.default.createElement(_antd.Icon,{type:"down",className:"icon-down"}))))));}}]);return Main;}(_react2.default.Component);var Com=(0,_middleware2.default)(Main,"WeaDropMenu");exports.default=Com;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});// props
var defaultProps=exports.defaultProps={value:"",ckConfig:{},// ck 配置
extentsConfig:[],// 扩展配置
viewAttr:2,// 编辑权限
readOnly:false,// 是否自读
className:"",style:{},readOnlyInSourceMode:false,// 源码模式是否只读
ls:false,// 模块需要的特殊处理
bottomBarConfig:[],// 底部工具栏
bottomBarRight:{},// 底部右侧按钮
bootomBarStyle:{},// 底部右侧按钮样式
getDataWidthDefaultFont:true,// 获取值的时候，是否拼接上有默认字体和默认字体大小的div
dropToUploadImg:true,dropToUploadFile:false,dropUploadImgUrl:(window.ecologyContentPath||"")+"/api/doc/upload/uploadFile",// 拖拽上传附件地址,默认和通用上传地址一致（流程需要区分）
dropUploadFileUrl:(window.ecologyContentPath||"")+"/api/doc/upload/uploadFile",// 拖拽上传附件地址,默认和通用上传地址一致（流程需要区分）
dropUploadImgParams:{},dropUploadFileParams:{}};// state
var defaultState=exports.defaultState={loading:false,// load ck loading
status:false,mode:"wysiwyg",// wysiwyg:正常编辑模式, source:markdown源码模式
maximize:false,// 最大化
nomalHeight:0,// 富文本高度
modalTrans:"inhreit",loadExtends:false,// 是否开始加载扩展属性
required:false// 是否显示必填
};// ckConfig
var defultCkConfig=exports.defultCkConfig={renderAsCk:true,toolbarStartupExpanded:true,toolbarCanCollapse:false,allowedContent:true,// startupFocus: true, // 默认输入框获得焦点
tabSpaces:4,pasteFilter:null,// 复制其他地方的内容不过滤
enterMode:1,contentsCss:(window.ecologyContentPath||"")+"/cloudstore/resource/pc/ckeditor-4.6.2/weaver/contents.css",// 默认解析css
fontSize_sizes:"8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;48/48px;72/72px",font_en:"Arial/Arial; Comic Sans MS/Comic Sans MS; Courier New/Courier New; Georgia/Georgia; Lucida Sans Unicode/Lucida Sans Unicode; Tahoma/Tahoma; Times New Roman/Times New Roman; Trebuchet MS/Trebuchet MS; Verdana/Verdana;",font_zh:"宋体/SimSun;新宋体/NSimSun;仿宋/FangSong;楷体/KaiTi;仿宋_GB2312/FangSong_GB2312;方正小标宋简体/FZXiaoBiaoSong-B05S;楷体_GB2312/KaiTi_GB2312;黑体/SimHei;华文细黑/STXihei;华文楷体/STKaiti;华文宋体/STSong;华文中宋/STZhongsong;华文仿宋/STFangsong;华文彩云/STCaiyun;华文琥珀/STHupo;华文隶书/STLiti;华文行楷/STXingkai;华文新魏/STXinwei;方正舒体/FZShuTi;方正姚体/FZYaoti;细明体/MingLiU;新细明体/PMingLiU;微软雅黑/Microsoft YaHei;微软正黑/Microsoft JhengHei;",uploadUrl:(window.ecologyContentPath||"")+"/api/doc/upload/uploadFile"// 通用上传地址（工具栏上传）
};// atwho config
var defaultAtwhoConfig=exports.defaultAtwhoConfig={// insert_tpl : ecologyContentPath 需要结合atwho特殊处理
at:"@",tpl:"<li data-uid='${id}' data-value='@${name}'>${name}</li>",insert_tpl:"<a href='${ecologyContentPath}/hrm/HrmTab.jsp?_fromURL=HrmResource&id=${id}' atsome='@${id}' atsome-uid='${id}' atsome-name='${name}' atsome-py='${py}' contenteditable='false' style='cursor:pointer;text-decoration:none !important;margin-right:8px;color:#2777c1!important;' target='_blank' onclick='if(window.openLink){window.openLink.openHrm(${id});return false;}'>${atwho-data-value}</a>&nbsp;",show_the_at:true,start_with_space:false,with_repeat_matcher:false,search_key_py:"py",pageIndex:1,pageSize:20,apiRequest:true};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTableEdit=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(4/* limit */).then(__webpack_require__.bind(null, 981));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaTableEdit;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(49);
var anObject = __webpack_require__(44);
var getKeys = __webpack_require__(91);

module.exports = __webpack_require__(48) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var core = __webpack_require__(20);
var dP = __webpack_require__(49);
var DESCRIPTORS = __webpack_require__(48);
var SPECIES = __webpack_require__(30)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(198);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _format=__webpack_require__(406);var format=_interopRequireWildcard(_format);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}var tools={tryCatch:function tryCatch(React,ErrorHandler,handlerOptions){if(!React||!React.Component){throw new Error("arguments[0] for react-try-catch-render does not look like React.");}if(typeof ErrorHandler!=="function"){throw new Error("arguments[1] for react-try-catch-render does not look like a function.");}/**
     * Implementation of the try/catch wrapper
     * @param  {[React.Component]} component The ES6 React.Component
     */return function wrapWithTryCatch(Component){var originalRender=Component.prototype.render;Component.prototype.render=function tryRender(){try{return originalRender.apply(this,arguments);}catch(err){// Log an error
window.console&&console.error("errorLog:",err);if(ErrorHandler&&ErrorHandler.prototype&&ErrorHandler.prototype.render){return React.createElement(ErrorHandler,handlerOptions);}// ErrorHandler is at least a valid function
return ErrorHandler(err);}};return Component;};},formatDate:format.formatToDate,formatTime:format.formatToTime,getTextWidth:function getTextWidth(str){var width=0;if(str){for(var i=0;i<str.length;i++){//如果是汉字
if(str.charCodeAt(i)>255){width+=14;}else{width+=7;}}}return width;},isWeekendDay:function isWeekendDay(str){var bool=false;if(str){var dt=new Date(str);// 修复大于 +8时区的周末显示异常
// let time = dt.getTime();
// dt = new Date(time + new Date(time).getTimezoneOffset() * 60 * 1000 + 8 * 60 * 60 * 1000)
if(dt.getDay()==0||dt.getDay()==6){bool=true;}}return bool;},isBelowIE9:function isBelowIE9(){return navigator.appName=="Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g,"").replace("MSIE",""))<=9;},camelCase:function camelCase(name){return name.charAt(0).toUpperCase()+name.slice(1).replace(/-(\w)/g,function(m,n){return n.toUpperCase();});}};exports.default=tools;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(29);
var has = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(48);
var $export = __webpack_require__(39);
var redefine = __webpack_require__(220);
var META = __webpack_require__(323).KEY;
var $fails = __webpack_require__(69);
var shared = __webpack_require__(160);
var setToStringTag = __webpack_require__(106);
var uid = __webpack_require__(109);
var wks = __webpack_require__(30);
var wksExt = __webpack_require__(166);
var wksDefine = __webpack_require__(167);
var enumKeys = __webpack_require__(430);
var isArray = __webpack_require__(339);
var anObject = __webpack_require__(44);
var isObject = __webpack_require__(53);
var toObject = __webpack_require__(70);
var toIObject = __webpack_require__(59);
var toPrimitive = __webpack_require__(158);
var createDesc = __webpack_require__(90);
var _create = __webpack_require__(143);
var gOPNExt = __webpack_require__(431);
var $GOPD = __webpack_require__(148);
var $GOPS = __webpack_require__(147);
var $DP = __webpack_require__(49);
var $keys = __webpack_require__(91);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(209).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(111).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(89)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(58)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(92);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(487), __esModule: true };

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(49);
var createDesc = __webpack_require__(90);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(118),
    isArrayLike = __webpack_require__(71),
    isIndex = __webpack_require__(179),
    isObject = __webpack_require__(40);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(499),
    createBaseEach = __webpack_require__(502);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getIconBGC=exports.createReactEle=exports.createDialog=exports.getDialog=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _IconBGCMap;var _weaDialog=__webpack_require__(55);var _weaDialog2=_interopRequireDefault(_weaDialog);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _loadCss=__webpack_require__(83);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getDialog=exports.getDialog=function getDialog(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";if(window[id]){return window[id];}if(parent[id]){return parent[id];}};function getUrlParam(name){var reg=new RegExp("(^|&|\\?)"+name+"=([^&]*)(&|$)");//构造一个含有目标参数的正则表达式对象
var url=self.frameElement?self.frameElement.getAttribute("src"):"";var r=url.match(reg);//匹配目标参数
if(r!=null)return unescape(r[2]);return null;//返回参数值
}_window2.default.getTop().getParentDialog=function(){var id=getUrlParam("dialogId");if(id&&_window2.default.getTop().dialogMapper&&_window2.default.getTop().dialogMapper[id]){return _window2.default.getTop().dialogMapper[id];}};var createDialog=exports.createDialog=function createDialog(params,children,callback){var id="cd"+new Date().getTime();var node=document.createElement("div");node.setAttribute("id",id);_window2.default.getTop().document.body.appendChild(node);(0,_loadCss.loadCss)();return createReactEle(id,_weaDialog2.default,params,children,callback);};var createReactEle=exports.createReactEle=function createReactEle(domEle,name){var params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var children=arguments[3];var callback=arguments[4];if(typeof domEle==="string"){domEle=_window2.default.getTop().document.getElementById(domEle);}var thatCom=null;var TheCom=function(_React$Component){(0,_inherits3.default)(TheCom,_React$Component);function TheCom(){(0,_classCallCheck3.default)(this,TheCom);return(0,_possibleConstructorReturn3.default)(this,(TheCom.__proto__||(0,_getPrototypeOf2.default)(TheCom)).apply(this,arguments));}(0,_createClass3.default)(TheCom,[{key:"render",value:function render(){params.ref=function(r){return thatCom=r;};return React.createElement(name,params,children);}}]);return TheCom;}(React.Component);ReactDOM.render(React.createElement(TheCom,null),domEle,function(){(0,_isFunction2.default)(callback)&&callback(thatCom);});return thatCom;};var IconBGCMap=(_IconBGCMap={home:{//门户
icon:"icon-coms-home",iconBgcolor:"#1a57a0"},cowork:{//协做
icon:"icon-coms-cowork",iconBgcolor:"#a0b0ba"},workflow:{//流程
icon:"icon-coms-workflow",iconBgcolor:"#0079de"},meeting:{//会议
icon:"icon-coms-meeting",iconBgcolor:"#f14a2d"},blog:{//微博
icon:"icon-coms-blog",iconBgcolor:"#6d3cf7"},crm:{//客户
icon:"icon-coms-crm",iconBgcolor:"#96358a"},photo:{//相册
icon:"icon-coms-photo",iconBgcolor:"#0079de"},hrm:{// 人事
icon:"icon-coms-hrm",iconBgcolor:"#217346"},investigate:{//调查
icon:"icon-coms-investigate",iconBgcolor:"#6d3cf7"},fa:{//资产
icon:"icon-coms-fa",iconBgcolor:"#f14a2d"},doc:{//知产
icon:"icon-coms-doc",iconBgcolor:"#f14a2d"},project:{//项目
icon:"icon-coms-project",iconBgcolor:"#217346"},email:{//邮件
icon:"icon-coms-email",iconBgcolor:"#a0b0ba"}},(0,_defineProperty3.default)(_IconBGCMap,"project",{//项目
icon:"icon-coms-project",iconBgcolor:"#217346"}),(0,_defineProperty3.default)(_IconBGCMap,"implement",{//执行力平台
icon:"icon-coms-implement",iconBgcolor:"#96358a"}),(0,_defineProperty3.default)(_IconBGCMap,"integration",{//集成
icon:"icon-coms-integration",iconBgcolor:"#1a57a0"}),(0,_defineProperty3.default)(_IconBGCMap,"official",{//公文
icon:"icon-coms-official",iconBgcolor:"#f14a2d"}),(0,_defineProperty3.default)(_IconBGCMap,"schedule",{//日程
icon:"icon-coms-schedule",iconBgcolor:"#6d3cf7"}),(0,_defineProperty3.default)(_IconBGCMap,"message",{//通信
icon:"icon-coms-message",iconBgcolor:"#0079de"}),(0,_defineProperty3.default)(_IconBGCMap,"car",{//车辆
icon:"icon-coms-car",iconBgcolor:"#1a57a0"}),(0,_defineProperty3.default)(_IconBGCMap,"ws",{//微搜
icon:"icon-coms-ws",iconBgcolor:"#a0b0ba"}),(0,_defineProperty3.default)(_IconBGCMap,"modelingengine",{//表单建模
icon:"icon-coms-ModelingEngine",iconBgcolor:"#96358a"}),(0,_defineProperty3.default)(_IconBGCMap,"mobileengine",{//移动建模
icon:"icon-coms-MobileEngine",iconBgcolor:"#96358a"}),(0,_defineProperty3.default)(_IconBGCMap,"finance",{//财务
icon:"icon-coms-Finance",iconBgcolor:"#f14a2d"}),(0,_defineProperty3.default)(_IconBGCMap,"content",{//通用
icon:"icon-coms-content",iconBgcolor:"#6d3cf7"}),(0,_defineProperty3.default)(_IconBGCMap,"idphoto",{//证照
icon:"icon-coms-ID-Photo",iconBgcolor:"#0079de"}),(0,_defineProperty3.default)(_IconBGCMap,"synergism",{//协同区
icon:"icon-coms-synergism",iconBgcolor:"#1a57a0"}),(0,_defineProperty3.default)(_IconBGCMap,"collection",{//收藏夹
icon:"icon-coms-Collection",iconBgcolor:"#a0b0ba"}),(0,_defineProperty3.default)(_IconBGCMap,"tasks",{//计划任务
icon:"icon-coms-Planning-tasks",iconBgcolor:"#96358a"}),(0,_defineProperty3.default)(_IconBGCMap,"emessage",{//e-message
icon:"icon-coms-e-message",iconBgcolor:"#0079de"}),(0,_defineProperty3.default)(_IconBGCMap,"littlee",{//小e助手
icon:"icon-coms-little-e",iconBgcolor:"#1a57a0"}),(0,_defineProperty3.default)(_IconBGCMap,"lcontract",{//合同
icon:"icon-coms-lcontract",iconBgcolor:"#217346"}),(0,_defineProperty3.default)(_IconBGCMap,"currency",{//系统设置
icon:"icon-coms-currency",iconBgcolor:"#217346"}),_IconBGCMap);var getIconBGC=exports.getIconBGC=function getIconBGC(moduleName){var res={};if((0,_isString2.default)(moduleName)){res=IconBGCMap[moduleName]||{};}return(0,_extends3.default)({},res);};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function isEqual(_a,_b){var result,aType,bType,aKeys,bKeys,i;try{aType=typeof _a==="undefined"?"undefined":(0,_typeof3.default)(_a);bType=typeof _b==="undefined"?"undefined":(0,_typeof3.default)(_b);if(aType!==bType){result=false;}else if(aType==="number"){// https://github.com/jashkenas/underscore/blob/master/underscore.js#L1187
if(+_a!==+_a){// `NaN`s are equivalent, but non-reflexive.
// Object(NaN) is equivalent to NaN.
result=+_b!==+_b;}else{// An `egal` comparison is performed for other numeric values.
result=+_a===0?1/+_a===1/_b:+_a===+_b;}}else if(aType==="string"){// https://github.com/jashkenas/underscore/blob/master/underscore.js#L1183
// Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
// equivalent to `new String("5")`.
result=''+_a===''+_b;}else if(aType==="boolean"||aType==="object"&&_a instanceof Date&&_b instanceof Date){// https://github.com/jashkenas/underscore/blob/master/underscore.js#L1194
// Coerce dates and booleans to numeric primitive values. Dates are compared by their
// millisecond representations. Note that invalid dates with millisecond representations
// of `NaN` are not equivalent.
result=+_a===+_b;}else if(aType==="object"&&_a instanceof Array&&_b instanceof Array){// The first difference we can find between two arrays is its length,
// otherwise iterate comparing each element.
if(_a.length!==_b.length){result=false;}else{result=true;for(i=0;i<_a.length;i++){result=isEqual(_a[i],_b[i]);if(!result){break;}}}}else if(aType==="object"&&_a instanceof Object&&_b instanceof Object){// The first difference we can find between two objects is the number of properties,
// otherwise iterate comparing each element.
aKeys=(0,_keys2.default)(_a);bKeys=(0,_keys2.default)(_b);if(aKeys.length!==bKeys.length){result=false;}else{result=true;for(i=0;i<aKeys.length;i++){result=isEqual(_a[aKeys[i]],_b[aKeys[i]]);if(!result){break;}}}}else if(aType==="object"&&_a===null&&_b===null||aType==="function"||aType==="undefined"){// The undefined values and the null values are equivalent
// and the functions does not interest us compare now.
result=true;}else{// When a and b do not fit with any of the alternatives, it returns false.
// This will help us identify in the future if we have to include new alterntivas.
result=false;}}catch(_ex){console.error(_ex.message);result=null;}finally{return result;}};module.exports=isEqual;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(537),
    baseUnary = __webpack_require__(94),
    nodeUtil = __webpack_require__(115);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _rcNotification=__webpack_require__(538);var _rcNotification2=_interopRequireDefault(_rcNotification);var _icon=__webpack_require__(551);var _icon2=_interopRequireDefault(_icon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultDuration=2;var defaultTop=void 0;var messageInstance=void 0;var key=1;var prefixCls="ant-message";function noop(){}function isObject(obj){return Object.prototype.toString.call(obj)==="[object Object]";}function isFunction(fn){return typeof fn==="function";}function getMessageInstance(callback){if(messageInstance){callback(messageInstance);return;}_rcNotification2.default.newInstance({prefixCls:prefixCls,transitionName:"move-up",style:{top:defaultTop// 覆盖原来的样式
}},function(instance){if(messageInstance){callback(messageInstance);return;}messageInstance=instance;callback(instance);});}function getEcodeConfigProps(){var newProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var name="message.config";if(isObject(window.pcComponentsConfig)&&window.pcComponentsConfig[name]){var overwrite=window.pcComponentsConfig[name];if(isObject(overwrite)){var propsFn=overwrite.overwritePropsFn;if(isFunction(propsFn)){var overwriteProps=propsFn(newProps,name);if(isObject(overwriteProps)){newProps=(0,_extends3.default)({},newProps,overwriteProps);}}}}return newProps;}function getEcodeProps(){var newProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var name="message";if(isObject(window.pcComponentsConfig)&&window.pcComponentsConfig[name]){var overwrite=window.pcComponentsConfig[name];if(isObject(overwrite)){var propsFn=overwrite.overwritePropsFn;if(isFunction(propsFn)){var overwriteProps=propsFn(newProps,name);if(isObject(overwriteProps)){newProps=(0,_extends3.default)({},newProps,overwriteProps);}}}}return newProps;}function notice(content){var duration=arguments.length>1&&arguments[1]!==undefined?arguments[1]:defaultDuration;var type=arguments[2];var onClose=arguments[3];if(!content)return;onClose=onClose||noop;var iconType={info:"info-circle",success:"check-circle",error:"cross-circle",warning:"exclamation-circle",loading:"loading"}[type];var target=key++;var props=getEcodeProps({duration:duration,content:content,onClose:onClose,type:type,iconType:iconType});getMessageInstance(function(instance){instance.notice((0,_extends3.default)({},props,{key:target,style:{},content:_react2.default.createElement("div",{className:prefixCls+"-custom-content "+prefixCls+"-"+props.type},_react2.default.createElement(_icon2.default,{type:props.iconType}),_react2.default.createElement("span",null,props.content),_react2.default.createElement("div",{className:prefixCls+"-custom-close",onClick:function onClick(){if(messageInstance){messageInstance.removeNotice(target);}}},_react2.default.createElement(_icon2.default,{type:"cross-circle"})))}));});return function(){if(messageInstance){messageInstance.removeNotice(target);}};}exports.default={info:function info(content,duration,onClose){return notice(content,duration,"info",onClose);},success:function success(content,duration,onClose){return notice(content,duration,"success",onClose);},error:function error(content,duration,onClose){return notice(content,duration,"error",onClose);},// Departed usage, please use warning()
warn:function warn(content,duration,onClose){return notice(content,duration,"warning",onClose);},warning:function warning(content,duration,onClose){return notice(content,duration,"warning",onClose);},loading:function loading(content,duration,onClose){return notice(content,duration,"loading",onClose);},config:function config(options){if("top"in options){defaultTop=options.top;}if("duration"in options){defaultDuration=options.duration;}if("prefixCls"in options){prefixCls=options.prefixCls;}var configOptions=getEcodeConfigProps(options);if("top"in configOptions){defaultTop=configOptions.top;}if("duration"in configOptions){defaultDuration=configOptions.duration;}},destroy:function destroy(){if(messageInstance){messageInstance.destroy();messageInstance=null;}}};

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(259);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(172),
    arrayEach = __webpack_require__(253),
    assignValue = __webpack_require__(260),
    baseAssign = __webpack_require__(554),
    baseAssignIn = __webpack_require__(555),
    cloneBuffer = __webpack_require__(558),
    copyArray = __webpack_require__(559),
    copySymbols = __webpack_require__(560),
    copySymbolsIn = __webpack_require__(561),
    getAllKeys = __webpack_require__(241),
    getAllKeysIn = __webpack_require__(562),
    getTag = __webpack_require__(93),
    initCloneArray = __webpack_require__(563),
    initCloneByTag = __webpack_require__(564),
    initCloneObject = __webpack_require__(569),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(114),
    isMap = __webpack_require__(571),
    isObject = __webpack_require__(40),
    isSet = __webpack_require__(573),
    keys = __webpack_require__(85),
    keysIn = __webpack_require__(183);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(243),
    baseRest = __webpack_require__(576),
    baseXor = __webpack_require__(583),
    isArrayLikeObject = __webpack_require__(589);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(269);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sortable = __webpack_require__(603).default;

module.exports = Sortable;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(608),
    baseToString = __webpack_require__(164),
    toInteger = __webpack_require__(203),
    toString = __webpack_require__(57);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null
    ? 0
    : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _Layout=__webpack_require__(611);var _Layout2=_interopRequireDefault(_Layout);var _LayoutCol=__webpack_require__(612);var _LayoutCol2=_interopRequireDefault(_LayoutCol);var _LayoutResize=__webpack_require__(613);var _LayoutResize2=_interopRequireDefault(_LayoutResize);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaLeftRightLayout=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaLeftRightLayout,_React$Component);function WeaLeftRightLayout(props){(0,_classCallCheck3.default)(this,WeaLeftRightLayout);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaLeftRightLayout.__proto__||(0,_getPrototypeOf2.default)(WeaLeftRightLayout)).call(this,props));_this.state={showLeft:props.showLeft===undefined?true:props.showLeft,showMid:props.showMid===undefined?true:props.showMid};return _this;}(0,_createClass3.default)(WeaLeftRightLayout,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextPorps){var _state=this.state,l=_state.showLeft,m=_state.showMid;var showLeft=nextPorps.showLeft,showMid=nextPorps.showMid;var newState={};if(showLeft!==undefined&&l!==showLeft){newState.showLeft=showLeft;}if(showMid!==undefined&&m!==showMid){newState.showMid=showMid;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:"onCollapse",value:function onCollapse(side,bool){var _props=this.props,onCollapse=_props.onCollapse,col=_props.col;this.setState(side==="left"?{showLeft:bool}:{showMid:bool});var arr=[bool];if(col===3)arr.unshift(side);typeof onCollapse==="function"&&onCollapse.apply(undefined,arr);}},{key:"render",value:function render(){var _this2=this;var _props2=this.props,col=_props2.col,children=_props2.children,leftWidth=_props2.leftWidth,midWidth=_props2.midWidth,showTitleL=_props2.showTitleL,showTitleM=_props2.showTitleM,titleLeft=_props2.titleLeft,titleMiddle=_props2.titleMiddle,resize=_props2.resize,ecId=_props2.ecId;var titleleft=showTitleL?{title:titleLeft}:{};var titlemiddle=showTitleM?{title:titleMiddle}:{};if(col===2){return typeof leftWidth==="number"&&!resize?_react2.default.createElement(_Layout2.default,(0,_extends3.default)({},this.props,{ecId:ecId+"_Layout@a9564k",btnTitle:titleleft})):typeof leftWidth==="number"?_react2.default.createElement(_LayoutResize2.default,(0,_extends3.default)({},this.props,{ecId:ecId+"_LayoutResize@s1vs4r"})):_react2.default.createElement(_LayoutCol2.default,(0,_extends3.default)({},this.props,{ecId:ecId+"_LayoutCol@2dt41a"}));}if(col===3){var _props3=this.props,showBtnL=_props3.showBtnL,showBtnM=_props3.showBtnM,midCom=_props3.midCom;return typeof leftWidth==="number"&&typeof midWidth==="number"?_react2.default.createElement(_Layout2.default,(0,_extends3.default)({},this.props,{ecId:ecId+"_Layout@fuo8fn",showLeft:this.state.showLeft,showBtn:showBtnL!==undefined?showBtnL:this.state.showMid,onCollapse:function onCollapse(bool){return _this2.onCollapse("left",bool);},btnTitle:titleleft}),_react2.default.createElement(_Layout2.default,(0,_extends3.default)({},this.props,{ecId:ecId+"_Layout@fu8c45",leftCom:midCom,leftWidth:midWidth,showBtn:showBtnM,showLeft:this.state.showMid,onCollapse:function onCollapse(bool){return _this2.onCollapse("middle",bool);},btnTitle:titlemiddle}),children)):_react2.default.createElement(_LayoutCol2.default,(0,_extends3.default)({},this.props,{ecId:ecId+"_LayoutCol@i4tuj6",showMid:this.state.showMid,onCollapse:function onCollapse(side,bool){return _this2.onCollapse(side,bool);}}));}return null;}}]);return WeaLeftRightLayout;}(_react2.default.Component),_class.defaultProps={col:2,showBtn:true,showTitleL:false,showTitleM:false,resize:false,titleLeft:"",titleMiddle:""},_temp);var Com=(0,_middleware2.default)(WeaLeftRightLayout,"WeaLeftRightLayout");exports.default=Com;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _class,_temp;// import WeaScroll from '../wea-scroll';
var _$=__webpack_require__(196);var _$2=_interopRequireDefault(_$);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _weaInputSearch=__webpack_require__(46);var _weaInputSearch2=_interopRequireDefault(_weaInputSearch);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _isArray=__webpack_require__(21);var _isArray2=_interopRequireDefault(_isArray);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _weaTreeTest=__webpack_require__(213);var _weaTreeTest2=_interopRequireDefault(_weaTreeTest);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var TreeNode=_antd.Tree.TreeNode;function objToArray(obj){if(!(0,_isArray2.default)(obj)){var arr=[];arr.push(obj);obj=arr;}return obj;}var getKeys=function getKeys(datas){var itemMainKey=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"domid";datas=objToArray(datas);return datas.map(function(data){return data[itemMainKey];});};// 获取总数，和每一叉树的所有 key
var getAllKeys=function getAllKeys(datas){var itemMainKey=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"domid";datas=objToArray(datas);var num=datas.length;var keys=getKeys(datas,itemMainKey);var childs=datas.map(function(data){var _obj2;var obj=(_obj2={},(0,_defineProperty3.default)(_obj2,itemMainKey,data[itemMainKey]),(0,_defineProperty3.default)(_obj2,"childs",[]),(0,_defineProperty3.default)(_obj2,"keys",[]),_obj2);if(data.childs&&data.childs.length>0){var _obj=getAllKeys(data.childs);num+=_obj.num;obj.num=_obj.num;obj.childs=[].concat((0,_toConsumableArray3.default)(_obj.childs));obj.keys=[].concat((0,_toConsumableArray3.default)(_obj.keys));keys=keys.concat(_obj.keys);}return obj;});return{num:num,childs:childs,keys:keys};};// 添加节点是否可展开标识，即是否有子集
var addLeaf=function addLeaf(datas){datas=objToArray(datas);return datas.map(function(data){var _data=(0,_extends3.default)({},data);if("isLeaf"in data)return _data;if(data.childs&&data.childs.length>0){_data.isLeaf=false;_data.childs=addLeaf(data.childs);}else{_data.isLeaf=true;}return _data;});};// 获取 maxLev 级树的数据
var getDefautDatasShow=function getDefautDatasShow(datas,maxLev){var lev=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;datas=objToArray(datas);return lev>maxLev?[]:datas.map(function(data){var _data=(0,_extends3.default)({},data);if(_data.childs&&_data.childs.length>0){_data.childs=getDefautDatasShow(data.childs,maxLev,lev+1);}return _data;});};// 点击展开节点，添加当前节点子集数据
var getDatasShow=function getDatasShow(datas,datashow,domid){var itemMainKey=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"domid";datashow=objToArray(datashow);return datashow.map(function(data,index){var _data=(0,_extends3.default)({},data);if(_data[itemMainKey]===domid){var _childs=[].concat((0,_toConsumableArray3.default)(datas[index].childs));_childs=_childs.map(function(c){var _c=(0,_extends3.default)({},c);_c.childs=[];return _c;});_data.childs=_childs;}else if(datas[index].childs&&datas[index].childs.length>0){_data.childs=getDatasShow(datas[index].childs,_data.childs,domid,itemMainKey);}return _data;});};// 过滤搜索值
var filterDatas=function filterDatas(datas,v){var searchKeys=arguments.length>2&&arguments[2]!==undefined?arguments[2]:["name","ecologyPinyinSearch"];datas=objToArray(datas);return datas.map(function(data){var _data=(0,_extends3.default)({},data);var keys=searchKeys.filter(function(key){return data[key]&&data[key].toLowerCase().indexOf(v.toLowerCase())>=0;});if(keys.length>0){var _childs=data.childs?filterDatas([].concat((0,_toConsumableArray3.default)(data.childs)),v,searchKeys):null;_data.isFind=true;_data.isLeaf=!(_childs&&_childs.length);_data.isParent=!_data.isLeaf;if(_childs&&_childs.length){_data.childs=_childs;}else{delete _data.childs;}}else if(data.childs&&data.childs.length>0){var childs=filterDatas(data.childs,v,searchKeys);var _childs2=childs.filter(function(c){return c.isFind;});if(_childs2.length===0){_data.isFind=false;}else{_data.isFind=true;_data.childs=childs;}}else{_data.isFind=false;}return _data;}).filter(function(c){return c.isFind;});};// 点击收藏 更改收藏状态
var doFavEdit=function doFavEdit(datas,domid){var itemMainKey=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"domid";datas=objToArray(datas);return datas.map(function(data){var _data=(0,_extends3.default)({},data);if(data[itemMainKey]===domid){_data.fav=!_data.fav;}else if(data.childs&&data.childs.length>0){_data.childs=doFavEdit(data.childs,domid);}return _data;});};// 删除不包含收藏节点的子集
var doNoFavDelete=function doNoFavDelete(datas){datas=objToArray(datas);return datas.map(function(data){var _data=(0,_extends3.default)({},data);_data.hasChildFav=false;if(data.childs&&data.childs.length>0){var childs=doNoFavDelete(data.childs);var _childs=childs.filter(function(c){return c.fav||c.hasChildFav;});if(_childs.length>0){_data.hasChildFav=true;_data.childs=_childs;}else{_data.isLeaf=true;_data.childs=[];}}return _data;}).filter(function(c){return c.fav||c.hasChildFav;});};var WeaLeftTree=(_temp=_class=function(_Component){(0,_inherits3.default)(WeaLeftTree,_Component);function WeaLeftTree(props){(0,_classCallCheck3.default)(this,WeaLeftTree);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaLeftTree.__proto__||(0,_getPrototypeOf2.default)(WeaLeftTree)).call(this,props));_this.onExpand=function(expandedKeys,target){var _this$props=_this.props,onExpand=_this$props.onExpand,ztreeMode=_this$props.ztreeMode;_this.setState({expandedKeys:expandedKeys});target=target||{node:null,expanded:false};if(target.node){target.node=ztreeMode?target.node:target.node.props.data;}typeof onExpand==="function"&&onExpand(expandedKeys,target);};_this.onSelect=function(keys,countsType){var _this$props2=_this.props,counts=_this$props2.counts,onSelect=_this$props2.onSelect;var key=keys&&keys.length>0?keys[0]:"";_this.setState({selectedKeys:keys});if(typeof onSelect==="function"){key&&key.length!==0&&_this.props.onSelect(key,counts?counts[key]:"",countsType||"",keys);}};_this.onSearchLabelClick=function(){var onSearchLabelClick=_this.props.onSearchLabelClick;typeof onSearchLabelClick==="function"&&onSearchLabelClick();};_this.onSearchChange=function(v){var _this$props3=_this.props,onSearchChange=_this$props3.onSearchChange,defaultExpandLevel=_this$props3.defaultExpandLevel,asyncLoad=_this$props3.asyncLoad,searchKeys=_this$props3.searchKeys,ztreeMode=_this$props3.ztreeMode;var _this$state=_this.state,datas=_this$state.datas,expandedKeys=_this$state.expandedKeys;var datasShow=v?filterDatas((0,_cloneDeep2.default)(datas),v,searchKeys):asyncLoad&&!ztreeMode?getDefautDatasShow(datas,1):[].concat((0,_toConsumableArray3.default)(datas));_this.setState({searchValue:v,datasShow:datasShow,expandedKeys:v?expandedKeys:asyncLoad&&!ztreeMode?[]:getAllKeys(getDefautDatasShow(datas,defaultExpandLevel-1)).keys});typeof onSearchChange==="function"&&onSearchChange(v);};_this.onLoadData=function(treeNode){return new _promise2.default(function(resolve){setTimeout(function(){var itemMainKey=_this.props.itemMainKey;var _this$state2=_this.state,datasShow=_this$state2.datasShow,datas=_this$state2.datas;var _datasShow=getDatasShow(datas,datasShow,treeNode.props.data[itemMainKey],itemMainKey);_this.setState({datasShow:_datasShow});resolve();},200);});};if(!props.vtreeMode){var datas=props.datas,_props$selectedKeys=props.selectedKeys,selectedKeys=_props$selectedKeys===undefined?[]:_props$selectedKeys,asyncLoad=props.asyncLoad,forceAsyn=props.forceAsyn,defaultExpandLevel=props.defaultExpandLevel,itemMainKey=props.itemMainKey,ztreeMode=props.ztreeMode;var _datas=addLeaf(datas);var expandedKeys=getAllKeys(getDefautDatasShow(_datas,defaultExpandLevel-1)).keys;var datasShow=[].concat((0,_toConsumableArray3.default)(_datas));if(asyncLoad&&!ztreeMode){datasShow=getDefautDatasShow(_datas,defaultExpandLevel);var total=getAllKeys(_datas,itemMainKey).num;var _total=getAllKeys(datasShow,itemMainKey).num;if(forceAsyn||_total>300&&total>500){datasShow=getDefautDatasShow(_datas,1);expandedKeys=[];}}_this.instanceIsMounted=false;_this.state={height:0,datas:_datas,datasShow:datasShow,expandedKeys:expandedKeys,selectedKeys:selectedKeys,searchValue:""};}_this.getTitle=_this.getTitle.bind(_this);return _this;}(0,_createClass3.default)(WeaLeftTree,[{key:"componentDidMount",value:function componentDidMount(){this.instanceIsMounted=true;}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(!nextProps.vtreeMode){var _state=this.state,_v=_state.searchValue,_d=_state.datas,_s=_state.selectedKeys,_e=_state.expandedKeys;var searchValue=nextProps.searchValue,datas=nextProps.datas,selectedKeys=nextProps.selectedKeys,expandedKeys=nextProps.expandedKeys,asyncLoad=nextProps.asyncLoad,forceAsyn=nextProps.forceAsyn,defaultExpandLevel=nextProps.defaultExpandLevel,ztreeMode=nextProps.ztreeMode,itemMainKey=nextProps.itemMainKey;var state={};var _datas=addLeaf(datas);if(!(0,_isEqual2.default)(_datas,_d)){var datasShow=[].concat((0,_toConsumableArray3.default)(_datas));var __e=getAllKeys(getDefautDatasShow(datasShow,defaultExpandLevel-1)).keys;if(asyncLoad&&!ztreeMode){datasShow=getDefautDatasShow(datasShow,defaultExpandLevel);var total=getAllKeys(datasShow,itemMainKey).num;var _total=getAllKeys(datasShow,itemMainKey).num;if(forceAsyn||_total>300&&total>500){datasShow=getDefautDatasShow(datasShow,1);__e=[];}}state=(0,_extends3.default)({},state,{datas:_datas,datasShow:datasShow},defaultExpandLevel?{expandedKeys:__e}:{});}if(searchValue!==undefined&&searchValue!==_v){state=(0,_extends3.default)({},state,{searchValue:searchValue});}if(expandedKeys!==undefined&&!(0,_isEqual2.default)(expandedKeys,_e)){state=(0,_extends3.default)({},state,{expandedKeys:expandedKeys});}if(selectedKeys!==undefined&&!(0,_isEqual2.default)(selectedKeys,_s)){state=(0,_extends3.default)({},state,{selectedKeys:selectedKeys});}this.setState(state);}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(preProps,preState){if(!this.props.vtreeMode){var datas=preState.datas,selectedKeys=preState.selectedKeys,expandedKeys=preState.expandedKeys,searchValue=preState.searchValue,datasShow=preState.datasShow;var _state2=this.state,_v=_state2.searchValue,_d=_state2.datas,_s=_state2.selectedKeys,_e=_state2.expandedKeys,_ds=_state2.datasShow;var counts=preProps.counts,countsType=preProps.countsType,loading=preProps.loading;var _props=this.props,_c=_props.counts,_t=_props.countsType,_l=_props.loading;return loading!==_l||searchValue!==_v||!(0,_isEqual2.default)(counts,_c)||!(0,_isEqual2.default)(countsType,_t)||!(0,_isEqual2.default)(datas,_d)||!(0,_isEqual2.default)(datasShow,_ds)||!(0,_isEqual2.default)(selectedKeys,_s)||!(0,_isEqual2.default)(expandedKeys,_e);}else{return true;}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.instanceIsMounted=false;}},{key:"onCollect",value:function onCollect(data,e){var _this2=this;var _props2=this.props,onCollect=_props2.onCollect,onlyShowFav=_props2.onlyShowFav,itemMainKey=_props2.itemMainKey;typeof onCollect==="function"&&onCollect(data).then(function(res){if(res.status===1){if(!res.hasDoFavToDatas){var datasShow=doFavEdit(_this2.state.datasShow,data[itemMainKey]);if(onlyShowFav)datasShow=doNoFavDelete(datasShow);_this2.setState({datasShow:datasShow});}_antd.message.success(res.msg||(data.fav?getLabel("129248","取消成功"):getLabel("383218","收藏成功"))+"\uFF01");}else{_antd.message.warning(res.msg||""+(data.fav?getLabel("385902","取消失败，请重试！"):getLabel("385472","收藏失败，请重试！")));}});e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();}},{key:"getTitle",value:function getTitle(data){var _this3=this;var _props3=this.props,showCollect=_props3.showCollect,itemMainKey=_props3.itemMainKey,counts=_props3.counts,countsType=_props3.countsType,ops=_props3.ops,prefixCls=_props3.prefixCls,ecId=_props3.ecId;var countsTypeShow=[];var notShowEm=0;var keys=[data[itemMainKey]];var flowSpan=showCollect?[_react2.default.createElement("i",{ecId:ecId+"_i@dnlfu4",title:""+(data.fav?getLabel("129753","取消收藏"):getLabel("22255","添加收藏")),className:"icon-coms-Collection"+(data.fav?"2":""),onClick:this.onCollect.bind(this,data)})]:[];countsType&&countsType.forEach(function(c){var num=counts&&counts[data[itemMainKey]]?counts[data[itemMainKey]][c.name]?counts[data[itemMainKey]][c.name]:"":"";if(num&&num!=="0"){notShowEm++;countsTypeShow.push(c);if(notShowEm!==1){flowSpan.push(_react2.default.createElement("em",{className:c.isshow?"":"wf-isshow",style:{display:c.isshow?"inline":"none"}}," ","/"," "));}flowSpan.push(_react2.default.createElement("span",{ecId:ecId+"_span@fob99e",title:c.title,className:c.isshow?"":"wf-isshow",style:{color:c.color,display:c.isshow?"inline-block":"none"},onClick:_this3.titileNumClick.bind(_this3,keys,c)},num));}});ops&&ops.length>0&&ops.forEach(function(op){flowSpan.push(_react2.default.createElement("div",{ecId:ecId+"_div@tchy8s@"+op.key,className:prefixCls+"-ops",key:op.key,onClick:function onClick(){return typeof op.onClick==="function"&&op.onClick(data);}},op.show));});return _react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@i41zv3",onMouseEnter:this.titleHoverIn.bind(this,countsTypeShow),onMouseLeave:this.titleHoverOut.bind(this,countsTypeShow)},_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@jvf2sb",span:"24",className:"titleText text-elli",title:data.name},data.name),_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@j5sc7p",span:"24",className:"titleNum"},_react2.default.createElement("div",null,flowSpan)));}},{key:"titileNumClick",value:function titileNumClick(keys,countsType,e){this.onSelect(keys,countsType);e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();}},{key:"titleHoverIn",value:function titleHoverIn(countsTypeShow,e){(0,_$2.default)(e.target).closest(".wea-tree-wrap").find(".ant-tree-title .titleNum").each(function(index,item){(0,_$2.default)(item).find(".wf-isshow").css({display:"inline-block"});(0,_$2.default)(item).find("span").each(function(i,m){(0,_$2.default)(m).css({"background-color":countsTypeShow[i].color,color:"#fff"});});});}},{key:"titleHoverOut",value:function titleHoverOut(countsTypeShow,e){(0,_$2.default)(e.target).closest(".wea-tree-wrap").find(".ant-tree-title .titleNum").each(function(index,item){(0,_$2.default)(item).find(".wf-isshow").css({display:"none"});(0,_$2.default)(item).find("span").each(function(i,m){(0,_$2.default)(m).css({color:countsTypeShow[i].color,"background-color":"transparent"});});});}},{key:"renderTreeNodes",value:function renderTreeNodes(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var counts=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _this4=this;var countsType=arguments[2];var lev=arguments[3];var _props4=this.props,itemMainKey=_props4.itemMainKey,ecId=_props4.ecId;var newDatas=[];datas&&datas.forEach(function(data){var _data$childs=data.childs,childs=_data$childs===undefined?[]:_data$childs;if((0,_keys2.default)(counts).length===0){newDatas.push(_react2.default.createElement(TreeNode,{ecId:ecId+"_TreeNode@evz87x@"+data[itemMainKey],browserTree:true,key:data[itemMainKey],data:data,isLeaf:data.isLeaf,title:_this4.getTitle(data),level:lev},_this4.renderTreeNodes(childs,counts,countsType,lev+1)));}else{var doTreeNodeRender=function doTreeNodeRender(){newDatas.push(_react2.default.createElement(TreeNode,(0,_extends3.default)({},data,{ecId:ecId+"_TreeNode@4z0c4j@"+data[itemMainKey],browserTree:true,key:data[itemMainKey],data:data,isLeaf:data.isLeaf,title:_this4.getTitle(data),level:lev}),_this4.renderTreeNodes(childs,counts,countsType,lev+1)));};if(counts[data[itemMainKey]]&&(typeof counts[data[itemMainKey]].flowAll==="string"||counts[data[itemMainKey]].flowAll&&counts[data[itemMainKey]].flowAll!=="0")){// 流程
doTreeNodeRender();}else if(counts[data[itemMainKey]]&&counts[data[itemMainKey]].allNum!==undefined){// 知识，这需求设计真是坑了
doTreeNodeRender();}}});return newDatas;}},{key:"render",value:function render(){if(this.props.vtreeMode){return _react2.default.createElement(_weaTreeTest2.default,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_WeaTreeTest@jcjh3g"}));}var _props5=this.props,prefixCls=_props5.prefixCls,className=_props5.className,counts=_props5.counts,countsType=_props5.countsType,asyncLoad=_props5.asyncLoad,asyncTree=_props5.asyncTree,ztreeMode=_props5.ztreeMode,searchLabel=_props5.searchLabel,noDataLabel=_props5.noDataLabel,loading=_props5.loading,style=_props5.style,ecId=_props5.ecId;var _state3=this.state,datasShow=_state3.datasShow,expandedKeys=_state3.expandedKeys,selectedKeys=_state3.selectedKeys,searchValue=_state3.searchValue;var props=(0,_extends3.default)({},asyncLoad&&!ztreeMode?{loadData:this.onLoadData}:{},this.props,{// 为实现异步树做展开受控处理 - 知识组
expandedKeys:asyncTree?this.props.expandedKeys:expandedKeys});return _react2.default.createElement("div",{className:prefixCls+" "+className,style:style},_react2.default.createElement(_antd.Spin,{spinning:loading,ecId:ecId+"_Spin@wy946p"},_react2.default.createElement("div",{className:prefixCls+"-search"},_react2.default.createElement("span",{ecId:ecId+"_span@dkt96d",className:prefixCls+"-search-label",onClick:this.onSearchLabelClick},searchLabel!==void 0?searchLabel:getLabel("21979","全部类型")),_react2.default.createElement(_weaInputSearch2.default,{ecId:ecId+"_WeaInputSearch@glsa3t",value:searchValue,onSearchChange:this.onSearchChange})),_react2.default.createElement("div",{className:prefixCls+"-scroll"},_react2.default.createElement(_weaNewScroll2.default,{ecId:ecId+"_WeaNewScroll@kn1wzr",height:"100%"},datasShow.length===0?_react2.default.createElement("p",{className:prefixCls+"-noData"},_react2.default.createElement("i",{className:"icon-coms-Invalid"}),noDataLabel!==void 0?noDataLabel:getLabel("83553","暂无数据")):null,_react2.default.createElement(_antd.Tree,(0,_extends3.default)({autoExpandParent:false,openTransitionName:"",showLine:true},props,{ecId:ecId+"_Tree@bi6vgv",prefixCls:"ant-tree",className:prefixCls+"-antd "+className,selectedKeys:selectedKeys,onExpand:this.onExpand,onSelect:this.onSelect,treeData:datasShow,ztreeMode:ztreeMode,getTitle:this.getTitle.bind(this),browserTree:true}),this.renderTreeNodes(datasShow,counts,countsType,0))))));}}]);return WeaLeftTree;}(_react.Component),_class.displayName="WeaLeftTree",_class.getKeys=getKeys,_class.getAllKeys=getAllKeys,_class.addLeaf=addLeaf,_class.getDefautDatasShow=getDefautDatasShow,_class.getDatasShow=getDatasShow,_class.filterDatas=filterDatas,_class.doFavEdit=doFavEdit,_class.doNoFavDelete=doNoFavDelete,_class.defaultProps={prefixCls:"wea-left-tree",className:"",cancelSelectable:true,datas:[],counts:{},countsType:[],itemMainKey:"domid",selectedKeys:undefined,expandedKeys:undefined,defaultExpandLevel:2,asyncLoad:false,forceAsyn:false,// searchLabel: getLabel('21979', "全部类型"),
searchValue:undefined,searchKeys:["name","ecologyPinyinSearch"],onlyShowFav:false,showCollect:false,// noDataLabel: getLabel('83553', "暂无数据"),
loading:false,style:{},ops:[]},_temp);var Com=(0,_middleware2.default)(WeaLeftTree,"WeaLeftTree");exports.default=Com;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(647);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(286);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(679);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaButtonIcon=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 965));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaButtonIcon;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _ActionButtons=__webpack_require__(361);var _ActionButtons2=_interopRequireDefault(_ActionButtons);var _TableCell=__webpack_require__(362);var _TableCell2=_interopRequireDefault(_TableCell);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Table=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 984));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});Table.TableCell=_TableCell2.default;Table.ActionButtons=_ActionButtons2.default;exports.default=Table;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class2,_temp3;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _weaDropdown=__webpack_require__(214);var _weaDropdown2=_interopRequireDefault(_weaDropdown);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var ButtonSelect=_weaDropdown2.default.ButtonSelect;var ActionButton=function(_React$PureComponent){(0,_inherits3.default)(ActionButton,_React$PureComponent);function ActionButton(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ActionButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ActionButton.__proto__||(0,_getPrototypeOf2.default)(ActionButton)).call.apply(_ref,[this].concat(args))),_this),_this.onBtnClick=function(e){var _this$props=_this.props,buttonType=_this$props.buttonType,onClick=_this$props.onClick;if(typeof onClick==="function")onClick(buttonType);},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ActionButton,[{key:"render",value:function render(){var _props=this.props,children=_props.children,isDropBtn=_props.isDropBtn,btnDropProps=_props.btnDropProps,nextProps=(0,_objectWithoutProperties3.default)(_props,["children","isDropBtn","btnDropProps"]);if(isDropBtn){return _react2.default.createElement(_antd.Dropdown,(0,_extends3.default)({trigger:["click"]},btnDropProps,{ecId:this.props.ecId+"_Dropdown@s1wyso"}),_react2.default.createElement(_antd.Button,(0,_extends3.default)({},nextProps,{onClick:this.onBtnClick,ecId:this.props.ecId+"_Button@si6uwm"}),children));}return _react2.default.createElement(_antd.Button,(0,_extends3.default)({},nextProps,{onClick:this.onBtnClick,ecId:this.props.ecId+"_Button@bdtvj6"}),children);}}]);return ActionButton;}(_react2.default.PureComponent);var ActionButtons=(_temp3=_class2=function(_Component){(0,_inherits3.default)(ActionButtons,_Component);function ActionButtons(){var _ref2;var _temp2,_this2,_ret2;(0,_classCallCheck3.default)(this,ActionButtons);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=(0,_possibleConstructorReturn3.default)(this,(_ref2=ActionButtons.__proto__||(0,_getPrototypeOf2.default)(ActionButtons)).call.apply(_ref2,[this].concat(args))),_this2),_this2.onMenuClick=function(e){var moveDropDatas=_this2.props.moveDropDatas;var onMenuClick=moveDropDatas.onMenuClick;typeof onMenuClick==="function"&&onMenuClick(e.key,e);},_this2.onClick=function(e){var moveDropDatas=_this2.props.moveDropDatas;var addBtn=moveDropDatas.addBtn;if(Array.isArray(addBtn)){addBtn.forEach(function(item){typeof item.onClick==="function"&&item.key===e.key&&item.onClick(e.key,e);});}else{typeof addBtn.onClick==="function"&&addBtn.onClick(e);}},_this2.onBtnClick=function(key){var onBtnClick=_this2.props.onBtnClick;if(key&&typeof onBtnClick==="function"){onBtnClick(key);}},_this2.onMenuClickAdd=function(e){var addDropDatas=_this2.props.addDropDatas;var onMenuClick=addDropDatas.onMenuClick;typeof onMenuClick==="function"&&onMenuClick(e.key,e);},_this2.onCollapse=function(){var _this2$props=_this2.props,collapsed=_this2$props.collapsed,onCollapse=_this2$props.onCollapse;if(typeof onCollapse==="function")onCollapse(!collapsed);},_temp2),(0,_possibleConstructorReturn3.default)(_this2,_ret2);}(0,_createClass3.default)(ActionButtons,[{key:"getMoveDropPropsDatas",value:function getMoveDropPropsDatas(){var _this3=this;var _props2=this.props,moveDropDatas=_props2.moveDropDatas,prefixCls=_props2.prefixCls;var datas=moveDropDatas.datas,addBtn=moveDropDatas.addBtn;if(Array.isArray(datas)&&datas.length>0){return{move:{overlay:_react2.default.createElement("div",{className:prefixCls+"-dropmenu-warp",style:{paddingBottom:addBtn?32:0,maxHeight:Array.isArray(addBtn)?194+addBtn.length*42:230},ecId:this.props.ecId+"_div@ycy5da"},_react2.default.createElement(_weaNewScroll2.default,{height:(datas.length>6?6:datas)*32,ecId:this.props.ecId+"_WeaNewScroll@v21oz3"},_react2.default.createElement(_antd.Menu,{prefixCls:prefixCls+"-dropmenu ant-dropdown-menu",onClick:this.onMenuClick,ecId:this.props.ecId+"_Menu@p817tj"},datas.map(function(d,index){return _react2.default.createElement(_antd.Menu.Item,{key:d.key,disabled:d.disabled,ecId:_this3.props.ecId+"_Menu.Item@bjuewe@"+d.key+"_"+index},d.show);}))),_react2.default.createElement(_antd.Menu,{prefixCls:prefixCls+"-dropmenu ant-dropdown-menu",onClick:this.onClick,ecId:this.props.ecId+"_Menu@fx91um"},addBtn?Array.isArray(addBtn)?addBtn.map(function(item,index){return _react2.default.createElement(_antd.Menu.Item,(0,_extends3.default)({className:prefixCls+"-dropmenu-addbtn"},item,{key:item.key,disabled:item.disabled,ecId:_this3.props.ecId+"_Menu.Item@jcwf0g@"+item.key+"_"+index}),item.show);}):_react2.default.createElement("div",(0,_extends3.default)({className:prefixCls+"-dropmenu-addbtn-single"},addBtn,{ecId:this.props.ecId+"_div@bxj4sj"}),addBtn.show):null))}};}return{};}},{key:"getAddBtn",value:function getAddBtn(){var _this4=this;var _props3=this.props,showAdd=_props3.showAdd,viewAttr=_props3.viewAttr,addButtonType=_props3.addButtonType,addDropDatas=_props3.addDropDatas;if(!showAdd)return null;var disabled=viewAttr===1;var props={type:"primary",disabled:disabled,size:"small",title:getLabel("611","添加")};var datas=addDropDatas.datas;if(addButtonType==="drop"&&Array.isArray(datas)&&datas.length>0){return _react2.default.createElement(_antd.Dropdown,{overlay:_react2.default.createElement(_antd.Menu,{onClick:this.onMenuClickAdd,ecId:this.props.ecId+"_Menu@9mzpl2"},datas.map(function(d,index){return _react2.default.createElement(_antd.Menu.Item,{key:d.key,disabled:d.disabled,ecId:_this4.props.ecId+"_Menu.Item@aaoam6@"+d.key+"_"+index},d.show);})),ecId:this.props.ecId+"_Dropdown@xlq5qc"},_react2.default.createElement(_antd.Button,(0,_extends3.default)({},props,{ecId:this.props.ecId+"_Button@8wjhdt"}),_react2.default.createElement("i",{className:"icon-coms-Add-to-hot",ecId:this.props.ecId+"_i@ev9bf0"})));}return _react2.default.createElement(ActionButton,(0,_extends3.default)({},props,{buttonType:"add",onClick:this.onBtnClick,ecId:this.props.ecId+"_ActionButton@s12kpa"}),_react2.default.createElement("i",{className:"icon-coms-Add-to-hot",ecId:this.props.ecId+"_i@w4z9nb"}));}},{key:"getBtnsArray",value:function getBtnsArray(){var _props4=this.props,viewAttr=_props4.viewAttr,showDelete=_props4.showDelete,showCopy=_props4.showCopy,showMove=_props4.showMove,customBtns=_props4.customBtns;var readOnly=viewAttr===1;var btns=[];if(!readOnly){showDelete&&btns.push({key:"delete",text:getLabel("91","删除"),show:_react2.default.createElement("i",{className:"icon-coms-form-delete-hot"})});showCopy&&btns.push({key:"copy",text:getLabel("77","复制"),show:_react2.default.createElement("i",{className:"icon-coms-copy-hot"})});showMove&&btns.push({key:"move",text:getLabel("81296","移动到组"),show:_react2.default.createElement("i",{className:"icon-coms-move2"}),isDropBtn:true});if(customBtns){btns=[].concat((0,_toConsumableArray3.default)(btns),(0,_toConsumableArray3.default)(customBtns));}}return btns;}},{key:"getCollapseBtn",value:function getCollapseBtn(){var _props5=this.props,showCollapse=_props5.showCollapse,collapsed=_props5.collapsed,onCollapse=_props5.onCollapse;return showCollapse?_react2.default.createElement("i",{style:{marginLeft:10,color:"#b2b2b2",cursor:"pointer",lineHeight:"20px"},className:"icon-coms-"+(collapsed?"down":"up"),onClick:this.onCollapse,ecId:this.props.ecId+"_i@onix14"}):null;}},{key:"getBtnsInline",value:function getBtnsInline(){var _this5=this;var _props6=this.props,viewAttr=_props6.viewAttr,selectedRowKeys=_props6.selectedRowKeys;var readOnly=viewAttr===1;var btns=this.getBtnsArray();var btnDropPropsDatas=this.getMoveDropPropsDatas();return btns.map(function(btn){return _react2.default.createElement(ActionButton,{type:"primary",disabled:"disabled"in btn?btn.disabled:readOnly||!(""+selectedRowKeys),title:btn.text,size:"small",buttonType:btn.key,isDropBtn:btn.isDropBtn,btnDropProps:btnDropPropsDatas[btn.key]||{overlay:_react2.default.createElement("span",null)},onClick:_this5.onBtnClick,ecId:_this5.props.ecId+"_ActionButton@25nek1"},btn.show);});}},{key:"getBtnsSelect",value:function getBtnsSelect(){var btns=this.getBtnsArray();if(btns.length===0)return null;var _props7=this.props,selectedBtnKey=_props7.selectedBtnKey,viewAttr=_props7.viewAttr,selectedRowKeys=_props7.selectedRowKeys,onBtnsSelect=_props7.onBtnsSelect;var readOnly=viewAttr===1;var selectedKey=selectedBtnKey||btns[0].key;var selected=btns.filter(function(b){return b.key===selectedKey;});var btn=selected[0];var btnDropPropsDatas=this.getMoveDropPropsDatas();if(btns.length===1){return _react2.default.createElement(ActionButton,{type:"primary",disabled:readOnly||!(""+selectedRowKeys),title:btn.text,size:"small",buttonType:btn.key,onClick:this.onBtnClick,ecId:this.props.ecId+"_ActionButton@28nw8u"},btn.show);}return _react2.default.createElement(ButtonSelect,{type:"small",selectedKey:selectedKey,btnProps:{title:btn.text||"",disabled:readOnly||!(""+selectedRowKeys),size:"small"},datas:btns,btnDropPropsDatas:btnDropPropsDatas,btnOnClick:this.onBtnClick,menuOnClick:function menuOnClick(key){return onBtnsSelect(key);},ecId:this.props.ecId+"_ButtonSelect@3auhxv"});}},{key:"render",value:function render(){var _props8=this.props,prefixCls=_props8.prefixCls,buttonsType=_props8.buttonsType,columns=_props8.columns;if(columns.length===0)return null;return _react2.default.createElement("span",{className:prefixCls+"-btns",ecId:this.props.ecId+"_span@bmh8rd"},this.getAddBtn(),buttonsType==="inline"?this.getBtnsInline():this.getBtnsSelect(),this.getCollapseBtn());}}]);return ActionButtons;}(_react.Component),_class2.displayName="ActionButtons",_temp3);exports.default=ActionButtons;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class2,_temp3;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _weaInput=__webpack_require__(56);var _weaInput2=_interopRequireDefault(_weaInput);var _weaInputNumber=__webpack_require__(200);var _weaInputNumber2=_interopRequireDefault(_weaInputNumber);var _weaTextarea=__webpack_require__(66);var _weaTextarea2=_interopRequireDefault(_weaTextarea);var _weaSelect=__webpack_require__(50);var _weaSelect2=_interopRequireDefault(_weaSelect);var _weaBrowser=__webpack_require__(80);var _weaBrowser2=_interopRequireDefault(_weaBrowser);var _weaDatePicker=__webpack_require__(133);var _weaDatePicker2=_interopRequireDefault(_weaDatePicker);var _weaTimePicker=__webpack_require__(98);var _weaTimePicker2=_interopRequireDefault(_weaTimePicker);var _weaTimeRangePicker=__webpack_require__(152);var _weaTimeRangePicker2=_interopRequireDefault(_weaTimeRangePicker);var _weaColorPicker=__webpack_require__(142);var _weaColorPicker2=_interopRequireDefault(_weaColorPicker);var _weaCheckbox=__webpack_require__(132);var _weaCheckbox2=_interopRequireDefault(_weaCheckbox);var _index=__webpack_require__(215);var _index2=_interopRequireDefault(_index);var _weaError=__webpack_require__(82);var _weaError2=_interopRequireDefault(_weaError);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatMultiLang=_weaLocaleProvider2.default.formatMultiLang;var TableCellSingle=function(_React$PureComponent){(0,_inherits3.default)(TableCellSingle,_React$PureComponent);function TableCellSingle(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,TableCellSingle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=TableCellSingle.__proto__||(0,_getPrototypeOf2.default)(TableCellSingle)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(value){var _this$props=_this.props,tableCellRecord=_this$props.tableCellRecord,tableCellIndex=_this$props.tableCellIndex,tableCellKey=_this$props.tableCellKey,onTableCellChange=_this$props.onTableCellChange,tableCellType=_this$props.tableCellType,tableCellCol=_this$props.tableCellCol;if(typeof onTableCellChange==="function"){if(tableCellType==="CHECKBOX"||tableCellType==="SWITCH"){onTableCellChange({record:tableCellRecord,index:tableCellIndex,key:tableCellKey,value:value,type:tableCellType,col:tableCellCol});}else if(tableCellType==="RADIO"){onTableCellChange({record:tableCellRecord,index:tableCellIndex,key:tableCellKey,value:value.target.checked,type:tableCellType,col:tableCellCol});}else{onTableCellChange({record:tableCellRecord,index:tableCellIndex,key:tableCellKey,value:value,type:tableCellType});}}},_this.onBrowserChange=function(ids,names,browserDatas){var _this$props2=_this.props,tableCellRecord=_this$props2.tableCellRecord,tableCellIndex=_this$props2.tableCellIndex,tableCellKey=_this$props2.tableCellKey,onTableCellChange=_this$props2.onTableCellChange,tableCellType=_this$props2.tableCellType;typeof onTableCellChange==="function"&&onTableCellChange({record:tableCellRecord,index:tableCellIndex,key:tableCellKey,value:ids,names:names,browserDatas:browserDatas,type:tableCellType});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(TableCellSingle,[{key:"render",value:function render(){var _props=this.props,tableCellType=_props.tableCellType,tableCellRecord=_props.tableCellRecord,tableCellIndex=_props.tableCellIndex,tableCellKey=_props.tableCellKey,tableCellCol=_props.tableCellCol,nextProps=(0,_objectWithoutProperties3.default)(_props,["tableCellType","tableCellRecord","tableCellIndex","tableCellKey","tableCellCol"]);if(tableCellType==="INPUTNUMBER"){return _react2.default.createElement(_weaInputNumber2.default,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaInputNumber@g06orn"}));}else if(tableCellType==="TEXTAREA"){return _react2.default.createElement(_weaTextarea2.default,(0,_extends3.default)({},nextProps,{onBlur:this.onChange,ecId:this.props.ecId+"_WeaTextarea@25uuhu"}));}else if(tableCellType==="TIMEPICKER"){return _react2.default.createElement(_weaTimePicker2.default,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaTimePicker@f3tvqy"}));}else if(tableCellType==="TIMERANGEPICKER"){return _react2.default.createElement(_weaTimeRangePicker2.default,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaTimeRangePicker@ms5f6x"}));}else if(tableCellType==="DATEPICKER"){return _react2.default.createElement(_weaDatePicker2.default,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaDatePicker@262cgq"}));}else if(tableCellType==="SELECT"){return _react2.default.createElement(_weaSelect2.default,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaSelect@o1yseu"}));}else if(tableCellType==="BROWSER"){return _react2.default.createElement(_weaBrowser2.default,(0,_extends3.default)({},nextProps,{onChange:this.onBrowserChange,ecId:this.props.ecId+"_WeaBrowser@tjtg3s"}));}else if(tableCellType==="CHECKBOX"||tableCellType==="SWITCH"){return _react2.default.createElement(_weaCheckbox2.default,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaCheckbox@cqlvzk"}));}else if(tableCellType==="CASCADER"){return _react2.default.createElement(_index2.default,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaCascader@7hi0vu"}));}else if(tableCellType==="CUSTOMFIELD"){return _react2.default.createElement(_index2.default.WeaCustomField,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaCascader.WeaCustomField@1pty9c"}));}else if(tableCellType==="COLORPICKER"){return _react2.default.createElement(_weaColorPicker2.default,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_WeaColorPicker@cg4mbg"}));}else if(tableCellType==="RADIO"){return _react2.default.createElement(_antd.Radio,(0,_extends3.default)({},nextProps,{onChange:this.onChange,ecId:this.props.ecId+"_Radio@gvflj2"}));}return _react2.default.createElement(_weaInput2.default,(0,_extends3.default)({},nextProps,{onBlur:this.onChange,ecId:this.props.ecId+"_WeaInput@sbpuqb"}));}}]);return TableCellSingle;}(_react2.default.PureComponent);var TableCell=(_temp3=_class2=function(_Component){(0,_inherits3.default)(TableCell,_Component);function TableCell(){var _ref2;var _temp2,_this2,_ret2;(0,_classCallCheck3.default)(this,TableCell);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=(0,_possibleConstructorReturn3.default)(this,(_ref2=TableCell.__proto__||(0,_getPrototypeOf2.default)(TableCell)).call.apply(_ref2,[this].concat(args))),_this2),_this2.onEdit=function(values){_this2.props.onEdit(values);},_this2.getBrowerDatas=function(record,key){var replaceDatas=[];if(record[key+"span"]!==void 0){var keys=typeof record[key]==="string"?record[key].split(","):[record[key]];var values=typeof record[key+"span"]==="string"?record[key+"span"].split(","):[record[key+"span"]];if(keys.length===values.length){keys.forEach(function(k,i){k!==""&&values[i]!==""&&replaceDatas.push({id:k,name:values[i]});});}}return replaceDatas;},_this2.createBrowser=function(props,type){var _this2$props=_this2.props,key=_this2$props.com.key,record=_this2$props.record,index=_this2$props.index;var v=_this2.getBrowerDatas(record,key);var _props$browserConditi=props.browserConditionParam,browserConditionParam=_props$browserConditi===undefined?{}:_props$browserConditi;return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({style:{width:"100%",display:"inline-block"},viewAttr:2,layout:_window2.default.getTop().document.body},props,browserConditionParam,{replaceDatas:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@o0t6j8@Browser_"+index}));},_this2.createCascader=function(props,type){var _this2$props2=_this2.props,key=_this2$props2.com.key,record=_this2$props2.record,index=_this2$props2.index;var v=record[key];return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({viewAttr:2},props,{values:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@utqxhs@Cascader_"+index}));},_this2.createCustomField=function(props,type){var _this2$props3=_this2.props,key=_this2$props3.com.key,record=_this2$props3.record,index=_this2$props3.index;var v=record[key];return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({viewAttr:2},props,{values:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@zhc615@CustomField_"+index}));},_this2.createCorlorPicker=function(props,type){var _this2$props4=_this2.props,key=_this2$props4.com.key,record=_this2$props4.record,index=_this2$props4.index;var v=record[key]||"";return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({viewAttr:2},props,{value:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@0mugtm@CorlorPicker_"+index}));},_this2.createCheckbox=function(props,type){var _this2$props5=_this2.props,key=_this2$props5.com.key,record=_this2$props5.record,index=_this2$props5.index,checkProps=_this2$props5.checkProps,col=_this2$props5.col;var v=record[key]||"";return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({style:{width:"100%"},viewAttr:checkProps.disabled?1:2},props,{defaultValue:v,value:v},checkProps,{tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,tableCellCol:col,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@tlzyu1@Checkbox_"+index}));},_this2.createRadio=function(props,type){var _this2$props6=_this2.props,key=_this2$props6.com.key,record=_this2$props6.record,index=_this2$props6.index,checkProps=_this2$props6.checkProps,col=_this2$props6.col;return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({},props,checkProps,{tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,tableCellCol:col,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@mazhlq@Radio_"+index}));},_this2.createSelect=function(props,type){var _this2$props7=_this2.props,key=_this2$props7.com.key,record=_this2$props7.record,index=_this2$props7.index;var v=record[key]||"";return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({viewAttr:2,options:[]},props,{defaultValue:v,value:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@xzzy27@Select_"+index}));},_this2.createTimeRangePicker=function(props,type){var _this2$props8=_this2.props,key=_this2$props8.com.key,record=_this2$props8.record,index=_this2$props8.index;var v=record[key]||[];return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({style:{width:"45%"},viewAttr:2},props,{defaultValue:v,value:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@negw0l@TimeRangePicker_"+index}));},_this2.createTimePicker=function(props,type){var _this2$props9=_this2.props,key=_this2$props9.com.key,record=_this2$props9.record,index=_this2$props9.index;var v=record[key]||"";return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({style:{width:"100%"},viewAttr:2},props,{defaultValue:v,value:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@3hub0b@TimePicker_"+index}));},_this2.createDatePicker=function(props,type){var _this2$props10=_this2.props,key=_this2$props10.com.key,record=_this2$props10.record,index=_this2$props10.index;var v=record[key]||"";return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({style:{width:"100%"},viewAttr:2},props,{defaultValue:v,value:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@k91ywz@DatePicker_"+index}));},_this2.createTextarea=function(props,type){var _this2$props11=_this2.props,key=_this2$props11.com.key,record=_this2$props11.record,index=_this2$props11.index;var v=record[key]||"";return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({style:{width:"100%"},viewAttr:2},props,{defaultValue:v,value:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@46p6eb@Textarea_"+index}));},_this2.createInputNumber=function(props,type){var _this2$props12=_this2.props,key=_this2$props12.com.key,record=_this2$props12.record,index=_this2$props12.index;var v=record[key]||"";if(record[key]===0){v=0;}return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({style:{width:"100%"},viewAttr:2},props,{defaultValue:v,value:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@633hzn@InputNumber_"+index}));},_this2.createInput=function(props,type){var _this2$props13=_this2.props,key=_this2$props13.com.key,record=_this2$props13.record,index=_this2$props13.index;var v=record[key]||"";return _react2.default.createElement(TableCellSingle,(0,_extends3.default)({style:{width:"100%"},viewAttr:2},props,{defaultValue:v,value:v,tableCellRecord:record,tableCellIndex:index,tableCellKey:key,tableCellType:type,onTableCellChange:_this2.onEdit,ecId:_this2.props.ecId+"_TableCellSingle@1kffbx@Input_"+index}));},_this2.createCustom=function(){var _this2$props14=_this2.props,com=_this2$props14.com,record=_this2$props14.record,index=_this2$props14.index,text=_this2$props14.text,onEdit=_this2$props14.onEdit;return com.render(text,record,index,onEdit);},_this2.createText=function(){var _this2$props15=_this2.props,com=_this2$props15.com,text=_this2$props15.text,index=_this2$props15.index;return _react2.default.createElement("span",{className:"wea-table-edit-html "+(com.className||""),dangerouslySetInnerHTML:{__html:formatMultiLang(text)},ecId:_this2.props.ecId+"_TableCellSingle@bqbrm7@Text_"+index});},_this2.onIconEnlargeClick=function(){var _this2$props16=_this2.props,rowKey=_this2$props16.rowKey,index=_this2$props16.index,record=_this2$props16.record,doAdd=_this2$props16.doAdd,onRowAdd=_this2$props16.onRowAdd;(0,_isFunction2.default)(doAdd)&&doAdd(record[rowKey]);(0,_isFunction2.default)(onRowAdd)&&onRowAdd(record,index);},_this2.wrapWeaComponent=function(){var _this2$props17=_this2.props,_this2$props17$com=_this2$props17.com,key=_this2$props17$com.key,isTreeNode=_this2$props17$com.isTreeNode,viewAttr=_this2$props17$com.viewAttr,len=_this2$props17.len,rowKey=_this2$props17.rowKey,index=_this2$props17.index,validateResult=_this2$props17.validate.validateResult,record=_this2$props17.record,lastTreeNode=_this2$props17.lastTreeNode,operationKey=_this2$props17.operationKey;var error=validateResult&&validateResult[key]?validateResult[key][0]:"";var dotIndex=record[rowKey].toString().split(".").length-1;var paddingLeft=20*dotIndex,left=20*(dotIndex-1);paddingLeft<0&&(paddingLeft=0);left<0&&(left=0);var com=isTreeNode?_react2.default.createElement("div",{style:{position:"relative",paddingLeft:paddingLeft},ecId:_this2.props.ecId+"_div@3yraq6@"+index},dotIndex!==0&&_react2.default.createElement("i",{className:""+(lastTreeNode?"icon-coms-line-2":"icon-coms-line-1"),style:{fontSize:18,color:"#979797",position:"absolute",left:left,top:4},ecId:_this2.props.ecId+"_i@btn3zs@"+index}),_react2.default.createElement(_weaError2.default,{ref:"error_"+record[rowKey]+"_"+key,error:error,style:{paddingRight:20,width:"100%"},tipPosition:len===index+1?"top":"bottom",ecId:_this2.props.ecId+"_WeaError@mqv451@"+index},_this2.getWeaComponent()),record[operationKey]&&_react2.default.createElement("i",{className:"icon-coms-Enlarge",style:{position:"absolute",fontSize:15,color:"#979797",top:viewAttr===1?4:7,right:-8,cursor:"pointer"},onClick:_this2.onIconEnlargeClick,ecId:_this2.props.ecId+"_i@ajn02t@"+index})):_react2.default.createElement(_weaError2.default,{ref:"error_"+record[rowKey]+"_"+key,error:error,tipPosition:len===index+1?"top":"bottom",ecId:_this2.props.ecId+"_WeaError@fd5vvo@"+index},_this2.getWeaComponent());return com;},_this2.wrapReactComponent=function(){var _this2$props18=_this2.props,com=_this2$props18.com,record=_this2$props18.record,index=_this2$props18.index,text=_this2$props18.text,onEdit=_this2$props18.onEdit;return(0,_react.cloneElement)(com,{tableCellProps:{record:record,index:index,text:text,onEdit:onEdit}});},_temp2),(0,_possibleConstructorReturn3.default)(_this2,_ret2);}(0,_createClass3.default)(TableCell,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _nextProps$validate=nextProps.validate,pass=_nextProps$validate.pass,validateResult=_nextProps$validate.validateResult,key=nextProps.com.key,rowKey=nextProps.rowKey,record=nextProps.record;if(pass===false&&key&&validateResult&&validateResult[key]&&validateResult[rowKey]===record[rowKey]){var error=this.refs["error_"+record[rowKey]+"_"+key];error&&error.showError();}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){return true;}},{key:"getWeaComponent",value:function getWeaComponent(){var com=this.props.com;var type=com.type,_com$otherParams=com.otherParams,otherParams=_com$otherParams===undefined?{}:_com$otherParams;var t=typeof type==="string"?type.toUpperCase():"INPUT";// com props
var props=(0,_extends3.default)({},com);delete props.type;delete props.key;delete props.label;delete props.otherParams;delete props.error;// otherParams props
props=(0,_extends3.default)({},props,otherParams);// dispath
switch(t){case"INPUT":return this.createInput(props,t);case"INPUTNUMBER":return this.createInputNumber(props,t);case"TEXTAREA":return this.createTextarea(props,t);case"DATEPICKER":return this.createDatePicker(props,t);case"TIMEPICKER":return this.createTimePicker(props,t);case"TIMERANGEPICKER":return this.createTimeRangePicker(props,t);case"SELECT":return this.createSelect(props,t);case"BROWSER":return this.createBrowser(props,t);case"CHECKBOX":return this.createCheckbox(props,t);case"SWITCH":return this.createCheckbox((0,_extends3.default)({},props,{display:"switch"}),t);case"RADIO":return this.createRadio(props,t);case"CASCADER":return this.createCascader(props,t);case"CUSTOMFIELD":return this.createCustomField(props,t);case"COLORPICKER":return this.createCorlorPicker(props,t);case"CUSTOM":return this.createCustom();case"TEXT":return this.createText();default:return null;}}// wrap WeaError
// tableCellProps
},{key:"render",value:function render(){var _props2=this.props,com=_props2.com,rowKey=_props2.rowKey,record=_props2.record,index=_props2.index;if((0,_react.isValidElement)(com)){return this.wrapReactComponent();}var _com$label=com.label,label=_com$label===undefined?"":_com$label,key=com.key,type=com.type,hasHiddenField=com.hasHiddenField;// hidden field
var hiddrenField=_react2.default.createElement("input",{id:key+"_"+record[rowKey],type:"hidden",value:record[key],ecId:this.props.ecId+"_input@gid7gu@"+index});if(typeof type==="string"&&type.toUpperCase()==="HIDDENFIELD"){return hiddrenField;}return _react2.default.createElement("span",null,label?_react2.default.createElement("span",{style:{marginLeft:5}},label):null,this.wrapWeaComponent(),hasHiddenField?hiddrenField:null);}}]);return TableCell;}(_react.Component),_class2.displayName="TableCell",_temp3);exports.default=TableCell;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(683);

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _loadjs=__webpack_require__(54);var _loadjs2=_interopRequireDefault(_loadjs);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _plugins=__webpack_require__(216);var _plugins2=_interopRequireDefault(_plugins);var _Textarea=__webpack_require__(702);var _Textarea2=_interopRequireDefault(_Textarea);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 打开应用连接
var openAppLink=function openAppLink(obj,linkid,linkType){// 新地址
if(Number(linkType)===37){window.openFullWindowHaveBar?window.openFullWindowHaveBar("/spa/document/index.jsp?id="+linkid+"&router=1#/main/document/detail"):window.open("/spa/document/index.jsp?id="+linkid+"&router=1#/main/document/detail");}else{var discussid=$(obj).parents(".reportItem").attr("id");if(linkType=="37")window.open("/spa/document/index.jsp?moduleid=blog&id="+linkid+"&discussid="+discussid+"&linkType="+linkType+"&linkid="+linkid);else if(linkType=="task")window.open("/proj/process/ViewTask.jsp?moduleid=blog&taskrecordid="+linkid+"&discussid="+discussid+"&linkType="+linkType+"&linkid="+linkid);else if(linkType=="18")window.open("/spa/crm/static/index.html#/main/crm/customerView?moduleid=blog&customerId="+linkid+"&discussid="+discussid+"&linkType="+linkType+"&linkid="+linkid);else if(linkType=="152")window.open("/spa/workflow/index_form.jsp#/main/workflow/req?moduleid=blog&requestid="+linkid+"&discussid="+discussid+"&linkType="+linkType+"&linkid="+linkid);else if(linkType=="135")window.open("/spa/prj/index.html#/main/prj/projectCard?moduleid=blog&prjid="+linkid+"&discussid="+discussid+"&linkType="+linkType+"&linkid="+linkid);else if(linkType=="workplan")window.open("/spa/workplan/static/index.html#/main/wp/workPlanCreateSingle?moduleid=blog&workid="+linkid+"&discussid="+discussid+"&linkType="+linkType+"&linkid="+linkid);else if(linkType==="prjtsk")window.open("/spa/prj/index.html#/main/prj/taskCard?taskid="+linkid+"&linkType="+linkType+"&linkid="+linkid);}return false;};// 打开附件
function opendoc(obj,showid,versionid,docImagefileid){var discussid=$(obj).parents(".reportItem").attr("id");window.openFullWindowHaveBar("/docs/docs/DocDspExt.jsp?id="+showid+"&imagefileId="+docImagefileid+"&blogDiscussid="+discussid+"&isFromAccessory=true&isfromcoworkdoc=1");}// 打开附件
function opendoc1(obj,showid){var discussid=$(obj).parents(".reportItem").attr("id");window.openFullWindowHaveBar("/docs/docs/DocDsp.jsp?id="+showid+"&blogDiscussid="+discussid+"&pstate=sub");}var WeaRichText=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 980));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});WeaRichText.openAppLink=openAppLink;WeaRichText.opendoc=opendoc;WeaRichText.opendoc1=opendoc1;WeaRichText.plugins=_plugins2.default;WeaRichText.Textarea=_Textarea2.default;WeaRichText.loadjs=_loadjs2.default;// iframe dialog嵌套的情况需要
exports.default=WeaRichText;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(701);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaMap=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(6/* limit */).then(__webpack_require__.bind(null, 978));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaMap;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(38);var _reactDom2=_interopRequireDefault(_reactDom);var _loadCss=__webpack_require__(83);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ExtendsContainer=function(_React$Component){(0,_inherits3.default)(ExtendsContainer,_React$Component);function ExtendsContainer(){(0,_classCallCheck3.default)(this,ExtendsContainer);return(0,_possibleConstructorReturn3.default)(this,(ExtendsContainer.__proto__||(0,_getPrototypeOf2.default)(ExtendsContainer)).apply(this,arguments));}(0,_createClass3.default)(ExtendsContainer,[{key:"append",value:function append(){var children=this.props.children;_reactDom2.default.unstable_renderSubtreeIntoContainer(this,children,this.container);}},{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,container=_props.container,style=_props.style,className=_props.className,_props$position=_props.position,position=_props$position===undefined?"last":_props$position,insertChildNode=_props.insertChildNode,onClick=_props.onClick,title=_props.title,ecId=_props.ecId;if(!insertChildNode){// 插入图标到最前或者最后
this.container=document.createElement("div");this.container.className=className===void 0?"wea-rich-text-extents":className;for(var key in style){if(style.hasOwnProperty(key)){this.container.style[key]=style[key];}}position==="first"?container.insertBefore(this.container,container.firstChild):container.appendChild(this.container);}else{// 插入图标到指定的位置
this.container=document.createElement("a");this.container.className=className;this.container.title=title;this.container.onclick=onClick;this.container.ecId=ecId+"_a@xn8n8e";container.insertBefore(this.container,insertChildNode);}this.append();(0,_loadCss.loadCss)();}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var className=nextProps.className,insertChildNode=nextProps.insertChildNode;// 插入到指定位置模式: 切换源码模式的时候,className要同步更新
if(insertChildNode&&className!==this.props.className){this.container.className=className;}}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.append();}},{key:"componentWillUnmount",value:function componentWillUnmount(){var container=this.props.container;container&&container.removeChild(this.container);}},{key:"render",value:function render(){return null;}}]);return ExtendsContainer;}(_react2.default.Component);exports.default=ExtendsContainer;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _weaHelpfulTip=__webpack_require__(52);var _weaHelpfulTip2=_interopRequireDefault(_weaHelpfulTip);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SearchGroup=function(_React$PureComponent){(0,_inherits3.default)(SearchGroup,_React$PureComponent);function SearchGroup(props){(0,_classCallCheck3.default)(this,SearchGroup);var _this=(0,_possibleConstructorReturn3.default)(this,(SearchGroup.__proto__||(0,_getPrototypeOf2.default)(SearchGroup)).call(this,props));_this.state={showGroup:props.showGroup||false};return _this;}(0,_createClass3.default)(SearchGroup,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// needUpdateShowGroupStatus 控制 componentWillReceiveProps 是否更新showGroup的值
if("showGroup"in nextProps&&"needUpdateShowGroupStatus"in nextProps&&nextProps.needUpdateShowGroupStatus&&this.state.showGroup!==nextProps.showGroup){this.setState({showGroup:nextProps.showGroup});}}},{key:"onAdSearch",value:function onAdSearch(){// 支持高级搜索内input框的onEnter触发搜索
var onAdSearch=this.props.onAdSearch;typeof onAdSearch==="function"&&onAdSearch();}},{key:"render",value:function render(){var _this2=this;var _props=this.props,ecId=_props.ecId,title=_props.title,items=_props.items,_props$needTigger=_props.needTigger,needTigger=_props$needTigger===undefined?true:_props$needTigger,_props$col=_props.col,col=_props$col===undefined?2:_props$col,_props$customComponen=_props.customComponent,customComponent=_props$customComponen===undefined?"":_props$customComponen,children=_props.children,fontSize=_props.fontSize,_props$style=_props.style,style=_props$style===undefined?{}:_props$style,center=_props.center,size=_props.size,hide=_props.hide,multiCol=_props.multiCol,_props$titleTip=_props.titleTip,titleTip=_props$titleTip===undefined?null:_props$titleTip;var showGroup=this.state.showGroup;return _react2.default.createElement("div",{className:"wea-search-group "+(this.props.className||"")+" "+(hide?"wea-hide":"wea-show"),style:style},title&&_react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@gkjv8p",className:"wea-title"},_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@582gf1",span:customComponent===""?needTigger?23:24:10},_react2.default.createElement("div",{style:{fontSize:fontSize},className:"wea-f12 text-elli"},title,titleTip&&_react2.default.createElement("span",{style:{"margin-left":"5px"}},_react2.default.createElement(_weaHelpfulTip2.default,(0,_extends3.default)({},titleTip,{ecId:ecId+"_WeaHelpfulTip@6du397"}))))),customComponent&&_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@qmsq8r",className:"wea-f12",span:needTigger?13:14,style:{textAlign:"right",paddingRight:10}},customComponent),needTigger&&_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@gzrxfj",className:"wea-f12",span:1,style:{textAlign:"right",paddingRight:10}},_react2.default.createElement("i",{ecId:ecId+"_i@4y1obt",className:showGroup?"icon-coms-up":"icon-coms-down",onClick:function onClick(){_this2.setState({showGroup:!showGroup});_this2.props.onVisibleChange&&_this2.props.onVisibleChange(!showGroup);}}))),_react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@ipqua7",className:"wea-content "+(center?"center":"")+" "+(multiCol?"multiCol":"")+" "+(title?"pt15":""),style:showGroup?{}:{display:"none"}},_react2.default.createElement("div",{className:"wea-form-cell-wrapper clearfix  "+(size||"")},items&&items.map(function(obj,index){if(obj){var cellNum=obj.col||col;if(center)cellNum=1;return _react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@z9kzzo@"+index,className:"wea-form-cell "+(obj.hide?"wea-hide":""),span:24/cellNum},obj.com);}}),children)));}}]);return SearchGroup;}(_react2.default.PureComponent);var Com=(0,_middleware2.default)(SearchGroup,"WeaSearchGroup");exports.default=Com;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _weaSearchAdvance=__webpack_require__(195);var _weaSearchAdvance2=_interopRequireDefault(_weaSearchAdvance);var _debounce=__webpack_require__(67);var _debounce2=_interopRequireDefault(_debounce);var _data=__webpack_require__(301);var _data2=_interopRequireDefault(_data);__webpack_require__(704);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var initialState={pageSize:10,currentPage:1,tableData:[],total:_data2.default.length,displayData:(0,_cloneDeep2.default)(_data2.default),inputValue:""};var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this2=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this2.state=(0,_cloneDeep2.default)(initialState);_this2.state.value=props.value||"";_this2.state.visible=false;return _this2;}(0,_createClass3.default)(main,[{key:"componentDidMount",value:function componentDidMount(){this.props.initFunc&&this.props.initFunc(this);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps&&this.props.value!==nextProps.value){this.setState({value:nextProps.value});}}},{key:"getData",value:function getData(){var currentPage=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var _state=this.state,pageSize=_state.pageSize,total=_state.total,displayData=_state.displayData;var start=pageSize*(currentPage-1);var end=pageSize*currentPage>total?total:pageSize*currentPage;var tableData=displayData.slice(start,end);this.setState({tableData:tableData});}},{key:"onSearchChange",value:function onSearchChange(v){var pageSize=this.state.pageSize;var all=(0,_cloneDeep2.default)(_data2.default);var displayData=all.filter(function(item){return item.indexOf(v)>-1;});var total=displayData.length;var currentPage=1;var start=pageSize*(currentPage-1);var end=pageSize*currentPage>total?total:pageSize*currentPage;var tableData=displayData.slice(start,end);this.setState({displayData:displayData,total:total,currentPage:currentPage,tableData:tableData,inputValue:v});}},{key:"closeModal",value:function closeModal(){this.setState(initialState);this.setState({visible:false});}},{key:"openModal",value:function openModal(){this.setState({visible:true});}},{key:"handleClear",value:function handleClear(){this.closeModal();this.setState({value:""});this.props.onChange&&this.props.onChange("");}},{key:"handleCancel",value:function handleCancel(){this.closeModal();}},{key:"open",value:function open(){this.setState(initialState);this.getData();this.openModal();}},{key:"set",value:function set(value){this.setState({value:value});}},{key:"get",value:function get(){var value=this.state.value;return{value:value};}},{key:"onRowClick",value:function onRowClick(name){this.setState({value:name});this.props.onChange&&this.props.onChange(name);this.closeModal();}},{key:"getSearchType",value:function getSearchType(){return["base"];}},{key:"render",value:function render(){var _this3=this;var _this=this;var _props=this.props,customized=_props.customized,buttons=_props.buttons,contentHeight=_props.contentHeight,icon=_props.icon,iconBgcolor=_props.iconBgcolor,title=_props.title,modalStyle=_props.modalStyle,_props$text=_props.text,text=_props$text===undefined?getLabel(83738,"更换"):_props$text;var _state2=this.state,pageSize=_state2.pageSize,total=_state2.total,currentPage=_state2.currentPage,value=_state2.value,tableData=_state2.tableData,inputValue=_state2.inputValue,visible=_state2.visible;var titleEle=React.createElement(_antd.Row,{ecId:this.props.ecId+"_Row@d4f9mo"},React.createElement(_antd.Col,{ecId:this.props.ecId+"_Col@nnybtc",span:"22",style:{paddingLeft:20,lineHeight:"48px"}},React.createElement("div",{className:"wea-hr-muti-input-title"},iconBgcolor?React.createElement("div",{className:"wea-workflow-radio-icon-circle",style:{background:iconBgcolor?iconBgcolor:""}},React.createElement("i",{className:icon})):React.createElement("span",{style:{verticalAlign:"middle",marginRight:10}},React.createElement("i",{className:icon})),React.createElement("span",{style:{verticalAlign:"middle"}},title))));var inputArr=React.createElement("div",{className:"wea-browser-icons",style:{display:"inline-block"}},value&&React.createElement("span",{style:{display:"inline-block",lineHeight:"30px"}},React.createElement("span",{className:value,style:{color:"#16a1fd",fontSize:17,marginRight:10}},React.createElement("span",{className:"path1"}),React.createElement("span",{className:"path2"}),React.createElement("span",{className:"path3"}),React.createElement("span",{className:"path4"}),React.createElement("span",{className:"path5"}),React.createElement("span",{className:"path6"}),React.createElement("span",{className:"path7"}),React.createElement("span",{className:"path8"}),React.createElement("span",{className:"path9"}),React.createElement("span",{className:"path10"}))),React.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@rt2bis",type:"ghost",onClick:this.open.bind(this)},text));var footer=buttons||[React.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@zt7kzo",type:"ghost",onClick:this.handleClear.bind(this)},getLabel(385566,"清 除")),React.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@6tkpru",type:"ghost",onClick:this.handleCancel.bind(this)},getLabel(385567,"取 消"))];var cHeight=contentHeight-46;var dom=inputArr;if(customized){dom=React.createElement("div",{ecId:this.props.ecId+"_div@rsd6o8",className:"cursor-pointer",onClick:this.openModal},this.props.children);}return React.createElement("div",null,dom,React.createElement(_antd.Modal,{ecId:this.props.ecId+"_Modal@mji7gu",wrapClassName:"wea-browser-single wea-browser-modal wea-browser-icons",title:titleEle,zIndex:this.props.zIndex,width:modalStyle.width,maskClosable:false,visible:visible,onCancel:this.handleCancel.bind(this),footer:footer},React.createElement("div",{className:"prel"},React.createElement(_weaSearchAdvance2.default,{ecId:this.props.ecId+"_WeaSearchAdvance@ui90ah",searchType:this.getSearchType(),searchsBaseValue:inputValue,onSearchChange:(0,_debounce2.default)(this.onSearchChange,200).bind(this),onSearch:this.onSearchChange.bind(this)}),React.createElement("div",null,React.createElement(_antd.Row,{ecId:this.props.ecId+"_Row@dy0nu3",className:"icons-header"},React.createElement(_antd.Col,{ecId:this.props.ecId+"_Col@y4xgtg",span:6,style:{paddingLeft:60}},getLabel(82757,"图标")),React.createElement(_antd.Col,{ecId:this.props.ecId+"_Col@o5hce3",span:18},getLabel(33439,"名称"))),!(0,_isEmpty2.default)(tableData)&&React.createElement("div",{style:{height:365}},tableData&&tableData.map(function(item){return React.createElement(_antd.Row,{ecId:_this3.props.ecId+"_Row@wvp2zb",className:"cursor-pointer icons-th",onClick:_this3.onRowClick.bind(_this3,item)},React.createElement(_antd.Col,{ecId:_this3.props.ecId+"_Col@4t0c61",span:6,style:{paddingLeft:60,fontSize:16}},React.createElement("span",{className:item,style:{color:"#16a1fd"}},React.createElement("span",{className:"path1"}),React.createElement("span",{className:"path2"}),React.createElement("span",{className:"path3"}),React.createElement("span",{className:"path4"}),React.createElement("span",{className:"path5"}),React.createElement("span",{className:"path6"}),React.createElement("span",{className:"path7"}),React.createElement("span",{className:"path8"}),React.createElement("span",{className:"path9"}),React.createElement("span",{className:"path10"}))),React.createElement(_antd.Col,{ecId:_this3.props.ecId+"_Col@hq790o",span:18},item));})),(0,_isEmpty2.default)(tableData)&&React.createElement("div",{className:"align-center",style:{paddingTop:20,color:"#666",height:400}},getLabel(385596,"没有找到图标")),total>0&&React.createElement(_antd.Pagination,{ecId:this.props.ecId+"_Pagination@7uuax7",weaSimple:true,current:currentPage,pageSize:pageSize,total:total,onChange:function onChange(page){_this3.getData(page);_this3.setState({currentPage:page});}})))));}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _weaAssociativeSearch=__webpack_require__(139);var _weaAssociativeSearch2=_interopRequireDefault(_weaAssociativeSearch);var _weaBrowserSearch=__webpack_require__(302);var _weaBrowserSearch2=_interopRequireDefault(_weaBrowserSearch);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _weaFormItem=__webpack_require__(47);var _weaFormItem2=_interopRequireDefault(_weaFormItem);var _weaSelect=__webpack_require__(50);var _weaSelect2=_interopRequireDefault(_weaSelect);var _data3=__webpack_require__(301);var _data4=_interopRequireDefault(_data3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var doSort=function doSort(arr,key){var order=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;return arr.sort(function(a,b){if(a[key]<b[key]){return-order;}else if(a[key]>b[key]){return order;}return 0;});};var Main=function(_React$PureComponent){(0,_inherits3.default)(Main,_React$PureComponent);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.initialState=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};// this.props.form && this.props.form.resetFields();
var needSelect=_this.props.needSelect;if(needSelect==1){_this.fetchSelect(params);}else{_this.fetchData(params);}};_this.showModal=function(bool){_this.setState({visible:bool});if(bool){_this.props.onOpen&&_this.props.onOpen();}else{_this.props.onClose&&_this.props.onClose();}};_this.getSelectedId=function(){var str=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var isId=arguments[1];var replaceDatas=_this.props.replaceDatas;var _this$state=_this.state,separator=_this$state.separator,selectedId=_this$state.selectedId,selectList=_this$state.selectList;var index=str.indexOf(separator);var result=void 0;if(index!==-1){result=isId?str.substring(index).replace(separator,""):str.substring(0,index);}else{result=isId?"":str;}if(!isId){var selectedOption=void 0;(selectList||[]).forEach(function(option){if(selectedId){if(option.key===selectedId){selectedOption=option;}}else if(option.selected){selectedOption=option;}});if(selectedOption){var _str="("+selectedOption.showname+")";if(result.indexOf(_str)==-1){result=""+result+_str;}}}return result;};_this.onBrowerClick=function(v){_this.setState({browserConditions:[],inputValue:""},function(){_this.initialState();//初始化浏览框
_this.setState({inputValue:""});if(!(0,_isEmpty2.default)(v)){_this.setState({paramKeyCache:v[0].id,nameCache:v[0].showName||v[0].paramName||v[0].name,dataCache:v[0],selectedRowKeys:[v[0].id]});}else{_this.setState({name:"",nameCache:"",paramKey:"",paramKeyCache:"",dataCache:{},selectedRowKeys:[]});}});_this.showModal(true);};_this.onBrowerChangeHandler=function(paramKey,name,data){_this.throwCurrentState(paramKey,name,data);};_this.onSearchChange=function(v){_this.setState({inputValue:v});// TODO
};_this.topComponents=function(){var inputValue=_this.state.inputValue;return React.createElement(_weaBrowserSearch2.default,{searchType:["base"],searchsBaseValue:inputValue,onSearchChange:function onSearchChange(v){_this.setState({inputValue:v});},onSearch:_this.onSearchChange.bind(_this)});};_this.handleOk=function(){var _this$state2=_this.state,paramKeyCache=_this$state2.paramKeyCache,nameCache=_this$state2.nameCache,dataCache=_this$state2.dataCache;_this.setState({paramKey:paramKeyCache,name:nameCache,visible:false,url:"",selectedValue:"",contentType:""},function(){_this.throwCurrentState(paramKeyCache,nameCache,dataCache);});_this.showModal(false);};_this.handleCancel=function(){_this.setState({paramKeyCache:"",nameCache:"",dataCache:{},url:"",selectedValue:"",contentType:""});_this.showModal(false);};_this.handleClear=function(){_this.throwCurrentState("","","");_this.setState({selectedValue:"",paramKeyCache:"",nameCache:"",dataCache:{},url:"",contentType:"",selectedRowKeys:[]});_this.showModal(false);_this.refs.associativeSearch&&_this.refs.associativeSearch.forceClear();};_this.state={visible:false,loading:true,showDrop:false,paramKey:"",name:"",paramKeyCache:"",nameCache:"",dataCache:{},inputValue:"",count:0,quickSearch:"",noData:false,selectedRowKeys:[],selectedId:"",selectList:[],separator:"_@"};return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,value=_props.value,valueSpan=_props.valueSpan;var newState={};if(!(0,_isEmpty2.default)(value)&&valueSpan){newState=(0,_extends3.default)({},newState,{paramKey:value,name:valueSpan});}// 默认显示数据
if(!(0,_isEmpty2.default)(this.props.replaceDatas)&&this.props.replaceDatas[0]){var _data=this.props.replaceDatas[0];var name=_data.showName||_data.paramName||_data.name;var paramKey=_data.id?_data.id+"":"";var rowKeys=paramKey?[paramKey]:[];newState=(0,_extends3.default)({},newState,{paramKey:paramKey,name:name,selectedRowKeys:rowKeys,paramKeyCache:paramKey,nameCache:name,dataCache:this.props.replaceDatas&&_data});// this.throwCurrentState(paramKey, name);
}this.setState(newState);this.props.initFunc&&this.props.initFunc(this);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextState){if("value"in nextProps){if(nextProps.value){this.setState({paramKey:nextProps.value,name:nextProps.valueSpan,selectedRowKeys:[nextProps.value]});this.setState({paramKeyCache:nextProps.value,nameCache:nextProps.valueSpan,dataCache:nextProps.valueObj});}else{this.setState({paramKey:"",name:""});this.refs.associativeSearch&&this.refs.associativeSearch.forceClear();}}if("visible"in nextProps&&this.setState.visible!==nextProps.visible){//form value改变&&有值
this.setState({visible:nextProps.visible});}if("replaceDatas"in nextProps&&!(0,_isEqual2.default)(this.props.replaceDatas,nextProps.replaceDatas)&&!nextProps.replaceNotCtrl){var paramKey="",name="";if(!(0,_isEmpty2.default)(nextProps.replaceDatas)&&nextProps.replaceDatas[0]){var _data2=nextProps.replaceDatas[0];name=_data2.showName||_data2.paramName||_data2.name;paramKey=_data2.id?_data2.id+"":"";}else{this.refs.associativeSearch&&this.refs.associativeSearch.forceClear();}this.setState({paramKey:paramKey,name:name});this.setState({paramKeyCache:paramKey,nameCache:name,dataCache:nextProps.replaceDatas&&_data4.default});}}},{key:"fetchData",value:function fetchData(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _props2=this.props,dataURL=_props2.dataURL,dataParams=_props2.dataParams,needSelect=_props2.needSelect;// const {pageSize} = this.state;
var url=dataURL||"/api/integration/esb/service/returnsContextData";// param['min'] = 1;
// param['max'] = 1 * pageSize;
// param['pageSize'] = pageSize;
params=(0,_extends3.default)({},params,needSelect?dataParams:{});url=url+"?"+_weaTools2.default.getFd(params);this.setState({url:url});this.setLoading(true);_weaTools2.default.callApi(url).then(function(data){if(data&&data.length===0){_this2.setState({noData:true});}else{_this2.setState({noData:false});}// data = doSort(data, 'paramKey', -1);
data.reverse();var treeData=[];var defaultExpandedRowKeys=[];var toYesOrNo=function toYesOrNo(flag){return flag==="true"?getLabel("163","是"):getLabel("30587","否");};for(var index=0;index<data.length;index++){var element=data[index];element.arrs+="";element.required+="";element.arrs=toYesOrNo(element.arrs);element.required=toYesOrNo(element.required);// element.showName += `${selectedId ? `${separator}${selectedId}` : ''}`;
defaultExpandedRowKeys.push(element.id);if(element.parentName){for(var newIndex=index+1;newIndex<data.length;newIndex++){if(newIndex==data.length){break;}var newElement=data[newIndex];if(newElement.paramKey===element.parentName){if(!newElement.children||(0,_typeof3.default)(newElement.children)!=="object"){newElement.children=[];}newElement.children.unshift(element);break;}}}else{treeData.push(element);}}treeData.reverse();_this2.setLoading(false);_this2.setState({data:treeData,defaultExpandedRowKeys:defaultExpandedRowKeys});}).catch(function(e){return _this2.props.onError&&_this2.props.onError(e);});}},{key:"fetchSelect",value:function fetchSelect(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _props3=this.props,selectUrl=_props3.selectUrl,_props3$dataParams=_props3.dataParams,dataParams=_props3$dataParams===undefined?{}:_props3$dataParams,replaceDatas=_props3.replaceDatas;var selectedId=Array.isArray(replaceDatas)&&replaceDatas.length>0?replaceDatas[0].detail?replaceDatas[0].detail.selectedId:this.getSelectedId(replaceDatas[0].name,true):"";var url=selectUrl||"/api/integration/esb/publish/contextNodeOptions";_weaTools2.default.callApi(url+"?"+_weaTools2.default.getFd((0,_extends3.default)({},dataParams,{selectedId:selectedId}))).then(function(res){if(res&&res.data){var newState={selectList:res.data};var selectedOption=void 0;(res.data||[]).forEach(function(option){if(selectedId){if(option.key===selectedId){selectedOption=option;}}else if(option.selected){selectedOption=option;}});if(selectedOption){var _selectedOption=selectedOption,key=_selectedOption.key,currentArray=_selectedOption.currentArray,contextType=_selectedOption.contextType,supers=_selectedOption.supers;params=(0,_extends3.default)({},params,selectedOption.detail,{selectedId:key,currentArray:currentArray,contextType:contextType,supers:supers?(0,_stringify2.default)(supers):""});newState=(0,_extends3.default)({},newState,{selectedId:selectedOption.key});}_this3.setState(newState);}_this3.fetchData(params);});}},{key:"setLoading",value:function setLoading(bool){this.setState({loading:bool});}},{key:"throwCurrentState",value:function throwCurrentState(){var paramKey=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var name=arguments[1];var record=arguments[2];var data=[];var _state=this.state,separator=_state.separator,selectedId=_state.selectedId;var getName=function getName(str){return""+str+(selectedId?""+separator+selectedId:"");};name=name?getName(name):name;if(!Array.isArray(record)){record=[record];}if(paramKey||name){data.push({paramKey:paramKey.toString(),name:name});}this.props.onChange&&this.props.onChange(paramKey.toString(),name,record?record.map(function(value){return(0,_extends3.default)({},value,{showName:getName(value.showName||value.paramName||value.name)});}):data);}},{key:"onRowClick",value:function onRowClick(record,index){if(typeof this.props.onRowClick==="function"){this.props.onRowClick(record,index);}}},{key:"getColumns",value:function getColumns(){var defaultCol=[{title:getLabel("23481","参数名称"),dataIndex:"paramName",key:"paramName",width:"26%"},{title:getLabel("30828","显示名称"),dataIndex:"showName",key:"showName",width:"26%"},{title:getLabel("503477","参数类别"),dataIndex:"paramType",key:"paramType",width:"16%"},{title:getLabel("514006","必须"),dataIndex:"required",key:"required",width:"16%"},{title:getLabel("502118","明细数据"),dataIndex:"arrs",key:"arrs",width:"16%"}];return this.props.columns||defaultCol;}},{key:"renderSelect",value:function renderSelect(){var _this4=this;var _state2=this.state,selectedId=_state2.selectedId,selectList=_state2.selectList;return selectList&&selectList.length>0?React.createElement(_weaFormItem2.default,{label:getLabel("511491","上下文节点"),labelCol:{span:3},wrapperCol:{span:6},className:"wea-nodetree-select"},React.createElement(_weaSelect2.default,{options:selectList,value:selectedId,onChange:function onChange(v,showname){var select=selectList.find(function(item){return item.key===v;});_this4.setState({selectedId:v},function(){if(select){var currentArray=select.currentArray,contextType=select.contextType,supers=select.supers;_this4.fetchData((0,_extends3.default)({},select.detail,{selectedId:v,currentArray:currentArray,contextType:contextType,supers:supers?(0,_stringify2.default)(supers):""}));}});}})):null;}},{key:"renderData",value:function renderData(){var _this5=this;var _state3=this.state,data=_state3.data,selectedRowKeys=_state3.selectedRowKeys,defaultExpandedRowKeys=_state3.defaultExpandedRowKeys;var _props4=this.props,isArray=_props4.isArray,contextType=_props4.contextType,contentHeight=_props4.contentHeight;var isArrayStr=isArray+"";var toYesOrNo=function toYesOrNo(flag){return flag==="true"?getLabel("163","是"):getLabel("30587","否");};isArrayStr=toYesOrNo(isArrayStr);// let contextType;
// if (selectList && selectList.length) {
//   const current = selectList.find(option =>
//     selectedId ? option.key === selectedId : option.selected
//   );
//   if (current) {
//     contextType = current.contextType;
//   }
// }
var rowSelection={selectedRowKeys:selectedRowKeys,type:"radio",onChange:function onChange(sRowKeys,sRows){_this5.setState({selectedRowKeys:sRowKeys,paramKeyCache:sRows[0]?sRows[0].id:"",nameCache:sRows[0]?sRows[0].showName||sRows[0].paramName:"",dataCache:sRows[0]?sRows[0]:{}});if(typeof _this5.props.getSelection==="function"){_this5.props.getSelection(""+sRowKeys,sRows);}},getCheckboxProps:function getCheckboxProps(record){return{disabled:contextType==="1"?!record["check"]:record["arrs"]!==isArrayStr};}};return React.createElement("div",null,React.createElement(_antd.Table,{scroll:{y:(contentHeight||460)-44},rowSelection:rowSelection,columns:this.getColumns(),dataSource:data,defaultExpandedRowKeys:defaultExpandedRowKeys// checkType={'radio'}
,rowKey:function rowKey(record){return record.id;},onRowClick:this.onRowClick.bind(this),pagination:false}));}},{key:"render",value:function render(){var _props5=this.props,icon=_props5.icon,iconBgcolor=_props5.iconBgcolor,title=_props5.title,topPrefix=_props5.topPrefix,value=_props5.value,type=_props5.type,modalStyle=_props5.modalStyle,customized=_props5.customized,hasRadio=_props5.hasRadio,buttons=_props5.buttons,_props5$noScroll=_props5.noScroll,noScroll=_props5$noScroll===undefined?false:_props5$noScroll;var _state4=this.state,paramKey=_state4.paramKey,name=_state4.name,visible=_state4.visible,contentType=_state4.contentType,loading=_state4.loading;var quickSearch=this.state.quickSearch;var showTop=quickSearch;var titleEle=React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:"22",style:{paddingLeft:20,lineHeight:"48px"}},React.createElement("div",{className:"wea-browser-single-title"},iconBgcolor?React.createElement("div",{className:"wea-browser-single-icon-circle",style:{background:iconBgcolor}},React.createElement("i",{className:icon})):React.createElement("span",{style:{verticalAlign:"middle",marginRight:10}},React.createElement("i",{className:icon})),React.createElement("span",{style:{verticalAlign:"middle"}},title||getLabel(511490,"选择上下文数据")))));var inputArr=React.createElement("div",{className:"ant-search-custom"},React.createElement(_antd.Input,{style:null,key:"theInput",addonAfter:React.createElement("div",{style:{cursor:"pointer"}},React.createElement("i",{onClick:this.showModal.bind(this),className:"anticon anticon-search"})),value:typeof value==="undefined"?"":name}));if(!!type){inputArr=React.createElement(_weaAssociativeSearch2.default,(0,_extends3.default)({},this.props,{ref:"associativeSearch",style:this.props.inputStyle,type:type,value:value,ids:paramKey,names:this.getSelectedId(name,false),clickCallback:this.onBrowerClick,hasScroll:!noScroll,onChange:this.onBrowerChangeHandler}));}var dom=inputArr;var footer=buttons||[React.createElement(_antd.Button,{key:"submit",type:"primary",onClick:this.handleOk.bind(this)},getLabel(385565,"确 定")),React.createElement(_antd.Button,{key:"clear",type:"ghost",onClick:this.handleClear.bind(this)},getLabel(385566,"清 除")),React.createElement(_antd.Button,{key:"back",type:"ghost",onClick:this.handleCancel.bind(this)},getLabel(385567,"取 消"))];return React.createElement("div",null,dom,React.createElement("input",{type:"hidden",id:this.props.fieldName,name:this.props.fieldName,value:paramKey}),React.createElement(_antd.Modal,{wrapClassName:"wea-browser-single "+(showTop?"":"no-top")+" wea-browser-modal wea-browser-table-cursor wea-nodetree-modal",title:titleEle,zIndex:this.props.zIndex,width:modalStyle.width// style={modalStyle}
,maskClosable:false,visible:visible,onCancel:this.handleCancel.bind(this),footer:footer},React.createElement(_antd.Spin,{spinning:loading},React.createElement("div",{style:{minHeight:423}},this.renderSelect(),this.renderData()))));}}]);return Main;}(React.PureComponent);exports.default=Main;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _weaFormItem=__webpack_require__(47);var _weaFormItem2=_interopRequireDefault(_weaFormItem);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _uniq=__webpack_require__(65);var _uniq2=_interopRequireDefault(_uniq);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _findIndex=__webpack_require__(141);var _findIndex2=_interopRequireDefault(_findIndex);var _xor=__webpack_require__(351);var _xor2=_interopRequireDefault(_xor);var _weaInputSearch=__webpack_require__(46);var _weaInputSearch2=_interopRequireDefault(_weaInputSearch);var _weaSearchBrowserBox=__webpack_require__(88);var _weaSearchBrowserBox2=_interopRequireDefault(_weaSearchBrowserBox);var _weaAssociativeSearchMult=__webpack_require__(87);var _weaAssociativeSearchMult2=_interopRequireDefault(_weaAssociativeSearchMult);var _operation=__webpack_require__(303);var _operation2=_interopRequireDefault(_operation);var _weaBrowserMutiRight=__webpack_require__(304);var _weaBrowserMutiRight2=_interopRequireDefault(_weaBrowserMutiRight);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _WeaTableLeft=__webpack_require__(328);var _WeaTableLeft2=_interopRequireDefault(_WeaTableLeft);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _uniqBy=__webpack_require__(104);var _uniqBy2=_interopRequireDefault(_uniqBy);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _callApi=__webpack_require__(17);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var initialState={showSearchAd:false,count:0,visible:false,currentPage:1,inputValue:"",searchPara:{},checkStrictly:true,browserConditions:[],leftListSelectedKeys:[],leftListSelectedData:[],loadedModules:[],expandModules:[],selectedValue:null,displayType:"",loading:true};var Main=(_temp=_class=function(_React$PureComponent){(0,_inherits3.default)(Main,_React$PureComponent);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.goSearch=function(e){// const { tabs } = this.props;
// const quickSearch = this.state.quickSearch || 'name';
// e.preventDefault();
// let params = this.getFields();
// let url = this.getUrl(true);
// this.getData(url, 1, true, params); // 搜索获取数据
// this.setState({
//   url,
//   searchPara: params,
//   showSearchAd: false,
//   inputValue: params[quickSearch] || '',
// });
// if (params['date2during']) {
//   this.setState({ selectedValue: params['date2during'] });
// }
// this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
};_this.onCustomClick=function(e){e&&e.preventDefault();if(_this.props.onBeforeFocusCheck){var cb=_this.onCustomClickInner.bind(_this);_this.props.onBeforeFocusCheck(cb);}else{_this.onCustomClickInner(e);}};_this.onCustomClickInner=function(e){var memorise=_this.props.memorise;if(memorise){var _this$state=_this.state,searchKeys=_this$state.searchKeys,selectedData=_this$state.selectedData;_this.onBrowerClick(searchKeys,selectedData);}else{_this.onBrowerClick();}};_this.onBrowerClick=function(keys,selectedObj){_this.setState({inputValue:""},function(){var initData=[];if(_this.props.isEcCom){for(var key in window.ecCom){if(window.ecCom.hasOwnProperty(key)){var element=window.ecCom[key];initData.push({id:key,idspan:key,title:key,titlespan:key,obj:element});}}}else{var comType="";if(typeof _this.props.comType=="string"){comType=_this.props.comType;}if((0,_typeof3.default)(_this.props.comType)=="object"){comType=_this.props.comType.join(",");}var params={comtype:comType};(0,_callApi.callApi)("/api/system/componentmanage/queryComponentByComtype","GET",params).then(function(data){if(data.status){data.datas.forEach(function(element){initData.push({id:element.id,idspan:element.id,name:element.name,namespan:element.name,title:element.title,titlespan:element.title,obj:element,isDevModule:true,comtype:element.comType||""});});}_this.setState({loading:false,listDatas:initData});});// window.devModuleConfig.forEach(element => {
//   initData.push({
//     id: element.id,
//     idspan: element.id,
//     name: element.name,
//     namespan: element.name,
//     title: element.title,
//     titlespan: element.title,
//     obj: element,
//     isDevModule: true,
//     comType: element.comType || '',
//   })
// });
// if (this.props.comType) {
//   initData = initData.filter((e) => e.comType === this.props.comType)
// }
}_this.setState({inputId:"id",inputName:"name",inputTop:["title"],inputBottom:["name"]});});_this.showModal();};_this.moveTo=function(direction){var _this$state2=_this.state,rightDatas=_this$state2.rightDatas,rightCheckedKeys=_this$state2.rightCheckedKeys,listDatas=_this$state2.listDatas,inputId=_this$state2.inputId;var destUrl=_this.props.destUrl;var rds=[];if(direction==="right"){var leftListSelectedData=_this.state.leftListSelectedData;var datas=[];leftListSelectedData.map(function(d){var temp=(0,_extends3.default)({},d);temp.titlespan=temp.title;temp.namespan=temp.name;datas.push(temp);return d;});rds=rightDatas.concat(datas);_this.onCountChange(rds);_this.setState({rightDatas:rds,rightCheckedKeys:[],leftListSelectedData:[],leftListSelectedKeys:[]});}if(direction==="left"){rds=rightDatas.filter(function(item){return!rightCheckedKeys.some(function(checkedKey){return item[inputId]===checkedKey;});});_this.setState({rightDatas:rds,rightCheckedKeys:[]});_this.onCountChange(rds);}if(direction==="allToLeft"){_this.setState({rightDatas:[],rightCheckedKeys:[]});_this.onCountChange(rds);}// if (direction === 'allToRight') {
//   if (this.leftListAllActive()) {
//     let datas = listDatas.filter((d) => !d.isDevModule);
//     datas = datas.map((d) => { d.titlespan = d.title; return d; });
//     rds = rightDatas.concat(datas)
//     this.setState({
//       rightDatas: rds,
//       rightCheckedKeys: [],
//       leftListSelectedData: [],
//       leftListSelectedKeys: [],
//     })
//   }
//   this.onCountChange(rds);
// }
};_this.moveToLeft=function(){return _this.moveTo("left");};_this.moveToRight=function(){return _this.moveTo("right");};_this.moveAllToLeft=function(){return _this.moveTo("allToLeft");};_this.moveAllToRight=function(){return _this.moveTo("allToRight");};_this.doChangeEvent=function(v){// const { setFieldsValue } = this.props.form;
// let url = this.getUrl();
// let params = this.getFields();
// params.date2during = v;
// this.getData(url, 1, true, params);
// this.setState({ selectedValue: v });
// setFieldsValue({ date2during: v });
};var dataUrl=_this.props.dataUrl;_this.state={visible:null,initialShowSearchAd:false,showSearchAd:false,rightCheckedKeys:[],//右侧选择的keys
rightDatas:[],// 右侧展示的数据
leftListSelectedKeys:[],// 左侧table选择的keys
leftListSelectedData:[],// 左侧table选择的数据
selectedData:{},// 搜索按钮选中的数据
searchKeys:[],// 搜索按钮选择的keys
listDatas:[],currentPage:1,pageSize:props.pageSize||20,count:0,url:dataUrl,inputValue:"",searchPara:{},dataKey:"",noPgTableData:[],inputId:"",inputName:"",inputTop:[],inputBottom:[],browserConditions:[],displayType:"list",// list/tree
contentType:1,// 数据展示的类别
quickSearch:"",defaultExpandedKeys:[],hiddenIds:"",selectedValue:null,loading:true,dropmenuDatas:[],loadedModules:[],expandModules:[]};return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){// 默认显示数据
if(!(0,_isEmpty2.default)(this.props.replaceDatas)){this.replaceSearchValues(this.props.replaceDatas);}if(!(0,_isEmpty2.default)(this.props.valueObj)){this.replaceSearchValues(this.props.valueObj);}this.props.initFunc&&this.props.initFunc(this);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps&&(0,_isEmpty2.default)(nextProps.value)){this.setState({searchKeys:[],selectedData:{}});this.refs.associativeSearch&&this.refs.associativeSearch.clear();}if("replaceDatas"in nextProps&&!(0,_isEqual2.default)(this.props.replaceDatas,nextProps.replaceDatas)&&!nextProps.replaceNotCtrl){this.replaceSearchValues(nextProps.replaceDatas||[]);if((0,_isEmpty2.default)(nextProps.replaceDatas)){this.refs.associativeSearch&&this.refs.associativeSearch.clear();}}}},{key:"setLoading",value:function setLoading(bool){this.setState({loading:bool});}},{key:"closeModal",value:function closeModal(){this.setState({visible:false});}},{key:"openModal",value:function openModal(){this.onCustomClick();}},{key:"onSearchChange",value:function onSearchChange(v){// const quickSearch = this.state.quickSearch || 'name';
// const { setFieldsValue } = this.props.form;
// let params = this.getFields();
// params[quickSearch] = v;
// if (this.state.selectedValue) params['date2during'] = this.state.selectedValue;
// let url = this.getUrl(true);
// this.getData(url, 1, true, params); // 搜索获取数据
// setFieldsValue(params); // 高级搜索数据联动
// this.setState({
//   url,
//   inputValue: v,
//   showSearchAd: false,
//   searchPara: params,
// });
// this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
}},{key:"showModal",value:function showModal(){this.setState({visible:true});this.props.onOpen&&this.props.onOpen();}},{key:"reload",value:function reload(){this.onBrowerClick();}},{key:"get",value:function get(){var _state=this.state,rightDatas=_state.rightDatas,inputId=_state.inputId;var values=[];!(0,_isEmpty2.default)(rightDatas)&&rightDatas.forEach(function(d){values.push(d[inputId]||d.id);});return{id:values,datas:rightDatas};}},{key:"handleOk",value:function handleOk(){var _this2=this;var _state2=this.state,rightDatas=_state2.rightDatas,inputId=_state2.inputId,inputName=_state2.inputName,contentType=_state2.contentType;var maxLength=this.props.maxLength;var values=[];var selectedData={};if(!(0,_isEmpty2.default)(rightDatas)){if(maxLength&&maxLength<this.count(rightDatas,true)){window.alert("\u6240\u9009\u7684\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7"+maxLength+"!");return;}rightDatas.forEach(function(item){item.id=item[inputId]||item.id;item.name=item[inputName+"span"]||item[inputName];selectedData[item.id]=item;values.push(item.id);});}values=(0,_uniq2.default)(values);this.setState({selectedData:selectedData,visible:false,searchKeys:values},function(){_this2.throwCurrentState(values.join(","),_this2.formatThrowDatas(rightDatas));_this2.props.onClose&&_this2.props.onClose();_this2.setState(initialState);//初始化浏览框
_this2.refs.browserRight&&_this2.refs.browserRight.reset();});}},{key:"handleCancel",value:function handleCancel(){this.setState(initialState);//初始化浏览框
this.refs.browserRight&&this.refs.browserRight.reset();this.props.onCancel&&this.props.onCancel();this.props.onClose&&this.props.onClose();}},{key:"handleClear",value:function handleClear(){this.setState({visible:false,rightDatas:[],rightCheckedKeys:[],leftListSelectedKeys:[],leftListSelectedData:[],selectedData:{},searchKeys:[]});this.setState(initialState);//初始化浏览框
this.throwCurrentState("",[]);this.refs.browserRight&&this.refs.browserRight.reset();this.props.onClose&&this.props.onClose();this.refs.associativeSearch&&this.refs.associativeSearch.clear();}},{key:"set",value:function set(datas){this.replaceSearchValues(datas);}},{key:"replaceSearchValues",value:function replaceSearchValues(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var searchKeys=[],selectedData={},rd=[];datas.forEach(function(item){if(item){searchKeys.push(item.id);selectedData[item.id]=item;rd.push(item);}});this.setState({searchKeys:searchKeys,selectedData:selectedData,rightDatas:rd});var ids=(0,_uniq2.default)(searchKeys).join(",");this.setState({hiddenIds:ids});// this.throwCurrentState(searchKeys.join(','), datas);
}},{key:"formatThrowDatas",value:function formatThrowDatas(datas){var _state3=this.state,inputId=_state3.inputId,inputName=_state3.inputName;if(!(0,_isEmpty2.default)(datas)){datas.forEach(function(d){d.id=d[inputId]||d.id||"";d.name=d[inputName+"span"]||d[inputName]||d.name||"";});}return datas;}},{key:"onBrowerChangeHandler",value:function onBrowerChangeHandler(values,datas){this.setState({searchKeys:values,selectedData:datas});var throwDatas=[];if(!(0,_isEmpty2.default)(values)){values.forEach(function(v){throwDatas.push(datas[v]);});}this.throwCurrentState(values.join(","),this.formatThrowDatas(throwDatas));}},{key:"onBrowerChange",value:function onBrowerChange(values,datas){var needOnchange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var _props=this.props,destUrl=_props.destUrl,needCallDest=_props.needCallDest;var rd=[];values.forEach(function(v){return rd.push(datas[v]);});this.setState({searchKeys:values,selectedData:datas,rightDatas:rd});if(needOnchange)this.throwCurrentState(values.join(","),this.formatThrowDatas(datas));return;}},{key:"onRightDoubleClick",value:function onRightDoubleClick(key){var _state4=this.state,rightDatas=_state4.rightDatas,inputId=_state4.inputId;var newRightDatas=rightDatas.filter(function(item){return(item[inputId]||item.id)!==key;});this.onCountChange(newRightDatas);this.setState({rightDatas:newRightDatas,rightCheckedKeys:[]});}},{key:"onleftDoubleClick",value:function onleftDoubleClick(data){var rightDatas=this.state.rightDatas;var temp=[(0,_extends3.default)({},data[0])];temp[0].titlespan=temp[0].title;temp[0].namespan=temp[0].name;this.onCountChange(rightDatas.concat(temp));this.setState({rightDatas:rightDatas.concat(temp),rightCheckedKeys:[],leftListSelectedData:[],leftListSelectedKeys:[]});}},{key:"onCountChange",value:function onCountChange(rightData){var count=this.props.count;var result=this.count(rightData)||"";this.props.count&&this.props.count(result);}},{key:"count",value:function count(){var rightDatas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var rNum=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var inputId=this.state.inputId;var count=0;var ids=[];rightDatas.forEach(function(item){ids.push(item[inputId]);});count+=(0,_uniq2.default)(ids).length;if(rNum)return count;return count>0?"("+count+")":"";}},{key:"leftListAllActive",value:function leftListAllActive(){var _state5=this.state,rightDatas=_state5.rightDatas,listDatas=_state5.listDatas,inputId=_state5.inputId;var bool=true;if((0,_isEmpty2.default)(listDatas))bool=false;if(!(0,_isEmpty2.default)(listDatas)&&!(0,_isEmpty2.default)(rightDatas)){bool=listDatas.filter(function(l){return!rightDatas.some(function(r){return l[inputId]===r[inputId];});}).length!==0;}return bool;}},{key:"reset",value:function reset(){this.setState({inputValue:""});}},{key:"focus",value:function focus(){this.refs.associativeSearch.focus();}},{key:"render",value:function render(){var _this3=this;var _props2=this.props,bottomLeft=_props2.bottomLeft,buttons=_props2.buttons,icon=_props2.icon,iconBgcolor=_props2.iconBgcolor,title=_props2.title,fieldName=_props2.fieldName,contentHeight=_props2.contentHeight,modalStyle=_props2.modalStyle;var _props3=this.props,type=_props3.type,customized=_props3.customized;var _state6=this.state,loading=_state6.loading,visible=_state6.visible,listDatas=_state6.listDatas,inputValue=_state6.inputValue;var _state7=this.state,displayType=_state7.displayType,rightDatas=_state7.rightDatas,rightCheckedKeys=_state7.rightCheckedKeys,leftListSelectedKeys=_state7.leftListSelectedKeys,selectedData=_state7.selectedData,searchKeys=_state7.searchKeys;var _state8=this.state,inputId=_state8.inputId,inputName=_state8.inputName,inputTop=_state8.inputTop,inputBottom=_state8.inputBottom,contentType=_state8.contentType,hiddenIds=_state8.hiddenIds,expandModules=_state8.expandModules;searchKeys=(0,_uniq2.default)(searchKeys||[]);var titleEle=React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:"22",style:{paddingLeft:20,lineHeight:"48px"}},React.createElement("div",{className:"wea-hr-muti-input-title"},iconBgcolor?React.createElement("div",{className:"wea-workflow-radio-icon-circle",style:{background:iconBgcolor?iconBgcolor:""}},React.createElement("i",{className:icon})):React.createElement("span",{style:{verticalAlign:"middle",marginRight:10}},React.createElement("i",{className:icon})),React.createElement("span",{style:{verticalAlign:"middle"}},title))));var inputArr=React.createElement(_weaAssociativeSearchMult2.default,(0,_extends3.default)({},this.props,{ref:"associativeSearch",inputName:inputName,inputId:inputId,style:this.props.inputStyle,datas:selectedData,selectedValues:searchKeys,type:type,clickCallback:this.onBrowerClick,onChange:this.onBrowerChangeHandler.bind(this)}));var footerTemp=[];footerTemp.push(React.createElement(_antd.Button,{key:"submit",type:"primary",onClick:this.handleOk.bind(this),disabled:this.count(rightDatas,true)==0},getLabel(385565,"确 定"),this.count(rightDatas)));if(!this.props.browserModalProps||!this.props.browserModalProps.hideClear)footerTemp.push(React.createElement(_antd.Button,{key:"clear",type:"ghost",onClick:this.handleClear.bind(this)},getLabel(385566,"清 除")));footerTemp.push(React.createElement(_antd.Button,{key:"back",type:"ghost",onClick:this.handleCancel.bind(this)},getLabel(385567,"取 消")));var footer=buttons||footerTemp;if(bottomLeft)footer.unshift(React.createElement("div",{className:"ext-link",style:{float:"left",cursor:"pointer",paddingLeft:20}},(0,_isString2.default)(bottomLeft)?React.createElement("span",{dangerouslySetInnerHTML:{__html:bottomLeft}}):React.createElement("span",null,bottomLeft)));var leftAllActive=displayType==="list"&&this.leftListAllActive();var initHeight=contentHeight;if(window.setLayoutWindow){var maxH=$(window.setLayoutWindow.document.body).height()-220;if(window.setDialogFullWindow||initHeight>maxH){if((0,_isEmpty2.default)(this.props.tabs)){maxH+=50;}initHeight=maxH;}}var sheight=initHeight;var dom=inputArr;if(customized){dom=React.createElement("div",{className:"cursor-pointer",onClick:this.onCustomClick},this.props.children);}var rightActive=false;if(leftListSelectedKeys&&leftListSelectedKeys.length>0){rightActive=true;}return React.createElement("div",null,dom,this.props.extraElement,React.createElement("input",{type:"hidden",id:fieldName,name:fieldName,value:hiddenIds}),React.createElement(_antd.Modal,(0,_extends3.default)({wrapClassName:"wea-hr-muti-input wea-browser-muli wea-browser-modal",title:titleEle,zIndex:this.props.zIndex,width:modalStyle.width,maskClosable:false,visible:visible,onCancel:this.handleCancel.bind(this),footer:footer},this.props.browserModalProps),React.createElement(_antd.Spin,{spinning:loading},React.createElement("div",{style:{padding:10}},React.createElement("div",{className:"wea-hr-muti-input-left"},React.createElement(_antd.Row,{style:{height:"35px"}},React.createElement(_antd.Col,{span:"24"},React.createElement(_weaInputSearch2.default,{placeholder:"",value:inputValue,onSearchChange:function onSearchChange(v){_this3.setState({inputValue:v});},onSearch:this.onSearchChange.bind(this)}))),React.createElement("div",null,React.createElement(_weaNewScroll2.default,{height:sheight,ref:"weaSrcoll"},React.createElement(_WeaTableLeft2.default,{contentType:contentType,inputId:inputId,inputName:inputName,inputTop:inputTop,inputBottom:inputBottom,onDoubleClick:this.onleftDoubleClick.bind(this),onClick:this.onLeftListCheck.bind(this),selectedKeys:leftListSelectedKeys,filterData:rightDatas,datas:listDatas.filter(function(e){if(!e.isDevModule){if(expandModules.indexOf(e.parent)===-1){return false;}}return true;})})))),React.createElement("div",{className:"wea-transfer-opration"},React.createElement(_operation2.default,{rightActive:rightActive,leftActive:rightCheckedKeys&&rightCheckedKeys.length>0,leftAllActive:leftAllActive,rightAllActive:rightDatas&&rightDatas.length>0,moveToRight:this.moveToRight,moveToLeft:this.moveToLeft// moveAllToRight={this.moveAllToRight}
,moveAllToLeft:this.moveAllToLeft})),React.createElement("div",{className:"wea-hr-muti-input-right"},React.createElement(_weaBrowserMutiRight2.default,{ref:"browserRight",contentType:contentType,inputId:inputId,inputName:inputName,inputTop:inputTop,inputBottom:inputBottom,data:rightDatas,checkedCb:this.onRightCheck.bind(this),onDoubleClick:this.onRightDoubleClick.bind(this),checkedKeys:rightCheckedKeys,height:initHeight,onDrag:function onDrag(data){_this3.setState({rightDatas:data});}}))))));}},{key:"onLeftListCheck",value:function onLeftListCheck(keys,datas,data){var _this4=this;if(data.isDevModule){var _state9=this.state,listDatas=_state9.listDatas,loadedModules=_state9.loadedModules,expandModules=_state9.expandModules;if(loadedModules.indexOf(data.id)!==-1){var modules=(0,_xor2.default)(expandModules,[data.id]);this.setState({expandModules:modules});}else{var tableStr="└";var index=(0,_findIndex2.default)(listDatas,["id",data.id]);window.eventRegister&&window.eventRegister.register(data.id,{lib:data.obj.url.split(","),libName:data.name,fn:function fn(){return"success";}});window.eventRegister&&window.eventRegister.loadModule(data.id,function(){try{var coms=window[data.name].com;var comsData=[];var titleMap=window[data.name].titles||[];for(var key in coms){if(coms.hasOwnProperty(key)){var element=coms[key];comsData.push({id:listDatas[index].id+"-"+key,idspan:listDatas[index].id+"-"+key,name:""+key,namespan:"<span style=\"margin-left:15px;\">"+key+"</span>",title:""+(titleMap[key]||key),titlespan:"<div style=\"position:absolute;top:10px;left:0;\">"+tableStr+" </div><span style=\"margin-left:15px;\">"+(titleMap[key]||key)+"</span>",parent:data.id,parentName:data.name,obj:element});}}var tempList=[].concat((0,_toConsumableArray3.default)(listDatas));tempList.splice.apply(tempList,[index+1,0].concat(comsData));_this4.setState({listDatas:tempList,loadedModules:[].concat((0,_toConsumableArray3.default)(loadedModules),[data.id]),expandModules:[].concat((0,_toConsumableArray3.default)(expandModules),[data.id])});}catch(error){alert("加载模块文件失败");}},function(){alert("加载模块文件失败");});return;}}var _state10=this.state,leftListSelectedData=_state10.leftListSelectedData,inputId=_state10.inputId;var targets=leftListSelectedData.concat(datas);targets=(0,_uniqBy2.default)(targets,inputId||"id");targets=targets.filter(function(t){return keys.indexOf(t[inputId||"id"])>-1;});this.setState({leftListSelectedKeys:keys,leftListSelectedData:targets});}},{key:"onRightCheck",value:function onRightCheck(keys){this.setState({rightCheckedKeys:keys});}},{key:"throwCurrentState",value:function throwCurrentState(ids){var datas=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var _state11=this.state,inputName=_state11.inputName,inputId=_state11.inputId;ids=(0,_uniq2.default)(ids.split(",")).join(",");this.setState({hiddenIds:ids});var names=[];datas=(0,_uniqBy2.default)(datas,inputId||"id");datas.forEach(function(d){names.push(d[inputName+"span"]||d[inputName]||d.name);});names=(0,_uniq2.default)(names);this.props.onChange&&this.props.onChange(ids,names.join(","),datas);}},{key:"getSearchs",value:function getSearchs(){var _this5=this;var browserConditions=this.state.browserConditions;var items=[];!(0,_isEmpty2.default)(browserConditions)&&browserConditions.forEach(function(field){items.push({com:React.createElement(_weaFormItem2.default,{label:""+field.label,labelCol:{span:""+field.labelcol},wrapperCol:{span:""+field.fieldcol}},_weaTools2.default.getComponent(field.conditionType,field.browserConditionParam,field.domkey,_this5.props,field)),colSpan:1,hide:_weaTools2.default.isComponentHide(field)});});return React.createElement(_weaSearchBrowserBox2.default,{items:items});}}]);return Main;}(React.PureComponent),_class.Operation=_operation2.default,_class.defaultProps={mult:true,needCallDest:true,checkStrictly:true},_temp);var conditionParamsBK={};Main=_antd.Form.create({onFieldsChange:function onFieldsChange(props,fields){for(var key in fields){conditionParamsBK[fields[key].name]=fields[key].value;}}})(Main);exports.default=Main;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _weaFormItem=__webpack_require__(47);var _weaFormItem2=_interopRequireDefault(_weaFormItem);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _forEach=__webpack_require__(81);var _forEach2=_interopRequireDefault(_forEach);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _uniq=__webpack_require__(65);var _uniq2=_interopRequireDefault(_uniq);var _uniqBy=__webpack_require__(104);var _uniqBy2=_interopRequireDefault(_uniqBy);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _weaSearchBrowserBox=__webpack_require__(88);var _weaSearchBrowserBox2=_interopRequireDefault(_weaSearchBrowserBox);var _weaAssociativeSearchMult=__webpack_require__(87);var _weaAssociativeSearchMult2=_interopRequireDefault(_weaAssociativeSearchMult);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _thumbnail=__webpack_require__(705);var _thumbnail2=_interopRequireDefault(_thumbnail);var _weaSearchAdvance=__webpack_require__(195);var _weaSearchAdvance2=_interopRequireDefault(_weaSearchAdvance);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var initialState={showSearchAd:false,count:0,visible:false,currentPage:1,inputValue:"",searchPara:{},browserConditions:[],showSelected:false,thumbnails:[]};var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this2=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this2.goSearch=function(e){var tabs=_this2.props.tabs;var quickSearch=_this2.state.quickSearch||"name";var dataUrl=_this2.props.dataUrl;e.preventDefault();var validateFields=_this2.props.form.validateFields;var params={};validateFields(function(errors,object){if(!!errors){_antd.message.error("Errors in form!!!");return;}var newObject=(0,_cloneDeep2.default)((0,_extends3.default)({},object,conditionParamsBK));(0,_forEach2.default)(newObject,function(value,key){if(value)params[key]=value;});});if(!(0,_isEmpty2.default)(tabs)&&!(0,_isEmpty2.default)(tabs[0].dataParams)){params=(0,_extends3.default)({},params,tabs[0].dataParams);}_this2.getData(dataUrl,1,true,params);// 搜索获取数据
_this2.setState({url:dataUrl,searchPara:params,showSearchAd:false,inputValue:params[quickSearch]||""});};_this2.onCustomClick=function(e){e&&e.preventDefault();if(_this2.props.onBeforeFocusCheck){var cb=_this2.onCustomClickInner.bind(_this2);_this2.props.onBeforeFocusCheck(cb);}else{_this2.onCustomClickInner(e);}};_this2.onCustomClickInner=function(e){_this2.onBrowerClick();};_this2.onBrowerClick=function(keys,selectedObj){var _this2$props$form=_this2.props.form,resetFields=_this2$props$form.resetFields,setFieldsValue=_this2$props$form.setFieldsValue;resetFields();// 重置高级搜索
var _this2$props=_this2.props,tabs=_this2$props.tabs,dataUrl=_this2$props.dataUrl;var url=dataUrl;_this2.onBrowerChange(keys,selectedObj,false);var conditionURL=_this2.props.conditionURL;_weaTools2.default.callApi(conditionURL,"GET").then(function(data){var quickSearch=void 0;if(!(0,_isEmpty2.default)(data.conditions)){data.conditions.forEach(function(item){if(item.isQuickSearch){quickSearch=item.domkey[0];}});}var params=_weaTools2.default.getParamsByConditions(data.conditions);conditionParamsBK=params;setFieldsValue(params);_this2.browserConditionsBk=data.conditions;_this2.defaultConditionParams=(0,_extends3.default)({},params);_this2.setState({browserConditions:data.conditions,quickSearch:quickSearch,url:url,searchPara:params,inputValue:params[quickSearch]||""});_this2.getData(url,1,true,params);});_this2.showModal();};_this2.onAdvanceSearchEnter=function(e){var event=window.event||e;var target=event.target;var keyCode=event.keyCode||event.which||event.charCode;if(keyCode==13&&target&&target.nodeName=="INPUT"&&target.id){_this2.goSearch(e);}};_this2.state={visible:null,initialShowSearchAd:false,showSearchAd:false,isClearData:false,selectedData:{},// 搜索按钮选中的数据
currentPage:1,pageSize:20,count:0,url:props.dataUrl,inputValue:"",searchPara:{},dataKey:"",browserConditions:[],contentType:1,// 数据展示的类别
quickSearch:"",hiddenIds:"",thumbnails:[],ctrIds:[],//check id受控
ctrDatas:[],selectedValues:[],showSelected:false};return _this2;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){// 默认显示数据
if(!(0,_isEmpty2.default)(this.props.replaceDatas)){this.replaceSearchValues(this.props.replaceDatas);}if(!(0,_isEmpty2.default)(this.props.valueObj)){this.replaceSearchValues(this.props.valueObj);}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps&&this.props.value!==nextProps.value&&(0,_isEmpty2.default)(nextProps.value)){this.setState({isClearData:!this.state.isClearData});this.handleClear();}if("replaceDatas"in nextProps&&!(0,_isEqual2.default)(this.props.replaceDatas,nextProps.replaceDatas)){this.replaceSearchValues(nextProps.replaceDatas);}if("valueObj"in nextProps&&nextProps.valueObj){this.replaceSearchValues(nextProps.valueObj||[]);}}},{key:"formatData",value:function formatData(data){if(data){data.browser&&data.browser.forEach(function(b,idx){b.id=data.datas[idx].id;b.name=data.datas[idx].name;b.namespan=data.datas[idx].namespan;b.subcompanyid=data.datas[idx].subcompanyid;b.subcompanyidspan=data.datas[idx].subcompanyidspan;b.roomdesc=data.datas[idx].roomdesc;b.roomdescspan=data.datas[idx].roomdescspan;b.roomstatus=data.datas[idx].roomstatus;b.roomstatusspan=data.datas[idx].roomstatusspan;});}}},{key:"datakeyTodatas",value:function datakeyTodatas(newDataKey,newCurrent,min,max,cb){var _this3=this;var tableApiPrefix=this.props.tableApiPrefix;_weaTools2.default.callApi((tableApiPrefix||"")+"/api/ec/dev/table/datas","POST",{dataKey:newDataKey,pageSize:this.state.pageSize,min:min,max:max}).then(function(data){if(cb)cb();_this3.formatData(data);_this3.setState({thumbnails:data.browser});},function(e){}).catch(function(e){return _this3.props.onError&&_this3.props.onError(e);}),_weaTools2.default.callApi((tableApiPrefix||"")+"/api/ec/dev/table/counts","POST",{dataKey:newDataKey}).then(function(data){_this3.setState({count:data.count});},function(e){}).catch(function(e){return _this3.props.onError&&_this3.props.onError(e);});}},{key:"formatUrl",value:function formatUrl(url,params){if(url&&!(0,_isEmpty2.default)(params)){url=""+url+_weaTools2.default.getFd(params);}return url;}},{key:"getData",value:function getData(url,currentPage){var hasPagination=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var _this4=this;var searchPara=arguments[3];var cb=arguments[4];var _state=this.state,pageSize=_state.pageSize,count=_state.count;url=url||this.state.url;var params=searchPara||this.state.searchPara||{};params=(0,_extends3.default)({},params);currentPage=currentPage||this.state.currentPage;if(hasPagination){params["min"]=(currentPage-1)*pageSize+1;params["max"]=currentPage*pageSize;}if(params["max"]&&currentPage>1){if(params["max"]>count)params["max"]=count;}_weaTools2.default.callApi(this.formatUrl(url,params),"GET").then(function(data){if(data.type==1){//分页table
var dataKey=data.datas;_this4.setState({contentType:data.type// pageSize: data.pageSize || 20
},function(){_this4.datakeyTodatas(dataKey,currentPage,params["min"],params["max"],cb);});}}).catch(function(error){_antd.message.err(error);if(_this4.props.onError)_this4.props.onError(error);});}},{key:"onPageChange",value:function onPageChange(page){this.getData("",page,true);this.setState({currentPage:page});}},{key:"closeModal",value:function closeModal(){this.setState({visible:false});}},{key:"openModal",value:function openModal(){this.onCustomClick();}},{key:"onSearchChange",value:function onSearchChange(v){var tabs=this.props.tabs;var quickSearch=this.state.quickSearch||"name";var dataUrl=this.props.dataUrl;var setFieldsValue=this.props.form.setFieldsValue;var params={};params[quickSearch]=v;if(!(0,_isEmpty2.default)(tabs)&&!(0,_isEmpty2.default)(tabs[0].dataParams)){params=(0,_extends3.default)({},params,tabs[0].dataParams);}this.getData(dataUrl,1,true,params);// 搜索获取数据
setFieldsValue(params);// 高级搜索数据联动
this.setState({url:dataUrl,inputValue:v,showSearchAd:false,searchPara:params});}},{key:"showModal",value:function showModal(){this.setState({visible:true});}},{key:"setShowSearchAd",value:function setShowSearchAd(bool){var showSearchAd=this.state.showSearchAd;this.setState({showSearchAd:bool,initialShowSearchAd:true});}},{key:"onBrowerChange",value:function onBrowerChange(values,datas){var _this5=this;var needOnchange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var destUrl=this.props.destUrl;if(!(0,_isEmpty2.default)(values)){values=(0,_uniq2.default)(values);_weaTools2.default.callApi(destUrl+"selectids="+values.join(","),"GET").then(function(res){_this5.formatData(res);_this5.setState({ctrIds:values,ctrDatas:res.browser||[]});if(needOnchange)_this5.throwCurrentState(values.join(","),res.browser||[]);},function(e){});}else{this.setState({ctrIds:[],ctrDatas:[]});if(needOnchange)this.throwCurrentState("",[]);}}},{key:"handleOk",value:function handleOk(){var _state2=this.state,ctrIds=_state2.ctrIds,_state2$ctrDatas=_state2.ctrDatas,ctrDatas=_state2$ctrDatas===undefined?[]:_state2$ctrDatas;var selectedData={};ctrDatas.forEach(function(c){return selectedData[c.id]=c;});this.setState({selectedValues:[].concat((0,_toConsumableArray3.default)(ctrIds)),selectedData:selectedData,visible:false});this.throwCurrentState(ctrIds.join(","),ctrDatas);this.setState(initialState);//初始化浏览框
}},{key:"handleCancel",value:function handleCancel(){this.setState(initialState);//初始化浏览框
}},{key:"handleClear",value:function handleClear(){this.setState({visible:false,isClearData:!this.state.isClearData,selectedData:{},selectedValues:[]});this.setState(initialState);//初始化浏览框
this.throwCurrentState("",[]);}},{key:"replaceSearchValues",value:function replaceSearchValues(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var ids=[],selectedData={};datas.forEach(function(item){ids.push(item.id);selectedData[item.id]=item;});this.setState({selectedValues:ids,selectedData:selectedData});}},{key:"toArr",value:function toArr(values,datas){var arr=[];for(var i=0;i<values.length;i++){arr.push(datas[values[i]]);}return arr;}},{key:"onBrowerChangeHandler",value:function onBrowerChangeHandler(values,datas){var throwDatas=this.toArr(values,datas);this.setState({selectedObj:values,selectedValues:values,selectedData:datas});this.throwCurrentState(values.join(","),throwDatas);}},{key:"count",value:function count(){var ctrIds=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var rNum=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var count=0;count+=(0,_uniq2.default)(ctrIds).length;if(rNum)return count;return count>0?"("+count+")":"";}},{key:"thumbnailsOnCheck",value:function thumbnailsOnCheck(){var ids=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var datas=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var _state$ctrDatas=this.state.ctrDatas,ctrDatas=_state$ctrDatas===undefined?[]:_state$ctrDatas;Array.prototype.push.apply(ctrDatas,datas);ctrDatas=(0,_uniqBy2.default)(ctrDatas,"id");ctrDatas=ctrDatas.filter(function(c){return ids.indexOf(c.id)>-1;});this.setState({ctrIds:ids,ctrDatas:ctrDatas});}},{key:"render",value:function render(){var _this6=this;var _props=this.props,icon=_props.icon,iconBgcolor=_props.iconBgcolor,title=_props.title,browerType=_props.browerType,dataUrl=_props.dataUrl,min=_props.min,max=_props.max,fieldName=_props.fieldName,contentHeight=_props.contentHeight,modalStyle=_props.modalStyle;var _props2=this.props,id=_props2.id,name=_props2.name,style=_props2.style,isMult=_props2.isMult,disabled=_props2.disabled,value=_props2.value,type=_props2.type,mult=_props2.mult,ecId=_props2.ecId,customized=_props2.customized;var _state3=this.state,visible=_state3.visible,showSearchAd=_state3.showSearchAd,inputValue=_state3.inputValue,pageSize=_state3.pageSize,count=_state3.count,currentPage=_state3.currentPage;var _state4=this.state,displayType=_state4.displayType,selectedData=_state4.selectedData,ctrIds=_state4.ctrIds,ctrDatas=_state4.ctrDatas;var _state5=this.state,contentType=_state5.contentType,treeData=_state5.treeData,hiddenIds=_state5.hiddenIds;var state=this.state,props=this.props;var titleEle=React.createElement(_antd.Row,{ecId:ecId+"_Row@59y5bt"},React.createElement(_antd.Col,{ecId:ecId+"_Col@1fx05m",span:"8",style:{paddingLeft:20,lineHeight:"48px"}},React.createElement("div",{className:"wea-hr-muti-input-title"},iconBgcolor?React.createElement("div",{className:"wea-workflow-radio-icon-circle",style:{background:iconBgcolor?iconBgcolor:""}},React.createElement("i",{className:icon})):React.createElement("span",{style:{verticalAlign:"middle",marginRight:10}},React.createElement("i",{className:icon})),React.createElement("span",{style:{verticalAlign:"middle"}},title))));var inputArr=React.createElement(_weaAssociativeSearchMult2.default,(0,_extends3.default)({},this.props,{ecId:ecId+"_WeaAssociativeSearchMult@h0f70p",style:this.props.inputStyle,datas:state.selectedData,selectedValues:state.selectedValues,isClearData:state.isClearData,type:type,clickCallback:this.onBrowerClick,onChange:this.onBrowerChangeHandler.bind(this)}));var buttons=[React.createElement(_antd.Button,{ecId:ecId+"_Button@7dd88q",key:"submit",type:"primary",onClick:this.handleOk.bind(this),disabled:this.count(ctrIds,true)==0},getLabel(385565,"确 定"),this.count(ctrIds)),React.createElement(_antd.Button,{ecId:ecId+"_Button@b1x68o",key:"clear",type:"ghost",onClick:this.handleClear.bind(this)},getLabel(385566,"清 除")),React.createElement(_antd.Button,{ecId:ecId+"_Button@2kw3gt",key:"back",type:"ghost",onClick:this.handleCancel.bind(this)},getLabel(385567,"取 消"))];var searchsBox=this.getSearchs();var buttonsAd=this.getTabButtonsAd();var initHeight=contentHeight;var sheight=initHeight;if(contentType===1||contentType===4)sheight-=35;//显示分页
var dataKey=this.state.dataKey;var dom=inputArr;if(customized){dom=React.createElement("div",{className:"cursor-pointer",onClick:this.onCustomClick},this.props.children);}var browserPagination=React.createElement(_antd.Pagination,{ecId:ecId+"_Pagination@q8i0rw",weaSimple:true,showTotal:function showTotal(total){return getLabel(385617,"共$s条").replace(/\$s/,total);},total:count,pageSize:pageSize,current:currentPage,onChange:this.onPageChange.bind(this)});return React.createElement("div",null,dom,this.props.extraElement,React.createElement("input",{type:"hidden",id:fieldName,name:fieldName,value:hiddenIds}),React.createElement(_antd.Modal,{ecId:ecId+"_Modal@2pe6dc",wrapClassName:"wea-hr-muti-input wea-browser-thumbnails wea-browser-modal",title:titleEle,width:modalStyle.width,maskClosable:false,visible:visible,onCancel:this.handleCancel.bind(this),footer:buttons},React.createElement("div",{className:"wea-thumbnails"},React.createElement("span",null,React.createElement(_weaSearchAdvance2.default,{ecId:ecId+"_WeaSearchAdvance@r0o0ot",leftDom:React.createElement("span",{className:"wea-thumbnail-filter"},React.createElement(_antd.Checkbox,{ecId:ecId+"_Checkbox@ot6000",checked:this.state.showSelected,onChange:function onChange(){return _this6.setState({showSelected:!_this6.state.showSelected});}},getLabel(385596,"仅显示已选"))),buttonsAd:buttonsAd,searchType:["base","advanced"],searchsBaseValue:inputValue,searchsAd:React.createElement(_antd.Form,{ecId:ecId+"_Form@k04amu",horizontal:true},searchsBox),showSearchAd:showSearchAd,setShowSearchAd:function setShowSearchAd(bool){_this6.setShowSearchAd(bool);},onSearchChange:function onSearchChange(v){return _this6.setState({inputValue:v});},onSearch:this.onSearchChange.bind(this)})),React.createElement(_thumbnail2.default,(0,_extends3.default)({},this.props,{ecId:ecId+"_Thumbnail@4y2ifr",sheight:sheight,browser:!state.showSelected?state.thumbnails:state.ctrDatas,ctrIds:(0,_uniq2.default)(state.ctrIds),thumbnailsOnCheck:this.thumbnailsOnCheck.bind(this)})),!state.showSelected&&browserPagination)));}},{key:"throwCurrentState",value:function throwCurrentState(ids){var datas=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];ids=(0,_uniq2.default)(ids.split(",")).join(",");this.setState({hiddenIds:ids});var names=[];datas.forEach(function(d){names.push(d.name);});this.props.onChange&&this.props.onChange(ids,names.join(","),datas);}},{key:"getSearchs",value:function getSearchs(){var _this7=this;var browserConditions=this.state.browserConditions;var items=[];!(0,_isEmpty2.default)(browserConditions)&&browserConditions.forEach(function(field,index){items.push({com:React.createElement(_weaFormItem2.default,{ecId:_this7.props.ecId+"_WeaFormItem@8i0g5o@"+index,label:""+field.label,labelCol:{span:""+field.labelcol},wrapperCol:{span:""+field.fieldcol}},_weaTools2.default.getComponent(field.conditionType,field.browserConditionParam,field.domkey,_this7.props,field)),colSpan:2});});return React.createElement(_weaSearchBrowserBox2.default,{ecId:this.props.ecId+"_WeaSearchBrowserBox@ozsm8e",items:items,onKeyDown:this.onAdvanceSearchEnter});}},{key:"getTabButtonsAd",value:function getTabButtonsAd(){var _this8=this;var _this=this;var _props$form=this.props.form,resetFields=_props$form.resetFields,validateFields=_props$form.validateFields;return[React.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@ixt88c",type:"primary",onClick:function onClick(e){_this8.goSearch(e);}},getLabel(197,"搜索")),React.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@umci15",type:"ghost",onClick:function onClick(e){e.preventDefault();_this8.setState({inputValue:""});resetFields();}},getLabel(2022,"重置")),React.createElement(_antd.Button,{ecId:this.props.ecId+"_Button@2d68cu",type:"ghost",onClick:function onClick(){_this.setState({showSearchAd:false});}},getLabel(31129,"取消"))];}}]);return Main;}(React.Component),_class.defaultProps={mult:true},_temp);var conditionParamsBK={};Main=_antd.Form.create({onFieldsChange:function onFieldsChange(props,fields){for(var key in fields){conditionParamsBK[fields[key].name]=fields[key].value;}}})(Main);exports.default=Main;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Wrapper=exports.showImage=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(38);var _reactDom2=_interopRequireDefault(_reactDom);__webpack_require__(706);var _Position=__webpack_require__(707);var _Position2=_interopRequireDefault(_Position);var _Control=__webpack_require__(709);var _Control2=_interopRequireDefault(_Control);var _Image=__webpack_require__(711);var _Image2=_interopRequireDefault(_Image);var _Background=__webpack_require__(713);var _Background2=_interopRequireDefault(_Background);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _utils=__webpack_require__(108);var _loadCss=__webpack_require__(83);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// Components
var Wrapper=function(_React$Component){(0,_inherits3.default)(Wrapper,_React$Component);function Wrapper(props){(0,_classCallCheck3.default)(this,Wrapper);var _this=(0,_possibleConstructorReturn3.default)(this,(Wrapper.__proto__||(0,_getPrototypeOf2.default)(Wrapper)).call(this,props));_this.mountSelf=function(){var coverNodeRef=_this.props.coverNodeRef;// 隐藏封面原图
// if (coverNodeRef) coverNodeRef.style.visibility = 'hidden'
// 显示并绑定事件
_this.setState({show:true},function(){(0,_utils.addListenEventOf)('keydown',_this.handleKeyDown);(0,_utils.addListenEventOf)('wheel',_this.handleWheelScroll);});};_this.unmountSelf=function(){var coverNodeRef=_this.props.coverNodeRef;var page=_this.state.page;// 显示封面原图（当前不为第一页时，遮罩从上方移除会迅速露出，需要立即显示，否则交由图片层处理）
if(coverNodeRef&&page!==0)coverNodeRef.style.visibility='visible';_this.setState({show:false});};_this.handleKeyDown=function(e){// 阻止默认事件
e.preventDefault();var imageSet=_this.props.imageSet;var zoom=_this.state.zoom;var hasImageSet=imageSet&&imageSet.constructor===Array;var toPrevPage=_this.handleSwitchPages("prev");var toNextPage=_this.handleSwitchPages("next");switch(e.key){case"ArrowLeft":// 上一张
!zoom&&toPrevPage();break;case"ArrowRight":// 下一张
!zoom&&hasImageSet&&toNextPage();break;case" ":// 缩放
_this.handleToggleZoom();break;case"Escape":// 退出
zoom?_this.handleToggleZoom():_this.unmountSelf();break;default:return;}};_this.handleWheelScroll=function(e){_this.state.show&&_this.unmountSelf();};_this.handleSwitchPages=function(direction){return function(){var imageSet=_this.props.imageSet;var page=_this.state.page;_this.setState({page:direction==="prev"?Math.abs(imageSet.length+page-1)%imageSet.length:(page+1)%imageSet.length});};};_this.handleToggleZoom=function(){_this.setState({zoom:!_this.state.zoom});};_this.state={// 显示
show:false,// 缩放
zoom:false,// 当前页数
page:props.page||0};return _this;}(0,_createClass3.default)(Wrapper,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.page!=nextProps.page){this.setState({page:nextProps.page});}}},{key:'componentWillMount',value:function componentWillMount(){// 延迟 100 毫秒加载自己，保证动画正常
setTimeout(this.mountSelf,50);}},{key:'componentWillUnmount',value:function componentWillUnmount(){(0,_utils.removeListenEventOf)('keydown',this.handleKeyDown);(0,_utils.removeListenEventOf)('wheel',this.handleWheelScroll);}/**
   * 加载器
   **//**
   * 事件处理
   **//**
   * 翻页控制
   **//**
   * 缩放控制
   **/},{key:'render',value:function render(){var _props=this.props,coverNodeRef=_props.coverNodeRef,imageSet=_props.imageSet,remove=_props.remove;var _state=this.state,show=_state.show,zoom=_state.zoom,page=_state.page;return _react2.default.createElement('div',{className:'wrapperLayer'},_react2.default.createElement(_Control2.default,{show:show,zoom:zoom,page:page,imageSet:imageSet,unmountSelf:this.unmountSelf,toggleZoom:this.handleToggleZoom,switchPages:this.handleSwitchPages}),_react2.default.createElement(_Position2.default,{show:show,zoom:zoom,page:page,imageSet:imageSet,coverNodeRef:coverNodeRef},_react2.default.createElement(_Image2.default,{show:show,zoom:zoom,page:page,imageSet:imageSet,coverNodeRef:coverNodeRef,remove:remove})),_react2.default.createElement(_Background2.default,{show:show,unmountSelf:this.unmountSelf,toggleZoom:this.handleToggleZoom}));}}]);return Wrapper;}(_react2.default.Component);// 主动调用显示，插入控件到指定节点（Body末端）
// Style
/**
 * 包裹层
 * 储存主要状态，组织架构
 **/// React Libs
var showImage=function showImage(_ref){var id=_ref.id,lazyLoad=_ref.lazyLoad,indicator=_ref.indicator,imageSet=_ref.imageSet,page=_ref.page;// 封面节点
var coverNodeRef=document.getElementById(id);// 容器节点
var wrapperNodeId='zmage-wrapper';var previousOverlayNode=document.getElementById(wrapperNodeId);previousOverlayNode&&previousOverlayNode.remove();var wrapperNode=document.createElement('div');wrapperNode.id=wrapperNodeId;_window2.default.getTop().document.body.appendChild(wrapperNode);(0,_loadCss.loadCss)();var wrapperNodeRef=document.getElementById(wrapperNodeId);//移除函数
var remove=function remove(){_reactDom2.default.unmountComponentAtNode(wrapperNodeRef);if((0,_isFunction2.default)(wrapperNodeRef.remove)){wrapperNodeRef.remove();}// IE下处理
if((0,_isFunction2.default)(wrapperNodeRef.removeNode)){wrapperNodeRef.removeNode(true);}};// 插入容器节点
wrapperNodeRef&&_reactDom2.default.render(_react2.default.createElement(Wrapper,{coverNodeRef:coverNodeRef,lazyLoad:lazyLoad,indicator:indicator,imageSet:imageSet,remove:remove,page:page}),wrapperNodeRef);// 对于函数调用模式，返回容器节点引用, 调用 remove() 即可移除（无动画）
return{node:wrapperNodeRef,remove:remove};};exports.showImage=showImage;exports.Wrapper=Wrapper;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _weaScroll=__webpack_require__(101);var _weaScroll2=_interopRequireDefault(_weaScroll);var _weaSelect=__webpack_require__(50);var _weaSelect2=_interopRequireDefault(_weaSelect);var _weaBrowser=__webpack_require__(80);var _weaBrowser2=_interopRequireDefault(_weaBrowser);var _weaScope=__webpack_require__(136);var _weaScope2=_interopRequireDefault(_weaScope);var _weaSelectGroup=__webpack_require__(137);var _weaSelectGroup2=_interopRequireDefault(_weaSelectGroup);var _weaAssociativeSearchMult=__webpack_require__(87);var _weaAssociativeSearchMult2=_interopRequireDefault(_weaAssociativeSearchMult);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _forEach=__webpack_require__(81);var _forEach2=_interopRequireDefault(_forEach);var _objectAssign=__webpack_require__(99);var _objectAssign2=_interopRequireDefault(_objectAssign);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Row from '../../../_antd1.11.2/Row';
// import Col from '../../../_antd1.11.2/Col';
// import Modal from '../../../_antd1.11.2/Modal';
// import Button from '../../../_antd1.11.2/Button';
// import Icon from '../../../_antd1.11.2/Icon';
// import message from '../../../_antd1.11.2/message'
// import Table from '../../../_antd1.11.2/table';
// import Dropdown from '../../../_antd1.11.2/dropdown';
// import Menu from '../../../_antd1.11.2/menu';
// import Form from '../../../_antd1.11.2/form';
//import {Row,Col,Modal,Button,Icon,message,Table,Dropdown,Menu,Form} from 'antd'
//import {WeaTools,WeaScroll,WeaSelect,WeaBrowser,WeaScope,WeaSelectGroup,WeaAssociativeSearch} from 'ecCom'
var MenuItem=_antd.Menu.Item;var FormItem=_antd.Form.Item;var getLabel=_weaLocaleProvider2.default.getLabel;//国际化 zxt- 20170419
var defaultLocale={total:"共",totalUnit:"条",operates:"操作",delete:"删除",customColSave:"保存",customColCancel:"取消",isShowSecLevel:true};var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);(0,_createClass3.default)(Main,[{key:"getLocale",value:function getLocale(){var locale={};if(this.context.antLocale&&this.context.antLocale.Table){locale=this.context.antLocale.WeaTable;}return(0,_extends3.default)({},defaultLocale,locale,this.props.locale);}//国际化 zxt- 20170419
}]);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.initConditions=function(){var conditionURL=_this.props.conditionURL;_weaTools2.default.callApi(conditionURL).then(function(datas){var conditions=datas.conditions;_this.setState({conditions:conditions});});};_this.doChangeSelectLinkage=function(index,domkey,args,selectlinkIndex){var conditions=_this.state.conditions;var resultCon=[].concat((0,_toConsumableArray3.default)(conditions));if(resultCon&&resultCon[1]&&resultCon[1][index]){resultCon[1][index].forEach(function(condition){if(condition.domkey===domkey&&condition.selectLinkageDatas&&condition.selectLinkageDatas[selectlinkIndex]){var select=condition.selectLinkageDatas[selectlinkIndex];if(select.browserConditionParam){select.browserConditionParam=(0,_extends3.default)({},select.browserConditionParam,{replaceDatas:args});}}});_this.setState({conditions:resultCon});}};_this.state={conditions:[],labels:{},//table
columns:[],datas:_this.addKeytoDatas(props.replaceDatas)||[],selectedRowKeys:[],pageSize:10,//select
selectDatas:{},//modal
visible:false,_visible:false,addData:{},addDataInit:{},seclevelMin:0,seclevelMax:100};_this.onBrowerChange=_this.onBrowerChange.bind(_this);_this.onBrowerClick=_this.onBrowerClick.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onClear=_this.onClear.bind(_this);_this._onOk=_this._onOk.bind(_this);_this._onCancel=_this._onCancel.bind(_this);_this.doAdd=_this.doAdd.bind(_this);_this.getSelectDatas=_this.getSelectDatas.bind(_this);return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var _props$replaceDatas=this.props.replaceDatas,replaceDatas=_props$replaceDatas===undefined?[]:_props$replaceDatas;//this.getDates();
var _props$conditionURL=this.props.conditionURL,conditionURL=_props$conditionURL===undefined?"":_props$conditionURL;//初始化数据
_weaTools2.default.callApi(conditionURL).then(function(datas){var conditions=datas.conditions,columns=datas.columns,labels=datas.labels;var addData={sharetype:conditions[0].options[0].key,sharetypespan:conditions[0].options[0].showname};_this2.setState({conditions:conditions,columns:columns,labels:labels,addData:addData,addDataInit:addData});var _datas=_this2.addKeytoDatas(replaceDatas);_this2.setState({datas:_datas,selectDatas:_this2.getSelectDatas(_datas)});});}//初始化数据Conditons
},{key:"render",value:function render(){var _props=this.props,_props$inputStyle=_props.inputStyle,inputStyle=_props$inputStyle===undefined?{}:_props$inputStyle,_props$type=_props.type,type=_props$type===undefined?"141":_props$type,_props$modalStyle=_props.modalStyle,modalStyle=_props$modalStyle===undefined?{}:_props$modalStyle;var _state=this.state,datas=_state.datas,selectDatas=_state.selectDatas,visible=_state.visible,_visible=_state._visible,selectedRowKeys=_state.selectedRowKeys;var buttons=[React.createElement(_antd.Button,{key:"submit",type:"primary",onClick:this.onOk,disabled:false},getLabel(385565,"确 定")),React.createElement(_antd.Button,{key:"clear",type:"ghost",onClick:this.onClear},getLabel(385566,"清 除")),React.createElement(_antd.Button,{key:"back",type:"ghost",onClick:this.onCancel},getLabel(385567,"取 消"))];var _buttons=[React.createElement(_antd.Button,{key:"submit",type:"primary",onClick:this._onOk},getLabel(385597,"保 存")),React.createElement(_antd.Button,{key:"back",type:"ghost",onClick:this._onCancel},getLabel(385567,"取 消"))];return React.createElement("div",{className:"wea-hrm-condition"},React.createElement(_weaAssociativeSearchMult2.default,(0,_extends3.default)({},this.props,{style:inputStyle,datas:selectDatas,selectedValues:this.getSelectKeys(),isClearData:(0,_stringify2.default)(selectDatas)==="{}",type:type,clickCallback:this.onBrowerClick,onChange:this.onBrowerChange})),React.createElement(_antd.Modal,{wrapClassName:"wea-hr-muti-input",title:this.getTitle(),width:modalStyle.width,maskClosable:false,visible:visible,onCancel:this.onCancel,footer:buttons},React.createElement("div",{className:"wea-table-edit wea-hrm-condition-table",style:{height:460}},React.createElement(_antd.Row,{className:"wea-table-edit-title"},React.createElement(_antd.Col,null,getLabel(385598,"已添加条件"),React.createElement(_antd.Button,{type:"primary",disabled:!(""+selectedRowKeys),title:getLabel(91,"删除"),size:"small",onClick:this.doDelete.bind(this,selectedRowKeys)},React.createElement(_antd.Icon,{type:"minus"})),React.createElement(_antd.Button,{type:"primary",title:getLabel(1421,"新增"),size:"small",onClick:this.doAdd},React.createElement(_antd.Icon,{type:"plus"})))),React.createElement(_antd.Table,{columns:this.getColumns(),dataSource:datas,pagination:this.getPagination(),rowSelection:this.getRowSelection(),scroll:{y:372}})),React.createElement(_antd.Modal,{wrapClassName:"wea-hr-muti-input",title:this.getTitle(true),width:modalStyle.width*0.6,maskClosable:false,visible:_visible,onCancel:this._onCancel,footer:_buttons},this.getAddComponent())));}//添加条件
},{key:"doAddComponentChange",value:function doAddComponentChange(type,key,value,list,url){var _state2=this.state,addData=_state2.addData,conditions=_state2.conditions;var _addData=key==="sharetype"?this.shareTypeChangeGetInitData(value):(0,_objectAssign2.default)({},addData);var _value=value==undefined?"":value;if(type==="BROWSER"){_addData[key]=_value;_addData[key+"data"]=list;_addData[key+"url"]=url;// if (/=$/.test(url)) {
//   _addData[`${key}url`] = url + _addData.relatedshare;
// }
}else if(type==="SELECT"){_addData[key]=_value;list.map(function(l){if(l.key===_value){_addData[key+"span"]=l.showname;if(url)_addData[key+"url"]=""+url+_value;}});}else if(type==="INPUT_INTERVAL"){_addData[key][0]=_value;_addData[key][1]=list==undefined?"":list;}this.setState({addData:_addData});}// SELECT_LINKAGE受控处理
},{key:"shareTypeChangeGetInitData",value:function shareTypeChangeGetInitData(sharetype){var _state3=this.state,seclevelMin=_state3.seclevelMin,seclevelMax=_state3.seclevelMax,conditions=_state3.conditions;var _addData={};if(sharetype==="2"){_addData.seclevel=[seclevelMin,seclevelMax];}else if(sharetype==="3"){_addData.seclevel=[seclevelMin,seclevelMax];}else if(sharetype==="4"){_addData.seclevel=[seclevelMin,seclevelMax];var option0=conditions[1][sharetype][1].options[0];_addData.rolelevel=option0.key;_addData.rolelevelspan=option0.showname;}else if(sharetype==="5"){_addData.seclevel=[seclevelMin,seclevelMax];}else if(sharetype==="6"){var _option=conditions[1][sharetype][1].options.filter(function(o){return o.selected;});_addData.joblevel=_option[0].key;_addData.joblevelspan=_option[0].showname;}return _addData;}},{key:"getAddComponent",value:function getAddComponent(){var _this3=this;var _state4=this.state,conditions=_state4.conditions,addData=_state4.addData,seclevelMin=_state4.seclevelMin,seclevelMax=_state4.seclevelMax;if(!(""+conditions))return null;var index=addData.sharetype;return React.createElement("div",{style:{padding:20}},React.createElement(FormItem,{label:conditions[0].label,labelCol:{span:conditions[0].labelcol},wrapperCol:{span:conditions[0].fieldcol}},React.createElement(_weaSelect2.default,{value:index,onChange:function onChange(v){return _this3.doAddComponentChange("SELECT",conditions[0].domkey[0],v,conditions[0].options);},options:conditions[0].options})),conditions[1][index].map(function(condition){var showDropMenu=false;var replaceDatas=[];var startValue=seclevelMin;var endValue=seclevelMax;if(condition.conditionType==="BROWSER"){if(condition.browserConditionParam)showDropMenu=condition.browserConditionParam.type=="4"||condition.browserConditionParam.type=="164";//部门分部显示维度菜单
replaceDatas=addData[condition.domkey[0]+"data"]||[];}if(condition.conditionType==="INPUT_INTERVAL"&&addData[condition.domkey[0]]){var value=addData[condition.domkey[0]];startValue=Number(value[0]);endValue=Number(value[1]);}return React.createElement(FormItem,{label:condition.label,labelCol:{span:condition.labelcol},wrapperCol:{span:condition.fieldcol}},condition.conditionType==="SELECT"&&React.createElement(_weaSelect2.default,{value:addData[condition.domkey[0]]||"1",onChange:function onChange(v){return _this3.doAddComponentChange("SELECT",condition.domkey[0],v,condition.options);},options:condition.options}),condition.conditionType==="BROWSER"&&React.createElement(_weaBrowser2.default,(0,_extends3.default)({},condition.browserConditionParam,{viewAttr:3,replaceDatas:replaceDatas,showDropMenu:showDropMenu,onChange:function onChange(v,name,list){return _this3.doAddComponentChange("BROWSER",condition.domkey[0],v,list,condition.browserConditionParam.linkUrl);}})),condition.conditionType==="INPUT_INTERVAL"&&React.createElement(_weaScope2.default,(0,_extends3.default)({min:[seclevelMin,seclevelMax],max:[seclevelMin,seclevelMax]},condition,condition.otherParams,{domkey:condition.domkey,startValue:startValue,endValue:endValue,onChange:function onChange(start,end){return _this3.doAddComponentChange("INPUT_INTERVAL",condition.domkey[0],start,end);}})),condition.conditionType==="SELECT_LINKAGE"&&React.createElement(_weaSelectGroup2.default,{domkey:condition.domkey,options:condition.options,selectLinkageDatas:condition.selectLinkageDatas,onChange:function onChange(v,b,args){_this3.doAddComponentChange("SELECT",condition.domkey[0],v,condition.options);if(b&&b.length&&b.length>0&&args&&condition.domkey){_this3.doAddComponentChange("BROWSER",condition.domkey[1],b,args[2],condition.selectLinkageDatas[v].browserConditionParam.linkUrl);_this3.doChangeSelectLinkage(index,condition.domkey,args[2],v);}}}));}));}//util
},{key:"getDates",value:function getDates(){var _this4=this;var _props$conditionURL2=this.props.conditionURL,conditionURL=_props$conditionURL2===undefined?"":_props$conditionURL2;_weaTools2.default.callApi(conditionURL).then(function(datas){var conditions=datas.conditions,columns=datas.columns,labels=datas.labels;var addData={sharetype:conditions[0].options[0].key,sharetypespan:conditions[0].options[0].showname};_this4.setState({conditions:conditions,columns:columns,labels:labels,addData:addData,addDataInit:addData});}).catch(function(e){return _this4.props.onError&&_this4.props.onError(e);});}},{key:"addKeytoDatas",value:function addKeytoDatas(datas){var _datas=datas&&datas.map(function(data,i){var _data=(0,_extends3.default)({},data);_data.key=i;return _data;});return _datas||[];}},{key:"getSelectDatas",value:function getSelectDatas(datas){var labels=this.state.labels;var isShowSecLevel=this.props.isShowSecLevel;var selectDatas={};datas.map(function(data){var key=data.key,sharetype=data.sharetype,sharetypespan=data.sharetypespan,relatedshare=data.relatedshare,relatedsharespan=data.relatedsharespan,relatedshareurl=data.relatedshareurl,rolelevel=data.rolelevel,rolelevelspan=data.rolelevelspan,rolelevelurl=data.rolelevelurl,joblevel=data.joblevel,joblevelspan=data.joblevelspan,joblevelurl=data.joblevelurl,jobfield=data.jobfield,jobfieldspan=data.jobfieldspan,jobfieldurl=data.jobfieldurl,seclevel=data.seclevel,seclevelspan=data.seclevelspan;var name="";if(sharetype!=="1"&&/=$/.test(relatedshareurl)){relatedshareurl=""+relatedshareurl+relatedshare;}var _relatedsharespan=relatedshareurl?sharetype==="1"?"<span class='condition-item-a' onClick='window.resourceConditionOpenHrm("+relatedshare+")'>"+relatedsharespan+"</span>":"<span class='condition-item-a' onClick=\"window.resourceConditionOpenTab('"+relatedshareurl+"')\" >"+relatedsharespan+"</span>":relatedsharespan;if(relatedshare!==undefined){name="<span>"+sharetypespan+"("+_relatedsharespan+")</span>";}if(rolelevel!==undefined){var _rolelevel=rolelevelurl?"<span class='condition-item-a' onClick=\"window.resourceConditionOpenTab('"+rolelevelurl+"')\" >"+(labels.rolelevelprefix||"")+rolelevelspan+"</span> ":""+(labels.rolelevelprefix||"")+rolelevelspan;name="<span>"+sharetypespan+"("+_relatedsharespan+")"+_rolelevel+"&nbsp;</span>";}if(joblevel!==undefined){var _jobfield="";var _jobfieldspan="";if(jobfield!==undefined){_jobfield=jobfield.split(",");_jobfieldspan=jobfieldspan.split(",");}var _jobfieldhtml="";if(jobfield!==undefined){_jobfieldhtml+="<span>(";_jobfield.map(function(_jobf,i){if(i>0){_jobfieldhtml+="&nbsp;&nbsp;";}if(jobfieldurl){_jobfieldhtml+="<span class='condition-item-a' onClick=\"window.resourceConditionOpenTab('"+(jobfieldurl+_jobf)+"')\" >"+_jobfieldspan[i]+"</span>";}else{_jobfieldhtml+=_jobfieldspan[i];}});_jobfieldhtml+=")</span>";}name="<span>"+sharetypespan+"("+_relatedsharespan+"/"+joblevelspan+_jobfieldhtml+")</span>";}var _seclevel="";if(seclevel!==undefined&&isShowSecLevel!=false){_seclevel=labels["seclevellabel"+sharetype]?labels["seclevellabel"+sharetype].replace("{$level$}",seclevel):seclevel;}if(sharetype==="5"){name="";if(isShowSecLevel==false){name=sharetypespan;}}selectDatas[key]={id:key,name:"<span>"+name+_seclevel+"</span>"};});return selectDatas;}//select
},{key:"getSelectKeys",value:function getSelectKeys(){var _state$selectDatas=this.state.selectDatas,selectDatas=_state$selectDatas===undefined?{}:_state$selectDatas;var selectKeys=[];(0,_forEach2.default)(selectDatas,function(value,key){selectKeys.push(key);});return selectKeys;}},{key:"onBrowerClick",value:function onBrowerClick(){this.setState({visible:true});var datas=this.state.datas;if(datas&&datas.length===0){this.doAdd();}}},{key:"onBrowerChange",value:function onBrowerChange(values,selectDatas){var _this5=this;try{var datas=this.state.datas;var _datas=datas.filter(function(data){return _this5.arrContains(values,data.key);});this.setState({datas:_datas,selectDatas:selectDatas});this.props.onChange("","",_datas);}catch(e){}}//table
},{key:"getColumns",value:function getColumns(){var _this6=this;var _state5=this.state,columns=_state5.columns,conditions=_state5.conditions;var _columns=[].concat(columns);_columns=_columns.map(function(col){col.width=col.oldWidth;var _col=(0,_extends3.default)({},col);if(_col.dataIndex==="sharetype"){_col.render=function(text,record,index){return record.sharetypespan;};}if(_col.dataIndex==="condition"){_col.render=function(text,record,index){var textArr=[];if(record.relatedsharespan!==undefined){textArr.push(record.relatedsharespan);}if(record.joblevelspan!==undefined){textArr.push(record.joblevelspan);}if(record.rolelevelspan!==undefined){textArr.push(record.rolelevelspan);}var newText=textArr.join(" /");if(record.jobfieldspan!==undefined){newText+="("+record.jobfieldspan+")";}return newText;};}return _col;});var locale=this.getLocale();_columns.push({title:"",dataIndex:"ops",key:"ops",width:"15%",className:"wea-table-operates",render:function render(text,record,index){var menu=React.createElement(_antd.Menu,null,React.createElement(MenuItem,null,React.createElement("a",{href:"javascript:void(0);",onClick:_this6.doDelete.bind(_this6,[record.key])},getLabel(91,"刪除"))));return React.createElement("div",{className:"wea-hrm-condition-table-ops"},React.createElement(_antd.Dropdown,{overlay:menu},React.createElement("span",null,getLabel(30585,"操作")," ",React.createElement(_antd.Icon,{type:"caret-down"}))));}});return _columns;}},{key:"getPagination",value:function getPagination(){return false;}},{key:"getRowSelection",value:function getRowSelection(){var _this7=this;var _state6=this.state,columns=_state6.columns,selectedRowKeys=_state6.selectedRowKeys;if(!(""+columns))return null;var rowSelection={selectedRowKeys:selectedRowKeys,onChange:function onChange(sRowKeys,selectedRows){_this7.setState({selectedRowKeys:sRowKeys});}};return rowSelection;}//btns
},{key:"doAdd",value:function doAdd(){this.setState({_visible:true});}},{key:"doDelete",value:function doDelete(keys){var datas=this.state.datas;var _datas=[].concat(datas);keys.map(function(key){_datas=_datas.filter(function(_data){return _data.key!==key;});});_datas=this.addKeytoDatas(_datas);this.setState({datas:_datas,selectedRowKeys:[]});}//modal
},{key:"getTitle",value:function getTitle(bool){var _props2=this.props,_props2$icon=_props2.icon,icon=_props2$icon===undefined?"":_props2$icon,_props2$title=_props2.title,title=_props2$title===undefined?getLabel(19303,"人力资源条件"):_props2$title,_props2$iconBgcolor=_props2.iconBgcolor,iconBgcolor=_props2$iconBgcolor===undefined?"":_props2$iconBgcolor;return React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:"8",style:{paddingLeft:20,lineHeight:"48px"}},React.createElement("div",{className:"wea-hr-muti-input-title"},iconBgcolor?React.createElement("div",{className:"wea-workflow-radio-icon-circle",style:{background:iconBgcolor?iconBgcolor:""}},React.createElement("i",{className:icon})):React.createElement("span",{style:{verticalAlign:"middle",marginRight:10}},React.createElement("i",{className:icon})),React.createElement("span",{style:{verticalAlign:"middle"}},bool?getLabel(15582,"添加条件"):title))));}},{key:"onOk",value:function onOk(){var datas=this.state.datas;this.setState({visible:false,selectDatas:this.getSelectDatas(datas)});if(typeof this.props.onChange==="function"){var jobfield=[],jobfieldspan=[];var _datas=datas.map(function(data,i){var _data=(0,_extends3.default)({},data);if(data.sharetype==="6"){jobfield.push(data.jobfield);jobfieldspan.push(data.sharetypespan+"("+data.jobfieldspan+")");}else if(data.sharetype==="5"){jobfieldspan.push(data.sharetypespan);}else{jobfield.push(data.relatedshare);jobfieldspan.push(data.sharetypespan+"("+data.relatedsharespan+")");}delete _data.key;return _data;});this.props.onChange(jobfield.join(),jobfieldspan.join(),_datas);}}},{key:"onClear",value:function onClear(){this.setState({datas:[],selectedRowKeys:[],selectDatas:[],visible:false});this.props.onChange("","",[]);}},{key:"onCancel",value:function onCancel(){var _props$replaceDatas2=this.props.replaceDatas,replaceDatas=_props$replaceDatas2===undefined?[]:_props$replaceDatas2;this.setState({datas:this.addKeytoDatas(replaceDatas),selectDatas:this.getSelectDatas(this.addKeytoDatas(replaceDatas)),selectedRowKeys:[],visible:false});}},{key:"_onOk",value:function _onOk(){var _state7=this.state,datas=_state7.datas,addData=_state7.addData,addDataInit=_state7.addDataInit;var _datas=[].concat(datas);var _addDatas=[];var sharetype=addData.sharetype,sharetypespan=addData.sharetypespan,_addData$relatedshare=addData.relatedshareurl,relatedshareurl=_addData$relatedshare===undefined?"":_addData$relatedshare,_addData$relatedshare2=addData.relatedsharedata,relatedsharedata=_addData$relatedshare2===undefined?[]:_addData$relatedshare2,joblevel=addData.joblevel,joblevelspan=addData.joblevelspan,jobfield=addData.jobfield,_addData$jobfielddata=addData.jobfielddata,jobfielddata=_addData$jobfielddata===undefined?[]:_addData$jobfielddata,_addData$jobfieldurl=addData.jobfieldurl,jobfieldurl=_addData$jobfieldurl===undefined?"":_addData$jobfieldurl,_addData$seclevel=addData.seclevel,seclevel=_addData$seclevel===undefined?[]:_addData$seclevel,rolelevel=addData.rolelevel,rolelevelspan=addData.rolelevelspan,canDownload=addData.canDownload;var jobfieldspan=[];if(jobfielddata.length>0){jobfielddata.map(function(o){return jobfieldspan.push(o.name);});}var isRequired=this.checkRequire(sharetype,relatedsharedata,jobfielddata,joblevel,seclevel);if(isRequired){relatedsharedata.map(function(o,i){var item={sharetype:sharetype,sharetypespan:sharetypespan,relatedshare:o.id,relatedsharespan:o.name||o.lastname||"",relatedshareurl:relatedshareurl,canDownload:canDownload=="0"?"否":"是"};if(seclevel.length===2)item.seclevel=seclevel.join("-");if(joblevel){item.joblevel=joblevel;item.joblevelspan=joblevelspan;}if(rolelevel){item.rolelevel=rolelevel;item.rolelevelspan=rolelevelspan;}if(jobfielddata.length>0){item.jobfieldspan=jobfieldspan.join(",");item.jobfieldurl=jobfieldurl;item.jobfield=jobfield;}_addDatas.push(item);});//所有人
if(sharetype==="5"){_addDatas.push({sharetype:sharetype,sharetypespan:sharetypespan,seclevel:seclevel.join("-"),canDownload:canDownload=="0"?"否":"是"});}_datas=this.addKeytoDatas(_datas.concat(_addDatas));this.setState({_visible:false,datas:_datas,addData:addDataInit});this.initConditions();}}//验证表单必填
},{key:"checkRequire",value:function checkRequire(sharetype,relatedsharedata,jobfielddata,joblevel,seclevel){if((sharetype==="2"||sharetype==="3"||sharetype==="4"||sharetype==="5")&&(seclevel.length<2||seclevel.length===2&&(seclevel[0]===""||seclevel[1]===""))){//所有人
_antd.message.warning(getLabel(23251,"安全级别不能为空"),5);return false;}if(sharetype==="5"){return true;}if(relatedsharedata.length===0){_antd.message.warning(getLabel(385600,"对象不能为空"),5);return false;}if(sharetype==="6"&&(joblevel==="0"||joblevel==="1")&&jobfielddata.length===0){_antd.message.warning(joblevel==="0"?getLabel(385601,"部门不能为空"):getLabel(125704,"分部不能为空"),5);return false;}return true;}},{key:"_onCancel",value:function _onCancel(){var addDataInit=this.state.addDataInit;this.setState({_visible:false,addData:addDataInit});this.initConditions();}},{key:"arrContains",value:function arrContains(arr,item){var i=arr.length;while(i--){if(arr[i]==item){return true;}}return false;}}]);return Main;}(React.Component),_class.contextTypes={antLocale:React.PropTypes.object},_temp);window.resourceConditionOpenTab=function(url){window.open(url);};window.resourceConditionOpenHrm=function(userid){window.pointerXY(window.event);window.openhrm(userid);};exports.default=Main;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(715);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaCityPicker=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(5/* limit */).then(__webpack_require__.bind(null, 987));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaCityPicker;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _antd=__webpack_require__(8);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _weaDialog=__webpack_require__(55);var _weaDialog2=_interopRequireDefault(_weaDialog);var _weaZmage=__webpack_require__(154);var _weaZmage2=_interopRequireDefault(_weaZmage);var _weaTab=__webpack_require__(199);var _weaTab2=_interopRequireDefault(_weaTab);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _weaTable=__webpack_require__(194);var _weaTable2=_interopRequireDefault(_weaTable);var _Search=__webpack_require__(716);var _Search2=_interopRequireDefault(_Search);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _constants=__webpack_require__(717);var _constants2=_interopRequireDefault(_constants);var _weaEcodeLogin=__webpack_require__(306);var _weaEcodeLogin2=_interopRequireDefault(_weaEcodeLogin);var _weaSelect=__webpack_require__(50);var _weaSelect2=_interopRequireDefault(_weaSelect);var _weaFormItem=__webpack_require__(47);var _weaFormItem2=_interopRequireDefault(_weaFormItem);var _weaTablePage=__webpack_require__(307);var _weaTablePage2=_interopRequireDefault(_weaTablePage);var _weaTextarea=__webpack_require__(66);var _weaTextarea2=_interopRequireDefault(_weaTextarea);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var quickSearchKey=_constants2.default.quickSearchKey,getBrowserConditions=_constants2.default.getBrowserConditions,getFuncListAll=_constants2.default.getFuncListAll,filterData=_constants2.default.filterData;var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_initialiseProps.call(_this);var browserConditions=getBrowserConditions({propertyList:[]},_this.props.demotype,_this.getLabels(),_this.getOtherParams());_this.state={visible:false,selectedData:[],selectedValues:[],datas:[],count:0,pageSize:9,pageNum:1,orderType:"all",loading:false,loadingUpload:false,showSearchAd:false,propertyList:[],browserConditions:browserConditions,defaultImg:props.demotype==="workflowChart"?(window.ecologyContentPath||"")+"/cloudstore/resource/pc/com/images/ecode-wf-empty.png":(window.ecologyContentPath||"")+"/cloudstore/resource/pc/com/images/meeting_default.png",selectedKey:"case",selectedSubKey:"all",passCheck:false,//校验token有效期
visibleForLogin:false,visibleOfApply:false,loadingApply:false,applyType:"temporary",applyList:[],loadingApplyList:false,visibleOfAuthKey:false,authKey:""};return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var _props=this.props,replaceDatas=_props.replaceDatas,valueObj=_props.valueObj;if(!(0,_isEmpty2.default)(replaceDatas)){this.reloadDatas(replaceDatas);}if(!(0,_isEmpty2.default)(valueObj)){this.reloadDatas(valueObj);}_weaTools2.default.callApi("/api/ecode/app/authKey","GET",{}).then(function(data){if(data.api_status){_this2.setState({authKey:data.authKey});}else{_antd.message.error(data.msg);}});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _replaceDatas=this.props.replaceDatas;var replaceDatas=nextProps.replaceDatas;if(replaceDatas&&!(0,_isEqual2.default)(_replaceDatas,replaceDatas)&&!nextProps.replaceNotCtrl){this.reloadDatas(replaceDatas);}if(nextProps.valueObj){this.reloadDatas(nextProps.valueObj||[]);}}// 获取行业/职能数据
// 获取已申请的订单信息
},{key:"render",value:function render(){var _this3=this;var _props2=this.props,ecodePrefixCls=_props2.ecodePrefixCls,modalStyle=_props2.modalStyle,customized=_props2.customized,title=_props2.title,iconBgcolor=_props2.iconBgcolor,icon=_props2.icon,btnProps=_props2.btnProps;var _state=this.state,visible=_state.visible,selectedValues=_state.selectedValues,count=_state.count,showSearchAd=_state.showSearchAd,browserConditions=_state.browserConditions,loadingUpload=_state.loadingUpload,selectedKey=_state.selectedKey,visibleForLogin=_state.visibleForLogin,loadingApply=_state.loadingApply,visibleOfApply=_state.visibleOfApply,selectedData=_state.selectedData,selectedSubKey=_state.selectedSubKey,loadingApplyList=_state.loadingApplyList,authKey=_state.authKey,visibleOfAuthKey=_state.visibleOfAuthKey;var dom=React.createElement(_antd.Button,(0,_extends3.default)({},btnProps,{onClick:this.onBrowerClick}),btnProps.title||getLabel("128328","从云商店导入"));if(customized){dom=React.createElement("div",{className:"cursor-pointer",onClick:this.onBrowerClick},this.props.children);}var buttons=[React.createElement(_antd.Button,{key:"submit",type:"primary",onClick:this.handleOk,loading:loadingUpload,disabled:selectedValues.length==0},selectedKey==="case"?getLabel(384124,"导入"):getLabel("129","申请"),"(",selectedValues.length,")"),React.createElement(_antd.Button,{key:"back",type:"ghost",onClick:this.onCancel},getLabel(385567,"取 消"))];var buttonsForApply=[React.createElement(_antd.Button,{key:"submit",type:"primary",onClick:this.doApply,loading:loadingApply},getLabel("83446","确 定")),React.createElement(_antd.Button,{key:"back",type:"ghost",onClick:this.onCancelForApply},getLabel(385567,"取 消"))];var buttonsAd=this.getTabButtonsAd();var inputValue=this.ecodeBrowserSearch?this.ecodeBrowserSearch.getFieldValue(quickSearchKey):"";var tabs=this.getTabs();var applyProps=this.getApplyProps();return React.createElement("div",{className:ecodePrefixCls},dom,React.createElement(_weaEcodeLogin2.default,{icon:icon,iconBgcolor:iconBgcolor,visible:visibleForLogin,onCancel:function onCancel(){_this3.setState({visibleForLogin:false,visibleOfApply:selectedSubKey==="all"});if(selectedSubKey==="apply")_this3.getApplyList();}}),React.createElement(_weaDialog2.default,{visible:visibleOfApply,title:getLabel("129","申请"),icon:icon,iconBgcolor:iconBgcolor,maskClosable:false,style:{height:420},buttons:buttonsForApply,onCancel:this.onCancelForApply},React.createElement("div",{className:ecodePrefixCls+"-apply"},React.createElement(_weaFormItem2.default,{label:getLabel("519106","授权类型"),labelCol:{span:6},wrapperCol:{span:18}},React.createElement(_weaSelect2.default,applyProps))),React.createElement(_weaTable2.default,{columns:this.getApplyColumns(),dataSource:selectedData,scroll:{y:250}})),React.createElement(_weaDialog2.default,{title:getLabel("519546","授权码"),icon:icon,iconBgcolor:iconBgcolor,maskClosable:false,visible:visibleOfAuthKey,style:{width:520},moreBtn:{datas:[]},onCancel:function onCancel(){return _this3.setState({visibleOfAuthKey:false});}},React.createElement("div",{className:ecodePrefixCls+"-authKey"},React.createElement(_weaTextarea2.default,{value:authKey,minRows:5}))),React.createElement(_weaDialog2.default,{className:"wea-browser-modal",visible:visible,title:title||getLabel("517262","选中流程表单"),icon:icon,iconBgcolor:iconBgcolor,maskClosable:false,style:modalStyle,buttons:buttons,onCancel:this.onCancel},React.createElement(_weaTab2.default,{datas:tabs,buttonsAd:buttonsAd,selectedKey:selectedKey,buttons:[React.createElement(_antd.Button,{type:"primary",key:"authKey",onClick:function onClick(){return _this3.setState({visibleOfAuthKey:true});}},getLabel("519546","授权码"))],searchType:selectedSubKey!=="apply"?["base","advanced"]:["base"],keyParam:"viewcondition",searchsBaseValue:inputValue,onChange:function onChange(v){_this3.setState({selectedKey:v,loadingUpload:false,selectedSubKey:"all"});_this3.reloadDatas([]);},searchsAd:React.createElement(_Search2.default,{ref:function ref(el){return _this3.ecodeBrowserSearch=el;},changeCondition:this.changeCondition,browserConditions:browserConditions}),showSearchAd:showSearchAd,setShowSearchAd:this.setShowSearchAd,onSearchChange:function onSearchChange(v){return _this3.ecodeBrowserSearch&&_this3.ecodeBrowserSearch.setFieldsValue((0,_defineProperty3.default)({},""+quickSearchKey,v));},onSearch:this.onSearch}),selectedKey==="case"?count>0?this.renderList():this.renderNoData():count>0?this.renderAppList():this.renderNoData()));}}]);return Main;}(React.Component),_class.defaultProps={ecodePrefixCls:"wea-ecode-browser",modalStyle:{width:854,height:652},num:3,rowKey:"id",nameKey:"title",btnProps:{type:"primary"},otherParams:{}},_initialiseProps=function _initialiseProps(){var _this4=this;this.getLabels=function(){return{keyword:getLabel("518762","案例名称"),platform:getLabel("518763","平台"),industry:getLabel("575","行业"),funtions:getLabel("383","职能")};};this.getOtherParams=function(){return{platform:{options:[{key:"all",showname:getLabel("82857","全部")},{key:"pc",showname:"PC"},{key:"mobile",showname:"MOBILE"}]}};};this.reloadDatas=function(replaceDatas){var rowKey=_this4.props.rowKey;var selectedValues=replaceDatas.map(function(data){return data[rowKey];});_this4.setState({selectedValues:selectedValues,selectedData:replaceDatas});};this.doChange=function(ids,names,datas){var onChange=_this4.props.onChange;_this4.setState({loadingUpload:false});typeof onChange==="function"&&onChange(ids,names,datas);_this4.onCancel();};this.importFormFromCloudStore=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return new _promise2.default(function(resolve){_weaTools2.default.callApi("/api/workflow/formSetting/list/importFormFromCloudStore","POST",params).then(function(data){resolve(data);});});};this.importModule=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return new _promise2.default(function(resolve){_weaTools2.default.callApi("/api/ecode/demo/moduleImport","POST",params).then(function(data){resolve(data);});});};this.downloadMould=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return new _promise2.default(function(resolve){_weaTools2.default.callApi("/api/doc/console/importmould/downloadMould","POST",params).then(function(data){resolve(data);});});};this.doImport=function(ids,names,datas){var _props3=_this4.props,demotype=_props3.demotype,_props3$otherParams=_props3.otherParams,otherParams=_props3$otherParams===undefined?{}:_props3$otherParams;_this4.setState({loadingUpload:true});if(demotype==="workflowChart"){_this4.importFormFromCloudStore((0,_extends3.default)({demotype:demotype,ids:ids},otherParams)).then(function(data){if(data.importStatus){_antd.message.success(getLabel("129463","导入成功"));_this4.doChange(ids,names,datas);}else{_antd.message.error(data.msg);_this4.setState({loadingUpload:false});}});}else if(demotype==="portalTheme"){_this4.importModule((0,_extends3.default)({demotype:demotype,ids:ids},otherParams)).then(function(data){if(data.api_status){_antd.message.success(getLabel("129463","导入成功"));_this4.doChange(ids,names,datas);}else{_antd.message.error(data.msg);_this4.setState({loadingUpload:false});}});}else if(demotype==="docViewTemplate"||demotype==="docEditTemplate"){_this4.importModule({demotype:demotype,ids:ids,moduleName:names}).then(function(data){if(data.api_status){_this4.downloadMould((0,_extends3.default)({fileid:data.fileId,mouldName:names},otherParams)).then(function(moduleData){if(moduleData.api_status){_antd.message.success(getLabel("129463","导入成功"));_this4.doChange(ids,names,datas);}else{_antd.message.error(moduleData.msg);_this4.setState({loadingUpload:false});}});}else{_antd.message.error(data.msg);}});}};this.doImportApp=function(record){var params={id:record.id,importType:"all",clone:"n",folderId:record.appId,typeId:"",autoRelease:"y",cs_token:_weaTools2.default.ls.getStr("csToken")};_weaTools2.default.callApi("/api/ecode/demo/import","POST",params).then(function(data){if(data.status){_antd.message.success(getLabel("129463","导入成功"));}else{_antd.message.error(data.msg);}});};this.doApply=function(){var _state2=_this4.state,_state2$selectedData=_state2.selectedData,selectedData=_state2$selectedData===undefined?[]:_state2$selectedData,applyType=_state2.applyType;var _props4=_this4.props,nameKey=_props4.nameKey,otherParams=_props4.otherParams,demotype=_props4.demotype;_this4.checkToken().then(function(data){if(data.api_status){_this4.setState({loadingApply:true});// 处理申请导入
var params=(0,_extends3.default)({appId:selectedData.map(function(da){return da.folderId;}),demoId:selectedData.map(function(da){return da.id;}),applyType:applyType,cs_token:_weaTools2.default.ls.getStr("csToken"),demotype:demotype},otherParams);_weaTools2.default.callApi("/api/ecode/demo/applyForApp","POST",params).then(function(data){if(data.status){_antd.message.success(getLabel("16248","提交成功"));_this4.setState({visibleOfApply:false});}else{_antd.message.error(data.msg);}_this4.setState({loadingApply:false});});}else{_this4.setState({visibleForLogin:true});}});};this.handleOk=function(){var _state3=_this4.state,selectedData=_state3.selectedData,selectedValues=_state3.selectedValues,selectedKey=_state3.selectedKey;var nameKey=_this4.props.nameKey;var names=selectedData.map(function(data){return data[nameKey];}).join();if(selectedKey==="case"){_this4.doImport(selectedValues.join(),names,selectedData);}else if(selectedKey==="app"){_this4.setState({visibleOfApply:true});}};this.onCancel=function(){_this4.setState({visible:false,selectedData:[],selectedValues:[],passCheck:false,visibleForLogin:false,visibleOfApply:false});if(_this4.ecodeBrowserSearch){_this4.ecodeBrowserSearch.resetFields();}};this.onBrowerClick=function(){_this4.getPropertyList();_this4.getData();_this4.setState({visible:true,selectedKey:_this4.props.demotype==="portalTheme"?"app":"case"});};this.getParams=function(){var _state4=_this4.state,pageSize=_state4.pageSize,pageNum=_state4.pageNum,orderType=_state4.orderType;var demotype=_this4.props.demotype;var formParams=_this4.ecodeBrowserSearch?_this4.ecodeBrowserSearch.getFieldsValue():{};var params=(0,_extends3.default)({pageSize:pageSize,pageNum:pageNum},formParams,{demotype:demotype});if(orderType!=="all")params["orderType"]=orderType;return params;};this.getData=function(){var selectedSubKey=_this4.state.selectedSubKey;if(selectedSubKey==="all"){var params=_this4.getParams();_this4.setState({loading:true});_weaTools2.default.callApi("/api/ecode/demo/list","GET",params).then(function(data){_this4.setState({datas:data.demoList,count:data.count,loading:false});});}else if(selectedSubKey==="apply"){_this4.getApplyList();}};this.getPropertyList=function(){var demotype=_this4.props.demotype;_weaTools2.default.callApi("/api/ecode/demo/propertyList","GET",{}).then(function(data){if(data.status){var datas=JSON.parse(data.data).data||[];var browserConditions=getBrowserConditions({propertyList:datas},demotype,_this4.getLabels(),_this4.getOtherParams());_this4.setState({propertyList:datas,browserConditions:browserConditions});}});};this.getApplyList=function(){_this4.checkToken().then(function(){var keyword=_this4.ecodeBrowserSearch?_this4.ecodeBrowserSearch.getFieldValue(quickSearchKey):"";var csToken=_weaTools2.default.ls.getStr("csToken");var param={pageSize:10,pageNum:1,keyword:keyword,cs_token:csToken};_this4.setState({loadingApplyList:true});_weaTools2.default.callApi("/api/ecode/demo/applyList","GET",param).then(function(data){if(data.status){var tempData=data.list||[];tempData=tempData.map(function(v){v["randomFieldOp"]=v.applyStatus==="successful"?[true]:[false];return v;});_this4.setState({applyList:tempData});}else{_antd.message.error(data.msg);}_this4.setState({loadingApplyList:false});});});};this.onPageChange=function(pageNum){var pageSize=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_this4.state.pageSize;_this4.setState({pageNum:pageNum,pageSize:pageSize},function(){_this4.getData();});};this.onCheck=function(value,data){var rowKey=_this4.props.rowKey;var _state5=_this4.state,selectedData=_state5.selectedData,selectedValues=_state5.selectedValues;if(value){selectedValues.push(data[rowKey]);selectedData.push(data);}else{selectedValues=selectedValues.filter(function(v){return v!==data[rowKey];});selectedData=selectedData.filter(function(v){return v[rowKey]!==data[rowKey];});}_this4.setState({selectedData:selectedData,selectedValues:selectedValues});};this.getTable=function(){var _props5=_this4.props,num=_props5.num,ecodePrefixCls=_props5.ecodePrefixCls,rowKey=_props5.rowKey;// 自定义每行展示数据的个数
var _state6=_this4.state,datas=_state6.datas,selectedValues=_state6.selectedValues,defaultImg=_state6.defaultImg;if(datas){return datas.map(function(data){var checked=selectedValues.indexOf(data[rowKey])>=0;var img=data.imageList&&data.imageList.length>0?data.imageList[0]:{};return React.createElement(_antd.Col,{span:24/num,className:ecodePrefixCls+"-table-col"},React.createElement("div",{className:ecodePrefixCls+"-table-single"+(checked?"-active":"")},React.createElement("div",{className:ecodePrefixCls+"-table-single-con"},React.createElement("div",{className:ecodePrefixCls+"-table-single-checkbox"},React.createElement(_antd.Checkbox,{checked:checked,onChange:function onChange(e){return _this4.onCheck(e.target.checked,data);}})),React.createElement("div",{className:ecodePrefixCls+"-table-single-num"},React.createElement("span",{className:ecodePrefixCls+"-table-single-num-first"},React.createElement("i",{className:ecodePrefixCls+"-table-single-num-icon icon-coms-Supervise"}),data.downloadCounts),React.createElement("span",null,React.createElement("i",{className:ecodePrefixCls+"-table-single-num-icon icon-coms-download2"}),data.downloadCounts)),React.createElement("div",{className:ecodePrefixCls+"-table-single-image"},React.createElement(_weaZmage2.default,{src:img.imageLink||img.thumbnailLink||defaultImg,style:{maxWidth:"100%",maxHeight:"100%"}})),React.createElement("div",{className:ecodePrefixCls+"-table-single-view"},data.detailsUrl&&React.createElement("span",{onClick:function onClick(){return window.open(data.detailsUrl);}},getLabel("22045","详情")),data.previewUrl&&React.createElement("span",{onClick:function onClick(){return window.open(data.previewUrl);}},getLabel("221","预览")))),React.createElement("div",{className:ecodePrefixCls+"-table-single-title text-elli",title:data.title},data.title)));});}return null;};this.onTopBtnClick=function(orderType){_this4.setState({orderType:orderType},function(){_this4.getData();});};this.getTopBtn=function(){var topBtn=[{key:"all",title:getLabel("503342","综合"),icon:""},// { key: 'views', title: getLabel('26668','访问量'), icon: '' },
{key:"downloadCount",title:getLabel("25204","下载次数"),icon:""},{key:"createTime",title:getLabel("26080","更新日期"),icon:""}];var orderType=_this4.state.orderType;return topBtn.map(function(btn){return React.createElement(_antd.Button,{key:btn.key,type:orderType===btn.key&&"primary",onClick:function onClick(){return _this4.onTopBtnClick(btn.key);}},React.createElement("span",null,btn.title),React.createElement("i",{className:"icon-coms02-Sort"}));});};this.getTabButtonsAd=function(){return[React.createElement(_antd.Button,{type:"primary",onClick:_this4.onSearch},getLabel(197,"搜索")),React.createElement(_antd.Button,{type:"ghost",onClick:_this4.onReset},getLabel(2022,"重置")),React.createElement(_antd.Button,{type:"ghost",onClick:function onClick(){return _this4.setShowSearchAd(false);}},getLabel(31129,"取消"))];};this.getTabs=function(){return[{title:getLabel("519104","案例"),viewcondition:"case"},{title:getLabel("25432","应用"),viewcondition:"app"}];};this.onReset=function(){if(_this4.ecodeBrowserSearch)_this4.ecodeBrowserSearch.resetFields();_this4.getData();};this.onSearch=function(){_this4.setShowSearchAd(false);_this4.getData();};this.setShowSearchAd=function(showSearchAd){_this4.setState({showSearchAd:showSearchAd});};this.renderNoData=function(){var ecodePrefixCls=_this4.props.ecodePrefixCls;return React.createElement("div",{className:ecodePrefixCls+"-no-data"},React.createElement("div",{className:ecodePrefixCls+"-no-data-con"},React.createElement("i",{className:"icon-coms-blank"}),React.createElement("div",null,getLabel("83553","暂无数据"))));};this.renderList=function(subTableClass){var ecodePrefixCls=_this4.props.ecodePrefixCls;var _state7=_this4.state,count=_state7.count,pageSize=_state7.pageSize,pageNum=_state7.pageNum,loading=_state7.loading;return[React.createElement("div",{className:ecodePrefixCls+"-btns",key:"WeaEcodeBrowser_Topbtn"},_this4.getTopBtn()),React.createElement("div",{className:ecodePrefixCls+"-table "+subTableClass,key:"WeaEcodeBrowser_Table"},React.createElement(_weaNewScroll2.default,{height:"100%"},React.createElement(_antd.Spin,{spinning:loading},React.createElement(_antd.Row,null,_this4.getTable())))),React.createElement("div",{className:ecodePrefixCls+"-pagination",key:"WeaEcodeBrowser_Pagination"},React.createElement(_antd.Pagination,{showQuickJumper:true,showSizeChanger:true,pageSizeOptions:["9","18","27","36"],showTotal:function showTotal(total){return getLabel(385617,"共$s条").replace(/\$s/,total);},total:count,pageSize:pageSize,current:pageNum,onChange:_this4.onPageChange,onShowSizeChange:_this4.onPageChange}))];};this.getSubTabs=function(){return[{title:getLabel("82857","全部"),viewcondition:"all"},{title:getLabel("18659","已申请"),viewcondition:"apply"}];};this.getColumns=function(){return[{title:getLabel("16841","订单编号"),dataIndex:"appId",key:"appId",display:"true",width:"33%",render:function render(text){return React.createElement("span",{title:text},text);}},{title:getLabel("15451","表单名称"),dataIndex:"appName",key:"appName",display:"true",width:"30%",render:function render(text){return React.createElement("span",{title:text},text);}},{title:getLabel("390653","申请时间"),dataIndex:"createDate",key:"createDate",display:"true",width:"18%",render:function render(text,record){return text+" "+record.createTime;}},{title:getLabel("500401","类型"),dataIndex:"applyType",key:"applyType",display:"true",width:"10%",render:function render(text){return text==="temporary"?getLabel("519105","临时(7天)"):getLabel("19182","永久");}},{title:getLabel("23247","状态"),dataIndex:"applyStatus",key:"applyStatus",display:"true",width:"8%",render:function render(text){if(text==="successful")return getLabel("15376","通过");else if(text==="applying")return getLabel("131030","审核中");if(text==="failed")return getLabel("390557","不通过");}},{dataIndex:"randomFieldId",dbField:"randomFieldId",from:"set",title:"randomFieldId"}];};this.onOperatesClick=function(record){_this4.doImportApp(record);};this.renderAppList=function(){var ecodePrefixCls=_this4.props.ecodePrefixCls;var _state8=_this4.state,selectedSubKey=_state8.selectedSubKey,applyList=_state8.applyList,loadingApplyList=_state8.loadingApplyList;return React.createElement("div",{className:ecodePrefixCls+"-tableSub-con"},React.createElement(_weaTab2.default,{type:"card",datas:_this4.getSubTabs(),selectedKey:selectedSubKey,keyParam:"viewcondition",onChange:function onChange(v){_this4.setState({selectedSubKey:v});if(v==="apply")_this4.getApplyList();}}),selectedSubKey==="all"?_this4.renderList(ecodePrefixCls+"-tableSub"):React.createElement(_weaTablePage2.default,{columns:_this4.getColumns(),datas:applyList,loading:loadingApplyList,className:"wea-new-table",operates:[{index:"0",nodeName:"operate",text:getLabel(384124,"导入")}],onOperatesClick:_this4.onOperatesClick}));};this.selectedIndustry=function(value,datas){var funs=value.value?value.value.split(","):[];if(funs.length>0){var selectedIndustry=[];funs.forEach(function(index){var re=datas.find(function(da){return da.funcList.find(function(v){return v.key===index;});});if(re&&selectedIndustry.indexOf(re.key)<0){selectedIndustry.push(re.key);}});if(_this4.ecodeBrowserSearch){var formParams=_this4.ecodeBrowserSearch?_this4.ecodeBrowserSearch.getFieldsValue():{};_this4.ecodeBrowserSearch.setFieldsValue((0,_extends3.default)({},formParams,{industry:selectedIndustry.join(),funtions:value.value}));}}};this.changeCondition=function(fields,domkey){var browserConditions=_this4.state.browserConditions;var propertyList=_this4.state.propertyList;propertyList=filterData(propertyList);var formParams=_this4.ecodeBrowserSearch?_this4.ecodeBrowserSearch.getFieldsValue():{};if(domkey==="funtions"&&!formParams.industry){_this4.selectedIndustry(fields.funtions,propertyList);}if("industry"in fields){var funcOptions=[];var industryValue=fields.industry.value;propertyList.forEach(function(pro){if(pro.key===fields.industry.value){funcOptions=pro.funcList.filter(function(v){return v.key!==""&&v.key!=="0";});// 过滤选项：全部
}});browserConditions.forEach(function(con){if(con.domkey.indexOf("funtions")>=0){con["options"]=industryValue&&industryValue!=="0"?getFuncListAll(propertyList,industryValue):getFuncListAll(propertyList);}});_this4.setState({browserConditions:browserConditions});}};this.checkToken=function(){var csToken=_weaTools2.default.ls.getStr("csToken");return new _promise2.default(function(resolve,reject){if(!csToken){_this4.setState({passCheck:false,visibleForLogin:true});reject();}else{var loadingMessage=_antd.message.loading(getLabel("518773","正在检查登录状态"),0);_weaTools2.default.callApi("/api/ecode/demo/checkTokens","GET",{cs_token:csToken}).then(function(data){setTimeout(loadingMessage,0);_this4.setState({passCheck:data.api_status?true:false,visibleForLogin:data.api_status?false:true});resolve(data);});}});};this.getApplyProps=function(){return{detailtype:3,domkey:"applyType",value:_this4.state.applyType,options:[{key:"temporary",showname:getLabel("519105","临时(7天)")},{key:"permanent",showname:getLabel("19182","永久")}],onChange:function onChange(v){return _this4.setState({applyType:v});}};};this.getApplyColumns=function(){return[// { title: '主键', dataIndex: 'folderId', key: 'folderId' },
{title:getLabel("15451","表单名称"),dataIndex:"title",key:"title"}];};this.onCancelForApply=function(){return _this4.setState({visibleOfApply:false,loadingApply:false});};},_temp);exports.default=Main;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _list=__webpack_require__(720);var _list2=_interopRequireDefault(_list);var _operation=__webpack_require__(303);var _operation2=_interopRequireDefault(_operation);var _toString=__webpack_require__(57);var _toString2=_interopRequireDefault(_toString);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _uniqBy=__webpack_require__(104);var _uniqBy2=_interopRequireDefault(_uniqBy);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.moveTo=function(direction){var _this$state=_this.state,leftCheckedKeys=_this$state.leftCheckedKeys,rightCheckedKeys=_this$state.rightCheckedKeys,rightData=_this$state.rightData,leftData=_this$state.leftData;if(direction==="right"){var checked=[];leftData.forEach(function(item){if(leftCheckedKeys.indexOf((0,_toString2.default)(item.id))>-1){checked.push(item);}});rightData=rightData.concat(checked);if(_this.props.moveToRightCB){rightData=_this.props.moveToRightCB(rightData);}_this.setState({leftCheckedKeys:[],rightCheckedKeys:[],rightData:rightData});_this.onChange(rightData);}if(direction==="left"){if(_this.props.moveToLeftBeforeCB&&!_this.props.moveToLeftBeforeCB(rightCheckedKeys)){_this.setState({rightCheckedKeys:[]});return;}rightData=rightData.filter(function(item){return rightCheckedKeys.indexOf((0,_toString2.default)(item.id))==-1;});_this.setState({leftCheckedKeys:[],rightCheckedKeys:[],rightData:rightData});_this.onChange(rightData);_this.props.moveToLeftCB&&_this.props.moveToLeftCB(rightData,rightCheckedKeys);}if(direction==="allToLeft"){var rgData=[],targetkeys=[];if(_this.props.filterRight){var filterDatas=(0,_cloneDeep2.default)(_this.props.filterRight((0,_cloneDeep2.default)(rightData)))||[];filterDatas.forEach(function(d){return targetkeys.push((0,_toString2.default)(d.id));});rgData=rightData.filter(function(item){return targetkeys.indexOf((0,_toString2.default)(item.id))==-1;});if(_this.props.moveToLeftBeforeCB&&!_this.props.moveToLeftBeforeCB(targetkeys))return;}_this.setState({leftCheckedKeys:[],rightCheckedKeys:[],rightData:rgData});_this.onChange(rgData);_this.props.moveToLeftCB&&_this.props.moveToLeftCB(rgData,targetkeys);}if(direction==="allToRight"){var targetData=(0,_cloneDeep2.default)(leftData);if(_this.props.filterLeft){targetData=(0,_cloneDeep2.default)(_this.props.filterLeft((0,_cloneDeep2.default)(targetData)));targetData=rightData.concat(targetData);}if(_this.props.moveToRightCB){targetData=_this.props.moveToRightCB(targetData);targetData=rightData.concat(targetData);}targetData=(0,_uniqBy2.default)(targetData,"id");_this.setState({leftCheckedKeys:[],rightCheckedKeys:[],rightData:targetData});_this.onChange(targetData);}};_this.moveToLeft=function(){return _this.moveTo("left");};_this.moveToRight=function(){return _this.moveTo("right");};_this.moveAllToLeft=function(){return _this.moveTo("allToLeft");};_this.moveAllToRight=function(){return _this.moveTo("allToRight");};var dataUrl=_this.props.dataUrl;_this.state={leftData:props.data,rightData:[],leftCheckedKeys:[],rightCheckedKeys:[]};if(!(0,_isEmpty2.default)(props.selectedKeys)&&!(0,_isEmpty2.default)(props.data)){var rightData=[];props.selectedKeys.forEach(function(key){var filterDatas=props.data.filter(function(i){return(0,_toString2.default)(i.id)===(0,_toString2.default)(key);});if(filterDatas.length>0){rightData.push(filterDatas[0]);}});_this.state.rightData=rightData;}var funcs=["onLeftCheck","onLeftDoubleClick","onRightCheck","onRightDoubleClick","onRightDrag"];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var leftData=this.state.leftData;var rightData=[];var selectedKeys=this.props.selectedKeys||[];if("data"in nextProps){leftData=nextProps.data||[];}if("selectedKeys"in nextProps&&!(0,_isEqual2.default)(this.props.selectedKeys,nextProps.selectedKeys)){selectedKeys=nextProps.selectedKeys||[];}selectedKeys.forEach(function(key){var filterDatas=leftData.filter(function(i){return(0,_toString2.default)(i.id)===(0,_toString2.default)(key);});if(filterDatas.length>0){rightData.push(filterDatas[0]);}});this.setState({leftData:leftData,rightData:rightData});}},{key:"leftListAllActive",value:function leftListAllActive(){var bool=true;var _state=this.state,rightData=_state.rightData,leftData=_state.leftData;bool=leftData.filter(function(item){return!rightData.some(function(i){return i.id===item.id;});}).length>0;return bool;}},{key:"leftListActive",value:function leftListActive(){var _state2=this.state,rightData=_state2.rightData,rightCheckedKeys=_state2.rightCheckedKeys;if(!(0,_isEmpty2.default)(rightCheckedKeys)){return rightCheckedKeys.filter(function(item){return rightData.some(function(i){return i.id==item;});}).length>0;}return false;}},{key:"onLeftCheck",value:function onLeftCheck(keys,e){if(this.props.leftCheckCB){keys=this.props.leftCheckCB(keys,e);}this.setState({leftCheckedKeys:keys});}},{key:"onLeftDoubleClick",value:function onLeftDoubleClick(key){if(this.props.leftDoubleClickCB){if(!this.props.leftDoubleClickCB(key))return;}var _state3=this.state,rightData=_state3.rightData,leftData=_state3.leftData;var data=leftData.filter(function(item){return(0,_toString2.default)(item.id)===(0,_toString2.default)(key);});rightData=rightData.concat(data);this.setState({leftCheckedKeys:[],rightCheckedKeys:[],rightData:rightData});this.onChange(rightData);}},{key:"onRightDoubleClick",value:function onRightDoubleClick(key){var rightData=this.state.rightData;if(this.props.moveToLeftBeforeCB&&!this.props.moveToLeftBeforeCB(key))return;rightData=rightData.filter(function(item){return(0,_toString2.default)(item.id)!==(0,_toString2.default)(key);});this.setState({leftCheckedKeys:[],rightCheckedKeys:[],rightData:rightData});this.onChange(rightData);this.props.moveToLeftCB&&this.props.moveToLeftCB(rightData,key);}},{key:"onRightCheck",value:function onRightCheck(keys,e){if(this.props.rightCheckCB){keys=this.props.rightCheckCB(keys,e);}this.setState({rightCheckedKeys:keys});}},{key:"onRightDrag",value:function onRightDrag(data){this.setState({rightData:data});this.onChange(data);}},{key:"get",value:function get(){var rightData=this.state.rightData;var ids=[];rightData.forEach(function(item){return ids.push((0,_toString2.default)(item.id));});return ids;}},{key:"clear",value:function clear(){this.setState({leftCheckedKeys:[],rightCheckedKeys:[]});}},{key:"onChange",value:function onChange(datas){var ids=[];datas.forEach(function(item){return ids.push((0,_toString2.default)(item.id));});this.props.onChange&&this.props.onChange(ids,datas);}},{key:"render",value:function render(){var _state4=this.state,leftData=_state4.leftData,rightData=_state4.rightData,leftCheckedKeys=_state4.leftCheckedKeys,rightCheckedKeys=_state4.rightCheckedKeys;var _props=this.props,height=_props.height,renderItem=_props.renderItem,renderLeft=_props.renderLeft,renderRight=_props.renderRight,style=_props.style;var rightDisplayData=(0,_cloneDeep2.default)(rightData);if(this.props.filterLeft){leftData=(0,_cloneDeep2.default)(this.props.filterLeft((0,_cloneDeep2.default)(leftData)));}if(this.props.filterRight){rightDisplayData=(0,_cloneDeep2.default)(this.props.filterRight(rightDisplayData));}return React.createElement("div",{className:"wea-transfer "+(this.props.className||""),style:style},React.createElement(_list2.default,(0,_extends3.default)({},this.props,{renderItem:renderLeft||renderItem,header:this.props.leftHeader,className:"wea-transfer-left-wrapper",data:leftData,draggable:false,checkedCb:this.onLeftCheck,onDoubleClick:this.onLeftDoubleClick,checkedKeys:leftCheckedKeys,filterData:rightData,height:height})),React.createElement(_operation2.default,{className:"wea-transfer-opration",rightActive:leftCheckedKeys.length>0,leftActive:this.leftListActive(),leftAllActive:this.leftListAllActive(),rightAllActive:rightData.length>0,moveToRight:this.moveToRight,moveToLeft:this.moveToLeft,moveAllToRight:this.moveAllToRight,moveAllToLeft:this.moveAllToLeft}),React.createElement(_list2.default,(0,_extends3.default)({},this.props,{renderItem:renderRight||renderItem,header:this.props.rightHeader,className:"wea-transfer-right-wrapper",data:rightDisplayData,draggable:true,onDrag:this.onRightDrag,checkedCb:this.onRightCheck,onDoubleClick:this.onRightDoubleClick,checkedKeys:rightCheckedKeys,height:height})));}}]);return Main;}(React.Component),_class.Operation=_operation2.default,_temp);Main.list=_list2.default;var Com=(0,_middleware2.default)(Main,"WeaTransfer");exports.default=Com;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _debounce=__webpack_require__(67);var _debounce2=_interopRequireDefault(_debounce);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Icon from '../../../_antd1.11.2/icon'
// import Button from '../../../_antd1.11.2/button'
// import Spin from '../../../_antd1.11.2/spin'
// import Row from '../../../_antd1.11.2/row'
// import Col from '../../../_antd1.11.2/col'
// import Card from '../../../_antd1.11.2/card'
// import Checkbox from '../../../_antd1.11.2/checkbox'
// import Pagination from '../../../_antd1.11.2/pagination';
// import Menu from '../../../_antd1.11.2/menu'
var MenuItem=_antd.Menu.Item;// import Dropdown from '../../../_antd1.11.2/dropdown'
// import cloneDeep from 'lodash/cloneDeep';
var getLabel=_weaLocaleProvider2.default.getLabel;var config={gap:105,borderColor:'#add8e6'};function compare(key){return function(obj1,obj2){var val1=obj1[key],val2=obj2[key];return 1*val1<=1*val2?-1:1;};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this2=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this2.state={checked:false,disabled:false,ids:[],style:null,recordId:''};_this2.checkboxOnChange=_this2.checkboxOnChange.bind(_this2);_this2.thumbnailsPageChange=_this2.thumbnailsPageChange.bind(_this2);_this2.thumbnailOnShowSizeChange=_this2.thumbnailOnShowSizeChange.bind(_this2);return _this2;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return this.props.height!==nextProps.height||this.state.checked!==nextState.checked||this.state.disabled!==nextState.disabled||this.state.style!==nextState.style||this.state.recordId!==nextState.recordId||this.state.ids!==nextState.ids||!(0,_isEqual2.default)(this.props.browser,nextProps.browser);}},{key:'getOpMenu',value:function getOpMenu(record){var _this3=this;var _props=this.props,operates=_props.operates,layout=_props.layout;var rfs=record.randomFieldOp?JSON.parse(record.randomFieldOp):{};var items=new Array();operates.forEach(function(operate,index){var flag=operate.index||"-1";if(rfs[flag]&&rfs[flag]!="false"){items.push(React.createElement(MenuItem,{key:index},React.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){typeof _this3.props.onOperatesClick==='function'&&_this3.props.onOperatesClick(record,null,operate,null);}},operate.text)));}});var menu=React.createElement(_antd.Menu,{kj:true},items);if(items.length>0){return React.createElement(_antd.Dropdown,{overlay:menu},React.createElement('span',{className:'wea-thumbnails-doc-t_text'},getLabel(30585,'操作'),React.createElement(_antd.Icon,{className:'wea-thumbnails-doc-t_column',type:'caret-down',style:{fontSize:10,color:'#a3a3a3',marginLeft:3}})));}}},{key:'getCards',value:function getCards(){var _this4=this;var ids=this.state.ids;var _props2=this.props,layout=_props2.layout,browser=_props2.browser,datas=_props2.datas;var _this=this;var thumbnailsArr=[];browser&&browser.forEach(function(item,browserIndex){var linkvaluecolumn=item.linkvaluecolumn;var linkkey=item.linkkey;var list=[].concat((0,_toConsumableArray3.default)(item.list));var title=null;list.forEach(function(l,index){if(l.t_type=='title'){title=l.t_column;list.splice(index,1);}});var newList=list.sort(compare('t_showorder'));var cardExtra=React.createElement('div',{className:'wea-thumbnails-doc-extra'},React.createElement(_antd.Checkbox,{checked:ids.indexOf(linkvaluecolumn)>=0,id:linkvaluecolumn,onChange:_this4.checkboxOnChange}));thumbnailsArr.push(React.createElement(_antd.Col,{span:'12'},React.createElement(_antd.Card,{extra:cardExtra},item.isNew=='1'&&React.createElement('div',{className:'wea-thumbnails-doc-triangle'}),React.createElement('div',{className:'wea-thumbnails-doc-image'},newList.map(function(l){if(l.t_type==='img'){return React.createElement('i',{className:l.t_column});}})),React.createElement('div',{className:'wea-thumbnails-doc-content'},React.createElement('p',{className:'wea-f14',style:{color:'#484a4d'}},React.createElement('span',{dangerouslySetInnerHTML:{__html:title}})),newList.map(function(l){if(l.t_type==='subtitle'){return React.createElement('p',null,React.createElement('span',{className:'wea-thumbnails-doc-content-subtitle'},l.t_text,' : '),React.createElement('span',{dangerouslySetInnerHTML:{__html:l.t_column}}));}})),React.createElement('div',{className:'wea-thumbnails-doc-content-foot'},React.createElement('p',null,newList.map(function(l){if(l.t_type=='foot'){return React.createElement('span',null,React.createElement('i',{className:l.t_icon}),' ',l.t_column);}}),React.createElement('span',{style:{cursor:'pointer'}},_this4.getOpMenu(datas[browserIndex])))))));});return thumbnailsArr;}},{key:'render',value:function render(){var _state=this.state,ids=_state.ids,thumbnailsArr=_state.thumbnailsArr;var _props3=this.props,browser=_props3.browser,height=_props3.height;return React.createElement('div',{className:'wea-thumbnails-doc'},React.createElement(_antd.Row,{style:{maxHeight:height,overflowY:'auto',padding:'0 20px 20px 0'}},this.getCards()));}//               <Row className='wea-thumbnails-doc-pg'>
//                  <Pagination
//                  	className='ant-table-pagination'
//                      {...this.props}
//                      {...this.props.paginationConfig}
//                      onChange={this.thumbnailsPageChange}
//                      onShowSizeChange={this.thumbnailOnShowSizeChange}
//                  />
//               </Row>
},{key:'checkboxOnChange',value:function checkboxOnChange(e){var isChecked=e.target.checked;var eId=e.target.id;this.setState(function(preState){var curIds=preState.ids;isChecked?this.throwIds=[].concat((0,_toConsumableArray3.default)(preState.ids),[eId])||[]:this.throwIds=curIds.filter(function(id){return eId!=id;})||[];this.throwCheckedIds();//this.changeCardCss(eId,isChecked);
return{ids:this.throwIds};});}},{key:'throwCheckedIds',value:function throwCheckedIds(){if(typeof this.props.thumbnailsOnChange=='function'){this.props.thumbnailsOnChange(this.throwIds);}}},{key:'thumbnailsPageChange',value:function thumbnailsPageChange(page){if(typeof this.props.onChange=="function"){this.props.onThumbnailsChange(page,this.props.pageSize,'');}}},{key:'thumbnailOnShowSizeChange',value:function thumbnailOnShowSizeChange(current,pageSize){this.props.onThumbnailsChange(current,pageSize,'');}}]);return Main;}(React.Component);exports.default=Main;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(721);__webpack_require__(722);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(723);__webpack_require__(724);__webpack_require__(725);__webpack_require__(726);__webpack_require__(727);__webpack_require__(728);__webpack_require__(729);__webpack_require__(730);__webpack_require__(731);__webpack_require__(732);__webpack_require__(733);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _index=__webpack_require__(308);var _index2=_interopRequireDefault(_index);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);__webpack_require__(750);var _index3=__webpack_require__(751);var InputUtil=_interopRequireWildcard(_index3);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));var formatvalue=_this.transFormatValue(props.value,props.format);_this.state={value:props.value?props.value:"",formatvalue:formatvalue,isonfocus:false,location:-1};// 点击回调聚焦判断使用
_this.needFocus=false;return _this;}(0,_createClass3.default)(Main,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.state.value!==nextProps.value||this.props.format!==nextProps.format||nextProps.defaultFocus){var formatShowValue=this.transFormatValue(nextProps.value,nextProps.format);var _state={value:nextProps.value,formatvalue:formatShowValue};if(nextProps.defaultFocus!==this.props.defaultFocus&&nextProps.defaultFocus){_state.isonfocus=true;}this.setState(_state);}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){if(this.props.defaultFocus&&this.props.defaultFocus!==nextProps.defaultFocus)//延时失去焦点时不渲染组件
return false;return nextProps.value!==this.props.value||nextProps.viewAttr!==this.props.viewAttr||nextState.value!==this.state.value||nextState.isonfocus!==this.state.isonfocus||nextState.formatvalue!==this.state.formatvalue||nextProps.format!==this.props.format||nextProps.showhtml!==this.props.showhtml||nextProps.emptyShowContent!==this.props.emptyShowContent||nextProps.fieldName!==this.props.fieldName;}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(this.state.isonfocus===true&&prevState.isonfocus===false)this.setLocation();}},{key:"render",value:function render(){var _state2=this.state,isonfocus=_state2.isonfocus,formatvalue=_state2.formatvalue;var _props=this.props,viewAttr=_props.viewAttr,style=_props.style,fieldid=_props.fieldid,fieldName=_props.fieldName,detailtype=_props.detailtype,qfws=_props.qfws,format=_props.format,isDetail=_props.isDetail,emptyShowContent=_props.emptyShowContent,showhtml=_props.showhtml,ecId=_props.ecId,_props$className=_props.className,className=_props$className===undefined?"":_props$className;var value=this.state.value;if(detailtype!==1){value=(0,_trim2.default)(value).length>0?value.replace(/\,/g,""):"";}var numberType=parseInt(format.numberType)||0;if(!isonfocus&&numberType===100){//财务表览
return React.createElement(_index2.default,{ecId:ecId+"_WeaWfFinancial@nc7g1c",type:2,finNum:format.finaNum,className:"finarea_"+fieldid+" "+className,viewAttr:viewAttr,value:value,clickEvent:this.doFocusEvent.bind(this,true),style:style});}if(numberType===2&&(format.formatPattern=="1"||format.formatPattern=="4")){//格式化值负数则变为红色
style["color"]=!isonfocus&&InputUtil.judgeIsNumber(value)&&parseFloat(value)<0?"#FF0000":"inherit";}var chinglish=detailtype===4?InputUtil.convertAmountChinese(value):"";var domArr=new Array();if(viewAttr===1){if(detailtype===4){if(!isDetail){domArr.push(React.createElement("span",{style:style},formatvalue));domArr.push(React.createElement("br",null));}domArr.push(React.createElement("span",{id:fieldName+"span",style:style},chinglish));}else{if(!!showhtml)formatvalue=showhtml;domArr.push(React.createElement("span",{id:fieldName+"span",className:"wf-readonly-span",style:style,dangerouslySetInnerHTML:{__html:formatvalue}}));}return React.createElement("span",{className:className,style:style},domArr,React.createElement("input",{ecId:ecId+"_input@d6pn3g",type:"hidden",id:fieldName,name:fieldName,value:value,onKeyDown:this.doKeyDown.bind(this)}));}else{var _className="wf-input wf-input-"+detailtype+" "+(isDetail?"wf-input-detail":"wf-input-main")+" wf-input-field"+fieldid;var onKeyPressEvent="";if(detailtype===2)onKeyPressEvent=this.doKeyPressCheckInteger.bind(this);else if(detailtype===3||detailtype===4||detailtype===5)onKeyPressEvent=this.doKeyPressCheckFloat.bind(this);if(detailtype===4){//金额转换字段
domArr.push(React.createElement("input",{ecId:ecId+"_input@vx4hxl",ref:"inputEle",type:"text",className:_className,id:fieldName,name:fieldName,value:isonfocus?value:isDetail?chinglish:formatvalue,onChange:this.setInputText.bind(this),onKeyDown:this.doKeyDown.bind(this),onKeyPress:onKeyPressEvent,onFocus:this.doFocusEvent.bind(this,true),onBlur:this.doFocusEvent.bind(this,false),style:style}));if(!isDetail){domArr.push(React.createElement("br",null));domArr.push(React.createElement("input",{ecId:ecId+"_input@i3psdu",type:"text",disabled:true,value:chinglish,onKeyDown:this.doKeyDown.bind(this),className:_className+" wf-input-chinese",style:style}));}}else{//支持可编辑无值时显示灰色默认值
emptyShowContent=emptyShowContent||"";if(!isonfocus&&emptyShowContent!==""&&formatvalue.toString()===""){style["color"]="#A5A5A5";formatvalue=emptyShowContent;}else{if(!"color"in style)style["color"]="inherit";}domArr.push(React.createElement("input",{ecId:ecId+"_input@vahdxd",ref:"inputEle",type:"text",className:_className,id:fieldName,name:fieldName,value:isonfocus?value:formatvalue,onChange:this.setInputText.bind(this),onKeyDown:this.doKeyDown.bind(this),onKeyPress:onKeyPressEvent,onFocus:this.doFocusEvent.bind(this,true),onBlur:this.doFocusEvent.bind(this,false),style:style}));}var isRequired=viewAttr===3&&(0,_trim2.default)(value).length===0;domArr.push(React.createElement("span",{id:fieldName+"span",className:"wf-input-required"},isRequired?React.createElement("img",{src:(window.ecologyContentPath||"")+"/images/BacoError_wev9.png",align:"absmiddle"}):""));return React.createElement("div",{className:"wea-wf-input "+_className,style:style},domArr);}}},{key:"setInputText",value:function setInputText(e){var _props2=this.props,detailtype=_props2.detailtype,length=_props2.length,fieldlabel=_props2.fieldlabel;var value=e.target.value;if(detailtype===1){var valLen=InputUtil.realLength(value);if(length&&valLen>length){// message.warning(`${fieldlabel}文本长度不能超过${length}(1个中文字符等于3个长度)`);
_antd.message.warning(""+(fieldlabel+" "+getLabel(20246,"文本长度不能超过")+length+"("+getLabel(124962,"1个中文字符等于3个长度")+")"));value=InputUtil.checkLength(value,valLen,length);}}this.setState({value:value});this.props.onChange&&this.props.onChange(value);}},{key:"doFocusEvent",value:function doFocusEvent(bool,e){var _this2=this;var input=e.target;if(bool){//获取焦点
if(this.props.onBeforeFocusCheck){if(!this.needFocus){this.refs.inputEle.blur();this.needFocus=true;}var cb=function cb(){if(_this2.needFocus){_this2.refs.inputEle.focus();_this2.needFocus=false;}_this2.doFocusEventInner(bool,input);};this.props.onBeforeFocusCheck(cb,function(){_this2.refs.inputEle.blur();});}else{this.doFocusEventInner(bool,input);}}else{//失去焦点
this.doFocusEventInner(bool,input);}}},{key:"doFocusEventInner",value:function doFocusEventInner(bool,input){if(this.props.viewAttr===1)return;if(bool){//获取焦点
this.setState({isonfocus:bool,location:this.getLocation()});}else{//失去焦点
var value=this.checkLen(input.value);//验证长度
var realValue=this.transRealValue(value,bool);var formatValue=this.transFormatValue(value,this.props.format);this.setState({value:realValue,formatvalue:formatValue,isonfocus:bool});}}},{key:"transRealValue",value:function transRealValue(value,bool){var _props3=this.props,detailtype=_props3.detailtype,qfws=_props3.qfws,_props3$isfloor=_props3.isfloor,isfloor=_props3$isfloor===undefined?false:_props3$isfloor;var realValue=value;if(detailtype!==1){var isqfw=detailtype===5;realValue=InputUtil.convertFloatValue(value,qfws,isqfw,false,isfloor);}this.props.onChange&&this.props.onChange(realValue);if(bool){this.props.onFocus&&this.props.onFocus(realValue);}else{this.props.onBlur&&this.props.onBlur(realValue);}return realValue;}},{key:"transFormatValue",value:function transFormatValue(value,format){var _props4=this.props,detailtype=_props4.detailtype,qfws=_props4.qfws,_props4$isfloor=_props4.isfloor,isfloor=_props4$isfloor===undefined?false:_props4$isfloor;if(detailtype!==1){value=(0,_trim2.default)(value).length>0?value.replace(/\,/g,""):"";}var formatvalue=value;var numberType=parseInt(format.numberType)||0;//失去焦点
if(numberType>0){if(numberType===100){//财务预览
}else if(numberType===101){//财务金额大写
formatvalue=InputUtil.convertAmountChinese(value);}else{formatvalue=InputUtil.convertFormatValue(value,format);}}else{if(detailtype!==1){var isqfw=false;if(detailtype===4||detailtype===5){isqfw=true;}formatvalue=InputUtil.convertFloatValue(value,qfws,isqfw,false,isfloor);}}return formatvalue;}},{key:"checkLen",value:function checkLen(val){var _props5=this.props,detailtype=_props5.detailtype,length=_props5.length,qfws=_props5.qfws,fieldlabel=_props5.fieldlabel;if(detailtype===1){var valLen=InputUtil.realLength(val);if(length&&valLen>length){// message.warning(`${fieldlabel}文本长度不能超过${length},(1个中文字符等于3个长度)`);
_antd.message.warning(""+(fieldlabel+" "+getLabel(20246,"文本长度不能超过")+length+"("+getLabel(124962,"1个中文字符等于3个长度")+")"));val=InputUtil.checkLength(val,valLen,length);}return val;}if((0,_trim2.default)(val).length===0)return"";if((0,_trim2.default)(val).length===1&&val.charCodeAt(0)===45)return val;if(!InputUtil.judgeIsNumber(val))return"";if(val.charCodeAt(0)===45)length=length+1;var arr=val.toString().split(".");if((0,_trim2.default)(arr[0]).length>length-qfws){// message.warning(`整数位数长度不能超过${length-qfws}位，请重新输入！`,5);
_antd.message.warning(""+(getLabel(385128,"整数位数长度不能超过")+length-qfws+getLabel(17081,"位")+"，"+getLabel(385129,"请重新输入！")),5);return"";}return val;}//整数
},{key:"doKeyPressCheckInteger",value:function doKeyPressCheckInteger(e){// const keyCode = e.nativeEvent.keyCode;
e=e.nativeEvent?e.nativeEvent:e;e=e?e:window.event;var keyCode=e.nativeEvent?e.nativeEvent.keyCode:e.which;var value=this.state.value;var length=this.props.length;var isNumber=keyCode>=48&&keyCode<=57||keyCode===45;var selectLen=(0,_trim2.default)(this.getSelectionText(e).toString()).length;if((0,_trim2.default)(value).length>0&&value.charCodeAt(0)===45)length=length+1;if(keyCode===45&&(0,_trim2.default)(value).length===length){var carePos=this.getCursortPosition();if(carePos===0){length=length+1;}}if(!isNumber||(0,_trim2.default)(value).length-selectLen>=length){e.preventDefault();}}},{key:"doKeyDown",value:function doKeyDown(e){var enableInput=this.props.enableInput;if(enableInput===false){this.props.onDisablePrompt();e.preventDefault();return;}var keyCode=e.nativeEvent.keyCode;if(keyCode===13){e.preventDefault();//阻止enter键导致表单提交
var _props6=this.props,onEnter=_props6.onEnter,onEnterSearch=_props6.onEnterSearch;var value=e.target.value;typeof onEnterSearch==="function"&&onEnterSearch(value);// 高级搜索传参
typeof onEnter==="function"&&onEnter(value);}e.stopPropagation();//阻止冒泡
}//检测小数输入
},{key:"doKeyPressCheckFloat",value:function doKeyPressCheckFloat(e){var _props7=this.props,length=_props7.length,qfws=_props7.qfws,detailtype=_props7.detailtype;var keyCode=e.nativeEvent.keyCode;var tmpvalue=this.state.value;if(detailtype!==1){tmpvalue=(0,_trim2.default)(tmpvalue).length>0?tmpvalue.replace(/\,/g,""):"";}var selectVal=this.getSelectionText(e).toString();if(selectVal.length>0&&(0,_trim2.default)(tmpvalue).length>0){var curPosition=this.getCursortPosition();tmpvalue=tmpvalue.substr(0,curPosition)+tmpvalue.substr(curPosition+selectVal.length);}// 排除backspance 和del
if(keyCode==8){return;}if((0,_trim2.default)(tmpvalue).length===0&&keyCode==46){e.preventDefault();}var dotCount=0;var integerCount=0;var afterDotCount=0;var hasDot=false;var len=(0,_trim2.default)(tmpvalue).length;for(var i=0;i<len;i++){if(tmpvalue.charAt(i)=="."){dotCount++;hasDot=true;}else{if(hasDot){afterDotCount++;}else{integerCount++;}}}//只能输入一个"."
if(keyCode==46&&(hasDot||qfws===0)){e.preventDefault();}//console.log("dotCount",dotCount,"integerCount",integerCount,"hasDot",hasDot,"afterDotCount",afterDotCount,"keyCode",keyCode);
var isNumber=keyCode>=48&&keyCode<=57;var checkInput=isNumber||keyCode==46||keyCode==45||keyCode==46&&dotCount==1;if(!checkInput){e.preventDefault();}var checkInteger=integerCount>=length-qfws&&hasDot==false&&isNumber;if(checkInteger){e.preventDefault();}var checkLen=afterDotCount>=qfws&&integerCount>=length-qfws;if(checkLen){e.preventDefault();}if(hasDot){var carePos=this.getCursortPosition();var dotIndex=(0,_trim2.default)(tmpvalue).indexOf(".");//console.log("carePos",carePos,"dotIndex",dotIndex);
if(carePos<=dotIndex){if(integerCount>=length-qfws){e.preventDefault();}}else{if(afterDotCount>=qfws){e.preventDefault();}}}}},{key:"getSelectionText",value:function getSelectionText(e){if(document.selection){//IE
return document.selection.createRange().text;}else if(window.getSelection().toString()){//Chrome
return window.getSelection().toString();}else if(e.selectionStart!=undefined&&e.selectionEnd!=undefined){//其它情况
var start=e.selectionStart;var end=e.selectionEnd;return e.value.substring(start,end);}return"";}},{key:"getCursortPosition",value:function getCursortPosition(){var input=this.refs.inputEle;var CaretPos=0;if(input.selection){input.focus();var Sel=input.selection.createRange();if(Sel.text.length<1){Sel.moveStart("character",-input.value.length);CaretPos=Sel.text.length;}}else if(input.selectionStart||input.selectionStart=="0"){//ff
CaretPos=input.selectionStart;}return CaretPos;}},{key:"getLocation",value:function getLocation(){try{//计算鼠标焦点位置
var elm=this.refs.inputEle;if(elm.createTextRange){// IE
var range=document.selection.createRange();range.setEndPoint("StartToStart",elm.createTextRange());return range.text.length;}else if(typeof elm.selectionStart==="number"){return elm.selectionStart;}}catch(e){return-1;}}},{key:"setLocation",value:function setLocation(){var elm=this.refs.inputEle;var location=this.state.location;if(location<0||location>elm.value.length)//定位到最后
location=elm.value.length;if(elm.createTextRange){//IE
var textRange=elm.createTextRange();textRange.moveStart("character",location);textRange.collapse();textRange.select();}else if(elm.setSelectionRange){elm.setSelectionRange(location,location);elm.focus();}}}]);return Main;}(React.Component),_class.defaultProps={format:{},style:{}},_temp);exports.default=Main;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _weaInputLocale=__webpack_require__(753);var _weaInputLocale2=_interopRequireDefault(_weaInputLocale);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_middleware2.default)(_weaInputLocale2.default,"WeaInputLocale");exports.default=Com;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getLinkUrls=exports.getRequiredKeys=exports.getDefaultValues=undefined;var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 在没有传props.datas的情况下，用于设置wea-auth中除去第一个select外其他表单字段的默认值
var getDefaultValues=exports.getDefaultValues=function getDefaultValues(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var obj={};var getNewObj=function getNewObj(d){if(d.conditionType==="SELECT"||d.conditionType==="SELECT_LINKAGE"){if(d.options.filter(function(op){return op.selected;}).length>0){var select=d.options.filter(function(op){return op.selected;})[0];obj[d.domkey[0]]=select.key;obj[d.domkey[0]+"span"]=select.showname;if(d.conditionType==="SELECT_LINKAGE"&&select.key){var sDatas=d.selectLinkageDatas;var bDatas=sDatas[select.key];bDatas&&getNewObj(bDatas);}}}else if(d.conditionType==="CHECKBOX"){obj[d.domkey[0]]=d.value||"0";obj[d.domkey[0]+"span"]=d.label||"";}else if(d.conditionType==="INPUT"){obj[d.domkey[0]]=d.value||"";}else if(d.conditionType==="TEXTAREA"){obj[d.domkey[0]]=d.value||"";}else if(d.conditionType==="DATEPICKER"){obj[d.domkey[0]]=d.value||"";}else if(d.conditionType==="INPUT_INTERVAL"){if(d.value){obj[d.domkey[0]]=d.value[0]||0;obj[d.domkey[1]]=d.value[1]||100;if(d.needDefaultValue===false){obj[d.domkey[0]]=d.value[0];obj[d.domkey[1]]=d.value[1];}}}else if(d.conditionType==="RANGEPICKER"){if(d.value){obj[d.domkey[0]]=d.value[0];obj[d.domkey[1]]=d.value[1];}}else if(d.conditionType==="BROWSER"){if(d.browserConditionParam.replaceDatas){var ids=[];var names=[];d.browserConditionParam.replaceDatas.forEach(function(l){ids.push(l.id);names.push(l.name);});obj[d.domkey[0]]=ids.join(",");obj[d.domkey[0]+"span"]=names.join(",");}}else if(d.conditionType==="INPUTNUMBER"){obj[d.domkey[0]]=d.value||"";}else if(!d.conditionType){obj=(0,_extends3.default)({},obj,getDefaultValues(d,obj));}};if((typeof datas==="undefined"?"undefined":(0,_typeof3.default)(datas))==="object"){if(Object.prototype.toString.call(datas)==="[object Array]"){datas.forEach(function(data){getNewObj(data);});}else{for(var key in datas){if(datas.hasOwnProperty(key)){getNewObj(datas[key]);}}}}return obj;};var getRequiredKeys=exports.getRequiredKeys=function getRequiredKeys(){var conditions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var datas=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var keys=[];var getNewKeys=function getNewKeys(d){if(d.conditionType==="BROWSER"&&d.browserConditionParam.viewAttr===3){keys.push(d.domkey[0]);}else if(d.conditionType==="TEXTAREA"&&d.viewAttr===3){keys.push(d.domkey[0]);}else if(d.conditionType==="INPUT_INTERVAL"&&d.viewAttr===3){if(d.needDefaultValue===false)keys.push([d.domkey[0],d.domkey[1],"or"]);else keys.push(d.domkey[0],[d.domkey[1],d.domkey[0]]);}else if(d.conditionType==="RANGEPICKER"&&d.viewAttr===3){if(d.needDefaultValue===false)keys.push([d.domkey[0],d.domkey[1],"or"]);else keys.push(d.domkey[0],d.domkey[1]);}else if(d.conditionType==="SELECT_LINKAGE"){var bDatas=d.selectLinkageDatas[datas[d.domkey[0]]];bDatas&&bDatas.viewAttr===3&&keys.push([bDatas.domkey[0],d.domkey[0]]);}else if(d.conditionType==="INPUT"&&d.viewAttr===3){keys.push(d.domkey[0]);}else if(d.conditionType==="DATEPICKER"&&d.viewAttr===3){keys.push(d.domkey[0]);}else if(d.conditionType==="INPUTNUMBER"&&d.viewAttr===3){keys.push(d.domkey[0]);}else if(d.conditionType==="SELECT"){keys.push(d.domkey[0]);}else if(!d.conditionType){keys=keys.concat(getRequiredKeys(d,datas));}};if((typeof conditions==="undefined"?"undefined":(0,_typeof3.default)(conditions))==="object"){if(Array.isArray(conditions)){conditions.forEach(function(data){getNewKeys(data);});}else{for(var key in conditions){if(conditions.hasOwnProperty(key)){getNewKeys(conditions[key]);}}}}return keys;};var getLinkUrls=exports.getLinkUrls=function getLinkUrls(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var urls={};var getNewObj=function getNewObj(d){if(d.conditionType==="SELECT_LINKAGE"){if(d.options.filter(function(op){return op.selected;}).length>0){var select=d.options.filter(function(op){return op.selected;})[0];if(d.conditionType==="SELECT_LINKAGE"&&select.key){var sDatas=d.selectLinkageDatas;var bDatas=sDatas[select.key];bDatas&&getNewObj(bDatas);}}}else if(d.conditionType==="BROWSER"){if(d.browserConditionParam.linkUrl){urls[d.domkey[0]]=d.browserConditionParam.linkUrl;}}};if((typeof datas==="undefined"?"undefined":(0,_typeof3.default)(datas))==="object"){if(Object.prototype.toString.call(datas)==="[object Array]"){datas.forEach(function(data){getNewObj(data);});}else{for(var key in datas){if(datas.hasOwnProperty(key)){getNewObj(datas[key]);}}}}return urls;};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaButton=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 991));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaButton;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ErrorPage=function(_React$Component){(0,_inherits3.default)(ErrorPage,_React$Component);function ErrorPage(){(0,_classCallCheck3.default)(this,ErrorPage);return(0,_possibleConstructorReturn3.default)(this,(ErrorPage.__proto__||(0,_getPrototypeOf2.default)(ErrorPage)).apply(this,arguments));}(0,_createClass3.default)(ErrorPage,[{key:"render",value:function render(){var _props=this.props,msg=_props.msg,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style,children=_props.children;return React.createElement("div",{style:(0,_extends3.default)({height:"100%"},style),className:className},React.createElement("div",{style:{position:"absolute",top:"35%",left:"40%",textAlign:"center"}},React.createElement("img",{src:(window.ecologyContentPath||"")+"/cloudstore/images/e9/error.png"}),React.createElement("div",{style:{textAlign:"center"}},msg)),children);}}]);return ErrorPage;}(React.Component);var Com=(0,_middleware2.default)(ErrorPage,"WeaErrorPage");exports.default=Com;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(860);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaSearchInput=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 1012));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaSearchInput;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(387);
module.exports = __webpack_require__(403);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}if(typeof _promise2.default==='undefined'){// Rejection tracking prevents a common issue where React gets into an
// inconsistent state due to an error, but it gets swallowed by a Promise,
// and the user has no idea what causes React's erratic future behavior.
__webpack_require__(401).enable();window.Promise=__webpack_require__(336);}// fetch() polyfill for making API calls.
__webpack_require__(402);// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign=__webpack_require__(99);// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if(false){require('raf').polyfill(global);}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(206);
__webpack_require__(84);
__webpack_require__(107);
__webpack_require__(395);
__webpack_require__(399);
__webpack_require__(400);
module.exports = __webpack_require__(20).Promise;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(155);
var defined = __webpack_require__(156);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(143);
var descriptor = __webpack_require__(90);
var setToStringTag = __webpack_require__(106);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(58)(IteratorPrototype, __webpack_require__(30)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(59);
var toLength = __webpack_require__(144);
var toAbsoluteIndex = __webpack_require__(392);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(155);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(394);
var step = __webpack_require__(333);
var Iterators = __webpack_require__(73);
var toIObject = __webpack_require__(59);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(207)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(89);
var global = __webpack_require__(29);
var ctx = __webpack_require__(68);
var classof = __webpack_require__(145);
var $export = __webpack_require__(39);
var isObject = __webpack_require__(53);
var aFunction = __webpack_require__(105);
var anInstance = __webpack_require__(321);
var forOf = __webpack_require__(318);
var speciesConstructor = __webpack_require__(226);
var task = __webpack_require__(227).set;
var microtask = __webpack_require__(397)();
var newPromiseCapabilityModule = __webpack_require__(163);
var perform = __webpack_require__(228);
var userAgent = __webpack_require__(398);
var promiseResolve = __webpack_require__(229);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(30)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(322)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(106)($Promise, PROMISE);
__webpack_require__(334)(PROMISE);
Wrapper = __webpack_require__(20)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(230)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var macrotask = __webpack_require__(227).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(92)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(39);
var core = __webpack_require__(20);
var global = __webpack_require__(29);
var speciesConstructor = __webpack_require__(226);
var promiseResolve = __webpack_require__(229);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(39);
var newPromiseCapability = __webpack_require__(163);
var perform = __webpack_require__(228);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(198);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(404);var _util=__webpack_require__(337);var _util2=_interopRequireDefault(_util);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import "./weaJs";
var req=__webpack_require__(420);var base=__webpack_require__(911);req.keys().forEach(function(mod){var v=req(mod);var match=mod.match(/^\.\/([^_][\w-]+)\/index\.js?$/);if(match&&match[1]){try{// console.log(v.default);
var name=_util2.default.camelCase(match[1]);// v.default = util.tryCatch(React, MyErrorHandler, {error: "前端组件库异常，请联系管理员!"})(v.default);
exports[name]=v.default;}catch(e){}}});base.keys().forEach(function(mod){var v=base(mod);var match=mod.match(/^\.\/([^_][\w-]+)\/index\.jsx?$/);if(match&&match[1]){try{var name=_util2.default.camelCase(match[1]);exports["Base"+name]=v.default;}catch(e){}}});

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.formatToTime=exports.formatToDate=exports.formatOfZero=undefined;var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatOfZero=exports.formatOfZero=function formatOfZero(value){var formatWithZero=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(!formatWithZero&&value&&typeof value==="string"&&value.indexOf("-")>-1){// feat: 增是否显示数字前0处理
// 去掉日期前的0
var arr=value.split("-");var newArr=[];if(arr&&arr.length>0){arr.map(function(i){newArr.push(i.replace(/^0/,""));});}var str=newArr.join("-");return str;}return value;};var formatToDate=exports.formatToDate=function formatToDate(realVal,formatPattern){var formatWithZero=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var pattern=new RegExp("^\\d{2,4}-\\d{1,2}-\\d{1,2}$");if(!pattern.test(realVal)){return formatOfZero(realVal,formatWithZero);}/**
   * formatPattern
   * 1：yyyy/MM/dd
   * 2：yyyy-MM-dd
   * 3：yyyy年MM月dd日
   * 4：yyyy年MM月
   * 5：MM月dd日
   * 6：EEEE
   * 7：日期大写
   * 8：yyyy/MM/dd hh:mm a
   * 9：yyyy/MM/dd HH:mm
   */var arr=realVal.split("-");var year=arr[0];var month=arr[1];var day=arr[2];if(parseInt(month)>12||parseInt(day)>31||parseInt(year)<=0||parseInt(month)<=0||parseInt(day)<=0){return realVal;}if(year.length==2)year=formatWithZero?"00"+year:year;if(year.length==3)year=formatWithZero?"0"+year:year;if(month.length==1)month=formatWithZero?"0"+month:month;if(day.length==1)day=formatWithZero?"0"+day:day;realVal=year+"-"+month+"-"+day;if(new Date(realVal).toString().indexOf("undefined")>-1){//解决IE下类似不存在的日期2014-9-31通过new Date无法生成日期问题，chrome下默认取的下一天
return realVal;}switch(parseInt(formatPattern)){case 1:return formatDate(new Date(realVal),"yyyy/MM/dd",formatWithZero);case 2:return formatDate(new Date(realVal),"yyyy-MM-dd",formatWithZero);case 3:return formatDate(new Date(realVal),"yyyy年MM月dd日",formatWithZero);case 4:return formatDate(new Date(realVal),"yyyy年MM月",formatWithZero);case 5:return formatDate(new Date(realVal),"MM月dd日",formatWithZero);case 6:return formatDate(new Date(realVal),"wwww",formatWithZero);case 7:return dataToChinese(new Date(realVal));case 8:return formatDate(new Date(realVal),"yyyy/MM/dd 12:00 a",formatWithZero);case 9:return formatDate(new Date(realVal),"yyyy/MM/dd 00:00",formatWithZero);default:return realVal;}};//日期格式
var formatDate=function formatDate(date,fmt){var formatWithZero=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;fmt=fmt||"yyyy-MM-dd HH:mm:ss";var obj={y:date.getUTCFullYear(),// 年份，注意必须用getFullYear
M:date.getUTCMonth()+1,// 月份，注意是从0-11
d:date.getUTCDate(),// 日期
q:Math.floor((date.getUTCMonth()+3)/3),// 季度
w:date.getUTCDay(),// 星期，注意是0-6
H:12,// 24小时制
h:12,// 12小时制
m:0,// 分钟
s:0,// 秒
S:0,// 毫秒
a:"AM"};var week=["天","一","二","三","四","五","六"];for(var i in obj){fmt=fmt.replace(new RegExp(i+"+","g"),function(m){var val=obj[i]+"";if(i=="a")return val;if(i=="w")return(m.length>2?"星期":"周")+week[val];for(var j=0,len=val.length;j<m.length-len;j++){// val = "0" + val;
// 增加format是否带0的处理,默认带0 (年 月 日)
if(!((i=="Y"||i=="y"||i=="M"||i=="d")&&!formatWithZero)){val="0"+val;}}return m.length==1?val:val.substring(val.length-m.length);});}return fmt;};//日期中文
var dataToChinese=function dataToChinese(date){var arr=["〇","一","二","三","四","五","六","七","八","九"];var year=date.getFullYear();var month=date.getMonth()+1;var day=date.getDate();var tempYear=year.toString().split("").map(function(o){return arr[parseInt(o)];}).toString();return(tempYear+"年"+convertNumToChinese(month)+"月"+convertNumToChinese(day)+"日").replace(/\,/g,"");};var convertNumToChinese=function convertNumToChinese(num){var arr1=["","","二","三"];var arr2=["","一","二","三","四","五","六","七","八","九"];num=num<10?"0"+num.toString():num.toString();var first=parseInt(num.toString().split("")[0]);var second=parseInt(num.toString().split("")[1]);return arr1[first]+(first>0?"十":"")+arr2[second];};var formatToTime=exports.formatToTime=function formatToTime(realVal,formatPattern){var pattern=new RegExp("^(\\d{1,2}:\\d{1,2})(:\\d{1,2})?$");if(!pattern.test(realVal)){return realVal;}/**
   * formatPattern
   * 1：HH:MI:SS
   * 2：HH:MI:SS AM/PM
   * 3：HH:MI
   * 4：HH:MI AM/PM
   * 5：HH时MI分SS秒
   * 6：HH时MI分
   * 7：HH时MI分SS秒 AM/PM
   * 8：HH时MI分 AM/PM
   **/var realValArr=realVal.split(":");var hour=realValArr[0];var minute=realValArr[1];var seconds=realValArr[2]||"00";var separatorChar=":";var suffix=parseInt(hour)<12?" AM":" PM";switch(parseInt(formatPattern)){case 1:return hour+separatorChar+minute+separatorChar+seconds;case 2:return hour+separatorChar+minute+separatorChar+seconds+suffix;case 3:return hour+separatorChar+minute;case 4:return hour+separatorChar+minute+suffix;case 5:return hour+"时"+minute+("\u5206"+seconds+"\u79D2");case 6:return hour+"时"+minute+"分";case 7:return hour+"时"+minute+("\u5206"+seconds+"\u79D2")+suffix;case 8:return hour+"时"+minute+"分"+suffix;default:return realVal;}};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(74);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(411);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(146);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(146);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(417),
    hasUnicode = __webpack_require__(418),
    unicodeToArray = __webpack_require__(419);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 417 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./wea-alert-page/index.js": 201,
	"./wea-alert-page/style/index.js": 441,
	"./wea-app-center/index.js": 443,
	"./wea-associative-search/index.js": 252,
	"./wea-audio/index.js": 757,
	"./wea-auth/index.js": 758,
	"./wea-auth/style/index.js": 759,
	"./wea-avatar/index.js": 135,
	"./wea-avatar/style/index.js": 761,
	"./wea-browser-search/index.js": 302,
	"./wea-browser-search/style/index.js": 763,
	"./wea-browser/index.js": 80,
	"./wea-browser/style/index.js": 379,
	"./wea-button-icon/index.js": 359,
	"./wea-button/index.js": 383,
	"./wea-button/style/index.js": 765,
	"./wea-cascader/index.js": 215,
	"./wea-checkbox/index.js": 132,
	"./wea-checkbox/style/index.js": 767,
	"./wea-city-picker/index.js": 374,
	"./wea-code-mirror/index.js": 769,
	"./wea-collect/index.js": 123,
	"./wea-collect/style/index.js": 771,
	"./wea-color-picker/index.js": 142,
	"./wea-color-picker/style/index.js": 363,
	"./wea-cron/index.js": 774,
	"./wea-cron/style/index.js": 775,
	"./wea-custom-new/index.js": 150,
	"./wea-custom/index.js": 777,
	"./wea-date-group/index.js": 202,
	"./wea-date-group/style/index.js": 778,
	"./wea-date-picker/index.js": 133,
	"./wea-date-switch/index.js": 780,
	"./wea-debug-route-menu/index.js": 781,
	"./wea-debug-route-menu/style/index.js": 782,
	"./wea-dialog-footer/index.js": 784,
	"./wea-dialog/index.js": 55,
	"./wea-dialog/style/index.js": 786,
	"./wea-drag-choose/index.js": 788,
	"./wea-draggable/index.js": 274,
	"./wea-dragula/index.js": 153,
	"./wea-drop-menu/index.js": 329,
	"./wea-drop-menu/style/index.js": 789,
	"./wea-dropdown/index.js": 214,
	"./wea-echart/index.js": 791,
	"./wea-ecode-upload/index.js": 792,
	"./wea-error-boundary/index.js": 794,
	"./wea-error-page/index.js": 384,
	"./wea-error/index.js": 82,
	"./wea-field-template-select/index.js": 795,
	"./wea-field/index.js": 796,
	"./wea-form-item/index.js": 47,
	"./wea-helpful-tip/index.js": 52,
	"./wea-hrmlist/index.js": 205,
	"./wea-image-cropper/index.js": 798,
	"./wea-image-cropper/style/index.js": 799,
	"./wea-input-encrypt/index.js": 801,
	"./wea-input-locale/index.js": 381,
	"./wea-input-number/index.js": 200,
	"./wea-input-search/index.js": 46,
	"./wea-input-search/style/index.js": 802,
	"./wea-input/index.js": 56,
	"./wea-intro/index.js": 804,
	"./wea-intro/style/index.js": 806,
	"./wea-language-select/index.js": 810,
	"./wea-left-right-layout/index.js": 355,
	"./wea-left-right-layout/style/index.js": 812,
	"./wea-left-tree/index.js": 356,
	"./wea-left-tree/style/index.js": 815,
	"./wea-loading-global/index.js": 817,
	"./wea-loading-global/style/index.js": 818,
	"./wea-locale-provider/index.js": 10,
	"./wea-locale-provider/style/index.js": 820,
	"./wea-map/index.js": 365,
	"./wea-menu/index.js": 822,
	"./wea-menu/style/index.js": 823,
	"./wea-mind/index.js": 825,
	"./wea-more-button/index.js": 210,
	"./wea-new-dragula/index.js": 327,
	"./wea-new-scroll-pagination/index.js": 826,
	"./wea-new-scroll/index.js": 26,
	"./wea-new-scroll/style/index.js": 827,
	"./wea-org-tree/index.js": 829,
	"./wea-org-tree/style/index.js": 830,
	"./wea-period/index.js": 832,
	"./wea-popover-hrm/index.js": 217,
	"./wea-popover-hrm/style/index.js": 834,
	"./wea-progress/index.js": 325,
	"./wea-qrcode/index.js": 299,
	"./wea-radio-group/index.js": 836,
	"./wea-range-picker/index.js": 102,
	"./wea-rate/index.js": 838,
	"./wea-report-card/index.js": 839,
	"./wea-report-group/index.js": 841,
	"./wea-report/index.js": 842,
	"./wea-report/style/index.js": 843,
	"./wea-req-top/index.js": 845,
	"./wea-req-top/style/index.js": 846,
	"./wea-rich-text/index.js": 364,
	"./wea-rich-text/style/index.js": 848,
	"./wea-right-menu/index.js": 212,
	"./wea-right-menu/style/index.js": 852,
	"./wea-scope/index.js": 136,
	"./wea-scroll/index.js": 101,
	"./wea-scroll/style/index.js": 854,
	"./wea-search-advance/index.js": 195,
	"./wea-search-advance/style/index.js": 856,
	"./wea-search-group/index.js": 367,
	"./wea-search-group/style/index.js": 858,
	"./wea-search-input/index.js": 385,
	"./wea-search-panel/index.js": 861,
	"./wea-select-group/index.js": 137,
	"./wea-select-group/style/index.js": 863,
	"./wea-select/index.js": 50,
	"./wea-share/index.js": 865,
	"./wea-share/style/index.js": 866,
	"./wea-show-url/index.js": 273,
	"./wea-signature/index.js": 868,
	"./wea-slide-modal/index.js": 872,
	"./wea-sortable/index.js": 875,
	"./wea-steps-menus/index.js": 877,
	"./wea-steps/index.js": 879,
	"./wea-switch/index.js": 881,
	"./wea-tab/index.js": 199,
	"./wea-tab/style/index.js": 882,
	"./wea-table-edit/index.js": 331,
	"./wea-table-edit/style/index.js": 884,
	"./wea-table-editable/index.js": 360,
	"./wea-table-editable/style/index.js": 886,
	"./wea-table-page/index.js": 307,
	"./wea-table-page/style/index.js": 378,
	"./wea-table/index.js": 194,
	"./wea-tag-group/index.js": 888,
	"./wea-tag-group/style/index.js": 889,
	"./wea-tag/index.js": 891,
	"./wea-tag/style/index.js": 892,
	"./wea-textarea/index.js": 66,
	"./wea-time-picker/index.js": 98,
	"./wea-time-range-picker/index.js": 152,
	"./wea-tools/index.js": 35,
	"./wea-top/index.js": 894,
	"./wea-top/style/index.js": 895,
	"./wea-transfer/index.js": 376,
	"./wea-transfer/style/index.js": 897,
	"./wea-tree-edit/index.js": 899,
	"./wea-tree-edit/style/index.js": 900,
	"./wea-tree-new/index.js": 902,
	"./wea-tree-test/index.js": 213,
	"./wea-tree-test/style/index.js": 903,
	"./wea-tree/index.js": 320,
	"./wea-upload/index.js": 313,
	"./wea-upload/style/index.js": 905,
	"./wea-video/index.js": 907,
	"./wea-video/style/index.js": 908,
	"./wea-year/index.js": 910,
	"./wea-zmage/index.js": 154
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 420;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(422);
module.exports = __webpack_require__(20).Object.assign;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(39);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(423) });


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(48);
var getKeys = __webpack_require__(91);
var gOPS = __webpack_require__(147);
var pIE = __webpack_require__(111);
var toObject = __webpack_require__(70);
var IObject = __webpack_require__(208);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(69)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(425);
module.exports = __webpack_require__(20).Object.getPrototypeOf;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(70);
var $getPrototypeOf = __webpack_require__(223);

__webpack_require__(165)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(427);
var $Object = __webpack_require__(20).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(39);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(48), 'Object', { defineProperty: __webpack_require__(49).f });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84);
__webpack_require__(107);
module.exports = __webpack_require__(166).f('iterator');


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(338);
__webpack_require__(206);
__webpack_require__(432);
__webpack_require__(433);
module.exports = __webpack_require__(20).Symbol;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(91);
var gOPS = __webpack_require__(147);
var pIE = __webpack_require__(111);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(59);
var gOPN = __webpack_require__(209).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(167)('asyncIterator');


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(167)('observable');


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(435);
module.exports = __webpack_require__(20).Object.setPrototypeOf;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(39);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(436).set });


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(53);
var anObject = __webpack_require__(44);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(68)(Function.call, __webpack_require__(148).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(438);
var $Object = __webpack_require__(20).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(39);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(143) });


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(440);
module.exports = __webpack_require__(20).Object.keys;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(70);
var $keys = __webpack_require__(91);

__webpack_require__(165)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(442);

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Com=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(4/* limit */).then(__webpack_require__.bind(null, 951));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Com;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(445);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(236);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(25),
    isMasked = __webpack_require__(449),
    isObject = __webpack_require__(40),
    toSource = __webpack_require__(237);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(450);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(41);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 451 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(62),
    isObjectLike = __webpack_require__(45);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 455 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(62),
    isLength = __webpack_require__(169),
    isObjectLike = __webpack_require__(45);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(172),
    equalArrays = __webpack_require__(239),
    equalByTag = __webpack_require__(482),
    equalObjects = __webpack_require__(484),
    getTag = __webpack_require__(93),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(114),
    isTypedArray = __webpack_require__(170);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 458 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116),
    Map = __webpack_require__(168),
    MapCache = __webpack_require__(173);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(469),
    ListCache = __webpack_require__(116),
    Map = __webpack_require__(168);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(470),
    hashDelete = __webpack_require__(471),
    hashGet = __webpack_require__(472),
    hashHas = __webpack_require__(473),
    hashSet = __webpack_require__(474);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 471 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 476 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 480 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(74),
    Uint8Array = __webpack_require__(240),
    eq = __webpack_require__(118),
    equalArrays = __webpack_require__(239),
    mapToArray = __webpack_require__(483),
    setToArray = __webpack_require__(176);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(241);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(20);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84);
__webpack_require__(488);
module.exports = __webpack_require__(20).Array.from;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(68);
var $export = __webpack_require__(39);
var toObject = __webpack_require__(70);
var call = __webpack_require__(224);
var isArrayIter = __webpack_require__(225);
var toLength = __webpack_require__(144);
var createProperty = __webpack_require__(342);
var getIterFn = __webpack_require__(162);

$export($export.S + $export.F * !__webpack_require__(230)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(490)
var ieee754 = __webpack_require__(491)
var isArray = __webpack_require__(492)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 491 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 492 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(495);
var $Object = __webpack_require__(20).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(59);
var $getOwnPropertyDescriptor = __webpack_require__(148).f;

__webpack_require__(165)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(41);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 497 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(500),
    keys = __webpack_require__(85);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(501);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(71);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(122);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaScroll=__webpack_require__(101);var _weaScroll2=_interopRequireDefault(_weaScroll);var _callApi=__webpack_require__(17);var _addGroup=__webpack_require__(507);var _addGroup2=_interopRequireDefault(_addGroup);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var OGroup=function(_React$Component){(0,_inherits3.default)(OGroup,_React$Component);function OGroup(props){(0,_classCallCheck3.default)(this,OGroup);var _this2=(0,_possibleConstructorReturn3.default)(this,(OGroup.__proto__||(0,_getPrototypeOf2.default)(OGroup)).call(this,props));_this2.state={showall:false,hrmgroups:[],allUserIds:"",allUserCount:0,showAllUser:false,addgroupVisable:false};var _this=_this2;(0,_callApi.callApi)("/api/workflow/forward/getHrmGroup","GET",{}).then(function(data){_this.setState({hrmgroups:data.datas||[]});});return _this2;}(0,_createClass3.default)(OGroup,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;if(!nextProps.isshowoperategroup){this.setState({showall:false});}if(nextProps.isshowoperategroup){(0,_callApi.callApi)("/api/workflow/forward/getHrmGroup","GET",{}).then(function(data){_this3.setState({hrmgroups:data.datas||[]});});}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return this.state.hrmgroups!==nextState.hrmgroups||this.state.showall!==nextState.showall||this.state.showAllUser!==nextState.showAllUser||this.state.addgroupVisable!==nextState.addgroupVisable||this.state.allUserCount!==nextState.allUserCount;}},{key:"addgroup",value:function addgroup(handleVisibleChange){this.setState({addgroupVisable:true});handleVisibleChange(false);}},{key:"add",value:function add(setOperatorIds,handleVisibleChange,groupobj){//公共組
var params={isAllUser:false};if(groupobj.grouptype=="4"){params.datas=[groupobj];}if(groupobj.grouptype=="6"){params.datas=groupobj.users;}setOperatorIds(params);handleVisibleChange(false);}},{key:"showAllOperators",value:function showAllOperators(){var _this4=this;var _state=this.state,showAllUser=_state.showAllUser,allUserIds=_state.allUserIds,allUserCount=_state.allUserCount;if(showAllUser){var _props=this.props,handleVisibleChange=_props.handleVisibleChange,setOperatorIds=_props.setOperatorIds;var params={ids:allUserIds,isAllUser:true,count:allUserCount};setOperatorIds(params);handleVisibleChange(false);}else{(0,_callApi.callApi)("/api/workflow/hrmgroup/datas","GET",{isgetallres:"1"}).then(function(data){_this4.setState({showAllUser:true,allUserIds:data.ids,allUserCount:data.count});});}}},{key:"render",value:function render(){var _this5=this;var _props2=this.props,handleVisibleChange=_props2.handleVisibleChange,setOperatorIds=_props2.setOperatorIds,iconBgcolor=_props2.iconBgcolor,icon=_props2.icon;var _state2=this.state,showall=_state2.showall,hrmgroups=_state2.hrmgroups,showAllUser=_state2.showAllUser,allUserCount=_state2.allUserCount,addgroupVisable=_state2.addgroupVisable;return React.createElement("div",{className:"wea-req-operate-group"},React.createElement("div",{className:"wea-req-all-operators",onClick:this.showAllOperators.bind(this)},React.createElement("span",null,getLabel(1340,"所有人"),showAllUser&&"（"+allUserCount+"）")),React.createElement("div",{className:"wea-req-operate-content"},React.createElement(_weaScroll2.default,{className:"wea-scroll",typeClass:"scrollbar-macosx"},React.createElement("ul",null,hrmgroups&&hrmgroups.map(function(o,index){if(index>2&&!showall){return true;}var count=o.users.length;return React.createElement("li",{onClick:_this5.add.bind(_this5,setOperatorIds,handleVisibleChange,o)},React.createElement("span",{className:"cg_title"},o.lastname+"\uFF08"+count+"\u4EBA\uFF09"),React.createElement("span",{className:"cg_detail"},o.names));})))),hrmgroups.length>3&&!showall&&React.createElement("div",{className:"wea-req-operate-load-more",onClick:function onClick(){return _this5.setState({showall:true});}},React.createElement(_antd.Icon,{type:"down"}),React.createElement("span",{style:{color:"#4397d3","margin-left":"10px"}},getLabel(20234,"显示全部"))),React.createElement("div",{className:"wea-req-operate-add",onClick:function onClick(){return _this5.addgroup(handleVisibleChange);}},React.createElement("span",{style:{color:"#59b632"}},React.createElement(_antd.Icon,{type:"plus-square"})),React.createElement("span",{style:{color:"#323232","margin-left":"10px"}},getLabel(124815,"添加常用组"))),React.createElement(_addGroup2.default,{visible:addgroupVisable,onVisableChange:function onVisableChange(){return _this5.setState({addgroupVisable:false});}}));}}]);return OGroup;}(React.Component);exports.default=OGroup;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * jQuery CSS Customizable Scrollbar
 *
 * Copyright 2015, Yuriy Khabarov
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * If you found bug, please contact me via email <13real008@gmail.com>
 *
 * @author Yuriy Khabarov aka Gromo
 * @version 0.2.11
 * @url https://github.com/gromo/jquery.scrollbar/
 *
 */;(function(root,factory){if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(506)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else if(typeof exports!=="undefined"){factory(require('jquery'));}else{factory(root.jQuery);}})(undefined,function($){'use strict';// init flags & variables
var debug=false;var browser={data:{index:0,name:'scrollbar'},firefox:/firefox/i.test(navigator.userAgent),macosx:/mac/i.test(navigator.platform),msedge:/edge\/\d+/i.test(navigator.userAgent),msie:/(msie|trident)/i.test(navigator.userAgent),mobile:/android|webos|iphone|ipad|ipod|blackberry/i.test(navigator.userAgent),overlay:null,scroll:null,scrolls:[],webkit:/webkit/i.test(navigator.userAgent)&&!/edge\/\d+/i.test(navigator.userAgent)};browser.scrolls.add=function(instance){this.remove(instance).push(instance);};browser.scrolls.remove=function(instance){while($.inArray(instance,this)>=0){this.splice($.inArray(instance,this),1);}return this;};var defaults={autoScrollSize:true,// automatically calculate scrollsize
autoUpdate:true,// update scrollbar if content/container size changed
debug:false,// debug mode
disableBodyScroll:false,// disable body scroll if mouse over container
duration:200,// scroll animate duration in ms
ignoreMobile:false,// ignore mobile devices
ignoreOverlay:false,// ignore browsers with overlay scrollbars (mobile, MacOS)
isRtl:false,// is RTL
scrollStep:30,// scroll step for scrollbar arrows
showArrows:false,// add class to show arrows
stepScrolling:true,// when scrolling to scrollbar mousedown position
scrollx:null,// horizontal scroll element
scrolly:null,// vertical scroll element
onDestroy:null,// callback function on destroy,
onFallback:null,// callback function if scrollbar is not initialized
onInit:null,// callback function on first initialization
onScroll:null,// callback function on content scrolling
onUpdate:null// callback function on init/resize (before scrollbar size calculation)
};var BaseScrollbar=function BaseScrollbar(container){if(!browser.scroll){browser.overlay=isScrollOverlaysContent();browser.scroll=getBrowserScrollSize();updateScrollbars();$(window).resize(function(){var forceUpdate=false;if(browser.scroll&&(browser.scroll.height||browser.scroll.width)){var scroll=getBrowserScrollSize();if(scroll.height!==browser.scroll.height||scroll.width!==browser.scroll.width){browser.scroll=scroll;forceUpdate=true;// handle page zoom
}}updateScrollbars(forceUpdate);});}this.container=container;this.namespace='.scrollbar_'+browser.data.index++;this.options=$.extend({},defaults,window.jQueryScrollbarOptions||{});this.scrollTo=null;this.scrollx={};this.scrolly={};container.data(browser.data.name,this);browser.scrolls.add(this);};BaseScrollbar.prototype={destroy:function destroy(){if(!this.wrapper){return;}this.container.removeData(browser.data.name);browser.scrolls.remove(this);// init variables
var scrollLeft=this.container.scrollLeft();var scrollTop=this.container.scrollTop();this.container.insertBefore(this.wrapper).css({"height":"","margin":"","max-height":""}).removeClass('scroll-content scroll-scrollx_visible scroll-scrolly_visible').off(this.namespace).scrollLeft(scrollLeft).scrollTop(scrollTop);this.scrollx.scroll.removeClass('scroll-scrollx_visible').find('div').addBack().off(this.namespace);this.scrolly.scroll.removeClass('scroll-scrolly_visible').find('div').addBack().off(this.namespace);this.wrapper.remove();$(document).add('body').off(this.namespace);if($.isFunction(this.options.onDestroy)){this.options.onDestroy.apply(this,[this.container]);}},init:function init(options){// init variables
var S=this,c=this.container,cw=this.containerWrapper||c,namespace=this.namespace,o=$.extend(this.options,options||{}),s={x:this.scrollx,y:this.scrolly},w=this.wrapper,cssOptions={};var initScroll={scrollLeft:c.scrollLeft(),scrollTop:c.scrollTop()};// do not init if in ignorable browser
if(browser.mobile&&o.ignoreMobile||browser.overlay&&o.ignoreOverlay||browser.macosx&&!browser.webkit// still required to ignore nonWebKit browsers on Mac
){if($.isFunction(o.onFallback)){o.onFallback.apply(this,[c]);}return false;}// init scroll container
if(!w){this.wrapper=w=$('<div>').addClass('scroll-wrapper').addClass(c.attr('class')).css('position',c.css('position')==='absolute'?'absolute':'relative').insertBefore(c).append(c);if(o.isRtl){w.addClass('scroll--rtl');}if(c.is('textarea')){this.containerWrapper=cw=$('<div>').insertBefore(c).append(c);w.addClass('scroll-textarea');}cssOptions={"height":"auto","margin-bottom":browser.scroll.height*-1+'px',"max-height":""};cssOptions[o.isRtl?'margin-left':'margin-right']=browser.scroll.width*-1+'px';cw.addClass('scroll-content').css(cssOptions);c.on('scroll'+namespace,function(event){var scrollLeft=c.scrollLeft();var scrollTop=c.scrollTop();if(o.isRtl){// webkit   0:100
// ie/edge  100:0
// firefox -100:0
switch(true){case browser.firefox:scrollLeft=Math.abs(scrollLeft);case browser.msedge||browser.msie:scrollLeft=c[0].scrollWidth-c[0].clientWidth-scrollLeft;break;}}if($.isFunction(o.onScroll)){o.onScroll.call(S,{maxScroll:s.y.maxScrollOffset,scroll:scrollTop,size:s.y.size,visible:s.y.visible},{maxScroll:s.x.maxScrollOffset,scroll:scrollLeft,size:s.x.size,visible:s.x.visible});}s.x.isVisible&&s.x.scroll.bar.css('left',scrollLeft*s.x.kx+'px');s.y.isVisible&&s.y.scroll.bar.css('top',scrollTop*s.y.kx+'px');});/* prevent native scrollbars to be visible on #anchor click */w.on('scroll'+namespace,function(){w.scrollTop(0).scrollLeft(0);});if(o.disableBodyScroll){var handleMouseScroll=function handleMouseScroll(event){isVerticalScroll(event)?s.y.isVisible&&s.y.mousewheel(event):s.x.isVisible&&s.x.mousewheel(event);};w.on('MozMousePixelScroll'+namespace,handleMouseScroll);w.on('mousewheel'+namespace,handleMouseScroll);if(browser.mobile){w.on('touchstart'+namespace,function(event){var touch=event.originalEvent.touches&&event.originalEvent.touches[0]||event;var originalTouch={pageX:touch.pageX,pageY:touch.pageY};var originalScroll={left:c.scrollLeft(),top:c.scrollTop()};$(document).on('touchmove'+namespace,function(event){var touch=event.originalEvent.targetTouches&&event.originalEvent.targetTouches[0]||event;c.scrollLeft(originalScroll.left+originalTouch.pageX-touch.pageX);c.scrollTop(originalScroll.top+originalTouch.pageY-touch.pageY);event.preventDefault();});$(document).on('touchend'+namespace,function(){$(document).off(namespace);});});}}if($.isFunction(o.onInit)){o.onInit.apply(this,[c]);}}else{if($.isFunction(o.onInit)){o.onInit.apply(this);}//IE8 BUG height:'auto'
cssOptions={"height":'100%',"margin-bottom":browser.scroll.height*-1+'px',"max-height":""};cssOptions[o.isRtl?'margin-left':'margin-right']=browser.scroll.width*-1+'px';cw.css(cssOptions);}// init scrollbars & recalculate sizes
$.each(s,function(d,scrollx){var scrollCallback=null;var scrollForward=1;var scrollOffset=d==='x'?'scrollLeft':'scrollTop';var scrollStep=o.scrollStep;var scrollTo=function scrollTo(){var currentOffset=c[scrollOffset]();c[scrollOffset](currentOffset+scrollStep);if(scrollForward==1&&currentOffset+scrollStep>=scrollToValue)currentOffset=c[scrollOffset]();if(scrollForward==-1&&currentOffset+scrollStep<=scrollToValue)currentOffset=c[scrollOffset]();if(c[scrollOffset]()==currentOffset&&scrollCallback){scrollCallback();}};var scrollToValue=0;if(!scrollx.scroll){scrollx.scroll=S._getScroll(o['scroll'+d]).addClass('scroll-'+d);if(o.showArrows){scrollx.scroll.addClass('scroll-element_arrows_visible');}scrollx.mousewheel=function(event){if(!scrollx.isVisible||d==='x'&&isVerticalScroll(event)){return true;}if(d==='y'&&!isVerticalScroll(event)){s.x.mousewheel(event);return true;}var delta=event.originalEvent.wheelDelta*-1||event.originalEvent.detail;var maxScrollValue=scrollx.size-scrollx.visible-scrollx.offset;// fix new mozilla
if(!delta){if(d==='x'&&!!event.originalEvent.deltaX){delta=event.originalEvent.deltaX*40;}else if(d==='y'&&!!event.originalEvent.deltaY){delta=event.originalEvent.deltaY*40;}}if(delta>0&&scrollToValue<maxScrollValue||delta<0&&scrollToValue>0){scrollToValue=scrollToValue+delta;if(scrollToValue<0)scrollToValue=0;if(scrollToValue>maxScrollValue)scrollToValue=maxScrollValue;S.scrollTo=S.scrollTo||{};S.scrollTo[scrollOffset]=scrollToValue;setTimeout(function(){if(S.scrollTo){c.stop().animate(S.scrollTo,240,'linear',function(){scrollToValue=c[scrollOffset]();});S.scrollTo=null;}},1);}event.preventDefault();return false;};scrollx.scroll.on('MozMousePixelScroll'+namespace,scrollx.mousewheel).on('mousewheel'+namespace,scrollx.mousewheel).on('mouseenter'+namespace,function(){scrollToValue=c[scrollOffset]();});// handle arrows & scroll inner mousedown event
scrollx.scroll.find('.scroll-arrow, .scroll-element_track').on('mousedown'+namespace,function(event){if(event.which!=1)// lmb
return true;scrollForward=1;var data={eventOffset:event[d==='x'?'pageX':'pageY'],maxScrollValue:scrollx.size-scrollx.visible-scrollx.offset,scrollbarOffset:scrollx.scroll.bar.offset()[d==='x'?'left':'top'],scrollbarSize:scrollx.scroll.bar[d==='x'?'outerWidth':'outerHeight']()};var timeout=0,timer=0;if($(this).hasClass('scroll-arrow')){scrollForward=$(this).hasClass("scroll-arrow_more")?1:-1;scrollStep=o.scrollStep*scrollForward;scrollToValue=scrollForward>0?data.maxScrollValue:0;if(o.isRtl){switch(true){case browser.firefox:scrollToValue=scrollForward>0?0:data.maxScrollValue*-1;break;case browser.msie||browser.msedge:break;}}}else{scrollForward=data.eventOffset>data.scrollbarOffset+data.scrollbarSize?1:data.eventOffset<data.scrollbarOffset?-1:0;if(d==='x'&&o.isRtl&&(browser.msie||browser.msedge))scrollForward=scrollForward*-1;scrollStep=Math.round(scrollx.visible*0.75)*scrollForward;scrollToValue=data.eventOffset-data.scrollbarOffset-(o.stepScrolling?scrollForward==1?data.scrollbarSize:0:Math.round(data.scrollbarSize/2));scrollToValue=c[scrollOffset]()+scrollToValue/scrollx.kx;}S.scrollTo=S.scrollTo||{};S.scrollTo[scrollOffset]=o.stepScrolling?c[scrollOffset]()+scrollStep:scrollToValue;if(o.stepScrolling){scrollCallback=function scrollCallback(){scrollToValue=c[scrollOffset]();clearInterval(timer);clearTimeout(timeout);timeout=0;timer=0;};timeout=setTimeout(function(){timer=setInterval(scrollTo,40);},o.duration+100);}setTimeout(function(){if(S.scrollTo){c.animate(S.scrollTo,o.duration);S.scrollTo=null;}},1);return S._handleMouseDown(scrollCallback,event);});// handle scrollbar drag'n'drop
scrollx.scroll.bar.on('mousedown'+namespace,function(event){if(event.which!=1)// lmb
return true;var eventPosition=event[d==='x'?'pageX':'pageY'];var initOffset=c[scrollOffset]();scrollx.scroll.addClass('scroll-draggable');$(document).on('mousemove'+namespace,function(event){var diff=parseInt((event[d==='x'?'pageX':'pageY']-eventPosition)/scrollx.kx,10);if(d==='x'&&o.isRtl&&(browser.msie||browser.msedge))diff=diff*-1;c[scrollOffset](initOffset+diff);});return S._handleMouseDown(function(){scrollx.scroll.removeClass('scroll-draggable');scrollToValue=c[scrollOffset]();},event);});}});// remove classes & reset applied styles
$.each(s,function(d,scrollx){var scrollClass='scroll-scroll'+d+'_visible';var scrolly=d=="x"?s.y:s.x;scrollx.scroll.removeClass(scrollClass);scrolly.scroll.removeClass(scrollClass);cw.removeClass(scrollClass);});// calculate init sizes
$.each(s,function(d,scrollx){$.extend(scrollx,d=="x"?{offset:parseInt(c.css('left'),10)||0,size:c.prop('scrollWidth'),visible:w.width()}:{offset:parseInt(c.css('top'),10)||0,size:c.prop('scrollHeight'),visible:w.height()});});// update scrollbar visibility/dimensions
this._updateScroll('x',this.scrollx);this._updateScroll('y',this.scrolly);if($.isFunction(o.onUpdate)){o.onUpdate.apply(this,[c]);}// calculate scroll size
$.each(s,function(d,scrollx){var cssOffset=d==='x'?'left':'top';var cssFullSize=d==='x'?'outerWidth':'outerHeight';var cssSize=d==='x'?'width':'height';var offset=parseInt(c.css(cssOffset),10)||0;var AreaSize=scrollx.size;var AreaVisible=scrollx.visible+offset;var scrollSize=scrollx.scroll.size[cssFullSize]()+(parseInt(scrollx.scroll.size.css(cssOffset),10)||0);if(o.autoScrollSize){scrollx.scrollbarSize=parseInt(scrollSize*AreaVisible/AreaSize,10);scrollx.scroll.bar.css(cssSize,scrollx.scrollbarSize+'px');}scrollx.scrollbarSize=scrollx.scroll.bar[cssFullSize]();scrollx.kx=(scrollSize-scrollx.scrollbarSize)/(AreaSize-AreaVisible)||1;scrollx.maxScrollOffset=AreaSize-AreaVisible;});c.scrollLeft(initScroll.scrollLeft).scrollTop(initScroll.scrollTop).trigger('scroll');},/**
         * Get scrollx/scrolly object
         *
         * @param {Mixed} scroll
         * @returns {jQuery} scroll object
         */_getScroll:function _getScroll(scroll){var types={advanced:['<div class="scroll-element">','<div class="scroll-element_corner"></div>','<div class="scroll-arrow scroll-arrow_less"></div>','<div class="scroll-arrow scroll-arrow_more"></div>','<div class="scroll-element_outer">','<div class="scroll-element_size"></div>',// required! used for scrollbar size calculation !
'<div class="scroll-element_inner-wrapper">','<div class="scroll-element_inner scroll-element_track">',// used for handling scrollbar click
'<div class="scroll-element_inner-bottom"></div>','</div>','</div>','<div class="scroll-bar">',// required
'<div class="scroll-bar_body">','<div class="scroll-bar_body-inner"></div>','</div>','<div class="scroll-bar_bottom"></div>','<div class="scroll-bar_center"></div>','</div>','</div>','</div>'].join(''),simple:['<div class="scroll-element">','<div class="scroll-element_outer">','<div class="scroll-element_size"></div>',// required! used for scrollbar size calculation !
'<div class="scroll-element_track"></div>',// used for handling scrollbar click
'<div class="scroll-bar"></div>',// required
'</div>','</div>'].join('')};if(types[scroll]){scroll=types[scroll];}if(!scroll){scroll=types['simple'];}if(typeof scroll=='string'){scroll=$(scroll).appendTo(this.wrapper);}else{scroll=$(scroll);}$.extend(scroll,{bar:scroll.find('.scroll-bar'),size:scroll.find('.scroll-element_size'),track:scroll.find('.scroll-element_track')});return scroll;},_handleMouseDown:function _handleMouseDown(callback,event){var namespace=this.namespace;$(document).on('blur'+namespace,function(){$(document).add('body').off(namespace);callback&&callback();});$(document).on('dragstart'+namespace,function(event){event.preventDefault();return false;});$(document).on('mouseup'+namespace,function(){$(document).add('body').off(namespace);callback&&callback();});$('body').on('selectstart'+namespace,function(event){event.preventDefault();return false;});event&&event.preventDefault();return false;},_updateScroll:function _updateScroll(d,scrollx){var container=this.container,containerWrapper=this.containerWrapper||container,scrollClass='scroll-scroll'+d+'_visible',scrolly=d==='x'?this.scrolly:this.scrollx,offset=parseInt(this.container.css(d==='x'?'left':'top'),10)||0,wrapper=this.wrapper;var AreaSize=scrollx.size;var AreaVisible=scrollx.visible+offset;scrollx.isVisible=AreaSize-AreaVisible>1;// bug in IE9/11 with 1px diff
if(scrollx.isVisible){scrollx.scroll.addClass(scrollClass);scrolly.scroll.addClass(scrollClass);containerWrapper.addClass(scrollClass);}else{scrollx.scroll.removeClass(scrollClass);scrolly.scroll.removeClass(scrollClass);containerWrapper.removeClass(scrollClass);}if(d==='y'){if(container.is('textarea')||AreaSize<AreaVisible){containerWrapper.css({"height":AreaVisible+browser.scroll.height+'px',"max-height":"none"});}else{containerWrapper.css({//"height": "auto", // do not reset height value: issue with height:100%!
"max-height":AreaVisible+browser.scroll.height+'px'});}}if(scrollx.size!=container.prop('scrollWidth')||scrolly.size!=container.prop('scrollHeight')||scrollx.visible!=wrapper.width()||scrolly.visible!=wrapper.height()||scrollx.offset!=(parseInt(container.css('left'),10)||0)||scrolly.offset!=(parseInt(container.css('top'),10)||0)){$.extend(this.scrollx,{offset:parseInt(container.css('left'),10)||0,size:container.prop('scrollWidth'),visible:wrapper.width()});$.extend(this.scrolly,{offset:parseInt(container.css('top'),10)||0,size:this.container.prop('scrollHeight'),visible:wrapper.height()});this._updateScroll(d==='x'?'y':'x',scrolly);}}};var CustomScrollbar=BaseScrollbar;/*
     * Extend jQuery as plugin
     *
     * @param {Mixed} command to execute
     * @param {Mixed} arguments as Array
     * @return {jQuery}
     */$.fn.scrollbar=function(command,args){if(typeof command!=='string'){args=command;command='init';}if(typeof args==='undefined'){args=[];}if(!$.isArray(args)){args=[args];}this.not('body, .scroll-wrapper').each(function(){var element=$(this),instance=element.data(browser.data.name);if(instance||command==='init'){if(!instance){instance=new CustomScrollbar(element);}if(instance[command]){instance[command].apply(instance,args);}}});return this;};/**
     * Connect default options to global object
     */$.fn.scrollbar.options=defaults;/**
     * Check if scroll content/container size is changed
     */var updateScrollbars=function(){var timer=0,timerCounter=0;return function(force){var i,container,options,scroll,wrapper,scrollx,scrolly;for(i=0;i<browser.scrolls.length;i++){scroll=browser.scrolls[i];container=scroll.container;options=scroll.options;wrapper=scroll.wrapper;scrollx=scroll.scrollx;scrolly=scroll.scrolly;if(force||options.autoUpdate&&wrapper&&wrapper.is(':visible')&&(container.prop('scrollWidth')!=scrollx.size||container.prop('scrollHeight')!=scrolly.size||wrapper.width()!=scrollx.visible||wrapper.height()!=scrolly.visible)){scroll.init();if(options.debug){window.console&&void 0;timerCounter++;}}}if(debug&&timerCounter>10){window.console&&void 0;updateScrollbars=function updateScrollbars(){};}else{clearTimeout(timer);timer=setTimeout(updateScrollbars,300);}};}();/* ADDITIONAL FUNCTIONS *//**
     * Get native browser scrollbar size (height/width)
     *
     * @param {Boolean} actual size or CSS size, default - CSS size
     * @returns {Object} with height, width
     */function getBrowserScrollSize(actualSize){if(browser.webkit&&!actualSize){return{height:0,width:0};}if(!browser.data.outer){var css={"border":"none","box-sizing":"content-box","height":"200px","margin":"0","padding":"0","width":"200px"};browser.data.inner=$("<div>").css($.extend({},css));browser.data.outer=$("<div>").css($.extend({"left":"-1000px","overflow":"scroll","position":"absolute","top":"-1000px"},css)).append(browser.data.inner).appendTo("body");}browser.data.outer.scrollLeft(1000).scrollTop(1000);return{height:Math.ceil(browser.data.outer.offset().top-browser.data.inner.offset().top||0),width:Math.ceil(browser.data.outer.offset().left-browser.data.inner.offset().left||0)};}/**
     * Check if native browser scrollbars overlay content
     *
     * @returns {Boolean}
     */function isScrollOverlaysContent(){var scrollSize=getBrowserScrollSize(true);return!(scrollSize.height||scrollSize.width);}function isVerticalScroll(event){var e=event.originalEvent;if(e.axis&&e.axis===e.HORIZONTAL_AXIS)return false;if(e.wheelDeltaX)return false;return true;}/**
     * Extend AngularJS as UI directive
     * and expose a provider for override default config
     *
     */if(window.angular){(function(angular){angular.module('jQueryScrollbar',[]).provider('jQueryScrollbar',function(){var defaultOptions=defaults;return{setOptions:function setOptions(options){angular.extend(defaultOptions,options);},$get:function $get(){return{options:angular.copy(defaultOptions)};}};}).directive('jqueryScrollbar',['jQueryScrollbar','$parse',function(jQueryScrollbar,$parse){return{restrict:"AC",link:function link(scope,element,attrs){var model=$parse(attrs.jqueryScrollbar),options=model(scope);element.scrollbar(options||jQueryScrollbar.options).on('$destroy',function(){element.scrollbar('destroy');});}};}]);})(window.angular);}});

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_506__;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _callApi=__webpack_require__(17);var _weaDialog=__webpack_require__(55);var _weaDialog2=_interopRequireDefault(_weaDialog);var _weaRightMenu=__webpack_require__(212);var _weaRightMenu2=_interopRequireDefault(_weaRightMenu);var _weaFormItem=__webpack_require__(47);var _weaFormItem2=_interopRequireDefault(_weaFormItem);var _weaInput=__webpack_require__(56);var _weaInput2=_interopRequireDefault(_weaInput);var _weaSelect=__webpack_require__(50);var _weaSelect2=_interopRequireDefault(_weaSelect);var _weaBrowser=__webpack_require__(80);var _weaBrowser2=_interopRequireDefault(_weaBrowser);var _weaError=__webpack_require__(82);var _weaError2=_interopRequireDefault(_weaError);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.state={name:"",type:"0",sn:null,hrmids:"",hrmidsDatas:[],savable:true};return _this;}(0,_createClass3.default)(Main,[{key:"init",value:function init(){this.setState({name:"",type:"0",sn:null,hrmids:"",hrmidsDatas:[]});}},{key:"render",value:function render(){var _this2=this;var _props=this.props,visible=_props.visible,onVisableChange=_props.onVisableChange;return _react2.default.createElement("div",null,_react2.default.createElement(_weaDialog2.default,{title:getLabel(81554,"常用组"),hasScroll:true,visible:visible,icon:"icon-coms-workflow",iconBgcolor:"#0079DE",closable:true,onCancel:function onCancel(){onVisableChange(false);_this2.init();},buttons:this.getAddModalButtons(),style:{height:"300px",width:"500px"},className:"wea-dialog-add-group-modal"},_react2.default.createElement(_weaRightMenu2.default,{datas:this.getRightMenu()},this.initGroup())));}},{key:"initGroup",value:function initGroup(){var _this3=this;var _state=this.state,name=_state.name,sn=_state.sn,type=_state.type,hrmidsDatas=_state.hrmidsDatas;return _react2.default.createElement("div",{className:"wea-form-item-group wea-addgroup-form"},_react2.default.createElement(_weaFormItem2.default,{label:getLabel(33439,"名称"),labelCol:{span:6},wrapperCol:{span:18},domkey:"name"},_react2.default.createElement(_weaError2.default,{tipPosition:"bottom",ref:"weaErrorName",error:getLabel(385562,'"名称"未填写').replace(/&quot;/g,'"')},_react2.default.createElement(_weaInput2.default,{viewAttr:3,value:name,onChange:function onChange(v){_this3.setState({name:v});if(!v)_this3.refs.weaErrorName.showError();}}))),_react2.default.createElement(_weaFormItem2.default,{label:getLabel("132033","类型"),labelCol:{span:6},wrapperCol:{span:18},domkey:"type"},_react2.default.createElement(_weaSelect2.default,{value:type,onChange:function onChange(v){_this3.setState({type:v});},options:[{key:"0",selected:true,showname:getLabel(17618,"私人组")},{key:"1",selected:false,showname:getLabel(17619,"公共组")}]})),_react2.default.createElement(_weaFormItem2.default,{label:getLabel(338,"排序"),labelCol:{span:6},wrapperCol:{span:18},domkey:"sn"},_react2.default.createElement(_antd.InputNumber,{value:sn,min:1,onChange:function onChange(v){_this3.setState({sn:v});}})),_react2.default.createElement(_weaFormItem2.default,{label:getLabel(431,"成员"),labelCol:{span:6},wrapperCol:{span:18},domkey:"hrmids"},_react2.default.createElement(_weaError2.default,{tipPosition:"bottom",ref:"weaErrorHrmids",error:getLabel(385563,'"成员"未填写').replace(/&quot;/g,'"')},_react2.default.createElement(_weaBrowser2.default,{mr0:true,type:17,isSingle:false,title:getLabel(83496,"多人力资源"),viewAttr:3,valueObj:hrmidsDatas,onChange:function onChange(v,n,datas){_this3.setState({hrmids:v,hrmidsDatas:datas});if(!v)_this3.refs.weaErrorHrmids.showError();}}))));}},{key:"getRightMenu",value:function getRightMenu(){var _this4=this;var btns=[];btns.push({key:"add",icon:_react2.default.createElement("i",{className:"icon-coms-Preservation"}),content:getLabel(30986,"保存"),onClick:function onClick(){_this4.doSave();}});return btns;}},{key:"validate",value:function validate(){var bool=true;var _state2=this.state,name=_state2.name,hrmids=_state2.hrmids;if(!name){bool=false;this.refs.weaErrorName.showError();}if(!hrmids){bool=false;this.refs.weaErrorHrmids.showError();}return bool;}},{key:"doSave",value:function doSave(){var _this5=this;var savable=this.state.savable;if(savable&&this.validate()){var resetSavable=function resetSavable(){return _this5.setState({savable:true});};this.setState({savable:false});var params=(0,_extends3.default)({},this.state);params.cmd="base";delete params.hrmidsDatas;(0,_callApi.callApi)("/api/workflow/forward/saveUserGroupCmd","POST",params).then(function(){resetSavable();_this5.init();_this5.props.onVisableChange();},function(){resetSavable();window.alert(getLabel(385564,"添加常用组失败！"));});}}},{key:"getAddModalButtons",value:function getAddModalButtons(){var _this6=this;return[_react2.default.createElement(_antd.Button,{type:"primary",onClick:function onClick(){_this6.doSave();}},getLabel(30986,"保存"))];}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var baron=__webpack_require__(75);function getDOMNode(ref){if(React.version<"0.14.0"&&ref&&ref.getDOMNode){return ref.getDOMNode();}return ref;}function on(eventNames,handler){eventNames=eventNames.split(" ");eventNames.forEach(function(eventName){this[0].addEventListener(eventName,handler);},this);}function off(eventNames,handler){eventNames=eventNames.split(" ");eventNames.forEach(function(eventName){this[0].removeEventListener(eventName,handler);},this);}function addClass(cls){this[0].classList.add(cls);}function removeClass(cls){this[0].classList.remove(cls);}function hasClass(cls){return this[0].classList.contains(cls);}function css(key,value){var obj=key;if(typeof key=="string"){if(value){this[0].style[key]=value;}return this[0].style[key];}else{for(var lkey in obj){this[0].style[lkey]=obj[lkey];}}}var jQueryLike=function jQueryLike(selector,context){var element;var rootElement=document;if(context&&context.querySelectorAll){rootElement=context;}if(typeof selector=="string"){element=rootElement.querySelectorAll(selector);}else{if(selector[0]){// If it already wrapped, dont wrap again
element=selector;return element;}else{// But if it HTMLElement, wrap it
}element=selector;}return{"0":element,length:1,on:on,off:off,addClass:addClass,removeClass:removeClass,hasClass:hasClass,css:css};};var Baron=React.createClass({displayName:"baron",componentDidMount:function componentDidMount(){var clipper=getDOMNode(this.refs.clipper);var scroller=getDOMNode(this.refs.scroller);var track=getDOMNode(this.refs.track);var bar=getDOMNode(this.refs.bar);this.baron=baron({$:this.props.$||window.jQuery,root:clipper,scroller:scroller,barOnCls:this.props.barOnCls,direction:this.props.direction,track:track,bar:bar,impact:this.props.impact,cssGuru:this.props.cssGuru});},componentDidUpdate:function componentDidUpdate(){this.baron.update();},scrollToLast:function scrollToLast(){var scroll=this.props.direction==="v"?"scrollTop":"scrollLeft";var size=this.props.direction==="v"?"scrollHeight":"scrollWidth";var node=getDOMNode(this.refs.scroller);node[scroll]=node[size];},getScroller:function getScroller(){return getDOMNode(this.refs.scroller);},getClipper:function getClipper(){return getDOMNode(this.refs.clipper);},getBar:function getBar(){return getDOMNode(this.refs.bar);},componentWillUnmount:function componentWillUnmount(){this.baron.dispose();this.baron=null;},render:function render(){var barCls=this.props.barCls;var trackCls=this.props.trackCls;if(this.props.direction==="h"){barCls+=" "+this.props.hModifier;trackCls+=" "+this.props.hModifier;}return React.createElement("div",{className:this.props.clipperCls,ref:"clipper",ecId:this.props.ecId+"_div@q0gmjp"},React.createElement("div",{className:this.props.scrollerCls,ref:"scroller",onScroll:this.props.onScroll,ecId:this.props.ecId+"_div@o12fam"},this.props.children),React.createElement("div",{className:trackCls,ref:"track",ecId:this.props.ecId+"_div@2zqrd9"},React.createElement("div",{className:barCls,ref:"bar",ecId:this.props.ecId+"_div@dvsfzh"})));}});Baron.propTypes={clipperCls:React.PropTypes.string,scrollerCls:React.PropTypes.string,trackCls:React.PropTypes.string,barCls:React.PropTypes.string,barOnCls:React.PropTypes.string,onScroll:React.PropTypes.func,$:React.PropTypes.func};Baron.defaultProps={clipperCls:"clipper",scrollerCls:"scroller",trackCls:"track",barCls:"bar",barOnCls:"baron",direction:"v",hModifier:"_h",impact:undefined,$:jQueryLike};module.exports=Baron;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Fixable elements plugin for baron 0.6+ */(function(){var scopedWindow=function(){return this||(1,eval)("this");}();var scopedBaron;if(true){scopedBaron=__webpack_require__(75);}else{scopedBaron=scopedWindow.baron;}// removeIf(production)
var log=function log(){scopedBaron.fn.log.apply(this,arguments);};// endRemoveIf(production)
var fix=function fix(userParams){var elements,viewPortSize,params={// Default params
outside:"",inside:"",before:"",after:"",past:"",future:"",radius:0,minView:0},topFixHeights=[],// inline style for element
topRealHeights=[],// ? something related to negative margins for fixable elements
headerTops=[],// offset positions when not fixed
scroller=this.scroller,eventManager=this.event,$=this.$,self=this;// removeIf(production)
if(this.position!="static"){log("error",["Fix plugin cannot work properly in non-static baron position.","See more https://github.com/Diokuz/baron/issues/135"].join(" "),this.params);}// endRemoveIf(production)
// i - number of fixing element, pos - fix-position in px, flag - 1: top, 2: bottom
// Invocation only in case when fix-state changed
function fixElement(i,_pos,flag){var pos=_pos;var ori=flag==1?"pos":"oppos";if(viewPortSize<(params.minView||0)){// No headers fixing when no enought space for viewport
pos=undefined;}// Removing all fixing stuff - we can do this because fixElement triggers only when fixState really changed
this.$(elements[i]).css(this.origin.pos,"").css(this.origin.oppos,"").removeClass(params.outside);// Fixing if needed
if(pos!==undefined){pos+="px";this.$(elements[i]).css(this.origin[ori],pos).addClass(params.outside);}}function bubbleWheel(e){try{var i=document.createEvent("WheelEvent");// i - for extra byte
// evt.initWebKitWheelEvent(deltaX, deltaY, window, screenX, screenY, clientX, clientY, ctrlKey, altKey, shiftKey, metaKey)
i.initWebKitWheelEvent(e.originalEvent.wheelDeltaX,e.originalEvent.wheelDeltaY);scroller.dispatchEvent(i);e.preventDefault();}catch(ex){//
}}function init(_params){var pos;for(var key in _params){params[key]=_params[key];}elements=this.$(params.elements,this.scroller);if(elements){viewPortSize=this.scroller[this.origin.client];for(var i=0;i<elements.length;i++){// Variable header heights
pos={};pos[this.origin.size]=elements[i][this.origin.offset];if(elements[i].parentNode!==this.scroller){this.$(elements[i].parentNode).css(pos);}pos={};pos[this.origin.crossSize]=elements[i].parentNode[this.origin.crossClient];this.$(elements[i]).css(pos);// Between fixed headers
viewPortSize-=elements[i][this.origin.offset];headerTops[i]=elements[i].parentNode[this.origin.offsetPos];// No paddings for parentNode
// Summary elements height above current
topFixHeights[i]=topFixHeights[i-1]||0;// Not zero because of negative margins
topRealHeights[i]=topRealHeights[i-1]||Math.min(headerTops[i],0);if(elements[i-1]){topFixHeights[i]+=elements[i-1][this.origin.offset];topRealHeights[i]+=elements[i-1][this.origin.offset];}if(!(i==0&&headerTops[i]==0)/* && force */){this.event(elements[i],"mousewheel",bubbleWheel,"off");this.event(elements[i],"mousewheel",bubbleWheel);}}if(params.limiter&&elements[0]){// Bottom edge of first header as top limit for track
if(this.track&&this.track!=this.scroller){pos={};pos[this.origin.pos]=elements[0].parentNode[this.origin.offset];this.$(this.track).css(pos);}else{this.barTopLimit=elements[0].parentNode[this.origin.offset];}// this.barTopLimit = elements[0].parentNode[this.origin.offset]
this.scroll();}if(params.limiter===false){// undefined (in second fix instance) should have no influence on bar limit
this.barTopLimit=0;}}var event={element:elements,handler:function handler(){var parent=$(this)[0].parentNode,top=parent.offsetTop,num;// finding num -> elements[num] === this
for(var j=0;j<elements.length;j++){if(elements[j]===this)num=j;}var locPos=top-topFixHeights[num];if(params.scroll){// User defined callback
params.scroll({x1:self.scroller.scrollTop,x2:locPos});}else{self.scroller.scrollTop=locPos;}},type:"click"};if(params.clickable){this._eventHandlers.push(event);// For auto-dispose
// eventManager(event.element, event.type, event.handler, 'off')
eventManager(event.element,event.type,event.handler,"on");}}this.on("init",init,userParams);var fixFlag=[],// 1 - past, 2 - future, 3 - current (not fixed)
gradFlag=[];this.on("init scroll",function(){var fixState,hTop,gradState;var i;if(elements){var change;// fixFlag update
for(i=0;i<elements.length;i++){fixState=0;if(headerTops[i]-this.pos()<topRealHeights[i]+params.radius){// Header trying to go up
fixState=1;hTop=topFixHeights[i];}else if(headerTops[i]-this.pos()>topRealHeights[i]+viewPortSize-params.radius){// Header trying to go down
fixState=2;// console.log('topFixHeights[i] + viewPortSize + topRealHeights[i]', topFixHeights[i], this.scroller[this.origin.client], topRealHeights[i])
hTop=this.scroller[this.origin.client]-elements[i][this.origin.offset]-topFixHeights[i]-viewPortSize;// console.log('hTop', hTop, viewPortSize, elements[this.origin.offset], topFixHeights[i])
// (topFixHeights[i] + viewPortSize + elements[this.origin.offset]) - this.scroller[this.origin.client]
}else{// Header in viewport
fixState=3;hTop=undefined;}gradState=false;if(headerTops[i]-this.pos()<topRealHeights[i]||headerTops[i]-this.pos()>topRealHeights[i]+viewPortSize){gradState=true;}if(fixState!=fixFlag[i]||gradState!=gradFlag[i]){fixElement.call(this,i,hTop,fixState);fixFlag[i]=fixState;gradFlag[i]=gradState;change=true;}}// Adding positioning classes (on last top and first bottom header)
if(change){// At leats one change in elements flag structure occured
for(i=0;i<elements.length;i++){if(fixFlag[i]==1&&params.past){this.$(elements[i]).addClass(params.past).removeClass(params.future);}if(fixFlag[i]==2&&params.future){this.$(elements[i]).addClass(params.future).removeClass(params.past);}if(fixFlag[i]==3){if(params.future||params.past)this.$(elements[i]).removeClass(params.past).removeClass(params.future);if(params.inside)this.$(elements[i]).addClass(params.inside);}else if(params.inside){this.$(elements[i]).removeClass(params.inside);}if(fixFlag[i]!=fixFlag[i+1]&&fixFlag[i]==1&&params.before){this.$(elements[i]).addClass(params.before).removeClass(params.after);// Last top fixed header
}else if(fixFlag[i]!=fixFlag[i-1]&&fixFlag[i]==2&&params.after){this.$(elements[i]).addClass(params.after).removeClass(params.before);// First bottom fixed header
}else{this.$(elements[i]).removeClass(params.before).removeClass(params.after);}if(params.grad){if(gradFlag[i]){this.$(elements[i]).addClass(params.grad);}else{this.$(elements[i]).removeClass(params.grad);}}}}}});this.on("resize upd",function(updParams){init.call(this,updParams&&updParams.fix);});};scopedBaron.fn.fix=function(params){var i=0;while(this[i]){fix.call(this[i],params);i++;}return this;};})();

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Pull to load plugin for baron 0.6+ */(function(){var scopedWindow=function(){return this||(1,eval)("this");}();var scopedBaron;if(true){scopedBaron=__webpack_require__(75);}else{scopedBaron=scopedWindow.baron;}var pull=function pull(params){var block=this.$(params.block),size=params.size||this.origin.size,limit=params.limit||80,onExpand=params.onExpand,elements=params.elements||[],inProgress=params.inProgress||"",self=this,_insistence=0,_zeroXCount=0,_interval,_timer,_x=0,_onExpandCalled,_waiting=params.waiting||500,_on;function getSize(){return self.scroller[self.origin.scroll]+self.scroller[self.origin.offset];}// Scroller content height
function getContentSize(){return self.scroller[self.origin.scrollSize];}// Scroller height
function getScrollerSize(){return self.scroller[self.origin.client];}function step(x,force){var k=x*0.0005;return Math.floor(force-k*(x+550));}function toggle(on){_on=on;if(on){update();// First time with no delay
_interval=setInterval(update,200);}else{clearInterval(_interval);}}function update(){var pos={},height=getSize(),scrollHeight=getContentSize(),dx,op4,scrollInProgress=_insistence==1;op4=0;// Возвращающая сила
if(_insistence>0){op4=40;}// if (_insistence > -1) {
dx=step(_x,op4);if(height>=scrollHeight-_x&&_insistence>-1){if(scrollInProgress){_x+=dx;}}else{_x=0;}if(_x<0)_x=0;pos[size]=_x+"px";if(getScrollerSize()<=getContentSize()){self.$(block).css(pos);for(var i=0;i<elements.length;i++){self.$(elements[i].self).css(elements[i].property,Math.min(_x/limit*100,100)+"%");}}if(inProgress&&_x){self.$(self.root).addClass(inProgress);}if(_x==0){if(params.onCollapse){params.onCollapse();}}_insistence=0;_timer=setTimeout(function(){_insistence=-1;},_waiting);// }
if(onExpand&&_x>limit&&!_onExpandCalled){onExpand();_onExpandCalled=true;}if(_x==0){_zeroXCount++;}else{_zeroXCount=0;}if(_zeroXCount>1){toggle(false);_onExpandCalled=false;if(inProgress){self.$(self.root).removeClass(inProgress);}}}this.on("init",function(){toggle(true);});this.on("dispose",function(){toggle(false);});this.event(this.scroller,"mousewheel DOMMouseScroll",function(e){var down=e.wheelDelta<0||e.originalEvent&&e.originalEvent.wheelDelta<0||e.detail>0;if(down){_insistence=1;clearTimeout(_timer);if(!_on&&getSize()>=getContentSize()){toggle(true);}}//  else {
//     toggle(false)
// }
});};scopedBaron.fn.pull=function(params){var i=0;while(this[i]){pull.call(this[i],params);i++;}return this;};})();

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Controls plugin for baron 0.6+ */(function(){var scopedWindow=function(){return this||(1,eval)("this");}();var scopedBaron;if(true){scopedBaron=__webpack_require__(75);}else{scopedBaron=scopedWindow.baron;}var controls=function controls(params){var forward,backward,track,screen,self=this,// AAAAAA!!!!!11
event;screen=params.screen||0.9;if(params.forward){forward=this.$(params.forward,this.clipper);event={element:forward,handler:function handler(){var y=self.pos()+(params.delta||30);self.pos(y);},type:"click"};this._eventHandlers.push(event);// For auto-dispose
this.event(event.element,event.type,event.handler,"on");}if(params.backward){backward=this.$(params.backward,this.clipper);event={element:backward,handler:function handler(){var y=self.pos()-(params.delta||30);self.pos(y);},type:"click"};this._eventHandlers.push(event);// For auto-dispose
this.event(event.element,event.type,event.handler,"on");}if(params.track){if(params.track===true){track=this.track;}else{track=this.$(params.track,this.clipper)[0];}if(track){event={element:track,handler:function handler(e){// https://github.com/Diokuz/baron/issues/121
if(e.target!=track)return;var x=e["offset"+self.origin.x],xBar=self.bar[self.origin.offsetPos],sign=0;if(x<xBar){sign=-1;}else if(x>xBar+self.bar[self.origin.offset]){sign=1;}var y=self.pos()+sign*screen*self.scroller[self.origin.client];self.pos(y);},type:"mousedown"};this._eventHandlers.push(event);// For auto-dispose
this.event(event.element,event.type,event.handler,"on");}}};scopedBaron.fn.controls=function(params){var i=0;while(this[i]){controls.call(this[i],params);i++;}return this;};})();

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Autoupdate plugin for baron 0.6+ */(function(){var scopedWindow=function(){return this||(1,eval)("this");}();var scopedBaron;if(true){scopedBaron=__webpack_require__(75);}else{scopedBaron=scopedWindow.baron;}var MutationObserver=scopedWindow.MutationObserver||scopedWindow.WebKitMutationObserver||scopedWindow.MozMutationObserver||null;var autoUpdate=function autoUpdate(){var self=this;var watcher;if(this._au){return;}function actualizeWatcher(){if(!self.root[self.origin.offset]){startWatch();}else{stopWatch();}}// Set interval timeout for watching when root node will be visible
function startWatch(){if(watcher)return;watcher=setInterval(function(){if(self.root[self.origin.offset]){stopWatch();self.update();}},300);// is it good enought for you?)
}function stopWatch(){clearInterval(watcher);watcher=null;}var debouncedUpdater=self._debounce(function(){self.update();},300);this._observer=new MutationObserver(function(){actualizeWatcher();self.update();debouncedUpdater();});this.on("init",function(){self._observer.observe(self.root,{childList:true,subtree:true,characterData:true// attributes: true
// No reasons to set attributes to true
// The case when root/child node with already properly inited baron toggled to hidden and then back to visible,
// and the size of parent was changed during that hidden state, is very rare
// Other cases are covered by watcher, and you still can do .update by yourself
});actualizeWatcher();});this.on("dispose",function(){self._observer.disconnect();stopWatch();delete self._observer;});this._au=true;};scopedBaron.fn.autoUpdate=function(params){if(!MutationObserver)return this;var i=0;while(this[i]){autoUpdate.call(this[i],params);i++;}return this;};})();

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(124), __webpack_require__(514), __webpack_require__(515), __webpack_require__(76), __webpack_require__(77), __webpack_require__(180), __webpack_require__(254), __webpack_require__(516), __webpack_require__(255), __webpack_require__(517), __webpack_require__(518), __webpack_require__(519), __webpack_require__(181), __webpack_require__(520), __webpack_require__(64), __webpack_require__(22), __webpack_require__(521), __webpack_require__(522), __webpack_require__(523), __webpack_require__(524), __webpack_require__(525), __webpack_require__(526), __webpack_require__(527), __webpack_require__(528), __webpack_require__(529), __webpack_require__(530), __webpack_require__(531), __webpack_require__(532), __webpack_require__(533), __webpack_require__(534), __webpack_require__(535), __webpack_require__(536));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(254));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(124), __webpack_require__(255));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(124));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(180), __webpack_require__(181));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(76), __webpack_require__(77), __webpack_require__(64), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(76), __webpack_require__(77), __webpack_require__(64), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(76), __webpack_require__(77), __webpack_require__(64), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(76), __webpack_require__(77), __webpack_require__(64), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(76), __webpack_require__(77), __webpack_require__(64), __webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(62),
    isObjectLike = __webpack_require__(45);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports=__webpack_require__(539);

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Notification=__webpack_require__(540);var _Notification2=_interopRequireDefault(_Notification);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Notification2.default;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _reactDom=__webpack_require__(38);var _reactDom2=_interopRequireDefault(_reactDom);var _rcAnimate=__webpack_require__(349);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _createChainedFunction=__webpack_require__(549);var _createChainedFunction2=_interopRequireDefault(_createChainedFunction);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _Notice=__webpack_require__(550);var _Notice2=_interopRequireDefault(_Notice);var _loadCss=__webpack_require__(83);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var seed=0;var now=Date.now();function getUuid(){return"rcNotification_"+now+"_"+seed++;}var Notification=(_temp2=_class=function(_Component){(0,_inherits3.default)(Notification,_Component);function Notification(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Notification);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Notification.__proto__||(0,_getPrototypeOf2.default)(Notification)).call.apply(_ref,[this].concat(args))),_this),_this.state={notices:[]},_this.add=function(notice){var key=notice.key=notice.key||getUuid();_this.setState(function(previousState){var notices=previousState.notices;if(!notices.filter(function(v){return v.key===key;}).length){return{notices:notices.concat(notice)};}});},_this.remove=function(key){_this.setState(function(previousState){return{notices:previousState.notices.filter(function(notice){return notice.key!==key;})};});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Notification,[{key:"getTransitionName",value:function getTransitionName(){var props=this.props;var transitionName=props.transitionName;if(!transitionName&&props.animation){transitionName=props.prefixCls+"-"+props.animation;}return transitionName;}},{key:"render",value:function render(){var _this2=this,_className;var props=this.props;var noticeNodes=this.state.notices.map(function(notice){var onClose=(0,_createChainedFunction2.default)(_this2.remove.bind(_this2,notice.key),notice.onClose);return _react2.default.createElement(_Notice2.default,(0,_extends3.default)({prefixCls:props.prefixCls},notice,{onClose:onClose}),notice.content);});var className=(_className={},(0,_defineProperty3.default)(_className,props.prefixCls,1),(0,_defineProperty3.default)(_className,props.className,!!props.className),_className);return _react2.default.createElement("div",{className:(0,_classnames2.default)(className),style:props.style},_react2.default.createElement(_rcAnimate2.default,{transitionName:this.getTransitionName()},noticeNodes));}}]);return Notification;}(_react.Component),_class.propTypes={prefixCls:_propTypes2.default.string,transitionName:_propTypes2.default.string,animation:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.object]),style:_propTypes2.default.object},_class.defaultProps={prefixCls:"rc-notification",animation:"fade",style:{top:65,left:"50%"}},_temp2);Notification.newInstance=function newNotificationInstance(properties,callback){var _ref2=properties||{},getContainer=_ref2.getContainer,props=(0,_objectWithoutProperties3.default)(_ref2,["getContainer"]);var div=void 0;if(getContainer){div=getContainer();}else{div=document.createElement("div");if(window.setLayoutWindow){window.setLayoutWindow.document.body.appendChild(div);}else{_window2.default.getTop().document.body.appendChild(div);}(0,_loadCss.loadCss)();}var called=false;function ref(notification){if(called){return;}called=true;callback({notice:function notice(noticeProps){notification.add(noticeProps);},removeNotice:function removeNotice(key){notification.remove(key);},component:notification,destroy:function destroy(){_reactDom2.default.unmountComponentAtNode(div);if(!getContainer){if(window.setLayoutWindow){window.setLayoutWindow.document.body.removeChild(div);}else{_window2.default.getTop().document.body.removeChild(div);}}}});}_reactDom2.default.render(_react2.default.createElement(Notification,(0,_extends3.default)({},props,{ref:ref})),div);};exports.default=Notification;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(542);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(259);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(258);
} catch (err) {
  var index = __webpack_require__(258);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = arguments;
  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

module.exports = createChainedFunction;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Notice=(_temp2=_class=function(_Component){(0,_inherits3.default)(Notice,_Component);function Notice(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Notice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Notice.__proto__||(0,_getPrototypeOf2.default)(Notice)).call.apply(_ref,[this].concat(args))),_this),_this.close=function(){_this.clearCloseTimer();_this.props.onClose();},_this.startCloseTimer=function(){if(_this.props.duration){_this.closeTimer=setTimeout(function(){_this.close();},_this.props.duration*1000);}},_this.clearCloseTimer=function(){if(_this.closeTimer){clearTimeout(_this.closeTimer);_this.closeTimer=null;}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Notice,[{key:'componentDidMount',value:function componentDidMount(){this.startCloseTimer();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.clearCloseTimer();}},{key:'render',value:function render(){var _className;var props=this.props;var componentClass=props.prefixCls+'-notice';var className=(_className={},(0,_defineProperty3.default)(_className,''+componentClass,1),(0,_defineProperty3.default)(_className,componentClass+'-closable',props.closable),(0,_defineProperty3.default)(_className,props.className,!!props.className),_className);return _react2.default.createElement('div',{className:(0,_classnames2.default)(className),style:props.style,onMouseEnter:this.clearCloseTimer,onMouseLeave:this.startCloseTimer},_react2.default.createElement('div',{className:componentClass+'-content'},props.children),props.closable?_react2.default.createElement('a',{tabIndex:'0',onClick:this.close,className:componentClass+'-close'},_react2.default.createElement('span',{className:componentClass+'-close-x'})):null);}}]);return Notice;}(_react.Component),_class.propTypes={duration:_propTypes2.default.number,onClose:_propTypes2.default.func,children:_propTypes2.default.any},_class.defaultProps={onEnd:function onEnd(){},onClose:function onClose(){},duration:1.5,style:{right:'50%'}},_temp2);exports.default=Notice;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(props){var type=props.type,_props$className=props.className,className=_props$className===undefined?"":_props$className,other=(0,_objectWithoutProperties3.default)(props,["type","className"]);className+=" anticon anticon-"+type;return _react2.default.createElement("i",(0,_extends3.default)({className:className.trim()},other,{ecId:other.ecId+"_i@0hqgzv"}));};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaRangePicker=__webpack_require__(102);var _weaRangePicker2=_interopRequireDefault(_weaRangePicker);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Option=_antd.SelectNew.Option;var WeaDateGroup=function(_React$Component){(0,_inherits3.default)(WeaDateGroup,_React$Component);function WeaDateGroup(props){(0,_classCallCheck3.default)(this,WeaDateGroup);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaDateGroup.__proto__||(0,_getPrototypeOf2.default)(WeaDateGroup)).call(this,props));_this.isDisabledDate=function(yearOne,monthOne,dayOne,yearTwo,monthTwo,dayTwo){var bool=false;if(yearTwo>yearOne)bool=true;else if(yearTwo===yearOne){if(monthTwo>monthOne)bool=true;else if(monthTwo===monthOne){if(dayTwo>dayOne)bool=true;}}return bool;};_this.getDisabledDate=function(current,value){var isStartValue=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var bool=false;if(current&&value){var currentYear=current.getYear();var currentMonth=current.getMonth()+1;var currentDay=current.getDayOfMonth();var year=new Date(value).getFullYear();var month=new Date(value).getMonth()+1;var day=new Date(value).getDate();if(isStartValue){bool=_this.isDisabledDate(currentYear,currentMonth,currentDay,year,month,day);}else{bool=_this.isDisabledDate(year,month,day,currentYear,currentMonth,currentDay);}}return bool;};_this.state={rangeValue:[]};if(!(0,_isEmpty2.default)(props.values)&&!(0,_isEmpty2.default)(props.domkey)){if(props.values[props.domkey[1]]&&props.values[props.domkey[2]]){_this.setState({rangeValue:[new Date(props.values[props.domkey[1]]),new Date(props.values[props.domkey[2]])]});}}return _this;}(0,_createClass3.default)(WeaDateGroup,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var value=nextProps.value,form=nextProps.form,domkey=nextProps.domkey;if(this.props.value=="6"&&value!=="6"&&form){var clear={};clear[domkey[1]]="";clear[domkey[2]]="";form.setFieldsValue(clear);this.setState({rangeValue:[]});}}},{key:"render",value:function render(){var _this2=this;var theProps=(0,_cloneDeep2.default)(this.props);var _props=this.props,datas=_props.datas,value=_props.value,form=_props.form,domkey=_props.domkey,rangeValue=_props.rangeValue,viewAttr=_props.viewAttr,textDecoration=_props.textDecoration,_props$className=_props.className,className=_props$className===undefined?"":_props$className,isInline=_props.isInline,style=_props.style;var disabled=false;if(viewAttr=="1")disabled=true;var showPicker=value==="6";return React.createElement("div",{className:"wea-date-group "+className+" "+(isInline?"isInline":"")+" "+(showPicker?"showPicker":""),style:style},React.createElement(_antd.SelectNew,(0,_extends3.default)({defaultValue:"0"},theProps,{disabled:disabled,size:"default",className:"wea-date-group-select "+(textDecoration&&"text-decoration")}),datas&&datas.map(function(d){return React.createElement(Option,{value:d.value},d.name);})),showPicker&&// 指定日期范围更换为WeaRangePicker组件
React.createElement("div",{className:"wea-date-group-rangePicker"},React.createElement(_weaRangePicker2.default,{value:rangeValue||[form&&form.getFieldValue(domkey[1]),form&&form.getFieldValue(domkey[2])],viewAttr:viewAttr,textDecoration:textDecoration,onChange:function onChange(v){var _form$setFieldsValue;form&&form.setFieldsValue((_form$setFieldsValue={},(0,_defineProperty3.default)(_form$setFieldsValue,domkey[1],v[0]),(0,_defineProperty3.default)(_form$setFieldsValue,domkey[2],v[1]),_form$setFieldsValue));_this2.setState({rangeValue:v});}})));}}]);return WeaDateGroup;}(React.Component);exports.default=WeaDateGroup;

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(126),
    keys = __webpack_require__(85);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(126),
    keysIn = __webpack_require__(183);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40),
    isPrototype = __webpack_require__(112),
    nativeKeysIn = __webpack_require__(557);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(41);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 559 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(126),
    getSymbols = __webpack_require__(178);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(126),
    getSymbolsIn = __webpack_require__(263);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(242),
    getSymbolsIn = __webpack_require__(263),
    keysIn = __webpack_require__(183);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(184),
    cloneDataView = __webpack_require__(565),
    cloneRegExp = __webpack_require__(566),
    cloneSymbol = __webpack_require__(567),
    cloneTypedArray = __webpack_require__(568);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(184);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 566 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(74);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(184);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(570),
    getPrototype = __webpack_require__(264),
    isPrototype = __webpack_require__(112);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(572),
    baseUnary = __webpack_require__(94),
    nodeUtil = __webpack_require__(115);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(93),
    isObjectLike = __webpack_require__(45);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(574),
    baseUnary = __webpack_require__(94),
    nodeUtil = __webpack_require__(115);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(93),
    isObjectLike = __webpack_require__(45);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaRangePicker=__webpack_require__(102);var _weaRangePicker2=_interopRequireDefault(_weaRangePicker);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Option=_antd.SelectNew.Option;var WeaDateGroup=function(_React$Component){(0,_inherits3.default)(WeaDateGroup,_React$Component);function WeaDateGroup(props){(0,_classCallCheck3.default)(this,WeaDateGroup);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaDateGroup.__proto__||(0,_getPrototypeOf2.default)(WeaDateGroup)).call(this,props));_this.isDisabledDate=function(yearOne,monthOne,dayOne,yearTwo,monthTwo,dayTwo){var bool=false;if(yearTwo>yearOne)bool=true;else if(yearTwo===yearOne){if(monthTwo>monthOne)bool=true;else if(monthTwo===monthOne){if(dayTwo>dayOne)bool=true;}}return bool;};_this.getDisabledDate=function(current,value){var isStartValue=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var bool=false;if(current&&value){var currentYear=current.getYear();var currentMonth=current.getMonth()+1;var currentDay=current.getDayOfMonth();var year=new Date(value).getFullYear();var month=new Date(value).getMonth()+1;var day=new Date(value).getDate();if(isStartValue){bool=_this.isDisabledDate(currentYear,currentMonth,currentDay,year,month,day);}else{bool=_this.isDisabledDate(year,month,day,currentYear,currentMonth,currentDay);}}return bool;};_this.state={selectValue:"",rangeValue:[]};if(!(0,_isEmpty2.default)(props.value)){_this.state.selectValue=props.value[0];if(props.value[0]=="6"){// this.setState({ rangeValue: [props.value[1], props.value[2]] });
_this.state.rangeValue=[props.value[1],props.value[2]];}}return _this;}(0,_createClass3.default)(WeaDateGroup,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps){var selectValue="0";var rangeValue=[];if(!(0,_isEmpty2.default)(nextProps.value)){selectValue=nextProps.value[0];if(nextProps.value[0]=="6"){rangeValue=[nextProps.value[1],nextProps.value[2]];}}this.setState({selectValue:selectValue,rangeValue:rangeValue});}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,datas=_props.datas,viewAttr=_props.viewAttr,textDecoration=_props.textDecoration,_props$className=_props.className,className=_props$className===undefined?"":_props$className,isInline=_props.isInline,style=_props.style;var _state=this.state,selectValue=_state.selectValue,rangeValue=_state.rangeValue;var disabled=false;if(viewAttr=="1")disabled=true;var showPicker=selectValue==="6";return React.createElement("div",{className:"wea-date-group "+className+" "+(isInline?"isInline":"")+" "+(showPicker?"showPicker":""),style:style},React.createElement(_antd.SelectNew,{value:selectValue,disabled:disabled,size:"default",className:"wea-date-group-select "+(textDecoration&&"text-decoration"),onChange:function onChange(v){var rangeValue=_this2.state.rangeValue;if(v!="6"){rangeValue=[];}_this2.setState({selectValue:v,rangeValue:rangeValue});_this2.props.onChange&&_this2.props.onChange([v].concat((0,_toConsumableArray3.default)(rangeValue)));}},datas&&datas.map(function(d){return React.createElement(Option,{value:d.value,title:d.name},d.name);})),showPicker&&// 指定日期范围更换为WeaRangePicker组件
React.createElement("div",{className:"wea-date-group-rangePicker"},React.createElement(_weaRangePicker2.default,{value:rangeValue,viewAttr:viewAttr,textDecoration:textDecoration,onChange:function onChange(v){_this2.setState({rangeValue:v});_this2.props.onChange&&_this2.props.onChange([selectValue].concat((0,_toConsumableArray3.default)(v)));}})));}}]);return WeaDateGroup;}(React.Component);exports.default=WeaDateGroup;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(122),
    overRest = __webpack_require__(577),
    setToString = __webpack_require__(579);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(578);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(580),
    shortOut = __webpack_require__(582);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(581),
    defineProperty = __webpack_require__(262),
    identity = __webpack_require__(122);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 581 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(584),
    baseFlatten = __webpack_require__(585),
    baseUniq = __webpack_require__(185);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(174),
    arrayIncludes = __webpack_require__(265),
    arrayIncludesWith = __webpack_require__(266),
    arrayMap = __webpack_require__(232),
    baseUnary = __webpack_require__(94),
    cacheHas = __webpack_require__(175);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(177),
    isFlattenable = __webpack_require__(586);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(74),
    isArguments = __webpack_require__(113),
    isArray = __webpack_require__(21);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(238),
    noop = __webpack_require__(588),
    setToArray = __webpack_require__(176);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(71),
    isObjectLike = __webpack_require__(45);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(591),
    getMatchData = __webpack_require__(592),
    matchesStrictComparable = __webpack_require__(268);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(172),
    baseIsEqual = __webpack_require__(171);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(267),
    keys = __webpack_require__(85);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(171),
    get = __webpack_require__(352),
    hasIn = __webpack_require__(597),
    isKey = __webpack_require__(186),
    isStrictComparable = __webpack_require__(267),
    matchesStrictComparable = __webpack_require__(268),
    toKey = __webpack_require__(127);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(595);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(596);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(173);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(598),
    hasPath = __webpack_require__(599);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 598 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(270),
    isArguments = __webpack_require__(113),
    isArray = __webpack_require__(21),
    isIndex = __webpack_require__(179),
    isLength = __webpack_require__(169),
    toKey = __webpack_require__(127);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(601),
    basePropertyDeep = __webpack_require__(602),
    isKey = __webpack_require__(186),
    toKey = __webpack_require__(127);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(269);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(604));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _sortablejs = _interopRequireDefault(__webpack_require__(271));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var store = {
  nextSibling: null,
  activeComponent: null
};

var Sortable =
/*#__PURE__*/
function (_Component) {
  _inherits(Sortable, _Component);

  function Sortable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Sortable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Sortable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "sortable", null);

    return _this;
  }

  _createClass(Sortable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var options = _objectSpread({}, this.props.options);

      ['onChoose', 'onStart', 'onEnd', 'onAdd', 'onUpdate', 'onSort', 'onRemove', 'onFilter', 'onMove', 'onClone'].forEach(function (name) {
        var eventHandler = options[name];

        options[name] = function () {
          for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            params[_key2] = arguments[_key2];
          }

          var evt = params[0];

          if (name === 'onChoose') {
            store.nextSibling = evt.item.nextElementSibling;
            store.activeComponent = _this2;
          } else if ((name === 'onAdd' || name === 'onUpdate') && _this2.props.onChange) {
            var items = _this2.sortable.toArray();

            var remote = store.activeComponent;
            var remoteItems = remote.sortable.toArray();
            var referenceNode = store.nextSibling && store.nextSibling.parentNode !== null ? store.nextSibling : null;
            evt.from.insertBefore(evt.item, referenceNode);

            if (remote !== _this2) {
              var remoteOptions = remote.props.options || {};

              if (_typeof(remoteOptions.group) === 'object' && remoteOptions.group.pull === 'clone') {
                // Remove the node with the same data-reactid
                evt.item.parentNode.removeChild(evt.item);
              }

              remote.props.onChange && remote.props.onChange(remoteItems, remote.sortable, evt);
            }

            _this2.props.onChange && _this2.props.onChange(items, _this2.sortable, evt);
          }

          if (evt.type === 'move') {
            var _evt = params[0],
                originalEvent = params[1];
            var canMove = eventHandler ? eventHandler(_evt, originalEvent) : true;
            return canMove;
          }

          setTimeout(function () {
            eventHandler && eventHandler(evt);
          }, 0);
        };
      });
      this.sortable = _sortablejs.default.create(this.node, options);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // If onChange is null, it is an UnControlled component
      // Don't let React re-render it by setting return to false
      if (!nextProps.onChange) {
        return false;
      }

      return true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.sortable) {
        this.sortable.destroy();
        this.sortable = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          Component = _this$props.tag,
          options = _this$props.options,
          onChange = _this$props.onChange,
          props = _objectWithoutProperties(_this$props, ["tag", "options", "onChange"]);

      return _react.default.createElement(Component, _extends({}, props, {
        ref: function ref(node) {
          _this3.node = node;
        }
      }));
    }
  }]);

  return Sortable;
}(_react.Component);

_defineProperty(Sortable, "propTypes", {
  options: _propTypes.default.object,
  onChange: _propTypes.default.func,
  tag: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  style: _propTypes.default.object
});

_defineProperty(Sortable, "defaultProps", {
  options: {},
  tag: 'div',
  style: {}
});

var _default = Sortable;
exports.default = _default;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(605)();
}


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(606);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;// import { findDOMNode } from 'react-dom';
var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Layout=(_temp=_class=function(_React$PureComponent){(0,_inherits3.default)(Layout,_React$PureComponent);function Layout(props){(0,_classCallCheck3.default)(this,Layout);var _this=(0,_possibleConstructorReturn3.default)(this,(Layout.__proto__||(0,_getPrototypeOf2.default)(Layout)).call(this,props));_this.onCollapse=function(e){var onCollapse=_this.props.onCollapse;var showLeft=_this.state.showLeft;_this.setState({showLeft:!showLeft});typeof onCollapse==="function"&&onCollapse(!showLeft);e.stopPropagation();e.preventDefault();e.nativeEvent.preventDefault();};_this.initShowLeft=props.leftFixed?false:props.showLeft===undefined?true:props.showLeft;_this.state={showLeft:_this.initShowLeft};return _this;}(0,_createClass3.default)(Layout,[{key:"componentDidMount",value:function componentDidMount(){this.setState({showLeft:this.initShowLeft});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextPorps){var l=this.state.showLeft;var showLeft=nextPorps.showLeft;if(showLeft!==undefined&&l!==showLeft){this.setState({showLeft:showLeft});}}},{key:"getLeftWidth",value:function getLeftWidth(){var leftWidth=this.props.leftWidth;// const dom = findDOMNode(this.refs.layout);
var style={};if(typeof leftWidth==="number"){style.width=leftWidth;style.marginLeft=-leftWidth;}else if(typeof leftWidth==="string"&&leftWidth.indexOf("%")>0){var persent=Number(leftWidth.replace("%",""));var width=persent*100/(100-persent)+"%";// if (dom) {
//   const domWidth = dom.offsetWidth;
//   const marginLeft = persent * domWidth / 100;
//   style.marginLeft = marginLeft < 200 ? -200 : marginLeft > 300 ? -300 : `-${width}`;
//   style.width = marginLeft < 200 ? 200 : marginLeft > 300 ? 300 : width;
// } else {
style.width=width;style.marginLeft="-"+width;// }
}return style;}},{key:"getPaddingLeft",value:function getPaddingLeft(){var showLeft=this.state.showLeft;var _props=this.props,leftWidth=_props.leftWidth,leftFixed=_props.leftFixed;return leftFixed?0:showLeft?leftWidth:0;// const dom = findDOMNode(this.refs.layout);
// if (dom) {
//   const domWidth = dom.offsetWidth;
//   if (typeof leftWidth === 'string' && leftWidth.indexOf('%') > 0) {
//     const persent = Number(leftWidth.replace('%', ''));
//     const width = persent * domWidth / 100;
//     return showLeft ? width < 200 ? 200 : width > 300 ? 300 : leftWidth : 0;
//   }
// }
// if (showLeft) return 0;
}},{key:"render",value:function render(){var _classNames;var prefixCls="wea-left-right-layout";var showLeft=this.state.showLeft;var _props2=this.props,children=_props2.children,leftCom=_props2.leftCom,showBtn=_props2.showBtn,leftFixed=_props2.leftFixed,leftWidth=_props2.leftWidth,btnTitle=_props2.btnTitle,_props2$className=_props2.className,className=_props2$className===undefined?"":_props2$className,style=_props2.style,ecId=_props2.ecId;var leftWidthStyle=this.getLeftWidth();var leftFixedStyle=leftFixed?{position:"absolute",left:showLeft?leftWidth:0,transition:"left .1s ease-in-out"}:{};var classnames=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-btn",true),(0,_defineProperty3.default)(_classNames,prefixCls+"-btn-hide",!showLeft),(0,_defineProperty3.default)(_classNames,prefixCls+"-btn-show",showLeft),_classNames));var paddingLeft=this.getPaddingLeft();return _react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@xgtu9x",ref:"layout",className:prefixCls+" "+className,style:(0,_extends3.default)({paddingLeft:paddingLeft},style)},_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@d3t1j3",className:prefixCls+"-left",style:(0,_extends3.default)({},leftWidthStyle,leftFixedStyle)},leftCom),_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@hevlqi",span:24,className:prefixCls+"-right"},showBtn&&_react2.default.createElement("div",(0,_extends3.default)({className:classnames,onClick:this.onCollapse,style:leftFixedStyle},btnTitle,{ecId:ecId+"_div@4494xq"})),children));}}]);return Layout;}(_react2.default.PureComponent),_class.defaultProps={leftWidth:260,leftFixed:false,showBtn:true},_temp);exports.default=Layout;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LayoutCol=(_temp=_class=function(_React$PureComponent){(0,_inherits3.default)(LayoutCol,_React$PureComponent);function LayoutCol(props){(0,_classCallCheck3.default)(this,LayoutCol);var _this=(0,_possibleConstructorReturn3.default)(this,(LayoutCol.__proto__||(0,_getPrototypeOf2.default)(LayoutCol)).call(this,props));_this.onCollapse=function(side,e){var _this$props=_this.props,onCollapse=_this$props.onCollapse,col=_this$props.col;var _this$state=_this.state,showLeft=_this$state.showLeft,showMid=_this$state.showMid;var arr=[side==="left"?!showLeft:!showMid];if(col===3)arr.unshift(side);_this.setState(side==="left"?{showLeft:!showLeft}:{showMid:!showMid});typeof onCollapse==="function"&&onCollapse.apply(undefined,arr);e.stopPropagation();e.preventDefault();e.nativeEvent.preventDefault();};_this.state={showLeft:props.showLeft===undefined?true:props.showLeft,showMid:props.showMid===undefined?true:props.showMid};return _this;}(0,_createClass3.default)(LayoutCol,[{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,showLeft=_props.showLeft,showMid=_props.showMid;this.setState({showLeft:showLeft===undefined?true:showLeft,showMid:showMid===undefined?true:showMid});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextPorps){var _state=this.state,l=_state.showLeft,m=_state.showMid;var showLeft=nextPorps.showLeft,showMid=nextPorps.showMid;var newState={};if(showLeft!==undefined&&l!==showLeft){newState.showLeft=showLeft;}if(showMid!==undefined&&m!==showMid){newState.showMid=showMid;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:"render",value:function render(){var _classNames,_classNames2,_this2=this;var prefixCls="wea-left-right-layout";var _state2=this.state,showLeft=_state2.showLeft,showMid=_state2.showMid;var _props2=this.props,col=_props2.col,children=_props2.children,leftCom=_props2.leftCom,midCom=_props2.midCom,showBtn=_props2.showBtn,showBtnL=_props2.showBtnL,showBtnM=_props2.showBtnM,showTitleL=_props2.showTitleL,showTitleM=_props2.showTitleM,titleLeft=_props2.titleLeft,titleMiddle=_props2.titleMiddle,_props2$className=_props2.className,className=_props2$className===undefined?"":_props2$className,style=_props2.style,ecId=_props2.ecId;var classNameL=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-btn",true),(0,_defineProperty3.default)(_classNames,prefixCls+"-btn-hide",!showLeft),(0,_defineProperty3.default)(_classNames,prefixCls+"-btn-show",showLeft),_classNames));var classNameM=(0,_classnames2.default)((_classNames2={},(0,_defineProperty3.default)(_classNames2,prefixCls+"-btn",true),(0,_defineProperty3.default)(_classNames2,prefixCls+"-btn-hide",!showMid),(0,_defineProperty3.default)(_classNames2,prefixCls+"-btn-show",showMid),_classNames2));var openCol={xs:8,sm:7,md:6,lg:5};var closeCol={xs:0,sm:0,md:0,lg:0};var leftCol=showLeft?(0,_extends3.default)({},openCol):(0,_extends3.default)({},closeCol);var midCol=col===3&&showMid?(0,_extends3.default)({},openCol):(0,_extends3.default)({},closeCol);var rightCol={xs:24-leftCol.xs-midCol.xs,sm:24-leftCol.sm-midCol.sm,md:24-leftCol.md-midCol.md,lg:24-leftCol.lg-midCol.lg};var titleleft=showTitleL?{title:titleLeft}:{};var titlemiddle=showTitleM?{title:titleMiddle}:{};return _react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@vmp8n6",className:prefixCls+" "+className,style:style},_react2.default.createElement(_antd.Col,(0,_extends3.default)({},leftCol,{ecId:ecId+"_Col@wciysz",className:prefixCls+"-left"}),leftCom),_react2.default.createElement(_antd.Col,(0,_extends3.default)({},midCol,{ecId:ecId+"_Col@z3m1iw",className:prefixCls+"-left "+prefixCls+"-right"}),col===3&&showBtnL&&showMid&&_react2.default.createElement("div",(0,_extends3.default)({className:classNameL,onClick:function onClick(e){return _this2.onCollapse("left",e);}},titleleft,{ecId:ecId+"_div@avgc9p"})),midCom),_react2.default.createElement(_antd.Col,(0,_extends3.default)({},rightCol,{ecId:ecId+"_Col@6pfike",className:prefixCls+"-right"}),col===2&&showBtn&&_react2.default.createElement("div",(0,_extends3.default)({className:classNameL,onClick:function onClick(e){return _this2.onCollapse("left",e);}},titleleft,{ecId:ecId+"_div@ttae61"})),col===3&&showBtnM&&_react2.default.createElement("div",(0,_extends3.default)({className:classNameM,onClick:function onClick(e){return _this2.onCollapse("middle",e);}},titlemiddle,{ecId:ecId+"_div@h6g07w"})),children));}}]);return LayoutCol;}(_react2.default.PureComponent),_class.defaultProps={col:2,showBtnL:true,showBtnM:true},_temp);exports.default=LayoutCol;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _weaDraggable=__webpack_require__(274);var _weaDraggable2=_interopRequireDefault(_weaDraggable);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LayoutResize=(_temp=_class=function(_React$Component){(0,_inherits3.default)(LayoutResize,_React$Component);function LayoutResize(props){(0,_classCallCheck3.default)(this,LayoutResize);var _this=(0,_possibleConstructorReturn3.default)(this,(LayoutResize.__proto__||(0,_getPrototypeOf2.default)(LayoutResize)).call(this,props));_this.onCollapse=function(side,e){var _this$props=_this.props,onCollapse=_this$props.onCollapse,col=_this$props.col;var showLeft=_this.state.showLeft;var arr=[side==="left"?!showLeft:!showMid];if(col===3)arr.unshift(side);_this.setState(side==="left"?{showLeft:!showLeft}:{showMid:!showMid});typeof onCollapse==="function"&&onCollapse.apply(undefined,arr);e.stopPropagation();e.preventDefault();e.nativeEvent.preventDefault();};_this.onStart=function(){};_this.onDrag=function(ev,ui){_this.setState({leftWidth:ui.x},function(){var onDrag=_this.props.onDrag;typeof onDrag=="function"&&onDrag(ui.x);});};_this.state={showLeft:props.showLeft===undefined?true:props.showLeft,leftWidth:props.leftWidth,leftMinWidth:20,leftMaxWidth:600};return _this;}(0,_createClass3.default)(LayoutResize,[{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,showLeft=_props.showLeft,leftWidth=_props.leftWidth;this.setState({showLeft:showLeft===undefined?true:showLeft,leftWidth:leftWidth===undefined?true:leftWidth});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _state=this.state,l=_state.showLeft,w=_state.leftWidth;var showLeft=nextProps.showLeft,leftWidth=nextProps.leftWidth;var newState={};if(showLeft!==undefined&&l!==showLeft){newState.showLeft=showLeft;}if(leftWidth!==undefined&&w!==leftWidth){newState.leftWidth=leftWidth;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:"render",value:function render(){var _classNames,_this2=this;var prefixCls="wea-left-right-layout";var _state2=this.state,leftWidth=_state2.leftWidth,leftMinWidth=_state2.leftMinWidth,leftMaxWidth=_state2.leftMaxWidth,showLeft=_state2.showLeft;var _props2=this.props,col=_props2.col,leftCom=_props2.leftCom,children=_props2.children,showBtn=_props2.showBtn,titleLeft=_props2.titleLeft,showTitleL=_props2.showTitleL,_props2$className=_props2.className,className=_props2$className===undefined?"":_props2$className,style=_props2.style,ecId=_props2.ecId;var classNameL=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-btn",true),(0,_defineProperty3.default)(_classNames,prefixCls+"-btn-hide",!showLeft),(0,_defineProperty3.default)(_classNames,prefixCls+"-btn-show",showLeft),_classNames));var openCol={xs:8,sm:7,md:6,lg:5};var closeCol={xs:0,sm:0,md:0,lg:0};var leftCol=showLeft?(0,_extends3.default)({},openCol):(0,_extends3.default)({},closeCol);var titleleft=showTitleL?{title:titleLeft}:{};var leftWidthstyle={};leftWidthstyle.width=leftWidth;return _react2.default.createElement(_antd.Row,{ecId:ecId+"_Row@kg7qf2",className:prefixCls+" "+className,style:style},_react2.default.createElement(_antd.Col,(0,_extends3.default)({},leftCol,{ecId:ecId+"_Col@g5ewkg",className:prefixCls+"-left",style:{width:leftWidthstyle.width+4}}),leftCom,_react2.default.createElement(_weaDraggable2.default,{ecId:ecId+"_WeaDraggable@2696kg",axis:"x",position:{x:leftWidth,y:0},bounds:{left:leftMinWidth,right:leftMaxWidth},onStart:this.onStart,onDrag:this.onDrag,handle:"div"},_react2.default.createElement("div",{className:prefixCls+"-resize"}))),_react2.default.createElement(_antd.Col,{ecId:ecId+"_Col@wok6zq",className:prefixCls+"-right"},col===2&&showBtn&&_react2.default.createElement("div",(0,_extends3.default)({className:classNameL,onClick:function onClick(e){return _this2.onCollapse("left",e);}},titleleft,{ecId:ecId+"_div@zx204f"})),children));}}]);return LayoutResize;}(_react2.default.Component),_class.defaultProps={col:2},_temp);exports.default=LayoutResize;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(38);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _src=__webpack_require__(615);var _src2=_interopRequireDefault(_src);var _core=__webpack_require__(75);var _core2=_interopRequireDefault(_core);var _util=__webpack_require__(296);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var count=0;var Expandable=function Expandable(_ref){var node=_ref.node,children=_ref.children,onExpand=_ref.onExpand,onSelect=_ref.onSelect,onDoubleClick=_ref.onDoubleClick,checkable=_ref.checkable,disableCheckbox=_ref.disableCheckbox,onCheck=_ref.onCheck,hasRadio=_ref.hasRadio,disableRadio=_ref.disableRadio,onRadioCheck=_ref.onRadioCheck,expandedKeys=_ref.expandedKeys,itemMainKey=_ref.itemMainKey,isExpandOnDoubleClick=_ref.isExpandOnDoubleClick,ecId=_ref.ecId;var childs=node.childs,isLeaf=node.isLeaf,checked=node.checked,halfcheck=node.halfcheck,isParent=node.isParent;var hasChildren="isLeaf"in node&&!isLeaf||childs&&childs.length||isParent;var stopPropagation=function stopPropagation(e){e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();};var renderExpand=function renderExpand(){return _react2.default.createElement("i",{ecId:ecId+"_i@sws6qx",onClick:function onClick(e){hasChildren&&onExpand(node,e);stopPropagation(e);},className:(0,_classnames2.default)({"ant-tree-icon":true,"ant-tree-switcher":true,"icon-coms-organization-down":hasChildren&&expandedKeys.some(function(k){return k===node[itemMainKey];}),"icon-coms-organization-right":hasChildren&&!expandedKeys.some(function(k){return k===node[itemMainKey];})})});};var renderCheck=function renderCheck(){var checkbtn=void 0;if(checkable){checkbtn=_react2.default.createElement("span",{ecId:ecId+"_span@rue0uo",onClick:function onClick(e){!disableCheckbox&&onCheck(node,e);stopPropagation(e);},className:(0,_classnames2.default)({"ant-tree-checkbox":true,"ant-tree-checkbox-checked":checked,"ant-tree-checkbox-indeterminate":halfcheck,"ant-tree-checkbox-disabled":disableCheckbox})},_react2.default.createElement("span",{className:"ant-tree-checkbox-inner"}));if(hasRadio){checkbtn=_react2.default.createElement("span",{ecId:ecId+"_span@apnt7e",onClick:function onClick(e){!disableCheckbox&&onRadioCheck(node,e);stopPropagation(e);},className:(0,_classnames2.default)({"ant-tree-radio":true,"ant-tree-radio-checked":checked,"ant-tree-radio-disabled":disableRadio})},_react2.default.createElement("span",{className:"ant-tree-radio-inner"}));}}return checkbtn;};return[renderExpand(),renderCheck(),node.icon&&_react2.default.createElement("i",{className:(0,_classnames2.default)((0,_defineProperty3.default)({"ant-tree-icon":true},node.icon,true))}),_react2.default.createElement("a",{ecId:ecId+"_a@94b3bc",className:(0,_classnames2.default)({"ant-tree-node-content-wrapper":true,"ant-tree-node-disabled":node.isCheck})// style={{ height: '26px', lineHeight: '26px' }}
,onClick:function onClick(e){if(node.isCheck)return;count++;setTimeout(function(){if(isExpandOnDoubleClick||count===1){onSelect(node,e);hasChildren&&onExpand(node,e);stopPropagation(e);}if(count===2&&node.type!=="3"){// 双击
typeof onDoubleClick==="function"&&onDoubleClick(node,e);}count=0;},300);}},children)].filter(Boolean);};var ScrollTree=function(_React$Component){(0,_inherits3.default)(ScrollTree,_React$Component);function ScrollTree(){var _ref2;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ScrollTree);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref2=ScrollTree.__proto__||(0,_getPrototypeOf2.default)(ScrollTree)).call.apply(_ref2,[this].concat(args))),_this),_this.baron=null,_this.updateData=function(props){var _ref3=props||_this.props,datas=_ref3.datas,itemMainKey=_ref3.itemMainKey,expandedKeys=_ref3.expandedKeys,checkedKeys=_ref3.checkedKeys,isOrg=_ref3.isOrg;(0,_util.traverTree)(datas,function(node){var key=node[itemMainKey];node.isopen=!(0,_isEmpty2.default)(expandedKeys)&&expandedKeys.indexOf(key)!==-1;node.checked=!(0,_isEmpty2.default)(checkedKeys)&&checkedKeys.indexOf(key)!==-1;});_this.forceUpdate();},_this.getCheckedKeys=function(data,node,checked){var checkedKeys=[];var checkedNodes=[];var newSt={event:"check",node:node,checkedKeys:checkedKeys,checkedNodes:checkedNodes,checked:checked};return newSt;},_this.onCheck=function(node,e){var _this$props=_this.props,datas=_this$props.datas,onCheck=_this$props.onCheck;var checked=!(node.checked||false);var _this$getCheckedKeys=_this.getCheckedKeys(datas,node,checked),checkedKeys=_this$getCheckedKeys.checkedKeys,checkedDatas=_this$getCheckedKeys.checkedDatas;// onCheck && onCheck(checkedKeys, checkedDatas, e);
},_this.onRadioCheck=function(node,e){},_this.isCheckboxDisable=function(item){var _this2=_this,props=_this2.props;if(props.isCheckboxDisable){return props.isCheckboxDisable(item);}return!item.canClick||false;},_this.isRadioDisable=function(item){var _this3=_this,props=_this3.props;if(props.isRadioDisable){return props.isRadioDisable(item);}return!item.canClick||false;},_this.getScrollerTrack=function(){return _react2.default.createElement("div",{ref:function ref(el){return _this.track=el;},className:"track"},_react2.default.createElement("div",{ref:function ref(el){return _this.bar=el;},className:"bar"}));},_this.renderExpandable=function(_ref4){var style=_ref4.style,node=_ref4.node,rest=(0,_objectWithoutProperties3.default)(_ref4,["style","node"]);var _this4=_this,props=_this4.props;var checkable=props.checkable,hasRadio=props.hasRadio,itemMainKey=props.itemMainKey,selectedKeys=props.selectedKeys,getTitle=props.getTitle,onExpand=props.onExpand,onSelect=props.onSelect,onDoubleClick=props.onDoubleClick,isExpandOnDoubleClick=props.isExpandOnDoubleClick,expandedKeys=props.expandedKeys,isOrg=props.isOrg,ecId=props.ecId;var className=(0,_classnames2.default)({"wea-tree-wrap":true,"wea-tree-wrap-true":selectedKeys.some(function(k){return k===node[itemMainKey];})});_this.treeMap[node.id]=node;style.height=node.type==="3"?"34px":"26px";style.lineHeight=node.type==="3"?"34px":"26px";return _react2.default.createElement("div",{className:className,style:style},_react2.default.createElement(Expandable,(0,_extends3.default)({node:node,isOrg:isOrg},rest,{ecId:ecId+"_Expandable@7rfrc8",checkable:checkable,expandedKeys:expandedKeys,itemMainKey:itemMainKey// checkboxChecked={this.isCheckboxChecked(node)}
,disableCheckbox:_this.isCheckboxDisable(node),hasRadio:hasRadio,disableRadio:_this.isRadioDisable(node),isExpandOnDoubleClick:isExpandOnDoubleClick// radioChecked={this.isRadioChecked(node)}
,onCheck:_this.onCheck,onRadioCheck:_this.onRadioCheck,onExpand:onExpand,onSelect:onSelect,onDoubleClick:onDoubleClick}),getTitle(node)));},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ScrollTree,[{key:"componentDidMount",value:function componentDidMount(){var root=(0,_reactDom.findDOMNode)(this.root);var scrollerParent=(0,_reactDom.findDOMNode)(this.scroller);var scroller=scrollerParent.querySelector(".scroller");var track=(0,_reactDom.findDOMNode)(this.track);var bar=(0,_reactDom.findDOMNode)(this.bar);this.baron=(0,_core2.default)({$:window.jQuery,root:root,clipper:root,scroller:scroller,track:track,bar:bar,notParentClipper:true});this.updateData();}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var update=false;if(nextProps.expandedKeys!=undefined&&this.props.expandedKeys!=nextProps.expandedKeys){update=true;}if(nextProps.checkedKeys!=undefined&&this.props.checkedKeys!=nextProps.checkedKeys){update=true;}if(update){this.updateData(nextProps);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.baron){this.baron.dispose();this.baron=null;}}// get
},{key:"render",value:function render(){var _this5=this;var props=this.props;var datas=props.datas,itemMainKey=props.itemMainKey,ecId=props.ecId;this.treeMap={};return _react2.default.createElement("div",{ref:function ref(el){return _this5.root=el;},className:"wea-tree-baron baron",style:{width:"100%",height:"100%",position:"relative",marginTop:"-5px"}},_react2.default.createElement(_src2.default,{ecId:ecId+"_Tree@3npkjw",nodes:datas,className:"scroller ant-tree",ref:function ref(el){return _this5.scroller=el;},nodePaddingLeft:18,mainKey:itemMainKey},this.renderExpandable),this.getScrollerTrack());}}]);return ScrollTree;}(_react2.default.Component);exports.default=ScrollTree;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FilteringContainer=exports.constants=exports.renderers=exports.selectors=undefined;var _TreeContainer=__webpack_require__(616);var _TreeContainer2=_interopRequireDefault(_TreeContainer);var _nodes=__webpack_require__(79);var selectors=_interopRequireWildcard(_nodes);var _renderers=__webpack_require__(668);var _renderers2=_interopRequireDefault(_renderers);var _contants=__webpack_require__(191);var constants=_interopRequireWildcard(_contants);var _FilteringContainer=__webpack_require__(672);var _FilteringContainer2=_interopRequireDefault(_FilteringContainer);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_TreeContainer2.default;exports.selectors=selectors;exports.renderers=_renderers2.default;exports.constants=constants;exports.FilteringContainer=_FilteringContainer2.default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _DEFAULT_UPDATE_TYPES,_class,_temp2;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _Tree=__webpack_require__(617);var _Tree2=_interopRequireDefault(_Tree);var _contants=__webpack_require__(191);var _getFlattenedTree=__webpack_require__(190);var _nodes=__webpack_require__(79);var _nodeShapes=__webpack_require__(131);var _reselect=__webpack_require__(295);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DEFAULT_UPDATE_TYPES=(_DEFAULT_UPDATE_TYPES={},(0,_defineProperty3.default)(_DEFAULT_UPDATE_TYPES,_contants.UPDATE_TYPE.DELETE,_nodes.deleteNodeFromTree),(0,_defineProperty3.default)(_DEFAULT_UPDATE_TYPES,_contants.UPDATE_TYPE.UPDATE,_nodes.replaceNodeFromTree),_DEFAULT_UPDATE_TYPES);var getExtensions=(0,_reselect.createSelector)(function(e){return e;},function(){var extensions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _extensions$updateTyp=extensions.updateTypeHandlers,updateTypeHandlers=_extensions$updateTyp===undefined?{}:_extensions$updateTyp;return{updateTypeHandlers:(0,_extends3.default)({},DEFAULT_UPDATE_TYPES,updateTypeHandlers)};});var TreeContainer=(_temp2=_class=function(_React$Component){(0,_inherits3.default)(TreeContainer,_React$Component);function TreeContainer(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,TreeContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=TreeContainer.__proto__||(0,_getPrototypeOf2.default)(TreeContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(_ref2){var node=_ref2.node,type=_ref2.type;var updatedNodes=getExtensions(_this.props.extensions).updateTypeHandlers[type](_this.nodes,node);_this.props.onChange(updatedNodes);},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(TreeContainer,[{key:"render",value:function render(){var _props=this.props,nodes=_props.nodes,mainKey=_props.mainKey,scrollToId=_props.scrollToId,ecId=_props.ecId;var flattenedTree=(0,_getFlattenedTree.getFlattenedTree)(nodes,[],mainKey);var rowIndex=(0,_nodes.getRowIndexFromId)(flattenedTree,scrollToId,mainKey);return _react2.default.createElement(_Tree2.default,(0,_extends3.default)({nodePaddingLeft:this.props.nodePaddingLeft,onChange:this.handleChange,NodeRenderer:this.props.children,scrollToIndex:rowIndex,scrollToAlignment:this.props.scrollToAlignment,width:this.props.width},this.props,{nodes:flattenedTree,ecId:ecId+"_Tree@bs6u0e"}));}},{key:"nodes",get:function get(){return this.context.unfilteredNodes||this.props.nodes;}}]);return TreeContainer;}(_react2.default.Component),_class.contextTypes={unfilteredNodes:_propTypes2.default.arrayOf(_propTypes2.default.shape(_nodeShapes.Node))},_temp2);exports.default=TreeContainer;TreeContainer.propTypes={extensions:_propTypes2.default.shape({updateTypeHandlers:_propTypes2.default.object}),nodes:_propTypes2.default.arrayOf(_propTypes2.default.shape(_nodeShapes.Node)).isRequired,onChange:_propTypes2.default.func,children:_propTypes2.default.func.isRequired,nodePaddingLeft:_propTypes2.default.number,width:_propTypes2.default.number,scrollToId:_propTypes2.default.number,scrollToAlignment:_propTypes2.default.string};TreeContainer.defaultProps={nodePaddingLeft:18};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _reactVirtualized=__webpack_require__(618);var _nodeShapes=__webpack_require__(131);var _TreeState=__webpack_require__(665);var _TreeState2=_interopRequireDefault(_TreeState);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tree=function(_React$Component){(0,_inherits3.default)(Tree,_React$Component);function Tree(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Tree);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Tree.__proto__||(0,_getPrototypeOf2.default)(Tree)).call.apply(_ref,[this].concat(args))),_this),_this._cache=new _reactVirtualized.CellMeasurerCache({fixedWidth:true,minHeight:28}),_this.getRowCount=function(){var nodes=_this.props.nodes;return nodes instanceof _TreeState.State?nodes.flattenedTree.length:nodes.length;},_this.getNodeDeepness=function(node,index){var nodes=_this.props.nodes;if(nodes instanceof _TreeState.State){_TreeState2.default.getNodeDeepness(nodes,index);}return nodes instanceof _TreeState.State?_TreeState2.default.getNodeDeepness(nodes,index):node.deepness;},_this.getNode=function(index){var nodes=_this.props.nodes;return nodes instanceof _TreeState.State?(0,_extends3.default)({},_TreeState2.default.getNodeAt(nodes,index),{deepness:_this.getNodeDeepness({},index)}):nodes[index];},_this.rowRenderer=function(_ref2){var node=_ref2.node,key=_ref2.key,measure=_ref2.measure,style=_ref2.style,NodeRenderer=_ref2.NodeRenderer,index=_ref2.index;var _this$props=_this.props,nodePaddingLeft=_this$props.nodePaddingLeft,ecId=_this$props.ecId;return _react2.default.createElement(NodeRenderer,{key:key,ecId:ecId+"_NodeRenderer@qri126@"+key,style:(0,_extends3.default)({},style,{paddingLeft:node.deepness*nodePaddingLeft+10,userSelect:"none"}),node:node,onChange:_this.props.onChange,measure:measure,index:index});},_this.measureRowRenderer=function(nodes){return function(_ref3){var key=_ref3.key,index=_ref3.index,style=_ref3.style,parent=_ref3.parent;var _this$props2=_this.props,NodeRenderer=_this$props2.NodeRenderer,ecId=_this$props2.ecId;var node=_this.getNode(index);return _react2.default.createElement(_reactVirtualized.CellMeasurer,{ecId:ecId+"_CellMeasurer@atl31o@"+key,cache:_this._cache,columnIndex:0,key:key,rowIndex:index,parent:parent},function(m){return _this.rowRenderer((0,_extends3.default)({},m,{index:index,node:node,key:key,style:style,NodeRenderer:NodeRenderer}));});};},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Tree,[{key:"render",value:function render(){var _this2=this;var _props=this.props,nodes=_props.nodes,width=_props.width,scrollToIndex=_props.scrollToIndex,scrollToAlignment=_props.scrollToAlignment,ecId=_props.ecId;return _react2.default.createElement(_reactVirtualized.AutoSizer,{ecId:ecId+"_AutoSizer@uca4nt",disableWidth:Boolean(width)},function(_ref4){var height=_ref4.height,autoWidth=_ref4.width;return _react2.default.createElement(_reactVirtualized.List,(0,_extends3.default)({},_this2.props,{ecId:ecId+"_List@chyl06",deferredMeasurementCache:_this2._cache,ref:function ref(r){return _this2._list=r;},height:height,rowCount:_this2.getRowCount(),rowHeight:_this2._cache.rowHeight,rowRenderer:_this2.measureRowRenderer(nodes),width:width||autoWidth,scrollToIndex:scrollToIndex,scrollToAlignment:scrollToAlignment}));});}}]);return Tree;}(_react2.default.Component);exports.default=Tree;Tree.propTypes={nodes:_propTypes2.default.arrayOf(_propTypes2.default.shape(_nodeShapes.FlattenedNode)).isRequired,NodeRenderer:_propTypes2.default.func.isRequired,onChange:_propTypes2.default.func.isRequired,nodePaddingLeft:_propTypes2.default.number,width:_propTypes2.default.number,scrollToIndex:_propTypes2.default.number,scrollToAlignment:_propTypes2.default.string};

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowKeyStepper", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AutoSizer", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CellMeasurer", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CellMeasurerCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return __WEBPACK_IMPORTED_MODULE_3__Collection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnSizer", function() { return __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "accessibilityOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellRangeRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__ = __webpack_require__(641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InfiniteLoader", function() { return __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_7__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Masonry__ = __webpack_require__(644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMasonryCellPositioner", function() { return __WEBPACK_IMPORTED_MODULE_8__Masonry__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Masonry", function() { return __WEBPACK_IMPORTED_MODULE_8__Masonry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MultiGrid", function() { return __WEBPACK_IMPORTED_MODULE_9__MultiGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollSync", function() { return __WEBPACK_IMPORTED_MODULE_10__ScrollSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTableMultiSort", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellDataGetter", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableHeaderRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableHeaderRowRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableRowRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortDirection", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortIndicator", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WindowScroller__ = __webpack_require__(662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WindowScroller", function() { return __WEBPACK_IMPORTED_MODULE_12__WindowScroller__["a"]; });














/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(275);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(280);
/* unused harmony reexport bpfrpt_proptype_ScrollIndices */








/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;


function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/**
 * Helper method that determines when to recalculate row or column metadata.
 */

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(11);



/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */

var CellSizeAndPositionManager = function () {

  // Used in deferred mode to track which cells have been queued for measurement.

  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeAndPositionData = {};
    this._lastMeasuredIndex = -1;
    this._lastBatchedIndex = -1;

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (_currentOffset === offset) {
          return middle;
        } else if (_currentOffset < offset) {
          low = middle + 1;
        } else if (_currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);




/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(623);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxElementSize; });
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScalingCellSizeAndPositionManager_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(11);




/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}



/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return caf; });


// Properly handle server-side rendering.
var win = void 0;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_DIRECTION_BACKWARD */
/* unused harmony export SCROLL_DIRECTION_FORWARD */
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}



/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(281);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });



/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);








/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CellMeasurer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CellMeasurer)).call.apply(_ref, [this].concat(args))), _this), _this._measure = function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return typeof children === 'function' ? children({ measure: this._measure }) : children;
    }
  }, {
    key: '_getCellMeasurements',
    value: function _getCellMeasurements() {
      var cache = this.props.cache;


      var node = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this);

      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height;

        // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }
        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth);

        // Reset after measuring to avoid breaking styles; see #660
        if (styleWidth) {
          node.style.width = styleWidth;
        }
        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return { height: height, width: width };
      } else {
        return { height: 0, width: 0 };
      }
    }
  }, {
    key: '_maybeMeasureCell',
    value: function _maybeMeasureCell() {
      var _props = this.props,
          cache = _props.cache,
          _props$columnIndex = _props.columnIndex,
          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
          parent = _props.parent,
          _props$rowIndex = _props.rowIndex,
          rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;


      if (!cache.has(rowIndex, columnIndex)) {
        var _getCellMeasurements2 = this._getCellMeasurements(),
            height = _getCellMeasurements2.height,
            width = _getCellMeasurements2.width;

        cache.set(rowIndex, columnIndex, width, height);

        // If size has changed, let Grid know to re-render.
        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

// Used for DEV mode warning check


CellMeasurer.__internalCellMeasurerFlag = false;
CellMeasurer.propTypes =  true ? null : {
  cache: function cache() {
    return (typeof bpfrpt_proptype_CellMeasureCache === 'function' ? bpfrpt_proptype_CellMeasureCache.isRequired ? bpfrpt_proptype_CellMeasureCache.isRequired : bpfrpt_proptype_CellMeasureCache : PropTypes.shape(bpfrpt_proptype_CellMeasureCache).isRequired).apply(this, arguments);
  },
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  columnIndex: PropTypes.number,
  index: PropTypes.number,
  parent: PropTypes.shape({
    invalidateCellSizeAfterRender: PropTypes.func,
    recomputeGridSize: PropTypes.func
  }).isRequired,
  rowIndex: PropTypes.number
};
/* harmony default export */ __webpack_exports__["a"] = (CellMeasurer);
if (false) {
  CellMeasurer.__internalCellMeasurerFlag = true;
}



/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_HEIGHT */
/* unused harmony export DEFAULT_WIDTH */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(284);




var DEFAULT_HEIGHT = 30;

var DEFAULT_WIDTH = 100;

// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache = function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCache);

    this._cellHeightCache = {};
    this._cellWidthCache = {};
    this._columnWidthCache = {};
    this._rowHeightCache = {};
    this._columnCount = 0;
    this._rowCount = 0;

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
    };

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;


    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;

    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
      }

      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }

      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCache, [{
    key: 'clear',
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache.hasOwnProperty(key);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }
      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      }

      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: '_updateCachedColumnAndRowSizes',
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;
        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }
        var columnKey = this._keyMapper(0, columnIndex);
        this._columnWidthCache[columnKey] = columnWidth;
      }
      if (!this._hasFixedHeight) {
        var rowHeight = 0;
        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }
        var rowKey = this._keyMapper(rowIndex, 0);
        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCache);


function defaultKeyMapper(rowIndex, columnIndex) {
  return rowIndex + '-' + columnIndex;
}


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collection__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Collection__["a" /* default */]);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CollectionView__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types__ = __webpack_require__(78);













/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Collection, _React$PureComponent);

  function Collection(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this, props, context));

    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for perforamnce)
    _this._cellCache = [];

    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'forceUpdate',
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }

    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */

  }, {
    key: 'render',
    value: function render() {
      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }

    /** CellLayoutManager interface */

  }, {
    key: 'calculateSizeAndPositionData',
    value: function calculateSizeAndPositionData() {
      var _props = this.props,
          cellCount = _props.cellCount,
          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
          sectionSize = _props.sectionSize;


      var data = Object(__WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: 'getLastRenderedIndices',
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: 'getScrollPositionForCell',
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;


      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];

        scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });

        scrollTop = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: 'cellRenderers',
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _props2 = this.props,
          cellGroupRenderer = _props2.cellGroupRenderer,
          cellRenderer = _props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });

      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({ index: index });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: '_isScrollingChange',
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: '_setCollectionViewRef',
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Collection.defaultProps = {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
};
/* harmony default export */ __webpack_exports__["a"] = (Collection);
Collection.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};


function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;

  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({ index: index });

    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_helpers_scrollbarSize__ = __webpack_require__(279);













// @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()
    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CollectionView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CollectionView)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    };
    _this._calculateSizeAndPositionDataOnNextUpdate = false;
    _this._onSectionRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);

    _this._invokeOnSectionRenderedHelper = function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;


      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._updateScrollPositionForScrollToCell = function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;


      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;

      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    };

    _this._scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_11_dom_helpers_scrollbarSize__["a" /* default */])();
    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          cellLayoutManager = _props.cellLayoutManager,
          scrollLeft = _props.scrollLeft,
          scrollToCell = _props.scrollToCell,
          scrollTop = _props.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_11_dom_helpers_scrollbarSize__["a" /* default */])();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width;

      // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          height = _props2.height,
          scrollToAlignment = _props2.scrollToAlignment,
          scrollToCell = _props2.scrollToCell,
          width = _props2.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          autoHeight = _props3.autoHeight,
          cellCount = _props3.cellCount,
          cellLayoutManager = _props3.cellLayoutManager,
          className = _props3.className,
          height = _props3.height,
          horizontalOverscanSize = _props3.horizontalOverscanSize,
          id = _props3.id,
          noContentRenderer = _props3.noContentRenderer,
          style = _props3.style,
          verticalOverscanSize = _props3.verticalOverscanSize,
          width = _props3.width;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;

      // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;

        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width;

      // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);

      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];

      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["default"])('ReactVirtualized__Collection', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collectionStyle, style),
          tabIndex: 0 },
        cellCount > 0 && __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Collection__innerScrollContainer',
            style: {
              height: totalHeight,
              maxHeight: totalHeight,
              maxWidth: totalWidth,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              width: totalWidth
            } },
          childrenToDisplay
        ),
        cellCount === 0 && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_enablePointerEventsAfterDelay',
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;


        isScrollingChange(false);

        _this2._disablePointerEventsTimeoutId = null;
        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref2) {
      var _this3 = this;

      var scrollLeft = _ref2.scrollLeft,
          scrollTop = _ref2.scrollTop,
          totalHeight = _ref2.totalHeight,
          totalWidth = _ref2.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref3) {
          var scrollLeft = _ref3.scrollLeft,
              scrollTop = _ref3.scrollTop;
          var _props4 = _this3.props,
              height = _props4.height,
              onScroll = _props4.onScroll,
              width = _props4.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref4) {
      var scrollLeft = _ref4.scrollLeft,
          scrollTop = _ref4.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

CollectionView.defaultProps = {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
};
CollectionView.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,

  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(CollectionView);

/* harmony default export */ __webpack_exports__["a"] = (CollectionView);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(636);


function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;

  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({ index: index });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);

    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(78);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */



var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;

    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: 'getCellIndices',
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;

      var indices = {};

      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */

  }, {
    key: 'getCellMetadata',
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;

      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */

  }, {
    key: 'getSections',
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;

      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);

      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = sectionX + '.' + sectionY;

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: 'getTotalSectionCount',
    value: function getTotalSectionCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).length;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: 'registerCell',
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;

      this._cellMetadata[index] = cellMetadatum;

      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({ index: index });
      });
    }
  }]);

  return SectionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SectionManager);



/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(78);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section = function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;

    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'addCellIndex',
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */

  }, {
    key: 'getCellIndices',
    value: function getCellIndices() {
      return this._indices;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
    }
  }]);

  return Section;
}();

/* harmony default export */ __webpack_exports__["a"] = (Section);



/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === undefined ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;

  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a" /* default */]);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColumnSizer)).call(this, props, context));

    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          columnMaxWidth = _props.columnMaxWidth,
          columnMinWidth = _props.columnMinWidth,
          columnCount = _props.columnCount,
          width = _props.width;


      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnMaxWidth = _props2.columnMaxWidth,
          columnMinWidth = _props2.columnMinWidth,
          columnCount = _props2.columnCount,
          width = _props2.width;


      var safeColumnMinWidth = columnMinWidth || 1;

      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;

      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);

      var adjustedWidth = Math.min(width, columnWidth * columnCount);

      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ColumnSizer);
ColumnSizer.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a" /* default */]);


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__ = __webpack_require__(188);










/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfiniteLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InfiniteLoader)).call(this, props, context));

    _this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__["a" /* default */])();

    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: 'resetLoadMoreRowsCache',
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__["a" /* default */])();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;


      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: '_onRowsRendered',
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;

      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: '_doStuff',
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2,
          _this3 = this;

      var _props = this.props,
          isRowLoaded = _props.isRowLoaded,
          minimumBatchSize = _props.minimumBatchSize,
          rowCount = _props.rowCount,
          threshold = _props.threshold;


      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(unloadedRanges.map(function (_ref3) {
        var startIndex = _ref3.startIndex,
            stopIndex = _ref3.stopIndex;
        return [startIndex, stopIndex];
      })));

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


InfiniteLoader.defaultProps = {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
};
/* harmony default export */ __webpack_exports__["a"] = (InfiniteLoader);
InfiniteLoader.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref4.lastRenderedStopIndex,
      startIndex = _ref4.startIndex,
      stopIndex = _ref4.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded,
      minimumBatchSize = _ref5.minimumBatchSize,
      rowCount = _ref5.rowCount,
      startIndex = _ref5.startIndex,
      stopIndex = _ref5.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({ index: index });

    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({ index: _index })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({ index: _index2 })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(285);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(129);
/* unused harmony reexport bpfrpt_proptype_RowRendererParams */








/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Masonry__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Masonry__["a"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__Masonry__["a" /* default */]);


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCellPositioner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Masonry__ = __webpack_require__(189);


function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;

  var columnHeights = void 0;

  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;
    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;

    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;

    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];
    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;

    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;

  return cellPositioner;
}



/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__ = __webpack_require__(652);





// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache = function () {
  function PositionCache() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PositionCache);

    this._columnSizeMap = {};
    this._intervalTree = Object(__WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__["a" /* default */])();
    this._leftMap = {};
  }
  // Tracks the height of each column


  // Store tops and bottoms of each cell for fast intersection lookup.


  // Maps cell index to x coordinates for quick lookup.


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PositionCache, [{
    key: 'estimateTotalHeight',
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    }

    // Render all cells visible within the viewport range defined.

  }, {
    key: 'range',
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: 'setPosition',
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);
      this._leftMap[index] = left;

      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];
      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: 'count',
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: 'shortestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: 'tallestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (PositionCache);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(648), __esModule: true };

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
__webpack_require__(84);
module.exports = __webpack_require__(649);


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(145);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(73);
module.exports = __webpack_require__(20).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
__webpack_require__(84);
module.exports = __webpack_require__(651);


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(44);
var get = __webpack_require__(162);
module.exports = __webpack_require__(20).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__ = __webpack_require__(653);
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/



var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);
  if (idx < 0) {
    return NOT_FOUND;
  }
  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);
  if (this.left) {
    this.left.intervals(result);
  }
  if (this.right) {
    this.right.intervals(result);
  }
  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;
  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin);
    var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;
  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }
    var rw = this.right ? this.right.count : 0;
    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.left.remove(interval);
    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }
    var lw = this.left ? this.left.count : 0;
    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.right.remove(interval);
    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }
    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;
        while (n.right) {
          p = n;
          n = n.right;
        }
        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }
        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }
      return SUCCESS;
    }
    for (var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }
      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);
        for (var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }
    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];
  if (d) {
    return d;
  }
  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];
  if (d) {
    return d;
  }
  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }
  var pts = [];
  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }
  pts.sort(compareNumbers);

  var mid = pts[pts.length >> 1];

  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];
  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];
    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  }

  //Split center intervals
  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);

  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
}

//User friendly wrapper that makes it possible to support empty trees
function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);
    if (r === EMPTY) {
      this.root = null;
    }
    return r !== NOT_FOUND;
  }
  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }
    return 0;
  }
});

Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }
    return [];
  }
});

function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }
  return new IntervalTree(createIntervalTree(intervals));
}

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

function _GEA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GEP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GTP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LTP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LEP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function _EQP(a, l, h, y, c) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);
    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a" /* default */]);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(31);













var SCROLLBAR_SIZE_BUFFER = 20;

/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MultiGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MultiGrid)).call(this, props, context));

    _initialiseProps.call(_this);

    var deferredMeasurementCache = props.deferredMeasurementCache,
        fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount;


    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheBottomRightGrid = fixedColumnCount > 0 || fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheTopRightGrid = fixedColumnCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: 'forceUpdateGrids',
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }

    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$columnIndex = _ref2.columnIndex,
          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
          _ref2$rowIndex = _ref2.rowIndex,
          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;

      var _props = this.props,
          fixedColumnCount = _props.fixedColumnCount,
          fixedRowCount = _props.fixedRowCount;


      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);

      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });

      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          scrollLeft = _props2.scrollLeft,
          scrollTop = _props2.scrollTop;


      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          onScroll = _props3.onScroll,
          onSectionRendered = _props3.onSectionRendered,
          onScrollbarPresenceChange = _props3.onScrollbarPresenceChange,
          scrollLeftProp = _props3.scrollLeft,
          scrollToColumn = _props3.scrollToColumn,
          scrollTopProp = _props3.scrollTop,
          scrollToRow = _props3.scrollToRow,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3, ['onScroll', 'onSectionRendered', 'onScrollbarPresenceChange', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);

      this._prepareForRender();

      // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      }

      // scrollTop and scrollLeft props are explicitly filtered out and ignored

      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        { style: this._containerOuterStyle },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerTopStyle },
          this._renderTopLeftGrid(rest),
          this._renderTopRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollLeft: scrollLeft
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerBottomStyle },
          this._renderBottomLeftGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollTop: scrollTop
          })),
          this._renderBottomRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            onSectionRendered: onSectionRendered,
            scrollLeft: scrollLeft,
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow,
            scrollTop: scrollTop
          }))
        )
      );
    }
  }, {
    key: '_getBottomGridHeight',
    value: function _getBottomGridHeight(props) {
      var height = props.height;


      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: '_getLeftGridWidth',
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;


      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({ index: index });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: '_getRightGridWidth',
    value: function _getRightGridWidth(props) {
      var width = props.width;


      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: '_getTopGridHeight',
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;


      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({ index: index });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: '_maybeCalculateCachedStyles',
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _props4 = this.props,
          columnWidth = _props4.columnWidth,
          enableFixedColumnScroll = _props4.enableFixedColumnScroll,
          enableFixedRowScroll = _props4.enableFixedRowScroll,
          height = _props4.height,
          fixedColumnCount = _props4.fixedColumnCount,
          fixedRowCount = _props4.fixedRowCount,
          rowHeight = _props4.rowHeight,
          style = _props4.style,
          styleBottomLeftGrid = _props4.styleBottomLeftGrid,
          styleBottomRightGrid = _props4.styleBottomRightGrid,
          styleTopLeftGrid = _props4.styleTopLeftGrid,
          styleTopRightGrid = _props4.styleTopRightGrid,
          width = _props4.width;


      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          height: height,
          overflow: 'visible', // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };

        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible', // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: '_prepareForRender',
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: '_renderBottomLeftGrid',
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;


      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'BottomLeftGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._bottomLeftGridStyle, {
              height: height,
              width: width,
              overflowY: 'hidden'
            }) },
          bottomLeftGrid
        );
      }
      return bottomLeftGrid;
    }
  }, {
    key: '_renderBottomRightGrid',
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopLeftGrid',
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;


      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopRightGrid',
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _state2 = this.state,
          showHorizontalScrollbar = _state2.showHorizontalScrollbar,
          scrollbarSize = _state2.scrollbarSize;


      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'TopRightGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
              height: height,
              width: width,
              overflowX: 'hidden'
            }) },
          topRightGrid
        );
      }
      return topRightGrid;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

MultiGrid.defaultProps = {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = {
    scrollLeft: 0,
    scrollTop: 0,
    scrollbarSize: 0,
    showHorizontalScrollbar: false,
    showVerticalScrollbar: false
  };
  this._deferredInvalidateColumnIndex = null;
  this._deferredInvalidateRowIndex = null;

  this._bottomLeftGridRef = function (ref) {
    _this2._bottomLeftGrid = ref;
  };

  this._bottomRightGridRef = function (ref) {
    _this2._bottomRightGrid = ref;
  };

  this._cellRendererBottomLeftGrid = function (_ref3) {
    var rowIndex = _ref3.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['rowIndex']);

    var _props5 = _this2.props,
        cellRenderer = _props5.cellRenderer,
        fixedRowCount = _props5.fixedRowCount,
        rowCount = _props5.rowCount;


    if (rowIndex === rowCount - fixedRowCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          height: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        parent: _this2,
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  };

  this._cellRendererBottomRightGrid = function (_ref4) {
    var columnIndex = _ref4.columnIndex,
        rowIndex = _ref4.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['columnIndex', 'rowIndex']);

    var _props6 = _this2.props,
        cellRenderer = _props6.cellRenderer,
        fixedColumnCount = _props6.fixedColumnCount,
        fixedRowCount = _props6.fixedRowCount;


    return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
      columnIndex: columnIndex + fixedColumnCount,
      parent: _this2,
      rowIndex: rowIndex + fixedRowCount
    }));
  };

  this._cellRendererTopRightGrid = function (_ref5) {
    var columnIndex = _ref5.columnIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['columnIndex']);

    var _props7 = _this2.props,
        cellRenderer = _props7.cellRenderer,
        columnCount = _props7.columnCount,
        fixedColumnCount = _props7.fixedColumnCount;


    if (columnIndex === columnCount - fixedColumnCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          width: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _this2
      }));
    }
  };

  this._columnWidthRightGrid = function (_ref6) {
    var index = _ref6.index;
    var _props8 = _this2.props,
        columnCount = _props8.columnCount,
        fixedColumnCount = _props8.fixedColumnCount,
        columnWidth = _props8.columnWidth;
    var _state3 = _this2.state,
        scrollbarSize = _state3.scrollbarSize,
        showHorizontalScrollbar = _state3.showHorizontalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
      return scrollbarSize;
    }

    return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
  };

  this._onScroll = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft,
        scrollTop = scrollInfo.scrollTop;

    _this2.setState({
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    });
    var onScroll = _this2.props.onScroll;
    if (onScroll) {
      onScroll(scrollInfo);
    }
  };

  this._onScrollbarPresenceChange = function (_ref7) {
    var horizontal = _ref7.horizontal,
        size = _ref7.size,
        vertical = _ref7.vertical;
    var _state4 = _this2.state,
        showHorizontalScrollbar = _state4.showHorizontalScrollbar,
        showVerticalScrollbar = _state4.showVerticalScrollbar;


    if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
      _this2.setState({
        scrollbarSize: size,
        showHorizontalScrollbar: horizontal,
        showVerticalScrollbar: vertical
      });

      var onScrollbarPresenceChange = _this2.props.onScrollbarPresenceChange;

      if (typeof onScrollbarPresenceChange === 'function') {
        onScrollbarPresenceChange({
          horizontal: horizontal,
          size: size,
          vertical: vertical
        });
      }
    }
  };

  this._onScrollLeft = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft;

    _this2._onScroll({
      scrollLeft: scrollLeft,
      scrollTop: _this2.state.scrollTop
    });
  };

  this._onScrollTop = function (scrollInfo) {
    var scrollTop = scrollInfo.scrollTop;

    _this2._onScroll({
      scrollTop: scrollTop,
      scrollLeft: _this2.state.scrollLeft
    });
  };

  this._rowHeightBottomGrid = function (_ref8) {
    var index = _ref8.index;
    var _props9 = _this2.props,
        fixedRowCount = _props9.fixedRowCount,
        rowCount = _props9.rowCount,
        rowHeight = _props9.rowHeight;
    var _state5 = _this2.state,
        scrollbarSize = _state5.scrollbarSize,
        showVerticalScrollbar = _state5.showVerticalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
      return scrollbarSize;
    }

    return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
  };

  this._topLeftGridRef = function (ref) {
    _this2._topLeftGrid = ref;
  };

  this._topRightGridRef = function (ref) {
    _this2._topRightGrid = ref;
  };
};

MultiGrid.propTypes =  false ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired,
  hideTopRightGridScrollbar: PropTypes.bool,
  hideBottomLeftGridScrollbar: PropTypes.bool
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(MultiGrid);

/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(283);




/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator = function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCacheDecorator);

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    };

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === undefined ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === undefined ? 0 : _params$rowIndexOffse;


    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCacheDecorator, [{
    key: 'clear',
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCacheDecorator);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a" /* default */]);


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          clientHeight = _state.clientHeight,
          clientWidth = _state.clientWidth,
          scrollHeight = _state.scrollHeight,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop,
          scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;

      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
ScrollSync.propTypes =  false ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMultiSort__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Column__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortDirection__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SortIndicator__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createMultiSort__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Column__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__SortDirection__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__SortIndicator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__Table__["a"]; });











/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */]);


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMultiSort;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



function createMultiSort(sortCallback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultSortBy = _ref.defaultSortBy,
      _ref$defaultSortDirec = _ref.defaultSortDirection,
      defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;

  if (!sortCallback) {
    throw Error('Required parameter "sortCallback" not specified');
  }

  var sortBy = defaultSortBy || [];
  var sortDirection = {};

  sortBy.forEach(function (dataKey) {
    sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
  });

  function sort(_ref2) {
    var defaultSortDirection = _ref2.defaultSortDirection,
        event = _ref2.event,
        dataKey = _ref2.sortBy;

    if (event.shiftKey) {
      // Shift + click appends a column to existing criteria
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
        sortBy.push(dataKey);
      }
    } else if (event.ctrlKey || event.metaKey) {
      // Control + click removes column from sort (if pressent)
      var index = sortBy.indexOf(dataKey);
      if (index >= 0) {
        sortBy.splice(index, 1);
        delete sortDirection[dataKey];
      }
    } else {
      // Clear sortBy array of all non-selected keys
      sortBy.length = 0;
      sortBy.push(dataKey);

      // Clear sortDirection object of all non-selected keys
      var sortDirectionKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sortDirection);
      sortDirectionKeys.forEach(function (key) {
        if (key !== dataKey) delete sortDirection[key];
      });

      // If key is already selected, reverse sort direction.
      // Else, set sort direction to default direction.
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
      }
    }

    // Notify application code
    sortCallback({
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }

  return {
    sort: sort,
    sortBy: sortBy,
    sortDirection: sortDirection
  };
}

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Column__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SortDirection__ = __webpack_require__(130);




















/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _React$PureComponent);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Table)).call(this, props));

    _this.state = {
      scrollbarWidth: 0
    };

    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _Grid$getOffsetForCel.scrollTop;

        return scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'getScrollbarWidth',
    value: function getScrollbarWidth() {
      if (this.Grid) {
        var _Grid = Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(this.Grid);
        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }

      return 0;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeader = _props.disableHeader,
          gridClassName = _props.gridClassName,
          gridStyle = _props.gridStyle,
          headerHeight = _props.headerHeight,
          headerRowRenderer = _props.headerRowRenderer,
          height = _props.height,
          id = _props.id,
          noRowsRenderer = _props.noRowsRenderer,
          rowClassName = _props.rowClassName,
          rowStyle = _props.rowStyle,
          scrollToIndex = _props.scrollToIndex,
          style = _props.style,
          width = _props.width;
      var scrollbarWidth = this.state.scrollbarWidth;


      var availableRowsHeight = disableHeader ? height : height - headerHeight;

      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          overflow: 'hidden'
        }, flexStyles);
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-label': this.props['aria-label'],
          'aria-labelledby': this.props['aria-labelledby'],
          'aria-colcount': __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).length,
          'aria-rowcount': this.props.rowCount,
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["default"])('ReactVirtualized__Table', className),
          id: id,
          role: 'grid',
          style: style },
        !disableHeader && headerRowRenderer({
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["default"])('ReactVirtualized__Table__headerRow', rowClass),
          columns: this._getHeaderColumns(),
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            height: headerHeight,
            overflow: 'hidden',
            paddingRight: scrollbarWidth,
            width: width
          }, rowStyleObject)
        }),
        __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
          'aria-readonly': null,
          autoContainerWidth: true,
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["default"])('ReactVirtualized__Table__Grid', gridClassName),
          cellRenderer: this._createRow,
          columnWidth: width,
          columnCount: 1,
          height: availableRowsHeight,
          id: undefined,
          noContentRenderer: noRowsRenderer,
          onScroll: this._onScroll,
          onSectionRendered: this._onSectionRendered,
          ref: this._setRef,
          role: 'rowgroup',
          scrollbarWidth: scrollbarWidth,
          scrollToRow: scrollToIndex,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, {
            overflowX: 'hidden'
          })
        }))
      );
    }
  }, {
    key: '_createColumn',
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;


      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({ columnData: columnData, dataKey: dataKey, event: event });
      };

      var style = this._cachedColumnStyles[columnIndex];

      var title = typeof renderedCell === 'string' ? renderedCell : null;

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-colindex': columnIndex + 1,
          'aria-describedby': id,
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["default"])('ReactVirtualized__Table__rowColumn', className),
          key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
          onClick: onClick,
          role: 'gridcell',
          style: style,
          title: title },
        renderedCell
      );
    }
  }, {
    key: '_createHeader',
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _props2 = this.props,
          headerClassName = _props2.headerClassName,
          headerStyle = _props2.headerStyle,
          onHeaderClick = _props2.onHeaderClick,
          sort = _props2.sort,
          sortBy = _props2.sortBy,
          sortDirection = _props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;

      var sortEnabled = !disableSort && sort;

      var classNames = Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["default"])('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headerStyle, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });

      var headerOnClick = void 0,
          headerOnKeyDown = void 0,
          headerTabIndex = void 0,
          headerAriaSort = void 0,
          headerAriaLabel = void 0;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey;

        // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.
        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC ? 'ascending' : 'descending';
      }

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-label': headerAriaLabel,
          'aria-sort': headerAriaSort,
          className: classNames,
          id: id,
          key: 'Header-Col' + index,
          onClick: headerOnClick,
          onKeyDown: headerOnKeyDown,
          role: 'columnheader',
          style: style,
          tabIndex: headerTabIndex },
        renderedHeader
      );
    }
  }, {
    key: '_createRow',
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _props3 = this.props,
          children = _props3.children,
          onRowClick = _props3.onRowClick,
          onRowDoubleClick = _props3.onRowDoubleClick,
          onRowRightClick = _props3.onRowRightClick,
          onRowMouseOver = _props3.onRowMouseOver,
          onRowMouseOut = _props3.onRowMouseOut,
          rowClassName = _props3.rowClassName,
          rowGetter = _props3.rowGetter,
          rowRenderer = _props3.rowRenderer,
          rowStyle = _props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;


      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
      var rowData = rowGetter({ index: index });

      var columns = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });

      var className = Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["default"])('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: '_getFlexStyleForColumn',
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: '_getHeaderColumns',
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _props4 = this.props,
          children = _props4.children,
          disableHeader = _props4.disableHeader;

      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children);

      return items.map(function (column, index) {
        return _this4._createHeader({ column: column, index: index });
      });
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;


      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: '_setRef',
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: '_setScrollbarWidth',
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();

      this.setState({ scrollbarWidth: scrollbarWidth });
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

Table.defaultProps = {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__["a" /* default */],
  headerRowRenderer: __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Table);
Table.propTypes =  false ? {
  /** This is just set on the grid top element. */
  'aria-label': PropTypes.string,

  /** This is just set on the grid top element. */
  'aria-labelledby': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      var childType = children[i].type;
      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
   * Optional callback when a column is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onColumnClick: PropTypes.func,

  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : {};


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a"]; });
/* unused harmony reexport IS_SCROLLING_TIMEOUT */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a" /* default */]);


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowScroller_js__ = __webpack_require__(294);



var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });

  disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;

    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}

function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDimensions;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionOffset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollOffset;


/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */

var isWindow = function isWindow(element) {
  return element === window;
};

// TODO Move this into WindowScroller and import from there


var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;

    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}

/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */
function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);
    var _elementRect = getBoundingBox(element);
    var _containerRect = getBoundingBox(container);
    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}

/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=exports.validateState=exports.State=undefined;var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _class2,_temp;var _getFlattenedTree=__webpack_require__(190);var _nodes=__webpack_require__(79);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var State=exports.State=function State(tree,flattenedTree){(0,_classCallCheck3.default)(this,State);this.flattenedTree=null;this.tree=null;this.tree=tree;this.flattenedTree=flattenedTree||(0,_getFlattenedTree.getFlattenedTreePaths)(tree);};var validateState=exports.validateState=function validateState(state){if(!(state instanceof State)){throw new Error("Expected a State instance but got "+(typeof state==="undefined"?"undefined":(0,_typeof3.default)(state)));}};/**
 * Immutable structure that represents the TreeState.
 */var TreeState=(_temp=_class2=function TreeState(){(0,_classCallCheck3.default)(this,TreeState);},_class2.getNodeAt=function(state,index){validateState(state);var rowPath=state.flattenedTree[index];if(!rowPath){throw Error("Tried to get node at row \""+index+"\" but got nothing, the tree are "+state.flattenedTree.length+" visible rows");}return(0,_nodes.getNodeFromPath)(rowPath,state.tree);},_class2.getNodeDeepness=function(state,index){validateState(state);var rowPath=state.flattenedTree[index];if(!rowPath){throw Error("Tried to get node at row \""+index+"\" but got nothing, the tree are "+state.flattenedTree.length+" visible rows");}return rowPath.length-1;},_class2.getNumberOfVisibleDescendants=function(state,index){var _TreeState$getNodeAt=TreeState.getNodeAt(state,index),id=_TreeState$getNodeAt.id;var flattenedTree=state.flattenedTree;var i=void 0;for(i=index;i<flattenedTree.length;i++){var path=flattenedTree[i];if(!path.some(function(p){return p===id;})){break;}}return Math.max(i-1-index,0);},_class2.getTree=function(state){validateState(state);return state.tree;},_class2.createFromTree=function(tree){if(!tree){throw Error("A falsy tree was supplied in tree creation");}if(!Array.isArray(tree)){throw Error("An invalid tree was supplied in creation");}return new State(tree);},_temp);exports.default=TreeState;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable string keyed properties of `object` that are
 * not omitted.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = baseRest(function(object, props) {
  if (object == null) {
    return {};
  }
  props = arrayMap(baseFlatten(props, 1), toKey);
  return basePick(object, baseDifference(getAllKeysIn(object), props));
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = omit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array ? array.length : 0;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = findIndex;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34), __webpack_require__(103)(module)))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Deletable=__webpack_require__(669);var _Deletable2=_interopRequireDefault(_Deletable);var _Expandable=__webpack_require__(670);var _Expandable2=_interopRequireDefault(_Expandable);var _Favorite=__webpack_require__(671);var _Favorite2=_interopRequireDefault(_Favorite);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={Deletable:_Deletable2.default,Expandable:_Expandable2.default,Favorite:_Favorite2.default};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _eventWrappers=__webpack_require__(192);var _nodes=__webpack_require__(79);var _rendererShapes=__webpack_require__(193);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Deletable=function Deletable(_ref){var onChange=_ref.onChange,node=_ref.node,_ref$iconsClassNameMa=_ref.iconsClassNameMap,iconsClassNameMap=_ref$iconsClassNameMa===undefined?{delete:"mi mi-delete"}:_ref$iconsClassNameMa,children=_ref.children,index=_ref.index,ecId=_ref.ecId;var _getNodeRenderOptions=(0,_nodes.getNodeRenderOptions)(node),isDeletable=_getNodeRenderOptions.isDeletable;var className=(0,_classnames2.default)((0,_defineProperty3.default)({},iconsClassNameMap.delete,isDeletable));var handleChange=function handleChange(){return onChange((0,_extends3.default)({},(0,_nodes.deleteNode)(node),{index:index}));};return _react2.default.createElement("span",null,isDeletable&&_react2.default.createElement("i",{ecId:ecId+"_i@0exiq6",tabIndex:0,onKeyDown:(0,_eventWrappers.submitEvent)(handleChange),onClick:handleChange,className:className}),children);};Deletable.propTypes=(0,_extends3.default)({},_rendererShapes.Renderer,{iconsClassNameMap:_propTypes2.default.shape({delete:_propTypes2.default.string})});exports.default=Deletable;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _eventWrappers=__webpack_require__(192);var _nodes=__webpack_require__(79);var _rendererShapes=__webpack_require__(193);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Expandable=function Expandable(_ref){var _classNames;var onChange=_ref.onChange,node=_ref.node,children=_ref.children,index=_ref.index,ecId=_ref.ecId,_ref$iconsClassNameMa=_ref.iconsClassNameMap,iconsClassNameMap=_ref$iconsClassNameMa===undefined?{expanded:"mi mi-keyboard-arrow-down",collapsed:"mi mi-keyboard-arrow-right",lastChild:""}:_ref$iconsClassNameMa;var _getNodeRenderOptions=(0,_nodes.getNodeRenderOptions)(node),hasChildren=_getNodeRenderOptions.hasChildren,isExpanded=_getNodeRenderOptions.isExpanded;var className=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,iconsClassNameMap.expanded,hasChildren&&isExpanded),(0,_defineProperty3.default)(_classNames,iconsClassNameMap.collapsed,hasChildren&&!isExpanded),(0,_defineProperty3.default)(_classNames,iconsClassNameMap.lastChild,!hasChildren),_classNames));var handleChange=function handleChange(){return onChange((0,_extends3.default)({},(0,_nodes.updateNode)(node,{expanded:!isExpanded}),{index:index}));};return _react2.default.createElement("span",{ecId:ecId+"_span@0sjfo4",onDoubleClick:handleChange},hasChildren&&_react2.default.createElement("i",{ecId:ecId+"_i@vxizuu",tabIndex:0,onKeyDown:(0,_eventWrappers.submitEvent)(handleChange),onClick:handleChange,className:className}),children);};Expandable.propTypes=(0,_extends3.default)({},_rendererShapes.Renderer,{iconsClassNameMap:_propTypes2.default.shape({expanded:_propTypes2.default.string,collapsed:_propTypes2.default.string,lastChild:_propTypes2.default.string})});exports.default=Expandable;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _eventWrappers=__webpack_require__(192);var _nodes=__webpack_require__(79);var _rendererShapes=__webpack_require__(193);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Favorite=function Favorite(_ref){var _classNames;var onChange=_ref.onChange,node=_ref.node,_ref$iconsClassNameMa=_ref.iconsClassNameMap,iconsClassNameMap=_ref$iconsClassNameMa===undefined?{favorite:"mi mi-star",notFavorite:"mi mi-star-border"}:_ref$iconsClassNameMa,children=_ref.children,index=_ref.index,ecId=_ref.ecId;var _getNodeRenderOptions=(0,_nodes.getNodeRenderOptions)(node),isFavorite=_getNodeRenderOptions.isFavorite;var className=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,iconsClassNameMap.favorite,isFavorite),(0,_defineProperty3.default)(_classNames,iconsClassNameMap.notFavorite,!isFavorite),_classNames));var handleChange=function handleChange(){return onChange((0,_extends3.default)({},(0,_nodes.updateNode)(node,{favorite:!isFavorite}),{index:index}));};return _react2.default.createElement("span",null,_react2.default.createElement("i",{ecId:ecId+"_i@os4d5b",tabIndex:0,onKeyDown:(0,_eventWrappers.submitEvent)(handleChange),onClick:handleChange,className:className}),children);};Favorite.propTypes=(0,_extends3.default)({},_rendererShapes.Renderer,{iconsClassNameMap:_propTypes2.default.shape({favorite:_propTypes2.default.string,notFavorite:_propTypes2.default.string})});exports.default=Favorite;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _lodash=__webpack_require__(358);var _lodash2=_interopRequireDefault(_lodash);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _DefaultGroupRenderer=__webpack_require__(673);var _DefaultGroupRenderer2=_interopRequireDefault(_DefaultGroupRenderer);var _nodeShapes=__webpack_require__(131);var _filtering=__webpack_require__(674);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var nameMatchesSearchTerm=function nameMatchesSearchTerm(searchTerm){return function(_ref){var name=_ref.name;var upperCaseName=name.toUpperCase();var upperCaseSearchTerm=searchTerm.toUpperCase();return upperCaseName.indexOf(upperCaseSearchTerm.trim())>-1;};};var FilteringContainer=(_temp=_class=function(_React$Component){(0,_inherits3.default)(FilteringContainer,_React$Component);function FilteringContainer(props){(0,_classCallCheck3.default)(this,FilteringContainer);var _this=(0,_possibleConstructorReturn3.default)(this,(FilteringContainer.__proto__||(0,_getPrototypeOf2.default)(FilteringContainer)).call(this,props));_this.state={filterText:"",filterTerm:""};_this.getChildContext=function(){return{unfilteredNodes:_this.props.nodes};};_this.handleFilterTextChange=function(e){var filterText=e.target.value;_this.setState({filterText:filterText});_this.setFilterTerm();};_this.setFilterTerm=props.debouncer(_this.setFilterTerm,300);return _this;}(0,_createClass3.default)(FilteringContainer,[{key:"setFilterTerm",value:function setFilterTerm(){this.setState(function(ps){return{filterTerm:ps.filterText};});}},{key:"render",value:function render(){var _state=this.state,filterTerm=_state.filterTerm,filterText=_state.filterText;var _props=this.props,nodes=_props.nodes,treeRenderer=_props.children,groups=_props.groups,selectedGroup=_props.selectedGroup,GroupRenderer=_props.groupRenderer,onSelectedGroupChange=_props.onSelectedGroupChange,ecId=_props.ecId;var relevantNodes=groups&&selectedGroup&&groups[selectedGroup]?(0,_filtering.filterNodes)(groups[selectedGroup].filter,nodes):{nodes:nodes,nodeParentMappings:{}};var _ref2=filterTerm?(0,_filtering.filterNodes)(nameMatchesSearchTerm(filterTerm),relevantNodes.nodes):relevantNodes,filteredNodes=_ref2.nodes,nodeParentMappings=_ref2.nodeParentMappings;return _react2.default.createElement("div",{className:"tree-filter-container"},_react2.default.createElement("div",{className:(0,_classnames2.default)("tree-lookup-input",{group:!!groups})},_react2.default.createElement("input",{ecId:ecId+"_input@zkgd8a",value:filterText,onChange:this.handleFilterTextChange,placeholder:"Search..."}),_react2.default.createElement("i",{"aria-hidden":"true",className:"mi mi-11 mi-search"}),groups&&_react2.default.createElement(GroupRenderer,{ecId:ecId+"_GroupRenderer@byh9lj",groups:groups,selectedGroup:selectedGroup,onChange:onSelectedGroupChange})),treeRenderer({nodes:filteredNodes,nodeParentMappings:nodeParentMappings}));}}]);return FilteringContainer;}(_react2.default.Component),_class.childContextTypes={unfilteredNodes:_propTypes2.default.arrayOf(_propTypes2.default.shape(_nodeShapes.Node)).isRequired},_class.defaultProps={debouncer:_lodash2.default,groupRenderer:_DefaultGroupRenderer2.default},_temp);exports.default=FilteringContainer;FilteringContainer.propTypes={children:_propTypes2.default.func.isRequired,debouncer:_propTypes2.default.func,groups:_propTypes2.default.object,selectedGroup:_propTypes2.default.string,groupRenderer:_propTypes2.default.func,onSelectedGroupChange:_propTypes2.default.func};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DefaultGroupRenderer=function DefaultGroupRenderer(_ref){var _onChange=_ref.onChange,groups=_ref.groups,selectedGroup=_ref.selectedGroup,ecId=_ref.ecId;return _react2.default.createElement("select",{ecId:ecId+"_select@p3zzh7",className:"tree-group",onChange:function onChange(_ref2){var value=_ref2.target.value;_onChange(value);},value:selectedGroup},(0,_keys2.default)(groups).map(function(g){return _react2.default.createElement("option",{key:g,value:g},groups[g].name);}));};exports.default=DefaultGroupRenderer;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.filterNodes=undefined;var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends3=__webpack_require__(0);var _extends4=_interopRequireDefault(_extends3);var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var INITIAL_FILTERED_VALUE={nodes:[],nodeParentMappings:{}};var filterNodes=exports.filterNodes=function filterNodes(filter,nodes){var parents=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];return nodes.reduce(function(filtered,n){var _ref=n.children?filterNodes(filter,n.children,[].concat((0,_toConsumableArray3.default)(parents),[n.id])):INITIAL_FILTERED_VALUE,filteredChildren=_ref.nodes,childrenNodeMappings=_ref.nodeParentMappings;return!(filter(n)||filteredChildren.length)?filtered:{nodes:[].concat((0,_toConsumableArray3.default)(filtered.nodes),[(0,_extends4.default)({},n,{children:filteredChildren})]),nodeParentMappings:(0,_extends4.default)({},filtered.nodeParentMappings,childrenNodeMappings,(0,_defineProperty3.default)({},n.id,parents))};},INITIAL_FILTERED_VALUE);};

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=reorder;/*
 * Utility to reorder list
 * Scans the list only once.
 */function reorder(array,fromIndex,toIndex){var lastIndex=array.length-1;var firstIndex=0;var result=new Array(array.length);var tmp=void 0;if(fromIndex===toIndex){return array;}if(fromIndex<toIndex){for(var i=firstIndex;i<=lastIndex;i++){if(i===fromIndex){tmp=array[i];}else if(i>fromIndex&&i<toIndex){result[i-1]=array[i];}else if(i===toIndex){result[i-1]=array[i];result[i]=tmp;}else{result[i]=array[i];}}}else{for(var _i=lastIndex;_i>=firstIndex;_i--){if(_i===fromIndex){tmp=array[_i];}else if(_i<fromIndex&&_i>toIndex){result[_i+1]=array[_i];}else if(_i===toIndex){result[_i]=tmp;result[_i+1]=array[_i];}else{result[_i]=array[_i];}}}return result;}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var dragula=__webpack_require__(687);var atoa=__webpack_require__(297);function reactDragula(){return dragula.apply(this,atoa(arguments)).on("cloned",cloned);function cloned(clone){rm(clone);atoa(clone.getElementsByTagName("*")).forEach(rm);}function rm(el){el.removeAttribute("data-reactid");}}module.exports=reactDragula;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var emitter=__webpack_require__(688);var crossvent=__webpack_require__(694);var classes=__webpack_require__(697);var doc=document;var documentElement=doc.documentElement;function dragula(initialContainers,options){var len=arguments.length;if(len===1&&Array.isArray(initialContainers)===false){options=initialContainers;initialContainers=[];}var _mirror;// mirror image
var _source;// source container
var _item;// item being dragged
var _offsetX;// reference x
var _offsetY;// reference y
var _moveX;// reference move x
var _moveY;// reference move y
var _initialSibling;// reference sibling when grabbed
var _currentSibling;// reference sibling now
var _copy;// item used for copying
var _renderTimer;// timer for setTimeout renderMirrorImage
var _lastDropTarget=null;// last container item was over
var _grabbed;// holds mousedown context until first mousemove
var o=options||{};if(o.moves===void 0){o.moves=always;}if(o.accepts===void 0){o.accepts=always;}if(o.invalid===void 0){o.invalid=invalidTarget;}if(o.containers===void 0){o.containers=initialContainers||[];}if(o.isContainer===void 0){o.isContainer=never;}if(o.copy===void 0){o.copy=false;}if(o.copySortSource===void 0){o.copySortSource=false;}if(o.revertOnSpill===void 0){o.revertOnSpill=false;}if(o.removeOnSpill===void 0){o.removeOnSpill=false;}if(o.direction===void 0){o.direction="vertical";}if(o.ignoreInputTextSelection===void 0){o.ignoreInputTextSelection=true;}if(o.mirrorContainer===void 0){o.mirrorContainer=doc.body;}if(o.doc!==void 0){doc=o.doc;//设置组件调用的document对象，解决流程模块使用iframe调用拖拽失效的问题
documentElement=doc.documentElement;}var drake=emitter({containers:o.containers,start:manualStart,end:end,cancel:cancel,remove:remove,destroy:destroy,canMove:canMove,dragging:false});if(o.removeOnSpill===true){drake.on("over",spillOver).on("out",spillOut);}events();return drake;function isContainer(el){return drake.containers.indexOf(el)!==-1||o.isContainer(el);}function events(remove){var op=remove?"remove":"add";touchy(documentElement,op,"mousedown",grab);touchy(documentElement,op,"mouseup",release);}function eventualMovements(remove){var op=remove?"remove":"add";touchy(documentElement,op,"mousemove",startBecauseMouseMoved);}function movements(remove){var op=remove?"remove":"add";crossvent[op](documentElement,"selectstart",preventGrabbed);// IE8
crossvent[op](documentElement,"click",preventGrabbed);}function destroy(){events(true);release({});}function preventGrabbed(e){if(_grabbed){e.preventDefault();}}function grab(e){_moveX=e.clientX;_moveY=e.clientY;var ignore=whichMouseButton(e)!==1||e.metaKey||e.ctrlKey;if(ignore){return;// we only care about honest-to-god left clicks and touch events
}var item=e.target;var context=canStart(item);if(!context){return;}_grabbed=context;eventualMovements();if(e.type==="mousedown"){if(isInput(item)){// see also: https://github.com/bevacqua/dragula/issues/208
item.focus();// fixes https://github.com/bevacqua/dragula/issues/176
}else{e.preventDefault();// fixes https://github.com/bevacqua/dragula/issues/155
}}}function startBecauseMouseMoved(e){if(!_grabbed){return;}if(whichMouseButton(e)===0){release({});return;// when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
}// truthy check fixes #239, equality fixes #207
if(e.clientX!==void 0&&e.clientX===_moveX&&e.clientY!==void 0&&e.clientY===_moveY){return;}if(o.ignoreInputTextSelection){var clientX=getCoord("clientX",e);var clientY=getCoord("clientY",e);var elementBehindCursor=doc.elementFromPoint(clientX,clientY);if(isInput(elementBehindCursor)){return;}}var grabbed=_grabbed;// call to end() unsets _grabbed
eventualMovements(true);movements();end();start(grabbed);var offset=getOffset(_item);_offsetX=getCoord("pageX",e)-offset.left;_offsetY=getCoord("pageY",e)-offset.top;classes.add(_copy||_item,"gu-transit");renderMirrorImage();drag(e);}function canStart(item){if(drake.dragging&&_mirror){return;}if(isContainer(item)){return;// don't drag container itself
}var handle=item;while(getParent(item)&&isContainer(getParent(item))===false){if(o.invalid(item,handle)){return;}item=getParent(item);// drag target should be a top element
if(!item){return;}}var source=getParent(item);if(!source){return;}if(o.invalid(item,handle)){return;}var movable=o.moves(item,source,handle,nextEl(item));if(!movable){return;}return{item:item,source:source};}function canMove(item){return!!canStart(item);}function manualStart(item){var context=canStart(item);if(context){start(context);}}function start(context){if(isCopy(context.item,context.source)){_copy=context.item.cloneNode(true);drake.emit("cloned",_copy,context.item,"copy");}_source=context.source;_item=context.item;_initialSibling=_currentSibling=nextEl(context.item);drake.dragging=true;drake.emit("drag",_item,_source);}function invalidTarget(){return false;}function end(){if(!drake.dragging){return;}var item=_copy||_item;drop(item,getParent(item));}function ungrab(){_grabbed=false;eventualMovements(true);movements(true);}function release(e){ungrab();if(!drake.dragging){return;}var item=_copy||_item;var clientX=getCoord("clientX",e);var clientY=getCoord("clientY",e);var elementBehindCursor=getElementBehindPoint(_mirror,clientX,clientY);var dropTarget=findDropTarget(elementBehindCursor,clientX,clientY);if(dropTarget&&(_copy&&o.copySortSource||!_copy||dropTarget!==_source)){drop(item,dropTarget);}else if(o.removeOnSpill){remove();}else{cancel();}}function drop(item,target){var parent=getParent(item);if(_copy&&o.copySortSource&&target===_source){parent.removeChild(_item);}if(isInitialPlacement(target)){drake.emit("cancel",item,_source,_source);}else{drake.emit("drop",item,target,_source,_currentSibling);}cleanup();}function remove(){if(!drake.dragging){return;}var item=_copy||_item;var parent=getParent(item);if(parent){parent.removeChild(item);}drake.emit(_copy?"cancel":"remove",item,parent,_source);cleanup();}function cancel(revert){if(!drake.dragging){return;}var reverts=arguments.length>0?revert:o.revertOnSpill;var item=_copy||_item;var parent=getParent(item);var initial=isInitialPlacement(parent);if(initial===false&&reverts){if(_copy){if(parent){parent.removeChild(_copy);}}else{_source.insertBefore(item,_initialSibling);}}if(initial||reverts){drake.emit("cancel",item,_source,_source);}else{drake.emit("drop",item,parent,_source,_currentSibling);}cleanup();}function cleanup(){var item=_copy||_item;ungrab();removeMirrorImage();if(item){classes.rm(item,"gu-transit");}if(_renderTimer){clearTimeout(_renderTimer);}drake.dragging=false;if(_lastDropTarget){drake.emit("out",item,_lastDropTarget,_source);}drake.emit("dragend",item);_source=_item=_copy=_initialSibling=_currentSibling=_renderTimer=_lastDropTarget=null;}function isInitialPlacement(target,s){var sibling;if(s!==void 0){sibling=s;}else if(_mirror){sibling=_currentSibling;}else{sibling=nextEl(_copy||_item);}return target===_source&&sibling===_initialSibling;}function findDropTarget(elementBehindCursor,clientX,clientY){var target=elementBehindCursor;while(target&&!accepted()){target=getParent(target);}return target;function accepted(){var droppable=isContainer(target);if(droppable===false){return false;}var immediate=getImmediateChild(target,elementBehindCursor);var reference=getReference(target,immediate,clientX,clientY);var initial=isInitialPlacement(target,reference);if(initial){return true;// should always be able to drop it right back where it was
}return o.accepts(_item,target,_source,reference);}}function drag(e){if(!_mirror){return;}e.preventDefault();var clientX=getCoord("clientX",e);var clientY=getCoord("clientY",e);var x=clientX-_offsetX;var y=clientY-_offsetY;_mirror.style.left=x+"px";_mirror.style.top=y+"px";var item=_copy||_item;var elementBehindCursor=getElementBehindPoint(_mirror,clientX,clientY);var dropTarget=findDropTarget(elementBehindCursor,clientX,clientY);var changed=dropTarget!==null&&dropTarget!==_lastDropTarget;if(changed||dropTarget===null){out();_lastDropTarget=dropTarget;over();}var parent=getParent(item);if(dropTarget===_source&&_copy&&!o.copySortSource){if(parent){parent.removeChild(item);}return;}var reference;var immediate=getImmediateChild(dropTarget,elementBehindCursor);if(immediate!==null){reference=getReference(dropTarget,immediate,clientX,clientY);}else if(o.revertOnSpill===true&&!_copy){reference=_initialSibling;dropTarget=_source;}else{if(_copy&&parent){parent.removeChild(item);}return;}if(reference===null&&changed||reference!==item&&reference!==nextEl(item)){_currentSibling=reference;dropTarget.insertBefore(item,reference);drake.emit("shadow",item,dropTarget,_source);}function moved(type){drake.emit(type,item,_lastDropTarget,_source);}function over(){if(changed){moved("over");}}function out(){if(_lastDropTarget){moved("out");}}}function spillOver(el){classes.rm(el,"gu-hide");}function spillOut(el){if(drake.dragging){classes.add(el,"gu-hide");}}function renderMirrorImage(){if(_mirror){return;}var rect=_item.getBoundingClientRect();_mirror=_item.cloneNode(true);_mirror.style.width=getRectWidth(rect)+"px";_mirror.style.height=getRectHeight(rect)+"px";classes.rm(_mirror,"gu-transit");classes.add(_mirror,"gu-mirror");o.mirrorContainer.appendChild(_mirror);touchy(documentElement,"add","mousemove",drag);classes.add(o.mirrorContainer,"gu-unselectable");drake.emit("cloned",_mirror,_item,"mirror");}function removeMirrorImage(){if(_mirror){classes.rm(o.mirrorContainer,"gu-unselectable");touchy(documentElement,"remove","mousemove",drag);getParent(_mirror).removeChild(_mirror);_mirror=null;}}function getImmediateChild(dropTarget,target){var immediate=target;while(immediate!==dropTarget&&getParent(immediate)!==dropTarget){immediate=getParent(immediate);}if(immediate===documentElement){return null;}return immediate;}function getReference(dropTarget,target,x,y){var horizontal=o.direction==="horizontal";var reference=target!==dropTarget?inside():outside();return reference;function outside(){// slower, but able to figure out any position
var len=dropTarget.children.length;var i;var el;var rect;for(i=0;i<len;i++){el=dropTarget.children[i];rect=el.getBoundingClientRect();if(horizontal&&rect.left+rect.width/2>x){return el;}if(!horizontal&&rect.top+rect.height/2>y){return el;}}return null;}function inside(){// faster, but only available if dropped inside a child element
var rect=target.getBoundingClientRect();if(horizontal){return resolve(x>rect.left+getRectWidth(rect)/2);}return resolve(y>rect.top+getRectHeight(rect)/2);}function resolve(after){return after?nextEl(target):target;}}function isCopy(item,container){return typeof o.copy==="boolean"?o.copy:o.copy(item,container);}}function touchy(el,op,type,fn){var touch={mouseup:"touchend",mousedown:"touchstart",mousemove:"touchmove"};var pointers={mouseup:"pointerup",mousedown:"pointerdown",mousemove:"pointermove"};var microsoft={mouseup:"MSPointerUp",mousedown:"MSPointerDown",mousemove:"MSPointerMove"};if(global.navigator.pointerEnabled){crossvent[op](el,pointers[type],fn);}else if(global.navigator.msPointerEnabled){crossvent[op](el,microsoft[type],fn);}else{crossvent[op](el,touch[type],fn);crossvent[op](el,type,fn);}}function whichMouseButton(e){if(e.touches!==void 0){return e.touches.length;}if(e.which!==void 0&&e.which!==0){return e.which;}// see https://github.com/bevacqua/dragula/issues/261
if(e.buttons!==void 0){return e.buttons;}var button=e.button;if(button!==void 0){// see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
return button&1?1:button&2?3:button&4?2:0;}}function getOffset(el){var rect=el.getBoundingClientRect();return{left:rect.left+getScroll("scrollLeft","pageXOffset"),top:rect.top+getScroll("scrollTop","pageYOffset")};}function getScroll(scrollProp,offsetProp){if(typeof global[offsetProp]!=="undefined"){return global[offsetProp];}if(documentElement.clientHeight){return documentElement[scrollProp];}return doc.body[scrollProp];}function getElementBehindPoint(point,x,y){var p=point||{};var state=p.className;var el;p.className+=" gu-hide";el=doc.elementFromPoint(x,y);p.className=state;return el;}function never(){return false;}function always(){return true;}function getRectWidth(rect){return rect.width||rect.right-rect.left;}function getRectHeight(rect){return rect.height||rect.bottom-rect.top;}function getParent(el){return el.parentNode===doc?null:el.parentNode;}function isInput(el){return el.tagName==="INPUT"||el.tagName==="TEXTAREA"||el.tagName==="SELECT"||isEditable(el);}function isEditable(el){if(!el){return false;}// no parents were editable
if(el.contentEditable==="false"){return false;}// stop the lookup
if(el.contentEditable==="true"){return true;}// found a contentEditable element in the chain
return isEditable(getParent(el));// contentEditable is set to 'inherit'
}function nextEl(el){return el.nextElementSibling||manually();function manually(){var sibling=el;do{sibling=sibling.nextSibling;}while(sibling&&sibling.nodeType!==1);return sibling;}}function getEventHost(e){// on touchend event, we have to use `e.changedTouches`
// see http://stackoverflow.com/questions/7192563/touchend-event-properties
// see https://github.com/bevacqua/dragula/issues/34
if(e.targetTouches&&e.targetTouches.length){return e.targetTouches[0];}if(e.changedTouches&&e.changedTouches.length){return e.changedTouches[0];}return e;}function getCoord(coord,e){var host=getEventHost(e);var missMap={pageX:"clientX",// IE8
pageY:"clientY"// IE8
};if(coord in missMap&&!(coord in host)&&missMap[coord]in host){coord=missMap[coord];}return host[coord];}module.exports=dragula;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var atoa = __webpack_require__(297);
var debounce = __webpack_require__(689);

module.exports = function emitter (thing, options) {
  var opts = options || {};
  var evt = {};
  if (thing === undefined) { thing = {}; }
  thing.on = function (type, fn) {
    if (!evt[type]) {
      evt[type] = [fn];
    } else {
      evt[type].push(fn);
    }
    return thing;
  };
  thing.once = function (type, fn) {
    fn._once = true; // thing.off(fn) still works!
    thing.on(type, fn);
    return thing;
  };
  thing.off = function (type, fn) {
    var c = arguments.length;
    if (c === 1) {
      delete evt[type];
    } else if (c === 0) {
      evt = {};
    } else {
      var et = evt[type];
      if (!et) { return thing; }
      et.splice(et.indexOf(fn), 1);
    }
    return thing;
  };
  thing.emit = function () {
    var args = atoa(arguments);
    return thing.emitterSnapshot(args.shift()).apply(this, args);
  };
  thing.emitterSnapshot = function (type) {
    var et = (evt[type] || []).slice(0);
    return function () {
      var args = atoa(arguments);
      var ctx = this || thing;
      if (type === 'error' && opts.throws !== false && !et.length) { throw args.length === 1 ? args[0] : args; }
      et.forEach(function emitter (listen) {
        if (opts.async) { debounce(listen, args, ctx); } else { listen.apply(ctx, args); }
        if (listen._once) { thing.off(type, listen); }
      });
      return thing;
    };
  };
  return thing;
};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ticky = __webpack_require__(690);

module.exports = function debounce (fn, args, ctx) {
  if (!fn) { return; }
  ticky(function run () {
    fn.apply(ctx || null, args || []);
  });
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var si = typeof setImmediate === 'function', tick;
if (si) {
  tick = function (fn) { setImmediate(fn); };
} else {
  tick = function (fn) { setTimeout(fn, 0); };
}

module.exports = tick;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(691).setImmediate))

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(692);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34), __webpack_require__(693)))

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var customEvent = __webpack_require__(695);
var eventmap = __webpack_require__(696);
var doc = global.document;
var addEvent = addEventEasy;
var removeEvent = removeEventEasy;
var hardCache = [];

if (!global.addEventListener) {
  addEvent = addEventHard;
  removeEvent = removeEventHard;
}

module.exports = {
  add: addEvent,
  remove: removeEvent,
  fabricate: fabricateEvent
};

function addEventEasy (el, type, fn, capturing) {
  return el.addEventListener(type, fn, capturing);
}

function addEventHard (el, type, fn) {
  return el.attachEvent('on' + type, wrap(el, type, fn));
}

function removeEventEasy (el, type, fn, capturing) {
  return el.removeEventListener(type, fn, capturing);
}

function removeEventHard (el, type, fn) {
  var listener = unwrap(el, type, fn);
  if (listener) {
    return el.detachEvent('on' + type, listener);
  }
}

function fabricateEvent (el, type, model) {
  var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
  if (el.dispatchEvent) {
    el.dispatchEvent(e);
  } else {
    el.fireEvent('on' + type, e);
  }
  function makeClassicEvent () {
    var e;
    if (doc.createEvent) {
      e = doc.createEvent('Event');
      e.initEvent(type, true, true);
    } else if (doc.createEventObject) {
      e = doc.createEventObject();
    }
    return e;
  }
  function makeCustomEvent () {
    return new customEvent(type, { detail: model });
  }
}

function wrapperFactory (el, type, fn) {
  return function wrapper (originalEvent) {
    var e = originalEvent || global.event;
    e.target = e.target || e.srcElement;
    e.preventDefault = e.preventDefault || function preventDefault () { e.returnValue = false; };
    e.stopPropagation = e.stopPropagation || function stopPropagation () { e.cancelBubble = true; };
    e.which = e.which || e.keyCode;
    fn.call(el, e);
  };
}

function wrap (el, type, fn) {
  var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
  hardCache.push({
    wrapper: wrapper,
    element: el,
    type: type,
    fn: fn
  });
  return wrapper;
}

function unwrap (el, type, fn) {
  var i = find(el, type, fn);
  if (i) {
    var wrapper = hardCache[i].wrapper;
    hardCache.splice(i, 1); // free up a tad of memory
    return wrapper;
  }
}

function find (el, type, fn) {
  var i, item;
  for (i = 0; i < hardCache.length; i++) {
    item = hardCache[i];
    if (item.element === el && item.type === type && item.fn === fn) {
      return i;
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var NativeCustomEvent = global.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

module.exports = useNative() ? NativeCustomEvent :

// IE >= 9
'function' === typeof document.createEvent ? function CustomEvent (type, params) {
  var e = document.createEvent('CustomEvent');
  if (params) {
    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
  } else {
    e.initCustomEvent(type, false, false, void 0);
  }
  return e;
} :

// IE <= 8
function CustomEvent (type, params) {
  var e = document.createEventObject();
  e.type = type;
  if (params) {
    e.bubbles = Boolean(params.bubbles);
    e.cancelable = Boolean(params.cancelable);
    e.detail = params.detail;
  } else {
    e.bubbles = false;
    e.cancelable = false;
    e.detail = void 0;
  }
  return e;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var eventmap = [];
var eventname = '';
var ron = /^on/;

for (eventname in global) {
  if (ron.test(eventname)) {
    eventmap.push(eventname.slice(2));
  }
}

module.exports = eventmap;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var cache={};var start="(?:^|\\s)";var end="(?:\\s|$)";function lookupClass(className){var cached=cache[className];if(cached){cached.lastIndex=0;}else{cache[className]=cached=new RegExp(start+className+end,"g");}return cached;}function addClass(el,className){var current=el.className;if(!current.length){el.className=className;}else if(!lookupClass(className).test(current)){el.className+=" "+className;}}function rmClass(el,className){el.className=el.className.replace(lookupClass(className)," ").trim();}module.exports={add:addClass,rm:rmClass};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaDialog=__webpack_require__(55);var _weaDialog2=_interopRequireDefault(_weaDialog);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _weaFormItem=__webpack_require__(47);var _weaFormItem2=_interopRequireDefault(_weaFormItem);var _weaSelect=__webpack_require__(50);var _weaSelect2=_interopRequireDefault(_weaSelect);var _weaInput=__webpack_require__(56);var _weaInput2=_interopRequireDefault(_weaInput);var _weaHelpfulTip=__webpack_require__(52);var _weaHelpfulTip2=_interopRequireDefault(_weaHelpfulTip);var _storage=__webpack_require__(60);var _callApi=__webpack_require__(17);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var options=[{disabled:false,key:"4",selected:false,showname:"公开",visible:true},{disabled:false,key:"3",selected:false,showname:"内部",visible:true},{disabled:false,key:"2",selected:false,showname:"秘密",visible:true},{disabled:false,key:"1",selected:false,showname:"机密",visible:true}];var linkageValue={0:"",1:"20年",2:"10年",3:"",4:""};var EditSet=function(_React$Component){(0,_inherits3.default)(EditSet,_React$Component);function EditSet(props){(0,_classCallCheck3.default)(this,EditSet);var _this=(0,_possibleConstructorReturn3.default)(this,(EditSet.__proto__||(0,_getPrototypeOf2.default)(EditSet)).call(this,props));_this.selectRef=null;_this.onEditSave=function(){var _this$props=_this.props,onSave=_this$props.onSave,changeVisible=_this$props.changeVisible,isEditSec=_this$props.isEditSec,onEditSec=_this$props.onEditSec;var _this$state=_this.state,secretLevel=_this$state.secretLevel,secretLevelValidity=_this$state.secretLevelValidity,showname=_this$state.showname;if(secretLevel<3&&!secretLevelValidity){_antd.message.error(getLabel(530992,"保密期限不能为空"),2);}else if(secretLevel<3&&!isNaN(secretLevelValidity)){_antd.message.error(getLabel(530063,"保密期限不能为纯数字"),2);}else{changeVisible(false);if(isEditSec){onEditSec({secretLevel:secretLevel,secretLevelValidity:secretLevelValidity},showname);}else{onSave({secretLevel:secretLevel,secretLevelValidity:secretLevelValidity});}_this.setState({showname:""});}};_this.onEditCancel=function(){var _this$props2=_this.props,changeVisible=_this$props2.changeVisible,onCancel=_this$props2.onCancel;changeVisible(false);onCancel();_this.setState({showname:""});};_this.getBtn=function(){var ecId=_this.props.ecId;return[React.createElement(_antd.Button,{ecId:ecId+"_Button@dcrpdd",type:"primary",onClick:_this.onEditSave},getLabel(30986,"保存")),React.createElement(_antd.Button,{ecId:ecId+"_Button@xi62n1",onClick:_this.onEditCancel},getLabel(31129,"取消"))];};_this.onSelectChange=function(v,showname){var linkageValue=_this.state.linkageValue;_this.setState({secretLevel:v,secretLevelValidity:linkageValue[v],showname:showname});};_this.onInputChange=function(v){_this.setState({secretLevelValidity:v});};_this.state={options:[],linkageValue:{},secretLevelValidity:"",secretLevel:"",// 当前修改的文件密级
showname:""};return _this;}(0,_createClass3.default)(EditSet,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var secLevel=this.props.secLevel;new _promise2.default(function(rs){if(!window.hasGetOpenClassification){window.hasGetOpenClassification=true;(0,_callApi.callApi)("/api/hrm/classifiedProtection/getClassificationInfo4Component","GET",{}).then(function(res){if(res.status){var isOpenClassification=res.isOpenClassification,resourceOptionInfo=res.resourceOptionInfo;window.localStorage.setItem("resourceOptionInfo",(0,_stringify2.default)(resourceOptionInfo));window.localStorage.setItem("isOpenClassification",isOpenClassification);window.hasGetOpenClassification=true;}else{window.hasGetOpenClassification=false;}rs();}).catch(function(err){window.hasGetOpenClassification=false;});}else{rs();}}).then(function(){var lsResourceOptionInfo=_storage.ls.getJSONObj("resourceOptionInfo");var resourceOptionInfo=lsResourceOptionInfo&&Array.isArray(lsResourceOptionInfo.resourceOptionList)?lsResourceOptionInfo:{resourceOptionList:options,resourceValidityInfo:linkageValue};resourceOptionInfo.resourceOptionList=resourceOptionInfo.resourceOptionList.map(function(item){item.disabled=false;item.disabled=item.key<secLevel;return item;});_this2.setState({options:resourceOptionInfo.resourceOptionList,linkageValue:resourceOptionInfo.resourceValidityInfo,secretLevel:secLevel,secretLevelValidity:resourceOptionInfo.resourceValidityInfo[secLevel]});});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;var currentFile=nextProps.currentFile;var _state=this.state,options=_state.options,linkageValue=_state.linkageValue;if(!nextProps.isEditSec){// 新上传
this.setState({secretLevel:nextProps.secLevel,secretLevelValidity:linkageValue[nextProps.secLevel]});}else{// 修改密级
this.setState({secretLevel:currentFile.secretLevel,secretLevelValidity:currentFile.secretLevelValidity});}if(this.props.secLevel!==nextProps.secLevel){// 模块密级修改后
var newOptions=options.map(function(item){item.disabled=false;item.disabled=item.key<nextProps.secLevel;return item;});this.setState({options:newOptions},function(){_this3.selectRef&&_this3.selectRef.forceUpdate();});}}},{key:"render",value:function render(){var _this4=this;var _props=this.props,visible=_props.visible,isEditSec=_props.isEditSec,ecId=_props.ecId,currentFile=_props.currentFile;var _state2=this.state,options=_state2.options,secretLevel=_state2.secretLevel,secretLevelValidity=_state2.secretLevelValidity;var filename=currentFile.filename||"";return React.createElement(_weaDialog2.default,{ecId:ecId+"_WeaDialog@z4e0y6",title:isEditSec?getLabel(528812,"修改密级")+":\u3010"+filename+"\u3011":getLabel(528813,"请先确认附件密级"),icon:"icon-coms02-Warning",iconBgcolor:"#ff8e00",style:{width:600,height:120},visible:visible,hasScroll:true,buttons:this.getBtn(),onCancel:this.onEditCancel},React.createElement(_weaFormItem2.default,{ecId:ecId+"_WeaFormItem@5oiaqg",label:getLabel(500520,"密级"),labelCol:{span:3,offset:2},wrapperCol:{span:12,offset:8},style:{padding:"10px"}},React.createElement(_weaSelect2.default,{ref:function ref(e){return _this4.selectRef=e;},ecId:ecId+"_WeaSelect@upfpl7",options:options,value:secretLevel,onChange:this.onSelectChange})),secretLevel<3&&React.createElement(_weaFormItem2.default,{ecId:ecId+"_WeaFormItem@3iqkd5",label:getLabel(131188,"保密期限"),labelCol:{span:3,offset:2},wrapperCol:{span:12,offset:8},viewAttr:3,style:{padding:"10px"}},React.createElement(_weaInput2.default,{ecId:ecId+"_WeaInput@ado2ug",viewAttr:3,value:secretLevelValidity,placeholder:getLabel(530018,"请输入保密期限"),onChange:this.onInputChange}),React.createElement(_weaHelpfulTip2.default,{ecId:ecId+"_WeaHelpfulTip@tc6qi1",title:getLabel(528340,"保密期限填写格式：3个月、10年、20年、长期…不能是纯数字"),placement:"bottom",width:200,style:{position:"absolute",right:"-40px",top:"7px"}})));}}]);return EditSet;}(React.Component);exports.default=EditSet;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaDialog=__webpack_require__(55);var _weaDialog2=_interopRequireDefault(_weaDialog);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _weaTable=__webpack_require__(194);var _weaTable2=_interopRequireDefault(_weaTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var columns=[{title:getLabel(15486,"序号"),dataIndex:"order",key:"order",width:80,render:function render(record,text,index){return index+1;}},{title:getLabel("23752","附件名称"),dataIndex:"filename",key:"projectName"},{title:getLabel("531837","含有的敏感词汇"),dataIndex:"sensitiveword",key:"sensitiveword",className:"wea-upload-sensitiveword"}];var SensitiveDialog=function(_React$Component){(0,_inherits3.default)(SensitiveDialog,_React$Component);function SensitiveDialog(props){(0,_classCallCheck3.default)(this,SensitiveDialog);var _this=(0,_possibleConstructorReturn3.default)(this,(SensitiveDialog.__proto__||(0,_getPrototypeOf2.default)(SensitiveDialog)).call(this,props));_this.onEditCancel=function(){var changeSensiVisible=_this.props.changeSensiVisible;changeSensiVisible(false);};_this.getBtn=function(){return[React.createElement(_antd.Button,{type:"primary",onClick:_this.onEditCancel},getLabel(532049,"确定"))];};return _this;}(0,_createClass3.default)(SensitiveDialog,[{key:"render",value:function render(){var _props=this.props,visible=_props.visible,_props$sensitiveList=_props.sensitiveList,sensitiveList=_props$sensitiveList===undefined?[]:_props$sensitiveList;return React.createElement(_weaDialog2.default,{className:"wea-upload-sensitive",title:getLabel(531826,"附件敏感词预检提示"),icon:"icon-coms02-Warning",iconBgcolor:"#ff8e00",style:{width:600,height:360},visible:visible,hasScroll:true,buttons:this.getBtn(),onCancel:this.onEditCancel},React.createElement("div",{className:"wea-upload-sensitive-tip"},getLabel("531836","提示: 以下附件内容含有敏感词汇，请修改后重新上传！")),React.createElement(_weaTable2.default,{className:"wea-upload-sensitive-table",columns:columns,dataSource:sensitiveList,pagination:false,bordered:true}));}}]);return SensitiveDialog;}(React.Component);exports.default=SensitiveDialog;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _plugins=__webpack_require__(216);var _plugins2=_interopRequireDefault(_plugins);var _weaTextarea=__webpack_require__(66);var _weaTextarea2=_interopRequireDefault(_weaTextarea);var _util=__webpack_require__(319);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_initialiseProps.call(_this);_this.state={value:"",random:new Date().getTime()+"_"+_this.getHash(),that:_this};if(!window.CK_REF){window.CK_REF={};}return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var props=this.props;var onStatusChange=props.onStatusChange;var newState={};if("value"in props){newState=(0,_extends3.default)({},newState,{value:(0,_util.convertSpecialChar)(props.value)});}this.setState(newState,function(){_this2.initEditor(props);typeof onStatusChange==="function"&&onStatusChange("ready");});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;var newState={random:new Date().getTime()+"_"+this.getHash()};if("value"in nextProps){newState=(0,_extends3.default)({},newState,{value:(0,_util.convertSpecialChar)(nextProps.value)});}this.setState(newState,function(){_this3.initEditor(nextProps);});}},{key:"getBootomBarItems",// 获取底部工具栏
value:function getBootomBarItems(){var _this4=this;var _props=this.props,bottomBarConfig=_props.bottomBarConfig,_props$bottomBarRight=_props.bottomBarRight,bottomBarRight=_props$bottomBarRight===undefined?{}:_props$bottomBarRight,ecId=_props.ecId;var items=[];var bottomBarConfigCom=void 0;var bottomBarRightCom=void 0;var spanCom=function spanCom(item,content,index){return _react2.default.createElement("span",{ecId:ecId+"_span@so3pyr@"+index,className:"wea-rich-text-toolbar-bottom-item "+(item.disabled?"wea-rich-text-toolbar-bottom-item-disabled":""),style:(0,_extends3.default)({position:"relative"},item.style)},content);};bottomBarConfig.forEach(function(item,index){if(item.name==="Component"){items.push(spanCom(item,item.show,index));}else{var Tool=_plugins2.default[item.name];items.push(spanCom(item,_react2.default.createElement(Tool,(0,_extends3.default)({onToolsChange:_this4.onToolsChange},item)),index));}});bottomBarConfigCom=items;if((0,_keys2.default)(bottomBarRight).length>0){bottomBarRightCom=_react2.default.createElement("div",{ecId:ecId+"_div@so3pyr",style:{width:bottomBarRight.width,float:"right"}},bottomBarRight.Component);bottomBarConfigCom=_react2.default.createElement("div",{style:{width:"100%",paddingRight:bottomBarRight.width+"px"}},bottomBarConfigCom);}return[bottomBarRightCom,bottomBarConfigCom];}// 获取 editor
// 获取数据
// 更新数据
},{key:"render",value:function render(){var props=this.props;var value=this.state.value;var viewAttr=props.viewAttr,bottomBarConfig=props.bottomBarConfig,bootomBarStyle=props.bootomBarStyle,bottomBarRight=props.bottomBarRight,ecId=props.ecId;var hasBottom=viewAttr!="1"&&(bottomBarConfig.length>0||bottomBarRight);return _react2.default.createElement("div",{ecId:ecId+"_div@cjbuem",className:"wea-rich-text"},_react2.default.createElement(_weaTextarea2.default,(0,_extends3.default)({minRows:10,maxRows:15},props,{ecId:ecId+"_WeaTextarea@7lg41g",value:value,onKeyDown:this.onKeyDown,onChange:this.onChange})),hasBottom&&_react2.default.createElement("div",{className:"wea-rich-text-toolbar-bottom",style:bootomBarStyle},this.getBootomBarItems()));}}]);return Main;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this5=this;this.initEditor=function(props){var _props$id=props.id,id=_props$id===undefined?"":_props$id;var random=_this5.state.random;window.CK_REF["wea_rich_text_wrap_"+id+"_"+random]=_this5;};this.getHash=function(){return Math.random().toString(36).substr(2,6);};this.onChange=function(value){var onChange=_this5.props.onChange;value=(0,_util.convertSpecialChar)(value);_this5.setState({value:value});onChange&&onChange(value);};this.onToolsChange=function(type,ids,list,lev2Type){var onToolsChange=_this5.props.onToolsChange;if(typeof onToolsChange==="function"){onToolsChange(type,ids,list,lev2Type);}};this.getEditor=function(){return _this5.state.that;};this.getData=function(){return(0,_util.restoreSpeicalStr)(_this5.state.value);};this.setData=function(value,callback){_this5.setState({value:(0,_util.convertSpecialChar)(value)},callback);};this.focus=function(){var textarea=document.querySelector(".wea-rich-text textarea");if(textarea){textarea.focus();}};this.onKeyDown=function(e){var onKeyDown=_this5.props.onKeyDown;onKeyDown&&onKeyDown(e);e.stopPropagation();};},_temp);exports.default=Main;

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _isEqual=__webpack_require__(32);var _isEqual2=_interopRequireDefault(_isEqual);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _weaZmage=__webpack_require__(154);var _weaZmage2=_interopRequireDefault(_weaZmage);var _utils=__webpack_require__(108);var _uniq=__webpack_require__(65);var _uniq2=_interopRequireDefault(_uniq);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Menub=_antd.Menu.b;var getLabel=_weaLocaleProvider2.default.getLabel;var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.stopPropagation=function(e){e&&e.stopPropagation&&e.stopPropagation();e&&e.preventDefault&&e.preventDefault();};_this.getImageUrl=function(b){var defaultImg=_this.props.defaultImg;var imgUrl=defaultImg;if(b.linkvaluecolumn){imgUrl=b.imgurl+"?"+b.linkkey+"="+b.linkvaluecolumn.split(",")[0];}return imgUrl;};_this.getImageSet=function(b){var defaultImg=_this.props.defaultImg;var imageSet=[];var imgurl=b.imgurl,linkkey=b.linkkey,linkvaluecolumn=b.linkvaluecolumn,linktitlecolumn=b.linktitlecolumn;if(b&&linkvaluecolumn){var imgs=linkvaluecolumn.split(",");if(imgs&&imgs.length){imgs.map(function(i){imageSet.push({src:imgurl+"?"+linkkey+"="+i,alt:"",text:""});});}}if(!imageSet.length){imageSet.push({src:defaultImg,alt:"",text:""});}return imageSet;};_this.showImage=function(e,b,index){e&&e.stopPropagation&&e.stopPropagation();(0,_weaZmage.showImage)({id:_this.state.uid+"-"+index,imageSet:_this.getImageSet(b),page:0});};_this.state={hoverId:"",uid:"u"+(0,_utils.generateUUID)()};return _this;}(0,_createClass3.default)(Main,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return!(0,_isEqual2.default)(this.props.browser,nextProps.browser)||this.props.num!==nextProps.num||!(0,_isEqual2.default)(this.props.ctrIds,nextProps.ctrIds);}},{key:"checkboxOnChange",value:function checkboxOnChange(e,id){this.stopPropagation(e);var _props=this.props,ctrIds=_props.ctrIds,browser=_props.browser;var datas=[];var ids=(0,_uniq2.default)([].concat((0,_toConsumableArray3.default)(ctrIds)));// if (e.target.checked) {
//     ids.push(id);
// } else {
//     ids = ids.filter((i) => i != id);
// }
if(ids.indexOf(id)===-1){ids.push(id);}else{ids=ids.filter(function(i){return i!=id;});}browser.forEach(function(b){if(ids.indexOf(b.id)>-1)datas.push(b);});this.props.thumbnailsOnCheck&&this.props.thumbnailsOnCheck(ids,datas);}},{key:"render",value:function render(){var _this2=this;var _props2=this.props,browser=_props2.browser,_props2$num=_props2.num,num=_props2$num===undefined?4:_props2$num,_props2$ctrIds=_props2.ctrIds,ctrIds=_props2$ctrIds===undefined?[]:_props2$ctrIds,defaultImg=_props2.defaultImg,ecId=_props2.ecId;var uid=this.state.uid;var thumbnailsArr=[];var dom=function dom(b,index){return React.createElement(_antd.Col,{ecId:ecId+"_Col@ulwgqk@"+index,"class":"wea-thumbnails-row",span:24/num,style:{minHeight:220}},React.createElement("div",{ecId:ecId+"_div@s0rrne@"+index,className:"wea-thumbnails-box",onClick:function onClick(e){return _this2.checkboxOnChange(e,b.id);}},React.createElement("div",{className:"wea-thumbnails-check"},React.createElement(_antd.Checkbox,{ecId:ecId+"_Checkbox@32ie69@"+index,id:b.id,imgId:b.linkvaluecolumn.split(",")[0],checked:ctrIds.indexOf(b.id)>=0})),React.createElement("div",{ecId:ecId+"_div@o34f9t@"+index,className:"wea-thumbnails-img-wrap",imgIds:b.linkvaluecolumn// onClick={(...e)=>{console.log('img-wrap--onClick',e,b.linkvaluecolumn)}}
,onMouseEnter:function onMouseEnter(){return _this2.setState({hoverId:b.id});},onMouseLeave:function onMouseLeave(){return _this2.setState({hoverId:""});}},b.linkvaluecolumn?React.createElement("img",{ecId:ecId+"_img@ozemdz@"+index,src:_this2.getImageUrl(b),id:uid+"-"+b.id,alt:"",onClick:function onClick(e){return _this2.showImage(e,b,b.id);}}):React.createElement("div",{ecId:ecId+"_div@vqj6hi@"+index,onClick:function onClick(e){return _this2.stopPropagation(e);}},React.createElement(_weaZmage2.default,{ecId:ecId+"_WeaZmage@03x3wq@"+index,src:defaultImg})),b.roomdescspan&&React.createElement("div",{className:"wea-thumbnails-roomdesc",dangerouslySetInnerHTML:{__html:b.roomdescspan}})),React.createElement("div",{className:"wea-thumbnails-title wea-f14",title:b.linktitlecolumn},b.linktitlecolumn),React.createElement("div",{className:"wea-thumbnails-subcolumn",title:b.subcolumn,style:{color:"#ccc"}},b.subcolumn),React.createElement("div",{className:(0,_classnames2.default)({"wea-thumbnails-isused":true,isused:b.roomstatusspan==1})},getLabel(510238,"已占用"))));};browser&&browser.forEach(function(b,index){thumbnailsArr.push(dom(b,index));});return React.createElement("div",{className:"wea-thumbnails-table"},React.createElement("div",{className:"wea-thumbnail-table-body",style:{height:this.props.contentHeight||450}},React.createElement(_weaNewScroll2.default,{ecId:ecId+"_WeaNewScroll@c55c8u",height:"100%"},React.createElement(_antd.Row,{ecId:ecId+"_Row@wsndkh"},thumbnailsArr))));}}]);return Main;}(React.Component),_class.defaultProps={defaultImg:(window.ecologyContentPath||"")+"/cloudstore/resource/pc/com/images/meeting_default.png"},_temp);exports.default=Main;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);__webpack_require__(708);var _lerp=__webpack_require__(305);var _lerp2=_interopRequireDefault(_lerp);var _utils=__webpack_require__(108);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// TODO: CONFIG
// Utils
/**
 * 位移控制层
 * 获取封面位置并控制图片位移
 **/// React Libs
var IMAGE_MARGIN=50;// Style
var Position=function(_React$Component){(0,_inherits3.default)(Position,_React$Component);function Position(props){(0,_classCallCheck3.default)(this,Position);var _this=(0,_possibleConstructorReturn3.default)(this,(Position.__proto__||(0,_getPrototypeOf2.default)(Position)).call(this,props));_this.gerZoomMovePositionRange=function(){var _this$props=_this.props,zoom=_this$props.zoom,page=_this$props.page,imageSet=_this$props.imageSet;var image=new Image();image.src=imageSet[page].src;var naturalWidth=image.naturalWidth;var naturalHeight=image.naturalHeight;_this.setState({naturalSize:!zoom?{naturalWidth:naturalWidth,naturalHeight:naturalHeight}:null,moveRange:!zoom?{x:naturalWidth-(0,_utils.clientWidth)()+2*IMAGE_MARGIN,y:naturalHeight-(0,_utils.clientHeight)()+2*IMAGE_MARGIN}:null});};_this.handleMouseMove=function(e){var _this$state=_this.state,naturalSize=_this$state.naturalSize,mr=_this$state.moveRange;var nw=naturalSize.naturalWidth,nh=naturalSize.naturalHeight;var cw=(0,_utils.clientWidth)();var ch=(0,_utils.clientHeight)();var mouseX=e.clientX;var mouseY=e.clientY;// 计算偏移量
var imgPosX=nw>cw?(nw-cw)/2+IMAGE_MARGIN-mr.x*(mouseX/cw):0;var imgPosY=nh>ch?(nh-ch)/2+IMAGE_MARGIN-mr.y*(mouseY/ch):0;// 设置图片位置
_this.move.to({data:{x:imgPosX,y:imgPosY}});};_this.getCoverCenterPosition=function(){var _this$props2=_this.props,page=_this$props2.page,coverNodeRef=_this$props2.coverNodeRef;var coverCenterPosition={x:0,y:0};if(coverNodeRef){var coverNodeRect=coverNodeRef.getBoundingClientRect();coverCenterPosition=page===0?{x:-(0,_utils.windowWidth)()/2+coverNodeRect.left+coverNodeRect.width/2,y:-(0,_utils.windowHeight)()/2+coverNodeRect.top+coverNodeRect.height/2}:{x:0,y:-(0,_utils.windowHeight)()};}return coverCenterPosition;};_this.moveToCoverCenterPosition=function(){_this.move.to({data:_this.getCoverCenterPosition()});};_this.getPageCenterPosition=function(){return{x:0,y:0};};_this.moveToPageCenterPosition=function(){_this.move.to({data:_this.getPageCenterPosition()});};_this.handleMoveCenterPosition=function(curr){var show=_this.props.show;if(_this.refs.positionController){_this.refs.positionController.style.visibility='visible';_this.refs.positionController.style.transform='translate3d('+curr.x+'px, '+curr.y+'px, 0)';if(!show){var scrollChange=window.pageYOffset-_this.initialPageOffset;_this.refs.positionController.style.top='calc(50% - '+scrollChange+'px)';}}};_this.state={// 原始尺寸
naturalSize:null,// 移动范围
moveRange:null};return _this;}(0,_createClass3.default)(Position,[{key:'componentWillMount',value:function componentWillMount(){this.move=new _lerp2.default({data:this.getCoverCenterPosition(),poster:this.handleMoveCenterPosition});// 记录初始页面高度
this.initialPageOffset=window.pageYOffset;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var show=nextProps.show,zoom=nextProps.zoom;if(show){this.moveToPageCenterPosition();if(zoom){this.gerZoomMovePositionRange();(0,_utils.addListenEventOf)('mousemove',this.handleMouseMove);}else{(0,_utils.removeListenEventOf)('mousemove',this.handleMouseMove);}}else{this.moveToCoverCenterPosition();(0,_utils.removeListenEventOf)('mousemove',this.handleMouseMove);}}/**
   * 放大查看
   **//**
   * 状态切换
   **//**
   * 位移控制器
   **/},{key:'render',value:function render(){return _react2.default.createElement('div',{className:'positionLayer'},_react2.default.createElement('div',{ref:'positionController'},this.props.children));}}]);return Position;}(_react2.default.Component);exports.default=Position;

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);__webpack_require__(710);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Control=function(_React$Component){(0,_inherits3.default)(Control,_React$Component);function Control(props){(0,_classCallCheck3.default)(this,Control);var _this=(0,_possibleConstructorReturn3.default)(this,(Control.__proto__||(0,_getPrototypeOf2.default)(Control)).call(this,props));_this.zoomStyle=function(show){return show?{WebkitClipPath:"polygon(0 65%, 65% 0, 100% 0, 100% 35%, 35% 100%, 0 100%)",MozClipPath:"polygon(0 65%, 65% 0, 100% 0, 100% 35%, 35% 100%, 0 100%)",MsClipPath:"polygon(0 65%, 65% 0, 100% 0, 100% 35%, 35% 100%, 0 100%)",OClipPath:"polygon(0 65%, 65% 0, 100% 0, 100% 35%, 35% 100%, 0 100%)",clipPath:"polygon(0 65%, 65% 0, 100% 0, 100% 35%, 35% 100%, 0 100%)",opacity:1}:{WebkitClipPath:"polygon(0 100%, 100% 0, 100% 0, 100% 0, 0 100%, 0 100%)",MozClipPath:"polygon(0 100%, 100% 0, 100% 0, 100% 0, 0 100%, 0 100%)",MsClipPath:"polygon(0 100%, 100% 0, 100% 0, 100% 0, 0 100%, 0 100%)",OClipPath:"polygon(0 100%, 100% 0, 100% 0, 100% 0, 0 100%, 0 100%)",clipPath:"polygon(0 100%, 100% 0, 100% 0, 100% 0, 0 100%, 0 100%)",opacity:0// 关闭按钮样式
};};_this.lineL=function(show){return show?{WebkitTransform:'translate(-50%, -50%) rotate(45deg)',transform:'translate(-50%, -50%) rotate(45deg)',opacity:1}:{WebkitTransform:'translate(-50%, -50%) rotate(0)',transform:'translate(-50%, -50%) rotate(0)',opacity:0};};_this.lineR=function(show){return show?{WebkitTransform:'translate(-50%, -50%) rotate(-45deg)',transform:'translate(-50%, -50%) rotate(-45deg)',opacity:1}:{WebkitTransform:'translate(-50%, -50%) rotate(0)',transform:'translate(-50%, -50%) rotate(0)',opacity:0// 切换按钮样式
};};_this.prevStyle=function(show){return show?{left:0,opacity:1}:{left:-55,opacity:0};};_this.nextStyle=function(show){return show?{right:0,opacity:1}:{right:-55,opacity:0// 页数指示样式
};};_this.pagesStyle=function(show){return show?{bottom:0,opacity:1}:{bottom:-31,opacity:0// 图片标题样式
};};_this.altStyle=function(show){return show?{WebkitClipPath:"polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",MozClipPath:"polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",MsClipPath:"polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",OClipPath:"polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",clipPath:"polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",opacity:1}:{WebkitClipPath:"polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",MozClipPath:"polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",MsClipPath:"polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",OClipPath:"polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",clipPath:"polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",opacity:0};};return _this;}// 放大按钮样式
(0,_createClass3.default)(Control,[{key:'render',value:function render(){var _props=this.props,show=_props.show,zoom=_props.zoom,page=_props.page,imageSet=_props.imageSet,unmountSelf=_props.unmountSelf,toggleZoom=_props.toggleZoom,switchPages=_props.switchPages;var hasMultipleImage=imageSet.length>1;return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement('div',{className:'closeButton',onClick:zoom?toggleZoom:unmountSelf},_react2.default.createElement(_antd.Icon,{type:'cross'})),hasMultipleImage&&!zoom&&_react2.default.createElement('div',{className:'switchButton',style:this.prevStyle(show),onClick:switchPages("prev")},_react2.default.createElement('i',{className:'icon-coms-Left'})),hasMultipleImage&&!zoom&&_react2.default.createElement('div',{className:'switchButton',style:this.nextStyle(show),onClick:switchPages("next")},_react2.default.createElement('i',{className:'icon-coms-Right'})),!zoom?imageSet[page].alt&&_react2.default.createElement('div',{className:'imgAlt',style:this.altStyle(show)},imageSet[page].alt):imageSet.alt&&_react2.default.createElement('div',{className:'imgAlt',style:this.altStyle(show)},imageSet.alt));}}]);return Control;}(_react2.default.Component);// Style
/**
 * 控制层
 * 控制图片切换等
 **/// React Libs
exports.default=Control;

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);__webpack_require__(712);var _lerp=__webpack_require__(305);var _lerp2=_interopRequireDefault(_lerp);var _utils=__webpack_require__(108);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// TODO: CONFIG
// Utils
/**
 * 图片层
 * 展示图片
 **/// React Libs
var IMAGE_MARGIN=50;// Style
var Image=function(_React$Component){(0,_inherits3.default)(Image,_React$Component);function Image(props){(0,_classCallCheck3.default)(this,Image);var _this=(0,_possibleConstructorReturn3.default)(this,(Image.__proto__||(0,_getPrototypeOf2.default)(Image)).call(this,props));_this.getCoverScale=function(){var coverNodeRef=_this.props.coverNodeRef;var coverScale={scale:0};if(coverNodeRef){var coverNodeStyle=window.getComputedStyle(coverNodeRef);coverScale={scale:parseInt(coverNodeStyle.width)/coverNodeRef.naturalWidth};}return coverScale;};_this.setToCoverScale=function(){var _this$props=_this.props,coverNodeRef=_this$props.coverNodeRef,remove=_this$props.remove;_this.resize.to({data:_this.getCoverScale(),after:function after(){// 显示封面原图
if(coverNodeRef)coverNodeRef.style.visibility='visible';// 移除节点
remove();}});};_this.getPageFitScale=function(page){/*const {coverNodeRef} = this.props
    let fitScale = {scale: 1}
    if (coverNodeRef) {
      fitScale = {scale: calcFitScale(coverNodeRef, IMAGE_MARGIN)}
    }
    return fitScale*//*FIX By caoyun 修复所有图片比例都以封面为主的问题*/var _this$props2=_this.props,coverNodeRef=_this$props2.coverNodeRef,imageSet=_this$props2.imageSet;var fitScale={scale:1},nodeRef=coverNodeRef;if(page){nodeRef=new window.Image();var src=imageSet[page];if((typeof src==='undefined'?'undefined':(0,_typeof3.default)(src))=='object'){nodeRef.src=src.src;}else if(typeof src=='string'){nodeRef.src=src;}else{console.error("not known src",nodeRef,imageSet[page],imageSet);}}if(nodeRef){fitScale={scale:(0,_utils.calcFitScale)(nodeRef,IMAGE_MARGIN)};}return fitScale;};_this.setToPageFitScale=function(page){var coverNodeRef=_this.props.coverNodeRef;_this.resize.to({data:_this.getPageFitScale(page)});if(!page&&!coverNodeRef){_this.refs.imageLayer.style.maxWidth='calc(100vw - '+2*IMAGE_MARGIN+'px)';_this.refs.imageLayer.style.maxHeight='calc(100vh - '+2*IMAGE_MARGIN+'px)';}};_this.getOriginalScale=function(){return{scale:1};};_this.setToOriginalScale=function(){var coverNodeRef=_this.props.coverNodeRef;_this.resize.to({data:_this.getOriginalScale()});if(!coverNodeRef){_this.refs.imageLayer.style.maxWidth='';_this.refs.imageLayer.style.maxHeight='';}};_this.handleResizeScale=function(curr){if(_this.refs.imageLayer){_this.refs.imageLayer.style.transform='translate(-50%, -50%) scale('+curr.scale+')';}};_this.state={// 加载完成
onLoad:true,// 加载错误
onError:false,// 翻页方向
direction:''};return _this;}(0,_createClass3.default)(Image,[{key:'componentWillMount',value:function componentWillMount(){this.resize=new _lerp2.default({data:this.getCoverScale(),poster:this.handleResizeScale});(0,_utils.addListenEventOf)('resize',this.setToPageFitScale);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var show=nextProps.show,zoom=nextProps.zoom,page=nextProps.page;if(show){if(zoom){this.setToOriginalScale();}else{this.setToPageFitScale(page);}}else{this.setToCoverScale();}if(page){this.setState({onLoad:true,onError:false});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){(0,_utils.removeListenEventOf)('resize',this.setToPageFitScale);}/**
   * 状态切换设置大小
   **//**
   * 尺寸控制器
   **/},{key:'render',value:function render(){var _this2=this;var _props=this.props,zoom=_props.zoom,page=_props.page,imageSet=_props.imageSet;var _state=this.state,onLoad=_state.onLoad,onError=_state.onError;return _react2.default.createElement(_react.Fragment,null,onLoad&&_react2.default.createElement('span',{className:'loading'},_react2.default.createElement('i',null),_react2.default.createElement('i',null),_react2.default.createElement('i',null),_react2.default.createElement('i',null)),onError&&_react2.default.createElement('img',{className:'loadError',src:'/spa/esearch/images/default.png'}),_react2.default.createElement('img',{key:page,ref:'imageLayer',className:'imageLayer',src:imageSet[page].src,alt:imageSet[page].alt,onLoad:function onLoad(){return _this2.setState({onLoad:false});},onError:function onError(){return _this2.setState({onError:true,onLoad:false});},onClick:zoom?this.handleToggleZoom:function(){}}));}}]);return Image;}(_react2.default.Component);exports.default=Image;

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);__webpack_require__(714);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 背景层
 * 叠加半透明背景
 **/// React Libs
var Background=function(_React$Component){(0,_inherits3.default)(Background,_React$Component);function Background(props){(0,_classCallCheck3.default)(this,Background);var _this=(0,_possibleConstructorReturn3.default)(this,(Background.__proto__||(0,_getPrototypeOf2.default)(Background)).call(this,props));_this.bgOverlayStyle=function(show){return show?{backgroundColor:'rgba(0,0,0,1)'}:{backgroundColor:'rgba(0,0,0,0)'};};return _this;}(0,_createClass3.default)(Background,[{key:'render',value:function render(){var _props=this.props,show=_props.show,zoom=_props.zoom,unmountSelf=_props.unmountSelf,toggleZoom=_props.toggleZoom;return _react2.default.createElement('div',{className:'backgroundLayer',onClick:zoom?toggleZoom:unmountSelf,style:this.bgOverlayStyle(show)});}}]);return Background;}(_react2.default.Component);// Style
exports.default=Background;

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _weaFormItem=__webpack_require__(47);var _weaFormItem2=_interopRequireDefault(_weaFormItem);var _weaSearchBrowserBox=__webpack_require__(88);var _weaSearchBrowserBox2=_interopRequireDefault(_weaSearchBrowserBox);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.resetFields=function(){var form=_this.props.form;form.resetFields();},_this.getFieldsValue=function(){var form=_this.props.form;return form.getFieldsValue();},_this.getFieldValue=function(params){var form=_this.props.form;return form.getFieldValue(params);},_this.setFieldsValue=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var form=_this.props.form;form.setFieldsValue(params);},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:"getSearchs",value:function getSearchs(){var _this2=this;var browserConditions=this.props.browserConditions;var items=[];!(0,_isEmpty2.default)(browserConditions)&&browserConditions.forEach(function(field){items.push({com:React.createElement(_weaFormItem2.default,{label:""+field.label,labelCol:{span:""+field.labelcol},wrapperCol:{span:""+field.fieldcol}},_weaTools2.default.getComponent(field.conditionType,field.browserConditionParam,field.domkey,_this2.props,field)),colSpan:2});});return React.createElement(_weaSearchBrowserBox2.default,{items:items,onKeyDown:this.onAdvanceSearchEnter});}},{key:"render",value:function render(){var searchsBox=this.getSearchs();return React.createElement(_antd.Form,{horizontal:true},searchsBox);}}]);return Main;}(React.Component);Main=_antd.Form.create({onFieldsChange:function onFieldsChange(props,fields){var changeCondition=props.changeCondition;(0,_keys2.default)(fields).forEach(function(key){if(key==="industry"){typeof changeCondition==="function"&&changeCondition(fields);}if(key==="funtions"){typeof changeCondition==="function"&&changeCondition(fields,"funtions");}});}})(Main);exports.default=Main;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var browserConditions=[{belong:"PC",colSpan:2,conditionType:"INPUT",domkey:["keyword"],fieldcol:18,isBase64:false,isQuickSearch:true,label:"案例名称",labelcol:6,viewAttr:2},{belong:"PC",colSpan:2,conditionType:"SELECT",domkey:["platform"],fieldcol:18,label:"平台",labelcol:6,viewAttr:2,options:[{key:"all",showname:"全部"},{key:"pc",showname:"PC"},{key:"mobile",showname:"MOBILE"}]},{belong:"PC",colSpan:2,conditionType:"SELECT",domkey:["industry"],fieldcol:18,label:"行业",otherParams:{multiple:true,style:{maxWidth:261}},labelcol:6,viewAttr:2,options:[]},{belong:"PC",colSpan:2,conditionType:"SELECT",domkey:["funtions"],fieldcol:18,label:"职能",otherParams:{multiple:true,style:{maxWidth:261}},labelcol:6,viewAttr:2,options:[]}];var quickSearchKey="keyword";var filterData=function filterData(datas){return datas.map(function(pros){if(pros.funcList){pros.funcList=pros.funcList.map(function(fun){return(0,_extends3.default)({},fun,{showname:fun.g_name||fun.name,key:fun.g_id||fun.key});});}return(0,_extends3.default)({},pros,{showname:pros.g_name||pros.name,key:pros.g_id||pros.key});});};var dealPropertyList=function dealPropertyList(conditons,propertyLists){propertyLists=filterData(propertyLists);if(propertyLists&&propertyLists.length>0){conditons[2]["options"]=propertyLists;conditons[3]["options"]=getFuncListAll(propertyLists);}return conditons;};var getFuncListAll=function getFuncListAll(){var propertyLists=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var industryValue=arguments[1];var funcListAll=[];if(industryValue){var industrys=industryValue.split(",");industrys.forEach(function(indus){var pros=propertyLists.find(function(pro){return pro.key===indus;});if(pros&&pros.funcList){funcListAll=funcListAll.concat(pros.funcList.filter(function(fun){return!funcListAll.find(function(v){return v.key===fun.key;})&&fun.key!==""&&fun.key!=="0";}));}});return funcListAll;}propertyLists.forEach(function(pros){if(pros.funcList){// 过滤重复选项及选项：全部
funcListAll=funcListAll.concat(pros.funcList.filter(function(fun){return!funcListAll.find(function(v){return v.key===fun.key;})&&fun.key!==""&&fun.key!=="0";}));}});return funcListAll;};var getBrowserConditions=function getBrowserConditions(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var demotype=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var labels=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var _params$propertyList=params.propertyList,propertyList=_params$propertyList===undefined?[]:_params$propertyList;var domkeysForLabel=(0,_keys2.default)(labels);var conditions=browserConditions.map(function(v){var domkey=v.domkey.join();if(domkeysForLabel.indexOf(domkey)>=0){v.label=labels[domkey];}return v;});var resConditions=dealPropertyList(conditions,propertyList);return demotype==="workflowChart"?resConditions:resConditions.slice(0,3);};exports.default={quickSearchKey:quickSearchKey,browserConditions:browserConditions,getFuncListAll:getFuncListAll,getBrowserConditions:getBrowserConditions,filterData:filterData};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _weaTools=__webpack_require__(35);var _weaTools2=_interopRequireDefault(_weaTools);var _weaFormItem=__webpack_require__(47);var _weaFormItem2=_interopRequireDefault(_weaFormItem);var _weaSearchBrowserBox=__webpack_require__(88);var _weaSearchBrowserBox2=_interopRequireDefault(_weaSearchBrowserBox);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).apply(this,arguments));}(0,_createClass3.default)(Main,[{key:"getSearchs",value:function getSearchs(){var _this2=this;var _props=this.props,browserConditions=_props.browserConditions,errorCom=_props.errorCom;var items=[];!(0,_isEmpty2.default)(browserConditions)&&browserConditions.forEach(function(field){if(field.conditionType==="CUSTOM"){items.push({com:React.createElement(_weaFormItem2.default,{label:""+field.label,labelCol:{span:""+field.labelcol},wrapperCol:{span:""+field.fieldcol}},React.createElement("div",{className:"wea-ecode-upload-search-customField"},React.createElement("span",{onClick:function onClick(e){window.open(field.linkUrl);e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();}},field.value))),colSpan:field.colSpan});}else{items.push({com:React.createElement(_weaFormItem2.default,{label:""+field.label,labelCol:{span:""+field.labelcol},wrapperCol:{span:""+field.fieldcol}},errorCom?errorCom(field,_weaTools2.default.getComponent(field.conditionType,field.browserConditionParam,field.domkey,_this2.props,field)):_weaTools2.default.getComponent(field.conditionType,field.browserConditionParam,field.domkey,_this2.props,field)),colSpan:field.colSpan});}});return React.createElement(_weaSearchBrowserBox2.default,{items:items,onKeyDown:this.onAdvanceSearchEnter});}},{key:"render",value:function render(){var searchsBox=this.getSearchs();return React.createElement(_antd.Form,{horizontal:true},searchsBox);}}]);return Main;}(React.Component);Main=_antd.Form.create({onFieldsChange:function onFieldsChange(props,fields){var changeCondition=props.changeCondition;typeof changeCondition==="function"&&changeCondition(fields);}})(Main);exports.default=Main;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loginCondtions=[{belong:"PC",colSpan:1,conditionType:"INPUT",domkey:["account"],fieldcol:16,isBase64:false,isQuickSearch:true,label:"云商店账号",labelcol:8,viewAttr:3,rules:"required"},{belong:"PC",colSpan:1,conditionType:"INPUT",domkey:["password"],fieldcol:16,isBase64:false,isQuickSearch:true,label:"云商店账号密码",labelcol:8,viewAttr:3,rules:"required",otherParams:{type:"password"}},{belong:"PC",colSpan:1,conditionType:"CUSTOM",domkey:["explain"],fieldcol:16,isBase64:false,isQuickSearch:true,label:"云商店登录和分享说明",labelcol:8,viewAttr:1,value:"点击查看",linkUrl:"https://e-cloudstore.com/doc.html?appId=09885365bc3c494ea848b067e5084297&maxImgWidth=800"}];var getLoginConditions=function getLoginConditions(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var labels=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};loginCondtions=loginCondtions.map(function(v){var domkeysForDatas=(0,_keys2.default)(datas);var domkeysForLabel=(0,_keys2.default)(labels);var domkey=v.domkey.join();if(domkeysForDatas.indexOf(domkey)>=0){v.value=datas[domkey];}if(domkeysForLabel.indexOf(domkey)>=0){v.label=labels[domkey];}return v;});return loginCondtions;};exports.default={loginCondtions:loginCondtions,getLoginConditions:getLoginConditions};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _isArray=__webpack_require__(21);var _isArray2=_interopRequireDefault(_isArray);var _isEmpty=__webpack_require__(18);var _isEmpty2=_interopRequireDefault(_isEmpty);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _toString=__webpack_require__(57);var _toString2=_interopRequireDefault(_toString);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TreeNode=_antd.TreeNew.TreeNode;var formatMultiLang=_weaLocaleProvider2.default.formatMultiLang;var timeout=null;var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this2=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this2.state={};return _this2;}(0,_createClass3.default)(main,[{key:"generateTreeNodes",value:function generateTreeNodes(){var _this3=this;var _props=this.props,data=_props.data,filterData=_props.filterData,renderItem=_props.renderItem;var treeNodes=[];this.ids=[];this.nodeObj={};if(!(0,_isEmpty2.default)(data)){if(!(0,_isEmpty2.default)(filterData)){data=data.filter(function(item){return!filterData.some(function(i){return(0,_toString2.default)(i.id)===(0,_toString2.default)(item.id);});});}data.map(function(item){item.id=(0,_toString2.default)(item.id);item.name=formatMultiLang(item.name);var title=React.createElement("div",{className:"tree-title",dangerouslySetInnerHTML:{__html:item.name}});if(renderItem){title=renderItem(item);}treeNodes.push(React.createElement(TreeNode,{title:title,name:item.name,key:item.id,isLeaf:true,id:item.id,type:item.type}));_this3.ids.push(item.id);_this3.nodeObj[item.id]=item;});}return treeNodes;}},{key:"checkHandler",value:function checkHandler(v,p){var _this=this;// 取消上次延时未执行的方法
clearTimeout(timeout);//执行延时
timeout=setTimeout(function(){_this.props.checkedCb&&_this.props.checkedCb(v,p);},200);}},{key:"onDoubleClick",value:function onDoubleClick(e,node){var key=node.props.eventKey;clearTimeout(timeout);var data=this.props.data;var target=data.filter(function(item){return(0,_toString2.default)(item.id)===(0,_toString2.default)(key);})[0];this.props.onDoubleClick&&this.props.onDoubleClick(key,target,node);}},{key:"onDragStart",value:function onDragStart(obj){clearTimeout(timeout);this.props.checkedCb&&this.props.checkedCb([]);}},{key:"onDrop",value:function onDrop(obj){var _this4=this;var dragNodes=obj.dragNodesKeys;var targetNode=obj.node.props.eventKey;var result=[];this.ids.filter(function(item){return dragNodes.indexOf(item)===-1;}).forEach(function(id){result.push(_this4.nodeObj[id]);if(id===targetNode){dragNodes.forEach(function(drag){result.push(_this4.nodeObj[drag]);});}});this.props.onDrag&&this.props.onDrag(result);}},{key:"render",value:function render(){var _props2=this.props,checkedKeys=_props2.checkedKeys,height=_props2.height,draggable=_props2.draggable,className=_props2.className,data=_props2.data,header=_props2.header;var treeNodes=this.generateTreeNodes();var traClass=(0,_classnames2.default)({borderRadius:header});return React.createElement("div",{className:"wea-transfer-list "+className+" "+traClass},React.createElement("div",{className:"wea-transfer-list-wrapper"},header&&React.createElement("div",{className:"wea-transfer-list-header"},header),React.createElement(_weaNewScroll2.default,{height:height||400},!(0,_isEmpty2.default)(data)&&React.createElement(_antd.TreeNew,{className:"transfer-tree",draggable:draggable,onDragStart:this.onDragStart.bind(this),onDrop:this.onDrop.bind(this),onSelect:this.checkHandler.bind(this),onDoubleClick:this.onDoubleClick.bind(this),selectedKeys:checkedKeys,multiple:true,async:true,selectable:true},treeNodes))));}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _callApi=__webpack_require__(17);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getHash(){return window.Math.random().toString(36).substr(2,6);}var Content=(_temp=_class=function(_Component){(0,_inherits3.default)(Content,_Component);function Content(){(0,_classCallCheck3.default)(this,Content);return(0,_possibleConstructorReturn3.default)(this,(Content.__proto__||(0,_getPrototypeOf2.default)(Content)).apply(this,arguments));}(0,_createClass3.default)(Content,[{key:'render',value:function render(){var _this2=this;var datas=this.props.datas;return _react2.default.createElement('div',{style:{display:'inline-block',verticalAlign:'top'}},_react2.default.createElement('p',null,datas[0].title,':'),datas.map(function(data){return _react2.default.createElement('p',{key:data.messageUnitId},data.context,_react2.default.createElement('a',{href:data.linkUrl,target:'_blank',rel:'noopener',onClick:function onClick(){var onClick=_this2.props.onClick;typeof onClick==='function'&&onClick(data);}},'\u67E5\u770B\u8BE6\u60C5'));}));}}]);return Content;}(_react.Component),_class.defaultProps={datas:[]},_temp);var MessageCenter=function(){function MessageCenter(){var _this3=this;(0,_classCallCheck3.default)(this,MessageCenter);this.onOpen=function(){};this.onClose=function(){};this.onError=function(){};this.onMessage=function(){};this.onViewDetails=function(data){(0,_callApi.callApi)('/api/ec/dev/message/statemessage','GET',{id:data.messageUnitId});};this.init=function(){// if ('WebSocket' in window) {
//   this.socketType = 'websocket';
//   this.socket = new WebSocket();
//   this.socket.onopen = this.onOpen;
//   this.socket.onerror = this.onClose;
//   this.socket.onclose = this.onError;
//   this.socket.onmessage = this.onMessage;
// } else {
var interval=function interval(){if(!/.*\/wui\/index.*/.test(window.location.href)){return;}(0,_callApi.callApi)('/api/ec/dev/message/getmessage','GET',{}).then(function(res){if(res.status===true){var datas=res.datas;if(datas.length>0){var props={datas:datas,onClick:function onClick(data){_this3.onViewDetails(data);}};var content=!_this3.content?_react2.default.createElement(Content,props):(0,_react.isValidElement)(_this3.content)?_react2.default.createElement(_this3.content,props):_this3.content;_antd.message.error(content,10);_this3.onMessage(res);}}});};_this3.socketType='interval';_this3.socket=window.setInterval(interval,60000);interval();// }
};this.send=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(_this3.socket){_this3.socketType==='interval'?(0,_callApi.callApi)('/api/ec/dev/message/sendmessage','POST',params).then(function(res){if(res.status===true){_this3.onMessage(res);}else{_this3.onError(res);}}):_this3.socket.send(params);}};this.close=function(){if(_this3.socket){if(_this3.socketType==='interval'){clearInterval(_this3.socket);_this3.onClose();_this3.socket=null;// window.sessionStorage.removeItem('e9_message_center_interval');
}else{_this3.socket.close();}}};this.id=getHash();this.socket=null;this.socketType='interval';this.content=null;this.currentInterval=false;}(0,_createClass3.default)(MessageCenter,[{key:'setContent',value:function setContent(com){this.content=com;}}]);return MessageCenter;}();exports.default=new MessageCenter();

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.attach=attach;exports.detach=detach;function attach(handleUnload,router,route,handleRouteUnload){if(handleUnload&&typeof handleUnload==="function"){window.onbeforeunload=handleUnload;if(router&&route){var handle=typeof handleRouteUnload==="function"?handleRouteUnload:handleUnload;router.setRouteLeaveHook(route,handle);}}}function detach(){window.onbeforeunload=function(){return null;};}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
if(typeof window.open==="function"){var openOld=window.open;var openNewWindow=function openNewWindow(a,b,c,d){var dpr=window.devicePixelRatio||1;var border=(dpr-1)*2+1;if(window.navigator.userAgent.match(/Mac/)){border=0;}// const width = window.screen.availWidth - 10 * border;
// const height = window.screen.availHeight - 50 * border;
var width=(window.outerWidth||window.screen.availWidth)-10*border;var height=(window.outerHeight||window.screen.availHeight)-50*border;var left=window.screenLeft||0;var top=window.screenTop||0;return openOld(a,b,"alwaysRaised=yes,width="+width+",height="+height+",top="+top+",left="+left+",directories=no,status=no,toolbar=no,location=no,menubar=no,scrollbars=yes,resizable=yes");};var openNewTab=function openNewTab(a,b,c,d){return openOld(a,b||"_blank");};var openReWirte=function openReWirte(a,b,c,d){if(!/^http/.test(a)){var reg=new RegExp("^"+window.ecologyContentPath+"");a=reg.test(a)?a:(window.ecologyContentPath||"")+a;}if(c&&c.match(/ecologysetting=no/)){return openOld(a,b,c,d);}if(window.localStorage.getItem("ec_open_rewrite")==="0"){return openNewWindow(a,b,c,d);}return openNewTab(a,b,c,d);};window.open=openReWirte;window.document.addEventListener("keydown",function(e){var ev=e||window.event;if(ev.keyCode===16){// shift
window.open=openNewWindow;}if(window.navigator.userAgent.match(/Mac/)){if(ev.keyCode===91){// command
window.open=openNewTab;}}else if(ev.keyCode===17){// ctrl
window.open=openNewTab;// if (window.navigator.userAgent.match(/Chrome/)) {
//   window.open = openOld;
// } else {
//   window.open = openNewTab;
// }
}});window.document.addEventListener("keyup",function(e){var ev=e||window.event;if(ev.keyCode===16||ev.keyCode===17||window.navigator.userAgent.match(/Mac/)&&ev.keyCode===91){window.open=openReWirte;}});window.addEventListener("blur",function(){window.open=openReWirte;});}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.viewer=undefined;var _loadjs=__webpack_require__(54);var _loadjs2=_interopRequireDefault(_loadjs);var _window=__webpack_require__(28);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 获取 window
var getCurrentWindow=function getCurrentWindow(){// if (this.state.hasSetWindow) {
//   return window["setUploadWindow" + this.state.containerId];
// }
return _window2.default.getParent()!==window&&undefined&&undefined.refs&&$(undefined.refs.wrap).closest(".ant-modal").length>0?_window2.default.getTop():window;// return WindowFunc.getParent() !== window
//   ? WindowFunc.getTop()
//   : window;
};var getCurrentJQuery=function getCurrentJQuery(){var currentWindow=getCurrentWindow();return currentWindow.$||currentWindow.jQuery;};var viewer=exports.viewer=function viewer(e){var source=e.target;var owner=source.ownerDocument.getElementsByClassName("formImgPlay");var currentWindow=getCurrentWindow();var windowEcCom=currentWindow.ecCom;var load=windowEcCom?windowEcCom.WeaUpload.loadjs:_loadjs2.default;load.isDefined("imcarouselJS")?load.ready("imcarouselJS",function(){// 图片轮播
var jq=getCurrentJQuery();var currentWindow=getCurrentWindow();var imgPool=[];var indexNum=0;for(var i=0;i<owner.length;i++){imgPool.push(owner[i].getAttribute("data-imgsrc")||owner[i].getAttribute("src"));}for(var _i=0;_i<imgPool.length;_i++){var imgSrc=!!jq(source).attr("data-imgsrc")?jq(source).attr("data-imgsrc"):jq(source).attr("src");if(imgSrc===imgPool[_i]){break;}else{indexNum++;}}IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.setLayoutWindow?window.setLayoutWindow:_window2.default.getTop());}):load(["/social/js/drageasy/drageasy.js","/social/js/bootstrap/js/bootstrap.js","/social/im/js/IMUtil_wev8.js","/social/js/imcarousel/imcarousel.js"],"imcarouselJS",function(){// 图片轮播
var jq=getCurrentJQuery();var currentWindow=getCurrentWindow();var imgPool=[];var indexNum=0;for(var i=0;i<owner.length;i++){imgPool.push(owner[i].getAttribute("data-imgsrc"));}for(var _i2=0;_i2<imgPool.length;_i2++){if(jq(source).attr("data-imgsrc")===imgPool[_i2]){break;}else{indexNum++;}}IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.setLayoutWindow?window.setLayoutWindow:_window2.default.getTop());});};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);exports.loadDevModules=loadDevModules;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function loadDevModules(moduleId,moduleName){return new _promise2.default(function(resolve,reject){function timeOutLoad(resolve,reject){if(window.e9_registed_coms){window.eventRegister&&window.eventRegister.loadModule(moduleId,function(){resolve();},function(){var msg=moduleName+" \u52A0\u8F7D\u5931\u8D25";reject(msg);});}else{setTimeout(function(){timeOutLoad(resolve,reject);},100);}}timeOutLoad(resolve,reject);});}

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _uniq=__webpack_require__(65);var _uniq2=_interopRequireDefault(_uniq);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function checkStdRouter(str){var isBackend=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var result={isRouter:false,url:str};if(typeof str!="string"){return result;}var exceptArr=["/spa/cowork/static/index.html#/cowork/","/spa/cube/index.html#/main/cube/card","/spa/workflow/index_form.jsp","/spa/document/index.jsp"];for(var index=0;index<exceptArr.length;index++){var element=exceptArr[index];if(str.indexOf(element)>-1){return result;}}if(str.indexOf("index.html")>-1&&isBackend===true){return result;}if(str.indexOf("engine.html")>-1&&isBackend===false){return result;}var moduleConfigs=window.e9ModuleConfig;if(!moduleConfigs){return result;}var modulePages=[];moduleConfigs.forEach(function(element){if(element.page){modulePages.push(element.page);}});modulePages=(0,_uniq2.default)(modulePages);modulePages.forEach(function(element){if(str.indexOf(element)!==-1){result.isRouter=true;result.url=str;if(str.indexOf("#")>-1){if(/#\/edc\/dataBoard/.test(str)&&/\/spa\/edc\/static\/app\/index.html/.test(str)){result.url=str.slice(str.indexOf("#")+1);result.url=result.url+str.slice(str.indexOf("?"),str.indexOf("#"));return result;}result.url=str.slice(str.indexOf("#")+1);}return result;}});var tempUrl=str;if(str.indexOf("?")>-1){tempUrl=str.slice(0,str.indexOf("?"));}if(!/.*\.(html|jsp|wx)/.test(tempUrl)&&tempUrl.indexOf("/")===0){result.isRouter=true;result.url=str;return result;}return result;}module.exports=checkStdRouter;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function getReverseColor(color){var input=color;if(!color||!/^#.*/.test(color)){return false;}//format
if(color.length===4){input="#"+color[1]+color[1]+color[2]+color[2]+color[3]+color[3];}var inputValue="0x"+input.replace(/#/g,"");var outValue="000000"+(0xffffff-inputValue).toString(16);return"#"+outValue.substring(outValue.length-6,outValue.length);}module.exports=getReverseColor;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.initRefreshLanguageInterval=exports.checkLang=exports.initBaseLanguageInterval=undefined;var _stringify=__webpack_require__(37);var _stringify2=_interopRequireDefault(_stringify);var _callApi=__webpack_require__(17);var _storage=__webpack_require__(60);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var initBaseLanguageInterval=exports.initBaseLanguageInterval=function initBaseLanguageInterval(){if(window.setBaseLanguageInterval!=true){var interval=function interval(){(0,_callApi.callApi)("/api/system/language/base/getActiveLanguage","GET",{}).then(function(res){if(res.activeLanguageIds&&res.activeLanguageIds.length>0){window.localStorage["activeLanguageIds"]=(0,_stringify2.default)(res.activeLanguageIds);}});};window.setInterval(interval,60000);window.setBaseLanguageInterval=true;interval();}};var checkLang=exports.checkLang=function checkLang(){if(_storage.ls.getJSONObj("activeLanguageIds")&&_storage.ls.getJSONObj("activeLanguageIds").length>1){(0,_callApi.callApi)("/api/system/language/base/getLang","GET",{}).then(function(res){if(res.status!=false&&res.lang&&res.lang!=localStorage["languageidweaver"]){localStorage["languageidweaver"]=res.lang;localStorage["e9_locale"]="";localStorage["isInitLSValue"]=false;window.location.reload();}});}};var initRefreshLanguageInterval=exports.initRefreshLanguageInterval=function initRefreshLanguageInterval(){var interval=function interval(){if(_storage.ls.getJSONObj("activeLanguageIds")&&_storage.ls.getJSONObj("activeLanguageIds").length>1){(0,_callApi.callApi)("/api/system/language/base/getLang","GET",{}).then(function(res){if(res.status!=false&&res.lang&&res.lang!=localStorage["languageidweaver"]){localStorage["languageidweaver"]=res.lang;localStorage["e9_locale"]="";localStorage["isInitLSValue"]=false;window.location.reload();}});}};window.setInterval(interval,30000);interval();};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function initContentPath(){if(window.ecologyContentPath){// 添加二级路径给 img
var e9HooksOld=(0,_extends3.default)({},window.e9Hooks);window.e9Hooks=(0,_extends3.default)({},window.e9Hooks,{reactDOMSetInnerHTML:function reactDOMSetInnerHTML(node,html){var newHtml=""+html;if(typeof e9HooksOld.reactDOMSetInnerHTML==="function"){newHtml=e9HooksOld.reactDOMSetInnerHTML(node,html)||""+html;}var imgReg=/<(img|a|iframe)\s[^>]+\/?>/gi;var match=newHtml.match(imgReg);if(match&&match.length){var srcReg=/(src|href)=[\'\"]?([^\'\"]*)[\'\"]?\s/i;newHtml=newHtml.replace(imgReg,function(){return"{~}";});match.forEach(function(m){m=m.replace(imgReg,function(img){var srcMatch=img.match(srcReg);if(srcMatch&&srcMatch.length){var src=srcMatch[2];src.replace(/\s$/,"");var reg=new RegExp("^"+window.ecologyContentPath);if(src&&!reg.test(src)&&/^\//.test(src)){return img.replace(srcReg,function(){return(/^src/.test(srcMatch[0])?"src":"href")+"=\""+window.ecologyContentPath+src+"\"";});}}return img;});newHtml=newHtml.replace(/{~}/,function(){return m;});});node.innerHTML=newHtml;}else{// default
node.innerHTML=newHtml;}return newHtml;},reactDOMSetAttribute:function reactDOMSetAttribute(isCustomComponentTag,propertyInfo,node,attributeName,attributeValue,attributeNamespace){var newAttributeValue=attributeValue;if(typeof e9HooksOld.reactDOMSetAttribute==="function"){newAttributeValue=e9HooksOld.reactDOMSetAttribute(isCustomComponentTag,propertyInfo,node,attributeName,attributeValue,attributeNamespace);}if(window.ecologyContentPath&&(node.nodeName==="IMG"&&attributeName==="src"||node.nodeName==="IFRAME"&&attributeName==="src"||node.nodeName==="A"&&attributeName==="href")){var reg=new RegExp("^"+window.ecologyContentPath);if(!reg.test(newAttributeValue)&&/^\//.test(newAttributeValue)){newAttributeValue=window.ecologyContentPath+newAttributeValue;}}// default
if(isCustomComponentTag||propertyInfo===null){node.setAttribute(attributeName,newAttributeValue);return newAttributeValue;}if(propertyInfo.mustUseProperty){node[attributeName]=newAttributeValue;return newAttributeValue;}if(attributeNamespace){node.setAttributeNS(attributeNamespace,attributeName,newAttributeValue);return newAttributeValue;}else{node.setAttribute(attributeName,newAttributeValue);return newAttributeValue;}}});}}module.exports=initContentPath;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _callApi=__webpack_require__(17);window.e9TimeOutSwitch=false;function initTimeoutSwitch(){(0,_callApi.callApi)("/api/hrm/login/getTimeOutSwitch","GET",{}).then(function(res){if(res.status=="1"&&res.isNeedDialog=="false"){window.e9TimeOutSwitch=true;}});}module.exports=initTimeoutSwitch;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _promise=__webpack_require__(27);var _promise2=_interopRequireDefault(_promise);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _isString=__webpack_require__(43);var _isString2=_interopRequireDefault(_isString);var _isArray=__webpack_require__(21);var _isArray2=_interopRequireDefault(_isArray);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);var _isObject=__webpack_require__(40);var _isObject2=_interopRequireDefault(_isObject);var _random=__webpack_require__(97);var _random2=_interopRequireDefault(_random);var _loadjs=__webpack_require__(54);var _loadjs2=_interopRequireDefault(_loadjs);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _callApi=__webpack_require__(17);var caUtil=_interopRequireWildcard(_callApi);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var callApi=caUtil.callApi;var EventRegister=function(){function EventRegister(){(0,_classCallCheck3.default)(this,EventRegister);this.timeMark="";this.loadjs=_loadjs2.default;this.list={};this.startListInner=this.startListInner.bind(this);}(0,_createClass3.default)(EventRegister,[{key:"register",value:function register(name,cof){this.list[name]=cof;}},{key:"registerList",value:function registerList(name,cof){if(Object.prototype.toString.call(this.list[name])==="[object Array]"){this.list[name].push(cof);}else{this.list[name]=[];this.list[name].push(cof);}}},{key:"startList",value:function startList(name,params,successCb,failedCb){var _this=this;_loadjs2.default.isDefined("devModuleCustom")?// ? loadjs.ready(
//     "devModuleCustom",
//     this.startListInner.bind(this, name, params, successCb, failedCb)
//   )
this.startListInner(name,params,successCb,failedCb):(0,_loadjs2.default)([(window.ecologyContentPath||"")+"/cloudstore/config/devStatic/devModuleCustom.js?v="+new Date().getTime(),"css!"+(window.ecologyContentPath||"")+"/cloudstore/config/devStatic/devModuleStyle.css?v="+new Date().getTime()],"devModuleCustom",{success:function success(){_this.startListInner(name,params,successCb,failedCb);},error:function error(){_this.startListInner(name,params,successCb,failedCb);}});}},{key:"startListInner",value:function startListInner(name,params,successCb,failedCb){var sCb=successCb;var fCb=failedCb;if((0,_isFunction2.default)(params)){sCb=params;fCb=successCb;}if(Object.prototype.toString.call(this.list[name])==="[object Array]"){var runItem=function runItem(item){if(item.fn&&(0,_isFunction2.default)(item.fn)){return window.Promise.try(function(){if((0,_isObject2.default)(params)){return item.fn(params);}else{return item.fn();}}).then(function(){item.callback&&item.callback.apply(item,arguments);}).catch(function(){(0,_isFunction2.default)(fCb)&&fCb.apply(undefined,arguments);});}else{return new _promise2.default(function(rs,rj){console&&console.error("run list item fail",item);rs();});}};var promiseArr=[];for(var _index=0;_index<this.list[name].length;_index++){var _element=this.list[name][_index];promiseArr.push(runItem(_element));}_promise2.default.all(promiseArr).then(function(){(0,_isFunction2.default)(sCb)&&sCb();}).catch(function(reason){(0,_isFunction2.default)(fCb)&&fCb.apply(undefined,(0,_toConsumableArray3.default)(reason));});}else{if(name&&(0,_isString2.default)(name)){if(this.list[name]){this.start(name,params,successCb,failedCb);}else{(0,_isFunction2.default)(sCb)&&sCb();}}else{(0,_isFunction2.default)(sCb)&&sCb();}}}},{key:"clear",value:function clear(){this.list={};}},{key:"getCof",value:function getCof(){return this.list;}},{key:"loadModule",value:function loadModule(){var _this2=this;for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var count=1;var interVal=setInterval(function(){if(args&&args[0]&&_this2.list[args[0]]){clearInterval(interVal);}if(count>1000)clearInterval(interVal);_this2.start.apply(_this2,args);count++;},10);}},{key:"start",value:function start(name,params,successCb,failedCb){var _this3=this;var sCb=successCb;var fCb=failedCb;if(name&&(0,_isString2.default)(name)){var item=this.list[name];if((0,_isFunction2.default)(params)){sCb=params;fCb=successCb;}var runItem=function runItem(item){if(item.fn&&(0,_isFunction2.default)(item.fn)){window.Promise.try(function(){if((0,_isObject2.default)(params)){return item.fn(params);}else{return item.fn();}}).then(function(){item.callback&&item.callback.apply(item,arguments);(0,_isFunction2.default)(sCb)&&sCb.apply(undefined,arguments);}).catch(function(){(0,_isFunction2.default)(fCb)&&fCb.apply(undefined,arguments);});}};if(item){if(item.lib){var buddleId=""+(item.libName||(0,_random2.default)(1000000));var libArr=item.lib.map(function(l){return""+(/\.css[^\/]*$/.test(l)?"css!":"")+l+_this3.timeMark;});if(!_loadjs2.default.isDefined(buddleId)){// 添加每天自动更新缓存功能
(0,_loadjs2.default)(libArr,buddleId,{async:"async"in item?item.async:true,success:function success(){runItem(item);},error:function error(){var message=item.libName||item.lib;message=getLabel(385818,"加载$s失败！！！").replace(/\$s/,message);fCb&&fCb(message);console&&console.error(message);}});}else{_loadjs2.default.ready(buddleId,function(){runItem(item);});}}else{runItem(item);}}}}}]);return EventRegister;}();if(!window.eventRegister){window.eventRegister=new EventRegister();}// const loadmodule = () => {
//   isArray(window.e9ModuleConfig) &&
//     window.e9ModuleConfig.forEach(cof => {
//       if (cof.name) {
//         window.eventRegister.register(cof.name, {
//           lib: cof.lib,
//           libName: cof.name,
//           fn() {
//             return "success";
//           }
//         });
//       }
//     });
// };
var loadmodule=function loadmodule(){var arr=[];if((0,_isArray2.default)(window.e9ModuleConfig)){arr=arr.concat(window.e9ModuleConfig);}if((0,_isArray2.default)(window.e9ModuleConfigCustomF)){arr=arr.concat(window.e9ModuleConfigCustomF);}if((0,_isArray2.default)(window.e9ModuleConfigCustomB)){arr=arr.concat(window.e9ModuleConfigCustomB);}arr.forEach(function(cof){if(cof.name){window.eventRegister.register(cof.name,{lib:cof.lib,libName:cof.name,fn:function fn(){return"success";}});}});};loadmodule();// loadjs(`/spa/moduleConfig.js?v=${random(1000000)}`, "e9ModuleConfig", () =>
//   loadmodule()
// );
// const loaddevmodule = () => {
//   isArray(window.devModuleConfig) &&
//     window.devModuleConfig.forEach(cof => {
//       if (cof.id) {
//         window.eventRegister.register(cof.id, {
//           lib: cof.lib,
//           libName: cof.name,
//           fn() {
//             return "success";
//           }
//         });
//       }
//     });
// };
// loadjs(
//   ["/cloudstore/config/devStatic/devModuleConfig.js"],
//   "devModuleConfig",
//   () => loaddevmodule()
// );
// callApi("/api/system/componentmanage/queryComponentByComtype").then(data => {
//   if (data.status && data.datas) {
//     data.datas.forEach(cof => {
//       if (cof.id) {
//         var libs = cof.url.split(",");
//         for (let index = 0; index < libs.length; index++) {
//           const element = libs[index];
//           if (
//             window.ecologyContentPath &&
//             !new RegExp(window.ecologyContentPath).test(element)
//           ) {
//             libs[index] = window.ecologyContentPath + element;
//           }
//         }
//         window.eventRegister.register(cof.id, {
//           lib: libs,
//           libName: cof.name,
//           fn() {
//             return "success";
//           }
//         });
//       }
//     });
//     window.e9_registed_coms = true;
//   }
// });
// 根据环境加载配置文件
// var curHost = window.location.hostname;
// var hostArr = ["192.168.7.224", "192.168.1.73", "192.168.1.71"];
// if (hostArr.indexOf(curHost) !== -1) {
//   loadjs(
//     [
//       "/cloudstore/config/devStatic/devModuleCustom-dev.js",
//       "/cloudstore/config/devStatic/devModuleStyle-dev.css"
//     ],
//     "devModuleCustom"
//   );
// } else {
try{var defaultDevFiles=[(window.ecologyContentPath||"")+"/cloudstore/config/devStatic/devModuleCustom.js?v="+new Date().getTime(),"css!"+(window.ecologyContentPath||"")+"/cloudstore/config/devStatic/devModuleStyle.css?v="+new Date().getTime()];if(window.ecDevFileConfig&&window.ecDevFileConfig.pc){if(window.ecDevFileConfig.pc.global){defaultDevFiles=window.ecDevFileConfig.pc.global;}if(window.ecDevFileConfig.pc.moduleConfig&&window.ecDevFileConfig.pc.moduleConfig.length){var moduleConfigList=window.ecDevFileConfig.pc.moduleConfig;for(var index=0;index<moduleConfigList.length;index++){var element=moduleConfigList[index];if(window.location.href.search(element.hrefRegex)>0){defaultDevFiles=defaultDevFiles.concat(element.files);}}}}_loadjs2.default.isDefined("devModuleCustom")?"":(0,_loadjs2.default)(defaultDevFiles,"devModuleCustom");}catch(error){window.localStorage["emDebug"]=="1"&&alert("devModuleCustom error");console&&void 0;}// }

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Poshy Tip jQuery plugin v1.2+
 * http://vadikom.com/tools/poshy-tip-jquery-plugin-for-stylish-tooltips/
 * Copyright 2010-2013, Vasil Dinkov, http://vadikom.com/
 */(function($){var tips=[],reBgImage=/^url\(["']?([^"'\)]*)["']?\);?$/i,rePNG=/\.png$/i,IE=!!window.createPopup,IE6=IE&&typeof document.documentElement.currentStyle.minWidth=='undefined',IElt9=IE&&!document.defaultView;// make sure the tips' position is updated on resize
function handleWindowResize(){$.each(tips,function(){this.refresh(true);});}$(window).resize(handleWindowResize);$.Poshytip=function(elm,options){this.$elm=$(elm);this.opts=$.extend({},$.fn.poshytip.defaults,options);var idNameHtml=''!=this.opts.idName?'id='+this.opts.idName:'';this.$tip=$(['<div ',idNameHtml,' class="',this.opts.className,'">','<div class="tip-inner tip-bg-image"></div>','<div class="tip-arrow tip-arrow-top tip-arrow-right tip-arrow-bottom tip-arrow-left"></div>','</div>'].join('')).appendTo(document.body);this.$arrow=this.$tip.find('div.tip-arrow');this.$inner=this.$tip.find('div.tip-inner');this.disabled=false;this.content=null;this.init();};$.Poshytip.hideAll=function(){$.each(tips,function(){this.hide();});};$.Poshytip.prototype={init:function init(){tips.push(this);// save the original title and a reference to the Poshytip object
var title=this.$elm.attr('title');this.$elm.data('title.poshytip',title!==undefined?title:null).data('poshytip',this);// hook element events
if(this.opts.showOn!='none'){this.$elm.bind({'mouseenter.poshytip':$.proxy(this.mouseenter,this),'mouseleave.poshytip':$.proxy(this.mouseleave,this)});switch(this.opts.showOn){case'hover':if(this.opts.alignTo=='cursor')this.$elm.bind('mousemove.poshytip',$.proxy(this.mousemove,this));if(this.opts.allowTipHover)this.$tip.hover($.proxy(this.clearTimeouts,this),$.proxy(this.mouseleave,this));break;case'focus':this.$elm.bind({'focus.poshytip':$.proxy(this.showDelayed,this),'blur.poshytip':$.proxy(this.hideDelayed,this)});break;}}},mouseenter:function mouseenter(e){if(this.disabled)return true;this.updateCursorPos(e);this.$elm.attr('title','');if(this.opts.showOn=='focus')return true;this.showDelayed();},mouseleave:function mouseleave(e){if(this.disabled||this.asyncAnimating&&(this.$tip[0]===e.relatedTarget||jQuery.contains(this.$tip[0],e.relatedTarget)))return true;if(!this.$tip.data('active')){var title=this.$elm.data('title.poshytip');if(title!==null)this.$elm.attr('title',title);}if(this.opts.showOn=='focus')return true;this.hideDelayed();},mousemove:function mousemove(e){if(this.disabled)return true;this.updateCursorPos(e);if(this.opts.followCursor&&this.$tip.data('active')){this.calcPos();this.$tip.css({left:this.pos.l,top:this.pos.t});if(this.pos.arrow)this.$arrow[0].className='tip-arrow tip-arrow-'+this.pos.arrow;}},show:function show(){if(this.disabled||this.$tip.data('active'))return;this.reset();this.update();// don't proceed if we didn't get any content in update() (e.g. the element has an empty title attribute)
if(!this.content)return;this.display();if(this.opts.timeOnScreen)this.hideDelayed(this.opts.timeOnScreen);},showDelayed:function showDelayed(timeout){this.clearTimeouts();this.showTimeout=setTimeout($.proxy(this.show,this),typeof timeout=='number'?timeout:this.opts.showTimeout);},hide:function hide(){if(this.disabled||!this.$tip.data('active'))return;this.display(true);},hideDelayed:function hideDelayed(timeout){this.clearTimeouts();this.hideTimeout=setTimeout($.proxy(this.hide,this),typeof timeout=='number'?timeout:this.opts.hideTimeout);},reset:function reset(){this.$tip.queue([]).detach().css('visibility','hidden').data('active',false);this.$inner.find('*').poshytip('hide');if(this.opts.fade)this.$tip.css('opacity',this.opacity);this.$arrow[0].className='tip-arrow tip-arrow-top tip-arrow-right tip-arrow-bottom tip-arrow-left';this.asyncAnimating=false;},update:function update(content,dontOverwriteOption){if(this.disabled)return;var async=content!==undefined;if(async){if(!dontOverwriteOption)this.opts.content=content;if(!this.$tip.data('active'))return;}else{content=this.opts.content;}// update content only if it has been changed since last time
var self=this,newContent=typeof content=='function'?content.call(this.$elm[0],function(newContent){self.update(newContent);}):content=='[title]'?this.$elm.data('title.poshytip'):content;if(this.content!==newContent){this.$inner.empty().append(newContent);this.content=newContent;}this.refresh(async);},refresh:function refresh(async){if(this.disabled)return;if(async){if(!this.$tip.data('active'))return;// save current position as we will need to animate
var currPos={left:this.$tip.css('left'),top:this.$tip.css('top')};}// reset position to avoid text wrapping, etc.
this.$tip.css({left:0,top:0}).appendTo(document.body);// save default opacity
if(this.opacity===undefined)this.opacity=this.$tip.css('opacity');// check for images - this code is here (i.e. executed each time we show the tip and not on init) due to some browser inconsistencies
var bgImage=this.$tip.css('background-image').match(reBgImage),arrow=this.$arrow.css('background-image').match(reBgImage);if(bgImage){var bgImagePNG=rePNG.test(bgImage[1]);// fallback to background-color/padding/border in IE6 if a PNG is used
if(IE6&&bgImagePNG){this.$tip.css('background-image','none');this.$inner.css({margin:0,border:0,padding:0});bgImage=bgImagePNG=false;}else{this.$tip.prepend('<table class="tip-table" border="0" cellpadding="0" cellspacing="0"><tr><td class="tip-top tip-bg-image" colspan="2"><span></span></td><td class="tip-right tip-bg-image" rowspan="2"><span></span></td></tr><tr><td class="tip-left tip-bg-image" rowspan="2"><span></span></td><td></td></tr><tr><td class="tip-bottom tip-bg-image" colspan="2"><span></span></td></tr></table>').css({border:0,padding:0,'background-image':'none','background-color':'transparent'}).find('.tip-bg-image').css('background-image','url("'+bgImage[1]+'")').end().find('td').eq(3).append(this.$inner);}// disable fade effect in IE due to Alpha filter + translucent PNG issue
if(bgImagePNG&&IElt9)this.opts.fade=false;}// IE arrow fixes
if(arrow&&IElt9){// disable arrow in IE6 if using a PNG
if(IE6&&rePNG.test(arrow[1])){arrow=false;this.$arrow.css('background-image','none');}// disable fade effect in IE due to Alpha filter + translucent PNG issue
this.opts.fade=false;}var $table=this.$tip.find('> table.tip-table');if(IE6){// fix min/max-width in IE6
this.$tip[0].style.width='';$table.width('auto').find('td').eq(3).width('auto');var tipW=this.$tip.width(),minW=parseInt(this.$tip.css('min-width')),maxW=parseInt(this.$tip.css('max-width'));if(!isNaN(minW)&&tipW<minW)tipW=minW;else if(!isNaN(maxW)&&tipW>maxW)tipW=maxW;this.$tip.add($table).width(tipW).eq(0).find('td').eq(3).width('100%');}else if($table[0]){// fix the table width if we are using a background image
// IE9, FF4 use float numbers for width/height so use getComputedStyle for them to avoid text wrapping
// for details look at: http://vadikom.com/dailies/offsetwidth-offsetheight-useless-in-ie9-firefox4/
$table.width('auto').find('td').eq(3).width('auto').end().end().width(document.defaultView&&document.defaultView.getComputedStyle&&parseFloat(document.defaultView.getComputedStyle(this.$tip[0],null).width)||this.$tip.width()).find('td').eq(3).width('100%');}this.tipOuterW=this.$tip.outerWidth();this.tipOuterH=this.$tip.outerHeight();this.calcPos();// position and show the arrow image
if(arrow&&this.pos.arrow){this.$arrow[0].className='tip-arrow tip-arrow-'+this.pos.arrow;this.$arrow.css('visibility','inherit');}if(async&&this.opts.refreshAniDuration){this.asyncAnimating=true;var self=this;this.$tip.css(currPos).animate({left:this.pos.l,top:this.pos.t},this.opts.refreshAniDuration,function(){self.asyncAnimating=false;});}else{this.$tip.css({left:this.pos.l,top:this.pos.t});}},display:function display(hide){var active=this.$tip.data('active');if(active&&!hide||!active&&hide)return;this.$tip.stop();if((this.opts.slide&&this.pos.arrow||this.opts.fade)&&(hide&&this.opts.hideAniDuration||!hide&&this.opts.showAniDuration)){var from={},to={};// this.pos.arrow is only undefined when alignX == alignY == 'center' and we don't need to slide in that rare case
if(this.opts.slide&&this.pos.arrow){var prop,arr;if(this.pos.arrow=='bottom'||this.pos.arrow=='top'){prop='top';arr='bottom';}else{prop='left';arr='right';}var val=parseInt(this.$tip.css(prop));from[prop]=val+(hide?0:this.pos.arrow==arr?-this.opts.slideOffset:this.opts.slideOffset);to[prop]=val+(hide?this.pos.arrow==arr?this.opts.slideOffset:-this.opts.slideOffset:0)+'px';}if(this.opts.fade){from.opacity=hide?this.$tip.css('opacity'):0;to.opacity=hide?0:this.opacity;}this.$tip.css(from).animate(to,this.opts[hide?'hideAniDuration':'showAniDuration']);}hide?this.$tip.queue($.proxy(this.reset,this)):this.$tip.css('visibility','inherit');if(active){var title=this.$elm.data('title.poshytip');if(title!==null)this.$elm.attr('title',title);}this.$tip.data('active',!active);},disable:function disable(){this.reset();this.disabled=true;},enable:function enable(){this.disabled=false;},destroy:function destroy(){this.reset();this.$tip.remove();delete this.$tip;this.content=null;this.$elm.unbind('.poshytip').removeData('title.poshytip').removeData('poshytip');tips.splice($.inArray(this,tips),1);},clearTimeouts:function clearTimeouts(){if(this.showTimeout){clearTimeout(this.showTimeout);this.showTimeout=0;}if(this.hideTimeout){clearTimeout(this.hideTimeout);this.hideTimeout=0;}},updateCursorPos:function updateCursorPos(e){this.eventX=e.pageX;this.eventY=e.pageY;},calcPos:function calcPos(){var pos={l:0,t:0,arrow:''},$win=$(window),win={l:$win.scrollLeft(),t:$win.scrollTop(),w:$win.width(),h:$win.height()},xL,xC,xR,yT,yC,yB;if(this.opts.alignTo=='cursor'){xL=xC=xR=this.eventX;yT=yC=yB=this.eventY;}else{// this.opts.alignTo == 'target'
var elmOffset=this.$elm.offset(),elm={l:elmOffset.left,t:elmOffset.top,w:this.$elm.outerWidth(),h:this.$elm.outerHeight()};xL=elm.l+(this.opts.alignX!='inner-right'?0:elm.w);// left edge
xC=xL+Math.floor(elm.w/2);// h center
xR=xL+(this.opts.alignX!='inner-left'?elm.w:0);// right edge
yT=elm.t+(this.opts.alignY!='inner-bottom'?0:elm.h);// top edge
yC=yT+Math.floor(elm.h/2);// v center
yB=yT+(this.opts.alignY!='inner-top'?elm.h:0);// bottom edge
}// keep in viewport and calc arrow position
switch(this.opts.alignX){case'right':case'inner-left':pos.l=xR+this.opts.offsetX;if(this.opts.keepInViewport&&pos.l+this.tipOuterW>win.l+win.w)pos.l=win.l+win.w-this.tipOuterW;if(this.opts.alignX=='right'||this.opts.alignY=='center')pos.arrow='left';break;case'center':pos.l=xC-Math.floor(this.tipOuterW/2);if(this.opts.keepInViewport){if(pos.l+this.tipOuterW>win.l+win.w)pos.l=win.l+win.w-this.tipOuterW;else if(pos.l<win.l)pos.l=win.l;}break;default:// 'left' || 'inner-right'
pos.l=xL-this.tipOuterW-this.opts.offsetX;if(this.opts.keepInViewport&&pos.l<win.l)pos.l=win.l;if(this.opts.alignX=='left'||this.opts.alignY=='center')pos.arrow='right';}switch(this.opts.alignY){case'bottom':case'inner-top':pos.t=yB+this.opts.offsetY;// 'left' and 'right' need priority for 'target'
if(!pos.arrow||this.opts.alignTo=='cursor')pos.arrow='top';if(this.opts.keepInViewport&&pos.t+this.tipOuterH>win.t+win.h){pos.t=yT-this.tipOuterH-this.opts.offsetY;if(pos.arrow=='top')pos.arrow='bottom';}break;case'center':pos.t=yC-Math.floor(this.tipOuterH/2);if(this.opts.keepInViewport){if(pos.t+this.tipOuterH>win.t+win.h)pos.t=win.t+win.h-this.tipOuterH;else if(pos.t<win.t)pos.t=win.t;}break;default:// 'top' || 'inner-bottom'
pos.t=yT-this.tipOuterH-this.opts.offsetY;// 'left' and 'right' need priority for 'target'
if(!pos.arrow||this.opts.alignTo=='cursor')pos.arrow='bottom';if(this.opts.keepInViewport&&pos.t<win.t){pos.t=yB+this.opts.offsetY;if(pos.arrow=='bottom')pos.arrow='top';}}this.pos=pos;}};$.fn.poshytip=function(options){if(typeof options=='string'){var args=arguments,method=options;Array.prototype.shift.call(args);// unhook live events if 'destroy' is called
if(method=='destroy'){this.die?this.die('mouseenter.poshytip').die('focus.poshytip'):$(document).undelegate(this.selector,'mouseenter.poshytip').undelegate(this.selector,'focus.poshytip');}return this.each(function(){var poshytip=$(this).data('poshytip');if(poshytip&&poshytip[method])poshytip[method].apply(poshytip,args);});}var opts=$.extend({},$.fn.poshytip.defaults,options);// generate CSS for this tip class if not already generated
if(!$('#poshytip-css-'+opts.className)[0])$(['<style id="poshytip-css-',opts.className,'" type="text/css">','div.',opts.className,'{visibility:hidden;position:absolute;top:0;left:0;}','div.',opts.className,' table.tip-table, div.',opts.className,' table.tip-table td{margin:0;font-family:inherit;font-size:inherit;font-weight:inherit;font-style:inherit;font-variant:inherit;vertical-align:middle;}','div.',opts.className,' td.tip-bg-image span{display:block;font:1px/1px sans-serif;height:',opts.bgImageFrameSize,'px;width:',opts.bgImageFrameSize,'px;overflow:hidden;}','div.',opts.className,' td.tip-right{background-position:100% 0;}','div.',opts.className,' td.tip-bottom{background-position:100% 100%;}','div.',opts.className,' td.tip-left{background-position:0 100%;}','div.',opts.className,' div.tip-inner{background-position:-',opts.bgImageFrameSize,'px -',opts.bgImageFrameSize,'px;}','div.',opts.className,' div.tip-arrow{visibility:hidden;position:absolute;overflow:hidden;font:1px/1px sans-serif;}','</style>'].join('')).appendTo('head');// check if we need to hook live events
if(opts.liveEvents&&opts.showOn!='none'){var handler,deadOpts=$.extend({},opts,{liveEvents:false});switch(opts.showOn){case'hover':handler=function handler(){var $this=$(this);if(!$this.data('poshytip'))$this.poshytip(deadOpts).poshytip('mouseenter');};// support 1.4.2+ & 1.9+
this.live?this.live('mouseenter.poshytip',handler):$(document).delegate(this.selector,'mouseenter.poshytip',handler);break;case'focus':handler=function handler(){var $this=$(this);if(!$this.data('poshytip'))$this.poshytip(deadOpts).poshytip('showDelayed');};this.live?this.live('focus.poshytip',handler):$(document).delegate(this.selector,'focus.poshytip',handler);break;}return this;}return this.each(function(){new $.Poshytip(this,opts);});};// default settings
$.fn.poshytip.defaults={content:'[title]',// content to display ('[title]', 'string', element, function(updateCallback){...}, jQuery)
className:'tip-yellow',// class for the tips
idName:'',// id for the tip
bgImageFrameSize:10,// size in pixels for the background-image (if set in CSS) frame around the inner content of the tip
showTimeout:500,// timeout before showing the tip (in milliseconds 1000 == 1 second)
hideTimeout:100,// timeout before hiding the tip
timeOnScreen:0,// timeout before automatically hiding the tip after showing it (set to > 0 in order to activate)
showOn:'hover',// handler for showing the tip ('hover', 'focus', 'none') - use 'none' to trigger it manually
liveEvents:false,// use live events
alignTo:'cursor',// align/position the tip relative to ('cursor', 'target')
alignX:'right',// horizontal alignment for the tip relative to the mouse cursor or the target element
// ('right', 'center', 'left', 'inner-left', 'inner-right') - 'inner-*' matter if alignTo:'target'
alignY:'top',// vertical alignment for the tip relative to the mouse cursor or the target element
// ('bottom', 'center', 'top', 'inner-bottom', 'inner-top') - 'inner-*' matter if alignTo:'target'
offsetX:-22,// offset X pixels from the default position - doesn't matter if alignX:'center'
offsetY:18,// offset Y pixels from the default position - doesn't matter if alignY:'center'
keepInViewport:true,// reposition the tooltip if needed to make sure it always appears inside the viewport
allowTipHover:true,// allow hovering the tip without hiding it onmouseout of the target - matters only if showOn:'hover'
followCursor:false,// if the tip should follow the cursor - matters only if showOn:'hover' and alignTo:'cursor'
fade:true,// use fade animation
slide:true,// use slide animation
slideOffset:8,// slide animation offset
showAniDuration:300,// show animation duration - set to 0 if you don't want show animation
hideAniDuration:300,// hide animation duration - set to 0 if you don't want hide animation
refreshAniDuration:200// refresh animation duration - set to 0 if you don't want animation when updating the tooltip asynchronously
};})(jQuery);

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var render=function render(_idArray,_nameArray,_jobtitleArray,__x,__y){var browgroupHtml="";var _i;for(_i=0;_i<_idArray.length;_i++){var className=_i%2==1?"ac_even":"ac_odd";var displaycss=_i>4?" display:none; ":"";var resdetailinfohtml="<span style='display:inline-block;width:80px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;'><a href=javaScript:openhrm("+_idArray[_i]+"); onclick='pointerXY(event);' style='overflow: hidden;white-space: nowrap;text-overflow: ellipsis;' title='"+_nameArray[_i]+"'>"+_nameArray[_i]+"</a></span>";resdetailinfohtml+="<span style='float:right;display:inline-block;width:130px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;' title='"+_jobtitleArray[_i]+"'>"+_jobtitleArray[_i]+"</span>";browgroupHtml+='<li class="'+className+'" _id="'+_idArray[_i]+"\" style='"+displaycss+"'>"+resdetailinfohtml+"</li>";if(_i>4&&_i==_idArray.length-1){browgroupHtml+='<li class="'+className+'" title="'+getLabel(20234,"显示全部")+'" style="text-align:center;" onclick="showallCrmsdetail(this);">'+getLabel(20234,"显示全部")+"</li>";}}if(!!browgroupHtml){var autoCompleteDiv=jQuery("<div id='__brow__detaildiv' class='wea-hrmgroup-wrapper' style=\"position:absolute;width:245px;z-index:1099;left:"+__x+"px;top:"+__y+'px;"></div>');var autoCompleteDiv_html=jQuery('<div class="arrowsblock"><img src="'+(window.ecologyContentPath||"")+'/images/ecology8/workflow/multres/arrows_2_wev8.png" width="22px" height="22px"></div>'+"<div class='ac_results' style='margin-top:20px;background:#fff;z-index:9;'><ul>"+browgroupHtml+"</ul></div>");var mask=jQuery("<div id='__brow__detaildiv_mask' onclick='closeCrmsDetail();' style=\"position:fixed; top:0;left:0;right:0;bottom:0; z-index:1098;\"></div>");autoCompleteDiv.append(autoCompleteDiv_html);// autoCompleteDiv_html.addClass("ac_results");
jQuery("body").append(mask).append(autoCompleteDiv);}};window.showCrmsDetail=function(e){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};closeCrmsDetail();var target=jQuery(e.target);var x=target.offset().left-(245-target.width())/2;var y=target.offset().top+15;render(params.ids,params.names,params.jobtitles,x,y);};window.closeCrmsDetail=function(){jQuery("#__brow__detaildiv_mask").remove();jQuery("#__brow__detaildiv").remove();};window.showallCrmsdetail=function(ele){var target=jQuery(ele);var parentDiv=target.closest("div");parentDiv.css({height:parentDiv.height()+"px",overflow:"auto"});// parentDiv.perfectScrollbar({horizrailenabled:false,zindex:1000});
var othli=target.parent().children().not(":visible");othli.show();target.hide();};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

/*! https://mths.be/utf8js v3.0.0 by @mathias */
;(function(root) {

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			checkScalarValue(codePoint);
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				checkScalarValue(codePoint);
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	root.version = '3.0.0';
	root.encode = utf8encode;
	root.decode = utf8decode;

}( false ? this.utf8 = {} : exports));


/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.specialTrans=exports.formatToSpecial=exports.formatToScience=exports.formatToPercent=exports.formatToTime=exports.convertNumToChinese=exports.dataToChinese=exports.formatDate=exports.formatToDate=exports.convertFormatValue=exports.convertFloatValue=exports.checkLength=exports.realLength=exports.convertAmountChinese=exports.judgeIsNumber=undefined;var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _ecCom=__webpack_require__(752);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var judgeIsNumber=exports.judgeIsNumber=function judgeIsNumber(val){if(val===null||typeof val==="undefined")return false;var reg=/^(-?\d+)(\.\d+)?$/;return reg.test(val.toString());};var convertAmountChinese=exports.convertAmountChinese=function convertAmountChinese(num){if(!judgeIsNumber(num))return"";var amount_convert_unit="元";if(typeof num==="string")num=parseFloat(num);var prefh="";if(num<0){prefh="负";num=Math.abs(num);}if(num>Math.pow(10,12))return"";var cn="零壹贰叁肆伍陆柒捌玖";var unit=new Array("拾佰仟","分角");var unit1=new Array("万亿万","");var numArray=num.toString().split(".");var start=new Array(numArray[0].length-1,2);function toChinese(num,index){var num=num.replace(/\d/g,function($1){return cn.charAt($1)+unit[index].charAt(start--%4?start%4:-1);});return num;}for(var i=0;i<numArray.length;i++){var tmp="";for(var j=0;j*4<numArray[i].length;j++){var strIndex=numArray[i].length-(j+1)*4;var str=numArray[i].substring(strIndex,strIndex+4);var start=i?2:str.length-1;var tmp1=toChinese(str,i);tmp1=tmp1.replace(/(零.)+/g,"零").replace(/零+$/,"");tmp=tmp1+unit1[i].charAt(j-1)+tmp;}numArray[i]=tmp;}numArray[1]=numArray[1]?numArray[1]:"";numArray[0]=numArray[0]?numArray[0]+amount_convert_unit:numArray[0];numArray[1]=numArray[1].replace(/^零+/,"");numArray[1]=numArray[1].match(/分/)?numArray[1]:numArray[1]+"整";var money=numArray[0]+numArray[1];money=money.replace(/(亿万)+/g,"亿");if(money=="整"){money="零"+amount_convert_unit+"整";}else{money=prefh+money;}return money;};var realLength=exports.realLength=function realLength(str){var j=0;for(var i=0;i<=str.length-1;i++){j=j+1;if(str.charCodeAt(i)>127){j=j+2;}}return j;};var checkLength=exports.checkLength=function checkLength(str,strLen,elMaxLen){if(strLen<=elMaxLen){return str;}var j=0;for(var i=0;i<=str.length-1;i++){j=j+1;if(str.charCodeAt(i)>127){j=j+2;}if(j>elMaxLen){return str.substring(0,i);}if(j==elMaxLen){return str.substring(0,i+1);}}return str;};var convertFloatValue=exports.convertFloatValue=function convertFloatValue(realval,decimals,transQfw,transAbs,isfloor){if(!judgeIsNumber(realval))//非数值直接返回原始值
return realval;realval=realval.toString();var formatval="";if(decimals===0){//需取整
formatval=Math.round(parseFloat(realval)).toString();}else{var n=Math.pow(10,decimals);if(isfloor){var index=realval.indexOf(".");var intPar=index>-1?realval.substring(0,index):realval;var pointPar=index>-1?realval.substring(index):"";if(pointPar.length>decimals){pointPar=pointPar.substring(0,decimals+1);}formatval=''+intPar+pointPar;}else{formatval=(Math.round(parseFloat(realval)*n)/n).toString();}var pindex=formatval.indexOf(".");var pointLength=pindex>-1?formatval.substr(pindex+1).length:0;//当前小数位数
if(decimals>pointLength){//需补零
if(pindex==-1)formatval+=".";for(var i=0;i<decimals-pointLength;i++){formatval+="0";}}}var index=formatval.indexOf(".");var intPar=index>-1?formatval.substring(0,index):formatval;var pointPar=index>-1?formatval.substring(index):"";//取绝对值
if(transAbs===true){//取绝对值
intPar=Math.abs(intPar).toString();}if(transQfw===true){//整数位format成千分位
var reg1=/(-?\d+)(\d{3})/;while(reg1.test(intPar)){intPar=intPar.replace(reg1,"$1,$2");}}formatval=intPar+pointPar;return formatval;};var convertFormatValue=exports.convertFormatValue=function convertFormatValue(realval,formatJSON){try{var formatval="";var numberType=parseInt(formatJSON["numberType"]);if(numberType===1){//1常规
}else if(numberType===2){//2数值
var transQfw=parseInt(formatJSON["thousands"]||0)===1;var transAbs=formatJSON["formatPattern"]=="3"||formatJSON["formatPattern"]=="4";if(parseInt(formatJSON["decimals"])<0){return realval;}formatval=convertFloatValue(realval,parseInt(formatJSON["decimals"]),transQfw,transAbs);}else if(numberType===3){//3日期
//formatval = this.formatToDate(realval,formatJSON["formatPattern"]);
formatval=_ecCom.WeaTools.formatDate(realval,formatJSON["formatPattern"]);}else if(numberType===4){//4时间
//formatval = this.formatToTime(realval,formatJSON["formatPattern"]);
formatval=_ecCom.WeaTools.formatTime(realval,formatJSON["formatPattern"]);}else if(numberType===5){//5百分比
formatval=formatToPercent(realval,formatJSON["decimals"]);}else if(numberType===6){//6科学计数
formatval=formatToScience(realval,formatJSON["decimals"]);}else if(numberType===7){//7文本
}else if(numberType===8){//8特殊
formatval=formatToSpecial(realval,formatJSON["formatPattern"]);}return formatval;}catch(e){if(window.console){}return realval;}};var formatToDate=exports.formatToDate=function formatToDate(realVal,formatPattern){var pattern=new RegExp("^\\d{2,4}-\\d{1,2}-\\d{1,2}$");if(!pattern.test(realVal)){return realVal;}/**
   * formatPattern
   * 1：yyyy/MM/dd
   * 2：yyyy-MM-dd
   * 3：yyyy年MM月dd日
   * 4：yyyy年MM月
   * 5：MM月dd日
   * 6：EEEE
   * 7：日期大写
   * 8：yyyy/MM/dd hh:mm a
   * 9：yyyy/MM/dd HH:mm
   */var arr=realVal.split("-");var year=arr[0];var month=arr[1];var day=arr[2];if(parseInt(month)>12||parseInt(day)>31||parseInt(year)<=0||parseInt(month)<=0||parseInt(day)<=0){return realVal;}if(year.length==2)year="00"+year;if(year.length==3)year="0"+year;if(month.length==1)month="0"+month;if(day.length==1)day="0"+day;realVal=year+"-"+month+"-"+day;if(new Date(realVal).toString().indexOf("undefined")>-1){//解决IE下类似不存在的日期2014-9-31通过new Date无法生成日期问题，chrome下默认取的下一天
return realVal;}switch(parseInt(formatPattern)){case 1:return undefined.formatDate(new Date(realVal),"yyyy/MM/dd");case 2:return undefined.formatDate(new Date(realVal),"yyyy-MM-dd");case 3:return undefined.formatDate(new Date(realVal),"yyyy年MM月dd日");case 4:return undefined.formatDate(new Date(realVal),"yyyy年MM月");case 5:return undefined.formatDate(new Date(realVal),"MM月dd日");case 6:return undefined.formatDate(new Date(realVal),"wwww");case 7:return undefined.dataToChinese(new Date(realVal));case 8:return undefined.formatDate(new Date(realVal),"yyyy/MM/dd 12:00 a");case 9:return undefined.formatDate(new Date(realVal),"yyyy/MM/dd 00:00");default:return realVal;}};var formatDate=exports.formatDate=function formatDate(date,fmt){fmt=fmt||'yyyy-MM-dd HH:mm:ss';var obj={'y':date.getFullYear(),// 年份，注意必须用getFullYear
'M':date.getMonth()+1,// 月份，注意是从0-11
'd':date.getDate(),// 日期
'q':Math.floor((date.getMonth()+3)/3),// 季度
'w':date.getDay(),// 星期，注意是0-6
'H':12,// 24小时制
'h':12,// 12小时制
'm':0,// 分钟
's':0,// 秒
'S':0,// 毫秒
'a':'AM'};var week=['天','一','二','三','四','五','六'];for(var i in obj){fmt=fmt.replace(new RegExp(i+'+','g'),function(m){var val=obj[i]+'';if(i=='a')return val;if(i=='w')return(m.length>2?'星期':'周')+week[val];for(var j=0,len=val.length;j<m.length-len;j++){val='0'+val;}return m.length==1?val:val.substring(val.length-m.length);});}return fmt;};var dataToChinese=exports.dataToChinese=function dataToChinese(date){var arr=["〇","一","二","三","四","五","六","七","八","九"];var year=date.getFullYear();var month=date.getMonth()+1;var day=date.getDate();var tempYear=year.toString().split('').map(function(o){return arr[parseInt(o)];}).toString();return(tempYear+"年"+convertNumToChinese(month)+"月"+convertNumToChinese(day)+"日").replace(/\,/g,'');};var convertNumToChinese=exports.convertNumToChinese=function convertNumToChinese(num){var arr1=["","","二","三"];var arr2=["","一","二","三","四","五","六","七","八","九"];num=num<10?"0"+num.toString():num.toString();var first=parseInt(num.toString().split("")[0]);var second=parseInt(num.toString().split("")[1]);return arr1[first]+(first>0?"十":"")+arr2[second];};var formatToTime=exports.formatToTime=function formatToTime(realVal,formatPattern){var pattern=new RegExp("^(\\d{1,2}:\\d{1,2})(:\\d{1,2})?$");if(!pattern.test(realVal)){return realVal;}/**
   * formatPattern
   * 1：HH:MI:SS
   * 2：HH:MI:SS AM/PM
   * 3：HH:MI
   * 4：HH:MI AM/PM
   * 5：HH时MI分SS秒
   * 6：HH时MI分
   * 7：HH时MI分SS秒 AM/PM
   * 8：HH时MI分 AM/PM
   **/var realValArr=realVal.split(":");var hour=realValArr[0];var minute=realValArr[1];var separatorChar=":";var suffix=parseInt(hour)<12?" AM":" PM";switch(parseInt(formatPattern)){case 1:return hour+separatorChar+minute+separatorChar+"00";case 2:return hour+separatorChar+minute+separatorChar+"00"+suffix;case 3:return hour+separatorChar+minute;case 4:return hour+separatorChar+minute+suffix;case 5:return hour+"时"+minute+"分00秒";case 6:return hour+"时"+minute+"分";case 7:return hour+"时"+minute+"分00秒"+suffix;case 8:return hour+"时"+minute+"分"+suffix;default:return realVal;}};var formatToPercent=exports.formatToPercent=function formatToPercent(realVal,decimals){//转百分比
var pattern=new RegExp("^(-?\\d+)(\\.\\d+)?$");if(!pattern.test(realVal)){return realVal;}return convertFloatValue(Number(realVal)*100,parseInt(decimals),false)+"%";};var formatToScience=exports.formatToScience=function formatToScience(realVal,decimals){//转科学计数
var pattern=new RegExp("^(-?\\d+)(\\.\\d+)?$");if(!pattern.test(realVal)){return realVal;}var result=Number(realVal).toExponential(decimals).toUpperCase();result=result.replace(/E(\+|-)(\d){1}$/,"E$10$2");//补零
return result;};var formatToSpecial=exports.formatToSpecial=function formatToSpecial(realVal,formatPattern){var pattern=new RegExp("^(-?\\d{1,12})(\\.\\d+)?$");if(!pattern.test(realVal)){return realVal;}if(parseInt(formatPattern)===1){var digit=["〇","一","二","三","四","五","六","七","八","九"];var unit=[["","万","亿"],["","十","百","千"]];return specialTrans(realVal,digit,unit);}else{var _digit=["零","壹","贰","叁","肆","伍","陆","柒","捌","玖"];var _unit=[["","万","亿"],["","拾","佰","千"]];return specialTrans(realVal,_digit,_unit);}};var specialTrans=exports.specialTrans=function specialTrans(realVal,digit,unit){realVal=parseFloat(realVal).toString();if(parseFloat(realVal)===0){return digit[0];}var headfix="";var intPar_t="";var pointPar_t="";if(parseFloat(realVal)<0){realVal=realVal.substring(1);headfix="-";}var realValArr=realVal.split(".");var intPar=(0,_trim2.default)(realValArr[0]);while(intPar.length>0&&parseInt(intPar[0])===0){intPar=intPar.substr(1);}var pointPar=realValArr.length===2?(0,_trim2.default)(realValArr[1]):"";var lastflag=false;var intParArr=intPar.length>0?intPar.toString().split(''):[];var pointParArr=pointPar.length>0?pointPar.toString().split(''):[];var j=0;pointPar_t=pointPar.length>0?".":pointPar_t;pointParArr.map(function(v){pointPar_t=pointPar_t+digit[parseInt(v)];});for(var i=intParArr.length-1;i>=0;i--,j++){var v=parseInt(intParArr[i]);var m=j%4;if(m===0){lastflag=false;intPar_t=unit[0][j/4]+intPar_t;}if(v===0){if(lastflag&&intPar_t[0]===digit[0]){intPar_t=digit[v]+intPar_t;}}else{lastflag=true;intPar_t=digit[v]+unit[1][m]+intPar_t;}}intPar_t=(0,_trim2.default)(intPar_t).length===0?digit[0]:intPar_t;return headfix+intPar_t+pointPar_t;};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_752__;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var React=_interopRequireWildcard(_react);var _antd=__webpack_require__(8);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _jsBase=__webpack_require__(138);var _weaInput=__webpack_require__(56);var _weaInput2=_interopRequireDefault(_weaInput);var _weaError=__webpack_require__(82);var _weaError2=_interopRequireDefault(_weaError);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);var _isArray=__webpack_require__(21);var _isArray2=_interopRequireDefault(_isArray);__webpack_require__(754);var _util=__webpack_require__(755);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var LANG={PREFIX:"~`~`",SPLITTER:"`~`",SUFFIX:"`~`~"};var WeaInputLocale=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaInputLocale,_React$Component);function WeaInputLocale(props){(0,_classCallCheck3.default)(this,WeaInputLocale);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaInputLocale.__proto__||(0,_getPrototypeOf2.default)(WeaInputLocale)).call(this,props));_this.getLanguageidweaver=function(){var localeLanguageId=window.localStorage.getItem("languageidweaver")||_this.state.languageidweaver;if(isNaN(Number(localeLanguageId))){localeLanguageId=_this.state.languageidweaver;}return localeLanguageId;};_this.updatePropsValue=function(value){var nextProps=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var localeLanguageId=_this.getLanguageidweaver();var list=_this.state.list;if(value&&nextProps.isBase64&&value.indexOf("base64_")>-1){// remove base64_
value=_jsBase.Base64.decode(value.substr(7));typeof _this.props.onChange==="function"&&_this.props.onChange(value);typeof _this.props.onBlur==="function"&&_this.props.onBlur(value);}// console.log('update props', list, value);
if(value&&value.indexOf(LANG.PREFIX)>-1){// 多值
value=value.substring(4);value=value.substring(0,value.length-4);var tempArray=value.split(LANG.SPLITTER);// console.log(this.props.value)
// console.log("list", list);
// console.log(tempArray);
var tempArrayKeys=[];tempArray.forEach(function(item){var key=item.substr(0,2).replace(/\s/g,"");tempArrayKeys.push(key);var value=item.substr(2);// console.log(item);
// console.log("73", list, key);
// 2019.1.22 去掉在这里更新 state list 的内容，会触发重绘
if(list.hasOwnProperty(key)){// 值在 active langeuage里面，就更新
list[key]=(0,_trim2.default)(item.substr(2));}if(localeLanguageId==key){// console.log(tempArray, key, value)
_this.setState({value:value});}});(0,_keys2.default)(list).forEach(function(item){if(!tempArrayKeys.includes(item)){list[item]="";}});// console.log(list);
}else{// 单值
(0,_keys2.default)(list).forEach(function(item){list[item]="";});// 如果只存在一个值，那么组件默认该值为单值，并且默认该值属于默认语言
list[localeLanguageId]=value;_this.setState({value:value});}// if (nextProps.value !== this.props.value) {
var resultValue=_this.getResultValue(list,localeLanguageId,"propUpdate");_this.setState({resultValue:resultValue});// }
};_this.confirm=function(){_this.setState({visible:false});// console.log('pass resultvalue to onblur', this.state.resultValue, this.state);
typeof _this.props.onBlur==="function"&&_this.props.onBlur(_this.state.resultValue);typeof _this.props.onChange==="function"&&_this.props.onChange(_this.state.resultValue);typeof _this.props.onOk==="function"&&_this.props.onOk(_this.state.resultValue);};_this.cancel=function(){_this.setState({visible:false});};_this.toggleClick=function(e){var visible=_this.state.visible;e.stopPropagation();_this.setState({visible:!visible});};_this.updateMultiLang=function(e,id){var localeLanguageId=_this.getLanguageidweaver();var list=_this.state.list;var value="";if(e.target){value=e.target.value;}else{value=e;}list[id]=value;var resultValue=_this.validateLength(function(){return _this.getResultValue(list,id);},id);// console.log(list, resultValue);
_this.props.onChange&&_this.props.onChange(resultValue);_this.props.onBlur&&_this.props.onBlur(resultValue);_this.setState({value:list[localeLanguageId],resultValue:resultValue});};_this.getResultValue=function(list,id,source){var resultValue="";if(source!=="propUpdate"){if((0,_keys2.default)(list).includes("7")&&(0,_keys2.default)(list).includes("9")){list=_this.handleTraditionalizedorSimplized(list,id);}}// console.log(list);
var temp=[];(0,_keys2.default)(list).reverse().forEach(function(id){_this.setState({value:list[id]});if(list[id]!==""){temp.push(id+" "+(0,_trim2.default)(list[id]));}});// console.log('temp', temp, 'list', list, 'id', id);
if(temp.length===1){resultValue=temp.toString().substr(2);}else if(temp.length===0){resultValue="";}else{resultValue=LANG.PREFIX+temp.reverse().join(LANG.SPLITTER)+LANG.SUFFIX;}return resultValue;};_this.handleTraditionalizedorSimplized=function(list,id){if(_this.state.visible){if(id==="7"&&list["7"]){list[9]=(0,_util.Traditionalized)(list[id]);}_this.setState({list:list});}return list;};_this.popOverChange=function(v){_this.setState({visible:v});if(v===false){_this.confirm();}};_this.onKeyDown=function(e){if(e.keyCode==13){var _this$props=_this.props,onEnter=_this$props.onEnter,onEnterSearch=_this$props.onEnterSearch;var value=e.target.value;typeof onEnterSearch==="function"&&onEnterSearch(value);// 高级搜索传参
typeof onEnter==="function"&&onEnter(value);}};_this.state={visible:false,resultValue:"",value:"",list:{},languageidweaver:"7",errorMsg:""};return _this;}(0,_createClass3.default)(WeaInputLocale,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var activeLanguageIds=window.localStorage.getItem("activeLanguageIds")||"['7']";// activeLanguageIds = JSON.stringify([
//   "7",
//   "8",
//   // "9",
//   // "12",
//   // "13",
//   // "14",
//   "15",
//   // "16",
//   // "17",
//   // "18"
// ]);
try{activeLanguageIds=JSON.parse(activeLanguageIds);}catch(error){console.error("请检查 localStorage",error);activeLanguageIds=["7"];}activeLanguageIds=(0,_isArray2.default)(activeLanguageIds)?activeLanguageIds:["7"];var list={};activeLanguageIds.forEach(function(item,index){list[item]="";});this.setState({list:list},function(){if(_this2.props.hasOwnProperty("value")&&_this2.props.value!==undefined){_this2.updatePropsValue(_this2.props.value,_this2.props);}});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// value 回显处理
if("value"in nextProps){// console.log(nextProps.value, " | ", this.props.value)
var value=nextProps.value||"";if(nextProps.value!==this.props.value||value.indexOf("base64_")>-1){this.updatePropsValue(nextProps.value,nextProps);}}}},{key:"validateLength",value:function validateLength(cb,id){var _this3=this;var list=this.state.list;var i18nLengthValidate=this.props.i18nLengthValidate;var currentLabel=list[id];// 有验证规则
if(i18nLengthValidate&&i18nLengthValidate.hasOwnProperty("maxLength")){var langKinds=(0,_keys2.default)(list).length;var limitLength=Number(i18nLengthValidate.maxLength);var reg=/^[a-z0-9\s]+$/i;var bolRes=reg.test(currentLabel);// 数字除 1 中文除 2
var divisor=bolRes?1:2;var perLangLength=Math.floor(limitLength/langKinds/divisor);if(currentLabel.length>perLangLength){// 提示错误信息
this.setState({errorMsg:""+getLabel("506875","名称长度不能超过")+perLangLength+getLabel("391259","字符")},function(){_this3.refs.weaError.showError();});// 截取字符，处理受控
list[id]=currentLabel.substring(0,perLangLength);// 这里需要强制更新，可能是WeaInput受控没有处理好，导致截取了以后UI没有变化，但是实际state已经改变
this.setState({list:list},function(){_this3.forceUpdate();});return this.getResultValue(list,id);}else{return cb();}// 无验证规则
}else{return cb();}}},{key:"render",value:function render(){var _this4=this;var localeLanguageId=this.getLanguageidweaver();var _state=this.state,list=_state.list,value=_state.value,resultValue=_state.resultValue;var _props=this.props,viewAttr=_props.viewAttr,style=_props.style,customBlur=_props.customBlur,ecId=_props.ecId,_props$className=_props.className,className=_props$className===undefined?"":_props$className;var i18nLengthValidate=this.props.i18nLengthValidate;var renderContent=(0,_keys2.default)(list).map(function(item,index){return React.createElement("label",{key:index,className:"wea-input-locale-popover-content-label"},React.createElement("img",{className:"wea-input-locale-popover-content-label-img",src:(window.ecologyContentPath||"")+"/images/ecology9/multiLang/multilang_"+item+".png",alt:""}),React.createElement(_antd.Input,{ecId:ecId+"_Input@jdtsl8@"+index,value:list[item],onChange:function onChange(e){return _this4.updateMultiLang(e,item);},className:"wea-input-locale-popover-content-label-input",onBlur:function onBlur(e){list[item]=(0,_trim2.default)(list[item]);var resultValue=_this4.getResultValue(list,item);_this4.setState({list:list,resultValue:resultValue});typeof customBlur==="function"&&customBlur(resultValue);},onKeyDown:_this4.onKeyDown}));});var content=React.createElement("div",null,renderContent,React.createElement("hr",{style:{marginTop:10,marginBottom:10,border:"1px solid #eee"}}),React.createElement("div",{className:"wea-input-locale-popover-button-group"},React.createElement(_antd.Button,{ecId:ecId+"_Button@wvluat",style:{marginRight:10},onClick:this.confirm,type:"primary"},getLabel("33703","确认")),React.createElement(_antd.Button,{ecId:ecId+"_Button@sm83n5",onClick:this.cancel},getLabel("31129","取消"))));// 防止死循环调用
var props=this.props;delete props.inputType;// console.log(this.props);
// console.log('render', list, localeLanguageId);
// console.log(resultValue);
if(viewAttr=="1"){return React.createElement(_weaInput2.default,(0,_extends3.default)({},props,{ecId:ecId+"_WeaInput@jr0x9g",defaultValue:list[localeLanguageId],value:list[localeLanguageId]}));}if(i18nLengthValidate===undefined){i18nLengthValidate={};}return React.createElement("div",{className:"wea-input-locale-container "+className,style:style},React.createElement("div",{className:"wea-default-input-locale"},React.createElement(_weaError2.default,{ecId:ecId+"_WeaError@dcyxgt",style:{width:"100%"},tipPosition:i18nLengthValidate.tipPosition||"top",error:this.state.errorMsg+(i18nLengthValidate.errorMessage||""),ref:"weaError"},React.createElement(_weaInput2.default,(0,_extends3.default)({},props,{ecId:ecId+"_WeaInput@umxz0g",style:{},onChange:function onChange(e){return _this4.updateMultiLang(e,localeLanguageId.toString());},defaultValue:list[localeLanguageId],value:list[localeLanguageId]// 标记 WeaInput 处于 WeaInputLocale 中
,modeSource:"weaInputLocale"// 有些组件会触发onBlur导致点击清空数据
,onBlur:function onBlur(e){typeof customBlur==="function"&&customBlur(_this4.getResultValue(list,localeLanguageId));}})))),React.createElement("div",{ecId:ecId+"_div@0byy97",ref:function ref(_ref){return _this4.ref=_ref;},onClick:function onClick(e){return _this4.toggleClick(e);},className:"wea-input-locale-input"// style={style}
},React.createElement(_antd.Popover,{ecId:ecId+"_Popover@zm1twn",onVisibleChange:function onVisibleChange(v){return _this4.popOverChange(v);},visible:this.state.visible,trigger:"click",placement:"bottom",content:content,overlayStyle:{width:this.ref&&(this.ref.clientWidth<224?224:this.ref.clientWidth)// left: 0, top: 30,
}},React.createElement("div",null,resultValue&&resultValue.indexOf(LANG.PREFIX)>-1?React.createElement("div",{"class":"wea-input-locale-earth-icon"},React.createElement(_antd.Tooltip,{ecId:ecId+"_Tooltip@q39vab",placement:"right",title:getLabel("385819","已设置多语言")},React.createElement("img",{src:(window.ecologyContentPath||"")+"/images/ecology9/multiLang/seted-multi-lang.png",alt:""}))):React.createElement("div",{"class":"wea-input-locale-earth-icon"},React.createElement(_antd.Tooltip,{ecId:ecId+"_Tooltip@g0f2lx",placement:"right",title:getLabel("385828","未设置多语言")},React.createElement("img",{src:(window.ecologyContentPath||"")+"/images/ecology9/multiLang/unset-multi-lang.png",alt:""})))))));}}]);return WeaInputLocale;}(React.Component),_class.getList=function(multiStr,cb){if(cb&&typeof cb==="function"){var list={};if(multiStr.indexOf(LANG.PREFIX)>-1){multiStr=multiStr.substring(4);multiStr=multiStr.substring(0,multiStr.length-4);multiStr.split(LANG.SPLITTER).map(function(item){list[item.substr(0,2)]=item.substr(2);});}else{return multiStr;}var resultObj=cb(list);var resultArr=(0,_keys2.default)(resultObj).map(function(item){return item+resultObj[item];});return LANG.PREFIX+resultArr.join(LANG.SPLITTER)+LANG.SUFFIX;}return multiStr;},_class.getCurrentLabel=function(multiStr,langId){var localeLanguageId=langId||window.localStorage.getItem("languageidweaver")||"7";var list={};if(typeof multiStr==="string"&&multiStr.indexOf(LANG.PREFIX)>-1){multiStr=multiStr.substring(4);multiStr=multiStr.substring(0,multiStr.length-4);multiStr.split(LANG.SPLITTER).map(function(item){list[item.substr(0,2).replace(" ","")]=item.substr(2);});return list[localeLanguageId]?list[localeLanguageId]:"";}else{return multiStr;}},_class.getMultiStrFromBase64=function(){var baseStr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";if(baseStr.indexOf("base64_")>-1){var resultMulti="";resultMulti=baseStr.substr(7);return _jsBase.Base64.decode(resultMulti);}else{return baseStr;}},_class.ref={},_temp);exports.default=WeaInputLocale;

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});function JTPYStr(){return'锕锿皑嗳蔼霭爱嫒碍暧瑷庵谙鹌鞍埯铵暗暗翱翱鳌鳌袄媪岙奥骜钯坝坝罢鲅霸摆呗败稗颁坂板钣办绊帮绑榜膀谤镑龅褒宝饱鸨褓报鲍杯杯鹎贝狈备背钡悖惫辈鞴奔奔贲锛绷绷逼秕笔币毕闭哔荜毙铋筚滗痹跸辟弊边笾编鳊贬变缏辩辫标飑骠膘镖飙飙飚镳表鳔鳖鳖别别瘪宾宾傧滨缤槟镔濒摈殡膑髌鬓鬓冰饼禀并并并拨剥钵钵饽驳驳钹铂博鹁钸卜补布钚财采采采彩睬踩参参参骖残蚕惭惭惨黪灿仓伧沧苍舱操艹册侧厕厕恻测策策层插馇锸查察镲诧钗侪虿觇掺搀婵谗禅馋缠蝉镡产产谄铲铲阐蒇冁忏颤伥阊鲳长肠苌尝尝偿厂厂场场怅畅钞车砗扯彻尘陈谌谌碜碜闯衬称龀趁榇谶柽蛏铛撑枨诚乘铖惩塍澄骋吃鸱痴驰迟齿耻饬炽敕冲冲虫宠铳俦帱绸畴筹酬酬酬踌雠雠丑瞅出刍厨锄锄雏橱蹰础储处处绌触传船钏囱疮窗窗窗床创怆捶棰锤锤春纯唇莼莼淳鹑醇绰辍龊词辞辞鹚鹚糍赐从匆匆苁枞葱骢聪丛丛凑辏粗粗蹴撺镩蹿窜篡脆村鹾锉错哒达沓鞑呆绐带玳贷单担郸殚瘅箪胆掸诞啖啖弹惮当当当裆挡挡党谠凼砀荡荡档导岛捣捣祷焘盗锝德灯邓凳镫堤镝籴敌涤觌诋抵抵递谛缔蒂颠巅癫点电垫钿淀雕雕雕鲷吊钓调铞谍喋叠叠叠蝶鲽钉顶订碇碇锭丢铥东冬岽岽鸫动冻峒栋胨兜斗斗斗钭豆窦读渎渎椟椟牍犊黩独笃赌睹妒镀端断缎煅锻簖队对兑怼镦吨墩趸炖钝顿遁夺铎朵垛缍堕跺讹讹峨锇鹅鹅额婀厄厄轭垩恶恶饿谔阏萼腭锷鹗颚鳄鳄儿鸸鲕尔迩饵铒贰发发罚罚阀法珐帆翻翻凡矾钒烦繁泛泛饭范贩钫鲂仿仿仿访纺飞绯鲱诽废费痱镄纷氛坟奋偾愤粪鲼丰风沣枫疯砜峰锋冯缝讽凤佛夫肤麸麸凫绂绋辐幞呒抚俯俯辅讣妇负附驸复复赋缚鲋赙鳆钆嘎该赅丐丐钙盖概干干杆尴尴秆赶绀赣冈刚岗纲肛钢杠戆皋槔糕缟稿镐诰锆纥胳鸽搁歌阁镉个个铬给亘耕赓绠鲠鲠宫躬龚巩贡沟钩钩缑构构诟购够觏轱鸪毂鹘诂谷钴蛊鹄鼓顾雇锢鲴刮鸹剐诖挂拐拐怪关关观鳏馆馆管管贯惯掼鹳罐广犷归妫妫龟规规闺瑰鲑轨匦诡刽刿柜贵鳜衮绲辊滚鲧鲧呙埚锅蝈国国帼掴果椁过铪骇顸函韩汉悍焊焊颔绗颃蚝嗥号皓皓颢灏诃合合和阂核盍颌阖贺鹤恒横轰哄红闳荭鸿黉讧糇鲎呼呼呼轷胡胡壶鹕糊浒户冱护沪鹱花花华哗哗骅铧划画话桦怀坏欢欢獾还环锾缳缓奂唤换涣焕痪鲩黄鳇恍谎诙咴挥晖珲辉辉徽回回回回蛔蛔蛔蛔汇汇汇会讳哕浍绘荟诲桧烩贿秽缋毁毁毁昏荤阍浑馄诨锪钬货获获祸镬讥击叽饥饥机玑矶鸡鸡迹迹积绩绩缉赍赍跻齑羁级极楫辑几虮挤计记纪际剂哜济继觊蓟霁鲚鲫骥夹夹浃家镓郏荚铗蛱颊贾钾价驾戋奸坚歼间艰监笺笺缄缣鲣鹣鞯拣枧俭茧捡笕减检睑裥锏简谫戬碱碱见饯剑剑荐贱涧舰渐谏溅践鉴鉴鉴键槛姜将浆僵缰缰讲奖桨蒋绛酱娇浇骄胶鲛鹪侥挢绞饺矫脚铰搅剿缴叫峤轿较阶阶疖秸节讦劫劫劫杰诘洁结颉鲒届诫斤仅卺紧谨锦馑尽尽劲进荩晋烬赆赆缙觐泾经茎荆惊鲸阱刭颈净弪径径胫痉竞靓静镜迥炯纠鸠阄揪韭旧厩厩救鹫驹锔局局举举榉龃讵钜剧惧据飓锯窭屦鹃镌镌卷锩倦桊狷绢隽眷决诀珏绝觉谲橛镢镢军钧皲俊浚骏咔开锎凯剀垲恺铠慨锴忾龛坎侃阚瞰糠糠闶炕钪考铐轲疴钶颏颗壳咳克克课骒缂锞肯垦恳坑铿抠眍叩扣寇库绔喾裤夸块侩郐哙狯脍宽髋款诓诳邝圹纩况旷矿矿贶亏岿窥窥匮愦愧溃蒉馈馈篑聩坤昆昆锟鲲捆捆阃困扩阔阔腊蜡辣来崃徕涞莱铼赉睐赖赖濑癞籁兰岚拦栏婪阑蓝谰澜褴斓篮镧览揽缆榄懒懒烂滥琅锒螂阆捞劳唠崂痨铹铑涝耢乐鳓缧镭诔垒泪类累棱厘梨狸离骊犁鹂漓缡蓠璃璃鲡篱藜礼里里逦锂鲤鳢历历历厉丽励呖坜沥苈枥疠隶隶俪栎疬疬荔轹郦栗砺砾莅莅粝蛎跞雳俩奁奁奁奁连帘怜涟莲联裢廉鲢镰敛敛琏脸裣蔹练娈炼炼恋殓链潋凉梁粮两魉谅辆辽疗缭镣鹩钌猎邻邻临淋辚磷磷鳞麟凛廪懔檩吝赁蔺躏灵灵岭凌铃棂棂绫菱龄鲮领溜刘浏留琉琉馏骝瘤镏柳柳绺锍鹨龙咙泷茏栊珑胧砻笼聋陇垄垄拢娄偻喽蒌楼耧蝼髅嵝搂篓瘘瘘镂噜撸卢庐芦垆垆泸炉炉栌胪轳鸬舻颅鲈卤卤虏掳鲁橹橹橹镥陆录赂辂渌禄滤戮辘鹭氇驴闾榈吕侣稆铝屡缕褛虑绿孪峦挛栾鸾脔滦銮乱略锊抡仑仑伦囵沦纶轮论罗罗猡脶萝逻椤锣箩骡骡镙裸裸泺络荦骆妈嬷麻蟆马犸玛码蚂杩骂骂唛吗买荬劢迈麦卖脉脉颟蛮馒瞒鳗满螨谩缦镘猫牦牦锚铆冒贸帽帽么没梅梅镅鹛霉镁门扪钔闷焖懑们蒙蒙蒙锰梦弥弥祢猕谜芈眯觅觅秘幂谧绵绵黾缅腼面面面鹋缈妙庙咩灭蔑珉缗缗闵泯闽悯愍鳘鸣铭谬缪谟馍馍模殁蓦镆谋亩钼幕拿拿镎内纳钠乃乃奶难楠楠馕挠铙蛲垴恼脑闹闹讷馁嫩铌霓鲵你拟昵腻鲇鲶捻辇撵念娘酿鸟茑袅袅袅捏陧聂啮啮嗫镊镍颞蹑孽宁咛拧狞柠聍泞纽钮农农侬哝浓脓弄驽钕疟暖暖傩诺锘讴欧殴瓯鸥呕怄沤盘盘蹒庞刨刨狍炮炮疱胚赔锫佩辔喷鹏碰碰纰铍毗罴骈谝骗骗缥飘飘贫嫔频颦评凭凭苹瓶鲆钋泼颇钷迫仆扑铺铺镤朴谱镨凄凄栖桤戚戚齐脐颀骐骑棋棋蛴旗蕲鳍岂启启绮气讫弃荠碛憩千扦迁佥钎牵悭铅谦愆签签骞荨钤钱钳乾乾潜浅肷谴缱堑椠呛羌戗枪跄锖锵镪强强墙墙嫱蔷樯樯抢羟襁襁炝硗硗跷锹锹缲乔侨荞桥谯憔憔鞒诮峭窍翘窃惬箧锲亲钦琴勤锓寝吣揿揿氢轻倾鲭苘顷请庆穷茕琼丘秋秋鳅鳅虬球赇巯区曲曲岖诎驱驱躯趋鸲癯龋阒觑觑觑权诠辁铨蜷颧绻劝却悫悫确阕阙鹊榷裙裙群冉让荛饶桡扰娆绕热认纫妊轫韧韧饪绒绒绒荣嵘蝾融冗铷颥缛软软蕊蕊蕊锐睿闰润箬洒飒萨腮鳃赛毵伞伞糁馓颡丧骚缫鳋扫涩涩啬铯穑杀纱铩鲨筛晒删姗钐膻闪陕讪骟缮膳赡鳝鳝伤殇觞垧赏绱烧绍赊蛇舍厍设慑慑摄滠绅诜审审谂婶渖肾渗升升声胜渑绳圣剩尸师虱诗狮湿湿酾鲺时识实蚀埘莳鲥驶势视视视试饰是柿贳适轼铈谥谥释寿寿兽绶书纾枢倏倏疏摅输赎薯术树竖竖庶数漱帅闩双谁税顺说说烁铄硕丝咝鸶缌蛳厮锶似祀饲驷俟松怂耸讼诵颂搜馊飕锼擞薮苏苏苏稣诉肃谡溯溯酸虽绥随岁岁谇孙狲荪飧损笋挲蓑缩唢琐锁它铊塔獭鳎挞闼骀台台台抬鲐态钛贪摊滩瘫坛坛坛坛坛昙谈锬谭袒钽叹叹赕汤铴镗饧糖傥烫趟涛绦绦绦掏韬鼗鼗讨铽腾誊藤锑绨啼缇鹈题蹄体体屉剃剃阗条龆鲦眺粜铫贴铁铁铁厅厅听听烃铤同铜统筒恸偷偷头秃图涂涂钍兔团团抟颓颓颓腿蜕饨臀托拖脱驮驼鸵鼍椭拓箨洼娲蛙袜袜腽弯湾纨玩顽挽绾碗碗万亡网往辋望为为韦围帏沩沩违闱涠维潍伟伪伪纬苇炜玮诿韪鲔卫卫谓喂喂猬温纹闻蚊蚊阌吻稳问瓮瓮挝涡莴窝蜗卧龌乌污污邬呜诬钨无吴芜坞坞妩妩庑忤怃鹉务误骛雾鹜诶牺晰溪锡嘻膝习席袭觋玺铣戏戏系系饩细郄阋舄虾侠峡狭硖辖辖吓厦仙纤纤籼莶跹锨鲜闲闲弦贤咸娴娴衔衔痫鹇鹇鹇显险猃蚬藓县岘苋现线线宪馅羡献乡乡芗厢缃骧镶详享响饷飨鲞向向项枭哓骁绡萧销潇箫嚣嚣晓筱效效啸啸蝎协邪胁胁挟谐携携撷缬鞋写泄泻绁绁绁亵谢蟹欣锌衅兴陉幸凶汹胸修鸺馐绣绣锈锈须须顼虚嘘许诩叙叙恤恤勖绪续婿溆轩谖喧萱萱萱萱悬旋璇选癣绚铉楦靴学泶鳕谑勋勋埙埙熏寻巡驯询浔鲟训讯徇逊丫压鸦鸦桠鸭哑痖亚讶垭娅氩咽恹恹烟胭阉腌讠闫严岩岩岩盐阎颜颜檐兖俨厣演魇鼹厌彦砚艳艳验验谚焰雁滟滟酽谳餍燕燕燕赝赝鸯扬扬扬阳杨炀疡养痒样夭尧肴轺窑窑谣摇遥瑶鳐药药鹞耀爷铘野野业叶页邺夜晔烨烨谒靥医医咿铱仪诒迤饴贻移遗颐彝彝钇舣蚁蚁义亿忆艺议异呓呓译峄怿绎诣驿轶谊缢瘗镒翳镱因阴阴荫荫殷铟喑堙吟淫淫银龈饮隐瘾应莺莺婴嘤撄缨罂罂樱璎鹦鹰茔荥荧莹萤营萦滢蓥潆蝇赢颍颖瘿映哟佣拥痈雍墉镛鳙咏涌恿恿踊优忧犹邮莜莸铀游鱿铕佑诱纡余欤鱼娱谀渔嵛逾觎舆与伛屿俣语龉驭吁吁妪饫郁狱钰预欲谕阈御鹆愈愈蓣誉鹬鸢鸳渊员园圆缘鼋猿猿辕橼远愿约岳钥钥钥悦钺阅阅跃粤云匀纭芸郧氲陨殒运郓恽晕酝酝愠韫韵蕴匝杂杂灾灾灾载簪咱咱攒攒攒趱暂赞赞赞錾瓒赃赃赃驵脏脏葬糟凿枣灶皂唣噪则择泽责啧帻箦赜贼谮缯锃赠揸齄扎扎札札轧闸闸铡诈栅榨斋债沾毡毡谵斩盏崭辗占战栈绽骣张獐涨帐胀账钊诏赵棹照哲辄蛰谪谪辙锗这浙鹧贞针针侦浈珍桢砧祯诊轸缜阵鸩赈镇争征峥挣狰钲睁铮筝证证诤郑帧症卮织栀执侄侄职絷跖踯只只址纸轵志制帙帙帜质栉挚致贽轾掷鸷滞骘稚稚置觯踬终钟钟钟肿种冢众众诌周轴帚纣咒绉昼荮皱骤朱诛诸猪铢槠潴橥烛属煮嘱瞩伫伫苎注贮驻筑铸箸专砖砖砖颛转啭赚撰馔妆妆庄桩装壮状骓锥坠缀缒赘谆准桌斫斫斫浊诼镯镯兹兹赀资缁谘辎锱龇鲻姊渍眦综棕踪鬃鬃总总偬纵粽邹驺诹鲰镞诅组躜缵纂钻钻罪樽鳟';}function FTPYStr(){return'錒锿皚噯藹靄愛嬡礙曖璦庵諳鵪鞍埯銨暗暗翱翱鰲鰲襖媼嶴奧驁鈀壩壩罷鮁霸擺唄敗稗頒坂板鈑辦絆幫綁榜膀謗鎊齙褒寶飽鴇褓報鮑杯杯鵯貝狽備背鋇悖憊輩鞴奔奔賁錛繃繃逼秕筆幣畢閉嗶蓽斃鉍篳滗痺蹕闢弊邊籩編鯿貶變緶辯辮標颮驃膘鏢飆飆飚鑣表鰾鱉鱉別別癟賓賓儐濱繽檳鑌瀕擯殯臏髕鬢鬢冰餅禀並並並撥剝缽缽餑駁駁鈸鉑博鵓鈽卜補布钚財采采採彩睬踩參參參驂殘蠶慚慚慘黪燦倉傖滄蒼艙操艹冊側廁廁惻測策策層插馇鍤查察镲詫釵儕蠆覘摻攙嬋讒禪饞纏蟬鐔產產諂鏟鏟闡蕆囅懺顫倀閶鯧長腸萇嚐嚐償廠廠場場悵暢鈔車硨扯徹塵陳諶諶磣磣闖襯稱齔趁櫬讖檉蟶鐺撐棖誠乘鋮懲塍澄騁吃鴟痴馳遲齒恥飭熾敕沖沖蟲寵銃儔幬綢疇籌酬酬酬躊讎讎醜瞅出芻廚鋤鋤雛櫥躕礎儲處處絀觸傳船釧囪瘡窗窗窗床創愴捶棰錘錘春純唇蓴蓴淳鶉醇綽輟齪詞辭辭鶿鶿糍賜從匆匆蓯樅蔥驄聰叢叢湊輳粗粗蹴攛鑹躥竄篡脆村鹺銼錯噠達沓韃呆紿帶玳貸單擔鄲殫癉簞膽撣誕啖啖彈憚噹噹當襠擋擋黨讜氹碭蕩蕩檔導島搗搗禱燾盜锝德燈鄧凳鐙堤鏑糴敵滌覿詆抵抵遞諦締蒂顛巔癲點電墊鈿淀雕雕雕鯛吊釣調铞諜喋疊疊疊蝶鰈釘頂訂碇碇錠丟铥東冬岽岽鶇動凍峒棟腖兜鬥鬥鬥鈄豆竇讀瀆瀆櫝櫝牘犢黷獨篤賭睹妒鍍端斷緞煅鍛簖隊對兌懟鐓噸墩躉燉鈍頓遁奪鐸朵垛綞墮跺訛訛峨鋨鵝鵝額婀厄厄軛堊惡惡餓諤閼萼腭鍔鶚顎鱷鱷兒鴯鮞爾邇餌鉺貳發發罰罰閥法琺帆翻翻凡礬釩煩繁泛泛飯範販鈁魴仿仿仿訪紡飛緋鯡誹廢費痱鐨紛氛墳奮僨憤糞鱝豐風灃楓瘋砜峰鋒馮縫諷鳳佛夫膚麩麩鳧紱紼輻幞嘸撫俯俯輔訃婦負附駙复复賦縛鮒賻鰒钆嘎該賅丐丐鈣蓋概幹幹桿尷尷稈趕紺贛岡剛崗綱肛鋼槓戇皋槔糕縞稿鎬誥鋯紇胳鴿擱歌閣鎘個個鉻給亙耕賡綆鯁鯁宮躬龔鞏貢溝鉤鉤緱構構詬購夠覯軲鴣轂鶻詁谷鈷蠱鵠鼓顧僱錮鯝刮鴰剮詿掛拐拐怪關關觀鰥館館管管貫慣摜鸛罐廣獷歸媯媯龜規規閨瑰鮭軌匭詭劊劌櫃貴鱖袞緄輥滾鯀鯀呙堝鍋蟈國國幗摑果槨過鉿駭頇函韓漢悍焊焊頷絎頏蠔嗥號皓皓顥灝訶合合和閡核盍頜闔賀鶴恆橫轟哄紅閎葒鴻黌訌餱鱟呼呼呼轷胡胡壺鶘糊滸戶沍護滬鹱花花華嘩嘩驊鏵劃畫話樺懷壞歡歡獾還環鍰繯緩奐喚換渙煥瘓鯇黃鰉恍謊詼咴揮暉琿輝輝徽回回回回蛔蛔蛔蛔匯匯匯會諱噦澮繪薈誨檜燴賄穢繢毀毀毀昏葷閽渾餛諢锪钬貨獲獲禍鑊譏擊嘰飢飢機璣磯雞雞跡跡積績績緝齎齎躋齏羈級極楫輯幾蟣擠計記紀際劑嚌濟繼覬薊霽鱭鯽驥夾夾浹家鎵郟莢鋏蛺頰賈鉀價駕戔姦堅殲間艱監箋箋緘縑鰹鶼韉揀梘儉繭撿筧減檢瞼襉鐧簡譾戩鹼鹼見餞劍劍薦賤澗艦漸諫濺踐鑑鑑鑑鍵檻姜將漿僵韁韁講獎槳蔣絳醬嬌澆驕膠鮫鷦僥撟絞餃矯腳鉸攪剿繳叫嶠轎較階階癤秸節訐劫劫劫傑詰潔結頡鮚屆誡斤僅卺緊謹錦饉盡盡勁進藎晉燼贐贐縉覲涇經莖荊驚鯨阱剄頸淨弳徑徑脛痙競靚靜鏡迥炯糾鳩鬮揪韭舊厩厩救鷲駒鋦局局舉舉櫸齟詎鉅劇懼據颶鋸窶屨鵑鐫鐫卷錈倦桊狷絹雋眷決訣珏絕覺譎橛镢镢軍鈞皸俊浚駿咔開锎凱剴塏愷鎧慨鍇愾龕坎侃闞瞰糠糠閌炕鈧考銬軻疴鈳頦顆殼咳克克課騍緙錁肯墾懇坑鏗摳眍叩扣寇庫絝嚳褲誇塊儈鄶噲獪膾寬髖款誆誑鄺壙纊況曠礦礦貺虧巋窺窺匱憒愧潰蕢饋饋簣聵坤昆昆錕鯤捆捆閫困擴闊闊臘蠟辣來崍徠淶萊錸賚睞賴賴瀨癩籟蘭嵐攔欄婪闌藍讕瀾襤斕籃鑭覽攬纜欖懶懶爛濫瑯鋃螂閬撈勞嘮嶗癆铹銠澇耢樂鳓縲鐳誄壘淚類累棱厘梨狸離驪犁鸝漓褵蘺璃璃鱺籬藜禮里里邐鋰鯉鱧歷歷歷厲麗勵嚦壢瀝藶櫪癘隸隸儷櫟癧癧荔轢酈栗礪礫蒞蒞糲蠣躒靂倆奩奩奩奩連簾憐漣蓮聯褳廉鰱鐮斂斂璉臉襝蘞練孌煉煉戀殮鏈瀲涼梁糧兩魎諒輛遼療繚鐐鷯釕獵鄰鄰臨淋轔磷磷鱗麟凜廩懍檁吝賃藺躪靈靈嶺凌鈴櫺櫺綾菱齡鯪領溜劉瀏留琉琉餾騮瘤鎦柳柳綹锍鷚龍嚨瀧蘢櫳瓏朧礱籠聾隴壟壟攏婁僂嘍蔞樓耬螻髏嶁摟簍瘺瘺鏤嚕擼盧廬蘆壚壚瀘爐爐櫨臚轤鸕艫顱鱸鹵鹵虜擄魯櫓櫓櫓镥陸錄賂輅淥祿濾戮轆鷺氌驢閭櫚呂侶稆鋁屢縷褸慮綠孿巒攣欒鸞臠灤鑾亂略鋝掄崙崙倫圇淪綸輪論羅羅玀腡蘿邏欏鑼籮騾騾鏍裸裸濼絡犖駱媽嬤麻蟆馬獁瑪碼螞榪罵罵嘜嗎買蕒勱邁麥賣脈脈顢蠻饅瞞鰻滿蟎謾縵鏝貓犛犛錨鉚冒貿帽帽麼沒梅梅镅鶥黴鎂門捫鍆悶燜懣們濛濛蒙錳夢彌彌祢獼謎羋瞇覓覓秘冪謐綿綿黽緬靦面面面鶓緲妙廟咩滅蔑珉緡緡閔泯閩憫愍鳘鳴銘謬繆謨饃饃模歿驀鏌謀畝鉬幕拿拿镎內納鈉乃乃奶難楠楠馕撓鐃蟯垴惱腦鬧鬧訥餒嫩鈮霓鯢你擬暱膩鮎鯰捻輦攆念娘釀鳥蔦裊裊裊捏隉聶囓囓囁鑷鎳顳躡孽寧嚀擰獰檸聹濘紐鈕農農儂噥濃膿弄駑釹瘧暖暖儺諾锘謳歐毆甌鷗嘔慪漚盤盤蹣龐刨刨狍炮炮皰胚賠锫佩轡噴鵬碰碰紕鈹毗羆駢諞騙騙縹飄飄貧嬪頻顰評憑憑蘋瓶鮃釙潑頗钷迫僕撲鋪鋪镤樸譜镨淒淒棲榿戚戚齊臍頎騏騎棋棋蠐旗蘄鰭豈啟啟綺氣訖棄薺磧憩千扦遷僉釬牽慳鉛謙愆簽簽騫蕁鈐錢鉗乾乾潛淺肷譴繾塹槧嗆羌戧槍蹌錆鏘鏹強強牆牆嬙薔檣檣搶羥襁襁熗磽磽蹺鍬鍬繰喬僑蕎橋譙憔憔鞒誚峭竅翹竊愜篋鍥親欽琴勤鋟寢吣撳撳氫輕傾鯖檾頃請慶窮煢瓊丘秋秋鰍鰍虯球賕巰區曲曲嶇詘驅驅軀趨鴝癯齲闃覷覷覷權詮輇銓蜷顴綣勸卻愨愨確闋闕鵲榷裙裙群冉讓蕘饒橈擾嬈繞熱認紉妊軔韌韌飪絨絨絨榮嶸蠑融冗銣顬縟軟軟蕊蕊蕊銳睿閏潤箬灑颯薩腮鰓賽毿傘傘糝馓顙喪騷繅鳋掃澀澀嗇銫穡殺紗鎩鯊篩曬刪姍釤羶閃陝訕騸繕膳贍鱔鱔傷殤觴垧賞绱燒紹賒蛇舍厙設懾懾攝灄紳詵審審諗嬸渖腎滲升升聲勝澠繩聖剩屍師蝨詩獅濕濕釃鲺時識實蝕塒蒔鰣駛勢視視視試飾是柿貰適軾鈰諡諡釋壽壽獸綬書紓樞倏倏疏攄輸贖薯術樹豎豎庶數漱帥閂雙誰稅順說說爍鑠碩絲噝鷥緦螄廝鍶似祀飼駟俟松慫聳訟誦頌搜餿颼鎪擻藪蘇蘇蘇穌訴肅謖溯溯酸雖綏隨歲歲誶孫猻蓀飧損筍挲蓑縮嗩瑣鎖它鉈塔獺鰨撻闥駘台台台抬鮐態鈦貪攤灘癱壇壇壇壇壇曇談錟譚袒鉭嘆嘆賧湯铴鏜餳糖儻燙趟濤絛絛絛掏韜鞀鞀討铽騰謄藤銻綈啼緹鵜題蹄體體屜剃剃闐條齠鰷眺糶銚貼鐵鐵鐵廳廳聽聽烴鋌同銅統筒慟偷偷頭禿圖塗塗釷兔團團摶頹頹頹腿蛻飩臀托拖脫馱駝鴕鼉橢拓籜窪媧蛙襪襪膃彎灣紈玩頑挽綰碗碗萬亡網往輞望為為韋圍幃溈溈違闈潿維濰偉偽偽緯葦煒瑋諉韙鮪衛衛謂喂喂猬溫紋聞蚊蚊閿吻穩問甕甕撾渦萵窩蝸臥齷烏污污鄔嗚誣鎢無吳蕪塢塢嫵嫵廡忤憮鵡務誤騖霧鶩誒犧晰溪錫嘻膝習席襲覡璽銑戲戲系系餼細郄鬩舄蝦俠峽狹硤轄轄嚇廈仙纖纖秈薟躚鍁鮮閒閒弦賢咸嫻嫻銜銜癇鷴鷴鷴顯險獫蜆蘚縣峴莧現線線憲餡羨獻鄉鄉薌廂緗驤鑲詳享響餉饗鯗向向項梟嘵驍綃蕭銷瀟簫囂囂曉筱效效嘯嘯蠍協邪脅脅挾諧攜攜擷纈鞋寫泄瀉紲紲紲褻謝蟹欣鋅釁興陘幸兇洶胸修鵂饈繡繡銹銹須須頊虛噓許詡敘敘卹卹勗緒續婿溆軒諼喧萱萱萱萱懸旋璇選癬絢鉉楦靴學澩鱈謔勳勳塤塤熏尋巡馴詢潯鱘訓訊徇遜丫壓鴉鴉椏鴨啞瘂亞訝埡婭氬咽懨懨煙胭閹醃讠閆嚴岩岩岩鹽閻顏顏簷兗儼厴演魘鼴厭彥硯艷艷驗驗諺焰雁灩灩釅讞饜燕燕燕贗贗鴦揚揚揚陽楊煬瘍養癢樣夭堯餚軺窯窯謠搖遙瑤鰩藥藥鷂耀爺铘野野業葉頁鄴夜曄燁燁謁靨醫醫咿銥儀詒迤飴貽移遺頤彝彝釔艤蟻蟻義億憶藝議異囈囈譯嶧懌繹詣驛軼誼縊瘞鎰翳鐿因陰陰蔭蔭殷銦喑堙吟淫淫銀齦飲隱癮應鶯鶯嬰嚶攖纓罌罌櫻瓔鸚鷹塋滎熒瑩螢營縈瀅鎣瀠蠅贏潁穎癭映喲傭擁癰雍墉鏞鳙詠湧恿恿踴優憂猶郵莜蕕鈾遊魷銪佑誘紆餘歟魚娛諛漁嵛逾覦輿與傴嶼俁語齬馭吁吁嫗飫鬱獄鈺預欲諭閾禦鵒愈愈蕷譽鷸鳶鴛淵員園圓緣黿猿猿轅櫞遠願約岳鑰鑰鑰悅鉞閱閱躍粵雲勻紜芸鄖氳隕殞運鄆惲暈醞醞慍韞韻蘊匝雜雜災災災載簪咱咱攢攢攢趲暫讚讚贊鏨瓚贓贓贓駔髒髒葬糟鑿棗灶皂唣噪則擇澤責嘖幘簀賾賊譖繒鋥贈揸齄紮紮札札軋閘閘鍘詐柵榨齋債沾氈氈譫斬盞嶄輾佔戰棧綻骣張獐漲帳脹賬釗詔趙棹照哲輒蟄謫謫轍鍺這浙鷓貞針針偵湞珍楨砧禎診軫縝陣鴆賑鎮爭徵崢掙猙鉦睜錚箏證證諍鄭幀症卮織梔執侄侄職縶蹠躑隻隻址紙軹志制帙帙幟質櫛摯致贄輊擲鷙滯騭稚稚置觶躓終鐘鐘鐘腫種塚眾眾謅週軸帚紂咒縐晝荮皺驟朱誅諸豬銖櫧瀦櫫燭屬煮囑矚佇佇苧注貯駐築鑄箸專磚磚磚顓轉囀賺撰饌妝妝莊樁裝壯狀騅錐墜綴縋贅諄準桌斫斫斫濁諑鐲鐲茲茲貲資緇諮輜錙齜鯔姊漬眥綜棕踪鬃鬃總總傯縱粽鄒騶諏鯫鏃詛組躦纘纂鑽鑽罪樽鱒';}function Traditionalized(cc){var str='',ss=JTPYStr(),tt=FTPYStr();for(var i=0;i<cc.length;i++){if(cc.charCodeAt(i)>10000&&ss.indexOf(cc.charAt(i))!=-1)str+=tt.charAt(ss.indexOf(cc.charAt(i)));else str+=cc.charAt(i);}return getStrFilterUpdate(str);}function Simplized(cc){var str='',ss=JTPYStr(),tt=FTPYStr();for(var i=0;i<cc.length;i++){if(cc.charCodeAt(i)>10000&&tt.indexOf(cc.charAt(i))!=-1)str+=ss.charAt(tt.indexOf(cc.charAt(i)));else str+=cc.charAt(i);}return getStrFilterUpdate(str);}function getStrFilterUpdate(str){// update —
var regMdash=new RegExp("&mdash;","gi");str=str.replace(regMdash,"—");// update ·
var regMiddot=new RegExp("&middot;","gi");str=str.replace(regMiddot,"·");// update “
var regLdquo=new RegExp("&ldquo;","gi");str=str.replace(regLdquo,"“");// update ”
var regRdquo=new RegExp("&rdquo;","gi");str=str.replace(regRdquo,"”");// update ‘
var regAmpLsquo=new RegExp("&amp;lsquo;","gi");str=str.replace(regAmpLsquo,"‘");// update ’
var regAmpRsquo=new RegExp("&amp;rsquo;","gi");str=str.replace(regAmpRsquo,"’");// update ‘
var regLsquo=new RegExp("&lsquo;","gi");str=str.replace(regLsquo,"‘");// update ’
var regRsquo=new RegExp("&rsquo;","gi");str=str.replace(regRsquo,"’");// update '
var reg39=new RegExp("&#39;","gi");str=str.replace(reg39,"'");// update <
var regRdquo=new RegExp("&lt;","gi");str=str.replace(regRdquo,"<");// update >
var regGt=new RegExp("&gt;","gi");str=str.replace(regGt,">");// update ≤
var regLe=new RegExp("&le;","gi");str=str.replace(regLe,"≤");// update ≥
var regGe=new RegExp("&ge;","gi");str=str.replace(regGe,"≥");// update ×
var regTimes=new RegExp("&times;","gi");str=str.replace(regTimes,"×");// update ÷
var regDivide=new RegExp("&divide;","gi");str=str.replace(regDivide,"÷");// update –
var regNdash=new RegExp("&ndash;","gi");str=str.replace(regNdash,"–");// update …
var regHellip=new RegExp("&hellip;","gi");str=str.replace(regHellip,"…");// update ±
var regHplusmn=new RegExp("&plusmn;","gi");str=str.replace(regHplusmn,"±");// update ∞
var regHinfin=new RegExp("&infin;","gi");str=str.replace(regHinfin,"∞");// update δ
var regHdelta=new RegExp("&delta;","gi");str=str.replace(regHdelta,"δ");// update ∝
var regHprop=new RegExp("&prop;","gi");str=str.replace(regHprop,"∝");// update ∨
var regHor=new RegExp("&or;","gi");str=str.replace(regHor,"∨");// update ∧
var regHand=new RegExp("&and;","gi");str=str.replace(regHand,"∧");// update ‰
var regHpermil=new RegExp("&permil;","gi");str=str.replace(regHpermil,"‰");// update ·
var regH8226=new RegExp("&#8226;","gi");str=str.replace(regH8226,"·");// update `
var regHbull=new RegExp("&bull;","gi");str=str.replace(regHbull,"`");// update 欧元符号
//本字符串是欧元符号的unicode码, GBK编辑中不支持欧元符号(需更改为UTF-8), 故只能使用unicode码
var regHeuro=new RegExp("&euro;","gi");str=str.replace(regHeuro,'\u20AC');// update →
var regHrarr=new RegExp("&rarr;","gi");str=str.replace(regHrarr,"→");var reg160=new RegExp("&amp;#160;","gi");str=str.replace(reg160," ");var regSup3=new RegExp("m&sup3;","gi");str=str.replace(regSup3,"m3");return str;}exports.Traditionalized=Traditionalized;exports.Simplized=Simplized;

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaAudio=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 989));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaAudio;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _util=__webpack_require__(382);var Util=_interopRequireWildcard(_util);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaAuth=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 990));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});WeaAuth.util=Util;exports.default=WeaAuth;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(760);

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(762);

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(764);

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(766);

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(768);

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(770);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CodeMirror=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(5/* limit */).then(__webpack_require__.bind(null, 992));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var WeaCodeMirror=function(_React$Component){(0,_inherits3.default)(WeaCodeMirror,_React$Component);function WeaCodeMirror(props){(0,_classCallCheck3.default)(this,WeaCodeMirror);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaCodeMirror.__proto__||(0,_getPrototypeOf2.default)(WeaCodeMirror)).call(this,props));_this.setValue=function(value){if(_this.codeMirror&&_this.codeMirror.codeMirror){_this.codeMirror.codeMirror.setValue(value);}};_this.setOption=function(name,value){if(_this.codeMirror&&_this.codeMirror.codeMirror){_this.codeMirror.codeMirror.setOption([name],value);}};_this.onChange=function(value){_this.setState({value:value});_this.props.onChange(value);};_this.state={value:props.value||"",theme:props.theme||"eclipse",mode:props.mode||"javascript"};return _this;}(0,_createClass3.default)(WeaCodeMirror,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// codeMirror内部受控问题：这里手动改值
if(nextProps.value&&nextProps.value!==this.state.value){this.onChange(nextProps.value);this.setValue(nextProps.value);}if(nextProps.theme&&nextProps.theme!==this.state.theme){this.setState({theme:nextProps.theme});this.setOption("theme",nextProps.theme);}if(nextProps.mode&&nextProps.mode!==this.state.mode){this.setState({mode:nextProps.mode});this.setOption("mode",nextProps.mode);}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,_props$width=_props.width,width=_props$width===undefined?"100%":_props$width,_props$height=_props.height,height=_props$height===undefined?"100%":_props$height,_props$viewAttr=_props.viewAttr,viewAttr=_props$viewAttr===undefined?2:_props$viewAttr,_props$className=_props.className,className=_props$className===undefined?"":_props$className,_props$style=_props.style,style=_props$style===undefined?{}:_props$style;var _state=this.state,value=_state.value,theme=_state.theme,mode=_state.mode;var options=(0,_extends3.default)({mode:mode,//定义mode
theme:theme,//选中的theme
styleActiveLine:true,autofocus:true,lineNumbers:true,//显示行号s
lineWrapping:false,// 长文本横向滚动
extraKeys:{Ctrl:"autocomplete"},//自动提示配置
tabSize:2,// tab字符的宽度
readOnly:viewAttr===1},this.props.options);return _react2.default.createElement("div",{style:(0,_extends3.default)({width:width,height:height},style),className:"wea-code-mirror "+className},_react2.default.createElement(CodeMirror,(0,_extends3.default)({},this.props,{value:value,ref:function ref(_ref){return _this2.codeMirror=_ref;},options:options,onChange:function onChange(code){return _this2.onChange(code);}})));}}]);return WeaCodeMirror;}(_react2.default.Component);var Com=(0,_middleware2.default)(WeaCodeMirror,"WeaCodeMirror");exports.default=Com;

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(772);__webpack_require__(773);

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaCron=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 993));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaCron;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(776);

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _weaCollect=__webpack_require__(123);var _weaCollect2=_interopRequireDefault(_weaCollect);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaCustom=function(_React$Component){(0,_inherits3.default)(WeaCustom,_React$Component);function WeaCustom(props){(0,_classCallCheck3.default)(this,WeaCustom);return(0,_possibleConstructorReturn3.default)(this,(WeaCustom.__proto__||(0,_getPrototypeOf2.default)(WeaCustom)).call(this,props));}(0,_createClass3.default)(WeaCustom,[{key:"render",value:function render(){var _props=this.props,children=_props.children,uuid=_props.uuid;if(children&&uuid==="0bd92b22-90f1-4d42-91a4-695adf976bc9"){return React.createElement("div",null,children);}else{return React.createElement("div",null);}}}]);return WeaCustom;}(React.Component);var Com=(0,_middleware2.default)(WeaCustom,"WeaCustom");exports.default=Com;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(779);

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaDateSwitch=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 994));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaDateSwitch;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _classnames3=__webpack_require__(13);var _classnames4=_interopRequireDefault(_classnames3);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _ExtendsContainer=__webpack_require__(366);var _ExtendsContainer2=_interopRequireDefault(_ExtendsContainer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getRouteList=function getRouteList(_ref){var path=_ref.path,childRoutes=_ref.childRoutes;var list=path?[path]:[];if(childRoutes&&Object.prototype.toString.call(childRoutes)==="[object Array]"){childRoutes.forEach(function(c){list=list.concat(getRouteList(c).map(function(l){return /^\//.test(l)?l:(path==="/"?"":path)+"/"+l;}));});}return list;};var WeaDebugRouteMenu=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaDebugRouteMenu,_React$Component);function WeaDebugRouteMenu(props){(0,_classCallCheck3.default)(this,WeaDebugRouteMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaDebugRouteMenu.__proto__||(0,_getPrototypeOf2.default)(WeaDebugRouteMenu)).call(this,props));_this.preCls="wea-debug-route-menu";_this.state={show:false};return _this;}(0,_createClass3.default)(WeaDebugRouteMenu,[{key:"componentDidMount",value:function componentDidMount(){var pathname=this.props.location.pathname;if(pathname==="/"||pathname.split("/").length===2)this.setState({show:true});}},{key:"getList",value:function getList(){var _props=this.props,route=_props.route,showRouteLev=_props.showRouteLev;var list=getRouteList(route);return list.filter(function(l){return l.split("/").length<showRouteLev+2;});}},{key:"render",value:function render(){var _this2=this,_classnames,_classnames2;var show=this.state.show;var _props2=this.props,children=_props2.children,route=_props2.route,router=_props2.router;if(!route)return _react2.default.createElement("div",null,"\u8BF7\u68C0\u67E5\u662F\u5426\u914D\u7F6E\u4E86\u8DEF\u7531");var menu=_react2.default.createElement(_antd.Menu,{onClick:function onClick(_ref2){var key=_ref2.key;router.push(key);_this2.setState({show:false});}},this.getList().map(function(l){return _react2.default.createElement(_antd.Menu.Item,{key:l},l);}));var wrapCls=(0,_classnames4.default)((_classnames={},(0,_defineProperty3.default)(_classnames,this.preCls,true),(0,_defineProperty3.default)(_classnames,this.preCls+"-show",show),_classnames));var btnCls=(0,_classnames4.default)((_classnames2={},(0,_defineProperty3.default)(_classnames2,this.preCls+"-btn",true),(0,_defineProperty3.default)(_classnames2,this.preCls+"-btn-show",!show),_classnames2));return[_react2.default.createElement(_ExtendsContainer2.default,{className:this.preCls,container:document.body},_react2.default.createElement("div",{className:wrapCls},_react2.default.createElement(_weaNewScroll2.default,{height:"100%"},menu),_react2.default.createElement("div",{className:btnCls,title:show?"隐藏路由":"显示路由",onClick:function onClick(){return _this2.setState({show:!show});}}))),children];}}]);return WeaDebugRouteMenu;}(_react2.default.Component),_class.displayName="WeaDebugRouteMenu",_class.defaultProps={showRouteLev:3,className:"",style:{}},_temp);exports.default=WeaDebugRouteMenu;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(783);

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _weaMoreButton=__webpack_require__(210);var _weaMoreButton2=_interopRequireDefault(_weaMoreButton);__webpack_require__(785);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:"render",value:function render(){var _props=this.props,_props$buttons=_props.buttons,buttons=_props$buttons===undefined?[]:_props$buttons,moreBtn=_props.moreBtn,borderTop=_props.borderTop,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style;if(moreBtn&&(0,_keys2.default)(moreBtn).length>0){buttons=buttons.concat([React.createElement(_weaMoreButton2.default,moreBtn)]);}return React.createElement("div",{className:"wea-dialog-footer "+(borderTop?"bTop":"")+" "+className,style:style},buttons);}}]);return Main;}(React.Component),_class.defaultProps={borderTop:true},_temp);var Com=(0,_middleware2.default)(Main,"WeaDialogFooter");exports.default=Com;

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(787);

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaDragChoose=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaDragChoose,_React$Component);function WeaDragChoose(props){(0,_classCallCheck3.default)(this,WeaDragChoose);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaDragChoose.__proto__||(0,_getPrototypeOf2.default)(WeaDragChoose)).call(this,props));_initialiseProps.call(_this);_this.state={dragStart:false,startRow:-1,startColumn:-1,endRow:-1,endColumn:-1};_this.activeCellProps=[];return _this;}(0,_createClass3.default)(WeaDragChoose,[{key:"render",value:function render(){this.activeCellProps=[];var _props=this.props,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style;return React.createElement("span",{className:className,style:style},this.registerChildren(this.props.children));}},{key:"checkActive",value:function checkActive(itemPos,props){var _state=this.state,startRow=_state.startRow,startColumn=_state.startColumn,endRow=_state.endRow,endColumn=_state.endColumn;var minRow=Math.min(startRow,endRow),maxRow=Math.max(startRow,endRow),minColumn=Math.min(startColumn,endColumn),maxColumn=Math.max(startColumn,endColumn);if(this.props.checkActive){var checkObject=(0,_extends3.default)({},this.state,{minRow:minRow,minColumn:minColumn,maxRow:maxRow,maxColumn:maxColumn});return this.props.checkActive(props,checkObject);}return itemPos[0]>=minRow&&itemPos[0]<=maxRow&&itemPos[1]>=minColumn&&itemPos[1]<=maxColumn;}},{key:"clear",value:function clear(){this.setState({dragStart:false,startRow:-1,startColumn:-1,endRow:-1,endColumn:-1});}}]);return WeaDragChoose;}(React.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.registerChildren=function(children){if((typeof children==="undefined"?"undefined":(0,_typeof3.default)(children))!=="object"||children===null){return children;}var childrenCount=React.Children.count(children);if(childrenCount>1){return React.Children.map(children,function(child){return _this2.registerChild(child);});}else if(childrenCount===1){return _this2.registerChild(Array.isArray(children)?children[0]:children);}};this.registerChild=function(child){if((typeof child==="undefined"?"undefined":(0,_typeof3.default)(child))!=="object"||child===null){return child;}if(child.props&&Array.isArray(child.props.itemPosition)){var props=child.props;var pos=props.itemPosition;var newProps={onMouseUp:_this2.mouseUp.bind(_this2,pos,props),onTouchEnd:_this2.mouseUp.bind(_this2,pos,props),onMouseDown:_this2.mouseDown.bind(_this2,pos,props),onTouchStart:_this2.mouseDown.bind(_this2,pos,props),onMouseMove:_this2.mouseMove.bind(_this2,pos,props),onTouchMove:_this2.mouseMove.bind(_this2,pos,props)};if(_this2.checkActive(pos,props)){_this2.activeCellProps.push(props);if(_this2.props.activeClass){newProps.className=(props.className||"")+" "+_this2.props.activeClass;}if(_this2.props.activeStyle){newProps.style=(0,_extends3.default)({},props.style,_this2.props.activeStyle);}}var newEle=React.cloneElement(child,newProps);return newEle;}return React.cloneElement(child,{},_this2.registerChildren(child.props&&child.props.children));};this.mouseUp=function(pos,props,e){if(!_this2.state.dragStart)return;_this2.setState({dragStart:false,endRow:pos[0],endColumn:pos[1],endProps:props},function(){_this2.props.onSelectEnd&&_this2.props.onSelectEnd((0,_extends3.default)({},_this2.state),_this2.activeCellProps);});};this.mouseDown=function(pos,props,e){_this2.setState({dragStart:true,startRow:pos[0],startColumn:pos[1],endRow:pos[0],endColumn:pos[1],startProps:props,endProps:props},function(){_this2.props.onSelect&&_this2.props.onSelect((0,_extends3.default)({},_this2.state),_this2.activeCellProps);});};this.mouseMove=function(pos,props,e){var dragStart=_this2.state.dragStart;if(!dragStart)return;e.preventDefault();var endRow=pos[0],endColumn=pos[1];_this2.setState({endRow:endRow,endColumn:endColumn,endProps:props},function(){_this2.props.onSelect&&_this2.props.onSelect((0,_extends3.default)({},_this2.state),_this2.activeCellProps);});};},_temp);/*const getCellLocation = (pos, e) => {
 let b;
 if (e.touches) {
 let c = e.touches[0];
 b = document.elementFromPoint(c.clientX, c.clientY);
 } else {
 for (b = e.target; "TD" !== b.tagName; ) {
 b = b.parentNode;
 }
 }
 return { row: b.parentNode.rowIndex, column: b.cellIndex };
 }*//**
 * 使用方式如下：
 * 在支持拖拽选中的区域外包一层 WeaDragChoose，支持选中的子节点需要传入itemPosition属性。onSelect为拖拽时触发方法，onSelectEnd为拖拽结束触发方法。
 * itemPosition为数组:[行号,列号];
 * onSelect与onSelectEnd会返回开始的行、列，结束的行列
 */WeaDragChoose.propTypes={onSelect:React.PropTypes.func,onSelectEnd:React.PropTypes.func,checkActive:React.PropTypes.func//判断表格是否选中（激活active状态）的方法,不会改变onSelect/onSelectEnd回调。
};var Com=(0,_middleware2.default)(WeaDragChoose,"WeaDragChoose");exports.default=Com;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(790);

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var colors=["#4DB4FF","#1477B4","#49AFBC","#B6CF21","#F9A825","#FF81AC","#AF64F0","#808BC5","#5C6977","#BEBEBE"];var WeaEchart=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 995));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});WeaEchart.colors=colors;exports.default=WeaEchart;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _weaCustomNew=__webpack_require__(150);var _weaCustomNew2=_interopRequireDefault(_weaCustomNew);__webpack_require__(793);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaEcodeUpload=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 996));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var EcodeUpload=function(_React$Component){(0,_inherits3.default)(EcodeUpload,_React$Component);function EcodeUpload(props){(0,_classCallCheck3.default)(this,EcodeUpload);return(0,_possibleConstructorReturn3.default)(this,(EcodeUpload.__proto__||(0,_getPrototypeOf2.default)(EcodeUpload)).call(this,props));}(0,_createClass3.default)(EcodeUpload,[{key:"render",value:function render(){return _react2.default.createElement(_weaCustomNew2.default,(0,_extends3.default)({type:"ecodeUpload"},this.props),_react2.default.createElement(WeaEcodeUpload,this.props));}}]);return EcodeUpload;}(_react2.default.Component);var Com=(0,_middleware2.default)(EcodeUpload,"WeaEcodeUpload");exports.default=Com;

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ErrorBoundary=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 997));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=ErrorBoundary;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaFieldTemplateSelect=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 998));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaFieldTemplateSelect;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(797);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaField=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 999));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaField;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaCropper=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(6/* limit */).then(__webpack_require__.bind(null, 1000));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaCropper;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(800);

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(23);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _weaInputAuth=__webpack_require__(151);var _weaInputAuth2=_interopRequireDefault(_weaInputAuth);var _weaTextareaAuth=__webpack_require__(125);var _weaTextareaAuth2=_interopRequireDefault(_weaTextareaAuth);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=function(_React$PureComponent){(0,_inherits3.default)(main,_React$PureComponent);function main(){(0,_classCallCheck3.default)(this,main);return(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).apply(this,arguments));}(0,_createClass3.default)(main,[{key:"render",value:function render(){var props=this.props;var children=props.children,type=props.type,resProps=(0,_objectWithoutProperties3.default)(props,["children","type"]);if(type==="TEXTAREA"){return[_react2.default.createElement(_weaTextareaAuth2.default,(0,_extends3.default)({className:"wea-textarea-normal wea-field-readonly"},resProps,{ecId:this.props.ecId+"_WeaTextareaAuth@p9v5i7"})),children];}return[_react2.default.createElement(_weaInputAuth2.default,(0,_extends3.default)({},resProps,{ecId:this.props.ecId+"_WeaInputAuth@04d4gi"})),children];}}]);return main;}(_react2.default.PureComponent);var Com=(0,_middleware2.default)(main,"WeaInputEnCrypt");exports.default=Com;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(803);

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _Step=__webpack_require__(805);var _Step2=_interopRequireDefault(_Step);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaIntro=function WeaIntro(){return _react2.default.createElement("div",null);};WeaIntro.Intro=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 1001));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});WeaIntro.Step=_Step2.default;var Com=(0,_middleware2.default)(WeaIntro,"WeaIntro");exports.default=Com;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(_ref){var id=_ref.id,children=_ref.children;return _react2.default.createElement('div',{className:'wea-intro-step',id:id},children);};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(807);__webpack_require__(808);__webpack_require__(809);

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(811);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaLanguageSelect=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1002));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaLanguageSelect;

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(813);__webpack_require__(814);

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(816);

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(38);var _reactDom2=_interopRequireDefault(_reactDom);var _antd=__webpack_require__(8);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var instance=null;var times=0;var WeaLoadingGlobal=function(_Component){(0,_inherits3.default)(WeaLoadingGlobal,_Component);function WeaLoadingGlobal(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,WeaLoadingGlobal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=WeaLoadingGlobal.__proto__||(0,_getPrototypeOf2.default)(WeaLoadingGlobal)).call.apply(_ref,[this].concat(args))),_this),_this.state={spinning:true,size:"large"},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(WeaLoadingGlobal,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"wea-loading-global"},_react2.default.createElement(_antd.Spin,(0,_extends3.default)({},this.state,this.props),_react2.default.createElement("div",{className:"wea-loading-global-content ant-spin-blur"})));}}]);return WeaLoadingGlobal;}(_react.Component);function newInstance(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var callback=arguments[1];var div=document.createElement("div");document.body.appendChild(div);function ref(spin){callback({component:spin,destroy:function destroy(){_reactDom2.default.unmountComponentAtNode(div);document.body.removeChild(div);}});}_reactDom2.default.render(_react2.default.createElement(WeaLoadingGlobal,(0,_extends3.default)({ref:ref},props)),div);}function getInstance(props,callback){times++;if(instance){callback(instance);return;}newInstance(props,function(ins){if(instance){callback(instance);return;}instance=ins;callback(ins);});}exports.default={start:function start(props){if(instance){instance.component.setState({spinning:true});}else{times===0&&getInstance(props,function(){});}},end:function end(){if(instance){instance.component.setState({spinning:false});}},destroy:function destroy(){if(instance){instance.destroy();instance=null;times=0;}}};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(819);

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(821);

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaMenu=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1003));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaMenu;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(824);

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaMind=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 1004));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaMind;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(38);var _reactDom2=_interopRequireDefault(_reactDom);var _propTypes=__webpack_require__(36);var _propTypes2=_interopRequireDefault(_propTypes);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaNewScrollPagination=function(_Component){(0,_inherits3.default)(WeaNewScrollPagination,_Component);function WeaNewScrollPagination(props){(0,_classCallCheck3.default)(this,WeaNewScrollPagination);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaNewScrollPagination.__proto__||(0,_getPrototypeOf2.default)(WeaNewScrollPagination)).call(this,props));_this.throttleFunction=function(method){return function(){var hasLoading=_this.props.hasOwnProperty("loading");var shortTime=_this.props.intervalTime;var longTime=_this.props.overtime;var curTime=new Date().getTime();var canScroll=false;var interval=curTime-_this.startTime;if(hasLoading){canScroll=_this.props.loading?interval>=longTime:interval>=shortTime;}else{canScroll=interval>=shortTime;}if(canScroll){_this.startTime=curTime;method();}};};_this.onScroll=function(event){var dom=event.currentTarget;var scrollTop=dom.scrollTop,clientHeight=dom.clientHeight,scrollHeight=dom.scrollHeight;if(scrollTop+clientHeight>=scrollHeight-_this.props.offset){_this.throttleFunction(_this.props.onScrollEnd)();}var onScroll=_this.props.onScroll;typeof onScroll==="function"&&onScroll(event);};_this.timeout=null;_this.startTime=new Date().getTime();return _this;}(0,_createClass3.default)(WeaNewScrollPagination,[{key:"scrollTop",value:function scrollTop(){var dom=_reactDom2.default.findDOMNode(this);var scroller=$(dom).children().children(".scroller");scroller&&scroller[0]&&(scroller[0].scrollTop=0);}},{key:"render",value:function render(){return _react2.default.createElement(_weaNewScroll2.default,(0,_extends3.default)({},this.props,{onScroll:this.onScroll}),this.props.children);}}]);return WeaNewScrollPagination;}(_react.Component);WeaNewScrollPagination.defaultProps={offset:30,overtime:5000,intervalTime:500};WeaNewScrollPagination.propTypes={onScrollEnd:_propTypes2.default.func.isRequired,// 滚动到最末尾时执行的函数
height:_propTypes2.default.number,// 高度，可不传
loading:_propTypes2.default.bool,// 加载状态。传入此值时，会以该值为依据判断是否可加载。传入该值时，若为true,则加载间隔为overtime，否则，加载间隔为intervalTime，不传时，加载间隔为intervalTime。
offset:_propTypes2.default.number,// 与底部的偏差，距底部多少距离时执行方法,默认30px
overtime:_propTypes2.default.number,// 超时时间，默认5000毫秒
intervalTime:_propTypes2.default.number// 间隔时间, 默认500毫秒
};var Com=(0,_middleware2.default)(WeaNewScrollPagination,"WeaNewScrollPagination");exports.default=Com;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(828);

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaOrgTree=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(2/* limit */).then(__webpack_require__.bind(null, 1005));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaOrgTree;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(831);

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(833);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaPeriod=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1006));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaPeriod;

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(835);

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(837);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaRadioGroup=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1007));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaRadioGroup;

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaRate=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1008));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaRate;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(840);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaReportCard=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 1009));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaReportCard;

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaReportGroup=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 1010));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});WeaReportGroup.item=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 950));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaReportGroup;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaReport=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1011));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaReport;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(844);

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _nprogress=__webpack_require__(309);var _nprogress2=_interopRequireDefault(_nprogress);var _classnames=__webpack_require__(13);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(310);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _RightMenu=__webpack_require__(128);var _RightMenu2=_interopRequireDefault(_RightMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaNewTopReq=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaNewTopReq,_React$Component);function WeaNewTopReq(props){(0,_classCallCheck3.default)(this,WeaNewTopReq);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaNewTopReq.__proto__||(0,_getPrototypeOf2.default)(WeaNewTopReq)).call(this,props));_this.onWindowResize=function(){if(_this.instanceIsMounted){_this.scrollheigth();_this.reGetWidth();}_this.resizeLeftWidth();//resize重新计算
};_this.resizeLeftWidth=function(){if(_this.refs.right&&_this.refs.title){var titleWidth=_this.refs.title.clientWidth;var rightWidth=_this.refs.right.clientWidth;_this.setState({leftMaxWidth:titleWidth-rightWidth});}};_this.instanceIsMounted=false;_this.hash="weareqtop_"+Math.random().toString(36).substr(2,6)+"_"+new Date().getTime();_this.state={showDrop:_this.props.showDrop||false,percent:85,end:true,height:0,showShadow:false,width:0,dropVerify:false,leftMaxWidth:"auto",isDropMenuEmpty:false};return _this;}(0,_createClass3.default)(WeaNewTopReq,[{key:"componentDidMount",value:function componentDidMount(){this.instanceIsMounted=true;this.scrollheigth();this.reGetWidth();this.resizeLeftWidth();//进入的时候计算一次
window.addEventListener("resize",this.onWindowResize);_nprogress2.default.configure({showSpinner:false,minimum:0.3,speed:500});this.props.onDidMount&&this.props.onDidMount(this.props,this.hash);window.onTopDidMount&&window.onTopDidMount(this.props,this.hash);if(this.RightMenu&&this.RightMenu.isEmpty)this.setState({isDropMenuEmpty:true});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this2=this;var _props=this.props,loading=_props.loading,heightSpace=_props.heightSpace,buttons=_props.buttons,tabDatas=_props.tabDatas,showDropIcon=_props.showDropIcon;if(!loading&&nextProps.loading){_nprogress2.default.configure({parent:"#"+this.hash});_nprogress2.default.start(0.3);// this.timer = setInterval(() => {
//   const percent = this.state.percent;
//   const newP = percent < 96 ? (percent + 1) : 96;
//   this.instanceIsMounted && this.setState({ end: false, percent: newP });
// }, 10);
}else if(loading&&!nextProps.loading){_nprogress2.default.done();// this.setState({ percent: 100 });
// this.timer && clearInterval(this.timer);
// setTimeout(() => {this.instanceIsMounted && this.setState({ percent: 85, end: true });}, 300);
}if(heightSpace!==nextProps.heightSpace){this.scrollheigth();}//得到buttons的时候重新计算
if(nextProps.buttons&&buttons.length!==nextProps.buttons.length){setTimeout(function(){return _this2.resizeLeftWidth();},200);}if(tabDatas&&tabDatas.length>0&&showDropIcon&&!this.state.dropVerify){setTimeout(function(){return _this2.resizeLeftWidth();},200);this.setState({dropVerify:true});}if(nextProps.showDrop!==undefined&&nextProps.showDrop!==this.state.showDrop){if(nextProps.showDrop){window.onWeaDialogOpen&&window.onWeaDialogOpen();}else{window.onWeaDialogClose&&window.onWeaDialogClose();}this.setState({showDrop:nextProps.showDrop});}}},{key:"componentWillUpdate",value:function componentWillUpdate(nextProps,nextState,nextContext){if(nextState.showDrop!=this.state.showDrop){if(nextState.showDrop){window.onWeaDialogOpen&&window.onWeaDialogOpen();}else{window.onWeaDialogClose&&window.onWeaDialogClose();}}}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.scrollheigth();var isDropMenuEmpty=this.state.isDropMenuEmpty;var isdropmenuempty=this.RightMenu&&this.RightMenu.isEmpty;if(isdropmenuempty!==isDropMenuEmpty)this.setState({isDropMenuEmpty:isdropmenuempty});}},{key:"componentWillUnmount",value:function componentWillUnmount(){// 防止节点卸载问题。。。
window.removeEventListener("resize",this.onWindowResize);_nprogress2.default.configure({parent:"body"});_nprogress2.default.done();_nprogress2.default.remove();this.instanceIsMounted=false;if(this.state.showDrop){window.onWeaDialogClose&&window.onWeaDialogClose();}}},{key:"onChange",value:function onChange(key){if(typeof this.props.onChange==="function"){this.props.onChange(key);}}},{key:"scrollheigth",value:function scrollheigth(){var heightSpace=this.props.heightSpace;var heightOther=heightSpace||0;var content=this.refs.content;var top=$(content).offset()?$(content).offset().top?$(content).offset().top:0:0;var scrollheigth=document.documentElement.clientHeight-top-heightOther;var height=this.state.height;scrollheigth&&scrollheigth!==height&&this.setState({height:scrollheigth});}},{key:"reGetWidth",value:function reGetWidth(){var width=this.wapper.offsetWidth;width&&this.setState({width:width});}},{key:"render",value:function render(){var _this3=this;var _state=this.state,showDrop=_state.showDrop,percent=_state.percent,height=_state.height,end=_state.end,showShadow=_state.showShadow,w=_state.width,isDropMenuEmpty=_state.isDropMenuEmpty;var _props2=this.props,children=_props2.children,icon=_props2.icon,iconBgcolor=_props2.iconBgcolor,title=_props2.title,buttons=_props2.buttons,buttonSpace=_props2.buttonSpace,selectedKey=_props2.selectedKey,tabDatas=_props2.tabDatas,showDropIcon=_props2.showDropIcon,dropMenuDatas=_props2.dropMenuDatas,replaceTab=_props2.replaceTab,dropMenuProps=_props2.dropMenuProps,onDropMenuClick=_props2.onDropMenuClick,className=_props2.className,style=_props2.style,handleDropMenuVisible=_props2.handleDropMenuVisible;var menuProps=(0,_extends3.default)({},dropMenuProps);if(dropMenuProps.datas===undefined&&Array.isArray(dropMenuDatas)){menuProps.datas=dropMenuDatas;}if(typeof onDropMenuClick==="function"){menuProps.onClick=onDropMenuClick;}var isIE8=window.navigator.appVersion.indexOf("MSIE 8.0")>=0;var mainClx=(0,_classnames2.default)({"wea-new-top-req-main":true,"wea-new-top-req-main-shadow":showShadow});if((!document.title||document.title==="undefined")&&typeof title==="string"){document.title=title;}return _react2.default.createElement("div",{className:"wea-new-top-req-wapper "+className,style:style,ref:function ref(c){return _this3.wapper=c;},id:this.hash},_react2.default.createElement(_antd.Row,{className:"wea-new-top-req"},!end?_react2.default.createElement(_antd.Progress,{percent:percent,showInfo:false,strokeWidth:2,status:"active"}):"",_react2.default.createElement(_antd.Col,{className:mainClx,span:24},_react2.default.createElement("div",{className:"wea-new-top-req-icon"},iconBgcolor?_react2.default.createElement("div",{className:"icon-circle-base",style:{background:iconBgcolor||""}},icon):_react2.default.createElement("span",{style:{verticalAlign:"middle",marginRight:10}},icon)),_react2.default.createElement("div",{className:"wea-new-top-req-title-text wea-f14"},title),_react2.default.createElement("div",{ref:"title"},_react2.default.createElement(_antd.Row,{className:"wea-new-top-req-title"},_react2.default.createElement(_antd.Col,{xs:isIE8?10:6,sm:6,md:8,lg:10},_react2.default.createElement("div",{style:{maxWidth:this.state.leftMaxWidth,overflow:"hidden"}},replaceTab?_react2.default.createElement("div",{style:{paddingLeft:8}},replaceTab):_react2.default.createElement(_antd.Tabs,{defaultActiveKey:selectedKey,activeKey:selectedKey,onChange:this.onChange.bind(this)},tabDatas&&tabDatas.map(function(data){return _react2.default.createElement(_antd.Tabs.TabPane,{tab:data.title,key:data.key});})))),_react2.default.createElement(_antd.Col,{xs:isIE8?14:18,sm:18,md:16,lg:14,style:{textAlign:"right",marginTop:-5}},_react2.default.createElement("div",{ref:"right"},buttons.map(function(data){return _react2.default.createElement("span",{style:{display:"inline-block",lineHeight:"28px",verticalAlign:"middle",marginLeft:!!buttonSpace?buttonSpace:10}},data);}),showDropIcon&&!isDropMenuEmpty&&_react2.default.createElement("span",{className:"wea-new-top-req-drop-btn "+(isDropMenuEmpty&&"wea-new-top-drop-btn-displayNone"),onClick:function onClick(){return _this3.setState({showDrop:true},function(){return typeof handleDropMenuVisible==="function"&&handleDropMenuVisible(true);});}},_react2.default.createElement("i",{className:"icon-button icon-New-Flow-menu"})),_react2.default.createElement("div",{className:"wea-new-top-req-drop-menu wea-right-menu",onMouseLeave:function onMouseLeave(){return _this3.setState({showDrop:false},function(){return typeof handleDropMenuVisible==="function"&&handleDropMenuVisible(false);});},style:{display:showDrop?"block":"none"}},_react2.default.createElement("span",{className:"wea-new-top-req-drop-btn",onClick:function onClick(){return _this3.setState({showDrop:false},function(){return typeof handleDropMenuVisible==="function"&&handleDropMenuVisible(false);});}},_react2.default.createElement("i",{className:"icon-button icon-New-Flow-menu"})),(0,_keys2.default)(menuProps).length>0?_react2.default.createElement(_RightMenu2.default,(0,_extends3.default)({},menuProps,{ref:function ref(el){return _this3.RightMenu=el;},showReport:true})):null))))))),children&&_react2.default.createElement("div",{ref:"content",className:"wea-new-top-req-content",style:{height:height},onScroll:function onScroll(e){if(e.target.scrollTop===0){_this3.setState({showShadow:false});}else if(!showShadow){_this3.setState({showShadow:true});}}},children));}}]);return WeaNewTopReq;}(_react2.default.Component),_class.displayName="WeaNewTopReq",_class.defaultProps={dropMenuDatas:undefined,dropMenuProps:{},icon:"",iconBgcolor:"",title:"",buttons:[],buttonSpace:0,selectedKey:[],tabDatas:[],replaceTab:"",className:"",style:{}},_temp);var Com=(0,_middleware2.default)(WeaNewTopReq,"WeaReqTop");exports.default=Com;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(847);

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(849);__webpack_require__(850);__webpack_require__(851);

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(853);

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(855);

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(857);

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(859);

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(862);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaSearchPanel=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1013));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaSearchPanel;

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(864);

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaShare=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1014));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaShare;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(867);

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(869);var _ColorPanel=__webpack_require__(870);var _ColorPanel2=_interopRequireDefault(_ColorPanel);var _BrushPanel=__webpack_require__(871);var _BrushPanel2=_interopRequireDefault(_BrushPanel);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaSignature=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(4/* limit */).then(__webpack_require__.bind(null, 1015));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});WeaSignature.ColorPanel=(0,_middleware2.default)(_ColorPanel2.default,"WeaSignature.ColorPanel");WeaSignature.BrushPanel=(0,_middleware2.default)(_BrushPanel2.default,"WeaSignature.BrushPanel");exports.default=WeaSignature;

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _index=__webpack_require__(142);var _index2=_interopRequireDefault(_index);var _constant=__webpack_require__(218);var _constant2=_interopRequireDefault(_constant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var normalColors=_constant2.default.normalColors;var ColorPanel=(_temp=_class=function(_React$Component){(0,_inherits3.default)(ColorPanel,_React$Component);function ColorPanel(props){(0,_classCallCheck3.default)(this,ColorPanel);var _this=(0,_possibleConstructorReturn3.default)(this,(ColorPanel.__proto__||(0,_getPrototypeOf2.default)(ColorPanel)).call(this,props));_this.onChangeColor=function(value){_this.setState({color:value});var onChangeColor=_this.props.onChangeColor;if(typeof onChangeColor==="function")onChangeColor(value);};_this.getNormalColors=function(datas,isSecondLine){var prefixCls=_this.props.prefixCls;return datas.map(function(v){return React.createElement("span",{className:prefixCls+"-tools-normalColors-single"+(isSecondLine?"-two":""),style:{background:v},onClick:function onClick(){return _this.onChangeColor(v);}});});};_this.state={color:props.defaultColor||props.color||"#000"// 默认笔触颜色
};return _this;}(0,_createClass3.default)(ColorPanel,[{key:"componentDidMount",value:function componentDidMount(){var color=this.props.color;if(color)this.setState({color:color});}},{key:"compomentWillReceiveProps",value:function compomentWillReceiveProps(nextProps){var color=nextProps.color;var _color=this.props.color;if(color&&color!==_color){this.setState({color:color});}}},{key:"render",value:function render(){var _props=this.props,prefixCls=_props.prefixCls,devType=_props.devType,normalColors=_props.normalColors;var color=this.state.color;var col=normalColors?Math.ceil(normalColors.length/2):10;return React.createElement("div",{className:"wea-f12 "+(devType==="em"&&prefixCls+"-tools-disabled")+" "+prefixCls+"-colorPanel"},devType!=="em"?React.createElement(_index2.default,{customized:true,value:color,onChange:this.onChangeColor},React.createElement("div",{className:prefixCls+"-tools-color",style:{background:color}})):React.createElement("div",{className:prefixCls+"-tools-color-disabled"}),React.createElement("div",{className:prefixCls+"-tools-normalColors"},React.createElement("div",null,this.getNormalColors(normalColors.slice(0,col))),React.createElement("div",null,this.getNormalColors(normalColors.slice(col),true))));}}]);return ColorPanel;}(React.Component),_class.defaultProps={prefixCls:"wea-signature",normalColors:normalColors},_temp);exports.default=ColorPanel;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _constant=__webpack_require__(218);var _constant2=_interopRequireDefault(_constant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var brushs=_constant2.default.brushs;var BrushPanel=(_temp=_class=function(_React$Component){(0,_inherits3.default)(BrushPanel,_React$Component);function BrushPanel(props){(0,_classCallCheck3.default)(this,BrushPanel);var _this=(0,_possibleConstructorReturn3.default)(this,(BrushPanel.__proto__||(0,_getPrototypeOf2.default)(BrushPanel)).call(this,props));_this.onChangeBrush=function(brush){_this.setState({brush:brush});var onChangeBrush=_this.props.onChangeBrush;if(typeof onChangeBrush==="function")onChangeBrush(brush);};_this.getBrushContent=function(){var _this$props=_this.props,_this$props$brushs=_this$props.brushs,brushs=_this$props$brushs===undefined?[]:_this$props$brushs,prefixCls=_this$props.prefixCls,color=_this$props.color;var brush=_this.state.brush;return brushs.map(function(b){var style=brush===b?{background:color}:{};return React.createElement("div",{className:prefixCls+"-tools-dot "+(brush===b&&prefixCls+"-tools-dot-selected"),onClick:function onClick(){return _this.onChangeBrush(b);}},React.createElement("div",{className:prefixCls+"-tools-dot-"+b,style:style}));});};_this.onVisibleChange=function(visible){_this.setState({toolTipVisible:visible});};_this.state={brush:props.brush||"md",// 默认中号字体
toolTipVisible:false};return _this;}(0,_createClass3.default)(BrushPanel,[{key:"componentDidMount",value:function componentDidMount(){var brush=this.props.brush;if(brush)this.setState({brush:brush});}},{key:"compomentWillReceiveProps",value:function compomentWillReceiveProps(nextProps){var brush=nextProps.brush;var _brush=this.props.brush;if(brush&&brush!==_brush){this.setState({brush:brush});}}},{key:"render",value:function render(){var _props=this.props,prefixCls=_props.prefixCls,color=_props.color;var _state=this.state,brush=_state.brush,toolTipVisible=_state.toolTipVisible;return React.createElement("div",{className:prefixCls+"-tools-dot "+prefixCls+"-brushPanel"},React.createElement(_antd.Tooltip,{overlayClassName:prefixCls+"-tools-dot-options",placement:"bottomLeft",arrowPointAtCenter:true,autoAdjustOverflow:true,title:this.getBrushContent(),visible:toolTipVisible,onVisibleChange:this.onVisibleChange},React.createElement("div",{className:prefixCls+"-tools-dot-container"},React.createElement("div",{className:prefixCls+"-tools-dot-"+brush+" "+prefixCls+"-tools-dot-active",style:{background:color}}),React.createElement("div",{className:prefixCls+"-tools-dot-arrow"},React.createElement("i",{className:!toolTipVisible?"icon-coms-Browse-box-Add-to":"icon-coms-Browse-box-delete"})))));}}]);return BrushPanel;}(React.Component),_class.defaultProps={prefixCls:"wea-signature",brushs:brushs,color:"#000"},_temp);exports.default=BrushPanel;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);__webpack_require__(873);__webpack_require__(874);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Rodal=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1016));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});// import Rodal from 'rodal';
// import Rodal from "./rodal.js";
// import "./rodal.css";
var WeaSlideModal=function(_React$Component){(0,_inherits3.default)(WeaSlideModal,_React$Component);function WeaSlideModal(){(0,_classCallCheck3.default)(this,WeaSlideModal);return(0,_possibleConstructorReturn3.default)(this,(WeaSlideModal.__proto__||(0,_getPrototypeOf2.default)(WeaSlideModal)).apply(this,arguments));}(0,_createClass3.default)(WeaSlideModal,[{key:"render",value:function render(){var _props=this.props,_props$direction=_props.direction,direction=_props$direction===undefined?"right":_props$direction,_props$title=_props.title,title=_props$title===undefined?"":_props$title,content=_props.content,_props$top=_props.top,top=_props$top===undefined?0:_props$top,_props$hasScroll=_props.hasScroll,hasScroll=_props$hasScroll===undefined?true:_props$hasScroll,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style;var animation=direction==="left"?"slideLeft":"slideRight";return React.createElement("div",{className:"wea-slide-modal "+className,style:style},React.createElement(Rodal,(0,_extends3.default)({},this.props,{animation:animation,enterAnimation:animation,leaveAnimation:animation,showCloseButton:true,closeOnEsc:false,customMaskStyles:{}}),title&&React.createElement("div",{className:"wea-slide-modal-title wea-f14"},title),React.createElement("div",{style:{height:"100%",paddingBottom:top+52}},hasScroll?React.createElement(_weaNewScroll2.default,{height:"100%"},content&&React.createElement("div",{className:"wea-slide-modal-content"},content)):React.createElement("div",{className:"wea-slide-modal-content"},content))));}}]);return WeaSlideModal;}(React.Component);var Com=(0,_middleware2.default)(WeaSlideModal,"WeaSlideModal");exports.default=Com;

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactSortablejs=__webpack_require__(353);var _reactSortablejs2=_interopRequireDefault(_reactSortablejs);__webpack_require__(876);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.getPropsOptions=function(){var _this$props=_this.props,_this$props$draggable=_this$props.draggableType,draggableType=_this$props$draggable===undefined?"row":_this$props$draggable,_this$props$ghostClas=_this$props.ghostClass,ghostClass=_this$props$ghostClas===undefined?"":_this$props$ghostClas,_this$props$chosenCla=_this$props.chosenClass,chosenClass=_this$props$chosenCla===undefined?"":_this$props$chosenCla,_this$props$dragClass=_this$props.dragClass,dragClass=_this$props$dragClass===undefined?"":_this$props$dragClass,_this$props$ignoreCla=_this$props.ignoreClass,ignoreClass=_this$props$ignoreCla===undefined?"":_this$props$ignoreCla,_this$props$isAnimati=_this$props.isAnimation,isAnimation=_this$props$isAnimati===undefined?true:_this$props$isAnimati;return{filter:ignoreClass?"."+ignoreClass:".wea-ignore-node",handle:draggableType==="icon"?".sortable-handle":"",ghostClass:ghostClass?ghostClass:"wea-sortable-ghost",// Class name for the drop placeholder
chosenClass:chosenClass?chosenClass:"wea-sortable-chosen",// Class name for the chosen item
dragClass:dragClass?dragClass:"wea-sortable-drag",// Class name for the dragging item
animation:isAnimation?150:0// ms, animation speed moving items when sorting, `0` — without animation
};};_this.renderItemlist=function(){var _this$props2=_this.props,datas=_this$props2.datas,_this$props2$classNam=_this$props2.className,className=_this$props2$classNam===undefined?"":_this$props2$classNam,_this$props2$draggabl=_this$props2.draggableType,draggableType=_this$props2$draggabl===undefined?"row":_this$props2$draggabl,renderNodeItem=_this$props2.renderNodeItem,_this$props2$ignoreCl=_this$props2.ignoreClass,ignoreClass=_this$props2$ignoreCl===undefined?"":_this$props2$ignoreCl;var itemCls="wea-sortable-list-item "+className+" ";var ignoreCls=ignoreClass?ignoreClass:"wea-ignore-node";return datas.map(function(val){return _react2.default.createElement("li",{className:itemCls+" "+(val.filter?ignoreCls:""),key:val.id,"data-id":val.id,style:val.filter?{cursor:"not-allowed"}:null},draggableType==="icon"?_react2.default.createElement("i",{className:"icon-coms-move sortable-handle"}):null,typeof renderNodeItem==="function"?renderNodeItem(val):_react2.default.createElement("span",{className:"wea-sortable-list-item-label",style:{marginLeft:draggableType==="icon"?"8px":null}},val.name));});};_this.onChange=function(order,sortable,evt){var _this$props3=_this.props,datas=_this$props3.datas,onChange=_this$props3.onChange;datas.sort(function(a,b){return order.indexOf(String(a.id))-order.indexOf(String(b.id));});typeof onChange==="function"&&onChange(datas,sortable,evt);};_this.state={};_this.sortable=null;// sortable instance
return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"render",value:function render(){var _this2=this;return _react2.default.createElement(_reactSortablejs2.default// Sortable options (https://github.com/RubaXa/Sortable#options)
,{options:(0,_extends3.default)({},this.getPropsOptions())// [Optional] Use ref to get the sortable instance
// https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute
,ref:function ref(c){if(c){_this2.sortable=c.sortable;}}// [Optional] A tag or react component to specify the wrapping element. Defaults to "div".
// In a case of a react component it is required to has children in the component
// and pass it down.
,tag:"ul"// [Optional] The onChange method allows you to implement a controlled component and keep
// DOM nodes untouched. You have to change state to re-render the component.
// @param {Array} order An ordered array of items defined by the `data-id` attribute.
// @param {Object} sortable The sortable instance.
// @param {Event} evt The event object.
,onChange:function onChange(order,sortable,evt){_this2.onChange(order,sortable,evt);}},this.renderItemlist());}}]);return Main;}(_react2.default.Component);var Com=(0,_middleware2.default)(Main,"WeaSortable");exports.default=Com;

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);var _isFunction=__webpack_require__(25);var _isFunction2=_interopRequireDefault(_isFunction);__webpack_require__(878);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Step=_antd.Steps.Step;var main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.state={current:_this.props.current||0};return _this;}(0,_createClass3.default)(main,[{key:"render",value:function render(){var _this2=this;var _props=this.props,_props$direction=_props.direction,direction=_props$direction===undefined?"vertical":_props$direction,_props$datas=_props.datas,datas=_props$datas===undefined?[]:_props$datas,_props$size=_props.size,size=_props$size===undefined?"small":_props$size,_props$hideStep=_props.hideStep,hideStep=_props$hideStep===undefined?true:_props$hideStep,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style;var current=this.state.current;//自定义steps -- 适用集成、财务模块
if(datas&&datas.length>0){return React.createElement(_antd.Steps,(0,_extends3.default)({},this.props,{className:"wea-steps-menus "+(hideStep?"wea-steps-menus-number":"")+" "+(direction!=="vertical"?"wea-steps-menus-transverse":"")+" "+className,direction:direction,size:size}),datas.map(function(v){return React.createElement(Step,{style:{cursor:"pointer"},status:current==Number(v.id)-1?"process":"wait",title:v.menuname,key:v.id,onClick:function onClick(){_this2.setState({current:Number(v.id)-1});_this2.props.onChange&&(0,_isFunction2.default)(_this2.props.onChange)&&_this2.props.onChange(v);}});}));}}}]);return main;}(React.Component),_class.Step=Step,_temp);var Com=(0,_middleware2.default)(main,"WeaStepsMenus");exports.default=Com;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(8);__webpack_require__(880);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Step=_antd.Steps.Step;var main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(){(0,_classCallCheck3.default)(this,main);return(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).apply(this,arguments));}(0,_createClass3.default)(main,[{key:"render",value:function render(){var _props$direction=this.props.direction,direction=_props$direction===undefined?"":_props$direction;//竖向
if(direction=="vertical"){return React.createElement(_antd.Steps,this.props);}else{//横向
return React.createElement(_antd.Steps,(0,_extends3.default)({className:"wea-steps",itemTrailPadding:64},this.props));}}}]);return main;}(React.Component),_class.Step=Step,_temp);var Com=(0,_middleware2.default)(main,"WeaSteps");exports.default=Com;

/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaSwitch=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1017));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaSwitch;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(883);

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(885);

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(887);

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTagGroup=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(4/* limit */).then(__webpack_require__.bind(null, 1018));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaTagGroup;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(890);

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTag=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1019));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaTag;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(893);

/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(16);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(8);var _nprogress=__webpack_require__(309);var _nprogress2=_interopRequireDefault(_nprogress);__webpack_require__(310);var _middleware=__webpack_require__(9);var _middleware2=_interopRequireDefault(_middleware);var _RightMenu=__webpack_require__(128);var _RightMenu2=_interopRequireDefault(_RightMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ProgressCom=function(_React$PureComponent){(0,_inherits3.default)(ProgressCom,_React$PureComponent);function ProgressCom(){(0,_classCallCheck3.default)(this,ProgressCom);return(0,_possibleConstructorReturn3.default)(this,(ProgressCom.__proto__||(0,_getPrototypeOf2.default)(ProgressCom)).apply(this,arguments));}(0,_createClass3.default)(ProgressCom,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState,nextContext){var _props=this.props,end=_props.end,percent=_props.percent;if(percent===nextProps.percent&&end===nextProps.end){return false;}else{return true;}}},{key:"render",value:function render(){var _props2=this.props,end=_props2.end,percent=_props2.percent;return!end?_react2.default.createElement(_antd.Progress,{percent:percent,showInfo:false,strokeWidth:2,status:"active",ecId:this.props.ecId+"_Progress@5g9x98"}):null;}}]);return ProgressCom;}(_react2.default.PureComponent);var TitleColCom=function(_React$PureComponent2){(0,_inherits3.default)(TitleColCom,_React$PureComponent2);function TitleColCom(){(0,_classCallCheck3.default)(this,TitleColCom);return(0,_possibleConstructorReturn3.default)(this,(TitleColCom.__proto__||(0,_getPrototypeOf2.default)(TitleColCom)).apply(this,arguments));}(0,_createClass3.default)(TitleColCom,[{key:"render",value:function render(){var _props3=this.props,icon=_props3.icon,iconBgcolor=_props3.iconBgcolor,_breadcrumb=_props3._breadcrumb,title=_props3.title;return _react2.default.createElement(_antd.Col,{span:"14",style:{paddingLeft:20,lineHeight:"50px"},ecId:this.props.ecId+"_Col@ffz3oe"},_react2.default.createElement("div",{className:"wea-new-top-title wea-f14"},iconBgcolor?_react2.default.createElement("div",{className:"icon-circle-base",style:{background:iconBgcolor||""}},icon):_react2.default.createElement("span",{style:{verticalAlign:"middle",marginRight:10}},icon),_react2.default.createElement("span",(0,_extends3.default)({className:"wea-new-top-title-breadcrumb",style:{verticalAlign:"middle"}},_breadcrumb.length>0||typeof title!=="string"?{}:{title:title}),_breadcrumb.length>0?_breadcrumb:title)));}}]);return TitleColCom;}(_react2.default.PureComponent);var RightColCom=function(_React$PureComponent3){(0,_inherits3.default)(RightColCom,_React$PureComponent3);function RightColCom(){(0,_classCallCheck3.default)(this,RightColCom);return(0,_possibleConstructorReturn3.default)(this,(RightColCom.__proto__||(0,_getPrototypeOf2.default)(RightColCom)).apply(this,arguments));}(0,_createClass3.default)(RightColCom,[{key:"render",value:function render(){var _this4=this;var _props4=this.props,buttons=_props4.buttons,showDropIcon=_props4.showDropIcon,menuProps=_props4.menuProps,isDropMenuEmpty=_props4.isDropMenuEmpty,showDrop=_props4.showDrop,buttonSpace=_props4.buttonSpace,handleShowDrop=_props4.handleShowDrop;return _react2.default.createElement(_antd.Col,{span:"10",style:{textAlign:"right",lineHeight:"50px",paddingRight:14,position:"absolute",right:0,top:0,width:"auto"},ecId:this.props.ecId+"_Col@3ss8sy"},buttons.map(function(data){return _react2.default.createElement("span",{style:{display:"inline-block",lineHeight:"28px",verticalAlign:"middle",marginLeft:!!buttonSpace?buttonSpace:10}},data);}),showDropIcon&&(0,_keys2.default)(menuProps).length>0&&_react2.default.createElement("span",{className:"wea-new-top-drop-btn "+(isDropMenuEmpty&&"wea-new-top-drop-btn-displayNone"),onClick:function onClick(){return handleShowDrop(true);},ecId:this.props.ecId+"_span_dropIcon@w5r91g"},_react2.default.createElement("i",{className:"icon-button icon-New-Flow-menu"})),_react2.default.createElement("div",{className:"wea-new-top-drop-menu wea-right-menu",onMouseLeave:function onMouseLeave(){return handleShowDrop(false);},style:{display:showDrop?"block":"none"},ecId:this.props.ecId+"_span_showDrop@fre939"},_react2.default.createElement("span",{className:"wea-new-top-drop-btn",onClick:function onClick(){return _this4.setState({showDrop:false});},ecId:this.props.ecId+"_span_dropBtn@dj5moj"},_react2.default.createElement("i",{className:"icon-button icon-New-Flow-menu"})),(0,_keys2.default)(menuProps).length>0?_react2.default.createElement(_RightMenu2.default,(0,_extends3.default)({},menuProps,{ref:function ref(el){return _this4.RightMenu=el;},ecId:this.props.ecId+"_RightMenu@22c195",showReport:true})):null));}}]);return RightColCom;}(_react2.default.PureComponent);var WeaTop=(_temp=_class=function(_React$Component){(0,_inherits3.default)(WeaTop,_React$Component);function WeaTop(props){(0,_classCallCheck3.default)(this,WeaTop);var _this5=(0,_possibleConstructorReturn3.default)(this,(WeaTop.__proto__||(0,_getPrototypeOf2.default)(WeaTop)).call(this,props));_this5.onWindowResize=function(){_this5.instanceIsMounted&&_this5.scrollheigth();};_this5.instanceIsMounted=false;_this5.hash="weatop_"+Math.random().toString(36).substr(2,6)+"_"+new Date().getTime();_this5.state={showDrop:false,percent:85,end:true,height:0,isDropMenuEmpty:false};return _this5;}(0,_createClass3.default)(WeaTop,[{key:"componentDidMount",value:function componentDidMount(){this.instanceIsMounted=true;this.scrollheigth();window.addEventListener("resize",this.onWindowResize);_nprogress2.default.configure({showSpinner:false,minimum:0.3,speed:500});this.props.onDidMount&&this.props.onDidMount(this.props,this.hash);window.onTopDidMount&&window.onTopDidMount(this.props,this.hash);if(this.RightMenu&&this.RightMenu.isEmpty)this.setState({isDropMenuEmpty:true});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var loading=this.props.loading;if(!loading&&nextProps.loading){_nprogress2.default.configure({parent:"#"+this.hash});_nprogress2.default.start(0.3);// this.timer = setInterval(() => {
//   const percent = this.state.percent;
//   const newP = percent < 96 ? (percent + 1) : 96;
//   this.instanceIsMounted && this.setState({ end: false, percent: newP });
// }, 10);
}else if(loading&&!nextProps.loading){_nprogress2.default.done();// this.setState({ percent: 100 });
// this.timer && clearInterval(this.timer);
// setTimeout(() => {this.instanceIsMounted && this.setState({ percent: 85, end: true });}, 300);
}}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.scrollheigth();var isDropMenuEmpty=this.state.isDropMenuEmpty;var isdropmenuempty=this.RightMenu&&this.RightMenu.isEmpty;if(isdropmenuempty!==isDropMenuEmpty)this.setState({isDropMenuEmpty:isdropmenuempty});}},{key:"componentWillUnmount",value:function componentWillUnmount(){// 防止节点卸载问题。。。
window.removeEventListener("resize",this.onWindowResize);_nprogress2.default.configure({parent:"body"});_nprogress2.default.done();_nprogress2.default.remove();this.instanceIsMounted=false;}},{key:"scrollheigth",value:function scrollheigth(){var _props5=this.props,heightSpace=_props5.heightSpace,getHeight=_props5.getHeight,_props5$inDialog=_props5.inDialog,inDialog=_props5$inDialog===undefined?false:_props5$inDialog;var heightOther=heightSpace!==undefined?heightSpace:inDialog?0:10;var content=this.refs.content;if(content){var top=$(content).offset()?$(content).offset().top:0;var dialog=inDialog?$(content).closest(".wea-dialog-body"):null;var scrollheigth=(inDialog&&dialog?dialog.height()+dialog.offset().top:document.documentElement.clientHeight)-top-heightOther;var height=this.state.height;if(height!==scrollheigth){this.setState({height:scrollheigth});typeof getHeight=="function"&&getHeight(scrollheigth);}}}},{key:"render",value:function render(){var _this6=this;var _state=this.state,showDrop=_state.showDrop,percent=_state.percent,end=_state.end,height=_state.height,isDropMenuEmpty=_state.isDropMenuEmpty;var _props6=this.props,children=_props6.children,icon=_props6.icon,iconBgcolor=_props6.iconBgcolor,title=_props6.title,buttons=_props6.buttons,buttonSpace=_props6.buttonSpace,isFixed=_props6.isFixed,showDropIcon=_props6.showDropIcon,dropMenuDatas=_props6.dropMenuDatas,breadcrumb=_props6.breadcrumb,dropMenuProps=_props6.dropMenuProps,onDropMenuClick=_props6.onDropMenuClick,className=_props6.className,style=_props6.style;var menuProps=(0,_extends3.default)({},dropMenuProps);if(dropMenuProps.datas===undefined&&Array.isArray(dropMenuDatas)){menuProps.datas=dropMenuDatas;}if(typeof onDropMenuClick==="function"){menuProps.onClick=onDropMenuClick;}var _breadcrumb=[];breadcrumb.forEach(function(bc,index){index>0&&_breadcrumb.push(_react2.default.createElement("i",{className:"icon-coms-Browse-box-Add-to"}));_breadcrumb.push(_react2.default.createElement("a",(0,_extends3.default)({className:"wea-f14"},bc),bc.name));});if((!document.title||document.title==="undefined")&&typeof title==="string"){document.title=title;}var titleColComProps={icon:icon,iconBgcolor:iconBgcolor,_breadcrumb:_breadcrumb,title:title};var rightColComProps={buttons:buttons,showDropIcon:showDropIcon,menuProps:menuProps,isDropMenuEmpty:isDropMenuEmpty,showDrop:showDrop,buttonSpace:buttonSpace,handleShowDrop:function handleShowDrop(v){return _this6.setState({showDrop:v});}};return _react2.default.createElement("div",{className:"wea-new-top-wapper "+className,id:this.hash,style:style,ecId:this.props.ecId+"_div@nrly0h"},_react2.default.createElement(_antd.Row,{className:!!isFixed?"wea-new-top-fixed":"wea-new-top",ecId:this.props.ecId+"_Row@di5qkc"},_react2.default.createElement(ProgressCom,{end:end,percent:percent,ecId:this.props.ecId+"_ProgressCom@qx98a5"}),_react2.default.createElement(TitleColCom,(0,_extends3.default)({},titleColComProps,{ecId:this.props.ecId+"_TitleColCom@jkz6r1"})),_react2.default.createElement(RightColCom,(0,_extends3.default)({},rightColComProps,{ecId:this.props.ecId+"_RightColCom@a10dl7"}))),children&&_react2.default.createElement("div",{ref:"content",className:"wea-new-top-content",style:{height:height}},children));}}]);return WeaTop;}(_react2.default.Component),_class.displayName="WeaTop",_class.defaultProps={dropMenuDatas:undefined,dropMenuProps:{},icon:"",iconBgcolor:"",title:"",buttons:[],buttonSpace:0,breadcrumb:[],className:"",style:{}},_temp);var Com=(0,_middleware2.default)(WeaTop,"WeaTop");exports.default=Com;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(896);

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(898);

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTreeEdit=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 1020));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaTreeEdit;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(901);

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTreeNew=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1021));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaTreeNew;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(904);

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(906);

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(24);var _typeof3=_interopRequireDefault(_typeof2);exports.getVideoString=getVideoString;exports.loadVideoPlayer=loadVideoPlayer;exports.renderVideoPlayer=renderVideoPlayer;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _loadjs=__webpack_require__(54);var _loadjs2=_interopRequireDefault(_loadjs);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getHash(prefix){return""+(prefix||"wea_vp_")+Math.random().toString(36).substr(2,6);}var isDOM=(typeof HTMLElement==="undefined"?"undefined":(0,_typeof3.default)(HTMLElement))==="object"?function(obj){return obj instanceof HTMLElement;}:function(obj){return obj&&(typeof obj==="undefined"?"undefined":(0,_typeof3.default)(obj))==="object"&&obj.nodeType===1&&typeof obj.nodeName==="string";};function getVideoString(options){var videoList=options.videoList,videoW=options.videoW,videoH=options.videoH,videoAlign=options.videoAlign,videoTabKey=options.videoTabKey,isTCPlayer=options.isTCPlayer;var videoUrl=options.videoUrl;var str="";var WHStyle="";if(videoW!==""){WHStyle+="width="+videoW+";";}if(videoH!==""){WHStyle+="height="+videoH+";";}var videoStyle="max-width:100%";var wrapStyle="text-align:"+videoAlign;var wrap=function wrap(html){var other=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";return"<p style="+wrapStyle+" "+other+">"+html+"&#8203;</p><br/>";};// const inner = (html, style = "", other = "") =>
//   `<p class="__wea_vp_class__" style="display:inline-block;${style}" ${other}>${html}</p>`;
var reg=new RegExp("^"+window.ecologyContentPath+"");videoUrl=reg.test(videoUrl)?videoUrl:(window.ecologyContentPath||"")+videoUrl;if(videoTabKey==="1"){videoList.length>0&&videoList.map(function(item){var html="";if(isTCPlayer){html="<video id="+getHash()+" isTCPlayer=\"1\" fileID="+item.fileID+" appID="+item.appID+" style="+videoStyle+" "+WHStyle+" preload=\"auto\" playsinline webkit-playsinline "+(item.fileExtendName==="swf"?"isSwf":"")+" ></video>";// html = inner(html);
html=wrap(html);}else{var videoSrc=item.imgSrc||item.loadlink;videoSrc=reg.test(videoSrc)?videoSrc:(window.ecologyContentPath||"")+videoSrc;if(item.fileExtendName=="swf"){html="<p style=\"text-align:"+videoAlign+";overflow:hidden;\"><embed src="+videoSrc+" quality=\"high\" style="+videoStyle+" "+WHStyle+" align="+videoAlign+" type=\"application/x-shockwave-flash\" ></embed>&#8203;</p><br/>";}else if(item.fileExtendName=="mp4"){html="<video src="+videoSrc+" style="+videoStyle+" "+WHStyle+" controls=\"controls\" playsinline webkit-playsinline ></video>";// html = `<p style="display:inline-block;${style}">${html}</p>`;
html=wrap(html);}else{html="<video src="+videoSrc+" style="+videoStyle+" "+WHStyle+" controls=\"controls\" playsinline webkit-playsinline ></video>";// html = inner(html, style, `id=${getHash()} ${WHStyle}`);
html=wrap(html);}}str+=html;});}else{var html="<video src="+videoUrl+" style="+videoStyle+" "+WHStyle+" controls=\"controls\" playsinline webkit-playsinline ></video>";// html = inner(html, style, `id=${getHash()} ${WHStyle}`);
html=wrap(html);str+=html;}return str;}function loadVideoPlayer(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var isTCPlayer=arguments[2];var opt=isTCPlayer?options:(0,_extends3.default)({},options,{video:options.video||"",container:options.container||getHash(),variable:"player"});var content=opt.video?"loading...":"暂无视频";var init=function init(){setTimeout(function(){try{var player=isTCPlayer?new TCPlayer(opt.container||getHash(),opt):new videoPlayer(opt);}catch(e){}},200);};var getDom=function getDom(opt){return isTCPlayer?_react2.default.createElement("video",{isTCPlayer:"1",id:opt.container,style:style,preload:"auto",playsinline:true,"webkit-playsinline":true}):_react2.default.createElement("div",{id:opt.container.substr(1),style:style},content);};var playerName=isTCPlayer?"TCPlayerJS":"videoPlayerJS";_loadjs2.default.isDefined(playerName)?_loadjs2.default.ready(playerName,init):(0,_loadjs2.default)(isTCPlayer?[(window.ecologyContentPath||"")+"/cloudstore/resource/pc/tcplayer/tcplayer.css",(window.ecologyContentPath||"")+"/cloudstore/resource/pc/tcplayer/libs/hls.min.0.12.4.js",(window.ecologyContentPath||"")+"/cloudstore/resource/pc/tcplayer/libs/dash.all.min.2.9.3.js",(window.ecologyContentPath||"")+"/cloudstore/resource/pc/tcplayer/tcplayer.min.js"]:(window.ecologyContentPath||"")+"/cloudstore/resource/pc/videoPlayer/index.min.js",playerName,init);return getDom(opt);}function renderVideoPlayer(dom,appID){dom=dom||window.document.body;if(!isDOM(dom))return;dom=dom.querySelectorAll(".__wea_vp_class__")||[];var loop=function loop(videoWrap){if(isDOM(videoWrap)){var videoDom=videoWrap.querySelector("video");if(!videoDom)return;if(videoDom.getAttribute("isTCPlayer")){var container=videoDom.id;var fileID=videoDom.getAttribute("fileID");appID=appID||videoDom.getAttribute("appID");var swf=videoDom.getAttribute("isswf");var width=videoDom.getAttribute("width");var height=videoDom.getAttribute("height");var options={container:container,fileID:fileID,appID:appID,width:width,height:height};if(swf){options=(0,_extends3.default)({},options,{flash:{swf:(window.ecologyContentPath||"")+"/cloudstore/resource/pc/tcplayer/player.swf"//swf 文件地址 必须
}});}loadVideoPlayer(options,{width:width,height:height},true);}else{var _container="#"+videoWrap.id;var video=videoDom.src;var _width=videoDom.getAttribute("width");var _height=videoDom.getAttribute("height");loadVideoPlayer({container:_container,video:video},{width:_width,height:_height});}}};if(dom&&dom.length>0){for(var index=0;index<dom.length;index++){loop(dom[index]);}}else{loop(dom);}}var Main=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1022));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});Main.getVideoString=getVideoString;Main.loadVideoPlayer=loadVideoPlayer;Main.renderVideoPlayer=renderVideoPlayer;exports.default=Main;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(909);

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaYear=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1023));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaYear;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./wea-associative-search-mult/index.js": 87,
	"./wea-associative-search-mult/style/index.js": 912,
	"./wea-associative-search/index.js": 139,
	"./wea-associative-search/style/index.js": 914,
	"./wea-browser-icons/index.js": 368,
	"./wea-browser-muti-right/index.js": 304,
	"./wea-browser-muti-right/style/index.js": 916,
	"./wea-browser-thumbnail/index.js": 371,
	"./wea-browser-thumbnail/style/index.js": 918,
	"./wea-dev-modules/index.js": 370,
	"./wea-docs-thumbnails/index.js": 377,
	"./wea-docs-thumbnails/style/index.js": 921,
	"./wea-drop-menu/index.js": 923,
	"./wea-drop-menu/style/index.js": 924,
	"./wea-ecode-browser/index.js": 375,
	"./wea-ecode-browser/style/index.js": 926,
	"./wea-ecode-login/index.js": 306,
	"./wea-hrm-condition/index.js": 373,
	"./wea-hrm-condition/style/index.js": 928,
	"./wea-input-auth/index.js": 151,
	"./wea-input-auth/style/index.js": 930,
	"./wea-input-normal/index.js": 140,
	"./wea-input-normal/style/index.js": 932,
	"./wea-new-table/index.js": 934,
	"./wea-new-table/style/index.js": 935,
	"./wea-node-tree-list/index.js": 369,
	"./wea-node-tree-list/style/index.js": 937,
	"./wea-search-browser-box/index.js": 88,
	"./wea-search-browser-box/style/index.js": 939,
	"./wea-textarea-auth/index.js": 125,
	"./wea-textarea-auth/style/index.js": 941,
	"./wea-textarea-locale/index.js": 256,
	"./wea-textarea-normal/index.js": 211,
	"./wea-transfer-right/index.js": 943,
	"./wea-transfer-right/style/index.js": 944,
	"./wea-wf-financial/index.js": 308,
	"./wea-wf-input/index.js": 380
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(913);

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(915);

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(917);

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(919);__webpack_require__(920);

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(922);

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Row from '../../../_antd1.11.2/row'
// import Col from '../../../_antd1.11.2/col'
// import Button from '../../../_antd1.11.2/button'
// import Menu from '../../../_antd1.11.2/menu'
var Item=_antd.Menu.Item;var WeaDropMenu=function(_React$Component){(0,_inherits3.default)(WeaDropMenu,_React$Component);function WeaDropMenu(props){(0,_classCallCheck3.default)(this,WeaDropMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaDropMenu.__proto__||(0,_getPrototypeOf2.default)(WeaDropMenu)).call(this,props));_this.state={showDrop:false};return _this;}(0,_createClass3.default)(WeaDropMenu,[{key:'render',value:function render(){var _this2=this;var showDrop=this.state.showDrop;var dropMenuDatas=this.props.dropMenuDatas;//isFixed:wea-new-top是否固定
var menu=dropMenuDatas?React.createElement(_antd.Menu,{mode:'vertical',onClick:function onClick(o){if(typeof _this2.props.onDropMenuClick=='function')_this2.props.onDropMenuClick(o.key);}},dropMenuDatas.map(function(d,i){return React.createElement(Item,{key:d.key||i,disabled:d.disabled},React.createElement('span',{className:'wea-right-menu-icon'},d.icon),d.content);})):'';return React.createElement('div',{className:'wea-drop-menu'},React.createElement('span',{className:'wea-new-top-drop-btn wea-btn-top',onClick:function onClick(){return _this2.setState({showDrop:true});}},React.createElement('i',{className:'icon-button icon-New-Flow-menu'})),React.createElement('div',{className:'wea-new-top-drop-menu wea-right-menu',onMouseLeave:function onMouseLeave(){return _this2.setState({showDrop:false});},style:{display:showDrop?'block':'none'}},React.createElement('span',{className:'wea-new-top-drop-btn',onClick:function onClick(){return _this2.setState({showDrop:false});}},React.createElement('i',{className:'icon-button icon-New-Flow-menu'})),React.createElement('div',{className:'wea-right-menu-icon-background'}),menu));}}]);return WeaDropMenu;}(React.Component);exports.default=WeaDropMenu;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(925);

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(927);

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(929);

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(931);

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(933);

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(0);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(7);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaNewTable=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0/* limit */).then(__webpack_require__.bind(null, 1024));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=WeaNewTable;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(936);

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(938);

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(940);

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(942);

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _toConsumableArray2=__webpack_require__(19);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(8);var _weaInputSearch=__webpack_require__(46);var _weaInputSearch2=_interopRequireDefault(_weaInputSearch);var _weaScroll=__webpack_require__(101);var _weaScroll2=_interopRequireDefault(_weaScroll);var _weaNewScroll=__webpack_require__(26);var _weaNewScroll2=_interopRequireDefault(_weaNewScroll);var _cloneDeep=__webpack_require__(42);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _isArray=__webpack_require__(21);var _isArray2=_interopRequireDefault(_isArray);var _trim=__webpack_require__(33);var _trim2=_interopRequireDefault(_trim);var _debounce=__webpack_require__(67);var _debounce2=_interopRequireDefault(_debounce);var _weaLocaleProvider=__webpack_require__(10);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TreeNode=_antd.Tree.TreeNode;// import Tree from '../../../_antd1.11.2/tree'
var getLabel=_weaLocaleProvider2.default.getLabel;var text=function text(item,field){var text="";if(item[field]!==undefined){text=item[field];}if(item[field+"span"]!==undefined){text=item[field+"span"];}return text;};var timeout=null;var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this2=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this2.state={key:""};return _this2;}(0,_createClass3.default)(main,[{key:"count",value:function count(item){if(item.type==="all")return item.count;return(item.users||[]).length;}},{key:"reset",value:function reset(){this.setState({key:""});}},{key:"generateTreeNodes",value:function generateTreeNodes(){var _this3=this;var _props=this.props,data=_props.data,inputTop=_props.inputTop,inputBottom=_props.inputBottom,hideNum=_props.hideNum;var key=this.state.key;var treeNodes=[];var showData=[].concat((0,_toConsumableArray3.default)(data));if((0,_trim2.default)(key)){showData=data.filter(function(item){var bool=false;bool=item.lastname.indexOf((0,_trim2.default)(key))>-1;if(!bool&&item.pingyinname){bool=item.pingyinname.indexOf((0,_trim2.default)(key))>-1;}return bool;});}this.nodeIds=[];this.nodeObj={};showData.map(function(item){var title=null;var crmNames=[];if(item.departmentname)crmNames.push(item.departmentname);if(item.supsubcompanyname)crmNames.push(item.supsubcompanyname);if(item.subcompanyname)crmNames.push(item.subcompanyname);item.crmNames=crmNames.join("／");if(item.type=="subcom"||item.type=="com"){title=React.createElement("div",{className:"tree-title"},React.createElement("i",{className:"icon-process-scene"}),React.createElement("span",{title:item.lastname},item.lastname),!hideNum&&"("+_this3.count(item)+")");}else if(item.type=="dept"){title=React.createElement("div",{className:"tree-title"},React.createElement("i",{className:"icon-mail-folder"})," ",React.createElement("span",{title:item.lastname},item.lastname),!hideNum&&"("+_this3.count(item)+")");}else if(item.type=="resource"){title=React.createElement("div",{className:"tree-title resource"},React.createElement("img",{className:"wea-tree-hr-portrait",src:item.icon,onError:function onError(){return item.icon=(window.ecologyContentPath||"")+"/cloudstore/resource/pc/com/images/portrait_default.jpg";},alt:"img"}),React.createElement("div",{className:"resource-content breakall"},React.createElement("div",null,inputTop||inputBottom?(inputTop||[]).map(function(field){return React.createElement("span",{style:{marginRight:5},dangerouslySetInnerHTML:{__html:text(item,field)}});}):[React.createElement("span",{className:"lastname",title:item.lastname},item.lastname),React.createElement("span",{className:"jobtitlename gray",title:item.jobtitlename},item.jobtitlename)]),React.createElement("div",null,inputTop||inputBottom?(inputBottom||[]).map(function(field){return React.createElement("span",{style:{marginRight:5},dangerouslySetInnerHTML:{__html:text(item,field)}});}):React.createElement("div",{className:"overflow gray",title:item.crmNames},item.crmNames))));}else{title=React.createElement("div",{className:"tree-title"},React.createElement("i",{className:"icon-process-scene"}),React.createElement("span",{title:item.lastname},item.lastname),!hideNum&&"("+_this3.count(item)+")");}treeNodes.push(React.createElement(TreeNode,{title:title,name:item.lastname,jobtitlename:item.jobtitlename,key:item.nodeid,isLeaf:true,id:item.id,type:item.type}));_this3.nodeIds.push(item.nodeid);_this3.nodeObj[item.nodeid]=item;});return treeNodes;}},{key:"onSearchChange",value:function onSearchChange(v){this.setState({key:v});}},{key:"checkHandler",value:function checkHandler(v,p){var _this=this;// 取消上次延时未执行的方法
clearTimeout(timeout);//执行延时
timeout=setTimeout(function(){_this.props.checkedCb&&_this.props.checkedCb(v);},200);}},{key:"onDoubleClick",value:function onDoubleClick(key){clearTimeout(timeout);this.props.onDoubleClick&&this.props.onDoubleClick(key);}},{key:"onDragStart",value:function onDragStart(obj){clearTimeout(timeout);this.props.checkedCb&&this.props.checkedCb([]);}},{key:"onDrop",value:function onDrop(obj){var _this4=this;var dragNodes=obj.dragNodesKeys;var targetNode=obj.node.props.eventKey;var result=[];this.nodeIds.filter(function(item){return dragNodes.indexOf(item)===-1;}).forEach(function(nodeid){if(nodeid===targetNode){dragNodes.forEach(function(drag){result.push(_this4.nodeObj[drag]);});}result.push(_this4.nodeObj[nodeid]);});this.props.onDrag&&this.props.onDrag(result);}},{key:"render",value:function render(){var _props2=this.props,checkedKeys=_props2.checkedKeys,height=_props2.height,noScroll=_props2.noScroll;var treeNodes=this.generateTreeNodes();var contents=React.createElement(_antd.Tree,{className:"transfer-tree",draggable:true,onDragStart:this.onDragStart.bind(this),onDrop:this.onDrop.bind(this),onSelect:this.checkHandler.bind(this),onDoubleClick:this.onDoubleClick.bind(this),selectedKeys:checkedKeys,multiple:true,async:true,selectable:true},treeNodes);return React.createElement("div",{className:"wea-transfer-right"},React.createElement(_weaInputSearch2.default,{onSearchChange:(0,_debounce2.default)(this.onSearchChange,20).bind(this),placeholder:getLabel(83788,"请输入关键字搜索"),value:this.state.key}),noScroll?React.createElement("div",{style:{height:height||400,overflowY:"scroll"}},contents):React.createElement(_weaNewScroll2.default,{height:height||400,ref:"weaSrcoll"},contents));}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(945);

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(405);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ecCom.min.js